(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirede23"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirede23"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPoFX", function(module, exports) {

var $1ciUP = parcelRequire("1ciUP");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $1ciUP._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});
parcelRegister("1ciUP", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $0df595ac9ba6bf47$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $0df595ac9ba6bf47$export$5f0017c582d45a2d; });
function $0df595ac9ba6bf47$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("1x6H7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $11de10e2de3ddf8e$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $11de10e2de3ddf8e$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var $11de10e2de3ddf8e$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($11de10e2de3ddf8e$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $11de10e2de3ddf8e$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $11de10e2de3ddf8e$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $11de10e2de3ddf8e$var$timeoutDuration);
        }
    };
}
var $11de10e2de3ddf8e$var$supportsMicroTasks = $11de10e2de3ddf8e$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $11de10e2de3ddf8e$var$debounce = $11de10e2de3ddf8e$var$supportsMicroTasks ? $11de10e2de3ddf8e$var$microtaskDebounce : $11de10e2de3ddf8e$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $11de10e2de3ddf8e$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $11de10e2de3ddf8e$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var _$window = element.ownerDocument.defaultView;
    var css = _$window.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $11de10e2de3ddf8e$var$getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $11de10e2de3ddf8e$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $11de10e2de3ddf8e$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $11de10e2de3ddf8e$var$getScrollParent($11de10e2de3ddf8e$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $11de10e2de3ddf8e$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $11de10e2de3ddf8e$var$isIE11 = $11de10e2de3ddf8e$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $11de10e2de3ddf8e$var$isIE10 = $11de10e2de3ddf8e$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $11de10e2de3ddf8e$var$isIE(version) {
    if (version === 11) return $11de10e2de3ddf8e$var$isIE11;
    if (version === 10) return $11de10e2de3ddf8e$var$isIE10;
    return $11de10e2de3ddf8e$var$isIE11 || $11de10e2de3ddf8e$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $11de10e2de3ddf8e$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $11de10e2de3ddf8e$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && $11de10e2de3ddf8e$var$getStyleComputedProperty(offsetParent, "position") === "static") return $11de10e2de3ddf8e$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $11de10e2de3ddf8e$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || $11de10e2de3ddf8e$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $11de10e2de3ddf8e$var$getRoot(node) {
    if (node.parentNode !== null) return $11de10e2de3ddf8e$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $11de10e2de3ddf8e$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($11de10e2de3ddf8e$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $11de10e2de3ddf8e$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $11de10e2de3ddf8e$var$getRoot(element1);
    if (element1root.host) return $11de10e2de3ddf8e$var$findCommonOffsetParent(element1root.host, element2);
    else return $11de10e2de3ddf8e$var$findCommonOffsetParent(element1, $11de10e2de3ddf8e$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $11de10e2de3ddf8e$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $11de10e2de3ddf8e$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $11de10e2de3ddf8e$var$getScroll(element, "top");
    var scrollLeft = $11de10e2de3ddf8e$var$getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $11de10e2de3ddf8e$var$getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function $11de10e2de3ddf8e$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], $11de10e2de3ddf8e$var$isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function $11de10e2de3ddf8e$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $11de10e2de3ddf8e$var$isIE(10) && getComputedStyle(html);
    return {
        height: $11de10e2de3ddf8e$var$getSize("Height", body, html, computedStyle),
        width: $11de10e2de3ddf8e$var$getSize("Width", body, html, computedStyle)
    };
}
var $11de10e2de3ddf8e$var$classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $11de10e2de3ddf8e$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $11de10e2de3ddf8e$var$defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $11de10e2de3ddf8e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $11de10e2de3ddf8e$var$getClientRect(offsets) {
    return $11de10e2de3ddf8e$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $11de10e2de3ddf8e$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($11de10e2de3ddf8e$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $11de10e2de3ddf8e$var$getScroll(element, "top");
            var scrollLeft = $11de10e2de3ddf8e$var$getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? $11de10e2de3ddf8e$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $11de10e2de3ddf8e$var$getStyleComputedProperty(element);
        horizScrollbar -= $11de10e2de3ddf8e$var$getBordersSize(styles, "x");
        vertScrollbar -= $11de10e2de3ddf8e$var$getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $11de10e2de3ddf8e$var$getClientRect(result);
}
function $11de10e2de3ddf8e$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $11de10e2de3ddf8e$var$isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = $11de10e2de3ddf8e$var$getBoundingClientRect(children);
    var parentRect = $11de10e2de3ddf8e$var$getBoundingClientRect(parent);
    var scrollParent = $11de10e2de3ddf8e$var$getScrollParent(children);
    var styles = $11de10e2de3ddf8e$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $11de10e2de3ddf8e$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = $11de10e2de3ddf8e$var$includeScroll(offsets, parent);
    return offsets;
}
function $11de10e2de3ddf8e$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $11de10e2de3ddf8e$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $11de10e2de3ddf8e$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $11de10e2de3ddf8e$var$getScroll(html, "left") : 0;
    var _$offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $11de10e2de3ddf8e$var$getClientRect(_$offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $11de10e2de3ddf8e$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if ($11de10e2de3ddf8e$var$getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = $11de10e2de3ddf8e$var$getParentNode(element);
    if (!parentNode) return false;
    return $11de10e2de3ddf8e$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $11de10e2de3ddf8e$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $11de10e2de3ddf8e$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $11de10e2de3ddf8e$var$getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $11de10e2de3ddf8e$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $11de10e2de3ddf8e$var$getFixedPositionOffsetParent(popper) : $11de10e2de3ddf8e$var$findCommonOffsetParent(popper, $11de10e2de3ddf8e$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = $11de10e2de3ddf8e$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = $11de10e2de3ddf8e$var$getScrollParent($11de10e2de3ddf8e$var$getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $11de10e2de3ddf8e$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !$11de10e2de3ddf8e$var$isFixed(offsetParent)) {
            var _getWindowSizes = $11de10e2de3ddf8e$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $11de10e2de3ddf8e$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = $11de10e2de3ddf8e$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $11de10e2de3ddf8e$var$_extends({
            key: key
        }, rects[key], {
            area: $11de10e2de3ddf8e$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $11de10e2de3ddf8e$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $11de10e2de3ddf8e$var$getFixedPositionOffsetParent(popper) : $11de10e2de3ddf8e$var$findCommonOffsetParent(popper, $11de10e2de3ddf8e$var$getReferenceNode(reference));
    return $11de10e2de3ddf8e$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $11de10e2de3ddf8e$var$getOuterSizes(element) {
    var _$window = element.ownerDocument.defaultView;
    var styles = _$window.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $11de10e2de3ddf8e$var$getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $11de10e2de3ddf8e$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = $11de10e2de3ddf8e$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$11de10e2de3ddf8e$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $11de10e2de3ddf8e$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $11de10e2de3ddf8e$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $11de10e2de3ddf8e$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $11de10e2de3ddf8e$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $11de10e2de3ddf8e$var$findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $11de10e2de3ddf8e$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $11de10e2de3ddf8e$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $11de10e2de3ddf8e$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $11de10e2de3ddf8e$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $11de10e2de3ddf8e$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $11de10e2de3ddf8e$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $11de10e2de3ddf8e$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = $11de10e2de3ddf8e$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $11de10e2de3ddf8e$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $11de10e2de3ddf8e$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $11de10e2de3ddf8e$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($11de10e2de3ddf8e$var$isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[$11de10e2de3ddf8e$var$getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $11de10e2de3ddf8e$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $11de10e2de3ddf8e$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $11de10e2de3ddf8e$var$attachToScrollParents($11de10e2de3ddf8e$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $11de10e2de3ddf8e$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $11de10e2de3ddf8e$var$getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $11de10e2de3ddf8e$var$getScrollParent(reference);
    $11de10e2de3ddf8e$var$attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $11de10e2de3ddf8e$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $11de10e2de3ddf8e$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $11de10e2de3ddf8e$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $11de10e2de3ddf8e$var$getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $11de10e2de3ddf8e$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $11de10e2de3ddf8e$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $11de10e2de3ddf8e$var$isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $11de10e2de3ddf8e$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && $11de10e2de3ddf8e$var$isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $11de10e2de3ddf8e$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $11de10e2de3ddf8e$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $11de10e2de3ddf8e$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $11de10e2de3ddf8e$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $11de10e2de3ddf8e$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $11de10e2de3ddf8e$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $11de10e2de3ddf8e$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $11de10e2de3ddf8e$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $11de10e2de3ddf8e$var$setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $11de10e2de3ddf8e$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $11de10e2de3ddf8e$var$isFirefox = $11de10e2de3ddf8e$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $11de10e2de3ddf8e$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $11de10e2de3ddf8e$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $11de10e2de3ddf8e$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $11de10e2de3ddf8e$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$11de10e2de3ddf8e$var$isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $11de10e2de3ddf8e$var$getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $11de10e2de3ddf8e$var$_extends({}, attributes, data.attributes);
    data.styles = $11de10e2de3ddf8e$var$_extends({}, styles, data.styles);
    data.arrowStyles = $11de10e2de3ddf8e$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $11de10e2de3ddf8e$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $11de10e2de3ddf8e$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$11de10e2de3ddf8e$var$isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = $11de10e2de3ddf8e$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $11de10e2de3ddf8e$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $11de10e2de3ddf8e$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $11de10e2de3ddf8e$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $11de10e2de3ddf8e$var$defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $11de10e2de3ddf8e$var$getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $11de10e2de3ddf8e$var$placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var $11de10e2de3ddf8e$var$validPlacements = $11de10e2de3ddf8e$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $11de10e2de3ddf8e$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $11de10e2de3ddf8e$var$validPlacements.indexOf(placement);
    var arr = $11de10e2de3ddf8e$var$validPlacements.slice(index + 1).concat($11de10e2de3ddf8e$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $11de10e2de3ddf8e$var$BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($11de10e2de3ddf8e$var$isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $11de10e2de3ddf8e$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = $11de10e2de3ddf8e$var$getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case $11de10e2de3ddf8e$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $11de10e2de3ddf8e$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $11de10e2de3ddf8e$var$clockwise(placement);
            break;
        case $11de10e2de3ddf8e$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $11de10e2de3ddf8e$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = $11de10e2de3ddf8e$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $11de10e2de3ddf8e$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $11de10e2de3ddf8e$var$_extends({}, data.offsets.popper, $11de10e2de3ddf8e$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $11de10e2de3ddf8e$var$runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $11de10e2de3ddf8e$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = $11de10e2de3ddf8e$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $11de10e2de3ddf8e$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($11de10e2de3ddf8e$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $11de10e2de3ddf8e$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($11de10e2de3ddf8e$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$offset(data, _ref) {
    var _$offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if ($11de10e2de3ddf8e$var$isNumeric(+_$offset)) offsets = [
        +_$offset,
        0
    ];
    else offsets = $11de10e2de3ddf8e$var$parseOffset(_$offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $11de10e2de3ddf8e$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $11de10e2de3ddf8e$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $11de10e2de3ddf8e$var$getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = $11de10e2de3ddf8e$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $11de10e2de3ddf8e$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return $11de10e2de3ddf8e$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = $11de10e2de3ddf8e$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: $11de10e2de3ddf8e$var$defineProperty({}, side, reference[side]),
            end: $11de10e2de3ddf8e$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $11de10e2de3ddf8e$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$hide(data) {
    if (!$11de10e2de3ddf8e$var$isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = $11de10e2de3ddf8e$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $11de10e2de3ddf8e$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = $11de10e2de3ddf8e$var$getOppositePlacement(placement);
    data.offsets.popper = $11de10e2de3ddf8e$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $11de10e2de3ddf8e$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $11de10e2de3ddf8e$var$applyStyle,
        /** @prop {Function} */ onLoad: $11de10e2de3ddf8e$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $11de10e2de3ddf8e$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $11de10e2de3ddf8e$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $11de10e2de3ddf8e$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $11de10e2de3ddf8e$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $11de10e2de3ddf8e$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $11de10e2de3ddf8e$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($11de10e2de3ddf8e$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $11de10e2de3ddf8e$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $11de10e2de3ddf8e$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $11de10e2de3ddf8e$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $11de10e2de3ddf8e$var$createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return $11de10e2de3ddf8e$var$update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return $11de10e2de3ddf8e$var$destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return $11de10e2de3ddf8e$var$enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return $11de10e2de3ddf8e$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $11de10e2de3ddf8e$var$Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
$11de10e2de3ddf8e$var$Popper.placements = $11de10e2de3ddf8e$var$placements;
$11de10e2de3ddf8e$var$Popper.Defaults = $11de10e2de3ddf8e$var$Defaults;
var $11de10e2de3ddf8e$export$2e2bcd8739ae039 = $11de10e2de3ddf8e$var$Popper;

});

parcelRegister("lQE57", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "data", function () { return data; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
$parcel$export(module.exports, "add", function () { return add; });
/**
 * Dom7 2.1.5
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * http://framework7.io/docs/dom.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: May 15, 2020
 */ 
var $2yCSJ = parcelRequire("2yCSJ");

var $59ZDq = parcelRequire("59ZDq");

var $e8VKf = parcelRequire("e8VKf");

var $6FbvV = parcelRequire("6FbvV");
var Dom7 = function Dom7(arr) {
    "use strict";
    (0, $2yCSJ._)(this, Dom7);
    var self = this;
    // Create array-like object
    for(var i = 0; i < arr.length; i += 1)self[i] = arr[i];
    self.length = arr.length;
    // Return collection with methods
    return this;
};
function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
        if (selector instanceof Dom7) return selector;
    }
    if (selector) {
        // String
        if (typeof selector === "string") {
            var els;
            var tempParent;
            var html = selector.trim();
            if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
                var toCreate = "div";
                if (html.indexOf("<li") === 0) toCreate = "ul";
                if (html.indexOf("<tr") === 0) toCreate = "tbody";
                if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
                if (html.indexOf("<tbody") === 0) toCreate = "table";
                if (html.indexOf("<option") === 0) toCreate = "select";
                tempParent = (0, $6FbvV.document).createElement(toCreate);
                tempParent.innerHTML = html;
                for(i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
            } else {
                if (!context && selector[0] === "#" && !selector.match(/[ .<>:~]/)) // Pure ID selector
                els = [
                    (0, $6FbvV.document).getElementById(selector.trim().split("#")[1])
                ];
                else // Other selectors
                els = (context || (0, $6FbvV.document)).querySelectorAll(selector.trim());
                for(i = 0; i < els.length; i += 1)if (els[i]) arr.push(els[i]);
            }
        } else if (selector.nodeType || selector === (0, $6FbvV.window) || selector === (0, $6FbvV.document)) // Node/element
        arr.push(selector);
        else if (selector.length > 0 && selector[0].nodeType) // Array of elements or instance of Dom
        for(i = 0; i < selector.length; i += 1)arr.push(selector[i]);
    }
    return new Dom7(arr);
}
$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;
function unique(arr) {
    var uniqueArray = [];
    for(var i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
}
function requestAnimationFrame(callback) {
    if ((0, $6FbvV.window).requestAnimationFrame) return (0, $6FbvV.window).requestAnimationFrame(callback);
    else if ((0, $6FbvV.window).webkitRequestAnimationFrame) return (0, $6FbvV.window).webkitRequestAnimationFrame(callback);
    return (0, $6FbvV.window).setTimeout(callback, 1000 / 60);
}
function cancelAnimationFrame(id) {
    if ((0, $6FbvV.window).cancelAnimationFrame) return (0, $6FbvV.window).cancelAnimationFrame(id);
    else if ((0, $6FbvV.window).webkitCancelAnimationFrame) return (0, $6FbvV.window).webkitCancelAnimationFrame(id);
    return (0, $6FbvV.window).clearTimeout(id);
}
// Classes and attributes
function addClass(className) {
    if (typeof className === "undefined") return this;
    var classes = className.split(" ");
    for(var i = 0; i < classes.length; i += 1){
        for(var j = 0; j < this.length; j += 1)if (typeof this[j] !== "undefined" && typeof this[j].classList !== "undefined") this[j].classList.add(classes[i]);
    }
    return this;
}
function removeClass(className) {
    var classes = className.split(" ");
    for(var i = 0; i < classes.length; i += 1){
        for(var j = 0; j < this.length; j += 1)if (typeof this[j] !== "undefined" && typeof this[j].classList !== "undefined") this[j].classList.remove(classes[i]);
    }
    return this;
}
function hasClass(className) {
    if (!this[0]) return false;
    return this[0].classList.contains(className);
}
function toggleClass(className) {
    var classes = className.split(" ");
    for(var i = 0; i < classes.length; i += 1){
        for(var j = 0; j < this.length; j += 1)if (typeof this[j] !== "undefined" && typeof this[j].classList !== "undefined") this[j].classList.toggle(classes[i]);
    }
    return this;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    }
    // Set attrs
    for(var i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        // eslint-disable-next-line
        for(var attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
    for(var i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
// eslint-disable-next-line
function prop(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(var i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            // eslint-disable-next-line
            for(var propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
}
function data(key, value) {
    var el;
    if (typeof value === "undefined") {
        el = this[0];
        // Get value
        if (el) {
            if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
            var dataKey = el.getAttribute("data-".concat(key));
            if (dataKey) return dataKey;
            return undefined;
        }
        return undefined;
    }
    // Set value
    for(var i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    var el = this[0];
    if (!el) return undefined;
    var dataset = {}; // eslint-disable-line
    if (el.dataset) // eslint-disable-next-line
    for(var dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(var i = 0; i < el.attributes.length; i += 1){
        // eslint-disable-next-line
        var attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    // eslint-disable-next-line
    for(var key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    var dom = this;
    if (typeof value === "undefined") {
        if (dom[0]) {
            if (dom[0].multiple && dom[0].nodeName.toLowerCase() === "select") {
                var values = [];
                for(var i = 0; i < dom[0].selectedOptions.length; i += 1)values.push(dom[0].selectedOptions[i].value);
                return values;
            }
            return dom[0].value;
        }
        return undefined;
    }
    for(var i1 = 0; i1 < dom.length; i1 += 1){
        var el = dom[i1];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(var j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return dom;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
    for(var i = 0; i < this.length; i += 1){
        var elStyle = this[i].style;
        elStyle.webkitTransform = transform;
        elStyle.transform = transform;
    }
    return this;
}
function transition(duration) {
    if (typeof duration !== "string") duration = "".concat(duration, "ms"); // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var elStyle = this[i].style;
        elStyle.webkitTransitionDuration = duration;
        elStyle.transitionDuration = duration;
    }
    return this;
}
// Events
function on() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $59ZDq._)(args, 4), eventType = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === "function") {
        var ref;
        ref = (0, $59ZDq._)(args, 3), eventType = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            var parents = $(target).parents(); // eslint-disable-line
            for(var k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    var events = eventType.split(" ");
    var j;
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            var event1 = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event1]) el.dom7LiveListeners[event1] = [];
            el.dom7LiveListeners[event1].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event1, handleLiveEvent, capture);
        }
    }
    return this;
}
function off() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $59ZDq._)(args, 4), eventType = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === "function") {
        var ref;
        ref = (0, $59ZDq._)(args, 3), eventType = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(" ");
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var handlers = void 0;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(var k = handlers.length - 1; k >= 0; k -= 1){
                var handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var dom = this;
    var _args = (0, $59ZDq._)(args, 4), eventName = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === "function") {
        var ref;
        ref = (0, $59ZDq._)(args, 3), eventName = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    function onceHandler() {
        for(var _len = arguments.length, eventArgs = new Array(_len), _key = 0; _key < _len; _key++){
            eventArgs[_key] = arguments[_key];
        }
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var events = args[0].split(" ");
    var eventData = args[1];
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var evt = void 0;
            try {
                evt = new (0, $6FbvV.window).CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
            } catch (e) {
                evt = (0, $6FbvV.document).createEvent("Event");
                evt.initEvent(event, true, true);
                evt.detail = eventData;
            }
            // eslint-disable-next-line
            el.dom7EventData = args.filter(function(data, dataIndex) {
                return dataIndex > 0;
            });
            el.dispatchEvent(evt);
            el.dom7EventData = [];
            delete el.dom7EventData;
        }
    }
    return this;
}
function transitionEnd(callback) {
    var events = [
        "webkitTransitionEnd",
        "transitionend"
    ];
    var dom = this;
    var i;
    function fireCallBack(e) {
        /* jshint validthis:true */ if (e.target !== this) return;
        callback.call(this, e);
        for(i = 0; i < events.length; i += 1)dom.off(events[i], fireCallBack);
    }
    if (callback) for(i = 0; i < events.length; i += 1)dom.on(events[i], fireCallBack);
    return this;
}
function animationEnd(callback) {
    var events = [
        "webkitAnimationEnd",
        "animationend"
    ];
    var dom = this;
    var i;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        for(i = 0; i < events.length; i += 1)dom.off(events[i], fireCallBack);
    }
    if (callback) for(i = 0; i < events.length; i += 1)dom.on(events[i], fireCallBack);
    return this;
}
// Sizing/Styles
function width() {
    if (this[0] === (0, $6FbvV.window)) return (0, $6FbvV.window).innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            // eslint-disable-next-line
            var styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    if (this[0] === (0, $6FbvV.window)) return (0, $6FbvV.window).innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            // eslint-disable-next-line
            var styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = (0, $6FbvV.document).body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === (0, $6FbvV.window) ? (0, $6FbvV.window).scrollY : el.scrollTop;
        var scrollLeft = el === (0, $6FbvV.window) ? (0, $6FbvV.window).scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(var i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function show() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if ((0, $6FbvV.window).getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function styles() {
    if (this[0]) return (0, $6FbvV.window).getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    var i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            if (this[0]) return (0, $6FbvV.window).getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            for(i = 0; i < this.length; i += 1)// eslint-disable-next-line
            for(var prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
// Dom manipulation
function toArray() {
    var arr = [];
    for(var i = 0; i < this.length; i += 1)arr.push(this[i]);
    return arr;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) return this;
    // Iterate over the current collection
    for(var i = 0; i < this.length; i += 1){
        // If the callback returns false
        if (callback.call(this[i], i, this[i]) === false) // End the loop early
        return this;
    }
    // Return `this` to allow chained DOM operations
    return this;
}
function forEach(callback) {
    // Don't bother continuing without a callback
    if (!callback) return this;
    // Iterate over the current collection
    for(var i = 0; i < this.length; i += 1){
        // If the callback returns false
        if (callback.call(this[i], this[i], i) === false) // End the loop early
        return this;
    }
    // Return `this` to allow chained DOM operations
    return this;
}
function filter(callback) {
    var matchedItems = [];
    var dom = this;
    for(var i = 0; i < dom.length; i += 1)if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
    return new Dom7(matchedItems);
}
function map(callback) {
    var modifiedItems = [];
    var dom = this;
    for(var i = 0; i < dom.length; i += 1)modifiedItems.push(callback.call(dom[i], i, dom[i]));
    return new Dom7(modifiedItems);
}
// eslint-disable-next-line
function html(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : undefined;
    for(var i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
// eslint-disable-next-line
function text(text) {
    if (typeof text === "undefined") {
        if (this[0]) return this[0].textContent.trim();
        return null;
    }
    for(var i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    } else if (selector === (0, $6FbvV.document)) return el === (0, $6FbvV.document);
    else if (selector === (0, $6FbvV.window)) return el === (0, $6FbvV.window);
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function indexOf(el) {
    for(var i = 0; i < this.length; i += 1){
        if (this[i] === el) return i;
    }
    return -1;
}
function index() {
    var child = this[0];
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
// eslint-disable-next-line
function eq(index) {
    if (typeof index === "undefined") return this;
    var length = this.length;
    var returnIndex;
    if (index > length - 1) return new Dom7([]);
    if (index < 0) {
        returnIndex = length + index;
        if (returnIndex < 0) return new Dom7([]);
        return new Dom7([
            this[returnIndex]
        ]);
    }
    return new Dom7([
        this[index]
    ]);
}
function append() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var newChild;
    for(var k = 0; k < args.length; k += 1){
        newChild = args[k];
        for(var i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                var tempDiv = (0, $6FbvV.document).createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(var j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
// eslint-disable-next-line
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    var i;
    var j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            var tempDiv = (0, $6FbvV.document).createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
// eslint-disable-next-line
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    var before = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(var j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    var after = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(var j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([
                this[0].nextElementSibling
            ]);
            return new Dom7([]);
        }
        if (this[0].nextElementSibling) return new Dom7([
            this[0].nextElementSibling
        ]);
        return new Dom7([]);
    }
    return new Dom7([]);
}
function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return new Dom7([]);
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return new Dom7(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        var el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return new Dom7([
                el.previousElementSibling
            ]);
            return new Dom7([]);
        }
        if (el.previousElementSibling) return new Dom7([
            el.previousElementSibling
        ]);
        return new Dom7([]);
    }
    return new Dom7([]);
}
function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return new Dom7([]);
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return new Dom7(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(unique(parents));
}
function parents(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(unique(parents));
}
function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return new Dom7([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    var foundElements = [];
    for(var i = 0; i < this.length; i += 1){
        var found = this[i].querySelectorAll(selector);
        for(var j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return new Dom7(foundElements);
}
function children(selector) {
    var children = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var childNodes = this[i].childNodes;
        for(var j = 0; j < childNodes.length; j += 1){
            if (!selector) {
                if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
            } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
        }
    }
    return new Dom7(unique(children));
}
function remove() {
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var dom = this;
    var i;
    var j;
    for(i = 0; i < args.length; i += 1){
        var toAdd = $(args[i]);
        for(j = 0; j < toAdd.length; j += 1){
            dom[dom.length] = toAdd[j];
            dom.length += 1;
        }
    }
    return dom;
}
function empty() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.nodeType === 1) {
            for(var j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
function scrollTo() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $59ZDq._)(args, 5), left = _args[0], top = _args[1], duration = _args[2], easing = _args[3], callback = _args[4];
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        var ref;
        ref = (0, $59ZDq._)(args, 5), left = ref[0], top = ref[1], duration = ref[2], callback = ref[3], easing = ref[4], ref;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        var el = this;
        var currentTop;
        var currentLeft;
        var maxTop;
        var maxLeft;
        var newTop;
        var newLeft;
        var scrollTop; // eslint-disable-line
        var scrollLeft; // eslint-disable-line
        var animateTop = top > 0 || top === 0;
        var animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        var startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render() {
            var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().getTime();
            if (startTime === null) startTime = time;
            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            var easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            var done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            requestAnimationFrame(render);
        }
        requestAnimationFrame(render);
    });
}
// scrollTop(top, duration, easing, callback) {
function scrollTop() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $59ZDq._)(args, 4), top = _args[0], duration = _args[1], easing = _args[2], callback = _args[3];
    var ref;
    if (args.length === 3 && typeof easing === "function") ref = (0, $59ZDq._)(args, 4), top = ref[0], duration = ref[1], callback = ref[2], easing = ref[3], ref;
    var dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $59ZDq._)(args, 4), left = _args[0], duration = _args[1], easing = _args[2], callback = _args[3];
    var ref;
    if (args.length === 3 && typeof easing === "function") ref = (0, $59ZDq._)(args, 4), left = ref[0], duration = ref[1], callback = ref[2], easing = ref[3], ref;
    var dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
function animate(initialProps, initialParams) {
    var els = this;
    var a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing"
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress: function(easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop: function() {
            if (a.frameId) cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each(function(index, el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done: function(complete) {
            a.animating = false;
            a.elements.each(function(index, el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                var que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate: function(props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            var elements = [];
            // Define & Cache Initials & Units
            a.elements.each(function(index, el) {
                var initialFullValue;
                var initialValue;
                var unit;
                var finalValue;
                var finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach(function(prop) {
                    initialFullValue = (0, $6FbvV.window).getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            var startTime = null;
            var time;
            var elementsDone = 0;
            var propsDone = 0;
            var done;
            var began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                var progress;
                var easeProgress;
                // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach(function(element) {
                    var el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach(function(prop) {
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        var _el_prop = el[prop], initialValue = _el_prop.initialValue, finalValue = _el_prop.finalValue, unit = _el_prop.unit;
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        var currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return;
                // Then call
                a.frameId = requestAnimationFrame(render);
            }
            a.frameId = requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    var animateInstance;
    for(var i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    var els = this;
    for(var i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
var noTrigger = "resize scroll".split(" ");
function eventShortcut(name) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (typeof args[0] === "undefined") {
        for(var i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
            if (name in this[i]) this[i][name]();
            else $(this[i]).trigger(name);
        }
        return this;
    }
    return this.on.apply(this, [
        name
    ].concat((0, $e8VKf._)(args)));
}
function click() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "click"
    ].concat((0, $e8VKf._)(args)));
}
function blur() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "blur"
    ].concat((0, $e8VKf._)(args)));
}
function focus() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "focus"
    ].concat((0, $e8VKf._)(args)));
}
function focusin() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "focusin"
    ].concat((0, $e8VKf._)(args)));
}
function focusout() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "focusout"
    ].concat((0, $e8VKf._)(args)));
}
function keyup() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "keyup"
    ].concat((0, $e8VKf._)(args)));
}
function keydown() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "keydown"
    ].concat((0, $e8VKf._)(args)));
}
function keypress() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "keypress"
    ].concat((0, $e8VKf._)(args)));
}
function submit() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "submit"
    ].concat((0, $e8VKf._)(args)));
}
function change() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "change"
    ].concat((0, $e8VKf._)(args)));
}
function mousedown() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mousedown"
    ].concat((0, $e8VKf._)(args)));
}
function mousemove() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mousemove"
    ].concat((0, $e8VKf._)(args)));
}
function mouseup() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mouseup"
    ].concat((0, $e8VKf._)(args)));
}
function mouseenter() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mouseenter"
    ].concat((0, $e8VKf._)(args)));
}
function mouseleave() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mouseleave"
    ].concat((0, $e8VKf._)(args)));
}
function mouseout() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mouseout"
    ].concat((0, $e8VKf._)(args)));
}
function mouseover() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "mouseover"
    ].concat((0, $e8VKf._)(args)));
}
function touchstart() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "touchstart"
    ].concat((0, $e8VKf._)(args)));
}
function touchend() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "touchend"
    ].concat((0, $e8VKf._)(args)));
}
function touchmove() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "touchmove"
    ].concat((0, $e8VKf._)(args)));
}
function resize() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "resize"
    ].concat((0, $e8VKf._)(args)));
}
function scroll() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return eventShortcut.bind(this).apply(this, [
        "scroll"
    ].concat((0, $e8VKf._)(args)));
}

});
parcelRegister("2yCSJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1dcceadf22aab102$export$2996f80ef42b8419; });
function $1dcceadf22aab102$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("59ZDq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3c1d9a6725b39139$export$fdf2a89c76341bbf; });

var $hudQk = parcelRequire("hudQk");

var $8ktbR = parcelRequire("8ktbR");

var $lA04c = parcelRequire("lA04c");

var $ax3pA = parcelRequire("ax3pA");
function $3c1d9a6725b39139$export$fdf2a89c76341bbf(arr, i) {
    return (0, $hudQk._array_with_holes)(arr) || (0, $8ktbR._iterable_to_array_limit)(arr, i) || (0, $ax3pA._unsupported_iterable_to_array)(arr, i) || (0, $lA04c._non_iterable_rest)();
}

});
parcelRegister("hudQk", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $cbaff9f282e33e26$export$e6256bf45c68d561; });
function $cbaff9f282e33e26$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("8ktbR", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $6106d59451899624$export$2fd15edff6687200; });
function $6106d59451899624$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("lA04c", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $fb5d0300cda576cc$export$60dbc22abd7da546; });
function $fb5d0300cda576cc$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ax3pA", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $7aafa1ea983223df$export$a5be06335b3a083c; });

var $7HFaP = parcelRequire("7HFaP");
function $7aafa1ea983223df$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7HFaP._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7HFaP._array_like_to_array)(o, minLen);
}

});
parcelRegister("7HFaP", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $59bc7cc447d4b637$export$79e617b1955a2616; });
function $59bc7cc447d4b637$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("e8VKf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a4be9afc4601ec63$export$1b5e630bc3aea29f; });

var $4Ae9E = parcelRequire("4Ae9E");

var $3Sli2 = parcelRequire("3Sli2");

var $iSMxv = parcelRequire("iSMxv");

var $ax3pA = parcelRequire("ax3pA");
function $a4be9afc4601ec63$export$1b5e630bc3aea29f(arr) {
    return (0, $4Ae9E._array_without_holes)(arr) || (0, $3Sli2._iterable_to_array)(arr) || (0, $ax3pA._unsupported_iterable_to_array)(arr) || (0, $iSMxv._non_iterable_spread)();
}

});
parcelRegister("4Ae9E", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $3565810dd1bc483a$export$7e0947b5ad3404e2; });

var $7HFaP = parcelRequire("7HFaP");
function $3565810dd1bc483a$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $7HFaP._array_like_to_array)(arr);
}

});

parcelRegister("3Sli2", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $2d26edf84a14d7c4$export$1eb58a6e75231000; });
function $2d26edf84a14d7c4$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("iSMxv", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $dbf2ec113d0ee8cc$export$e6f3c4780d19eb2b; });
function $dbf2ec113d0ee8cc$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6FbvV", function(module, exports) {

$parcel$export(module.exports, "document", function () { return $4d9f80da2a754eca$export$5a7bfc01df82fcd1; });
$parcel$export(module.exports, "window", function () { return $4d9f80da2a754eca$export$8291e5b88f90ce4; });
/**
 * SSR Window 2.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: May 12, 2020
 */ /* eslint-disable no-param-reassign */ function $4d9f80da2a754eca$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $4d9f80da2a754eca$export$8b58be045bf06082(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($4d9f80da2a754eca$var$isObject(src[key]) && $4d9f80da2a754eca$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $4d9f80da2a754eca$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $4d9f80da2a754eca$export$5a7bfc01df82fcd1 = typeof document !== "undefined" ? document : {};
var $4d9f80da2a754eca$var$ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
        blur: function blur() {},
        nodeName: ""
    },
    querySelector: function querySelector() {
        return null;
    },
    querySelectorAll: function querySelectorAll() {
        return [];
    },
    getElementById: function getElementById() {
        return null;
    },
    createEvent: function createEvent() {
        return {
            initEvent: function initEvent() {}
        };
    },
    createElement: function createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function setAttribute() {},
            getElementsByTagName: function getElementsByTagName() {
                return [];
            }
        };
    },
    createElementNS: function createElementNS() {
        return {};
    },
    importNode: function importNode() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
$4d9f80da2a754eca$export$8b58be045bf06082($4d9f80da2a754eca$export$5a7bfc01df82fcd1, $4d9f80da2a754eca$var$ssrDocument);
var $4d9f80da2a754eca$export$8291e5b88f90ce4 = typeof window !== "undefined" ? window : {};
var $4d9f80da2a754eca$var$ssrWindow = {
    document: $4d9f80da2a754eca$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function replaceState() {},
        pushState: function pushState() {},
        go: function go() {},
        back: function back() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
        return {
            getPropertyValue: function getPropertyValue() {
                return "";
            }
        };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
        return {};
    }
};
$4d9f80da2a754eca$export$8b58be045bf06082($4d9f80da2a754eca$export$8291e5b88f90ce4, $4d9f80da2a754eca$var$ssrWindow);

});


parcelRegister("kLeCf", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("8BYBg", function(module, exports) {
/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory();
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.IPv6 = factory(root);
})(module.exports, function(root) {
    "use strict";
    /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */ // save current IPv6 variable, if any
    var _IPv6 = root && root.IPv6;
    function bestPresentation(address) {
        // based on:
        // Javascript to test an IPv6 address for proper format, and to
        // present the "best text representation" according to IETF Draft RFC at
        // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
        // 8 Feb 2010 Rich Brown, Dartware, LLC
        // Please feel free to use this code as long as you provide a link to
        // http://www.intermapper.com
        // http://intermapper.com/support/tools/IPV6-Validator.aspx
        // http://download.dartware.com/thirdparty/ipv6validator.js
        var _address = address.toLowerCase();
        var segments = _address.split(":");
        var length = segments.length;
        var total = 8;
        // trim colons (:: or ::a:b:c… or …a:b:c::)
        if (segments[0] === "" && segments[1] === "" && segments[2] === "") {
            // must have been ::
            // remove first two items
            segments.shift();
            segments.shift();
        } else if (segments[0] === "" && segments[1] === "") // must have been ::xxxx
        // remove the first item
        segments.shift();
        else if (segments[length - 1] === "" && segments[length - 2] === "") // must have been xxxx::
        segments.pop();
        length = segments.length;
        // adjust total segments for IPv4 trailer
        if (segments[length - 1].indexOf(".") !== -1) // found a "." which means IPv4
        total = 7;
        // fill empty segments them with "0000"
        var pos;
        for(pos = 0; pos < length; pos++){
            if (segments[pos] === "") break;
        }
        if (pos < total) {
            segments.splice(pos, 1, "0000");
            while(segments.length < total)segments.splice(pos, 0, "0000");
        }
        // strip leading zeros
        var _segments;
        for(var i = 0; i < total; i++){
            _segments = segments[i].split("");
            for(var j = 0; j < 3; j++){
                if (_segments[0] === "0" && _segments.length > 1) _segments.splice(0, 1);
                else break;
            }
            segments[i] = _segments.join("");
        }
        // find longest sequence of zeroes and coalesce them into one segment
        var best = -1;
        var _best = 0;
        var _current = 0;
        var current = -1;
        var inzeroes = false;
        // i; already declared
        for(i = 0; i < total; i++){
            if (inzeroes) {
                if (segments[i] === "0") _current += 1;
                else {
                    inzeroes = false;
                    if (_current > _best) {
                        best = current;
                        _best = _current;
                    }
                }
            } else if (segments[i] === "0") {
                inzeroes = true;
                current = i;
                _current = 1;
            }
        }
        if (_current > _best) {
            best = current;
            _best = _current;
        }
        if (_best > 1) segments.splice(best, _best, "");
        length = segments.length;
        // assemble remaining segments
        var result = "";
        if (segments[0] === "") result = ":";
        for(i = 0; i < length; i++){
            result += segments[i];
            if (i === length - 1) break;
            result += ":";
        }
        if (segments[length - 1] === "") result += ":";
        return result;
    }
    function noConflict() {
        /*jshint validthis: true */ if (root.IPv6 === this) root.IPv6 = _IPv6;
        return this;
    }
    return {
        best: bestPresentation,
        noConflict: noConflict
    };
});

});

parcelRegister("lY1XY", function(module, exports) {
/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory();
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
})(module.exports, function(root) {
    "use strict";
    // save current SecondLevelDomains variable, if any
    var _SecondLevelDomains = root && root.SecondLevelDomains;
    var SLD = {
        // list of known Second Level Domains
        // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
        // ----
        // publicsuffix.org is more current and actually used by a couple of browsers internally.
        // downside is it also contains domains like "dyndns.org" - which is fine for the security
        // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
        // ----
        list: {
            "ac": " com gov mil net org ",
            "ae": " ac co gov mil name net org pro sch ",
            "af": " com edu gov net org ",
            "al": " com edu gov mil net org ",
            "ao": " co ed gv it og pb ",
            "ar": " com edu gob gov int mil net org tur ",
            "at": " ac co gv or ",
            "au": " asn com csiro edu gov id net org ",
            "ba": " co com edu gov mil net org rs unbi unmo unsa untz unze ",
            "bb": " biz co com edu gov info net org store tv ",
            "bh": " biz cc com edu gov info net org ",
            "bn": " com edu gov net org ",
            "bo": " com edu gob gov int mil net org tv ",
            "br": " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
            "bs": " com edu gov net org ",
            "bz": " du et om ov rg ",
            "ca": " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
            "ck": " biz co edu gen gov info net org ",
            "cn": " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
            "co": " com edu gov mil net nom org ",
            "cr": " ac c co ed fi go or sa ",
            "cy": " ac biz com ekloges gov ltd name net org parliament press pro tm ",
            "do": " art com edu gob gov mil net org sld web ",
            "dz": " art asso com edu gov net org pol ",
            "ec": " com edu fin gov info med mil net org pro ",
            "eg": " com edu eun gov mil name net org sci ",
            "er": " com edu gov ind mil net org rochest w ",
            "es": " com edu gob nom org ",
            "et": " biz com edu gov info name net org ",
            "fj": " ac biz com info mil name net org pro ",
            "fk": " ac co gov net nom org ",
            "fr": " asso com f gouv nom prd presse tm ",
            "gg": " co net org ",
            "gh": " com edu gov mil org ",
            "gn": " ac com gov net org ",
            "gr": " com edu gov mil net org ",
            "gt": " com edu gob ind mil net org ",
            "gu": " com edu gov net org ",
            "hk": " com edu gov idv net org ",
            "hu": " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
            "id": " ac co go mil net or sch web ",
            "il": " ac co gov idf k12 muni net org ",
            "in": " ac co edu ernet firm gen gov i ind mil net nic org res ",
            "iq": " com edu gov i mil net org ",
            "ir": " ac co dnssec gov i id net org sch ",
            "it": " edu gov ",
            "je": " co net org ",
            "jo": " com edu gov mil name net org sch ",
            "jp": " ac ad co ed go gr lg ne or ",
            "ke": " ac co go info me mobi ne or sc ",
            "kh": " com edu gov mil net org per ",
            "ki": " biz com de edu gov info mob net org tel ",
            "km": " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
            "kn": " edu gov net org ",
            "kr": " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
            "kw": " com edu gov net org ",
            "ky": " com edu gov net org ",
            "kz": " com edu gov mil net org ",
            "lb": " com edu gov net org ",
            "lk": " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
            "lr": " com edu gov net org ",
            "lv": " asn com conf edu gov id mil net org ",
            "ly": " com edu gov id med net org plc sch ",
            "ma": " ac co gov m net org press ",
            "mc": " asso tm ",
            "me": " ac co edu gov its net org priv ",
            "mg": " com edu gov mil nom org prd tm ",
            "mk": " com edu gov inf name net org pro ",
            "ml": " com edu gov net org presse ",
            "mn": " edu gov org ",
            "mo": " com edu gov net org ",
            "mt": " com edu gov net org ",
            "mv": " aero biz com coop edu gov info int mil museum name net org pro ",
            "mw": " ac co com coop edu gov int museum net org ",
            "mx": " com edu gob net org ",
            "my": " com edu gov mil name net org sch ",
            "nf": " arts com firm info net other per rec store web ",
            "ng": " biz com edu gov mil mobi name net org sch ",
            "ni": " ac co com edu gob mil net nom org ",
            "np": " com edu gov mil net org ",
            "nr": " biz com edu gov info net org ",
            "om": " ac biz co com edu gov med mil museum net org pro sch ",
            "pe": " com edu gob mil net nom org sld ",
            "ph": " com edu gov i mil net ngo org ",
            "pk": " biz com edu fam gob gok gon gop gos gov net org web ",
            "pl": " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
            "pr": " ac biz com edu est gov info isla name net org pro prof ",
            "ps": " com edu gov net org plo sec ",
            "pw": " belau co ed go ne or ",
            "ro": " arts com firm info nom nt org rec store tm www ",
            "rs": " ac co edu gov in org ",
            "sb": " com edu gov net org ",
            "sc": " com edu gov net org ",
            "sh": " co com edu gov net nom org ",
            "sl": " com edu gov net org ",
            "st": " co com consulado edu embaixada gov mil net org principe saotome store ",
            "sv": " com edu gob org red ",
            "sz": " ac co org ",
            "tr": " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
            "tt": " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
            "tw": " club com ebiz edu game gov idv mil net org ",
            "mu": " ac co com gov net or org ",
            "mz": " ac co edu gov org ",
            "na": " co com ",
            "nz": " ac co cri geek gen govt health iwi maori mil net org parliament school ",
            "pa": " abo ac com edu gob ing med net nom org sld ",
            "pt": " com edu gov int net nome org publ ",
            "py": " com edu gov mil net org ",
            "qa": " com edu gov mil net org ",
            "re": " asso com nom ",
            "ru": " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
            "rw": " ac co com edu gouv gov int mil net ",
            "sa": " com edu gov med net org pub sch ",
            "sd": " com edu gov info med net org tv ",
            "se": " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
            "sg": " com edu gov idn net org per ",
            "sn": " art com edu gouv org perso univ ",
            "sy": " com edu gov mil net news org ",
            "th": " ac co go in mi net or ",
            "tj": " ac biz co com edu go gov info int mil name net nic org test web ",
            "tn": " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
            "tz": " ac co go ne or ",
            "ua": " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
            "ug": " ac co go ne or org sc ",
            "uk": " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
            "us": " dni fed isa kids nsn ",
            "uy": " com edu gub mil net org ",
            "ve": " co com edu gob info mil net org web ",
            "vi": " co com k12 net org ",
            "vn": " ac biz com edu gov health info int name net org pro ",
            "ye": " co com gov ltd me net org plc ",
            "yu": " ac co edu gov org ",
            "za": " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
            "zm": " ac co com edu gov net org sch ",
            // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
            "com": "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
            "net": "gb jp se uk ",
            "org": "ae",
            "de": "com "
        },
        // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
        // in both performance and memory footprint. No initialization required.
        // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
        // Following methods use lastIndexOf() rather than array.split() in order
        // to avoid any memory allocations.
        has: function has(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(" " + domain.slice(sldOffset + 1, tldOffset) + " ") >= 0;
        },
        is: function is(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset >= 0) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(" " + domain.slice(0, tldOffset) + " ") >= 0;
        },
        get: function get(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return null;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return null;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return null;
            if (sldList.indexOf(" " + domain.slice(sldOffset + 1, tldOffset) + " ") < 0) return null;
            return domain.slice(sldOffset + 1);
        },
        noConflict: function noConflict() {
            if (root.SecondLevelDomains === this) root.SecondLevelDomains = _SecondLevelDomains;
            return this;
        }
    };
    return SLD;
});

});

parcelRegister("cosnu", function(module, exports) {
/*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */ /*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */ 
var $2yCSJ = parcelRequire("2yCSJ");

var $80pZ5 = parcelRequire("80pZ5");

var $ddmaO = parcelRequire("ddmaO");

var $1ciUP = parcelRequire("1ciUP");
"use strict";
var $905dbd31c454eff7$var$t1 = Object.freeze({}), $905dbd31c454eff7$var$e = Array.isArray;
function $905dbd31c454eff7$var$n1(t1) {
    return null == t1;
}
function $905dbd31c454eff7$var$o(t1) {
    return null != t1;
}
function $905dbd31c454eff7$var$r(t1) {
    return !0 === t1;
}
function $905dbd31c454eff7$var$s(t1) {
    return "string" == typeof t1 || "number" == typeof t1 || "symbol" == (typeof t1 === "undefined" ? "undefined" : (0, $1ciUP._)(t1)) || "boolean" == typeof t1;
}
function $905dbd31c454eff7$var$i(t1) {
    return "function" == typeof t1;
}
function $905dbd31c454eff7$var$c(t1) {
    return null !== t1 && "object" == typeof t1;
}
var $905dbd31c454eff7$var$a = Object.prototype.toString;
function $905dbd31c454eff7$var$l(t1) {
    return "[object Object]" === $905dbd31c454eff7$var$a.call(t1);
}
function $905dbd31c454eff7$var$u(t1) {
    var e = parseFloat(String(t1));
    return e >= 0 && Math.floor(e) === e && isFinite(t1);
}
function $905dbd31c454eff7$var$f(t1) {
    return $905dbd31c454eff7$var$o(t1) && "function" == typeof t1.then && "function" == typeof t1.catch;
}
function $905dbd31c454eff7$var$d(t1) {
    return null == t1 ? "" : Array.isArray(t1) || $905dbd31c454eff7$var$l(t1) && t1.toString === $905dbd31c454eff7$var$a ? JSON.stringify(t1, $905dbd31c454eff7$var$p, 2) : String(t1);
}
function $905dbd31c454eff7$var$p(t1, e) {
    return e && e.__v_isRef ? e.value : e;
}
function $905dbd31c454eff7$var$h(t1) {
    var e = parseFloat(t1);
    return isNaN(e) ? t1 : e;
}
function $905dbd31c454eff7$var$m(t1, e) {
    var n1 = Object.create(null), o = t1.split(",");
    for(var _$t = 0; _$t < o.length; _$t++)n1[o[_$t]] = !0;
    return e ? function(t1) {
        return n1[t1.toLowerCase()];
    } : function(t1) {
        return n1[t1];
    };
}
var $905dbd31c454eff7$var$g = $905dbd31c454eff7$var$m("slot,component", !0), $905dbd31c454eff7$var$v = $905dbd31c454eff7$var$m("key,ref,slot,slot-scope,is");
function $905dbd31c454eff7$var$y(t1, e) {
    var n1 = t1.length;
    if (n1) {
        if (e === t1[n1 - 1]) return void (t1.length = n1 - 1);
        var o = t1.indexOf(e);
        if (o > -1) return t1.splice(o, 1);
    }
}
var $905dbd31c454eff7$var$_ = Object.prototype.hasOwnProperty;
function $905dbd31c454eff7$var$$(t1, e) {
    return $905dbd31c454eff7$var$_.call(t1, e);
}
function $905dbd31c454eff7$var$b(t1) {
    var e = Object.create(null);
    return function(n1) {
        return e[n1] || (e[n1] = t1(n1));
    };
}
var $905dbd31c454eff7$var$w = /-(\w)/g, $905dbd31c454eff7$var$x = $905dbd31c454eff7$var$b(function(t1) {
    return t1.replace($905dbd31c454eff7$var$w, function(t1, e) {
        return e ? e.toUpperCase() : "";
    });
}), $905dbd31c454eff7$var$C = $905dbd31c454eff7$var$b(function(t1) {
    return t1.charAt(0).toUpperCase() + t1.slice(1);
}), $905dbd31c454eff7$var$k = /\B([A-Z])/g, $905dbd31c454eff7$var$S = $905dbd31c454eff7$var$b(function(t1) {
    return t1.replace($905dbd31c454eff7$var$k, "-$1").toLowerCase();
});
var $905dbd31c454eff7$var$O = Function.prototype.bind ? function O(t1, e) {
    return t1.bind(e);
} : function(t1, e) {
    function n1(n1) {
        var o = arguments.length;
        return o ? o > 1 ? t1.apply(e, arguments) : t1.call(e, n1) : t1.call(e);
    }
    return n1._length = t1.length, n1;
};
function $905dbd31c454eff7$var$T(t1, e) {
    e = e || 0;
    var n1 = t1.length - e;
    var o = new Array(n1);
    for(; n1--;)o[n1] = t1[n1 + e];
    return o;
}
function $905dbd31c454eff7$var$A(t1, e) {
    for(var n1 in e)t1[n1] = e[n1];
    return t1;
}
function $905dbd31c454eff7$var$j(t1) {
    var e = {};
    for(var n1 = 0; n1 < t1.length; n1++)t1[n1] && $905dbd31c454eff7$var$A(e, t1[n1]);
    return e;
}
function $905dbd31c454eff7$var$E(t1, e, n1) {}
var $905dbd31c454eff7$var$N = function(t1, e, n1) {
    return !1;
}, $905dbd31c454eff7$var$P = function(t1) {
    return t1;
};
function $905dbd31c454eff7$var$D(t1, e) {
    if (t1 === e) return !0;
    var n1 = $905dbd31c454eff7$var$c(t1), o = $905dbd31c454eff7$var$c(e);
    if (!n1 || !o) return !n1 && !o && String(t1) === String(e);
    try {
        var n2 = Array.isArray(t1), o1 = Array.isArray(e);
        if (n2 && o1) return t1.length === e.length && t1.every(function(t1, n1) {
            return $905dbd31c454eff7$var$D(t1, e[n1]);
        });
        if (t1 instanceof Date && e instanceof Date) return t1.getTime() === e.getTime();
        if (n2 || o1) return !1;
        {
            var n3 = Object.keys(t1), o2 = Object.keys(e);
            return n3.length === o2.length && n3.every(function(n1) {
                return $905dbd31c454eff7$var$D(t1[n1], e[n1]);
            });
        }
    } catch (t1) {
        return !1;
    }
}
function $905dbd31c454eff7$var$M(t1, e) {
    for(var n1 = 0; n1 < t1.length; n1++)if ($905dbd31c454eff7$var$D(t1[n1], e)) return n1;
    return -1;
}
function $905dbd31c454eff7$var$I(t1) {
    var e = !1;
    return function() {
        e || (e = !0, t1.apply(this, arguments));
    };
}
function $905dbd31c454eff7$var$L(t1, e) {
    return t1 === e ? 0 === t1 && 1 / t1 != 1 / e : t1 == t1 || e == e;
}
var $905dbd31c454eff7$var$R = "data-server-rendered", $905dbd31c454eff7$var$F = [
    "component",
    "directive",
    "filter"
], $905dbd31c454eff7$var$H = [
    "beforeCreate",
    "created",
    "beforeMount",
    "mounted",
    "beforeUpdate",
    "updated",
    "beforeDestroy",
    "destroyed",
    "activated",
    "deactivated",
    "errorCaptured",
    "serverPrefetch",
    "renderTracked",
    "renderTriggered"
];
var $905dbd31c454eff7$var$B = {
    optionMergeStrategies: Object.create(null),
    silent: !1,
    productionTip: !1,
    devtools: !1,
    performance: !1,
    errorHandler: null,
    warnHandler: null,
    ignoredElements: [],
    keyCodes: Object.create(null),
    isReservedTag: $905dbd31c454eff7$var$N,
    isReservedAttr: $905dbd31c454eff7$var$N,
    isUnknownElement: $905dbd31c454eff7$var$N,
    getTagNamespace: $905dbd31c454eff7$var$E,
    parsePlatformTagName: $905dbd31c454eff7$var$P,
    mustUseProp: $905dbd31c454eff7$var$N,
    async: !0,
    _lifecycleHooks: $905dbd31c454eff7$var$H
};
var $905dbd31c454eff7$var$U = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
function $905dbd31c454eff7$var$z(t1) {
    var e = (t1 + "").charCodeAt(0);
    return 36 === e || 95 === e;
}
function $905dbd31c454eff7$var$V(t1, e, n1, o) {
    Object.defineProperty(t1, e, {
        value: n1,
        enumerable: !!o,
        writable: !0,
        configurable: !0
    });
}
var $905dbd31c454eff7$var$K = new RegExp("[^".concat($905dbd31c454eff7$var$U.source, ".$_\\d]"));
var $905dbd31c454eff7$var$J = "__proto__" in {}, $905dbd31c454eff7$var$q = "undefined" != typeof window, $905dbd31c454eff7$var$W = $905dbd31c454eff7$var$q && window.navigator.userAgent.toLowerCase(), $905dbd31c454eff7$var$Z = $905dbd31c454eff7$var$W && /msie|trident/.test($905dbd31c454eff7$var$W), $905dbd31c454eff7$var$G = $905dbd31c454eff7$var$W && $905dbd31c454eff7$var$W.indexOf("msie 9.0") > 0, $905dbd31c454eff7$var$X = $905dbd31c454eff7$var$W && $905dbd31c454eff7$var$W.indexOf("edge/") > 0;
$905dbd31c454eff7$var$W && $905dbd31c454eff7$var$W.indexOf("android");
var $905dbd31c454eff7$var$Y = $905dbd31c454eff7$var$W && /iphone|ipad|ipod|ios/.test($905dbd31c454eff7$var$W);
$905dbd31c454eff7$var$W && /chrome\/\d+/.test($905dbd31c454eff7$var$W), $905dbd31c454eff7$var$W && /phantomjs/.test($905dbd31c454eff7$var$W);
var $905dbd31c454eff7$var$Q = $905dbd31c454eff7$var$W && $905dbd31c454eff7$var$W.match(/firefox\/(\d+)/), $905dbd31c454eff7$var$tt = {}.watch;
var $905dbd31c454eff7$var$et, $905dbd31c454eff7$var$nt = !1;
if ($905dbd31c454eff7$var$q) try {
    var $905dbd31c454eff7$var$t2 = {};
    Object.defineProperty($905dbd31c454eff7$var$t2, "passive", {
        get: function() {
            $905dbd31c454eff7$var$nt = !0;
        }
    }), window.addEventListener("test-passive", null, $905dbd31c454eff7$var$t2);
} catch (t1) {}
var $905dbd31c454eff7$var$ot = function() {
    return void 0 === $905dbd31c454eff7$var$et && ($905dbd31c454eff7$var$et = !$905dbd31c454eff7$var$q && "undefined" != typeof $parcel$global && $parcel$global.process && "server" === $parcel$global.process.env.VUE_ENV), $905dbd31c454eff7$var$et;
}, $905dbd31c454eff7$var$rt = $905dbd31c454eff7$var$q && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
function $905dbd31c454eff7$var$st(t1) {
    return "function" == typeof t1 && /native code/.test(t1.toString());
}
var $905dbd31c454eff7$var$it = "undefined" != typeof Symbol && $905dbd31c454eff7$var$st(Symbol) && "undefined" != typeof Reflect && $905dbd31c454eff7$var$st(Reflect.ownKeys);
var $905dbd31c454eff7$var$ct;
$905dbd31c454eff7$var$ct = "undefined" != typeof Set && $905dbd31c454eff7$var$st(Set) ? Set : /*#__PURE__*/ function() {
    function _class() {
        (0, $2yCSJ._)(this, _class);
        this.set = Object.create(null);
    }
    (0, $80pZ5._)(_class, [
        {
            key: "has",
            value: function has(t1) {
                return !0 === this.set[t1];
            }
        },
        {
            key: "add",
            value: function add(t1) {
                this.set[t1] = !0;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.set = Object.create(null);
            }
        }
    ]);
    return _class;
}();
var $905dbd31c454eff7$var$at = null;
function $905dbd31c454eff7$var$lt() {
    var t1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    t1 || $905dbd31c454eff7$var$at && $905dbd31c454eff7$var$at._scope.off(), $905dbd31c454eff7$var$at = t1, t1 && t1._scope.on();
}
var $905dbd31c454eff7$var$ut = /*#__PURE__*/ function() {
    function ut(t1, e, n1, o, r, s, i, c) {
        (0, $2yCSJ._)(this, ut);
        this.tag = t1, this.data = e, this.children = n1, this.text = o, this.elm = r, this.ns = void 0, this.context = s, this.fnContext = void 0, this.fnOptions = void 0, this.fnScopeId = void 0, this.key = e && e.key, this.componentOptions = i, this.componentInstance = void 0, this.parent = void 0, this.raw = !1, this.isStatic = !1, this.isRootInsert = !0, this.isComment = !1, this.isCloned = !1, this.isOnce = !1, this.asyncFactory = c, this.asyncMeta = void 0, this.isAsyncPlaceholder = !1;
    }
    (0, $80pZ5._)(ut, [
        {
            key: "child",
            get: function get() {
                return this.componentInstance;
            }
        }
    ]);
    return ut;
}();
var $905dbd31c454eff7$var$ft = function() {
    var t1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var e = new $905dbd31c454eff7$var$ut;
    return e.text = t1, e.isComment = !0, e;
};
function $905dbd31c454eff7$var$dt(t1) {
    return new $905dbd31c454eff7$var$ut(void 0, void 0, void 0, String(t1));
}
function $905dbd31c454eff7$var$pt(t1) {
    var e = new $905dbd31c454eff7$var$ut(t1.tag, t1.data, t1.children && t1.children.slice(), t1.text, t1.elm, t1.context, t1.componentOptions, t1.asyncFactory);
    return e.ns = t1.ns, e.isStatic = t1.isStatic, e.key = t1.key, e.isComment = t1.isComment, e.fnContext = t1.fnContext, e.fnOptions = t1.fnOptions, e.fnScopeId = t1.fnScopeId, e.asyncMeta = t1.asyncMeta, e.isCloned = !0, e;
}
var $905dbd31c454eff7$var$ht = 0;
var $905dbd31c454eff7$var$mt = [], $905dbd31c454eff7$var$gt = function() {
    for(var t1 = 0; t1 < $905dbd31c454eff7$var$mt.length; t1++){
        var e = $905dbd31c454eff7$var$mt[t1];
        e.subs = e.subs.filter(function(t1) {
            return t1;
        }), e._pending = !1;
    }
    $905dbd31c454eff7$var$mt.length = 0;
};
var $905dbd31c454eff7$var$vt = /*#__PURE__*/ function() {
    function vt() {
        (0, $2yCSJ._)(this, vt);
        this._pending = !1, this.id = $905dbd31c454eff7$var$ht++, this.subs = [];
    }
    (0, $80pZ5._)(vt, [
        {
            key: "addSub",
            value: function addSub(t1) {
                this.subs.push(t1);
            }
        },
        {
            key: "removeSub",
            value: function removeSub(t1) {
                this.subs[this.subs.indexOf(t1)] = null, this._pending || (this._pending = !0, $905dbd31c454eff7$var$mt.push(this));
            }
        },
        {
            key: "depend",
            value: function depend(t1) {
                vt.target && vt.target.addDep(this);
            }
        },
        {
            key: "notify",
            value: function notify(t1) {
                var e = this.subs.filter(function(t1) {
                    return t1;
                });
                for(var t2 = 0, n1 = e.length; t2 < n1; t2++)e[t2].update();
            }
        }
    ]);
    return vt;
}();
$905dbd31c454eff7$var$vt.target = null;
var $905dbd31c454eff7$var$yt = [];
function $905dbd31c454eff7$var$_t(t1) {
    $905dbd31c454eff7$var$yt.push(t1), $905dbd31c454eff7$var$vt.target = t1;
}
function $905dbd31c454eff7$var$$t() {
    $905dbd31c454eff7$var$yt.pop(), $905dbd31c454eff7$var$vt.target = $905dbd31c454eff7$var$yt[$905dbd31c454eff7$var$yt.length - 1];
}
var $905dbd31c454eff7$var$bt = Array.prototype, $905dbd31c454eff7$var$wt = Object.create($905dbd31c454eff7$var$bt);
[
    "push",
    "pop",
    "shift",
    "unshift",
    "splice",
    "sort",
    "reverse"
].forEach(function(t1) {
    var e = $905dbd31c454eff7$var$bt[t1];
    $905dbd31c454eff7$var$V($905dbd31c454eff7$var$wt, t1, function() {
        for(var _len = arguments.length, n1 = new Array(_len), _key = 0; _key < _len; _key++){
            n1[_key] = arguments[_key];
        }
        var o = e.apply(this, n1), r = this.__ob__;
        var s;
        switch(t1){
            case "push":
            case "unshift":
                s = n1;
                break;
            case "splice":
                s = n1.slice(2);
        }
        return s && r.observeArray(s), r.dep.notify(), o;
    });
});
var $905dbd31c454eff7$var$xt = Object.getOwnPropertyNames($905dbd31c454eff7$var$wt), $905dbd31c454eff7$var$Ct = {};
var $905dbd31c454eff7$var$kt = !0;
function $905dbd31c454eff7$var$St(t1) {
    $905dbd31c454eff7$var$kt = t1;
}
var $905dbd31c454eff7$var$Ot = {
    notify: $905dbd31c454eff7$var$E,
    depend: $905dbd31c454eff7$var$E,
    addSub: $905dbd31c454eff7$var$E,
    removeSub: $905dbd31c454eff7$var$E
};
var $905dbd31c454eff7$var$Tt = /*#__PURE__*/ function() {
    function Tt(t1) {
        var n1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        (0, $2yCSJ._)(this, Tt);
        if (this.value = t1, this.shallow = n1, this.mock = o, this.dep = o ? $905dbd31c454eff7$var$Ot : new $905dbd31c454eff7$var$vt, this.vmCount = 0, $905dbd31c454eff7$var$V(t1, "__ob__", this), $905dbd31c454eff7$var$e(t1)) {
            if (!o) {
                if ($905dbd31c454eff7$var$J) t1.__proto__ = $905dbd31c454eff7$var$wt;
                else for(var e1 = 0, n2 = $905dbd31c454eff7$var$xt.length; e1 < n2; e1++){
                    var n3 = $905dbd31c454eff7$var$xt[e1];
                    $905dbd31c454eff7$var$V(t1, n3, $905dbd31c454eff7$var$wt[n3]);
                }
            }
            n1 || this.observeArray(t1);
        } else {
            var e2 = Object.keys(t1);
            for(var r = 0; r < e2.length; r++)$905dbd31c454eff7$var$jt(t1, e2[r], $905dbd31c454eff7$var$Ct, void 0, n1, o);
        }
    }
    (0, $80pZ5._)(Tt, [
        {
            key: "observeArray",
            value: function observeArray(t1) {
                for(var e = 0, n1 = t1.length; e < n1; e++)$905dbd31c454eff7$var$At(t1[e], !1, this.mock);
            }
        }
    ]);
    return Tt;
}();
function $905dbd31c454eff7$var$At(t1, n1, o) {
    return t1 && $905dbd31c454eff7$var$$(t1, "__ob__") && t1.__ob__ instanceof $905dbd31c454eff7$var$Tt ? t1.__ob__ : !$905dbd31c454eff7$var$kt || !o && $905dbd31c454eff7$var$ot() || !$905dbd31c454eff7$var$e(t1) && !$905dbd31c454eff7$var$l(t1) || !Object.isExtensible(t1) || t1.__v_skip || $905dbd31c454eff7$var$Ht(t1) || t1 instanceof $905dbd31c454eff7$var$ut ? void 0 : new $905dbd31c454eff7$var$Tt(t1, n1, o);
}
function $905dbd31c454eff7$var$jt(t1, n1, o, r, s, i) {
    var c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1;
    var a = new $905dbd31c454eff7$var$vt, l = Object.getOwnPropertyDescriptor(t1, n1);
    if (l && !1 === l.configurable) return;
    var u = l && l.get, f = l && l.set;
    u && !f || o !== $905dbd31c454eff7$var$Ct && 2 !== arguments.length || (o = t1[n1]);
    var d = s ? o && o.__ob__ : $905dbd31c454eff7$var$At(o, !1, i);
    return Object.defineProperty(t1, n1, {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            var _$n = u ? u.call(t1) : o;
            return $905dbd31c454eff7$var$vt.target && (a.depend(), d && (d.dep.depend(), $905dbd31c454eff7$var$e(_$n) && $905dbd31c454eff7$var$Pt(_$n))), $905dbd31c454eff7$var$Ht(_$n) && !s ? _$n.value : _$n;
        },
        set: function set(e) {
            var _$n = u ? u.call(t1) : o;
            if ($905dbd31c454eff7$var$L(_$n, e)) {
                if (f) f.call(t1, e);
                else {
                    if (u) return;
                    if (!s && $905dbd31c454eff7$var$Ht(_$n) && !$905dbd31c454eff7$var$Ht(e)) return void (_$n.value = e);
                    o = e;
                }
                d = s ? e && e.__ob__ : $905dbd31c454eff7$var$At(e, !1, i), a.notify();
            }
        }
    }), a;
}
function $905dbd31c454eff7$var$Et(t1, n1, o) {
    if ($905dbd31c454eff7$var$Rt(t1)) return;
    var r = t1.__ob__;
    return $905dbd31c454eff7$var$e(t1) && $905dbd31c454eff7$var$u(n1) ? (t1.length = Math.max(t1.length, n1), t1.splice(n1, 1, o), r && !r.shallow && r.mock && $905dbd31c454eff7$var$At(o, !1, !0), o) : n1 in t1 && !(n1 in Object.prototype) ? (t1[n1] = o, o) : t1._isVue || r && r.vmCount ? o : r ? ($905dbd31c454eff7$var$jt(r.value, n1, o, void 0, r.shallow, r.mock), r.dep.notify(), o) : (t1[n1] = o, o);
}
function $905dbd31c454eff7$var$Nt(t1, n1) {
    if ($905dbd31c454eff7$var$e(t1) && $905dbd31c454eff7$var$u(n1)) return void t1.splice(n1, 1);
    var o = t1.__ob__;
    t1._isVue || o && o.vmCount || $905dbd31c454eff7$var$Rt(t1) || $905dbd31c454eff7$var$$(t1, n1) && (delete t1[n1], o && o.dep.notify());
}
function $905dbd31c454eff7$var$Pt(t1) {
    for(var n1, o = 0, r = t1.length; o < r; o++)n1 = t1[o], n1 && n1.__ob__ && n1.__ob__.dep.depend(), $905dbd31c454eff7$var$e(n1) && $905dbd31c454eff7$var$Pt(n1);
}
function $905dbd31c454eff7$var$Dt(t1) {
    return $905dbd31c454eff7$var$Mt(t1, !0), $905dbd31c454eff7$var$V(t1, "__v_isShallow", !0), t1;
}
function $905dbd31c454eff7$var$Mt(t1, e) {
    $905dbd31c454eff7$var$Rt(t1) || $905dbd31c454eff7$var$At(t1, e, $905dbd31c454eff7$var$ot());
}
function $905dbd31c454eff7$var$It(t1) {
    return $905dbd31c454eff7$var$Rt(t1) ? $905dbd31c454eff7$var$It(t1.__v_raw) : !(!t1 || !t1.__ob__);
}
function $905dbd31c454eff7$var$Lt(t1) {
    return !(!t1 || !t1.__v_isShallow);
}
function $905dbd31c454eff7$var$Rt(t1) {
    return !(!t1 || !t1.__v_isReadonly);
}
var $905dbd31c454eff7$var$Ft = "__v_isRef";
function $905dbd31c454eff7$var$Ht(t1) {
    return !(!t1 || !0 !== t1.__v_isRef);
}
function $905dbd31c454eff7$var$Bt(t1, e) {
    if ($905dbd31c454eff7$var$Ht(t1)) return t1;
    var n1 = {};
    return $905dbd31c454eff7$var$V(n1, $905dbd31c454eff7$var$Ft, !0), $905dbd31c454eff7$var$V(n1, "__v_isShallow", e), $905dbd31c454eff7$var$V(n1, "dep", $905dbd31c454eff7$var$jt(n1, "value", t1, null, e, $905dbd31c454eff7$var$ot())), n1;
}
function $905dbd31c454eff7$var$Ut(t1, e, n1) {
    Object.defineProperty(t1, n1, {
        enumerable: !0,
        configurable: !0,
        get: function() {
            var _$t = e[n1];
            if ($905dbd31c454eff7$var$Ht(_$t)) return _$t.value;
            {
                var _$e = _$t && _$t.__ob__;
                return _$e && _$e.dep.depend(), _$t;
            }
        },
        set: function(t1) {
            var o = e[n1];
            $905dbd31c454eff7$var$Ht(o) && !$905dbd31c454eff7$var$Ht(t1) ? o.value = t1 : e[n1] = t1;
        }
    });
}
function $905dbd31c454eff7$var$zt(t1, e, n1) {
    var o = t1[e];
    if ($905dbd31c454eff7$var$Ht(o)) return o;
    var r = {
        get value () {
            var o1 = t1[e];
            return void 0 === o1 ? n1 : o1;
        },
        set value (n){
            t1[e] = n;
        }
    };
    return $905dbd31c454eff7$var$V(r, $905dbd31c454eff7$var$Ft, !0), r;
}
var $905dbd31c454eff7$var$Vt = "__v_rawToReadonly", $905dbd31c454eff7$var$Kt = "__v_rawToShallowReadonly";
function $905dbd31c454eff7$var$Jt(t1) {
    return $905dbd31c454eff7$var$qt(t1, !1);
}
function $905dbd31c454eff7$var$qt(t1, e) {
    if (!$905dbd31c454eff7$var$l(t1)) return t1;
    if ($905dbd31c454eff7$var$Rt(t1)) return t1;
    var n1 = e ? $905dbd31c454eff7$var$Kt : $905dbd31c454eff7$var$Vt, o = t1[n1];
    if (o) return o;
    var r = Object.create(Object.getPrototypeOf(t1));
    $905dbd31c454eff7$var$V(t1, n1, r), $905dbd31c454eff7$var$V(r, "__v_isReadonly", !0), $905dbd31c454eff7$var$V(r, "__v_raw", t1), $905dbd31c454eff7$var$Ht(t1) && $905dbd31c454eff7$var$V(r, $905dbd31c454eff7$var$Ft, !0), (e || $905dbd31c454eff7$var$Lt(t1)) && $905dbd31c454eff7$var$V(r, "__v_isShallow", !0);
    var s = Object.keys(t1);
    for(var n2 = 0; n2 < s.length; n2++)$905dbd31c454eff7$var$Wt(r, t1, s[n2], e);
    return r;
}
function $905dbd31c454eff7$var$Wt(t1, e, n1, o) {
    Object.defineProperty(t1, n1, {
        enumerable: !0,
        configurable: !0,
        get: function() {
            var _$t = e[n1];
            return o || !$905dbd31c454eff7$var$l(_$t) ? _$t : $905dbd31c454eff7$var$Jt(_$t);
        },
        set: function() {}
    });
}
var $905dbd31c454eff7$var$Zt = $905dbd31c454eff7$var$b(function(t1) {
    var e = "&" === t1.charAt(0), n1 = "~" === (t1 = e ? t1.slice(1) : t1).charAt(0), o = "!" === (t1 = n1 ? t1.slice(1) : t1).charAt(0);
    return {
        name: t1 = o ? t1.slice(1) : t1,
        once: n1,
        capture: o,
        passive: e
    };
});
function $905dbd31c454eff7$var$Gt(t1, n1) {
    function o() {
        var _$t = o.fns;
        if (!$905dbd31c454eff7$var$e(_$t)) return $905dbd31c454eff7$var$vn(_$t, null, arguments, n1, "v-on handler");
        {
            var e1 = _$t.slice();
            for(var _$t1 = 0; _$t1 < e1.length; _$t1++)$905dbd31c454eff7$var$vn(e1[_$t1], null, arguments, n1, "v-on handler");
        }
    }
    return o.fns = t1, o;
}
function $905dbd31c454eff7$var$Xt(t1, e, o, s, i, c) {
    var a, l, u, f;
    for(a in t1)l = t1[a], u = e[a], f = $905dbd31c454eff7$var$Zt(a), $905dbd31c454eff7$var$n1(l) || ($905dbd31c454eff7$var$n1(u) ? ($905dbd31c454eff7$var$n1(l.fns) && (l = t1[a] = $905dbd31c454eff7$var$Gt(l, c)), $905dbd31c454eff7$var$r(f.once) && (l = t1[a] = i(f.name, l, f.capture)), o(f.name, l, f.capture, f.passive, f.params)) : l !== u && (u.fns = l, t1[a] = u));
    for(a in e)$905dbd31c454eff7$var$n1(t1[a]) && (f = $905dbd31c454eff7$var$Zt(a), s(f.name, e[a], f.capture));
}
function $905dbd31c454eff7$var$Yt(t1, e, s) {
    var i;
    t1 instanceof $905dbd31c454eff7$var$ut && (t1 = t1.data.hook || (t1.data.hook = {}));
    var c = t1[e];
    function a() {
        s.apply(this, arguments), $905dbd31c454eff7$var$y(i.fns, a);
    }
    $905dbd31c454eff7$var$n1(c) ? i = $905dbd31c454eff7$var$Gt([
        a
    ]) : $905dbd31c454eff7$var$o(c.fns) && $905dbd31c454eff7$var$r(c.merged) ? (i = c, i.fns.push(a)) : i = $905dbd31c454eff7$var$Gt([
        c,
        a
    ]), i.merged = !0, t1[e] = i;
}
function $905dbd31c454eff7$var$Qt(t1, e, n1, r, s) {
    if ($905dbd31c454eff7$var$o(e)) {
        if ($905dbd31c454eff7$var$$(e, n1)) return t1[n1] = e[n1], s || delete e[n1], !0;
        if ($905dbd31c454eff7$var$$(e, r)) return t1[n1] = e[r], s || delete e[r], !0;
    }
    return !1;
}
function $905dbd31c454eff7$var$te(t1) {
    return $905dbd31c454eff7$var$s(t1) ? [
        $905dbd31c454eff7$var$dt(t1)
    ] : $905dbd31c454eff7$var$e(t1) ? $905dbd31c454eff7$var$ne(t1) : void 0;
}
function $905dbd31c454eff7$var$ee(t1) {
    return $905dbd31c454eff7$var$o(t1) && $905dbd31c454eff7$var$o(t1.text) && !1 === t1.isComment;
}
function $905dbd31c454eff7$var$ne(t1, i) {
    var c = [];
    var a, l, u, f;
    for(a = 0; a < t1.length; a++)l = t1[a], $905dbd31c454eff7$var$n1(l) || "boolean" == typeof l || (u = c.length - 1, f = c[u], $905dbd31c454eff7$var$e(l) ? l.length > 0 && (l = $905dbd31c454eff7$var$ne(l, "".concat(i || "", "_").concat(a)), $905dbd31c454eff7$var$ee(l[0]) && $905dbd31c454eff7$var$ee(f) && (c[u] = $905dbd31c454eff7$var$dt(f.text + l[0].text), l.shift()), c.push.apply(c, l)) : $905dbd31c454eff7$var$s(l) ? $905dbd31c454eff7$var$ee(f) ? c[u] = $905dbd31c454eff7$var$dt(f.text + l) : "" !== l && c.push($905dbd31c454eff7$var$dt(l)) : $905dbd31c454eff7$var$ee(l) && $905dbd31c454eff7$var$ee(f) ? c[u] = $905dbd31c454eff7$var$dt(f.text + l.text) : ($905dbd31c454eff7$var$r(t1._isVList) && $905dbd31c454eff7$var$o(l.tag) && $905dbd31c454eff7$var$n1(l.key) && $905dbd31c454eff7$var$o(i) && (l.key = "__vlist".concat(i, "_").concat(a, "__")), c.push(l)));
    return c;
}
var $905dbd31c454eff7$var$oe = 1, $905dbd31c454eff7$var$re = 2;
function $905dbd31c454eff7$var$se(t1, n1, a, l, u, f) {
    return ($905dbd31c454eff7$var$e(a) || $905dbd31c454eff7$var$s(a)) && (u = l, l = a, a = void 0), $905dbd31c454eff7$var$r(f) && (u = $905dbd31c454eff7$var$re), function(t1, n1, r, s, a) {
        if ($905dbd31c454eff7$var$o(r) && $905dbd31c454eff7$var$o(r.__ob__)) return $905dbd31c454eff7$var$ft();
        $905dbd31c454eff7$var$o(r) && $905dbd31c454eff7$var$o(r.is) && (n1 = r.is);
        if (!n1) return $905dbd31c454eff7$var$ft();
        $905dbd31c454eff7$var$e(s) && $905dbd31c454eff7$var$i(s[0]) && ((r = r || {}).scopedSlots = {
            default: s[0]
        }, s.length = 0);
        a === $905dbd31c454eff7$var$re ? s = $905dbd31c454eff7$var$te(s) : a === $905dbd31c454eff7$var$oe && (s = function(t1) {
            for(var _$n = 0; _$n < t1.length; _$n++)if ($905dbd31c454eff7$var$e(t1[_$n])) return Array.prototype.concat.apply([], t1);
            return t1;
        }(s));
        var _$l, _$u;
        if ("string" == typeof n1) {
            var e1;
            _$u = t1.$vnode && t1.$vnode.ns || $905dbd31c454eff7$var$B.getTagNamespace(n1), _$l = $905dbd31c454eff7$var$B.isReservedTag(n1) ? new $905dbd31c454eff7$var$ut($905dbd31c454eff7$var$B.parsePlatformTagName(n1), r, s, void 0, void 0, t1) : r && r.pre || !$905dbd31c454eff7$var$o(e1 = $905dbd31c454eff7$var$$o(t1.$options, "components", n1)) ? new $905dbd31c454eff7$var$ut(n1, r, s, void 0, void 0, t1) : $905dbd31c454eff7$var$lo(e1, r, t1, s, n1);
        } else _$l = $905dbd31c454eff7$var$lo(n1, r, t1, s);
        return $905dbd31c454eff7$var$e(_$l) ? _$l : $905dbd31c454eff7$var$o(_$l) ? ($905dbd31c454eff7$var$o(_$u) && $905dbd31c454eff7$var$ie(_$l, _$u), $905dbd31c454eff7$var$o(r) && function(t1) {
            $905dbd31c454eff7$var$c(t1.style) && $905dbd31c454eff7$var$Un(t1.style);
            $905dbd31c454eff7$var$c(t1.class) && $905dbd31c454eff7$var$Un(t1.class);
        }(r), _$l) : $905dbd31c454eff7$var$ft();
    }(t1, n1, a, l, u);
}
function $905dbd31c454eff7$var$ie(t1, e, s) {
    if (t1.ns = e, "foreignObject" === t1.tag && (e = void 0, s = !0), $905dbd31c454eff7$var$o(t1.children)) for(var i = 0, c = t1.children.length; i < c; i++){
        var c1 = t1.children[i];
        $905dbd31c454eff7$var$o(c1.tag) && ($905dbd31c454eff7$var$n1(c1.ns) || $905dbd31c454eff7$var$r(s) && "svg" !== c1.tag) && $905dbd31c454eff7$var$ie(c1, e, s);
    }
}
function $905dbd31c454eff7$var$ce(t1, n1) {
    var r, s, i, a, l = null;
    if ($905dbd31c454eff7$var$e(t1) || "string" == typeof t1) for(l = new Array(t1.length), r = 0, s = t1.length; r < s; r++)l[r] = n1(t1[r], r);
    else if ("number" == typeof t1) for(l = new Array(t1), r = 0; r < t1; r++)l[r] = n1(r + 1, r);
    else if ($905dbd31c454eff7$var$c(t1)) {
        if ($905dbd31c454eff7$var$it && t1[Symbol.iterator]) {
            l = [];
            var e1 = t1[Symbol.iterator]();
            var _$o = e1.next();
            for(; !_$o.done;)l.push(n1(_$o.value, l.length)), _$o = e1.next();
        } else for(i = Object.keys(t1), l = new Array(i.length), r = 0, s = i.length; r < s; r++)a = i[r], l[r] = n1(t1[a], a, r);
    }
    return $905dbd31c454eff7$var$o(l) || (l = []), l._isVList = !0, l;
}
function $905dbd31c454eff7$var$ae(t1, e, n1, o) {
    var r = this.$scopedSlots[t1];
    var s;
    r ? (n1 = n1 || {}, o && (n1 = $905dbd31c454eff7$var$A($905dbd31c454eff7$var$A({}, o), n1)), s = r(n1) || ($905dbd31c454eff7$var$i(e) ? e() : e)) : s = this.$slots[t1] || ($905dbd31c454eff7$var$i(e) ? e() : e);
    var c = n1 && n1.slot;
    return c ? this.$createElement("template", {
        slot: c
    }, s) : s;
}
function $905dbd31c454eff7$var$le(t1) {
    return $905dbd31c454eff7$var$$o(this.$options, "filters", t1) || $905dbd31c454eff7$var$P;
}
function $905dbd31c454eff7$var$ue(t1, n1) {
    return $905dbd31c454eff7$var$e(t1) ? -1 === t1.indexOf(n1) : t1 !== n1;
}
function $905dbd31c454eff7$var$fe(t1, e, n1, o, r) {
    var s = $905dbd31c454eff7$var$B.keyCodes[e] || n1;
    return r && o && !$905dbd31c454eff7$var$B.keyCodes[e] ? $905dbd31c454eff7$var$ue(r, o) : s ? $905dbd31c454eff7$var$ue(s, t1) : o ? $905dbd31c454eff7$var$S(o) !== e : void 0 === t1;
}
function $905dbd31c454eff7$var$de(t1, n1, o, r, s) {
    if (o) {
        if ($905dbd31c454eff7$var$c(o)) {
            var _loop = function(e1) {
                if ("class" === e1 || "style" === e1 || $905dbd31c454eff7$var$v(e1)) i = t1;
                else {
                    var _$o = t1.attrs && t1.attrs.type;
                    i = r || $905dbd31c454eff7$var$B.mustUseProp(n1, _$o, e1) ? t1.domProps || (t1.domProps = {}) : t1.attrs || (t1.attrs = {});
                }
                var _$c = $905dbd31c454eff7$var$x(e1), a = $905dbd31c454eff7$var$S(e1);
                if (!(_$c in i) && !(a in i) && (i[e1] = o[e1], s)) (t1.on || (t1.on = {}))["update:".concat(e1)] = function(t1) {
                    o[e1] = t1;
                };
            };
            var i;
            $905dbd31c454eff7$var$e(o) && (o = $905dbd31c454eff7$var$j(o));
            for(var e1 in o)_loop(e1);
        }
    }
    return t1;
}
function $905dbd31c454eff7$var$pe(t1, e) {
    var n1 = this._staticTrees || (this._staticTrees = []);
    var o = n1[t1];
    return o && !e || (o = n1[t1] = this.$options.staticRenderFns[t1].call(this._renderProxy, this._c, this), $905dbd31c454eff7$var$me(o, "__static__".concat(t1), !1)), o;
}
function $905dbd31c454eff7$var$he(t1, e, n1) {
    return $905dbd31c454eff7$var$me(t1, "__once__".concat(e).concat(n1 ? "_".concat(n1) : ""), !0), t1;
}
function $905dbd31c454eff7$var$me(t1, n1, o) {
    if ($905dbd31c454eff7$var$e(t1)) for(var e1 = 0; e1 < t1.length; e1++)t1[e1] && "string" != typeof t1[e1] && $905dbd31c454eff7$var$ge(t1[e1], "".concat(n1, "_").concat(e1), o);
    else $905dbd31c454eff7$var$ge(t1, n1, o);
}
function $905dbd31c454eff7$var$ge(t1, e, n1) {
    t1.isStatic = !0, t1.key = e, t1.isOnce = n1;
}
function $905dbd31c454eff7$var$ve(t1, e) {
    if (e) {
        if ($905dbd31c454eff7$var$l(e)) {
            var n1 = t1.on = t1.on ? $905dbd31c454eff7$var$A({}, t1.on) : {};
            for(var _$t in e){
                var o = n1[_$t], r = e[_$t];
                n1[_$t] = o ? [].concat(o, r) : r;
            }
        }
    }
    return t1;
}
function $905dbd31c454eff7$var$ye(t1, n1, o, r) {
    n1 = n1 || {
        $stable: !o
    };
    for(var _$r = 0; _$r < t1.length; _$r++){
        var s = t1[_$r];
        $905dbd31c454eff7$var$e(s) ? $905dbd31c454eff7$var$ye(s, n1, o) : s && (s.proxy && (s.fn.proxy = !0), n1[s.key] = s.fn);
    }
    return r && (n1.$key = r), n1;
}
function $905dbd31c454eff7$var$_e(t1, e) {
    for(var n1 = 0; n1 < e.length; n1 += 2){
        var o = e[n1];
        "string" == typeof o && o && (t1[e[n1]] = e[n1 + 1]);
    }
    return t1;
}
function $905dbd31c454eff7$var$$e(t1, e) {
    return "string" == typeof t1 ? e + t1 : t1;
}
function $905dbd31c454eff7$var$be(t1) {
    t1._o = $905dbd31c454eff7$var$he, t1._n = $905dbd31c454eff7$var$h, t1._s = $905dbd31c454eff7$var$d, t1._l = $905dbd31c454eff7$var$ce, t1._t = $905dbd31c454eff7$var$ae, t1._q = $905dbd31c454eff7$var$D, t1._i = $905dbd31c454eff7$var$M, t1._m = $905dbd31c454eff7$var$pe, t1._f = $905dbd31c454eff7$var$le, t1._k = $905dbd31c454eff7$var$fe, t1._b = $905dbd31c454eff7$var$de, t1._v = $905dbd31c454eff7$var$dt, t1._e = $905dbd31c454eff7$var$ft, t1._u = $905dbd31c454eff7$var$ye, t1._g = $905dbd31c454eff7$var$ve, t1._d = $905dbd31c454eff7$var$_e, t1._p = $905dbd31c454eff7$var$$e;
}
function $905dbd31c454eff7$var$we(t1, e) {
    if (!t1 || !t1.length) return {};
    var n1 = {};
    for(var o = 0, r = t1.length; o < r; o++){
        var r1 = t1[o], s = r1.data;
        if (s && s.attrs && s.attrs.slot && delete s.attrs.slot, r1.context !== e && r1.fnContext !== e || !s || null == s.slot) (n1.default || (n1.default = [])).push(r1);
        else {
            var _$t = s.slot, _$e = n1[_$t] || (n1[_$t] = []);
            "template" === r1.tag ? _$e.push.apply(_$e, r1.children || []) : _$e.push(r1);
        }
    }
    for(var _$t1 in n1)n1[_$t1].every($905dbd31c454eff7$var$xe) && delete n1[_$t1];
    return n1;
}
function $905dbd31c454eff7$var$xe(t1) {
    return t1.isComment && !t1.asyncFactory || " " === t1.text;
}
function $905dbd31c454eff7$var$Ce(t1) {
    return t1.isComment && t1.asyncFactory;
}
function $905dbd31c454eff7$var$ke(e, n1, o, r) {
    var s;
    var i = Object.keys(o).length > 0, c = n1 ? !!n1.$stable : !i, a = n1 && n1.$key;
    if (n1) {
        if (n1._normalized) return n1._normalized;
        if (c && r && r !== $905dbd31c454eff7$var$t1 && a === r.$key && !i && !r.$hasNormal) return r;
        s = {};
        for(var t2 in n1)n1[t2] && "$" !== t2[0] && (s[t2] = $905dbd31c454eff7$var$Se(e, o, t2, n1[t2]));
    } else s = {};
    for(var t3 in o)t3 in s || (s[t3] = $905dbd31c454eff7$var$Oe(o, t3));
    return n1 && Object.isExtensible(n1) && (n1._normalized = s), $905dbd31c454eff7$var$V(s, "$stable", c), $905dbd31c454eff7$var$V(s, "$key", a), $905dbd31c454eff7$var$V(s, "$hasNormal", i), s;
}
function $905dbd31c454eff7$var$Se(t1, n1, o, r) {
    var s = function s() {
        var _$n = $905dbd31c454eff7$var$at;
        $905dbd31c454eff7$var$lt(t1);
        var _$o = arguments.length ? r.apply(null, arguments) : r({});
        _$o = _$o && "object" == typeof _$o && !$905dbd31c454eff7$var$e(_$o) ? [
            _$o
        ] : $905dbd31c454eff7$var$te(_$o);
        var s = _$o && _$o[0];
        return $905dbd31c454eff7$var$lt(_$n), _$o && (!s || 1 === _$o.length && s.isComment && !$905dbd31c454eff7$var$Ce(s)) ? void 0 : _$o;
    };
    return r.proxy && Object.defineProperty(n1, o, {
        get: s,
        enumerable: !0,
        configurable: !0
    }), s;
}
function $905dbd31c454eff7$var$Oe(t1, e) {
    return function() {
        return t1[e];
    };
}
function $905dbd31c454eff7$var$Te(e) {
    return {
        get attrs () {
            if (!e._attrsProxy) {
                var n1 = e._attrsProxy = {};
                $905dbd31c454eff7$var$V(n1, "_v_attr_proxy", !0), $905dbd31c454eff7$var$Ae(n1, e.$attrs, $905dbd31c454eff7$var$t1, e, "$attrs");
            }
            return e._attrsProxy;
        },
        get listeners () {
            if (!e._listenersProxy) $905dbd31c454eff7$var$Ae(e._listenersProxy = {}, e.$listeners, $905dbd31c454eff7$var$t1, e, "$listeners");
            return e._listenersProxy;
        },
        get slots () {
            return function(t1) {
                t1._slotsProxy || $905dbd31c454eff7$var$Ee(t1._slotsProxy = {}, t1.$scopedSlots);
                return t1._slotsProxy;
            }(e);
        },
        emit: $905dbd31c454eff7$var$O(e.$emit, e),
        expose: function(t1) {
            t1 && Object.keys(t1).forEach(function(n1) {
                return $905dbd31c454eff7$var$Ut(e, t1, n1);
            });
        }
    };
}
function $905dbd31c454eff7$var$Ae(t1, e, n1, o, r) {
    var s = !1;
    for(var i in e)i in t1 ? e[i] !== n1[i] && (s = !0) : (s = !0, $905dbd31c454eff7$var$je(t1, i, o, r));
    for(var _$n in t1)_$n in e || (s = !0, delete t1[_$n]);
    return s;
}
function $905dbd31c454eff7$var$je(t1, e, n1, o) {
    Object.defineProperty(t1, e, {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n1[o][e];
        }
    });
}
function $905dbd31c454eff7$var$Ee(t1, e) {
    for(var n1 in e)t1[n1] = e[n1];
    for(var n2 in t1)n2 in e || delete t1[n2];
}
function $905dbd31c454eff7$var$Ne() {
    var t1 = $905dbd31c454eff7$var$at;
    return t1._setupContext || (t1._setupContext = $905dbd31c454eff7$var$Te(t1));
}
var $905dbd31c454eff7$var$Pe, $905dbd31c454eff7$var$De, $905dbd31c454eff7$var$Me = null;
function $905dbd31c454eff7$var$Ie(t1, e) {
    return (t1.__esModule || $905dbd31c454eff7$var$it && "Module" === t1[Symbol.toStringTag]) && (t1 = t1.default), $905dbd31c454eff7$var$c(t1) ? e.extend(t1) : t1;
}
function $905dbd31c454eff7$var$Le(t1) {
    if ($905dbd31c454eff7$var$e(t1)) for(var e1 = 0; e1 < t1.length; e1++){
        var n1 = t1[e1];
        if ($905dbd31c454eff7$var$o(n1) && ($905dbd31c454eff7$var$o(n1.componentOptions) || $905dbd31c454eff7$var$Ce(n1))) return n1;
    }
}
function $905dbd31c454eff7$var$Re(t1, e) {
    $905dbd31c454eff7$var$Pe.$on(t1, e);
}
function $905dbd31c454eff7$var$Fe(t1, e) {
    $905dbd31c454eff7$var$Pe.$off(t1, e);
}
function $905dbd31c454eff7$var$He(t1, e) {
    var n1 = $905dbd31c454eff7$var$Pe;
    return function o() {
        null !== e.apply(null, arguments) && n1.$off(t1, o);
    };
}
function $905dbd31c454eff7$var$Be(t1, e, n1) {
    $905dbd31c454eff7$var$Pe = t1, $905dbd31c454eff7$var$Xt(e, n1 || {}, $905dbd31c454eff7$var$Re, $905dbd31c454eff7$var$Fe, $905dbd31c454eff7$var$He, t1), $905dbd31c454eff7$var$Pe = void 0;
}
var $905dbd31c454eff7$var$Ue = /*#__PURE__*/ function() {
    function Ue() {
        var t1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        (0, $2yCSJ._)(this, Ue);
        this.detached = t1, this.active = !0, this.effects = [], this.cleanups = [], this.parent = $905dbd31c454eff7$var$De, !t1 && $905dbd31c454eff7$var$De && (this.index = ($905dbd31c454eff7$var$De.scopes || ($905dbd31c454eff7$var$De.scopes = [])).push(this) - 1);
    }
    (0, $80pZ5._)(Ue, [
        {
            key: "run",
            value: function run(t1) {
                if (this.active) {
                    var e = $905dbd31c454eff7$var$De;
                    try {
                        return $905dbd31c454eff7$var$De = this, t1();
                    } finally{
                        $905dbd31c454eff7$var$De = e;
                    }
                }
            }
        },
        {
            key: "on",
            value: function on() {
                $905dbd31c454eff7$var$De = this;
            }
        },
        {
            key: "off",
            value: function off() {
                $905dbd31c454eff7$var$De = this.parent;
            }
        },
        {
            key: "stop",
            value: function stop(t1) {
                if (this.active) {
                    var e, n1;
                    for(e = 0, n1 = this.effects.length; e < n1; e++)this.effects[e].teardown();
                    for(e = 0, n1 = this.cleanups.length; e < n1; e++)this.cleanups[e]();
                    if (this.scopes) for(e = 0, n1 = this.scopes.length; e < n1; e++)this.scopes[e].stop(!0);
                    if (!this.detached && this.parent && !t1) {
                        var _$t = this.parent.scopes.pop();
                        _$t && _$t !== this && (this.parent.scopes[this.index] = _$t, _$t.index = this.index);
                    }
                    this.parent = void 0, this.active = !1;
                }
            }
        }
    ]);
    return Ue;
}();
function $905dbd31c454eff7$var$ze() {
    return $905dbd31c454eff7$var$De;
}
var $905dbd31c454eff7$var$Ve = null;
function $905dbd31c454eff7$var$Ke(t1) {
    var e = $905dbd31c454eff7$var$Ve;
    return $905dbd31c454eff7$var$Ve = t1, function() {
        $905dbd31c454eff7$var$Ve = e;
    };
}
function $905dbd31c454eff7$var$Je(t1) {
    for(; t1 && (t1 = t1.$parent);)if (t1._inactive) return !0;
    return !1;
}
function $905dbd31c454eff7$var$qe(t1, e) {
    if (e) {
        if (t1._directInactive = !1, $905dbd31c454eff7$var$Je(t1)) return;
    } else if (t1._directInactive) return;
    if (t1._inactive || null === t1._inactive) {
        t1._inactive = !1;
        for(var _$e = 0; _$e < t1.$children.length; _$e++)$905dbd31c454eff7$var$qe(t1.$children[_$e]);
        $905dbd31c454eff7$var$Ze(t1, "activated");
    }
}
function $905dbd31c454eff7$var$We(t1, e) {
    if (!(e && (t1._directInactive = !0, $905dbd31c454eff7$var$Je(t1)) || t1._inactive)) {
        t1._inactive = !0;
        for(var _$e = 0; _$e < t1.$children.length; _$e++)$905dbd31c454eff7$var$We(t1.$children[_$e]);
        $905dbd31c454eff7$var$Ze(t1, "deactivated");
    }
}
function $905dbd31c454eff7$var$Ze(t1, e, n1) {
    var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    $905dbd31c454eff7$var$_t();
    var r = $905dbd31c454eff7$var$at, s = $905dbd31c454eff7$var$ze();
    o && $905dbd31c454eff7$var$lt(t1);
    var i = t1.$options[e], c = "".concat(e, " hook");
    if (i) for(var _$e = 0, o1 = i.length; _$e < o1; _$e++)$905dbd31c454eff7$var$vn(i[_$e], t1, n1 || null, t1, c);
    t1._hasHookEvent && t1.$emit("hook:" + e), o && ($905dbd31c454eff7$var$lt(r), s && s.on()), $905dbd31c454eff7$var$$t();
}
var $905dbd31c454eff7$var$Ge = [], $905dbd31c454eff7$var$Xe = [];
var $905dbd31c454eff7$var$Ye = {}, $905dbd31c454eff7$var$Qe = !1, $905dbd31c454eff7$var$tn = !1, $905dbd31c454eff7$var$en = 0;
var $905dbd31c454eff7$var$nn = 0, $905dbd31c454eff7$var$on = Date.now;
if ($905dbd31c454eff7$var$q && !$905dbd31c454eff7$var$Z) {
    var $905dbd31c454eff7$var$t3 = window.performance;
    $905dbd31c454eff7$var$t3 && "function" == typeof $905dbd31c454eff7$var$t3.now && $905dbd31c454eff7$var$on() > document.createEvent("Event").timeStamp && ($905dbd31c454eff7$var$on = function() {
        return $905dbd31c454eff7$var$t3.now();
    });
}
var $905dbd31c454eff7$var$rn = function(t1, e) {
    if (t1.post) {
        if (!e.post) return 1;
    } else if (e.post) return -1;
    return t1.id - e.id;
};
function $905dbd31c454eff7$var$sn() {
    var t1, e;
    for($905dbd31c454eff7$var$nn = $905dbd31c454eff7$var$on(), $905dbd31c454eff7$var$tn = !0, $905dbd31c454eff7$var$Ge.sort($905dbd31c454eff7$var$rn), $905dbd31c454eff7$var$en = 0; $905dbd31c454eff7$var$en < $905dbd31c454eff7$var$Ge.length; $905dbd31c454eff7$var$en++)t1 = $905dbd31c454eff7$var$Ge[$905dbd31c454eff7$var$en], t1.before && t1.before(), e = t1.id, $905dbd31c454eff7$var$Ye[e] = null, t1.run();
    var n1 = $905dbd31c454eff7$var$Xe.slice(), o = $905dbd31c454eff7$var$Ge.slice();
    $905dbd31c454eff7$var$en = $905dbd31c454eff7$var$Ge.length = $905dbd31c454eff7$var$Xe.length = 0, $905dbd31c454eff7$var$Ye = {}, $905dbd31c454eff7$var$Qe = $905dbd31c454eff7$var$tn = !1, function(t1) {
        for(var e = 0; e < t1.length; e++)t1[e]._inactive = !0, $905dbd31c454eff7$var$qe(t1[e], !0);
    }(n1), function(t1) {
        var e = t1.length;
        for(; e--;){
            var n1 = t1[e], o = n1.vm;
            o && o._watcher === n1 && o._isMounted && !o._isDestroyed && $905dbd31c454eff7$var$Ze(o, "updated");
        }
    }(o), $905dbd31c454eff7$var$gt(), $905dbd31c454eff7$var$rt && $905dbd31c454eff7$var$B.devtools && $905dbd31c454eff7$var$rt.emit("flush");
}
function $905dbd31c454eff7$var$cn(t1) {
    var e = t1.id;
    if (null == $905dbd31c454eff7$var$Ye[e] && (t1 !== $905dbd31c454eff7$var$vt.target || !t1.noRecurse)) {
        if ($905dbd31c454eff7$var$Ye[e] = !0, $905dbd31c454eff7$var$tn) {
            var e1 = $905dbd31c454eff7$var$Ge.length - 1;
            for(; e1 > $905dbd31c454eff7$var$en && $905dbd31c454eff7$var$Ge[e1].id > t1.id;)e1--;
            $905dbd31c454eff7$var$Ge.splice(e1 + 1, 0, t1);
        } else $905dbd31c454eff7$var$Ge.push(t1);
        $905dbd31c454eff7$var$Qe || ($905dbd31c454eff7$var$Qe = !0, $905dbd31c454eff7$var$kn($905dbd31c454eff7$var$sn));
    }
}
var $905dbd31c454eff7$var$an = "watcher", $905dbd31c454eff7$var$ln = "".concat($905dbd31c454eff7$var$an, " callback"), $905dbd31c454eff7$var$un = "".concat($905dbd31c454eff7$var$an, " getter"), $905dbd31c454eff7$var$fn = "".concat($905dbd31c454eff7$var$an, " cleanup");
function $905dbd31c454eff7$var$dn(t1, e) {
    return $905dbd31c454eff7$var$hn(t1, null, {
        flush: "post"
    });
}
var $905dbd31c454eff7$var$pn = {};
function $905dbd31c454eff7$var$hn(n1, o) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $905dbd31c454eff7$var$t1, r = _ref.immediate, s = _ref.deep, tmp = _ref.flush, c = tmp === void 0 ? "pre" : tmp, a = _ref.onTrack, l = _ref.onTrigger;
    var u = $905dbd31c454eff7$var$at, f = function(t1, e) {
        var _$n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var _$o = $905dbd31c454eff7$var$vn(t1, null, _$n, u, e);
        return s && _$o && _$o.__ob__ && _$o.__ob__.dep.depend(), _$o;
    };
    var d, p, h = !1, _$m = !1;
    if ($905dbd31c454eff7$var$Ht(n1) ? (d = function() {
        return n1.value;
    }, h = $905dbd31c454eff7$var$Lt(n1)) : $905dbd31c454eff7$var$It(n1) ? (d = function() {
        return n1.__ob__.dep.depend(), n1;
    }, s = !0) : $905dbd31c454eff7$var$e(n1) ? (_$m = !0, h = n1.some(function(t1) {
        return $905dbd31c454eff7$var$It(t1) || $905dbd31c454eff7$var$Lt(t1);
    }), d = function() {
        return n1.map(function(t1) {
            return $905dbd31c454eff7$var$Ht(t1) ? t1.value : $905dbd31c454eff7$var$It(t1) ? (t1.__ob__.dep.depend(), $905dbd31c454eff7$var$Un(t1)) : $905dbd31c454eff7$var$i(t1) ? f(t1, $905dbd31c454eff7$var$un) : void 0;
        });
    }) : d = $905dbd31c454eff7$var$i(n1) ? o ? function() {
        return f(n1, $905dbd31c454eff7$var$un);
    } : function() {
        if (!u || !u._isDestroyed) return p && p(), f(n1, $905dbd31c454eff7$var$an, [
            g
        ]);
    } : $905dbd31c454eff7$var$E, o && s) {
        var t2 = d;
        d = function() {
            return $905dbd31c454eff7$var$Un(t2());
        };
    }
    var g = function(t1) {
        p = v.onStop = function() {
            f(t1, $905dbd31c454eff7$var$fn);
        };
    };
    if ($905dbd31c454eff7$var$ot()) return g = $905dbd31c454eff7$var$E, o ? r && f(o, $905dbd31c454eff7$var$ln, [
        d(),
        _$m ? [] : void 0,
        g
    ]) : d(), $905dbd31c454eff7$var$E;
    var v = new $905dbd31c454eff7$var$Kn($905dbd31c454eff7$var$at, d, $905dbd31c454eff7$var$E, {
        lazy: !0
    });
    v.noRecurse = !o;
    var y = _$m ? [] : $905dbd31c454eff7$var$pn;
    return v.run = function() {
        if (v.active) {
            if (o) {
                var t1 = v.get();
                (s || h || (_$m ? t1.some(function(t1, e) {
                    return $905dbd31c454eff7$var$L(t1, y[e]);
                }) : $905dbd31c454eff7$var$L(t1, y))) && (p && p(), f(o, $905dbd31c454eff7$var$ln, [
                    t1,
                    y === $905dbd31c454eff7$var$pn ? void 0 : y,
                    g
                ]), y = t1);
            } else v.get();
        }
    }, "sync" === c ? v.update = v.run : "post" === c ? (v.post = !0, v.update = function() {
        return $905dbd31c454eff7$var$cn(v);
    }) : v.update = function() {
        if (u && u === $905dbd31c454eff7$var$at && !u._isMounted) {
            var t1 = u._preWatchers || (u._preWatchers = []);
            t1.indexOf(v) < 0 && t1.push(v);
        } else $905dbd31c454eff7$var$cn(v);
    }, o ? r ? v.run() : y = v.get() : "post" === c && u ? u.$once("hook:mounted", function() {
        return v.get();
    }) : v.get(), function() {
        v.teardown();
    };
}
function $905dbd31c454eff7$var$mn(t1) {
    var e = t1._provided, n1 = t1.$parent && t1.$parent._provided;
    return n1 === e ? t1._provided = Object.create(n1) : e;
}
function $905dbd31c454eff7$var$gn(t1, e, n1) {
    $905dbd31c454eff7$var$_t();
    try {
        if (e) {
            var o = e;
            for(; o = o.$parent;){
                var r = o.$options.errorCaptured;
                if (r) for(var s = 0; s < r.length; s++)try {
                    if (!1 === r[s].call(o, t1, e, n1)) return;
                } catch (t1) {
                    $905dbd31c454eff7$var$yn(t1, o, "errorCaptured hook");
                }
            }
        }
        $905dbd31c454eff7$var$yn(t1, e, n1);
    } finally{
        $905dbd31c454eff7$var$$t();
    }
}
function $905dbd31c454eff7$var$vn(t1, e, n1, o, r) {
    var s;
    try {
        s = n1 ? t1.apply(e, n1) : t1.call(e), s && !s._isVue && $905dbd31c454eff7$var$f(s) && !s._handled && (s.catch(function(t1) {
            return $905dbd31c454eff7$var$gn(t1, o, r + " (Promise/async)");
        }), s._handled = !0);
    } catch (t1) {
        $905dbd31c454eff7$var$gn(t1, o, r);
    }
    return s;
}
function $905dbd31c454eff7$var$yn(t1, e, n1) {
    if ($905dbd31c454eff7$var$B.errorHandler) try {
        return $905dbd31c454eff7$var$B.errorHandler.call(null, t1, e, n1);
    } catch (e) {
        e !== t1 && $905dbd31c454eff7$var$_n(e);
    }
    $905dbd31c454eff7$var$_n(t1);
}
function $905dbd31c454eff7$var$_n(t1, e, n1) {
    if (!$905dbd31c454eff7$var$q || "undefined" == typeof console) throw t1;
    console.error(t1);
}
var $905dbd31c454eff7$var$$n = !1;
var $905dbd31c454eff7$var$bn = [];
var $905dbd31c454eff7$var$wn, $905dbd31c454eff7$var$xn = !1;
function $905dbd31c454eff7$var$Cn() {
    $905dbd31c454eff7$var$xn = !1;
    var t1 = $905dbd31c454eff7$var$bn.slice(0);
    $905dbd31c454eff7$var$bn.length = 0;
    for(var e = 0; e < t1.length; e++)t1[e]();
}
if ("undefined" != typeof Promise && $905dbd31c454eff7$var$st(Promise)) {
    var $905dbd31c454eff7$var$t4 = Promise.resolve();
    $905dbd31c454eff7$var$wn = function() {
        $905dbd31c454eff7$var$t4.then($905dbd31c454eff7$var$Cn), $905dbd31c454eff7$var$Y && setTimeout($905dbd31c454eff7$var$E);
    }, $905dbd31c454eff7$var$$n = !0;
} else if ($905dbd31c454eff7$var$Z || "undefined" == typeof MutationObserver || !$905dbd31c454eff7$var$st(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString()) $905dbd31c454eff7$var$wn = "undefined" != typeof setImmediate && $905dbd31c454eff7$var$st(setImmediate) ? function() {
    setImmediate($905dbd31c454eff7$var$Cn);
} : function() {
    setTimeout($905dbd31c454eff7$var$Cn, 0);
};
else {
    var $905dbd31c454eff7$var$t5 = 1;
    var $905dbd31c454eff7$var$e1 = new MutationObserver($905dbd31c454eff7$var$Cn), $905dbd31c454eff7$var$n2 = document.createTextNode(String($905dbd31c454eff7$var$t5));
    $905dbd31c454eff7$var$e1.observe($905dbd31c454eff7$var$n2, {
        characterData: !0
    }), $905dbd31c454eff7$var$wn = function() {
        $905dbd31c454eff7$var$t5 = ($905dbd31c454eff7$var$t5 + 1) % 2, $905dbd31c454eff7$var$n2.data = String($905dbd31c454eff7$var$t5);
    }, $905dbd31c454eff7$var$$n = !0;
}
function $905dbd31c454eff7$var$kn(t1, e) {
    var n1;
    if ($905dbd31c454eff7$var$bn.push(function() {
        if (t1) try {
            t1.call(e);
        } catch (t1) {
            $905dbd31c454eff7$var$gn(t1, e, "nextTick");
        }
        else n1 && n1(e);
    }), $905dbd31c454eff7$var$xn || ($905dbd31c454eff7$var$xn = !0, $905dbd31c454eff7$var$wn()), !t1 && "undefined" != typeof Promise) return new Promise(function(t1) {
        n1 = t1;
    });
}
function $905dbd31c454eff7$var$Sn(t1) {
    return function(e) {
        var n1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $905dbd31c454eff7$var$at;
        if (n1) return function(t1, e, n1) {
            var o = t1.$options;
            o[e] = $905dbd31c454eff7$var$go(o[e], n1);
        }(n1, t1, e);
    };
}
var $905dbd31c454eff7$var$On = $905dbd31c454eff7$var$Sn("beforeMount"), $905dbd31c454eff7$var$Tn = $905dbd31c454eff7$var$Sn("mounted"), $905dbd31c454eff7$var$An = $905dbd31c454eff7$var$Sn("beforeUpdate"), $905dbd31c454eff7$var$jn = $905dbd31c454eff7$var$Sn("updated"), $905dbd31c454eff7$var$En = $905dbd31c454eff7$var$Sn("beforeDestroy"), $905dbd31c454eff7$var$Nn = $905dbd31c454eff7$var$Sn("destroyed"), $905dbd31c454eff7$var$Pn = $905dbd31c454eff7$var$Sn("activated"), $905dbd31c454eff7$var$Dn = $905dbd31c454eff7$var$Sn("deactivated"), $905dbd31c454eff7$var$Mn = $905dbd31c454eff7$var$Sn("serverPrefetch"), $905dbd31c454eff7$var$In = $905dbd31c454eff7$var$Sn("renderTracked"), $905dbd31c454eff7$var$Ln = $905dbd31c454eff7$var$Sn("renderTriggered"), $905dbd31c454eff7$var$Rn = $905dbd31c454eff7$var$Sn("errorCaptured");
var $905dbd31c454eff7$var$Fn = "2.7.16";
var $905dbd31c454eff7$var$Hn = Object.freeze({
    __proto__: null,
    version: $905dbd31c454eff7$var$Fn,
    defineComponent: function defineComponent(t1) {
        return t1;
    },
    ref: function ref(t1) {
        return $905dbd31c454eff7$var$Bt(t1, !1);
    },
    shallowRef: function shallowRef(t1) {
        return $905dbd31c454eff7$var$Bt(t1, !0);
    },
    isRef: $905dbd31c454eff7$var$Ht,
    toRef: $905dbd31c454eff7$var$zt,
    toRefs: function toRefs(t1) {
        var n1 = $905dbd31c454eff7$var$e(t1) ? new Array(t1.length) : {};
        for(var e1 in t1)n1[e1] = $905dbd31c454eff7$var$zt(t1, e1);
        return n1;
    },
    unref: function unref(t1) {
        return $905dbd31c454eff7$var$Ht(t1) ? t1.value : t1;
    },
    proxyRefs: function proxyRefs(t1) {
        if ($905dbd31c454eff7$var$It(t1)) return t1;
        var e = {}, n1 = Object.keys(t1);
        for(var o = 0; o < n1.length; o++)$905dbd31c454eff7$var$Ut(e, t1, n1[o]);
        return e;
    },
    customRef: function customRef(t1) {
        var e = new $905dbd31c454eff7$var$vt, _t = t1(function() {
            e.depend();
        }, function() {
            e.notify();
        }), n1 = _t.get, o = _t.set, r = {
            get value () {
                return n1();
            },
            set value (t){
                o(t);
            }
        };
        return $905dbd31c454eff7$var$V(r, $905dbd31c454eff7$var$Ft, !0), r;
    },
    triggerRef: function triggerRef(t1) {
        t1.dep && t1.dep.notify();
    },
    reactive: function reactive(t1) {
        return $905dbd31c454eff7$var$Mt(t1, !1), t1;
    },
    isReactive: $905dbd31c454eff7$var$It,
    isReadonly: $905dbd31c454eff7$var$Rt,
    isShallow: $905dbd31c454eff7$var$Lt,
    isProxy: function isProxy(t1) {
        return $905dbd31c454eff7$var$It(t1) || $905dbd31c454eff7$var$Rt(t1);
    },
    shallowReactive: $905dbd31c454eff7$var$Dt,
    markRaw: function markRaw(t1) {
        return Object.isExtensible(t1) && $905dbd31c454eff7$var$V(t1, "__v_skip", !0), t1;
    },
    toRaw: function t1(e) {
        var n1 = e && e.__v_raw;
        return n1 ? t1(n1) : e;
    },
    readonly: $905dbd31c454eff7$var$Jt,
    shallowReadonly: function shallowReadonly(t1) {
        return $905dbd31c454eff7$var$qt(t1, !0);
    },
    computed: function computed(t1, e) {
        var n1, o;
        var r = $905dbd31c454eff7$var$i(t1);
        r ? (n1 = t1, o = $905dbd31c454eff7$var$E) : (n1 = t1.get, o = t1.set);
        var s = $905dbd31c454eff7$var$ot() ? null : new $905dbd31c454eff7$var$Kn($905dbd31c454eff7$var$at, n1, $905dbd31c454eff7$var$E, {
            lazy: !0
        }), c = {
            effect: s,
            get value () {
                return s ? (s.dirty && s.evaluate(), $905dbd31c454eff7$var$vt.target && s.depend(), s.value) : n1();
            },
            set value (t){
                o(t);
            }
        };
        return $905dbd31c454eff7$var$V(c, $905dbd31c454eff7$var$Ft, !0), $905dbd31c454eff7$var$V(c, "__v_isReadonly", r), c;
    },
    watch: function watch(t1, e, n1) {
        return $905dbd31c454eff7$var$hn(t1, e, n1);
    },
    watchEffect: function watchEffect(t1, e) {
        return $905dbd31c454eff7$var$hn(t1, null, e);
    },
    watchPostEffect: $905dbd31c454eff7$var$dn,
    watchSyncEffect: function watchSyncEffect(t1, e) {
        return $905dbd31c454eff7$var$hn(t1, null, {
            flush: "sync"
        });
    },
    EffectScope: $905dbd31c454eff7$var$Ue,
    effectScope: function effectScope(t1) {
        return new $905dbd31c454eff7$var$Ue(t1);
    },
    onScopeDispose: function onScopeDispose(t1) {
        $905dbd31c454eff7$var$De && $905dbd31c454eff7$var$De.cleanups.push(t1);
    },
    getCurrentScope: $905dbd31c454eff7$var$ze,
    provide: function provide(t1, e) {
        $905dbd31c454eff7$var$at && ($905dbd31c454eff7$var$mn($905dbd31c454eff7$var$at)[t1] = e);
    },
    inject: function inject(t1, e) {
        var n1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        var o = $905dbd31c454eff7$var$at;
        if (o) {
            var r = o.$parent && o.$parent._provided;
            if (r && t1 in r) return r[t1];
            if (arguments.length > 1) return n1 && $905dbd31c454eff7$var$i(e) ? e.call(o) : e;
        }
    },
    h: function h(t1, e, n1) {
        return $905dbd31c454eff7$var$se($905dbd31c454eff7$var$at, t1, e, n1, 2, !0);
    },
    getCurrentInstance: function getCurrentInstance() {
        return $905dbd31c454eff7$var$at && {
            proxy: $905dbd31c454eff7$var$at
        };
    },
    useSlots: function useSlots() {
        return $905dbd31c454eff7$var$Ne().slots;
    },
    useAttrs: function useAttrs() {
        return $905dbd31c454eff7$var$Ne().attrs;
    },
    useListeners: function useListeners() {
        return $905dbd31c454eff7$var$Ne().listeners;
    },
    mergeDefaults: function mergeDefaults(t1, n1) {
        var o = $905dbd31c454eff7$var$e(t1) ? t1.reduce(function(t1, e) {
            return t1[e] = {}, t1;
        }, {}) : t1;
        for(var _$t in n1){
            var r = o[_$t];
            r ? $905dbd31c454eff7$var$e(r) || $905dbd31c454eff7$var$i(r) ? o[_$t] = {
                type: r,
                default: n1[_$t]
            } : r.default = n1[_$t] : null === r && (o[_$t] = {
                default: n1[_$t]
            });
        }
        return o;
    },
    nextTick: $905dbd31c454eff7$var$kn,
    set: $905dbd31c454eff7$var$Et,
    del: $905dbd31c454eff7$var$Nt,
    useCssModule: function useCssModule() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
        {
            if (!$905dbd31c454eff7$var$at) return $905dbd31c454eff7$var$t1;
            var n1 = $905dbd31c454eff7$var$at[e];
            return n1 || $905dbd31c454eff7$var$t1;
        }
    },
    useCssVars: function useCssVars(t1) {
        if (!$905dbd31c454eff7$var$q) return;
        var e = $905dbd31c454eff7$var$at;
        e && $905dbd31c454eff7$var$dn(function() {
            var n1 = e.$el, o = t1(e, e._setupProxy);
            if (n1 && 1 === n1.nodeType) {
                var _$t = n1.style;
                for(var e1 in o)_$t.setProperty("--".concat(e1), o[e1]);
            }
        });
    },
    defineAsyncComponent: function defineAsyncComponent(t1) {
        $905dbd31c454eff7$var$i(t1) && (t1 = {
            loader: t1
        });
        var e = t1.loader, n1 = t1.loadingComponent, o = t1.errorComponent, tmp = t1.delay, r = tmp === void 0 ? 200 : tmp, s = t1.timeout, tmp1 = t1.suspensible, c = tmp1 === void 0 ? !1 : tmp1, a = t1.onError;
        var l = null, u = 0;
        var f = function() {
            var _$t;
            return l || (_$t = l = e().catch(function(t1) {
                if (t1 = t1 instanceof Error ? t1 : new Error(String(t1)), a) return new Promise(function(e, n1) {
                    a(t1, function() {
                        return e((u++, l = null, f()));
                    }, function() {
                        return n1(t1);
                    }, u + 1);
                });
                throw t1;
            }).then(function(e) {
                return _$t !== l && l ? l : (e && (e.__esModule || "Module" === e[Symbol.toStringTag]) && (e = e.default), e);
            }));
        };
        return function() {
            return {
                component: f(),
                delay: r,
                timeout: s,
                error: o,
                loading: n1
            };
        };
    },
    onBeforeMount: $905dbd31c454eff7$var$On,
    onMounted: $905dbd31c454eff7$var$Tn,
    onBeforeUpdate: $905dbd31c454eff7$var$An,
    onUpdated: $905dbd31c454eff7$var$jn,
    onBeforeUnmount: $905dbd31c454eff7$var$En,
    onUnmounted: $905dbd31c454eff7$var$Nn,
    onActivated: $905dbd31c454eff7$var$Pn,
    onDeactivated: $905dbd31c454eff7$var$Dn,
    onServerPrefetch: $905dbd31c454eff7$var$Mn,
    onRenderTracked: $905dbd31c454eff7$var$In,
    onRenderTriggered: $905dbd31c454eff7$var$Ln,
    onErrorCaptured: function onErrorCaptured(t1) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $905dbd31c454eff7$var$at;
        $905dbd31c454eff7$var$Rn(t1, e);
    }
});
var $905dbd31c454eff7$var$Bn = new $905dbd31c454eff7$var$ct;
function $905dbd31c454eff7$var$Un(t1) {
    return $905dbd31c454eff7$var$zn(t1, $905dbd31c454eff7$var$Bn), $905dbd31c454eff7$var$Bn.clear(), t1;
}
function $905dbd31c454eff7$var$zn(t1, n1) {
    var o, r;
    var s = $905dbd31c454eff7$var$e(t1);
    if (!(!s && !$905dbd31c454eff7$var$c(t1) || t1.__v_skip || Object.isFrozen(t1) || t1 instanceof $905dbd31c454eff7$var$ut)) {
        if (t1.__ob__) {
            var e1 = t1.__ob__.dep.id;
            if (n1.has(e1)) return;
            n1.add(e1);
        }
        if (s) for(o = t1.length; o--;)$905dbd31c454eff7$var$zn(t1[o], n1);
        else if ($905dbd31c454eff7$var$Ht(t1)) $905dbd31c454eff7$var$zn(t1.value, n1);
        else for(r = Object.keys(t1), o = r.length; o--;)$905dbd31c454eff7$var$zn(t1[r[o]], n1);
    }
}
var $905dbd31c454eff7$var$Vn = 0;
var $905dbd31c454eff7$var$Kn = /*#__PURE__*/ function() {
    function Kn(t1, e, n1, o, r) {
        (0, $2yCSJ._)(this, Kn);
        !function(t1) {
            var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $905dbd31c454eff7$var$De;
            _$e && _$e.active && _$e.effects.push(t1);
        }(this, $905dbd31c454eff7$var$De && !$905dbd31c454eff7$var$De._vm ? $905dbd31c454eff7$var$De : t1 ? t1._scope : void 0), (this.vm = t1) && r && (t1._watcher = this), o ? (this.deep = !!o.deep, this.user = !!o.user, this.lazy = !!o.lazy, this.sync = !!o.sync, this.before = o.before) : this.deep = this.user = this.lazy = this.sync = !1, this.cb = n1, this.id = ++$905dbd31c454eff7$var$Vn, this.active = !0, this.post = !1, this.dirty = this.lazy, this.deps = [], this.newDeps = [], this.depIds = new $905dbd31c454eff7$var$ct, this.newDepIds = new $905dbd31c454eff7$var$ct, this.expression = "", $905dbd31c454eff7$var$i(e) ? this.getter = e : (this.getter = function(t1) {
            if ($905dbd31c454eff7$var$K.test(t1)) return;
            var _$e = t1.split(".");
            return function(t1) {
                for(var _$n = 0; _$n < _$e.length; _$n++){
                    if (!t1) return;
                    t1 = t1[_$e[_$n]];
                }
                return t1;
            };
        }(e), this.getter || (this.getter = $905dbd31c454eff7$var$E)), this.value = this.lazy ? void 0 : this.get();
    }
    (0, $80pZ5._)(Kn, [
        {
            key: "get",
            value: function get() {
                var _$t;
                $905dbd31c454eff7$var$_t(this);
                var e = this.vm;
                try {
                    _$t = this.getter.call(e, e);
                } catch (t1) {
                    if (!this.user) throw t1;
                    $905dbd31c454eff7$var$gn(t1, e, 'getter for watcher "'.concat(this.expression, '"'));
                } finally{
                    this.deep && $905dbd31c454eff7$var$Un(_$t), $905dbd31c454eff7$var$$t(), this.cleanupDeps();
                }
                return _$t;
            }
        },
        {
            key: "addDep",
            value: function addDep(t1) {
                var e = t1.id;
                this.newDepIds.has(e) || (this.newDepIds.add(e), this.newDeps.push(t1), this.depIds.has(e) || t1.addSub(this));
            }
        },
        {
            key: "cleanupDeps",
            value: function cleanupDeps() {
                var t1 = this.deps.length;
                for(; t1--;){
                    var e = this.deps[t1];
                    this.newDepIds.has(e.id) || e.removeSub(this);
                }
                var e1 = this.depIds;
                this.depIds = this.newDepIds, this.newDepIds = e1, this.newDepIds.clear(), e1 = this.deps, this.deps = this.newDeps, this.newDeps = e1, this.newDeps.length = 0;
            }
        },
        {
            key: "update",
            value: function update() {
                this.lazy ? this.dirty = !0 : this.sync ? this.run() : $905dbd31c454eff7$var$cn(this);
            }
        },
        {
            key: "run",
            value: function run() {
                if (this.active) {
                    var t1 = this.get();
                    if (t1 !== this.value || $905dbd31c454eff7$var$c(t1) || this.deep) {
                        var e = this.value;
                        if (this.value = t1, this.user) {
                            var n1 = 'callback for watcher "'.concat(this.expression, '"');
                            $905dbd31c454eff7$var$vn(this.cb, this.vm, [
                                t1,
                                e
                            ], this.vm, n1);
                        } else this.cb.call(this.vm, t1, e);
                    }
                }
            }
        },
        {
            key: "evaluate",
            value: function evaluate() {
                this.value = this.get(), this.dirty = !1;
            }
        },
        {
            key: "depend",
            value: function depend() {
                var t1 = this.deps.length;
                for(; t1--;)this.deps[t1].depend();
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                if (this.vm && !this.vm._isBeingDestroyed && $905dbd31c454eff7$var$y(this.vm._scope.effects, this), this.active) {
                    var t1 = this.deps.length;
                    for(; t1--;)this.deps[t1].removeSub(this);
                    this.active = !1, this.onStop && this.onStop();
                }
            }
        }
    ]);
    return Kn;
}();
var $905dbd31c454eff7$var$Jn = {
    enumerable: !0,
    configurable: !0,
    get: $905dbd31c454eff7$var$E,
    set: $905dbd31c454eff7$var$E
};
function $905dbd31c454eff7$var$qn(t1, e, n1) {
    $905dbd31c454eff7$var$Jn.get = function() {
        return this[e][n1];
    }, $905dbd31c454eff7$var$Jn.set = function(t1) {
        this[e][n1] = t1;
    }, Object.defineProperty(t1, n1, $905dbd31c454eff7$var$Jn);
}
function $905dbd31c454eff7$var$Wn(t1) {
    var n1 = t1.$options;
    if (n1.props && function(t1, e) {
        var n1 = t1.$options.propsData || {}, o = t1._props = $905dbd31c454eff7$var$Dt({}), r = t1.$options._propKeys = [], s = !t1.$parent;
        s || $905dbd31c454eff7$var$St(!1);
        for(var s1 in e){
            r.push(s1);
            $905dbd31c454eff7$var$jt(o, s1, $905dbd31c454eff7$var$bo(s1, e, n1, t1), void 0, !0), s1 in t1 || $905dbd31c454eff7$var$qn(t1, "_props", s1);
        }
        $905dbd31c454eff7$var$St(!0);
    }(t1, n1.props), function(t1) {
        var e = t1.$options, n1 = e.setup;
        if (n1) {
            var o = t1._setupContext = $905dbd31c454eff7$var$Te(t1);
            $905dbd31c454eff7$var$lt(t1), $905dbd31c454eff7$var$_t();
            var r = $905dbd31c454eff7$var$vn(n1, null, [
                t1._props || $905dbd31c454eff7$var$Dt({}),
                o
            ], t1, "setup");
            if ($905dbd31c454eff7$var$$t(), $905dbd31c454eff7$var$lt(), $905dbd31c454eff7$var$i(r)) e.render = r;
            else if ($905dbd31c454eff7$var$c(r)) {
                if (t1._setupState = r, r.__sfc) {
                    var e1 = t1._setupProxy = {};
                    for(var _$t in r)"__sfc" !== _$t && $905dbd31c454eff7$var$Ut(e1, r, _$t);
                } else for(var e2 in r)$905dbd31c454eff7$var$z(e2) || $905dbd31c454eff7$var$Ut(t1, r, e2);
            }
        }
    }(t1), n1.methods && function(t1, e) {
        t1.$options.props;
        for(var n1 in e)t1[n1] = "function" != typeof e[n1] ? $905dbd31c454eff7$var$E : $905dbd31c454eff7$var$O(e[n1], t1);
    }(t1, n1.methods), n1.data) !function(t1) {
        var e = t1.$options.data;
        e = t1._data = $905dbd31c454eff7$var$i(e) ? function(t1, e) {
            $905dbd31c454eff7$var$_t();
            try {
                return t1.call(e, e);
            } catch (t1) {
                return $905dbd31c454eff7$var$gn(t1, e, "data()"), {};
            } finally{
                $905dbd31c454eff7$var$$t();
            }
        }(e, t1) : e || {}, $905dbd31c454eff7$var$l(e) || (e = {});
        var n1 = Object.keys(e), o = t1.$options.props;
        t1.$options.methods;
        var r = n1.length;
        for(; r--;){
            var e1 = n1[r];
            o && $905dbd31c454eff7$var$$(o, e1) || $905dbd31c454eff7$var$z(e1) || $905dbd31c454eff7$var$qn(t1, "_data", e1);
        }
        var s = $905dbd31c454eff7$var$At(e);
        s && s.vmCount++;
    }(t1);
    else {
        var e1 = $905dbd31c454eff7$var$At(t1._data = {});
        e1 && e1.vmCount++;
    }
    n1.computed && function(t1, e) {
        var n1 = t1._computedWatchers = Object.create(null), o = $905dbd31c454eff7$var$ot();
        for(var r in e){
            var s = e[r], c = $905dbd31c454eff7$var$i(s) ? s : s.get;
            o || (n1[r] = new $905dbd31c454eff7$var$Kn(t1, c || $905dbd31c454eff7$var$E, $905dbd31c454eff7$var$E, $905dbd31c454eff7$var$Zn)), r in t1 || $905dbd31c454eff7$var$Gn(t1, r, s);
        }
    }(t1, n1.computed), n1.watch && n1.watch !== $905dbd31c454eff7$var$tt && function(t1, n1) {
        for(var o in n1){
            var r = n1[o];
            if ($905dbd31c454eff7$var$e(r)) for(var e1 = 0; e1 < r.length; e1++)$905dbd31c454eff7$var$Qn(t1, o, r[e1]);
            else $905dbd31c454eff7$var$Qn(t1, o, r);
        }
    }(t1, n1.watch);
}
var $905dbd31c454eff7$var$Zn = {
    lazy: !0
};
function $905dbd31c454eff7$var$Gn(t1, e, n1) {
    var o = !$905dbd31c454eff7$var$ot();
    $905dbd31c454eff7$var$i(n1) ? ($905dbd31c454eff7$var$Jn.get = o ? $905dbd31c454eff7$var$Xn(e) : $905dbd31c454eff7$var$Yn(n1), $905dbd31c454eff7$var$Jn.set = $905dbd31c454eff7$var$E) : ($905dbd31c454eff7$var$Jn.get = n1.get ? o && !1 !== n1.cache ? $905dbd31c454eff7$var$Xn(e) : $905dbd31c454eff7$var$Yn(n1.get) : $905dbd31c454eff7$var$E, $905dbd31c454eff7$var$Jn.set = n1.set || $905dbd31c454eff7$var$E), Object.defineProperty(t1, e, $905dbd31c454eff7$var$Jn);
}
function $905dbd31c454eff7$var$Xn(t1) {
    return function() {
        var e = this._computedWatchers && this._computedWatchers[t1];
        if (e) return e.dirty && e.evaluate(), $905dbd31c454eff7$var$vt.target && e.depend(), e.value;
    };
}
function $905dbd31c454eff7$var$Yn(t1) {
    return function() {
        return t1.call(this, this);
    };
}
function $905dbd31c454eff7$var$Qn(t1, e, n1, o) {
    return $905dbd31c454eff7$var$l(n1) && (o = n1, n1 = n1.handler), "string" == typeof n1 && (n1 = t1[n1]), t1.$watch(e, n1, o);
}
function $905dbd31c454eff7$var$to(t1, e) {
    if (t1) {
        var n1 = Object.create(null), o = $905dbd31c454eff7$var$it ? Reflect.ownKeys(t1) : Object.keys(t1);
        for(var r = 0; r < o.length; r++){
            var s = o[r];
            if ("__ob__" === s) continue;
            var c = t1[s].from;
            if (c in e._provided) n1[s] = e._provided[c];
            else if ("default" in t1[s]) {
                var o1 = t1[s].default;
                n1[s] = $905dbd31c454eff7$var$i(o1) ? o1.call(e) : o1;
            }
        }
        return n1;
    }
}
var $905dbd31c454eff7$var$eo = 0;
function $905dbd31c454eff7$var$no(t1) {
    var e = t1.options;
    if (t1.super) {
        var n1 = $905dbd31c454eff7$var$no(t1.super);
        if (n1 !== t1.superOptions) {
            t1.superOptions = n1;
            var o = function(t1) {
                var e;
                var n1 = t1.options, o = t1.sealedOptions;
                for(var _$t in n1)n1[_$t] !== o[_$t] && (e || (e = {}), e[_$t] = n1[_$t]);
                return e;
            }(t1);
            o && $905dbd31c454eff7$var$A(t1.extendOptions, o), e = t1.options = $905dbd31c454eff7$var$_o(n1, t1.extendOptions), e.name && (e.components[e.name] = t1);
        }
    }
    return e;
}
function $905dbd31c454eff7$var$oo(n1, o, s, i, c) {
    var _this = this;
    var a = c.options;
    var l;
    $905dbd31c454eff7$var$$(i, "_uid") ? (l = Object.create(i), l._original = i) : (l = i, i = i._original);
    var u = $905dbd31c454eff7$var$r(a._compiled), f = !u;
    this.data = n1, this.props = o, this.children = s, this.parent = i, this.listeners = n1.on || $905dbd31c454eff7$var$t1, this.injections = $905dbd31c454eff7$var$to(a.inject, i), this.slots = function() {
        return _this.$slots || $905dbd31c454eff7$var$ke(i, n1.scopedSlots, _this.$slots = $905dbd31c454eff7$var$we(s, i)), _this.$slots;
    }, Object.defineProperty(this, "scopedSlots", {
        enumerable: !0,
        get: function() {
            return $905dbd31c454eff7$var$ke(i, n1.scopedSlots, this.slots());
        }
    }), u && (this.$options = a, this.$slots = this.slots(), this.$scopedSlots = $905dbd31c454eff7$var$ke(i, n1.scopedSlots, this.$slots)), a._scopeId ? this._c = function(t1, n1, o, r) {
        var _$s = $905dbd31c454eff7$var$se(l, t1, n1, o, r, f);
        return _$s && !$905dbd31c454eff7$var$e(_$s) && (_$s.fnScopeId = a._scopeId, _$s.fnContext = i), _$s;
    } : this._c = function(t1, e, n1, o) {
        return $905dbd31c454eff7$var$se(l, t1, e, n1, o, f);
    };
}
function $905dbd31c454eff7$var$ro(t1, e, n1, o, r) {
    var s = $905dbd31c454eff7$var$pt(t1);
    return s.fnContext = n1, s.fnOptions = o, e.slot && ((s.data || (s.data = {})).slot = e.slot), s;
}
function $905dbd31c454eff7$var$so(t1, e) {
    for(var n1 in e)t1[$905dbd31c454eff7$var$x(n1)] = e[n1];
}
function $905dbd31c454eff7$var$io(t1) {
    return t1.name || t1.__name || t1._componentTag;
}
$905dbd31c454eff7$var$be($905dbd31c454eff7$var$oo.prototype);
var $905dbd31c454eff7$var$co = (0, $ddmaO._)({
    init: function(t1, e) {
        if (t1.componentInstance && !t1.componentInstance._isDestroyed && t1.data.keepAlive) {
            var _$e = t1;
            $905dbd31c454eff7$var$co.prepatch(_$e, _$e);
        } else (t1.componentInstance = function(t1, e) {
            var n1 = {
                _isComponent: !0,
                _parentVnode: t1,
                parent: e
            }, r = t1.data.inlineTemplate;
            $905dbd31c454eff7$var$o(r) && (n1.render = r.render, n1.staticRenderFns = r.staticRenderFns);
            return new t1.componentOptions.Ctor(n1);
        }(t1, $905dbd31c454eff7$var$Ve)).$mount(e ? t1.elm : void 0, e);
    },
    prepatch: function(e, n1) {
        var o = n1.componentOptions;
        !function(e, n1, o, r, s) {
            var i = r.data.scopedSlots, c = e.$scopedSlots, a = !!(i && !i.$stable || c !== $905dbd31c454eff7$var$t1 && !c.$stable || i && e.$scopedSlots.$key !== i.$key || !i && e.$scopedSlots.$key);
            var l = !!(s || e.$options._renderChildren || a);
            var u = e.$vnode;
            e.$options._parentVnode = r, e.$vnode = r, e._vnode && (e._vnode.parent = r), e.$options._renderChildren = s;
            var f = r.data.attrs || $905dbd31c454eff7$var$t1;
            e._attrsProxy && $905dbd31c454eff7$var$Ae(e._attrsProxy, f, u.data && u.data.attrs || $905dbd31c454eff7$var$t1, e, "$attrs") && (l = !0), e.$attrs = f, o = o || $905dbd31c454eff7$var$t1;
            var d = e.$options._parentListeners;
            if (e._listenersProxy && $905dbd31c454eff7$var$Ae(e._listenersProxy, o, d || $905dbd31c454eff7$var$t1, e, "$listeners"), e.$listeners = e.$options._parentListeners = o, $905dbd31c454eff7$var$Be(e, o, d), n1 && e.$options.props) {
                $905dbd31c454eff7$var$St(!1);
                var t2 = e._props, _$o = e.$options._propKeys || [];
                for(var _$r = 0; _$r < _$o.length; _$r++){
                    var _$s = _$o[_$r], i1 = e.$options.props;
                    t2[_$s] = $905dbd31c454eff7$var$bo(_$s, i1, n1, e);
                }
                $905dbd31c454eff7$var$St(!0), e.$options.propsData = n1;
            }
            l && (e.$slots = $905dbd31c454eff7$var$we(s, r.context), e.$forceUpdate());
        }(n1.componentInstance = e.componentInstance, o.propsData, o.listeners, n1, o.children);
    },
    insert: function(t1) {
        var e = t1.context, n1 = t1.componentInstance;
        var o;
        n1._isMounted || (n1._isMounted = !0, $905dbd31c454eff7$var$Ze(n1, "mounted")), t1.data.keepAlive && (e._isMounted ? ((o = n1)._inactive = !1, $905dbd31c454eff7$var$Xe.push(o)) : $905dbd31c454eff7$var$qe(n1, !0));
    }
}, "destroy", function(t1) {
    var e = t1["componentInstance"];
    e._isDestroyed || (t1.data.keepAlive ? $905dbd31c454eff7$var$We(e, !0) : e.$destroy());
}), $905dbd31c454eff7$var$ao = Object.keys($905dbd31c454eff7$var$co);
function $905dbd31c454eff7$var$lo(s, i, a, l, u) {
    if ($905dbd31c454eff7$var$n1(s)) return;
    var d = a.$options._base;
    if ($905dbd31c454eff7$var$c(s) && (s = d.extend(s)), "function" != typeof s) return;
    var p;
    if ($905dbd31c454eff7$var$n1(s.cid) && (p = s, s = function(t1, e) {
        if ($905dbd31c454eff7$var$r(t1.error) && $905dbd31c454eff7$var$o(t1.errorComp)) return t1.errorComp;
        if ($905dbd31c454eff7$var$o(t1.resolved)) return t1.resolved;
        var _$s = $905dbd31c454eff7$var$Me;
        if (_$s && $905dbd31c454eff7$var$o(t1.owners) && -1 === t1.owners.indexOf(_$s) && t1.owners.push(_$s), $905dbd31c454eff7$var$r(t1.loading) && $905dbd31c454eff7$var$o(t1.loadingComp)) return t1.loadingComp;
        if (_$s && !$905dbd31c454eff7$var$o(t1.owners)) {
            var _$r = t1.owners = [
                _$s
            ];
            var _$i = !0, _$a = null, _$l = null;
            _$s.$on("hook:destroyed", function() {
                return $905dbd31c454eff7$var$y(_$r, _$s);
            });
            var _$u = function(t1) {
                for(var _$t = 0, _$e = _$r.length; _$t < _$e; _$t++)_$r[_$t].$forceUpdate();
                t1 && (_$r.length = 0, null !== _$a && (clearTimeout(_$a), _$a = null), null !== _$l && (clearTimeout(_$l), _$l = null));
            }, d = $905dbd31c454eff7$var$I(function(n1) {
                t1.resolved = $905dbd31c454eff7$var$Ie(n1, e), _$i ? _$r.length = 0 : _$u(!0);
            }), p = $905dbd31c454eff7$var$I(function(e) {
                $905dbd31c454eff7$var$o(t1.errorComp) && (t1.error = !0, _$u(!0));
            }), h = t1(d, p);
            return $905dbd31c454eff7$var$c(h) && ($905dbd31c454eff7$var$f(h) ? $905dbd31c454eff7$var$n1(t1.resolved) && h.then(d, p) : $905dbd31c454eff7$var$f(h.component) && (h.component.then(d, p), $905dbd31c454eff7$var$o(h.error) && (t1.errorComp = $905dbd31c454eff7$var$Ie(h.error, e)), $905dbd31c454eff7$var$o(h.loading) && (t1.loadingComp = $905dbd31c454eff7$var$Ie(h.loading, e), 0 === h.delay ? t1.loading = !0 : _$a = setTimeout(function() {
                _$a = null, $905dbd31c454eff7$var$n1(t1.resolved) && $905dbd31c454eff7$var$n1(t1.error) && (t1.loading = !0, _$u(!1));
            }, h.delay || 200)), $905dbd31c454eff7$var$o(h.timeout) && (_$l = setTimeout(function() {
                _$l = null, $905dbd31c454eff7$var$n1(t1.resolved) && p(null);
            }, h.timeout)))), _$i = !1, t1.loading ? t1.loadingComp : t1.resolved;
        }
    }(p, d), void 0 === s)) return function(t1, e, n1, o, r) {
        var _$s = $905dbd31c454eff7$var$ft();
        return _$s.asyncFactory = t1, _$s.asyncMeta = {
            data: e,
            context: n1,
            children: o,
            tag: r
        }, _$s;
    }(p, i, a, l, u);
    i = i || {}, $905dbd31c454eff7$var$no(s), $905dbd31c454eff7$var$o(i.model) && function(t1, n1) {
        var _$r = t1.model && t1.model.prop || "value", _$s = t1.model && t1.model.event || "input";
        (n1.attrs || (n1.attrs = {}))[_$r] = n1.model.value;
        var _$i = n1.on || (n1.on = {}), _$c = _$i[_$s], _$a = n1.model.callback;
        $905dbd31c454eff7$var$o(_$c) ? ($905dbd31c454eff7$var$e(_$c) ? -1 === _$c.indexOf(_$a) : _$c !== _$a) && (_$i[_$s] = [
            _$a
        ].concat(_$c)) : _$i[_$s] = _$a;
    }(s.options, i);
    var h = function(t1, e, r) {
        var _$s = e.options.props;
        if ($905dbd31c454eff7$var$n1(_$s)) return;
        var _$i = {}, _$c = t1.attrs, _$a = t1.props;
        if ($905dbd31c454eff7$var$o(_$c) || $905dbd31c454eff7$var$o(_$a)) for(var _$t in _$s){
            var _$e = $905dbd31c454eff7$var$S(_$t);
            $905dbd31c454eff7$var$Qt(_$i, _$a, _$t, _$e, !0) || $905dbd31c454eff7$var$Qt(_$i, _$c, _$t, _$e, !1);
        }
        return _$i;
    }(i, s);
    if ($905dbd31c454eff7$var$r(s.options.functional)) return function(n1, r, s, i, c) {
        var _$a = n1.options, _$l = {}, _$u = _$a.props;
        if ($905dbd31c454eff7$var$o(_$u)) for(var e1 in _$u)_$l[e1] = $905dbd31c454eff7$var$bo(e1, _$u, r || $905dbd31c454eff7$var$t1);
        else $905dbd31c454eff7$var$o(s.attrs) && $905dbd31c454eff7$var$so(_$l, s.attrs), $905dbd31c454eff7$var$o(s.props) && $905dbd31c454eff7$var$so(_$l, s.props);
        var f = new $905dbd31c454eff7$var$oo(s, _$l, c, i, n1), d = _$a.render.call(null, f._c, f);
        if (d instanceof $905dbd31c454eff7$var$ut) return $905dbd31c454eff7$var$ro(d, s, f.parent, _$a);
        if ($905dbd31c454eff7$var$e(d)) {
            var t2 = $905dbd31c454eff7$var$te(d) || [], e2 = new Array(t2.length);
            for(var _$n = 0; _$n < t2.length; _$n++)e2[_$n] = $905dbd31c454eff7$var$ro(t2[_$n], s, f.parent, _$a);
            return e2;
        }
    }(s, h, i, a, l);
    var _$m = i.on;
    if (i.on = i.nativeOn, $905dbd31c454eff7$var$r(s.options.abstract)) {
        var t2 = i.slot;
        i = {}, t2 && (i.slot = t2);
    }
    !function(t1) {
        var e = t1.hook || (t1.hook = {});
        for(var _$t = 0; _$t < $905dbd31c454eff7$var$ao.length; _$t++){
            var _$n = $905dbd31c454eff7$var$ao[_$t], _$o = e[_$n], _$r = $905dbd31c454eff7$var$co[_$n];
            _$o === _$r || _$o && _$o._merged || (e[_$n] = _$o ? $905dbd31c454eff7$var$uo(_$r, _$o) : _$r);
        }
    }(i);
    var g = $905dbd31c454eff7$var$io(s.options) || u;
    return new $905dbd31c454eff7$var$ut("vue-component-".concat(s.cid).concat(g ? "-".concat(g) : ""), i, void 0, void 0, void 0, a, {
        Ctor: s,
        propsData: h,
        listeners: _$m,
        tag: u,
        children: l
    }, p);
}
function $905dbd31c454eff7$var$uo(t1, e) {
    var n1 = function(n1, o) {
        t1(n1, o), e(n1, o);
    };
    return n1._merged = !0, n1;
}
var $905dbd31c454eff7$var$fo = $905dbd31c454eff7$var$E;
var $905dbd31c454eff7$var$po = $905dbd31c454eff7$var$B.optionMergeStrategies;
function $905dbd31c454eff7$var$ho(t1, e) {
    var n1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    if (!e) return t1;
    var o, r, s;
    var i = $905dbd31c454eff7$var$it ? Reflect.ownKeys(e) : Object.keys(e);
    for(var c = 0; c < i.length; c++)o = i[c], "__ob__" !== o && (r = t1[o], s = e[o], n1 && $905dbd31c454eff7$var$$(t1, o) ? r !== s && $905dbd31c454eff7$var$l(r) && $905dbd31c454eff7$var$l(s) && $905dbd31c454eff7$var$ho(r, s) : $905dbd31c454eff7$var$Et(t1, o, s));
    return t1;
}
function $905dbd31c454eff7$var$mo(t1, e, n1) {
    return n1 ? function() {
        var o = $905dbd31c454eff7$var$i(e) ? e.call(n1, n1) : e, r = $905dbd31c454eff7$var$i(t1) ? t1.call(n1, n1) : t1;
        return o ? $905dbd31c454eff7$var$ho(o, r) : r;
    } : e ? t1 ? function() {
        return $905dbd31c454eff7$var$ho($905dbd31c454eff7$var$i(e) ? e.call(this, this) : e, $905dbd31c454eff7$var$i(t1) ? t1.call(this, this) : t1);
    } : e : t1;
}
function $905dbd31c454eff7$var$go(t1, n1) {
    var o = n1 ? t1 ? t1.concat(n1) : $905dbd31c454eff7$var$e(n1) ? n1 : [
        n1
    ] : t1;
    return o ? function(t1) {
        var e = [];
        for(var _$n = 0; _$n < t1.length; _$n++)-1 === e.indexOf(t1[_$n]) && e.push(t1[_$n]);
        return e;
    }(o) : o;
}
function $905dbd31c454eff7$var$vo(t1, e, n1, o) {
    var r = Object.create(t1 || null);
    return e ? $905dbd31c454eff7$var$A(r, e) : r;
}
$905dbd31c454eff7$var$po.data = function(t1, e, n1) {
    return n1 ? $905dbd31c454eff7$var$mo(t1, e, n1) : e && "function" != typeof e ? t1 : $905dbd31c454eff7$var$mo(t1, e);
}, $905dbd31c454eff7$var$H.forEach(function(t1) {
    $905dbd31c454eff7$var$po[t1] = $905dbd31c454eff7$var$go;
}), $905dbd31c454eff7$var$F.forEach(function(t1) {
    $905dbd31c454eff7$var$po[t1 + "s"] = $905dbd31c454eff7$var$vo;
}), $905dbd31c454eff7$var$po.watch = function(t1, n1, o, r) {
    if (t1 === $905dbd31c454eff7$var$tt && (t1 = void 0), n1 === $905dbd31c454eff7$var$tt && (n1 = void 0), !n1) return Object.create(t1 || null);
    if (!t1) return n1;
    var s = {};
    $905dbd31c454eff7$var$A(s, t1);
    for(var _$t in n1){
        var o1 = s[_$t];
        var r1 = n1[_$t];
        o1 && !$905dbd31c454eff7$var$e(o1) && (o1 = [
            o1
        ]), s[_$t] = o1 ? o1.concat(r1) : $905dbd31c454eff7$var$e(r1) ? r1 : [
            r1
        ];
    }
    return s;
}, $905dbd31c454eff7$var$po.props = $905dbd31c454eff7$var$po.methods = $905dbd31c454eff7$var$po.inject = $905dbd31c454eff7$var$po.computed = function(t1, e, n1, o) {
    if (!t1) return e;
    var r = Object.create(null);
    return $905dbd31c454eff7$var$A(r, t1), e && $905dbd31c454eff7$var$A(r, e), r;
}, $905dbd31c454eff7$var$po.provide = function(t1, e) {
    return t1 ? function() {
        var n1 = Object.create(null);
        return $905dbd31c454eff7$var$ho(n1, $905dbd31c454eff7$var$i(t1) ? t1.call(this) : t1), e && $905dbd31c454eff7$var$ho(n1, $905dbd31c454eff7$var$i(e) ? e.call(this) : e, !1), n1;
    } : e;
};
var $905dbd31c454eff7$var$yo = function yo(t1, e) {
    return void 0 === e ? t1 : e;
};
function $905dbd31c454eff7$var$_o(t1, n1, o) {
    if ($905dbd31c454eff7$var$i(n1) && (n1 = n1.options), function(t1, n1) {
        var _$o = t1.props;
        if (!_$o) return;
        var r = {};
        var s, _$i, _$c;
        if ($905dbd31c454eff7$var$e(_$o)) for(s = _$o.length; s--;)_$i = _$o[s], "string" == typeof _$i && (_$c = $905dbd31c454eff7$var$x(_$i), r[_$c] = {
            type: null
        });
        else if ($905dbd31c454eff7$var$l(_$o)) for(var _$t in _$o)_$i = _$o[_$t], _$c = $905dbd31c454eff7$var$x(_$t), r[_$c] = $905dbd31c454eff7$var$l(_$i) ? _$i : {
            type: _$i
        };
        t1.props = r;
    }(n1), function(t1, n1) {
        var _$o = t1.inject;
        if (!_$o) return;
        var r = t1.inject = {};
        if ($905dbd31c454eff7$var$e(_$o)) for(var _$t = 0; _$t < _$o.length; _$t++)r[_$o[_$t]] = {
            from: _$o[_$t]
        };
        else if ($905dbd31c454eff7$var$l(_$o)) for(var _$t1 in _$o){
            var e1 = _$o[_$t1];
            r[_$t1] = $905dbd31c454eff7$var$l(e1) ? $905dbd31c454eff7$var$A({
                from: _$t1
            }, e1) : {
                from: e1
            };
        }
    }(n1), function(t1) {
        var e = t1.directives;
        if (e) for(var _$t in e){
            var _$n = e[_$t];
            $905dbd31c454eff7$var$i(_$n) && (e[_$t] = {
                bind: _$n,
                update: _$n
            });
        }
    }(n1), !n1._base && (n1.extends && (t1 = $905dbd31c454eff7$var$_o(t1, n1.extends, o)), n1.mixins)) for(var e1 = 0, r = n1.mixins.length; e1 < r; e1++)t1 = $905dbd31c454eff7$var$_o(t1, n1.mixins[e1], o);
    var r1 = {};
    var s;
    for(s in t1)c(s);
    for(s in n1)$905dbd31c454eff7$var$$(t1, s) || c(s);
    function c(e) {
        var s = $905dbd31c454eff7$var$po[e] || $905dbd31c454eff7$var$yo;
        r1[e] = s(t1[e], n1[e], o, e);
    }
    return r1;
}
function $905dbd31c454eff7$var$$o(t1, e, n1, o) {
    if ("string" != typeof n1) return;
    var r = t1[e];
    if ($905dbd31c454eff7$var$$(r, n1)) return r[n1];
    var s = $905dbd31c454eff7$var$x(n1);
    if ($905dbd31c454eff7$var$$(r, s)) return r[s];
    var i = $905dbd31c454eff7$var$C(s);
    if ($905dbd31c454eff7$var$$(r, i)) return r[i];
    return r[n1] || r[s] || r[i];
}
function $905dbd31c454eff7$var$bo(t1, e, n1, o) {
    var r = e[t1], s = !$905dbd31c454eff7$var$$(n1, t1);
    var c = n1[t1];
    var a = $905dbd31c454eff7$var$ko(Boolean, r.type);
    if (a > -1) {
        if (s && !$905dbd31c454eff7$var$$(r, "default")) c = !1;
        else if ("" === c || c === $905dbd31c454eff7$var$S(t1)) {
            var _$t = $905dbd31c454eff7$var$ko(String, r.type);
            (_$t < 0 || a < _$t) && (c = !0);
        }
    }
    if (void 0 === c) {
        c = function(t1, e, n1) {
            if (!$905dbd31c454eff7$var$$(e, "default")) return;
            var _$o = e.default;
            if (t1 && t1.$options.propsData && void 0 === t1.$options.propsData[n1] && void 0 !== t1._props[n1]) return t1._props[n1];
            return $905dbd31c454eff7$var$i(_$o) && "Function" !== $905dbd31c454eff7$var$xo(e.type) ? _$o.call(t1) : _$o;
        }(o, r, t1);
        var _$e = $905dbd31c454eff7$var$kt;
        $905dbd31c454eff7$var$St(!0), $905dbd31c454eff7$var$At(c), $905dbd31c454eff7$var$St(_$e);
    }
    return c;
}
var $905dbd31c454eff7$var$wo = /^\s*function (\w+)/;
function $905dbd31c454eff7$var$xo(t1) {
    var e = t1 && t1.toString().match($905dbd31c454eff7$var$wo);
    return e ? e[1] : "";
}
function $905dbd31c454eff7$var$Co(t1, e) {
    return $905dbd31c454eff7$var$xo(t1) === $905dbd31c454eff7$var$xo(e);
}
function $905dbd31c454eff7$var$ko(t1, n1) {
    if (!$905dbd31c454eff7$var$e(n1)) return $905dbd31c454eff7$var$Co(n1, t1) ? 0 : -1;
    for(var e1 = 0, o = n1.length; e1 < o; e1++)if ($905dbd31c454eff7$var$Co(n1[e1], t1)) return e1;
    return -1;
}
function $905dbd31c454eff7$var$So(t1) {
    this._init(t1);
}
function $905dbd31c454eff7$var$Oo(t1) {
    t1.cid = 0;
    var e = 1;
    t1.extend = function(t1) {
        t1 = t1 || {};
        var n1 = this, o = n1.cid, r = t1._Ctor || (t1._Ctor = {});
        if (r[o]) return r[o];
        var s = $905dbd31c454eff7$var$io(t1) || $905dbd31c454eff7$var$io(n1.options), i = function i(t1) {
            this._init(t1);
        };
        return (i.prototype = Object.create(n1.prototype)).constructor = i, i.cid = e++, i.options = $905dbd31c454eff7$var$_o(n1.options, t1), i.super = n1, i.options.props && function(t1) {
            var e = t1.options.props;
            for(var n1 in e)$905dbd31c454eff7$var$qn(t1.prototype, "_props", n1);
        }(i), i.options.computed && function(t1) {
            var e = t1.options.computed;
            for(var n1 in e)$905dbd31c454eff7$var$Gn(t1.prototype, n1, e[n1]);
        }(i), i.extend = n1.extend, i.mixin = n1.mixin, i.use = n1.use, $905dbd31c454eff7$var$F.forEach(function(t1) {
            i[t1] = n1[t1];
        }), s && (i.options.components[s] = i), i.superOptions = n1.options, i.extendOptions = t1, i.sealedOptions = $905dbd31c454eff7$var$A({}, i.options), r[o] = i, i;
    };
}
function $905dbd31c454eff7$var$To(t1) {
    return t1 && ($905dbd31c454eff7$var$io(t1.Ctor.options) || t1.tag);
}
function $905dbd31c454eff7$var$Ao(t1, n1) {
    var o;
    return $905dbd31c454eff7$var$e(t1) ? t1.indexOf(n1) > -1 : "string" == typeof t1 ? t1.split(",").indexOf(n1) > -1 : (o = t1, "[object RegExp]" === $905dbd31c454eff7$var$a.call(o) && t1.test(n1));
}
function $905dbd31c454eff7$var$jo(t1, e) {
    var n1 = t1.cache, o = t1.keys, r = t1._vnode, s = t1.$vnode;
    for(var _$t in n1){
        var s1 = n1[_$t];
        if (s1) {
            var i = s1.name;
            i && !e(i) && $905dbd31c454eff7$var$Eo(n1, _$t, o, r);
        }
    }
    s.componentOptions.children = void 0;
}
function $905dbd31c454eff7$var$Eo(t1, e, n1, o) {
    var r = t1[e];
    !r || o && r.tag === o.tag || r.componentInstance.$destroy(), t1[e] = null, $905dbd31c454eff7$var$y(n1, e);
}
!function(e) {
    e.prototype._init = function(e) {
        var n1 = this;
        n1._uid = $905dbd31c454eff7$var$eo++, n1._isVue = !0, n1.__v_skip = !0, n1._scope = new $905dbd31c454eff7$var$Ue(!0), n1._scope.parent = void 0, n1._scope._vm = !0, e && e._isComponent ? function(t1, e) {
            var n1 = t1.$options = Object.create(t1.constructor.options), o = e._parentVnode;
            n1.parent = e.parent, n1._parentVnode = o;
            var r = o.componentOptions;
            n1.propsData = r.propsData, n1._parentListeners = r.listeners, n1._renderChildren = r.children, n1._componentTag = r.tag, e.render && (n1.render = e.render, n1.staticRenderFns = e.staticRenderFns);
        }(n1, e) : n1.$options = $905dbd31c454eff7$var$_o($905dbd31c454eff7$var$no(n1.constructor), e || {}, n1), n1._renderProxy = n1, n1._self = n1, function(t1) {
            var _$e = t1.$options;
            var n1 = _$e.parent;
            if (n1 && !_$e.abstract) {
                for(; n1.$options.abstract && n1.$parent;)n1 = n1.$parent;
                n1.$children.push(t1);
            }
            t1.$parent = n1, t1.$root = n1 ? n1.$root : t1, t1.$children = [], t1.$refs = {}, t1._provided = n1 ? n1._provided : Object.create(null), t1._watcher = null, t1._inactive = null, t1._directInactive = !1, t1._isMounted = !1, t1._isDestroyed = !1, t1._isBeingDestroyed = !1;
        }(n1), function(t1) {
            t1._events = Object.create(null), t1._hasHookEvent = !1;
            var _$e = t1.$options._parentListeners;
            _$e && $905dbd31c454eff7$var$Be(t1, _$e);
        }(n1), function(e) {
            e._vnode = null, e._staticTrees = null;
            var n1 = e.$options, o = e.$vnode = n1._parentVnode, r = o && o.context;
            e.$slots = $905dbd31c454eff7$var$we(n1._renderChildren, r), e.$scopedSlots = o ? $905dbd31c454eff7$var$ke(e.$parent, o.data.scopedSlots, e.$slots) : $905dbd31c454eff7$var$t1, e._c = function(t1, n1, o, r) {
                return $905dbd31c454eff7$var$se(e, t1, n1, o, r, !1);
            }, e.$createElement = function(t1, n1, o, r) {
                return $905dbd31c454eff7$var$se(e, t1, n1, o, r, !0);
            };
            var s = o && o.data;
            $905dbd31c454eff7$var$jt(e, "$attrs", s && s.attrs || $905dbd31c454eff7$var$t1, null, !0), $905dbd31c454eff7$var$jt(e, "$listeners", n1._parentListeners || $905dbd31c454eff7$var$t1, null, !0);
        }(n1), $905dbd31c454eff7$var$Ze(n1, "beforeCreate", void 0, !1), function(t1) {
            var _$e = $905dbd31c454eff7$var$to(t1.$options.inject, t1);
            _$e && ($905dbd31c454eff7$var$St(!1), Object.keys(_$e).forEach(function(n1) {
                $905dbd31c454eff7$var$jt(t1, n1, _$e[n1]);
            }), $905dbd31c454eff7$var$St(!0));
        }(n1), $905dbd31c454eff7$var$Wn(n1), function(t1) {
            var _$e = t1.$options.provide;
            if (_$e) {
                var n1 = $905dbd31c454eff7$var$i(_$e) ? _$e.call(t1) : _$e;
                if (!$905dbd31c454eff7$var$c(n1)) return;
                var o = $905dbd31c454eff7$var$mn(t1), r = $905dbd31c454eff7$var$it ? Reflect.ownKeys(n1) : Object.keys(n1);
                for(var _$t = 0; _$t < r.length; _$t++){
                    var _$e1 = r[_$t];
                    Object.defineProperty(o, _$e1, Object.getOwnPropertyDescriptor(n1, _$e1));
                }
            }
        }(n1), $905dbd31c454eff7$var$Ze(n1, "created"), n1.$options.el && n1.$mount(n1.$options.el);
    };
}($905dbd31c454eff7$var$So), function(t1) {
    var e = {
        get: function get() {
            return this._data;
        }
    }, n1 = {
        get: function get() {
            return this._props;
        }
    };
    Object.defineProperty(t1.prototype, "$data", e), Object.defineProperty(t1.prototype, "$props", n1), t1.prototype.$set = $905dbd31c454eff7$var$Et, t1.prototype.$delete = $905dbd31c454eff7$var$Nt, t1.prototype.$watch = function(t1, e, n1) {
        var o = this;
        if ($905dbd31c454eff7$var$l(e)) return $905dbd31c454eff7$var$Qn(o, t1, e, n1);
        (n1 = n1 || {}).user = !0;
        var r = new $905dbd31c454eff7$var$Kn(o, t1, e, n1);
        if (n1.immediate) {
            var _$t = 'callback for immediate watcher "'.concat(r.expression, '"');
            $905dbd31c454eff7$var$_t(), $905dbd31c454eff7$var$vn(e, o, [
                r.value
            ], o, _$t), $905dbd31c454eff7$var$$t();
        }
        return function() {
            r.teardown();
        };
    };
}($905dbd31c454eff7$var$So), function(t1) {
    var n1 = /^hook:/;
    t1.prototype.$on = function(t1, o) {
        var r = this;
        if ($905dbd31c454eff7$var$e(t1)) for(var e1 = 0, n2 = t1.length; e1 < n2; e1++)r.$on(t1[e1], o);
        else (r._events[t1] || (r._events[t1] = [])).push(o), n1.test(t1) && (r._hasHookEvent = !0);
        return r;
    }, t1.prototype.$once = function(t1, e) {
        var n1 = this;
        function o() {
            n1.$off(t1, o), e.apply(n1, arguments);
        }
        return o.fn = e, n1.$on(t1, o), n1;
    }, t1.prototype.$off = function(t1, n1) {
        var o = this;
        if (!arguments.length) return o._events = Object.create(null), o;
        if ($905dbd31c454eff7$var$e(t1)) {
            for(var e1 = 0, r = t1.length; e1 < r; e1++)o.$off(t1[e1], n1);
            return o;
        }
        var r1 = o._events[t1];
        if (!r1) return o;
        if (!n1) return o._events[t1] = null, o;
        var s, i = r1.length;
        for(; i--;)if (s = r1[i], s === n1 || s.fn === n1) {
            r1.splice(i, 1);
            break;
        }
        return o;
    }, t1.prototype.$emit = function(t1) {
        var e = this;
        var n1 = e._events[t1];
        if (n1) {
            n1 = n1.length > 1 ? $905dbd31c454eff7$var$T(n1) : n1;
            var o = $905dbd31c454eff7$var$T(arguments, 1), r = 'event handler for "'.concat(t1, '"');
            for(var _$t = 0, s = n1.length; _$t < s; _$t++)$905dbd31c454eff7$var$vn(n1[_$t], e, o, e, r);
        }
        return e;
    };
}($905dbd31c454eff7$var$So), function(t1) {
    t1.prototype._update = function(t1, e) {
        var n1 = this, o = n1.$el, r = n1._vnode, s = $905dbd31c454eff7$var$Ke(n1);
        n1._vnode = t1, n1.$el = r ? n1.__patch__(r, t1) : n1.__patch__(n1.$el, t1, e, !1), s(), o && (o.__vue__ = null), n1.$el && (n1.$el.__vue__ = n1);
        var i = n1;
        for(; i && i.$vnode && i.$parent && i.$vnode === i.$parent._vnode;)i.$parent.$el = i.$el, i = i.$parent;
    }, t1.prototype.$forceUpdate = function() {
        var _$t = this;
        _$t._watcher && _$t._watcher.update();
    }, t1.prototype.$destroy = function() {
        var _$t = this;
        if (_$t._isBeingDestroyed) return;
        $905dbd31c454eff7$var$Ze(_$t, "beforeDestroy"), _$t._isBeingDestroyed = !0;
        var e = _$t.$parent;
        !e || e._isBeingDestroyed || _$t.$options.abstract || $905dbd31c454eff7$var$y(e.$children, _$t), _$t._scope.stop(), _$t._data.__ob__ && _$t._data.__ob__.vmCount--, _$t._isDestroyed = !0, _$t.__patch__(_$t._vnode, null), $905dbd31c454eff7$var$Ze(_$t, "destroyed"), _$t.$off(), _$t.$el && (_$t.$el.__vue__ = null), _$t.$vnode && (_$t.$vnode.parent = null);
    };
}($905dbd31c454eff7$var$So), function(t1) {
    $905dbd31c454eff7$var$be(t1.prototype), t1.prototype.$nextTick = function(t1) {
        return $905dbd31c454eff7$var$kn(t1, this);
    }, t1.prototype._render = function() {
        var _$t = this, _t_$options = _$t.$options, n1 = _t_$options.render, o = _t_$options._parentVnode;
        o && _$t._isMounted && (_$t.$scopedSlots = $905dbd31c454eff7$var$ke(_$t.$parent, o.data.scopedSlots, _$t.$slots, _$t.$scopedSlots), _$t._slotsProxy && $905dbd31c454eff7$var$Ee(_$t._slotsProxy, _$t.$scopedSlots)), _$t.$vnode = o;
        var r = $905dbd31c454eff7$var$at, s = $905dbd31c454eff7$var$Me;
        var i;
        try {
            $905dbd31c454eff7$var$lt(_$t), $905dbd31c454eff7$var$Me = _$t, i = n1.call(_$t._renderProxy, _$t.$createElement);
        } catch (e) {
            $905dbd31c454eff7$var$gn(e, _$t, "render"), i = _$t._vnode;
        } finally{
            $905dbd31c454eff7$var$Me = s, $905dbd31c454eff7$var$lt(r);
        }
        return $905dbd31c454eff7$var$e(i) && 1 === i.length && (i = i[0]), i instanceof $905dbd31c454eff7$var$ut || (i = $905dbd31c454eff7$var$ft()), i.parent = o, i;
    };
}($905dbd31c454eff7$var$So);
var $905dbd31c454eff7$var$No = [
    String,
    RegExp,
    Array
];
var $905dbd31c454eff7$var$Po = {
    KeepAlive: {
        name: "keep-alive",
        abstract: !0,
        props: {
            include: $905dbd31c454eff7$var$No,
            exclude: $905dbd31c454eff7$var$No,
            max: [
                String,
                Number
            ]
        },
        methods: {
            cacheVNode: function() {
                var _this = this, t1 = _this.cache, e = _this.keys, n1 = _this.vnodeToCache, o = _this.keyToCache;
                if (n1) {
                    var r = n1.tag, s = n1.componentInstance, i = n1.componentOptions;
                    t1[o] = {
                        name: $905dbd31c454eff7$var$To(i),
                        tag: r,
                        componentInstance: s
                    }, e.push(o), this.max && e.length > parseInt(this.max) && $905dbd31c454eff7$var$Eo(t1, e[0], e, this._vnode), this.vnodeToCache = null;
                }
            }
        },
        created: function() {
            this.cache = Object.create(null), this.keys = [];
        },
        destroyed: function() {
            for(var t1 in this.cache)$905dbd31c454eff7$var$Eo(this.cache, t1, this.keys);
        },
        mounted: function() {
            var _this = this;
            this.cacheVNode(), this.$watch("include", function(t1) {
                $905dbd31c454eff7$var$jo(_this, function(e) {
                    return $905dbd31c454eff7$var$Ao(t1, e);
                });
            }), this.$watch("exclude", function(t1) {
                $905dbd31c454eff7$var$jo(_this, function(e) {
                    return !$905dbd31c454eff7$var$Ao(t1, e);
                });
            });
        },
        updated: function() {
            this.cacheVNode();
        },
        render: function() {
            var t1 = this.$slots.default, e = $905dbd31c454eff7$var$Le(t1), n1 = e && e.componentOptions;
            if (n1) {
                var t2 = $905dbd31c454eff7$var$To(n1), _this = this, o = _this.include, r = _this.exclude;
                if (o && (!t2 || !$905dbd31c454eff7$var$Ao(o, t2)) || r && t2 && $905dbd31c454eff7$var$Ao(r, t2)) return e;
                var _this1 = this, s = _this1.cache, i = _this1.keys, c = null == e.key ? n1.Ctor.cid + (n1.tag ? "::".concat(n1.tag) : "") : e.key;
                s[c] ? (e.componentInstance = s[c].componentInstance, $905dbd31c454eff7$var$y(i, c), i.push(c)) : (this.vnodeToCache = e, this.keyToCache = c), e.data.keepAlive = !0;
            }
            return e || t1 && t1[0];
        }
    }
};
!function(t1) {
    var e = {
        get: function() {
            return $905dbd31c454eff7$var$B;
        }
    };
    Object.defineProperty(t1, "config", e), t1.util = {
        warn: $905dbd31c454eff7$var$fo,
        extend: $905dbd31c454eff7$var$A,
        mergeOptions: $905dbd31c454eff7$var$_o,
        defineReactive: $905dbd31c454eff7$var$jt
    }, t1.set = $905dbd31c454eff7$var$Et, t1.delete = $905dbd31c454eff7$var$Nt, t1.nextTick = $905dbd31c454eff7$var$kn, t1.observable = function(t1) {
        return $905dbd31c454eff7$var$At(t1), t1;
    }, t1.options = Object.create(null), $905dbd31c454eff7$var$F.forEach(function(e) {
        t1.options[e + "s"] = Object.create(null);
    }), t1.options._base = t1, $905dbd31c454eff7$var$A(t1.options.components, $905dbd31c454eff7$var$Po), function(t1) {
        t1.use = function(t1) {
            var e = this._installedPlugins || (this._installedPlugins = []);
            if (e.indexOf(t1) > -1) return this;
            var n1 = $905dbd31c454eff7$var$T(arguments, 1);
            return n1.unshift(this), $905dbd31c454eff7$var$i(t1.install) ? t1.install.apply(t1, n1) : $905dbd31c454eff7$var$i(t1) && t1.apply(null, n1), e.push(t1), this;
        };
    }(t1), function(t1) {
        t1.mixin = function(t1) {
            return this.options = $905dbd31c454eff7$var$_o(this.options, t1), this;
        };
    }(t1), $905dbd31c454eff7$var$Oo(t1), function(t1) {
        $905dbd31c454eff7$var$F.forEach(function(e) {
            t1[e] = function(t1, n1) {
                return n1 ? ("component" === e && $905dbd31c454eff7$var$l(n1) && (n1.name = n1.name || t1, n1 = this.options._base.extend(n1)), "directive" === e && $905dbd31c454eff7$var$i(n1) && (n1 = {
                    bind: n1,
                    update: n1
                }), this.options[e + "s"][t1] = n1, n1) : this.options[e + "s"][t1];
            };
        });
    }(t1);
}($905dbd31c454eff7$var$So), Object.defineProperty($905dbd31c454eff7$var$So.prototype, "$isServer", {
    get: $905dbd31c454eff7$var$ot
}), Object.defineProperty($905dbd31c454eff7$var$So.prototype, "$ssrContext", {
    get: function() {
        return this.$vnode && this.$vnode.ssrContext;
    }
}), Object.defineProperty($905dbd31c454eff7$var$So, "FunctionalRenderContext", {
    value: $905dbd31c454eff7$var$oo
}), $905dbd31c454eff7$var$So.version = $905dbd31c454eff7$var$Fn;
var $905dbd31c454eff7$var$Do = $905dbd31c454eff7$var$m("style,class"), $905dbd31c454eff7$var$Mo = $905dbd31c454eff7$var$m("input,textarea,option,select,progress"), $905dbd31c454eff7$var$Io = function(t1, e, n1) {
    return "value" === n1 && $905dbd31c454eff7$var$Mo(t1) && "button" !== e || "selected" === n1 && "option" === t1 || "checked" === n1 && "input" === t1 || "muted" === n1 && "video" === t1;
}, $905dbd31c454eff7$var$Lo = $905dbd31c454eff7$var$m("contenteditable,draggable,spellcheck"), $905dbd31c454eff7$var$Ro = $905dbd31c454eff7$var$m("events,caret,typing,plaintext-only"), $905dbd31c454eff7$var$Fo = function(t1, e) {
    return $905dbd31c454eff7$var$Vo(e) || "false" === e ? "false" : "contenteditable" === t1 && $905dbd31c454eff7$var$Ro(e) ? e : "true";
}, $905dbd31c454eff7$var$Ho = $905dbd31c454eff7$var$m("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"), $905dbd31c454eff7$var$Bo = "http://www.w3.org/1999/xlink", $905dbd31c454eff7$var$Uo = function(t1) {
    return ":" === t1.charAt(5) && "xlink" === t1.slice(0, 5);
}, $905dbd31c454eff7$var$zo = function(t1) {
    return $905dbd31c454eff7$var$Uo(t1) ? t1.slice(6, t1.length) : "";
}, $905dbd31c454eff7$var$Vo = function(t1) {
    return null == t1 || !1 === t1;
};
function $905dbd31c454eff7$var$Ko(t1) {
    var e = t1.data, n1 = t1, r = t1;
    for(; $905dbd31c454eff7$var$o(r.componentInstance);)r = r.componentInstance._vnode, r && r.data && (e = $905dbd31c454eff7$var$Jo(r.data, e));
    for(; $905dbd31c454eff7$var$o(n1 = n1.parent);)n1 && n1.data && (e = $905dbd31c454eff7$var$Jo(e, n1.data));
    return function(t1, e) {
        if ($905dbd31c454eff7$var$o(t1) || $905dbd31c454eff7$var$o(e)) return $905dbd31c454eff7$var$qo(t1, $905dbd31c454eff7$var$Wo(e));
        return "";
    }(e.staticClass, e.class);
}
function $905dbd31c454eff7$var$Jo(t1, e) {
    return {
        staticClass: $905dbd31c454eff7$var$qo(t1.staticClass, e.staticClass),
        class: $905dbd31c454eff7$var$o(t1.class) ? [
            t1.class,
            e.class
        ] : e.class
    };
}
function $905dbd31c454eff7$var$qo(t1, e) {
    return t1 ? e ? t1 + " " + e : t1 : e || "";
}
function $905dbd31c454eff7$var$Wo(t1) {
    return Array.isArray(t1) ? function(t1) {
        var e, n1 = "";
        for(var r = 0, s = t1.length; r < s; r++)$905dbd31c454eff7$var$o(e = $905dbd31c454eff7$var$Wo(t1[r])) && "" !== e && (n1 && (n1 += " "), n1 += e);
        return n1;
    }(t1) : $905dbd31c454eff7$var$c(t1) ? function(t1) {
        var e = "";
        for(var n1 in t1)t1[n1] && (e && (e += " "), e += n1);
        return e;
    }(t1) : "string" == typeof t1 ? t1 : "";
}
var $905dbd31c454eff7$var$Zo = {
    svg: "http://www.w3.org/2000/svg",
    math: "http://www.w3.org/1998/Math/MathML"
}, $905dbd31c454eff7$var$Go = $905dbd31c454eff7$var$m("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"), $905dbd31c454eff7$var$Xo = $905dbd31c454eff7$var$m("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0), $905dbd31c454eff7$var$Yo = function(t1) {
    return $905dbd31c454eff7$var$Go(t1) || $905dbd31c454eff7$var$Xo(t1);
};
function $905dbd31c454eff7$var$Qo(t1) {
    return $905dbd31c454eff7$var$Xo(t1) ? "svg" : "math" === t1 ? "math" : void 0;
}
var $905dbd31c454eff7$var$tr = Object.create(null);
var $905dbd31c454eff7$var$er = $905dbd31c454eff7$var$m("text,number,password,search,email,tel,url");
function $905dbd31c454eff7$var$nr(t1) {
    if ("string" == typeof t1) {
        var e = document.querySelector(t1);
        return e || document.createElement("div");
    }
    return t1;
}
var $905dbd31c454eff7$var$or = Object.freeze({
    __proto__: null,
    createElement: function createElement(t1, e) {
        var n1 = document.createElement(t1);
        return "select" !== t1 || e.data && e.data.attrs && void 0 !== e.data.attrs.multiple && n1.setAttribute("multiple", "multiple"), n1;
    },
    createElementNS: function createElementNS(t1, e) {
        return document.createElementNS($905dbd31c454eff7$var$Zo[t1], e);
    },
    createTextNode: function createTextNode(t1) {
        return document.createTextNode(t1);
    },
    createComment: function createComment(t1) {
        return document.createComment(t1);
    },
    insertBefore: function insertBefore(t1, e, n1) {
        t1.insertBefore(e, n1);
    },
    removeChild: function removeChild(t1, e) {
        t1.removeChild(e);
    },
    appendChild: function appendChild(t1, e) {
        t1.appendChild(e);
    },
    parentNode: function parentNode(t1) {
        return t1.parentNode;
    },
    nextSibling: function nextSibling(t1) {
        return t1.nextSibling;
    },
    tagName: function tagName(t1) {
        return t1.tagName;
    },
    setTextContent: function setTextContent(t1, e) {
        t1.textContent = e;
    },
    setStyleScope: function setStyleScope(t1, e) {
        t1.setAttribute(e, "");
    }
}), $905dbd31c454eff7$var$rr = {
    create: function(t1, e) {
        $905dbd31c454eff7$var$sr(e);
    },
    update: function(t1, e) {
        t1.data.ref !== e.data.ref && ($905dbd31c454eff7$var$sr(t1, !0), $905dbd31c454eff7$var$sr(e));
    },
    destroy: function(t1) {
        $905dbd31c454eff7$var$sr(t1, !0);
    }
};
function $905dbd31c454eff7$var$sr(t1, n1) {
    var r = t1.data.ref;
    if (!$905dbd31c454eff7$var$o(r)) return;
    var s = t1.context, c = t1.componentInstance || t1.elm, a = n1 ? null : c, l = n1 ? void 0 : c;
    if ($905dbd31c454eff7$var$i(r)) return void $905dbd31c454eff7$var$vn(r, s, [
        a
    ], s, "template ref function");
    var u = t1.data.refInFor, f = "string" == typeof r || "number" == typeof r, d = $905dbd31c454eff7$var$Ht(r), p = s.$refs;
    if (f || d) {
        if (u) {
            var _$t = f ? p[r] : r.value;
            n1 ? $905dbd31c454eff7$var$e(_$t) && $905dbd31c454eff7$var$y(_$t, c) : $905dbd31c454eff7$var$e(_$t) ? _$t.includes(c) || _$t.push(c) : f ? (p[r] = [
                c
            ], $905dbd31c454eff7$var$ir(s, r, p[r])) : r.value = [
                c
            ];
        } else if (f) {
            if (n1 && p[r] !== c) return;
            p[r] = l, $905dbd31c454eff7$var$ir(s, r, a);
        } else if (d) {
            if (n1 && r.value !== c) return;
            r.value = a;
        }
    }
}
function $905dbd31c454eff7$var$ir(param, e, n1) {
    var t1 = param._setupState;
    t1 && $905dbd31c454eff7$var$$(t1, e) && ($905dbd31c454eff7$var$Ht(t1[e]) ? t1[e].value = n1 : t1[e] = n1);
}
var $905dbd31c454eff7$var$cr = new $905dbd31c454eff7$var$ut("", {}, []), $905dbd31c454eff7$var$ar = [
    "create",
    "activate",
    "update",
    "remove",
    "destroy"
];
function $905dbd31c454eff7$var$lr(t1, e) {
    return t1.key === e.key && t1.asyncFactory === e.asyncFactory && (t1.tag === e.tag && t1.isComment === e.isComment && $905dbd31c454eff7$var$o(t1.data) === $905dbd31c454eff7$var$o(e.data) && function(t1, e) {
        if ("input" !== t1.tag) return !0;
        var _$n;
        var _$r = $905dbd31c454eff7$var$o(_$n = t1.data) && $905dbd31c454eff7$var$o(_$n = _$n.attrs) && _$n.type, s = $905dbd31c454eff7$var$o(_$n = e.data) && $905dbd31c454eff7$var$o(_$n = _$n.attrs) && _$n.type;
        return _$r === s || $905dbd31c454eff7$var$er(_$r) && $905dbd31c454eff7$var$er(s);
    }(t1, e) || $905dbd31c454eff7$var$r(t1.isAsyncPlaceholder) && $905dbd31c454eff7$var$n1(e.asyncFactory.error));
}
function $905dbd31c454eff7$var$ur(t1, e, n1) {
    var r, s;
    var i = {};
    for(r = e; r <= n1; ++r)s = t1[r].key, $905dbd31c454eff7$var$o(s) && (i[s] = r);
    return i;
}
var $905dbd31c454eff7$var$fr = {
    create: $905dbd31c454eff7$var$dr,
    update: $905dbd31c454eff7$var$dr,
    destroy: function destroy(t1) {
        $905dbd31c454eff7$var$dr(t1, $905dbd31c454eff7$var$cr);
    }
};
function $905dbd31c454eff7$var$dr(t1, e) {
    (t1.data.directives || e.data.directives) && function(t1, e) {
        var n1 = t1 === $905dbd31c454eff7$var$cr, o = e === $905dbd31c454eff7$var$cr, r = $905dbd31c454eff7$var$hr(t1.data.directives, t1.context), s = $905dbd31c454eff7$var$hr(e.data.directives, e.context), i = [], c = [];
        var a, l, u;
        for(a in s)l = r[a], u = s[a], l ? (u.oldValue = l.value, u.oldArg = l.arg, $905dbd31c454eff7$var$gr(u, "update", e, t1), u.def && u.def.componentUpdated && c.push(u)) : ($905dbd31c454eff7$var$gr(u, "bind", e, t1), u.def && u.def.inserted && i.push(u));
        if (i.length) {
            var o1 = function() {
                for(var n1 = 0; n1 < i.length; n1++)$905dbd31c454eff7$var$gr(i[n1], "inserted", e, t1);
            };
            n1 ? $905dbd31c454eff7$var$Yt(e, "insert", o1) : o1();
        }
        c.length && $905dbd31c454eff7$var$Yt(e, "postpatch", function() {
            for(var n1 = 0; n1 < c.length; n1++)$905dbd31c454eff7$var$gr(c[n1], "componentUpdated", e, t1);
        });
        if (!n1) for(a in r)s[a] || $905dbd31c454eff7$var$gr(r[a], "unbind", t1, t1, o);
    }(t1, e);
}
var $905dbd31c454eff7$var$pr = Object.create(null);
function $905dbd31c454eff7$var$hr(t1, e) {
    var n1 = Object.create(null);
    if (!t1) return n1;
    var o, r;
    for(o = 0; o < t1.length; o++){
        if (r = t1[o], r.modifiers || (r.modifiers = $905dbd31c454eff7$var$pr), n1[$905dbd31c454eff7$var$mr(r)] = r, e._setupState && e._setupState.__sfc) {
            var _$t = r.def || $905dbd31c454eff7$var$$o(e, "_setupState", "v-" + r.name);
            r.def = "function" == typeof _$t ? {
                bind: _$t,
                update: _$t
            } : _$t;
        }
        r.def = r.def || $905dbd31c454eff7$var$$o(e.$options, "directives", r.name);
    }
    return n1;
}
function $905dbd31c454eff7$var$mr(t1) {
    return t1.rawName || "".concat(t1.name, ".").concat(Object.keys(t1.modifiers || {}).join("."));
}
function $905dbd31c454eff7$var$gr(t1, e, n1, o, r) {
    var s = t1.def && t1.def[e];
    if (s) try {
        s(n1.elm, t1, n1, o, r);
    } catch (o) {
        $905dbd31c454eff7$var$gn(o, n1.context, "directive ".concat(t1.name, " ").concat(e, " hook"));
    }
}
var $905dbd31c454eff7$var$vr = [
    $905dbd31c454eff7$var$rr,
    $905dbd31c454eff7$var$fr
];
function $905dbd31c454eff7$var$yr(t1, e) {
    var s = e.componentOptions;
    if ($905dbd31c454eff7$var$o(s) && !1 === s.Ctor.options.inheritAttrs) return;
    if ($905dbd31c454eff7$var$n1(t1.data.attrs) && $905dbd31c454eff7$var$n1(e.data.attrs)) return;
    var i, c, a;
    var l = e.elm, u = t1.data.attrs || {};
    var f = e.data.attrs || {};
    for(i in ($905dbd31c454eff7$var$o(f.__ob__) || $905dbd31c454eff7$var$r(f._v_attr_proxy)) && (f = e.data.attrs = $905dbd31c454eff7$var$A({}, f)), f)c = f[i], a = u[i], a !== c && $905dbd31c454eff7$var$_r(l, i, c, e.data.pre);
    for(i in ($905dbd31c454eff7$var$Z || $905dbd31c454eff7$var$X) && f.value !== u.value && $905dbd31c454eff7$var$_r(l, "value", f.value), u)$905dbd31c454eff7$var$n1(f[i]) && ($905dbd31c454eff7$var$Uo(i) ? l.removeAttributeNS($905dbd31c454eff7$var$Bo, $905dbd31c454eff7$var$zo(i)) : $905dbd31c454eff7$var$Lo(i) || l.removeAttribute(i));
}
function $905dbd31c454eff7$var$_r(t1, e, n1, o) {
    o || t1.tagName.indexOf("-") > -1 ? $905dbd31c454eff7$var$$r(t1, e, n1) : $905dbd31c454eff7$var$Ho(e) ? $905dbd31c454eff7$var$Vo(n1) ? t1.removeAttribute(e) : (n1 = "allowfullscreen" === e && "EMBED" === t1.tagName ? "true" : e, t1.setAttribute(e, n1)) : $905dbd31c454eff7$var$Lo(e) ? t1.setAttribute(e, $905dbd31c454eff7$var$Fo(e, n1)) : $905dbd31c454eff7$var$Uo(e) ? $905dbd31c454eff7$var$Vo(n1) ? t1.removeAttributeNS($905dbd31c454eff7$var$Bo, $905dbd31c454eff7$var$zo(e)) : t1.setAttributeNS($905dbd31c454eff7$var$Bo, e, n1) : $905dbd31c454eff7$var$$r(t1, e, n1);
}
function $905dbd31c454eff7$var$$r(t1, e, n1) {
    if ($905dbd31c454eff7$var$Vo(n1)) t1.removeAttribute(e);
    else {
        if ($905dbd31c454eff7$var$Z && !$905dbd31c454eff7$var$G && "TEXTAREA" === t1.tagName && "placeholder" === e && "" !== n1 && !t1.__ieph) {
            var _$e = function(n1) {
                n1.stopImmediatePropagation(), t1.removeEventListener("input", _$e);
            };
            t1.addEventListener("input", _$e), t1.__ieph = !0;
        }
        t1.setAttribute(e, n1);
    }
}
var $905dbd31c454eff7$var$br = {
    create: $905dbd31c454eff7$var$yr,
    update: $905dbd31c454eff7$var$yr
};
function $905dbd31c454eff7$var$wr(t1, e) {
    var r = e.elm, s = e.data, i = t1.data;
    if ($905dbd31c454eff7$var$n1(s.staticClass) && $905dbd31c454eff7$var$n1(s.class) && ($905dbd31c454eff7$var$n1(i) || $905dbd31c454eff7$var$n1(i.staticClass) && $905dbd31c454eff7$var$n1(i.class))) return;
    var c = $905dbd31c454eff7$var$Ko(e);
    var a = r._transitionClasses;
    $905dbd31c454eff7$var$o(a) && (c = $905dbd31c454eff7$var$qo(c, $905dbd31c454eff7$var$Wo(a))), c !== r._prevClass && (r.setAttribute("class", c), r._prevClass = c);
}
var $905dbd31c454eff7$var$xr = {
    create: $905dbd31c454eff7$var$wr,
    update: $905dbd31c454eff7$var$wr
};
var $905dbd31c454eff7$var$Cr = /[\w).+\-_$\]]/;
function $905dbd31c454eff7$var$kr(t1) {
    var e, n1, o, r, s, i = !1, c = !1, a = !1, l = !1, u = 0, f = 0, d = 0, p = 0;
    for(o = 0; o < t1.length; o++)if (n1 = e, e = t1.charCodeAt(o), i) 39 === e && 92 !== n1 && (i = !1);
    else if (c) 34 === e && 92 !== n1 && (c = !1);
    else if (a) 96 === e && 92 !== n1 && (a = !1);
    else if (l) 47 === e && 92 !== n1 && (l = !1);
    else if (124 !== e || 124 === t1.charCodeAt(o + 1) || 124 === t1.charCodeAt(o - 1) || u || f || d) {
        switch(e){
            case 34:
                c = !0;
                break;
            case 39:
                i = !0;
                break;
            case 96:
                a = !0;
                break;
            case 40:
                d++;
                break;
            case 41:
                d--;
                break;
            case 91:
                f++;
                break;
            case 93:
                f--;
                break;
            case 123:
                u++;
                break;
            case 125:
                u--;
        }
        if (47 === e) {
            var e1 = void 0, n2 = o - 1;
            for(; n2 >= 0 && (e1 = t1.charAt(n2), " " === e1); n2--);
            e1 && $905dbd31c454eff7$var$Cr.test(e1) || (l = !0);
        }
    } else void 0 === r ? (p = o + 1, r = t1.slice(0, o).trim()) : h();
    function h() {
        (s || (s = [])).push(t1.slice(p, o).trim()), p = o + 1;
    }
    if (void 0 === r ? r = t1.slice(0, o).trim() : 0 !== p && h(), s) for(o = 0; o < s.length; o++)r = $905dbd31c454eff7$var$Sr(r, s[o]);
    return r;
}
function $905dbd31c454eff7$var$Sr(t1, e) {
    var n1 = e.indexOf("(");
    if (n1 < 0) return '_f("'.concat(e, '")(').concat(t1, ")");
    {
        var o = e.slice(0, n1), r = e.slice(n1 + 1);
        return '_f("'.concat(o, '")(').concat(t1).concat(")" !== r ? "," + r : r);
    }
}
function $905dbd31c454eff7$var$Or(t1, e) {
    console.error("[Vue compiler]: ".concat(t1));
}
function $905dbd31c454eff7$var$Tr(t1, e) {
    return t1 ? t1.map(function(t1) {
        return t1[e];
    }).filter(function(t1) {
        return t1;
    }) : [];
}
function $905dbd31c454eff7$var$Ar(t1, e, n1, o, r) {
    (t1.props || (t1.props = [])).push($905dbd31c454eff7$var$Rr({
        name: e,
        value: n1,
        dynamic: r
    }, o)), t1.plain = !1;
}
function $905dbd31c454eff7$var$jr(t1, e, n1, o, r) {
    (r ? t1.dynamicAttrs || (t1.dynamicAttrs = []) : t1.attrs || (t1.attrs = [])).push($905dbd31c454eff7$var$Rr({
        name: e,
        value: n1,
        dynamic: r
    }, o)), t1.plain = !1;
}
function $905dbd31c454eff7$var$Er(t1, e, n1, o) {
    t1.attrsMap[e] = n1, t1.attrsList.push($905dbd31c454eff7$var$Rr({
        name: e,
        value: n1
    }, o));
}
function $905dbd31c454eff7$var$Nr(t1, e, n1, o, r, s, i, c) {
    (t1.directives || (t1.directives = [])).push($905dbd31c454eff7$var$Rr({
        name: e,
        rawName: n1,
        value: o,
        arg: r,
        isDynamicArg: s,
        modifiers: i
    }, c)), t1.plain = !1;
}
function $905dbd31c454eff7$var$Pr(t1, e, n1) {
    return n1 ? "_p(".concat(e, ',"').concat(t1, '")') : t1 + e;
}
function $905dbd31c454eff7$var$Dr(e, n1, o, r, s, i, c, a) {
    var l;
    (r = r || $905dbd31c454eff7$var$t1).right ? a ? n1 = "(".concat(n1, ")==='click'?'contextmenu':(").concat(n1, ")") : "click" === n1 && (n1 = "contextmenu", delete r.right) : r.middle && (a ? n1 = "(".concat(n1, ")==='click'?'mouseup':(").concat(n1, ")") : "click" === n1 && (n1 = "mouseup")), r.capture && (delete r.capture, n1 = $905dbd31c454eff7$var$Pr("!", n1, a)), r.once && (delete r.once, n1 = $905dbd31c454eff7$var$Pr("~", n1, a)), r.passive && (delete r.passive, n1 = $905dbd31c454eff7$var$Pr("&", n1, a)), r.native ? (delete r.native, l = e.nativeEvents || (e.nativeEvents = {})) : l = e.events || (e.events = {});
    var u = $905dbd31c454eff7$var$Rr({
        value: o.trim(),
        dynamic: a
    }, c);
    r !== $905dbd31c454eff7$var$t1 && (u.modifiers = r);
    var f = l[n1];
    Array.isArray(f) ? s ? f.unshift(u) : f.push(u) : l[n1] = f ? s ? [
        u,
        f
    ] : [
        f,
        u
    ] : u, e.plain = !1;
}
function $905dbd31c454eff7$var$Mr(t1, e, n1) {
    var o = $905dbd31c454eff7$var$Ir(t1, ":" + e) || $905dbd31c454eff7$var$Ir(t1, "v-bind:" + e);
    if (null != o) return $905dbd31c454eff7$var$kr(o);
    if (!1 !== n1) {
        var _$n = $905dbd31c454eff7$var$Ir(t1, e);
        if (null != _$n) return JSON.stringify(_$n);
    }
}
function $905dbd31c454eff7$var$Ir(t1, e, n1) {
    var o;
    if (null != (o = t1.attrsMap[e])) {
        var _$n = t1.attrsList;
        for(var _$t = 0, o1 = _$n.length; _$t < o1; _$t++)if (_$n[_$t].name === e) {
            _$n.splice(_$t, 1);
            break;
        }
    }
    return n1 && delete t1.attrsMap[e], o;
}
function $905dbd31c454eff7$var$Lr(t1, e) {
    var n1 = t1.attrsList;
    for(var _$t = 0, o = n1.length; _$t < o; _$t++){
        var o1 = n1[_$t];
        if (e.test(o1.name)) return n1.splice(_$t, 1), o1;
    }
}
function $905dbd31c454eff7$var$Rr(t1, e) {
    return e && (null != e.start && (t1.start = e.start), null != e.end && (t1.end = e.end)), t1;
}
function $905dbd31c454eff7$var$Fr(t1, e, n1) {
    var _ref = n1 || {}, o = _ref.number, r = _ref.trim, s = "$$v";
    var i = s;
    r && (i = "(typeof ".concat(s, " === 'string'? ").concat(s, ".trim(): ").concat(s, ")")), o && (i = "_n(".concat(i, ")"));
    var c = $905dbd31c454eff7$var$Hr(e, i);
    t1.model = {
        value: "(".concat(e, ")"),
        expression: JSON.stringify(e),
        callback: "function (".concat(s, ") {").concat(c, "}")
    };
}
function $905dbd31c454eff7$var$Hr(t1, e) {
    var n1 = function(t1) {
        if (t1 = t1.trim(), $905dbd31c454eff7$var$Br = t1.length, t1.indexOf("[") < 0 || t1.lastIndexOf("]") < $905dbd31c454eff7$var$Br - 1) return $905dbd31c454eff7$var$Vr = t1.lastIndexOf("."), $905dbd31c454eff7$var$Vr > -1 ? {
            exp: t1.slice(0, $905dbd31c454eff7$var$Vr),
            key: '"' + t1.slice($905dbd31c454eff7$var$Vr + 1) + '"'
        } : {
            exp: t1,
            key: null
        };
        $905dbd31c454eff7$var$Ur = t1, $905dbd31c454eff7$var$Vr = $905dbd31c454eff7$var$Kr = $905dbd31c454eff7$var$Jr = 0;
        for(; !$905dbd31c454eff7$var$Wr();)$905dbd31c454eff7$var$zr = $905dbd31c454eff7$var$qr(), $905dbd31c454eff7$var$Zr($905dbd31c454eff7$var$zr) ? $905dbd31c454eff7$var$Xr($905dbd31c454eff7$var$zr) : 91 === $905dbd31c454eff7$var$zr && $905dbd31c454eff7$var$Gr($905dbd31c454eff7$var$zr);
        return {
            exp: t1.slice(0, $905dbd31c454eff7$var$Kr),
            key: t1.slice($905dbd31c454eff7$var$Kr + 1, $905dbd31c454eff7$var$Jr)
        };
    }(t1);
    return null === n1.key ? "".concat(t1, "=").concat(e) : "$set(".concat(n1.exp, ", ").concat(n1.key, ", ").concat(e, ")");
}
var $905dbd31c454eff7$var$Br, $905dbd31c454eff7$var$Ur, $905dbd31c454eff7$var$zr, $905dbd31c454eff7$var$Vr, $905dbd31c454eff7$var$Kr, $905dbd31c454eff7$var$Jr;
function $905dbd31c454eff7$var$qr() {
    return $905dbd31c454eff7$var$Ur.charCodeAt(++$905dbd31c454eff7$var$Vr);
}
function $905dbd31c454eff7$var$Wr() {
    return $905dbd31c454eff7$var$Vr >= $905dbd31c454eff7$var$Br;
}
function $905dbd31c454eff7$var$Zr(t1) {
    return 34 === t1 || 39 === t1;
}
function $905dbd31c454eff7$var$Gr(t1) {
    var e = 1;
    for($905dbd31c454eff7$var$Kr = $905dbd31c454eff7$var$Vr; !$905dbd31c454eff7$var$Wr();)if ($905dbd31c454eff7$var$Zr(t1 = $905dbd31c454eff7$var$qr())) $905dbd31c454eff7$var$Xr(t1);
    else if (91 === t1 && e++, 93 === t1 && e--, 0 === e) {
        $905dbd31c454eff7$var$Jr = $905dbd31c454eff7$var$Vr;
        break;
    }
}
function $905dbd31c454eff7$var$Xr(t1) {
    var e = t1;
    for(; !$905dbd31c454eff7$var$Wr() && (t1 = $905dbd31c454eff7$var$qr()) !== e;);
}
var $905dbd31c454eff7$var$Yr = "__r", $905dbd31c454eff7$var$Qr = "__c";
var $905dbd31c454eff7$var$ts;
function $905dbd31c454eff7$var$es(t1, e, n1) {
    var o = $905dbd31c454eff7$var$ts;
    return function r() {
        null !== e.apply(null, arguments) && $905dbd31c454eff7$var$rs(t1, r, n1, o);
    };
}
var $905dbd31c454eff7$var$ns = $905dbd31c454eff7$var$$n && !($905dbd31c454eff7$var$Q && Number($905dbd31c454eff7$var$Q[1]) <= 53);
function $905dbd31c454eff7$var$os(t1, e, n1, o) {
    if ($905dbd31c454eff7$var$ns) {
        var _$t = $905dbd31c454eff7$var$nn, _$n = e;
        e = _$n._wrapper = function e(_e) {
            if (_e.target === _e.currentTarget || _e.timeStamp >= _$t || _e.timeStamp <= 0 || _e.target.ownerDocument !== document) return _$n.apply(this, arguments);
        };
    }
    $905dbd31c454eff7$var$ts.addEventListener(t1, e, $905dbd31c454eff7$var$nt ? {
        capture: n1,
        passive: o
    } : n1);
}
function $905dbd31c454eff7$var$rs(t1, e, n1, o) {
    (o || $905dbd31c454eff7$var$ts).removeEventListener(t1, e._wrapper || e, n1);
}
function $905dbd31c454eff7$var$ss(t1, e) {
    if ($905dbd31c454eff7$var$n1(t1.data.on) && $905dbd31c454eff7$var$n1(e.data.on)) return;
    var r = e.data.on || {}, s = t1.data.on || {};
    $905dbd31c454eff7$var$ts = e.elm || t1.elm, function(t1) {
        if ($905dbd31c454eff7$var$o(t1[$905dbd31c454eff7$var$Yr])) {
            var _$e = $905dbd31c454eff7$var$Z ? "change" : "input";
            t1[_$e] = [].concat(t1[$905dbd31c454eff7$var$Yr], t1[_$e] || []), delete t1[$905dbd31c454eff7$var$Yr];
        }
        $905dbd31c454eff7$var$o(t1[$905dbd31c454eff7$var$Qr]) && (t1.change = [].concat(t1[$905dbd31c454eff7$var$Qr], t1.change || []), delete t1[$905dbd31c454eff7$var$Qr]);
    }(r), $905dbd31c454eff7$var$Xt(r, s, $905dbd31c454eff7$var$os, $905dbd31c454eff7$var$rs, $905dbd31c454eff7$var$es, e.context), $905dbd31c454eff7$var$ts = void 0;
}
var $905dbd31c454eff7$var$is = {
    create: $905dbd31c454eff7$var$ss,
    update: $905dbd31c454eff7$var$ss,
    destroy: function(t1) {
        return $905dbd31c454eff7$var$ss(t1, $905dbd31c454eff7$var$cr);
    }
};
var $905dbd31c454eff7$var$cs;
function $905dbd31c454eff7$var$as(t1, e) {
    if ($905dbd31c454eff7$var$n1(t1.data.domProps) && $905dbd31c454eff7$var$n1(e.data.domProps)) return;
    var s, i;
    var c = e.elm, a = t1.data.domProps || {};
    var l = e.data.domProps || {};
    for(s in ($905dbd31c454eff7$var$o(l.__ob__) || $905dbd31c454eff7$var$r(l._v_attr_proxy)) && (l = e.data.domProps = $905dbd31c454eff7$var$A({}, l)), a)s in l || (c[s] = "");
    for(s in l){
        if (i = l[s], "textContent" === s || "innerHTML" === s) {
            if (e.children && (e.children.length = 0), i === a[s]) continue;
            1 === c.childNodes.length && c.removeChild(c.childNodes[0]);
        }
        if ("value" === s && "PROGRESS" !== c.tagName) {
            c._value = i;
            var _$t = $905dbd31c454eff7$var$n1(i) ? "" : String(i);
            $905dbd31c454eff7$var$ls(c, _$t) && (c.value = _$t);
        } else if ("innerHTML" === s && $905dbd31c454eff7$var$Xo(c.tagName) && $905dbd31c454eff7$var$n1(c.innerHTML)) {
            $905dbd31c454eff7$var$cs = $905dbd31c454eff7$var$cs || document.createElement("div"), $905dbd31c454eff7$var$cs.innerHTML = "<svg>".concat(i, "</svg>");
            var _$t1 = $905dbd31c454eff7$var$cs.firstChild;
            for(; c.firstChild;)c.removeChild(c.firstChild);
            for(; _$t1.firstChild;)c.appendChild(_$t1.firstChild);
        } else if (i !== a[s]) try {
            c[s] = i;
        } catch (t1) {}
    }
}
function $905dbd31c454eff7$var$ls(t1, e) {
    return !t1.composing && ("OPTION" === t1.tagName || function(t1, e) {
        var n1 = !0;
        try {
            n1 = document.activeElement !== t1;
        } catch (t1) {}
        return n1 && t1.value !== e;
    }(t1, e) || function(t1, e) {
        var n1 = t1.value, r = t1._vModifiers;
        if ($905dbd31c454eff7$var$o(r)) {
            if (r.number) return $905dbd31c454eff7$var$h(n1) !== $905dbd31c454eff7$var$h(e);
            if (r.trim) return n1.trim() !== e.trim();
        }
        return n1 !== e;
    }(t1, e));
}
var $905dbd31c454eff7$var$us = {
    create: $905dbd31c454eff7$var$as,
    update: $905dbd31c454eff7$var$as
};
var $905dbd31c454eff7$var$fs = $905dbd31c454eff7$var$b(function(t1) {
    var e = {}, n1 = /:(.+)/;
    return t1.split(/;(?![^(]*\))/g).forEach(function(t1) {
        if (t1) {
            var o = t1.split(n1);
            o.length > 1 && (e[o[0].trim()] = o[1].trim());
        }
    }), e;
});
function $905dbd31c454eff7$var$ds(t1) {
    var e = $905dbd31c454eff7$var$ps(t1.style);
    return t1.staticStyle ? $905dbd31c454eff7$var$A(t1.staticStyle, e) : e;
}
function $905dbd31c454eff7$var$ps(t1) {
    return Array.isArray(t1) ? $905dbd31c454eff7$var$j(t1) : "string" == typeof t1 ? $905dbd31c454eff7$var$fs(t1) : t1;
}
var $905dbd31c454eff7$var$hs = /^--/, $905dbd31c454eff7$var$ms = /\s*!important$/, $905dbd31c454eff7$var$gs = function(t1, e, n1) {
    if ($905dbd31c454eff7$var$hs.test(e)) t1.style.setProperty(e, n1);
    else if ($905dbd31c454eff7$var$ms.test(n1)) t1.style.setProperty($905dbd31c454eff7$var$S(e), n1.replace($905dbd31c454eff7$var$ms, ""), "important");
    else {
        var o = $905dbd31c454eff7$var$_s(e);
        if (Array.isArray(n1)) for(var _$e = 0, r = n1.length; _$e < r; _$e++)t1.style[o] = n1[_$e];
        else t1.style[o] = n1;
    }
}, $905dbd31c454eff7$var$vs = [
    "Webkit",
    "Moz",
    "ms"
];
var $905dbd31c454eff7$var$ys;
var $905dbd31c454eff7$var$_s = $905dbd31c454eff7$var$b(function(t1) {
    if ($905dbd31c454eff7$var$ys = $905dbd31c454eff7$var$ys || document.createElement("div").style, "filter" !== (t1 = $905dbd31c454eff7$var$x(t1)) && t1 in $905dbd31c454eff7$var$ys) return t1;
    var e = t1.charAt(0).toUpperCase() + t1.slice(1);
    for(var _$t = 0; _$t < $905dbd31c454eff7$var$vs.length; _$t++){
        var n1 = $905dbd31c454eff7$var$vs[_$t] + e;
        if (n1 in $905dbd31c454eff7$var$ys) return n1;
    }
});
function $905dbd31c454eff7$var$$s(t1, e) {
    var r = e.data, s = t1.data;
    if ($905dbd31c454eff7$var$n1(r.staticStyle) && $905dbd31c454eff7$var$n1(r.style) && $905dbd31c454eff7$var$n1(s.staticStyle) && $905dbd31c454eff7$var$n1(s.style)) return;
    var i, c;
    var a = e.elm, l = s.staticStyle, u = s.normalizedStyle || s.style || {}, f = l || u, d = $905dbd31c454eff7$var$ps(e.data.style) || {};
    e.data.normalizedStyle = $905dbd31c454eff7$var$o(d.__ob__) ? $905dbd31c454eff7$var$A({}, d) : d;
    var p = function(t1, e) {
        var _$n = {};
        var _$o;
        if (e) {
            var _$e = t1;
            for(; _$e.componentInstance;)_$e = _$e.componentInstance._vnode, _$e && _$e.data && (_$o = $905dbd31c454eff7$var$ds(_$e.data)) && $905dbd31c454eff7$var$A(_$n, _$o);
        }
        (_$o = $905dbd31c454eff7$var$ds(t1.data)) && $905dbd31c454eff7$var$A(_$n, _$o);
        var r = t1;
        for(; r = r.parent;)r.data && (_$o = $905dbd31c454eff7$var$ds(r.data)) && $905dbd31c454eff7$var$A(_$n, _$o);
        return _$n;
    }(e, !0);
    for(c in f)$905dbd31c454eff7$var$n1(p[c]) && $905dbd31c454eff7$var$gs(a, c, "");
    for(c in p)i = p[c], $905dbd31c454eff7$var$gs(a, c, null == i ? "" : i);
}
var $905dbd31c454eff7$var$bs = {
    create: $905dbd31c454eff7$var$$s,
    update: $905dbd31c454eff7$var$$s
};
var $905dbd31c454eff7$var$ws = /\s+/;
function $905dbd31c454eff7$var$xs(t1, e) {
    if (e && (e = e.trim())) {
        if (t1.classList) e.indexOf(" ") > -1 ? e.split($905dbd31c454eff7$var$ws).forEach(function(e) {
            return t1.classList.add(e);
        }) : t1.classList.add(e);
        else {
            var n1 = " ".concat(t1.getAttribute("class") || "", " ");
            n1.indexOf(" " + e + " ") < 0 && t1.setAttribute("class", (n1 + e).trim());
        }
    }
}
function $905dbd31c454eff7$var$Cs(t1, e) {
    if (e && (e = e.trim())) {
        if (t1.classList) e.indexOf(" ") > -1 ? e.split($905dbd31c454eff7$var$ws).forEach(function(e) {
            return t1.classList.remove(e);
        }) : t1.classList.remove(e), t1.classList.length || t1.removeAttribute("class");
        else {
            var n1 = " ".concat(t1.getAttribute("class") || "", " ");
            var o = " " + e + " ";
            for(; n1.indexOf(o) >= 0;)n1 = n1.replace(o, " ");
            n1 = n1.trim(), n1 ? t1.setAttribute("class", n1) : t1.removeAttribute("class");
        }
    }
}
function $905dbd31c454eff7$var$ks(t1) {
    if (t1) {
        if ("object" == typeof t1) {
            var e = {};
            return !1 !== t1.css && $905dbd31c454eff7$var$A(e, $905dbd31c454eff7$var$Ss(t1.name || "v")), $905dbd31c454eff7$var$A(e, t1), e;
        }
        return "string" == typeof t1 ? $905dbd31c454eff7$var$Ss(t1) : void 0;
    }
}
var $905dbd31c454eff7$var$Ss = $905dbd31c454eff7$var$b(function(t1) {
    return {
        enterClass: "".concat(t1, "-enter"),
        enterToClass: "".concat(t1, "-enter-to"),
        enterActiveClass: "".concat(t1, "-enter-active"),
        leaveClass: "".concat(t1, "-leave"),
        leaveToClass: "".concat(t1, "-leave-to"),
        leaveActiveClass: "".concat(t1, "-leave-active")
    };
}), $905dbd31c454eff7$var$Os = $905dbd31c454eff7$var$q && !$905dbd31c454eff7$var$G, $905dbd31c454eff7$var$Ts = "transition", $905dbd31c454eff7$var$As = "animation";
var $905dbd31c454eff7$var$js = "transition", $905dbd31c454eff7$var$Es = "transitionend", $905dbd31c454eff7$var$Ns = "animation", $905dbd31c454eff7$var$Ps = "animationend";
$905dbd31c454eff7$var$Os && (void 0 === window.ontransitionend && void 0 !== window.onwebkittransitionend && ($905dbd31c454eff7$var$js = "WebkitTransition", $905dbd31c454eff7$var$Es = "webkitTransitionEnd"), void 0 === window.onanimationend && void 0 !== window.onwebkitanimationend && ($905dbd31c454eff7$var$Ns = "WebkitAnimation", $905dbd31c454eff7$var$Ps = "webkitAnimationEnd"));
var $905dbd31c454eff7$var$Ds = $905dbd31c454eff7$var$q ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : function(t1) {
    return t1();
};
function $905dbd31c454eff7$var$Ms(t1) {
    $905dbd31c454eff7$var$Ds(function() {
        $905dbd31c454eff7$var$Ds(t1);
    });
}
function $905dbd31c454eff7$var$Is(t1, e) {
    var n1 = t1._transitionClasses || (t1._transitionClasses = []);
    n1.indexOf(e) < 0 && (n1.push(e), $905dbd31c454eff7$var$xs(t1, e));
}
function $905dbd31c454eff7$var$Ls(t1, e) {
    t1._transitionClasses && $905dbd31c454eff7$var$y(t1._transitionClasses, e), $905dbd31c454eff7$var$Cs(t1, e);
}
function $905dbd31c454eff7$var$Rs(t1, e, n1) {
    var _Hs = $905dbd31c454eff7$var$Hs(t1, e), o = _Hs.type, r = _Hs.timeout, s = _Hs.propCount;
    if (!o) return n1();
    var i = o === $905dbd31c454eff7$var$Ts ? $905dbd31c454eff7$var$Es : $905dbd31c454eff7$var$Ps;
    var c = 0;
    var a = function() {
        t1.removeEventListener(i, l), n1();
    }, l = function(e) {
        e.target === t1 && ++c >= s && a();
    };
    setTimeout(function() {
        c < s && a();
    }, r + 1), t1.addEventListener(i, l);
}
var $905dbd31c454eff7$var$Fs = /\b(transform|all)(,|$)/;
function $905dbd31c454eff7$var$Hs(t1, e) {
    var n1 = window.getComputedStyle(t1), o = (n1[$905dbd31c454eff7$var$js + "Delay"] || "").split(", "), r = (n1[$905dbd31c454eff7$var$js + "Duration"] || "").split(", "), s = $905dbd31c454eff7$var$Bs(o, r), i = (n1[$905dbd31c454eff7$var$Ns + "Delay"] || "").split(", "), c = (n1[$905dbd31c454eff7$var$Ns + "Duration"] || "").split(", "), a = $905dbd31c454eff7$var$Bs(i, c);
    var l, u = 0, f = 0;
    e === $905dbd31c454eff7$var$Ts ? s > 0 && (l = $905dbd31c454eff7$var$Ts, u = s, f = r.length) : e === $905dbd31c454eff7$var$As ? a > 0 && (l = $905dbd31c454eff7$var$As, u = a, f = c.length) : (u = Math.max(s, a), l = u > 0 ? s > a ? $905dbd31c454eff7$var$Ts : $905dbd31c454eff7$var$As : null, f = l ? l === $905dbd31c454eff7$var$Ts ? r.length : c.length : 0);
    return {
        type: l,
        timeout: u,
        propCount: f,
        hasTransform: l === $905dbd31c454eff7$var$Ts && $905dbd31c454eff7$var$Fs.test(n1[$905dbd31c454eff7$var$js + "Property"])
    };
}
function $905dbd31c454eff7$var$Bs(t1, e) {
    for(; t1.length < e.length;)t1 = t1.concat(t1);
    return Math.max.apply(null, e.map(function(e, n1) {
        return $905dbd31c454eff7$var$Us(e) + $905dbd31c454eff7$var$Us(t1[n1]);
    }));
}
function $905dbd31c454eff7$var$Us(t1) {
    return 1e3 * Number(t1.slice(0, -1).replace(",", "."));
}
function $905dbd31c454eff7$var$zs(t1, e) {
    var r = t1.elm;
    $905dbd31c454eff7$var$o(r._leaveCb) && (r._leaveCb.cancelled = !0, r._leaveCb());
    var s = $905dbd31c454eff7$var$ks(t1.data.transition);
    if ($905dbd31c454eff7$var$n1(s)) return;
    if ($905dbd31c454eff7$var$o(r._enterCb) || 1 !== r.nodeType) return;
    var a = s.css, l = s.type, u = s.enterClass, f = s.enterToClass, d = s.enterActiveClass, p = s.appearClass, _$m = s.appearToClass, g = s.appearActiveClass, v = s.beforeEnter, y = s.enter, _ = s.afterEnter, $ = s.enterCancelled, _$b = s.beforeAppear, w = s.appear, x = s.afterAppear, C = s.appearCancelled, k = s.duration;
    var S = $905dbd31c454eff7$var$Ve, O = $905dbd31c454eff7$var$Ve.$vnode;
    for(; O && O.parent;)S = O.context, O = O.parent;
    var T = !S._isMounted || !t1.isRootInsert;
    if (T && !w && "" !== w) return;
    var _$A = T && p ? p : u, j = T && g ? g : d, _$E = T && _$m ? _$m : f, N = T && _$b || v, P = T && $905dbd31c454eff7$var$i(w) ? w : y, D = T && x || _, M = T && C || $, L = $905dbd31c454eff7$var$h($905dbd31c454eff7$var$c(k) ? k.enter : k), R = !1 !== a && !$905dbd31c454eff7$var$G, F = $905dbd31c454eff7$var$Js(P), H = r._enterCb = $905dbd31c454eff7$var$I(function() {
        R && ($905dbd31c454eff7$var$Ls(r, _$E), $905dbd31c454eff7$var$Ls(r, j)), H.cancelled ? (R && $905dbd31c454eff7$var$Ls(r, _$A), M && M(r)) : D && D(r), r._enterCb = null;
    });
    t1.data.show || $905dbd31c454eff7$var$Yt(t1, "insert", function() {
        var _$e = r.parentNode, _$n = _$e && _$e._pending && _$e._pending[t1.key];
        _$n && _$n.tag === t1.tag && _$n.elm._leaveCb && _$n.elm._leaveCb(), P && P(r, H);
    }), N && N(r), R && ($905dbd31c454eff7$var$Is(r, _$A), $905dbd31c454eff7$var$Is(r, j), $905dbd31c454eff7$var$Ms(function() {
        $905dbd31c454eff7$var$Ls(r, _$A), H.cancelled || ($905dbd31c454eff7$var$Is(r, _$E), F || ($905dbd31c454eff7$var$Ks(L) ? setTimeout(H, L) : $905dbd31c454eff7$var$Rs(r, l, H)));
    })), t1.data.show && (e && e(), P && P(r, H)), R || F || H();
}
function $905dbd31c454eff7$var$Vs(t1, e) {
    var r = t1.elm;
    $905dbd31c454eff7$var$o(r._enterCb) && (r._enterCb.cancelled = !0, r._enterCb());
    var s = $905dbd31c454eff7$var$ks(t1.data.transition);
    if ($905dbd31c454eff7$var$n1(s) || 1 !== r.nodeType) return e();
    if ($905dbd31c454eff7$var$o(r._leaveCb)) return;
    var i = s.css, a = s.type, l = s.leaveClass, u = s.leaveToClass, f = s.leaveActiveClass, d = s.beforeLeave, p = s.leave, _$m = s.afterLeave, g = s.leaveCancelled, v = s.delayLeave, y = s.duration, _ = !1 !== i && !$905dbd31c454eff7$var$G, $ = $905dbd31c454eff7$var$Js(p), _$b = $905dbd31c454eff7$var$h($905dbd31c454eff7$var$c(y) ? y.leave : y), w = r._leaveCb = $905dbd31c454eff7$var$I(function() {
        r.parentNode && r.parentNode._pending && (r.parentNode._pending[t1.key] = null), _ && ($905dbd31c454eff7$var$Ls(r, u), $905dbd31c454eff7$var$Ls(r, f)), w.cancelled ? (_ && $905dbd31c454eff7$var$Ls(r, l), g && g(r)) : (e(), _$m && _$m(r)), r._leaveCb = null;
    });
    function x() {
        w.cancelled || (!t1.data.show && r.parentNode && ((r.parentNode._pending || (r.parentNode._pending = {}))[t1.key] = t1), d && d(r), _ && ($905dbd31c454eff7$var$Is(r, l), $905dbd31c454eff7$var$Is(r, f), $905dbd31c454eff7$var$Ms(function() {
            $905dbd31c454eff7$var$Ls(r, l), w.cancelled || ($905dbd31c454eff7$var$Is(r, u), $ || ($905dbd31c454eff7$var$Ks(_$b) ? setTimeout(w, _$b) : $905dbd31c454eff7$var$Rs(r, a, w)));
        })), p && p(r, w), _ || $ || w());
    }
    v ? v(x) : x();
}
function $905dbd31c454eff7$var$Ks(t1) {
    return "number" == typeof t1 && !isNaN(t1);
}
function $905dbd31c454eff7$var$Js(t1) {
    if ($905dbd31c454eff7$var$n1(t1)) return !1;
    var e = t1.fns;
    return $905dbd31c454eff7$var$o(e) ? $905dbd31c454eff7$var$Js(Array.isArray(e) ? e[0] : e) : (t1._length || t1.length) > 1;
}
function $905dbd31c454eff7$var$qs(t1, e) {
    !0 !== e.data.show && $905dbd31c454eff7$var$zs(e);
}
var $905dbd31c454eff7$var$Ws = function(t1) {
    var i, c;
    var a = {}, l = t1.modules, u = t1.nodeOps;
    for(i = 0; i < $905dbd31c454eff7$var$ar.length; ++i)for(a[$905dbd31c454eff7$var$ar[i]] = [], c = 0; c < l.length; ++c)$905dbd31c454eff7$var$o(l[c][$905dbd31c454eff7$var$ar[i]]) && a[$905dbd31c454eff7$var$ar[i]].push(l[c][$905dbd31c454eff7$var$ar[i]]);
    function f(t1) {
        var e = u.parentNode(t1);
        $905dbd31c454eff7$var$o(e) && u.removeChild(e, t1);
    }
    function d(t1, e, n1, s, i, c, l) {
        if ($905dbd31c454eff7$var$o(t1.elm) && $905dbd31c454eff7$var$o(c) && (t1 = c[l] = $905dbd31c454eff7$var$pt(t1)), t1.isRootInsert = !i, function(t1, e, n1, s) {
            var _$i = t1.data;
            if ($905dbd31c454eff7$var$o(_$i)) {
                var _$c = $905dbd31c454eff7$var$o(t1.componentInstance) && _$i.keepAlive;
                if ($905dbd31c454eff7$var$o(_$i = _$i.hook) && $905dbd31c454eff7$var$o(_$i = _$i.init) && _$i(t1, !1), $905dbd31c454eff7$var$o(t1.componentInstance)) return p(t1, e), h(n1, t1.elm, s), $905dbd31c454eff7$var$r(_$c) && function(t1, e, n1, r) {
                    var _$s, _$i = t1;
                    for(; _$i.componentInstance;)if (_$i = _$i.componentInstance._vnode, $905dbd31c454eff7$var$o(_$s = _$i.data) && $905dbd31c454eff7$var$o(_$s = _$s.transition)) {
                        for(_$s = 0; _$s < a.activate.length; ++_$s)a.activate[_$s]($905dbd31c454eff7$var$cr, _$i);
                        e.push(_$i);
                        break;
                    }
                    h(n1, t1.elm, r);
                }(t1, e, n1, s), !0;
            }
        }(t1, e, n1, s)) return;
        var f = t1.data, d = t1.children, _$m = t1.tag;
        $905dbd31c454eff7$var$o(_$m) ? (t1.elm = t1.ns ? u.createElementNS(t1.ns, _$m) : u.createElement(_$m, t1), _(t1), g(t1, d, e), $905dbd31c454eff7$var$o(f) && y(t1, e), h(n1, t1.elm, s)) : $905dbd31c454eff7$var$r(t1.isComment) ? (t1.elm = u.createComment(t1.text), h(n1, t1.elm, s)) : (t1.elm = u.createTextNode(t1.text), h(n1, t1.elm, s));
    }
    function p(t1, e) {
        $905dbd31c454eff7$var$o(t1.data.pendingInsert) && (e.push.apply(e, t1.data.pendingInsert), t1.data.pendingInsert = null), t1.elm = t1.componentInstance.$el, v(t1) ? (y(t1, e), _(t1)) : ($905dbd31c454eff7$var$sr(t1), e.push(t1));
    }
    function h(t1, e, n1) {
        $905dbd31c454eff7$var$o(t1) && ($905dbd31c454eff7$var$o(n1) ? u.parentNode(n1) === t1 && u.insertBefore(t1, e, n1) : u.appendChild(t1, e));
    }
    function g(t1, n1, o) {
        if ($905dbd31c454eff7$var$e(n1)) for(var e1 = 0; e1 < n1.length; ++e1)d(n1[e1], o, t1.elm, null, !0, n1, e1);
        else $905dbd31c454eff7$var$s(t1.text) && u.appendChild(t1.elm, u.createTextNode(String(t1.text)));
    }
    function v(t1) {
        for(; t1.componentInstance;)t1 = t1.componentInstance._vnode;
        return $905dbd31c454eff7$var$o(t1.tag);
    }
    function y(t1, e) {
        for(var _$e = 0; _$e < a.create.length; ++_$e)a.create[_$e]($905dbd31c454eff7$var$cr, t1);
        i = t1.data.hook, $905dbd31c454eff7$var$o(i) && ($905dbd31c454eff7$var$o(i.create) && i.create($905dbd31c454eff7$var$cr, t1), $905dbd31c454eff7$var$o(i.insert) && e.push(t1));
    }
    function _(t1) {
        var e;
        if ($905dbd31c454eff7$var$o(e = t1.fnScopeId)) u.setStyleScope(t1.elm, e);
        else {
            var n1 = t1;
            for(; n1;)$905dbd31c454eff7$var$o(e = n1.context) && $905dbd31c454eff7$var$o(e = e.$options._scopeId) && u.setStyleScope(t1.elm, e), n1 = n1.parent;
        }
        $905dbd31c454eff7$var$o(e = $905dbd31c454eff7$var$Ve) && e !== t1.context && e !== t1.fnContext && $905dbd31c454eff7$var$o(e = e.$options._scopeId) && u.setStyleScope(t1.elm, e);
    }
    function $(t1, e, n1, o, r, s) {
        for(; o <= r; ++o)d(n1[o], s, t1, e, !1, n1, o);
    }
    function b(t1) {
        var e, n1;
        var r = t1.data;
        if ($905dbd31c454eff7$var$o(r)) for($905dbd31c454eff7$var$o(e = r.hook) && $905dbd31c454eff7$var$o(e = e.destroy) && e(t1), e = 0; e < a.destroy.length; ++e)a.destroy[e](t1);
        if ($905dbd31c454eff7$var$o(e = t1.children)) for(n1 = 0; n1 < t1.children.length; ++n1)b(t1.children[n1]);
    }
    function w(t1, e, n1) {
        for(; e <= n1; ++e){
            var _$n = t1[e];
            $905dbd31c454eff7$var$o(_$n) && ($905dbd31c454eff7$var$o(_$n.tag) ? (x(_$n), b(_$n)) : f(_$n.elm));
        }
    }
    function x(t1, e) {
        if ($905dbd31c454eff7$var$o(e) || $905dbd31c454eff7$var$o(t1.data)) {
            var n1;
            var r = a.remove.length + 1;
            for($905dbd31c454eff7$var$o(e) ? e.listeners += r : e = function(t1, e) {
                function n1() {
                    0 == --n1.listeners && f(t1);
                }
                return n1.listeners = e, n1;
            }(t1.elm, r), $905dbd31c454eff7$var$o(n1 = t1.componentInstance) && $905dbd31c454eff7$var$o(n1 = n1._vnode) && $905dbd31c454eff7$var$o(n1.data) && x(n1, e), n1 = 0; n1 < a.remove.length; ++n1)a.remove[n1](t1, e);
            $905dbd31c454eff7$var$o(n1 = t1.data.hook) && $905dbd31c454eff7$var$o(n1 = n1.remove) ? n1(t1, e) : e();
        } else f(t1.elm);
    }
    function C(t1, e, n1, r) {
        for(var s = n1; s < r; s++){
            var _$n = e[s];
            if ($905dbd31c454eff7$var$o(_$n) && $905dbd31c454eff7$var$lr(t1, _$n)) return s;
        }
    }
    function k(t1, e, s, i, c, l) {
        if (t1 === e) return;
        $905dbd31c454eff7$var$o(e.elm) && $905dbd31c454eff7$var$o(i) && (e = i[c] = $905dbd31c454eff7$var$pt(e));
        var f = e.elm = t1.elm;
        if ($905dbd31c454eff7$var$r(t1.isAsyncPlaceholder)) return void ($905dbd31c454eff7$var$o(e.asyncFactory.resolved) ? T(t1.elm, e, s) : e.isAsyncPlaceholder = !0);
        if ($905dbd31c454eff7$var$r(e.isStatic) && $905dbd31c454eff7$var$r(t1.isStatic) && e.key === t1.key && ($905dbd31c454eff7$var$r(e.isCloned) || $905dbd31c454eff7$var$r(e.isOnce))) return void (e.componentInstance = t1.componentInstance);
        var p;
        var h = e.data;
        $905dbd31c454eff7$var$o(h) && $905dbd31c454eff7$var$o(p = h.hook) && $905dbd31c454eff7$var$o(p = p.prepatch) && p(t1, e);
        var _$m = t1.children, g = e.children;
        if ($905dbd31c454eff7$var$o(h) && v(e)) {
            for(p = 0; p < a.update.length; ++p)a.update[p](t1, e);
            $905dbd31c454eff7$var$o(p = h.hook) && $905dbd31c454eff7$var$o(p = p.update) && p(t1, e);
        }
        $905dbd31c454eff7$var$n1(e.text) ? $905dbd31c454eff7$var$o(_$m) && $905dbd31c454eff7$var$o(g) ? _$m !== g && function(t1, e, r, s, i) {
            var _$c, a, _$l, f, p = 0, h = 0, _$m = e.length - 1, g = e[0], _$v = e[_$m], y = r.length - 1, _ = r[0], _$b = r[y];
            var x = !i;
            for(; p <= _$m && h <= y;)$905dbd31c454eff7$var$n1(g) ? g = e[++p] : $905dbd31c454eff7$var$n1(_$v) ? _$v = e[--_$m] : $905dbd31c454eff7$var$lr(g, _) ? (k(g, _, s, r, h), g = e[++p], _ = r[++h]) : $905dbd31c454eff7$var$lr(_$v, _$b) ? (k(_$v, _$b, s, r, y), _$v = e[--_$m], _$b = r[--y]) : $905dbd31c454eff7$var$lr(g, _$b) ? (k(g, _$b, s, r, y), x && u.insertBefore(t1, g.elm, u.nextSibling(_$v.elm)), g = e[++p], _$b = r[--y]) : $905dbd31c454eff7$var$lr(_$v, _) ? (k(_$v, _, s, r, h), x && u.insertBefore(t1, _$v.elm, g.elm), _$v = e[--_$m], _ = r[++h]) : ($905dbd31c454eff7$var$n1(_$c) && (_$c = $905dbd31c454eff7$var$ur(e, p, _$m)), a = $905dbd31c454eff7$var$o(_.key) ? _$c[_.key] : C(_, e, p, _$m), $905dbd31c454eff7$var$n1(a) ? d(_, s, t1, g.elm, !1, r, h) : (_$l = e[a], $905dbd31c454eff7$var$lr(_$l, _) ? (k(_$l, _, s, r, h), e[a] = void 0, x && u.insertBefore(t1, _$l.elm, g.elm)) : d(_, s, t1, g.elm, !1, r, h)), _ = r[++h]);
            p > _$m ? (f = $905dbd31c454eff7$var$n1(r[y + 1]) ? null : r[y + 1].elm, $(t1, f, r, h, y, s)) : h > y && w(e, p, _$m);
        }(f, _$m, g, s, l) : $905dbd31c454eff7$var$o(g) ? ($905dbd31c454eff7$var$o(t1.text) && u.setTextContent(f, ""), $(f, null, g, 0, g.length - 1, s)) : $905dbd31c454eff7$var$o(_$m) ? w(_$m, 0, _$m.length - 1) : $905dbd31c454eff7$var$o(t1.text) && u.setTextContent(f, "") : t1.text !== e.text && u.setTextContent(f, e.text), $905dbd31c454eff7$var$o(h) && $905dbd31c454eff7$var$o(p = h.hook) && $905dbd31c454eff7$var$o(p = p.postpatch) && p(t1, e);
    }
    function S(t1, e, n1) {
        if ($905dbd31c454eff7$var$r(n1) && $905dbd31c454eff7$var$o(t1.parent)) t1.parent.data.pendingInsert = e;
        else for(var _$t = 0; _$t < e.length; ++_$t)e[_$t].data.hook.insert(e[_$t]);
    }
    var O = $905dbd31c454eff7$var$m("attrs,class,staticClass,staticStyle,key");
    function T(t1, e, n1, s) {
        var i;
        var c = e.tag, a = e.data, l = e.children;
        if (s = s || a && a.pre, e.elm = t1, $905dbd31c454eff7$var$r(e.isComment) && $905dbd31c454eff7$var$o(e.asyncFactory)) return e.isAsyncPlaceholder = !0, !0;
        if ($905dbd31c454eff7$var$o(a) && ($905dbd31c454eff7$var$o(i = a.hook) && $905dbd31c454eff7$var$o(i = i.init) && i(e, !0), $905dbd31c454eff7$var$o(i = e.componentInstance))) return p(e, n1), !0;
        if ($905dbd31c454eff7$var$o(c)) {
            if ($905dbd31c454eff7$var$o(l)) {
                if (t1.hasChildNodes()) {
                    if ($905dbd31c454eff7$var$o(i = a) && $905dbd31c454eff7$var$o(i = i.domProps) && $905dbd31c454eff7$var$o(i = i.innerHTML)) {
                        if (i !== t1.innerHTML) return !1;
                    } else {
                        var _$e = !0, _$o = t1.firstChild;
                        for(var _$t = 0; _$t < l.length; _$t++){
                            if (!_$o || !T(_$o, l[_$t], n1, s)) {
                                _$e = !1;
                                break;
                            }
                            _$o = _$o.nextSibling;
                        }
                        if (!_$e || _$o) return !1;
                    }
                } else g(e, l, n1);
            }
            if ($905dbd31c454eff7$var$o(a)) {
                var _$t1 = !1;
                for(var _$o1 in a)if (!O(_$o1)) {
                    _$t1 = !0, y(e, n1);
                    break;
                }
                !_$t1 && a.class && $905dbd31c454eff7$var$Un(a.class);
            }
        } else t1.data !== e.text && (t1.data = e.text);
        return !0;
    }
    return function(t1, e, s, i) {
        if ($905dbd31c454eff7$var$n1(e)) return void ($905dbd31c454eff7$var$o(t1) && b(t1));
        var c = !1;
        var l = [];
        if ($905dbd31c454eff7$var$n1(t1)) c = !0, d(e, l);
        else {
            var _$n = $905dbd31c454eff7$var$o(t1.nodeType);
            if (!_$n && $905dbd31c454eff7$var$lr(t1, e)) k(t1, e, l, null, null, i);
            else {
                if (_$n) {
                    if (1 === t1.nodeType && t1.hasAttribute($905dbd31c454eff7$var$R) && (t1.removeAttribute($905dbd31c454eff7$var$R), s = !0), $905dbd31c454eff7$var$r(s) && T(t1, e, l)) return S(e, l, !0), t1;
                    f = t1, t1 = new $905dbd31c454eff7$var$ut(u.tagName(f).toLowerCase(), {}, [], void 0, f);
                }
                var _$i = t1.elm, c1 = u.parentNode(_$i);
                if (d(e, l, _$i._leaveCb ? null : c1, u.nextSibling(_$i)), $905dbd31c454eff7$var$o(e.parent)) {
                    var _$t = e.parent;
                    var _$n1 = v(e);
                    for(; _$t;){
                        for(var _$e = 0; _$e < a.destroy.length; ++_$e)a.destroy[_$e](_$t);
                        if (_$t.elm = e.elm, _$n1) {
                            for(var _$e1 = 0; _$e1 < a.create.length; ++_$e1)a.create[_$e1]($905dbd31c454eff7$var$cr, _$t);
                            var _$e2 = _$t.data.hook.insert;
                            if (_$e2.merged) {
                                var _$t1 = _$e2.fns.slice(1);
                                for(var _$e3 = 0; _$e3 < _$t1.length; _$e3++)_$t1[_$e3]();
                            }
                        } else $905dbd31c454eff7$var$sr(_$t);
                        _$t = _$t.parent;
                    }
                }
                $905dbd31c454eff7$var$o(c1) ? w([
                    t1
                ], 0, 0) : $905dbd31c454eff7$var$o(t1.tag) && b(t1);
            }
        }
        var f;
        return S(e, l, c), e.elm;
    };
}({
    nodeOps: $905dbd31c454eff7$var$or,
    modules: [
        $905dbd31c454eff7$var$br,
        $905dbd31c454eff7$var$xr,
        $905dbd31c454eff7$var$is,
        $905dbd31c454eff7$var$us,
        $905dbd31c454eff7$var$bs,
        $905dbd31c454eff7$var$q ? {
            create: $905dbd31c454eff7$var$qs,
            activate: $905dbd31c454eff7$var$qs,
            remove: function(t1, e) {
                !0 !== t1.data.show ? $905dbd31c454eff7$var$Vs(t1, e) : e();
            }
        } : {}
    ].concat($905dbd31c454eff7$var$vr)
});
$905dbd31c454eff7$var$G && document.addEventListener("selectionchange", function() {
    var t1 = document.activeElement;
    t1 && t1.vmodel && $905dbd31c454eff7$var$ni(t1, "input");
});
var $905dbd31c454eff7$var$Zs = {
    inserted: function(t1, e, n1, o) {
        "select" === n1.tag ? (o.elm && !o.elm._vOptions ? $905dbd31c454eff7$var$Yt(n1, "postpatch", function() {
            $905dbd31c454eff7$var$Zs.componentUpdated(t1, e, n1);
        }) : $905dbd31c454eff7$var$Gs(t1, e, n1.context), t1._vOptions = [].map.call(t1.options, $905dbd31c454eff7$var$Qs)) : ("textarea" === n1.tag || $905dbd31c454eff7$var$er(t1.type)) && (t1._vModifiers = e.modifiers, e.modifiers.lazy || (t1.addEventListener("compositionstart", $905dbd31c454eff7$var$ti), t1.addEventListener("compositionend", $905dbd31c454eff7$var$ei), t1.addEventListener("change", $905dbd31c454eff7$var$ei), $905dbd31c454eff7$var$G && (t1.vmodel = !0)));
    },
    componentUpdated: function(t1, e, n1) {
        if ("select" === n1.tag) {
            $905dbd31c454eff7$var$Gs(t1, e, n1.context);
            var o = t1._vOptions, r = t1._vOptions = [].map.call(t1.options, $905dbd31c454eff7$var$Qs);
            if (r.some(function(t1, e) {
                return !$905dbd31c454eff7$var$D(t1, o[e]);
            })) (t1.multiple ? e.value.some(function(t1) {
                return $905dbd31c454eff7$var$Ys(t1, r);
            }) : e.value !== e.oldValue && $905dbd31c454eff7$var$Ys(e.value, r)) && $905dbd31c454eff7$var$ni(t1, "change");
        }
    }
};
function $905dbd31c454eff7$var$Gs(t1, e, n1) {
    $905dbd31c454eff7$var$Xs(t1, e), ($905dbd31c454eff7$var$Z || $905dbd31c454eff7$var$X) && setTimeout(function() {
        $905dbd31c454eff7$var$Xs(t1, e);
    }, 0);
}
function $905dbd31c454eff7$var$Xs(t1, e, n1) {
    var o = e.value, r = t1.multiple;
    if (r && !Array.isArray(o)) return;
    var s, i;
    for(var _$e = 0, n2 = t1.options.length; _$e < n2; _$e++)if (i = t1.options[_$e], r) s = $905dbd31c454eff7$var$M(o, $905dbd31c454eff7$var$Qs(i)) > -1, i.selected !== s && (i.selected = s);
    else if ($905dbd31c454eff7$var$D($905dbd31c454eff7$var$Qs(i), o)) return void (t1.selectedIndex !== _$e && (t1.selectedIndex = _$e));
    r || (t1.selectedIndex = -1);
}
function $905dbd31c454eff7$var$Ys(t1, e) {
    return e.every(function(e) {
        return !$905dbd31c454eff7$var$D(e, t1);
    });
}
function $905dbd31c454eff7$var$Qs(t1) {
    return "_value" in t1 ? t1._value : t1.value;
}
function $905dbd31c454eff7$var$ti(t1) {
    t1.target.composing = !0;
}
function $905dbd31c454eff7$var$ei(t1) {
    t1.target.composing && (t1.target.composing = !1, $905dbd31c454eff7$var$ni(t1.target, "input"));
}
function $905dbd31c454eff7$var$ni(t1, e) {
    var n1 = document.createEvent("HTMLEvents");
    n1.initEvent(e, !0, !0), t1.dispatchEvent(n1);
}
function $905dbd31c454eff7$var$oi(t1) {
    return !t1.componentInstance || t1.data && t1.data.transition ? t1 : $905dbd31c454eff7$var$oi(t1.componentInstance._vnode);
}
var $905dbd31c454eff7$var$_obj;
var $905dbd31c454eff7$var$ri = ($905dbd31c454eff7$var$_obj = {
    bind: function(t1, param, n1) {
        var e = param.value;
        var o = (n1 = $905dbd31c454eff7$var$oi(n1)).data && n1.data.transition, r = t1.__vOriginalDisplay = "none" === t1.style.display ? "" : t1.style.display;
        e && o ? (n1.data.show = !0, $905dbd31c454eff7$var$zs(n1, function() {
            t1.style.display = r;
        })) : t1.style.display = e ? r : "none";
    }
}, (0, $ddmaO._)($905dbd31c454eff7$var$_obj, "update", function(t1, param, o) {
    var e = param["value"], n1 = param.oldValue;
    if (!e == !n1) return;
    (o = $905dbd31c454eff7$var$oi(o)).data && o.data.transition ? (o.data.show = !0, e ? $905dbd31c454eff7$var$zs(o, function() {
        t1.style.display = t1.__vOriginalDisplay;
    }) : $905dbd31c454eff7$var$Vs(o, function() {
        t1.style.display = "none";
    })) : t1.style.display = e ? t1.__vOriginalDisplay : "none";
}), (0, $ddmaO._)($905dbd31c454eff7$var$_obj, "unbind", function(t1, e, n1, o, r) {
    r || (t1.style.display = t1.__vOriginalDisplay);
}), $905dbd31c454eff7$var$_obj), $905dbd31c454eff7$var$si = {
    model: $905dbd31c454eff7$var$Zs,
    show: $905dbd31c454eff7$var$ri
};
var $905dbd31c454eff7$var$ii = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [
        Number,
        String,
        Object
    ]
};
function $905dbd31c454eff7$var$ci(t1) {
    var e = t1 && t1.componentOptions;
    return e && e.Ctor.options.abstract ? $905dbd31c454eff7$var$ci($905dbd31c454eff7$var$Le(e.children)) : t1;
}
function $905dbd31c454eff7$var$ai(t1) {
    var e = {}, n1 = t1.$options;
    for(var o in n1.propsData)e[o] = t1[o];
    var o1 = n1._parentListeners;
    for(var _$t in o1)e[$905dbd31c454eff7$var$x(_$t)] = o1[_$t];
    return e;
}
function $905dbd31c454eff7$var$li(t1, e) {
    if (/\d-keep-alive$/.test(e.tag)) return t1("keep-alive", {
        props: e.componentOptions.propsData
    });
}
var $905dbd31c454eff7$var$ui = function(t1) {
    return t1.tag || $905dbd31c454eff7$var$Ce(t1);
}, $905dbd31c454eff7$var$fi = function(t1) {
    return "show" === t1.name;
};
var $905dbd31c454eff7$var$di = {
    name: "transition",
    props: $905dbd31c454eff7$var$ii,
    abstract: !0,
    render: function(t1) {
        var _this = this;
        var e = this.$slots.default;
        if (!e) return;
        if (e = e.filter($905dbd31c454eff7$var$ui), !e.length) return;
        var n1 = this.mode, o = e[0];
        if (function(t1) {
            for(; t1 = t1.parent;)if (t1.data.transition) return !0;
        }(this.$vnode)) return o;
        var r = $905dbd31c454eff7$var$ci(o);
        if (!r) return o;
        if (this._leaving) return $905dbd31c454eff7$var$li(t1, o);
        var i = "__transition-".concat(this._uid, "-");
        r.key = null == r.key ? r.isComment ? i + "comment" : i + r.tag : $905dbd31c454eff7$var$s(r.key) ? 0 === String(r.key).indexOf(i) ? r.key : i + r.key : r.key;
        var c = (r.data || (r.data = {})).transition = $905dbd31c454eff7$var$ai(this), a = this._vnode, l = $905dbd31c454eff7$var$ci(a);
        if (r.data.directives && r.data.directives.some($905dbd31c454eff7$var$fi) && (r.data.show = !0), l && l.data && !function(t1, e) {
            return e.key === t1.key && e.tag === t1.tag;
        }(r, l) && !$905dbd31c454eff7$var$Ce(l) && (!l.componentInstance || !l.componentInstance._vnode.isComment)) {
            var e1 = l.data.transition = $905dbd31c454eff7$var$A({}, c);
            if ("out-in" === n1) return this._leaving = !0, $905dbd31c454eff7$var$Yt(e1, "afterLeave", function() {
                _this._leaving = !1, _this.$forceUpdate();
            }), $905dbd31c454eff7$var$li(t1, o);
            if ("in-out" === n1) {
                if ($905dbd31c454eff7$var$Ce(r)) return a;
                var _$t;
                var n2 = function() {
                    _$t();
                };
                $905dbd31c454eff7$var$Yt(c, "afterEnter", n2), $905dbd31c454eff7$var$Yt(c, "enterCancelled", n2), $905dbd31c454eff7$var$Yt(e1, "delayLeave", function(e) {
                    _$t = e;
                });
            }
        }
        return o;
    }
};
var $905dbd31c454eff7$var$pi = $905dbd31c454eff7$var$A({
    tag: String,
    moveClass: String
}, $905dbd31c454eff7$var$ii);
delete $905dbd31c454eff7$var$pi.mode;
var $905dbd31c454eff7$var$hi = {
    props: $905dbd31c454eff7$var$pi,
    beforeMount: function() {
        var _this = this;
        var t1 = this._update;
        this._update = function(e, n1) {
            var o = $905dbd31c454eff7$var$Ke(_this);
            _this.__patch__(_this._vnode, _this.kept, !1, !0), _this._vnode = _this.kept, o(), t1.call(_this, e, n1);
        };
    },
    render: function(t1) {
        var e = this.tag || this.$vnode.data.tag || "span", n1 = Object.create(null), o = this.prevChildren = this.children, r = this.$slots.default || [], s = this.children = [], i = $905dbd31c454eff7$var$ai(this);
        for(var _$t = 0; _$t < r.length; _$t++){
            var e1 = r[_$t];
            e1.tag && null != e1.key && 0 !== String(e1.key).indexOf("__vlist") && (s.push(e1), n1[e1.key] = e1, (e1.data || (e1.data = {})).transition = i);
        }
        if (o) {
            var r1 = [], s1 = [];
            for(var _$t1 = 0; _$t1 < o.length; _$t1++){
                var e2 = o[_$t1];
                e2.data.transition = i, e2.data.pos = e2.elm.getBoundingClientRect(), n1[e2.key] ? r1.push(e2) : s1.push(e2);
            }
            this.kept = t1(e, null, r1), this.removed = s1;
        }
        return t1(e, null, s);
    },
    updated: function() {
        var t1 = this.prevChildren, e = this.moveClass || (this.name || "v") + "-move";
        t1.length && this.hasMove(t1[0].elm, e) && (t1.forEach($905dbd31c454eff7$var$mi), t1.forEach($905dbd31c454eff7$var$gi), t1.forEach($905dbd31c454eff7$var$vi), this._reflow = document.body.offsetHeight, t1.forEach(function(t1) {
            if (t1.data.moved) {
                var n1 = t1.elm, o = n1.style;
                $905dbd31c454eff7$var$Is(n1, e), o.transform = o.WebkitTransform = o.transitionDuration = "", n1.addEventListener($905dbd31c454eff7$var$Es, n1._moveCb = function t1(o) {
                    o && o.target !== n1 || o && !/transform$/.test(o.propertyName) || (n1.removeEventListener($905dbd31c454eff7$var$Es, t1), n1._moveCb = null, $905dbd31c454eff7$var$Ls(n1, e));
                });
            }
        }));
    },
    methods: {
        hasMove: function(t1, e) {
            if (!$905dbd31c454eff7$var$Os) return !1;
            if (this._hasMove) return this._hasMove;
            var n1 = t1.cloneNode();
            t1._transitionClasses && t1._transitionClasses.forEach(function(t1) {
                $905dbd31c454eff7$var$Cs(n1, t1);
            }), $905dbd31c454eff7$var$xs(n1, e), n1.style.display = "none", this.$el.appendChild(n1);
            var o = $905dbd31c454eff7$var$Hs(n1);
            return this.$el.removeChild(n1), this._hasMove = o.hasTransform;
        }
    }
};
function $905dbd31c454eff7$var$mi(t1) {
    t1.elm._moveCb && t1.elm._moveCb(), t1.elm._enterCb && t1.elm._enterCb();
}
function $905dbd31c454eff7$var$gi(t1) {
    t1.data.newPos = t1.elm.getBoundingClientRect();
}
function $905dbd31c454eff7$var$vi(t1) {
    var e = t1.data.pos, n1 = t1.data.newPos, o = e.left - n1.left, r = e.top - n1.top;
    if (o || r) {
        t1.data.moved = !0;
        var e1 = t1.elm.style;
        e1.transform = e1.WebkitTransform = "translate(".concat(o, "px,").concat(r, "px)"), e1.transitionDuration = "0s";
    }
}
var $905dbd31c454eff7$var$yi = {
    Transition: $905dbd31c454eff7$var$di,
    TransitionGroup: $905dbd31c454eff7$var$hi
};
$905dbd31c454eff7$var$So.config.mustUseProp = $905dbd31c454eff7$var$Io, $905dbd31c454eff7$var$So.config.isReservedTag = $905dbd31c454eff7$var$Yo, $905dbd31c454eff7$var$So.config.isReservedAttr = $905dbd31c454eff7$var$Do, $905dbd31c454eff7$var$So.config.getTagNamespace = $905dbd31c454eff7$var$Qo, $905dbd31c454eff7$var$So.config.isUnknownElement = function(t1) {
    if (!$905dbd31c454eff7$var$q) return !0;
    if ($905dbd31c454eff7$var$Yo(t1)) return !1;
    if (t1 = t1.toLowerCase(), null != $905dbd31c454eff7$var$tr[t1]) return $905dbd31c454eff7$var$tr[t1];
    var e = document.createElement(t1);
    return t1.indexOf("-") > -1 ? $905dbd31c454eff7$var$tr[t1] = e.constructor === window.HTMLUnknownElement || e.constructor === window.HTMLElement : $905dbd31c454eff7$var$tr[t1] = /HTMLUnknownElement/.test(e.toString());
}, $905dbd31c454eff7$var$A($905dbd31c454eff7$var$So.options.directives, $905dbd31c454eff7$var$si), $905dbd31c454eff7$var$A($905dbd31c454eff7$var$So.options.components, $905dbd31c454eff7$var$yi), $905dbd31c454eff7$var$So.prototype.__patch__ = $905dbd31c454eff7$var$q ? $905dbd31c454eff7$var$Ws : $905dbd31c454eff7$var$E, $905dbd31c454eff7$var$So.prototype.$mount = function(t1, e) {
    return function(t1, e, n1) {
        var o;
        t1.$el = e, t1.$options.render || (t1.$options.render = $905dbd31c454eff7$var$ft), $905dbd31c454eff7$var$Ze(t1, "beforeMount"), o = function() {
            t1._update(t1._render(), n1);
        }, new $905dbd31c454eff7$var$Kn(t1, o, $905dbd31c454eff7$var$E, {
            before: function() {
                t1._isMounted && !t1._isDestroyed && $905dbd31c454eff7$var$Ze(t1, "beforeUpdate");
            }
        }, !0), n1 = !1;
        var r = t1._preWatchers;
        if (r) for(var _$t = 0; _$t < r.length; _$t++)r[_$t].run();
        return null == t1.$vnode && (t1._isMounted = !0, $905dbd31c454eff7$var$Ze(t1, "mounted")), t1;
    }(this, t1 = t1 && $905dbd31c454eff7$var$q ? $905dbd31c454eff7$var$nr(t1) : void 0, e);
}, $905dbd31c454eff7$var$q && setTimeout(function() {
    $905dbd31c454eff7$var$B.devtools && $905dbd31c454eff7$var$rt && $905dbd31c454eff7$var$rt.emit("init", $905dbd31c454eff7$var$So);
}, 0);
var $905dbd31c454eff7$var$_i = /\{\{((?:.|\r?\n)+?)\}\}/g, $905dbd31c454eff7$var$$i = /[-.*+?^${}()|[\]\/\\]/g, $905dbd31c454eff7$var$bi = $905dbd31c454eff7$var$b(function(t1) {
    var e = t1[0].replace($905dbd31c454eff7$var$$i, "\\$&"), n1 = t1[1].replace($905dbd31c454eff7$var$$i, "\\$&");
    return new RegExp(e + "((?:.|\\n)+?)" + n1, "g");
});
var $905dbd31c454eff7$var$wi = {
    staticKeys: [
        "staticClass"
    ],
    transformNode: function transformNode(t1, e) {
        e.warn;
        var n1 = $905dbd31c454eff7$var$Ir(t1, "class");
        n1 && (t1.staticClass = JSON.stringify(n1.replace(/\s+/g, " ").trim()));
        var o = $905dbd31c454eff7$var$Mr(t1, "class", !1);
        o && (t1.classBinding = o);
    },
    genData: function genData(t1) {
        var e = "";
        return t1.staticClass && (e += "staticClass:".concat(t1.staticClass, ",")), t1.classBinding && (e += "class:".concat(t1.classBinding, ",")), e;
    }
};
var $905dbd31c454eff7$var$xi = {
    staticKeys: [
        "staticStyle"
    ],
    transformNode: function transformNode(t1, e) {
        e.warn;
        var n1 = $905dbd31c454eff7$var$Ir(t1, "style");
        n1 && (t1.staticStyle = JSON.stringify($905dbd31c454eff7$var$fs(n1)));
        var o = $905dbd31c454eff7$var$Mr(t1, "style", !1);
        o && (t1.styleBinding = o);
    },
    genData: function genData(t1) {
        var e = "";
        return t1.staticStyle && (e += "staticStyle:".concat(t1.staticStyle, ",")), t1.styleBinding && (e += "style:(".concat(t1.styleBinding, "),")), e;
    }
};
var $905dbd31c454eff7$var$Ci;
var $905dbd31c454eff7$var$ki = {
    decode: function(t1) {
        return $905dbd31c454eff7$var$Ci = $905dbd31c454eff7$var$Ci || document.createElement("div"), $905dbd31c454eff7$var$Ci.innerHTML = t1, $905dbd31c454eff7$var$Ci.textContent;
    }
};
var $905dbd31c454eff7$var$Si = $905dbd31c454eff7$var$m("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"), $905dbd31c454eff7$var$Oi = $905dbd31c454eff7$var$m("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"), $905dbd31c454eff7$var$Ti = $905dbd31c454eff7$var$m("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"), $905dbd31c454eff7$var$Ai = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/, $905dbd31c454eff7$var$ji = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/, $905dbd31c454eff7$var$Ei = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat($905dbd31c454eff7$var$U.source, "]*"), $905dbd31c454eff7$var$Ni = "((?:".concat($905dbd31c454eff7$var$Ei, "\\:)?").concat($905dbd31c454eff7$var$Ei, ")"), $905dbd31c454eff7$var$Pi = new RegExp("^<".concat($905dbd31c454eff7$var$Ni)), $905dbd31c454eff7$var$Di = /^\s*(\/?)>/, $905dbd31c454eff7$var$Mi = new RegExp("^<\\/".concat($905dbd31c454eff7$var$Ni, "[^>]*>")), $905dbd31c454eff7$var$Ii = /^<!DOCTYPE [^>]+>/i, $905dbd31c454eff7$var$Li = /^<!\--/, $905dbd31c454eff7$var$Ri = /^<!\[/, $905dbd31c454eff7$var$Fi = $905dbd31c454eff7$var$m("script,style,textarea", !0), $905dbd31c454eff7$var$Hi = {}, $905dbd31c454eff7$var$Bi = {
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&amp;": "&",
    "&#10;": "\n",
    "&#9;": "	",
    "&#39;": "'"
}, $905dbd31c454eff7$var$Ui = /&(?:lt|gt|quot|amp|#39);/g, $905dbd31c454eff7$var$zi = /&(?:lt|gt|quot|amp|#39|#10|#9);/g, $905dbd31c454eff7$var$Vi = $905dbd31c454eff7$var$m("pre,textarea", !0), $905dbd31c454eff7$var$Ki = function(t1, e) {
    return t1 && $905dbd31c454eff7$var$Vi(t1) && "\n" === e[0];
};
function $905dbd31c454eff7$var$Ji(t1, e) {
    var n1 = e ? $905dbd31c454eff7$var$zi : $905dbd31c454eff7$var$Ui;
    return t1.replace(n1, function(t1) {
        return $905dbd31c454eff7$var$Bi[t1];
    });
}
var $905dbd31c454eff7$var$qi = /^@|^v-on:/, $905dbd31c454eff7$var$Wi = /^v-|^@|^:|^#/, $905dbd31c454eff7$var$Zi = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/, $905dbd31c454eff7$var$Gi = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/, $905dbd31c454eff7$var$Xi = /^\(|\)$/g, $905dbd31c454eff7$var$Yi = /^\[.*\]$/, $905dbd31c454eff7$var$Qi = /:(.*)$/, $905dbd31c454eff7$var$tc = /^:|^\.|^v-bind:/, $905dbd31c454eff7$var$ec = /\.[^.\]]+(?=[^\]]*$)/g, $905dbd31c454eff7$var$nc = /^v-slot(:|$)|^#/, $905dbd31c454eff7$var$oc = /[\r\n]/, $905dbd31c454eff7$var$rc = /[ \f\t\r\n]+/g, $905dbd31c454eff7$var$sc = $905dbd31c454eff7$var$b($905dbd31c454eff7$var$ki.decode), $905dbd31c454eff7$var$ic = "_empty_";
var $905dbd31c454eff7$var$cc, $905dbd31c454eff7$var$ac, $905dbd31c454eff7$var$lc, $905dbd31c454eff7$var$uc, $905dbd31c454eff7$var$fc, $905dbd31c454eff7$var$dc, $905dbd31c454eff7$var$pc, $905dbd31c454eff7$var$hc;
function $905dbd31c454eff7$var$mc(t1, e, n1) {
    return {
        type: 1,
        tag: t1,
        attrsList: e,
        attrsMap: $905dbd31c454eff7$var$wc(e),
        rawAttrsMap: {},
        parent: n1,
        children: []
    };
}
function $905dbd31c454eff7$var$gc(t1, e) {
    $905dbd31c454eff7$var$cc = e.warn || $905dbd31c454eff7$var$Or, $905dbd31c454eff7$var$dc = e.isPreTag || $905dbd31c454eff7$var$N, $905dbd31c454eff7$var$pc = e.mustUseProp || $905dbd31c454eff7$var$N, $905dbd31c454eff7$var$hc = e.getTagNamespace || $905dbd31c454eff7$var$N, e.isReservedTag, $905dbd31c454eff7$var$lc = $905dbd31c454eff7$var$Tr(e.modules, "transformNode"), $905dbd31c454eff7$var$uc = $905dbd31c454eff7$var$Tr(e.modules, "preTransformNode"), $905dbd31c454eff7$var$fc = $905dbd31c454eff7$var$Tr(e.modules, "postTransformNode"), $905dbd31c454eff7$var$ac = e.delimiters;
    var n1 = [], o = !1 !== e.preserveWhitespace, r = e.whitespace;
    var s, i, c = !1, a = !1;
    function l(t1) {
        if (u(t1), c || t1.processed || (t1 = $905dbd31c454eff7$var$vc(t1, e)), n1.length || t1 === s || s.if && (t1.elseif || t1.else) && $905dbd31c454eff7$var$_c(s, {
            exp: t1.elseif,
            block: t1
        }), i && !t1.forbidden) {
            if (t1.elseif || t1.else) !function(t1, e) {
                var n1 = function(t1) {
                    var _$e = t1.length;
                    for(; _$e--;){
                        if (1 === t1[_$e].type) return t1[_$e];
                        t1.pop();
                    }
                }(e.children);
                n1 && n1.if && $905dbd31c454eff7$var$_c(n1, {
                    exp: t1.elseif,
                    block: t1
                });
            }(t1, i);
            else {
                if (t1.slotScope) {
                    var _$e = t1.slotTarget || '"default"';
                    (i.scopedSlots || (i.scopedSlots = {}))[_$e] = t1;
                }
                i.children.push(t1), t1.parent = i;
            }
        }
        t1.children = t1.children.filter(function(t1) {
            return !t1.slotScope;
        }), u(t1), t1.pre && (c = !1), $905dbd31c454eff7$var$dc(t1.tag) && (a = !1);
        for(var n2 = 0; n2 < $905dbd31c454eff7$var$fc.length; n2++)$905dbd31c454eff7$var$fc[n2](t1, e);
    }
    function u(t1) {
        if (!a) {
            var _$e;
            for(; (_$e = t1.children[t1.children.length - 1]) && 3 === _$e.type && " " === _$e.text;)t1.children.pop();
        }
    }
    return function(t1, e) {
        var _loop = function() {
            if (i = t1, c && $905dbd31c454eff7$var$Fi(c)) {
                var n1 = 0;
                var o = c.toLowerCase(), r = $905dbd31c454eff7$var$Hi[o] || ($905dbd31c454eff7$var$Hi[o] = new RegExp("([\\s\\S]*?)(</" + o + "[^>]*>)", "i")), s = t1.replace(r, function(t1, r, s) {
                    return n1 = s.length, $905dbd31c454eff7$var$Fi(o) || "noscript" === o || (r = r.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), $905dbd31c454eff7$var$Ki(o, r) && (r = r.slice(1)), e.chars && e.chars(r), "";
                });
                a += t1.length - s.length, t1 = s, d(o, a - n1, a);
            } else {
                var n2 = void 0, o1 = void 0, r1 = void 0, s1 = t1.indexOf("<");
                if (0 === s1) {
                    if ($905dbd31c454eff7$var$Li.test(t1)) {
                        var n3 = t1.indexOf("-->");
                        if (n3 >= 0) {
                            e.shouldKeepComment && e.comment && e.comment(t1.substring(4, n3), a, a + n3 + 3), l(n3 + 3);
                            return "continue";
                        }
                    }
                    if ($905dbd31c454eff7$var$Ri.test(t1)) {
                        var _$e = t1.indexOf("]>");
                        if (_$e >= 0) {
                            l(_$e + 2);
                            return "continue";
                        }
                    }
                    var n4 = t1.match($905dbd31c454eff7$var$Ii);
                    if (n4) {
                        l(n4[0].length);
                        return "continue";
                    }
                    var o2 = t1.match($905dbd31c454eff7$var$Mi);
                    if (o2) {
                        var _$t = a;
                        l(o2[0].length), d(o2[1], _$t, a);
                        return "continue";
                    }
                    var r2 = u();
                    if (r2) {
                        f(r2), $905dbd31c454eff7$var$Ki(r2.tagName, t1) && l(1);
                        return "continue";
                    }
                }
                if (s1 >= 0) {
                    for(o1 = t1.slice(s1); !($905dbd31c454eff7$var$Mi.test(o1) || $905dbd31c454eff7$var$Pi.test(o1) || $905dbd31c454eff7$var$Li.test(o1) || $905dbd31c454eff7$var$Ri.test(o1) || (r1 = o1.indexOf("<", 1), r1 < 0));)s1 += r1, o1 = t1.slice(s1);
                    n2 = t1.substring(0, s1);
                }
                s1 < 0 && (n2 = t1), n2 && l(n2.length), e.chars && n2 && e.chars(n2, a - n2.length, a);
            }
            if (t1 === i) {
                e.chars && e.chars(t1);
                return "break";
            }
        };
        var n1 = [], o = e.expectHTML, r = e.isUnaryTag || $905dbd31c454eff7$var$N, s = e.canBeLeftOpenTag || $905dbd31c454eff7$var$N;
        var i, c, a = 0;
        for(; t1;){
            var _ret = _loop();
            if (_ret === "break") break;
        }
        function l(e) {
            a += e, t1 = t1.substring(e);
        }
        function u() {
            var _$e = t1.match($905dbd31c454eff7$var$Pi);
            if (_$e) {
                var n1 = {
                    tagName: _$e[1],
                    attrs: [],
                    start: a
                };
                var o, r;
                for(l(_$e[0].length); !(o = t1.match($905dbd31c454eff7$var$Di)) && (r = t1.match($905dbd31c454eff7$var$ji) || t1.match($905dbd31c454eff7$var$Ai));)r.start = a, l(r[0].length), r.end = a, n1.attrs.push(r);
                if (o) return n1.unarySlash = o[1], l(o[0].length), n1.end = a, n1;
            }
        }
        function f(t1) {
            var i = t1.tagName, a = t1.unarySlash;
            o && ("p" === c && $905dbd31c454eff7$var$Ti(i) && d(c), s(i) && c === i && d(i));
            var _$l = r(i) || !!a, _$u = t1.attrs.length, _$f = new Array(_$u);
            for(var n2 = 0; n2 < _$u; n2++){
                var o1 = t1.attrs[n2], r1 = o1[3] || o1[4] || o1[5] || "", s1 = "a" === i && "href" === o1[1] ? e.shouldDecodeNewlinesForHref : e.shouldDecodeNewlines;
                _$f[n2] = {
                    name: o1[1],
                    value: $905dbd31c454eff7$var$Ji(r1, s1)
                };
            }
            _$l || (n1.push({
                tag: i,
                lowerCasedTag: i.toLowerCase(),
                attrs: _$f,
                start: t1.start,
                end: t1.end
            }), c = i), e.start && e.start(i, _$f, _$l, t1.start, t1.end);
        }
        function d(t1, o, r) {
            var s, i;
            if (null == o && (o = a), null == r && (r = a), t1) for(i = t1.toLowerCase(), s = n1.length - 1; s >= 0 && n1[s].lowerCasedTag !== i; s--);
            else s = 0;
            if (s >= 0) {
                for(var _$t = n1.length - 1; _$t >= s; _$t--)e.end && e.end(n1[_$t].tag, o, r);
                n1.length = s, c = s && n1[s - 1].tag;
            } else "br" === i ? e.start && e.start(t1, [], !0, o, r) : "p" === i && (e.start && e.start(t1, [], !1, o, r), e.end && e.end(t1, o, r));
        }
        d();
    }(t1, {
        warn: $905dbd31c454eff7$var$cc,
        expectHTML: e.expectHTML,
        isUnaryTag: e.isUnaryTag,
        canBeLeftOpenTag: e.canBeLeftOpenTag,
        shouldDecodeNewlines: e.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: e.shouldDecodeNewlinesForHref,
        shouldKeepComment: e.comments,
        outputSourceRange: e.outputSourceRange,
        start: function(t1, o, r, u, f) {
            var d = i && i.ns || $905dbd31c454eff7$var$hc(t1);
            $905dbd31c454eff7$var$Z && "svg" === d && (o = function(t1) {
                var _$e = [];
                for(var n1 = 0; n1 < t1.length; n1++){
                    var _$o = t1[n1];
                    $905dbd31c454eff7$var$xc.test(_$o.name) || (_$o.name = _$o.name.replace($905dbd31c454eff7$var$Cc, ""), _$e.push(_$o));
                }
                return _$e;
            }(o));
            var p = $905dbd31c454eff7$var$mc(t1, o, i);
            var h;
            d && (p.ns = d), "style" !== (h = p).tag && ("script" !== h.tag || h.attrsMap.type && "text/javascript" !== h.attrsMap.type) || $905dbd31c454eff7$var$ot() || (p.forbidden = !0);
            for(var _$t = 0; _$t < $905dbd31c454eff7$var$uc.length; _$t++)p = $905dbd31c454eff7$var$uc[_$t](p, e) || p;
            c || (!function(t1) {
                null != $905dbd31c454eff7$var$Ir(t1, "v-pre") && (t1.pre = !0);
            }(p), p.pre && (c = !0)), $905dbd31c454eff7$var$dc(p.tag) && (a = !0), c ? function(t1) {
                var _$e = t1.attrsList, n1 = _$e.length;
                if (n1) {
                    var _$o = t1.attrs = new Array(n1);
                    for(var _$t = 0; _$t < n1; _$t++)_$o[_$t] = {
                        name: _$e[_$t].name,
                        value: JSON.stringify(_$e[_$t].value)
                    }, null != _$e[_$t].start && (_$o[_$t].start = _$e[_$t].start, _$o[_$t].end = _$e[_$t].end);
                } else t1.pre || (t1.plain = !0);
            }(p) : p.processed || ($905dbd31c454eff7$var$yc(p), function(t1) {
                var _$e = $905dbd31c454eff7$var$Ir(t1, "v-if");
                if (_$e) t1.if = _$e, $905dbd31c454eff7$var$_c(t1, {
                    exp: _$e,
                    block: t1
                });
                else {
                    null != $905dbd31c454eff7$var$Ir(t1, "v-else") && (t1.else = !0);
                    var _$e1 = $905dbd31c454eff7$var$Ir(t1, "v-else-if");
                    _$e1 && (t1.elseif = _$e1);
                }
            }(p), function(t1) {
                var _$e = $905dbd31c454eff7$var$Ir(t1, "v-once");
                null != _$e && (t1.once = !0);
            }(p)), s || (s = p), r ? l(p) : (i = p, n1.push(p));
        },
        end: function(t1, e, o) {
            var r = n1[n1.length - 1];
            n1.length -= 1, i = n1[n1.length - 1], l(r);
        },
        chars: function(t1, e, n1) {
            if (!i) return;
            if ($905dbd31c454eff7$var$Z && "textarea" === i.tag && i.attrsMap.placeholder === t1) return;
            var s = i.children;
            var l;
            if (t1 = a || t1.trim() ? "script" === (l = i).tag || "style" === l.tag ? t1 : $905dbd31c454eff7$var$sc(t1) : s.length ? r ? "condense" === r && $905dbd31c454eff7$var$oc.test(t1) ? "" : " " : o ? " " : "" : "") {
                var _$e, n2;
                a || "condense" !== r || (t1 = t1.replace($905dbd31c454eff7$var$rc, " ")), !c && " " !== t1 && (_$e = function(t1, e) {
                    var n1 = e ? $905dbd31c454eff7$var$bi(e) : $905dbd31c454eff7$var$_i;
                    if (!n1.test(t1)) return;
                    var o = [], r = [];
                    var s, i, c, a = n1.lastIndex = 0;
                    for(; s = n1.exec(t1);){
                        i = s.index, i > a && (r.push(c = t1.slice(a, i)), o.push(JSON.stringify(c)));
                        var _$e = $905dbd31c454eff7$var$kr(s[1].trim());
                        o.push("_s(".concat(_$e, ")")), r.push({
                            "@binding": _$e
                        }), a = i + s[0].length;
                    }
                    return a < t1.length && (r.push(c = t1.slice(a)), o.push(JSON.stringify(c))), {
                        expression: o.join("+"),
                        tokens: r
                    };
                }(t1, $905dbd31c454eff7$var$ac)) ? n2 = {
                    type: 2,
                    expression: _$e.expression,
                    tokens: _$e.tokens,
                    text: t1
                } : " " === t1 && s.length && " " === s[s.length - 1].text || (n2 = {
                    type: 3,
                    text: t1
                }), n2 && s.push(n2);
            }
        },
        comment: function(t1, e, n1) {
            if (i) {
                var _$e = {
                    type: 3,
                    text: t1,
                    isComment: !0
                };
                i.children.push(_$e);
            }
        }
    }), s;
}
function $905dbd31c454eff7$var$vc(t1, e) {
    var n1;
    !function(t1) {
        var _$e = $905dbd31c454eff7$var$Mr(t1, "key");
        _$e && (t1.key = _$e);
    }(t1), t1.plain = !t1.key && !t1.scopedSlots && !t1.attrsList.length, function(t1) {
        var _$e = $905dbd31c454eff7$var$Mr(t1, "ref");
        _$e && (t1.ref = _$e, t1.refInFor = function(t1) {
            var _$e = t1;
            for(; _$e;){
                if (void 0 !== _$e.for) return !0;
                _$e = _$e.parent;
            }
            return !1;
        }(t1));
    }(t1), function(t1) {
        var _$e;
        "template" === t1.tag ? (_$e = $905dbd31c454eff7$var$Ir(t1, "scope"), t1.slotScope = _$e || $905dbd31c454eff7$var$Ir(t1, "slot-scope")) : (_$e = $905dbd31c454eff7$var$Ir(t1, "slot-scope")) && (t1.slotScope = _$e);
        var n1 = $905dbd31c454eff7$var$Mr(t1, "slot");
        n1 && (t1.slotTarget = '""' === n1 ? '"default"' : n1, t1.slotTargetDynamic = !(!t1.attrsMap[":slot"] && !t1.attrsMap["v-bind:slot"]), "template" === t1.tag || t1.slotScope || $905dbd31c454eff7$var$jr(t1, "slot", n1, function(t1, e) {
            return t1.rawAttrsMap[":" + e] || t1.rawAttrsMap["v-bind:" + e] || t1.rawAttrsMap[e];
        }(t1, "slot")));
        if ("template" === t1.tag) {
            var _$e1 = $905dbd31c454eff7$var$Lr(t1, $905dbd31c454eff7$var$nc);
            if (_$e1) {
                var _$c = $905dbd31c454eff7$var$$c(_$e1), n2 = _$c.name, o = _$c.dynamic;
                t1.slotTarget = n2, t1.slotTargetDynamic = o, t1.slotScope = _$e1.value || $905dbd31c454eff7$var$ic;
            }
        } else {
            var _$e2 = $905dbd31c454eff7$var$Lr(t1, $905dbd31c454eff7$var$nc);
            if (_$e2) {
                var n3 = t1.scopedSlots || (t1.scopedSlots = {}), _$c1 = $905dbd31c454eff7$var$$c(_$e2), o1 = _$c1.name, r = _$c1.dynamic, s = n3[o1] = $905dbd31c454eff7$var$mc("template", [], t1);
                s.slotTarget = o1, s.slotTargetDynamic = r, s.children = t1.children.filter(function(t1) {
                    if (!t1.slotScope) return t1.parent = s, !0;
                }), s.slotScope = _$e2.value || $905dbd31c454eff7$var$ic, t1.children = [], t1.plain = !1;
            }
        }
    }(t1), "slot" === (n1 = t1).tag && (n1.slotName = $905dbd31c454eff7$var$Mr(n1, "name")), function(t1) {
        var _$e;
        (_$e = $905dbd31c454eff7$var$Mr(t1, "is")) && (t1.component = _$e);
        null != $905dbd31c454eff7$var$Ir(t1, "inline-template") && (t1.inlineTemplate = !0);
    }(t1);
    for(var n2 = 0; n2 < $905dbd31c454eff7$var$lc.length; n2++)t1 = $905dbd31c454eff7$var$lc[n2](t1, e) || t1;
    return function(t1) {
        var _$e = t1.attrsList;
        var n1, o, r, s, i, c, a, l;
        for(n1 = 0, o = _$e.length; n1 < o; n1++)if (r = s = _$e[n1].name, i = _$e[n1].value, $905dbd31c454eff7$var$Wi.test(r)) {
            if (t1.hasBindings = !0, c = $905dbd31c454eff7$var$bc(r.replace($905dbd31c454eff7$var$Wi, "")), c && (r = r.replace($905dbd31c454eff7$var$ec, "")), $905dbd31c454eff7$var$tc.test(r)) r = r.replace($905dbd31c454eff7$var$tc, ""), i = $905dbd31c454eff7$var$kr(i), l = $905dbd31c454eff7$var$Yi.test(r), l && (r = r.slice(1, -1)), c && (c.prop && !l && (r = $905dbd31c454eff7$var$x(r), "innerHtml" === r && (r = "innerHTML")), c.camel && !l && (r = $905dbd31c454eff7$var$x(r)), c.sync && (a = $905dbd31c454eff7$var$Hr(i, "$event"), l ? $905dbd31c454eff7$var$Dr(t1, '"update:"+('.concat(r, ")"), a, null, !1, 0, _$e[n1], !0) : ($905dbd31c454eff7$var$Dr(t1, "update:".concat($905dbd31c454eff7$var$x(r)), a, null, !1, 0, _$e[n1]), $905dbd31c454eff7$var$S(r) !== $905dbd31c454eff7$var$x(r) && $905dbd31c454eff7$var$Dr(t1, "update:".concat($905dbd31c454eff7$var$S(r)), a, null, !1, 0, _$e[n1])))), c && c.prop || !t1.component && $905dbd31c454eff7$var$pc(t1.tag, t1.attrsMap.type, r) ? $905dbd31c454eff7$var$Ar(t1, r, i, _$e[n1], l) : $905dbd31c454eff7$var$jr(t1, r, i, _$e[n1], l);
            else if ($905dbd31c454eff7$var$qi.test(r)) r = r.replace($905dbd31c454eff7$var$qi, ""), l = $905dbd31c454eff7$var$Yi.test(r), l && (r = r.slice(1, -1)), $905dbd31c454eff7$var$Dr(t1, r, i, c, !1, 0, _$e[n1], l);
            else {
                r = r.replace($905dbd31c454eff7$var$Wi, "");
                var o1 = r.match($905dbd31c454eff7$var$Qi);
                var a1 = o1 && o1[1];
                l = !1, a1 && (r = r.slice(0, -(a1.length + 1)), $905dbd31c454eff7$var$Yi.test(a1) && (a1 = a1.slice(1, -1), l = !0)), $905dbd31c454eff7$var$Nr(t1, r, s, i, a1, l, c, _$e[n1]);
            }
        } else $905dbd31c454eff7$var$jr(t1, r, JSON.stringify(i), _$e[n1]), !t1.component && "muted" === r && $905dbd31c454eff7$var$pc(t1.tag, t1.attrsMap.type, r) && $905dbd31c454eff7$var$Ar(t1, r, "true", _$e[n1]);
    }(t1), t1;
}
function $905dbd31c454eff7$var$yc(t1) {
    var e;
    if (e = $905dbd31c454eff7$var$Ir(t1, "v-for")) {
        var n1 = function(t1) {
            var e = t1.match($905dbd31c454eff7$var$Zi);
            if (!e) return;
            var n1 = {};
            n1.for = e[2].trim();
            var o = e[1].trim().replace($905dbd31c454eff7$var$Xi, ""), r = o.match($905dbd31c454eff7$var$Gi);
            r ? (n1.alias = o.replace($905dbd31c454eff7$var$Gi, "").trim(), n1.iterator1 = r[1].trim(), r[2] && (n1.iterator2 = r[2].trim())) : n1.alias = o;
            return n1;
        }(e);
        n1 && $905dbd31c454eff7$var$A(t1, n1);
    }
}
function $905dbd31c454eff7$var$_c(t1, e) {
    t1.ifConditions || (t1.ifConditions = []), t1.ifConditions.push(e);
}
function $905dbd31c454eff7$var$$c(t1) {
    var e = t1.name.replace($905dbd31c454eff7$var$nc, "");
    return e || "#" !== t1.name[0] && (e = "default"), $905dbd31c454eff7$var$Yi.test(e) ? {
        name: e.slice(1, -1),
        dynamic: !0
    } : {
        name: '"'.concat(e, '"'),
        dynamic: !1
    };
}
function $905dbd31c454eff7$var$bc(t1) {
    var e = t1.match($905dbd31c454eff7$var$ec);
    if (e) {
        var _$t = {};
        return e.forEach(function(e) {
            _$t[e.slice(1)] = !0;
        }), _$t;
    }
}
function $905dbd31c454eff7$var$wc(t1) {
    var e = {};
    for(var n1 = 0, o = t1.length; n1 < o; n1++)e[t1[n1].name] = t1[n1].value;
    return e;
}
var $905dbd31c454eff7$var$xc = /^xmlns:NS\d+/, $905dbd31c454eff7$var$Cc = /^NS\d+:/;
function $905dbd31c454eff7$var$kc(t1) {
    return $905dbd31c454eff7$var$mc(t1.tag, t1.attrsList.slice(), t1.parent);
}
var $905dbd31c454eff7$var$Sc = [
    $905dbd31c454eff7$var$wi,
    $905dbd31c454eff7$var$xi,
    {
        preTransformNode: function preTransformNode(t1, e) {
            if ("input" === t1.tag) {
                var n1 = t1.attrsMap;
                if (!n1["v-model"]) return;
                var o;
                if ((n1[":type"] || n1["v-bind:type"]) && (o = $905dbd31c454eff7$var$Mr(t1, "type")), n1.type || o || !n1["v-bind"] || (o = "(".concat(n1["v-bind"], ").type")), o) {
                    var n2 = $905dbd31c454eff7$var$Ir(t1, "v-if", !0), r = n2 ? "&&(".concat(n2, ")") : "", s = null != $905dbd31c454eff7$var$Ir(t1, "v-else", !0), i = $905dbd31c454eff7$var$Ir(t1, "v-else-if", !0), c = $905dbd31c454eff7$var$kc(t1);
                    $905dbd31c454eff7$var$yc(c), $905dbd31c454eff7$var$Er(c, "type", "checkbox"), $905dbd31c454eff7$var$vc(c, e), c.processed = !0, c.if = "(".concat(o, ")==='checkbox'") + r, $905dbd31c454eff7$var$_c(c, {
                        exp: c.if,
                        block: c
                    });
                    var a = $905dbd31c454eff7$var$kc(t1);
                    $905dbd31c454eff7$var$Ir(a, "v-for", !0), $905dbd31c454eff7$var$Er(a, "type", "radio"), $905dbd31c454eff7$var$vc(a, e), $905dbd31c454eff7$var$_c(c, {
                        exp: "(".concat(o, ")==='radio'") + r,
                        block: a
                    });
                    var l = $905dbd31c454eff7$var$kc(t1);
                    return $905dbd31c454eff7$var$Ir(l, "v-for", !0), $905dbd31c454eff7$var$Er(l, ":type", o), $905dbd31c454eff7$var$vc(l, e), $905dbd31c454eff7$var$_c(c, {
                        exp: n2,
                        block: l
                    }), s ? c.else = !0 : i && (c.elseif = i), c;
                }
            }
        }
    }
];
var $905dbd31c454eff7$var$Oc = {
    expectHTML: !0,
    modules: $905dbd31c454eff7$var$Sc,
    directives: {
        model: function model(t1, e, n1) {
            var o = e.value, r = e.modifiers, s = t1.tag, i = t1.attrsMap.type;
            if (t1.component) return $905dbd31c454eff7$var$Fr(t1, o, r), !1;
            if ("select" === s) !function(t1, e, n1) {
                var o = n1 && n1.number;
                var r = 'var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '.concat(o ? "_n(val)" : "val", "});");
                r = "".concat(r, " ").concat($905dbd31c454eff7$var$Hr(e, "$event.target.multiple ? $$selectedVal : $$selectedVal[0]")), $905dbd31c454eff7$var$Dr(t1, "change", r, null, !0);
            }(t1, o, r);
            else if ("input" === s && "checkbox" === i) !function(t1, e, n1) {
                var o = n1 && n1.number, r = $905dbd31c454eff7$var$Mr(t1, "value") || "null", s = $905dbd31c454eff7$var$Mr(t1, "true-value") || "true", i = $905dbd31c454eff7$var$Mr(t1, "false-value") || "false";
                $905dbd31c454eff7$var$Ar(t1, "checked", "Array.isArray(".concat(e, ")?_i(").concat(e, ",").concat(r, ")>-1") + ("true" === s ? ":(".concat(e, ")") : ":_q(".concat(e, ",").concat(s, ")"))), $905dbd31c454eff7$var$Dr(t1, "change", "var $$a=".concat(e, ",$$el=$event.target,$$c=$$el.checked?(").concat(s, "):(").concat(i, ");if(Array.isArray($$a)){var $$v=").concat(o ? "_n(" + r + ")" : r, ",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&(").concat($905dbd31c454eff7$var$Hr(e, "$$a.concat([$$v])"), ")}else{$$i>-1&&(").concat($905dbd31c454eff7$var$Hr(e, "$$a.slice(0,$$i).concat($$a.slice($$i+1))"), ")}}else{").concat($905dbd31c454eff7$var$Hr(e, "$$c"), "}"), null, !0);
            }(t1, o, r);
            else if ("input" === s && "radio" === i) !function(t1, e, n1) {
                var o = n1 && n1.number;
                var r = $905dbd31c454eff7$var$Mr(t1, "value") || "null";
                r = o ? "_n(".concat(r, ")") : r, $905dbd31c454eff7$var$Ar(t1, "checked", "_q(".concat(e, ",").concat(r, ")")), $905dbd31c454eff7$var$Dr(t1, "change", $905dbd31c454eff7$var$Hr(e, r), null, !0);
            }(t1, o, r);
            else if ("input" === s || "textarea" === s) !function(t1, e, n1) {
                var o = t1.attrsMap.type, _ref = n1 || {}, r = _ref.lazy, s = _ref.number, i = _ref.trim, c = !r && "range" !== o, a = r ? "change" : "range" === o ? $905dbd31c454eff7$var$Yr : "input";
                var l = "$event.target.value";
                i && (l = "$event.target.value.trim()");
                s && (l = "_n(".concat(l, ")"));
                var u = $905dbd31c454eff7$var$Hr(e, l);
                c && (u = "if($event.target.composing)return;".concat(u));
                $905dbd31c454eff7$var$Ar(t1, "value", "(".concat(e, ")")), $905dbd31c454eff7$var$Dr(t1, a, u, null, !0), (i || s) && $905dbd31c454eff7$var$Dr(t1, "blur", "$forceUpdate()");
            }(t1, o, r);
            else if (!$905dbd31c454eff7$var$B.isReservedTag(s)) return $905dbd31c454eff7$var$Fr(t1, o, r), !1;
            return !0;
        },
        text: function text(t1, e) {
            e.value && $905dbd31c454eff7$var$Ar(t1, "textContent", "_s(".concat(e.value, ")"), e);
        },
        html: function html(t1, e) {
            e.value && $905dbd31c454eff7$var$Ar(t1, "innerHTML", "_s(".concat(e.value, ")"), e);
        }
    },
    isPreTag: function(t1) {
        return "pre" === t1;
    },
    isUnaryTag: $905dbd31c454eff7$var$Si,
    mustUseProp: $905dbd31c454eff7$var$Io,
    canBeLeftOpenTag: $905dbd31c454eff7$var$Oi,
    isReservedTag: $905dbd31c454eff7$var$Yo,
    getTagNamespace: $905dbd31c454eff7$var$Qo,
    staticKeys: function(t1) {
        return t1.reduce(function(t1, e) {
            return t1.concat(e.staticKeys || []);
        }, []).join(",");
    }($905dbd31c454eff7$var$Sc)
};
var $905dbd31c454eff7$var$Tc, $905dbd31c454eff7$var$Ac;
var $905dbd31c454eff7$var$jc = $905dbd31c454eff7$var$b(function(t1) {
    return $905dbd31c454eff7$var$m("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" + (t1 ? "," + t1 : ""));
});
function $905dbd31c454eff7$var$Ec(t1, e) {
    t1 && ($905dbd31c454eff7$var$Tc = $905dbd31c454eff7$var$jc(e.staticKeys || ""), $905dbd31c454eff7$var$Ac = e.isReservedTag || $905dbd31c454eff7$var$N, $905dbd31c454eff7$var$Nc(t1), $905dbd31c454eff7$var$Pc(t1, !1));
}
function $905dbd31c454eff7$var$Nc(t1) {
    if (t1.static = function(t1) {
        if (2 === t1.type) return !1;
        if (3 === t1.type) return !0;
        return !(!t1.pre && (t1.hasBindings || t1.if || t1.for || $905dbd31c454eff7$var$g(t1.tag) || !$905dbd31c454eff7$var$Ac(t1.tag) || function(t1) {
            for(; t1.parent;){
                if ("template" !== (t1 = t1.parent).tag) return !1;
                if (t1.for) return !0;
            }
            return !1;
        }(t1) || !Object.keys(t1).every($905dbd31c454eff7$var$Tc)));
    }(t1), 1 === t1.type) {
        if (!$905dbd31c454eff7$var$Ac(t1.tag) && "slot" !== t1.tag && null == t1.attrsMap["inline-template"]) return;
        for(var e = 0, n1 = t1.children.length; e < n1; e++){
            var n2 = t1.children[e];
            $905dbd31c454eff7$var$Nc(n2), n2.static || (t1.static = !1);
        }
        if (t1.ifConditions) for(var e1 = 1, n3 = t1.ifConditions.length; e1 < n3; e1++){
            var n4 = t1.ifConditions[e1].block;
            $905dbd31c454eff7$var$Nc(n4), n4.static || (t1.static = !1);
        }
    }
}
function $905dbd31c454eff7$var$Pc(t1, e) {
    if (1 === t1.type) {
        if ((t1.static || t1.once) && (t1.staticInFor = e), t1.static && t1.children.length && (1 !== t1.children.length || 3 !== t1.children[0].type)) return void (t1.staticRoot = !0);
        if (t1.staticRoot = !1, t1.children) for(var n1 = 0, o = t1.children.length; n1 < o; n1++)$905dbd31c454eff7$var$Pc(t1.children[n1], e || !!t1.for);
        if (t1.ifConditions) for(var n2 = 1, o1 = t1.ifConditions.length; n2 < o1; n2++)$905dbd31c454eff7$var$Pc(t1.ifConditions[n2].block, e);
    }
}
var $905dbd31c454eff7$var$Dc = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/, $905dbd31c454eff7$var$Mc = /\([^)]*?\);*$/, $905dbd31c454eff7$var$Ic = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/, $905dbd31c454eff7$var$Lc = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [
        8,
        46
    ]
}, $905dbd31c454eff7$var$Rc = {
    esc: [
        "Esc",
        "Escape"
    ],
    tab: "Tab",
    enter: "Enter",
    space: [
        " ",
        "Spacebar"
    ],
    up: [
        "Up",
        "ArrowUp"
    ],
    left: [
        "Left",
        "ArrowLeft"
    ],
    right: [
        "Right",
        "ArrowRight"
    ],
    down: [
        "Down",
        "ArrowDown"
    ],
    delete: [
        "Backspace",
        "Delete",
        "Del"
    ]
}, $905dbd31c454eff7$var$Fc = function(t1) {
    return "if(".concat(t1, ")return null;");
}, $905dbd31c454eff7$var$Hc = {
    stop: "$event.stopPropagation();",
    prevent: "$event.preventDefault();",
    self: $905dbd31c454eff7$var$Fc("$event.target !== $event.currentTarget"),
    ctrl: $905dbd31c454eff7$var$Fc("!$event.ctrlKey"),
    shift: $905dbd31c454eff7$var$Fc("!$event.shiftKey"),
    alt: $905dbd31c454eff7$var$Fc("!$event.altKey"),
    meta: $905dbd31c454eff7$var$Fc("!$event.metaKey"),
    left: $905dbd31c454eff7$var$Fc("'button' in $event && $event.button !== 0"),
    middle: $905dbd31c454eff7$var$Fc("'button' in $event && $event.button !== 1"),
    right: $905dbd31c454eff7$var$Fc("'button' in $event && $event.button !== 2")
};
function $905dbd31c454eff7$var$Bc(t1, e) {
    var n1 = e ? "nativeOn:" : "on:";
    var o = "", r = "";
    for(var _$e in t1){
        var n2 = $905dbd31c454eff7$var$Uc(t1[_$e]);
        t1[_$e] && t1[_$e].dynamic ? r += "".concat(_$e, ",").concat(n2, ",") : o += '"'.concat(_$e, '":').concat(n2, ",");
    }
    return o = "{".concat(o.slice(0, -1), "}"), r ? n1 + "_d(".concat(o, ",[").concat(r.slice(0, -1), "])") : n1 + o;
}
function $905dbd31c454eff7$var$Uc(t1) {
    if (!t1) return "function(){}";
    if (Array.isArray(t1)) return "[".concat(t1.map(function(t1) {
        return $905dbd31c454eff7$var$Uc(t1);
    }).join(","), "]");
    var e = $905dbd31c454eff7$var$Ic.test(t1.value), n1 = $905dbd31c454eff7$var$Dc.test(t1.value), o = $905dbd31c454eff7$var$Ic.test(t1.value.replace($905dbd31c454eff7$var$Mc, ""));
    if (t1.modifiers) {
        var _loop = function(e1) {
            if ($905dbd31c454eff7$var$Hc[e1]) s += $905dbd31c454eff7$var$Hc[e1], $905dbd31c454eff7$var$Lc[e1] && i.push(e1);
            else if ("exact" === e1) {
                var e = t1.modifiers;
                s += $905dbd31c454eff7$var$Fc([
                    "ctrl",
                    "shift",
                    "alt",
                    "meta"
                ].filter(function(t1) {
                    return !e[t1];
                }).map(function(t1) {
                    return "$event.".concat(t1, "Key");
                }).join("||"));
            } else i.push(e1);
        };
        var r = "", s = "";
        var i = [];
        for(var e1 in t1.modifiers)_loop(e1);
        i.length && (r += function(t1) {
            return "if(!$event.type.indexOf('key')&&".concat(t1.map($905dbd31c454eff7$var$zc).join("&&"), ")return null;");
        }(i)), s && (r += s);
        return "function($event){".concat(r).concat(e ? "return ".concat(t1.value, ".apply(null, arguments)") : n1 ? "return (".concat(t1.value, ").apply(null, arguments)") : o ? "return ".concat(t1.value) : t1.value, "}");
    }
    return e || n1 ? t1.value : "function($event){".concat(o ? "return ".concat(t1.value) : t1.value, "}");
}
function $905dbd31c454eff7$var$zc(t1) {
    var e = parseInt(t1, 10);
    if (e) return "$event.keyCode!==".concat(e);
    var n1 = $905dbd31c454eff7$var$Lc[t1], o = $905dbd31c454eff7$var$Rc[t1];
    return "_k($event.keyCode,".concat(JSON.stringify(t1), ",").concat(JSON.stringify(n1), ",$event.key,").concat(JSON.stringify(o), ")");
}
var $905dbd31c454eff7$var$Vc = {
    on: function on(t1, e) {
        t1.wrapListeners = function(t1) {
            return "_g(".concat(t1, ",").concat(e.value, ")");
        };
    },
    bind: function bind(t1, e) {
        t1.wrapData = function(n1) {
            return "_b(".concat(n1, ",'").concat(t1.tag, "',").concat(e.value, ",").concat(e.modifiers && e.modifiers.prop ? "true" : "false").concat(e.modifiers && e.modifiers.sync ? ",true" : "", ")");
        };
    },
    cloak: $905dbd31c454eff7$var$E
};
var $905dbd31c454eff7$var$Kc = function Kc(t1) {
    (0, $2yCSJ._)(this, Kc);
    this.options = t1, this.warn = t1.warn || $905dbd31c454eff7$var$Or, this.transforms = $905dbd31c454eff7$var$Tr(t1.modules, "transformCode"), this.dataGenFns = $905dbd31c454eff7$var$Tr(t1.modules, "genData"), this.directives = $905dbd31c454eff7$var$A($905dbd31c454eff7$var$A({}, $905dbd31c454eff7$var$Vc), t1.directives);
    var e = t1.isReservedTag || $905dbd31c454eff7$var$N;
    this.maybeComponent = function(t1) {
        return !!t1.component || !e(t1.tag);
    }, this.onceId = 0, this.staticRenderFns = [], this.pre = !1;
};
function $905dbd31c454eff7$var$Jc(t1, e) {
    var n1 = new $905dbd31c454eff7$var$Kc(e);
    return {
        render: "with(this){return ".concat(t1 ? "script" === t1.tag ? "null" : $905dbd31c454eff7$var$qc(t1, n1) : '_c("div")', "}"),
        staticRenderFns: n1.staticRenderFns
    };
}
function $905dbd31c454eff7$var$qc(t1, e) {
    if (t1.parent && (t1.pre = t1.pre || t1.parent.pre), t1.staticRoot && !t1.staticProcessed) return $905dbd31c454eff7$var$Wc(t1, e);
    if (t1.once && !t1.onceProcessed) return $905dbd31c454eff7$var$Zc(t1, e);
    if (t1.for && !t1.forProcessed) return $905dbd31c454eff7$var$Yc(t1, e);
    if (t1.if && !t1.ifProcessed) return $905dbd31c454eff7$var$Gc(t1, e);
    if ("template" !== t1.tag || t1.slotTarget || e.pre) {
        if ("slot" === t1.tag) return function(t1, e) {
            var n1 = t1.slotName || '"default"', o = $905dbd31c454eff7$var$na(t1, e);
            var r = "_t(".concat(n1).concat(o ? ",function(){return ".concat(o, "}") : "");
            var s = t1.attrs || t1.dynamicAttrs ? $905dbd31c454eff7$var$sa((t1.attrs || []).concat(t1.dynamicAttrs || []).map(function(t1) {
                return {
                    name: $905dbd31c454eff7$var$x(t1.name),
                    value: t1.value,
                    dynamic: t1.dynamic
                };
            })) : null, i = t1.attrsMap["v-bind"];
            !s && !i || o || (r += ",null");
            s && (r += ",".concat(s));
            i && (r += "".concat(s ? "" : ",null", ",").concat(i));
            return r + ")";
        }(t1, e);
        {
            var n1;
            if (t1.component) n1 = function(t1, e, n1) {
                var o = e.inlineTemplate ? null : $905dbd31c454eff7$var$na(e, n1, !0);
                return "_c(".concat(t1, ",").concat($905dbd31c454eff7$var$Qc(e, n1)).concat(o ? ",".concat(o) : "", ")");
            }(t1.component, t1, e);
            else {
                var o;
                var r = e.maybeComponent(t1);
                var s;
                (!t1.plain || t1.pre && r) && (o = $905dbd31c454eff7$var$Qc(t1, e));
                var i = e.options.bindings;
                r && i && !1 !== i.__isScriptSetup && (s = function(t1, e) {
                    var n1 = $905dbd31c454eff7$var$x(e), o = $905dbd31c454eff7$var$C(n1), r = function(r) {
                        return t1[e] === r ? e : t1[n1] === r ? n1 : t1[o] === r ? o : void 0;
                    }, s = r("setup-const") || r("setup-reactive-const");
                    if (s) return s;
                    var i = r("setup-let") || r("setup-ref") || r("setup-maybe-ref");
                    if (i) return i;
                }(i, t1.tag)), s || (s = "'".concat(t1.tag, "'"));
                var c = t1.inlineTemplate ? null : $905dbd31c454eff7$var$na(t1, e, !0);
                n1 = "_c(".concat(s).concat(o ? ",".concat(o) : "").concat(c ? ",".concat(c) : "", ")");
            }
            for(var o1 = 0; o1 < e.transforms.length; o1++)n1 = e.transforms[o1](t1, n1);
            return n1;
        }
    }
    return $905dbd31c454eff7$var$na(t1, e) || "void 0";
}
function $905dbd31c454eff7$var$Wc(t1, e) {
    t1.staticProcessed = !0;
    var n1 = e.pre;
    return t1.pre && (e.pre = t1.pre), e.staticRenderFns.push("with(this){return ".concat($905dbd31c454eff7$var$qc(t1, e), "}")), e.pre = n1, "_m(".concat(e.staticRenderFns.length - 1).concat(t1.staticInFor ? ",true" : "", ")");
}
function $905dbd31c454eff7$var$Zc(t1, e) {
    if (t1.onceProcessed = !0, t1.if && !t1.ifProcessed) return $905dbd31c454eff7$var$Gc(t1, e);
    if (t1.staticInFor) {
        var n1 = "", o = t1.parent;
        for(; o;){
            if (o.for) {
                n1 = o.key;
                break;
            }
            o = o.parent;
        }
        return n1 ? "_o(".concat($905dbd31c454eff7$var$qc(t1, e), ",").concat(e.onceId++, ",").concat(n1, ")") : $905dbd31c454eff7$var$qc(t1, e);
    }
    return $905dbd31c454eff7$var$Wc(t1, e);
}
function $905dbd31c454eff7$var$Gc(t1, e, n1, o) {
    return t1.ifProcessed = !0, $905dbd31c454eff7$var$Xc(t1.ifConditions.slice(), e, n1, o);
}
function $905dbd31c454eff7$var$Xc(t1, e, n1, o) {
    if (!t1.length) return o || "_e()";
    var r = t1.shift();
    return r.exp ? "(".concat(r.exp, ")?").concat(s(r.block), ":").concat($905dbd31c454eff7$var$Xc(t1, e, n1, o)) : "".concat(s(r.block));
    function s(t1) {
        return n1 ? n1(t1, e) : t1.once ? $905dbd31c454eff7$var$Zc(t1, e) : $905dbd31c454eff7$var$qc(t1, e);
    }
}
function $905dbd31c454eff7$var$Yc(t1, e, n1, o) {
    var r = t1.for, s = t1.alias, i = t1.iterator1 ? ",".concat(t1.iterator1) : "", c = t1.iterator2 ? ",".concat(t1.iterator2) : "";
    return t1.forProcessed = !0, "".concat(o || "_l", "((").concat(r, "),function(").concat(s).concat(i).concat(c, "){return ").concat((n1 || $905dbd31c454eff7$var$qc)(t1, e), "})");
}
function $905dbd31c454eff7$var$Qc(t1, e) {
    var n1 = "{";
    var o = function(t1, e) {
        var n1 = t1.directives;
        if (!n1) return;
        var o, r, s, i, c = "directives:[", a = !1;
        for(o = 0, r = n1.length; o < r; o++){
            s = n1[o], i = !0;
            var r1 = e.directives[s.name];
            r1 && (i = !!r1(t1, s, e.warn)), i && (a = !0, c += '{name:"'.concat(s.name, '",rawName:"').concat(s.rawName, '"').concat(s.value ? ",value:(".concat(s.value, "),expression:").concat(JSON.stringify(s.value)) : "").concat(s.arg ? ",arg:".concat(s.isDynamicArg ? s.arg : '"'.concat(s.arg, '"')) : "").concat(s.modifiers ? ",modifiers:".concat(JSON.stringify(s.modifiers)) : "", "},"));
        }
        if (a) return c.slice(0, -1) + "]";
    }(t1, e);
    o && (n1 += o + ","), t1.key && (n1 += "key:".concat(t1.key, ",")), t1.ref && (n1 += "ref:".concat(t1.ref, ",")), t1.refInFor && (n1 += "refInFor:true,"), t1.pre && (n1 += "pre:true,"), t1.component && (n1 += 'tag:"'.concat(t1.tag, '",'));
    for(var o1 = 0; o1 < e.dataGenFns.length; o1++)n1 += e.dataGenFns[o1](t1);
    if (t1.attrs && (n1 += "attrs:".concat($905dbd31c454eff7$var$sa(t1.attrs), ",")), t1.props && (n1 += "domProps:".concat($905dbd31c454eff7$var$sa(t1.props), ",")), t1.events && (n1 += "".concat($905dbd31c454eff7$var$Bc(t1.events, !1), ",")), t1.nativeEvents && (n1 += "".concat($905dbd31c454eff7$var$Bc(t1.nativeEvents, !0), ",")), t1.slotTarget && !t1.slotScope && (n1 += "slot:".concat(t1.slotTarget, ",")), t1.scopedSlots && (n1 += "".concat(function(t1, e, n1) {
        var o = t1.for || Object.keys(e).some(function(t1) {
            var n1 = e[t1];
            return n1.slotTargetDynamic || n1.if || n1.for || $905dbd31c454eff7$var$ta(n1);
        }), r = !!t1.if;
        if (!o) {
            var _$e = t1.parent;
            for(; _$e;){
                if (_$e.slotScope && _$e.slotScope !== $905dbd31c454eff7$var$ic || _$e.for) {
                    o = !0;
                    break;
                }
                _$e.if && (r = !0), _$e = _$e.parent;
            }
        }
        var s = Object.keys(e).map(function(t1) {
            return $905dbd31c454eff7$var$ea(e[t1], n1);
        }).join(",");
        return "scopedSlots:_u([".concat(s, "]").concat(o ? ",null,true" : "").concat(!o && r ? ",null,false,".concat(function(t1) {
            var _$e = 5381, n1 = t1.length;
            for(; n1;)_$e = 33 * _$e ^ t1.charCodeAt(--n1);
            return _$e >>> 0;
        }(s)) : "", ")");
    }(t1, t1.scopedSlots, e), ",")), t1.model && (n1 += "model:{value:".concat(t1.model.value, ",callback:").concat(t1.model.callback, ",expression:").concat(t1.model.expression, "},")), t1.inlineTemplate) {
        var o2 = function(t1, e) {
            var n1 = t1.children[0];
            if (n1 && 1 === n1.type) {
                var _$t = $905dbd31c454eff7$var$Jc(n1, e.options);
                return "inlineTemplate:{render:function(){".concat(_$t.render, "},staticRenderFns:[").concat(_$t.staticRenderFns.map(function(t1) {
                    return "function(){".concat(t1, "}");
                }).join(","), "]}");
            }
        }(t1, e);
        o2 && (n1 += "".concat(o2, ","));
    }
    return n1 = n1.replace(/,$/, "") + "}", t1.dynamicAttrs && (n1 = "_b(".concat(n1, ',"').concat(t1.tag, '",').concat($905dbd31c454eff7$var$sa(t1.dynamicAttrs), ")")), t1.wrapData && (n1 = t1.wrapData(n1)), t1.wrapListeners && (n1 = t1.wrapListeners(n1)), n1;
}
function $905dbd31c454eff7$var$ta(t1) {
    return 1 === t1.type && ("slot" === t1.tag || t1.children.some($905dbd31c454eff7$var$ta));
}
function $905dbd31c454eff7$var$ea(t1, e) {
    var n1 = t1.attrsMap["slot-scope"];
    if (t1.if && !t1.ifProcessed && !n1) return $905dbd31c454eff7$var$Gc(t1, e, $905dbd31c454eff7$var$ea, "null");
    if (t1.for && !t1.forProcessed) return $905dbd31c454eff7$var$Yc(t1, e, $905dbd31c454eff7$var$ea);
    var o = t1.slotScope === $905dbd31c454eff7$var$ic ? "" : String(t1.slotScope), r = "function(".concat(o, "){return ").concat("template" === t1.tag ? t1.if && n1 ? "(".concat(t1.if, ")?").concat($905dbd31c454eff7$var$na(t1, e) || "undefined", ":undefined") : $905dbd31c454eff7$var$na(t1, e) || "undefined" : $905dbd31c454eff7$var$qc(t1, e), "}"), s = o ? "" : ",proxy:true";
    return "{key:".concat(t1.slotTarget || '"default"', ",fn:").concat(r).concat(s, "}");
}
function $905dbd31c454eff7$var$na(t1, e, n1, o, r) {
    var s = t1.children;
    if (s.length) {
        var _$t = s[0];
        if (1 === s.length && _$t.for && "template" !== _$t.tag && "slot" !== _$t.tag) {
            var _$r = n1 ? e.maybeComponent(_$t) ? ",1" : ",0" : "";
            return "".concat((o || $905dbd31c454eff7$var$qc)(_$t, e)).concat(_$r);
        }
        var i = n1 ? function(t1, e) {
            var _$n = 0;
            for(var _$o = 0; _$o < t1.length; _$o++){
                var _$r = t1[_$o];
                if (1 === _$r.type) {
                    if ($905dbd31c454eff7$var$oa(_$r) || _$r.ifConditions && _$r.ifConditions.some(function(t1) {
                        return $905dbd31c454eff7$var$oa(t1.block);
                    })) {
                        _$n = 2;
                        break;
                    }
                    (e(_$r) || _$r.ifConditions && _$r.ifConditions.some(function(t1) {
                        return e(t1.block);
                    })) && (_$n = 1);
                }
            }
            return _$n;
        }(s, e.maybeComponent) : 0, c = r || $905dbd31c454eff7$var$ra;
        return "[".concat(s.map(function(t1) {
            return c(t1, e);
        }).join(","), "]").concat(i ? ",".concat(i) : "");
    }
}
function $905dbd31c454eff7$var$oa(t1) {
    return void 0 !== t1.for || "template" === t1.tag || "slot" === t1.tag;
}
function $905dbd31c454eff7$var$ra(t1, e) {
    return 1 === t1.type ? $905dbd31c454eff7$var$qc(t1, e) : 3 === t1.type && t1.isComment ? function(t1) {
        return "_e(".concat(JSON.stringify(t1.text), ")");
    }(t1) : function(t1) {
        return "_v(".concat(2 === t1.type ? t1.expression : $905dbd31c454eff7$var$ia(JSON.stringify(t1.text)), ")");
    }(t1);
}
function $905dbd31c454eff7$var$sa(t1) {
    var e = "", n1 = "";
    for(var o = 0; o < t1.length; o++){
        var r = t1[o], s = $905dbd31c454eff7$var$ia(r.value);
        r.dynamic ? n1 += "".concat(r.name, ",").concat(s, ",") : e += '"'.concat(r.name, '":').concat(s, ",");
    }
    return e = "{".concat(e.slice(0, -1), "}"), n1 ? "_d(".concat(e, ",[").concat(n1.slice(0, -1), "])") : e;
}
function $905dbd31c454eff7$var$ia(t1) {
    return t1.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
function $905dbd31c454eff7$var$ca(t1, e) {
    try {
        return new Function(t1);
    } catch (n1) {
        return e.push({
            err: n1,
            code: t1
        }), $905dbd31c454eff7$var$E;
    }
}
function $905dbd31c454eff7$var$aa(t1) {
    var e = Object.create(null);
    return function(n1, o, r) {
        (o = $905dbd31c454eff7$var$A({}, o)).warn, delete o.warn;
        var s = o.delimiters ? String(o.delimiters) + n1 : n1;
        if (e[s]) return e[s];
        var i = t1(n1, o), c = {}, a = [];
        return c.render = $905dbd31c454eff7$var$ca(i.render, a), c.staticRenderFns = i.staticRenderFns.map(function(t1) {
            return $905dbd31c454eff7$var$ca(t1, a);
        }), e[s] = c;
    };
}
new RegExp("\\b" + "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b") + "\\b"), new RegExp("\\b" + "delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b") + "\\s*\\([^\\)]*\\)");
var $905dbd31c454eff7$var$la = ($905dbd31c454eff7$var$ua = function ua(t1, e) {
    var n1 = $905dbd31c454eff7$var$gc(t1.trim(), e);
    !1 !== e.optimize && $905dbd31c454eff7$var$Ec(n1, e);
    var o = $905dbd31c454eff7$var$Jc(n1, e);
    return {
        ast: n1,
        render: o.render,
        staticRenderFns: o.staticRenderFns
    };
}, function la(t1) {
    function e(e, n1) {
        var o = Object.create(t1), r = [], s = [];
        if (n1) {
            n1.modules && (o.modules = (t1.modules || []).concat(n1.modules)), n1.directives && (o.directives = $905dbd31c454eff7$var$A(Object.create(t1.directives || null), n1.directives));
            for(var _$t in n1)"modules" !== _$t && "directives" !== _$t && (o[_$t] = n1[_$t]);
        }
        o.warn = function(t1, e, n1) {
            (n1 ? s : r).push(t1);
        };
        var i = $905dbd31c454eff7$var$ua(e.trim(), o);
        return i.errors = r, i.tips = s, i;
    }
    return {
        compile: e,
        compileToFunctions: $905dbd31c454eff7$var$aa(e)
    };
});
var $905dbd31c454eff7$var$ua;
var $905dbd31c454eff7$var$_la = $905dbd31c454eff7$var$la($905dbd31c454eff7$var$Oc), $905dbd31c454eff7$var$fa = $905dbd31c454eff7$var$_la.compile, $905dbd31c454eff7$var$da = $905dbd31c454eff7$var$_la.compileToFunctions;
var $905dbd31c454eff7$var$pa;
function $905dbd31c454eff7$var$ha(t1) {
    return $905dbd31c454eff7$var$pa = $905dbd31c454eff7$var$pa || document.createElement("div"), $905dbd31c454eff7$var$pa.innerHTML = t1 ? '<a href="\n"/>' : '<div a="\n"/>', $905dbd31c454eff7$var$pa.innerHTML.indexOf("&#10;") > 0;
}
var $905dbd31c454eff7$var$ma = !!$905dbd31c454eff7$var$q && $905dbd31c454eff7$var$ha(!1), $905dbd31c454eff7$var$ga = !!$905dbd31c454eff7$var$q && $905dbd31c454eff7$var$ha(!0), $905dbd31c454eff7$var$va = $905dbd31c454eff7$var$b(function(t1) {
    var e = $905dbd31c454eff7$var$nr(t1);
    return e && e.innerHTML;
}), $905dbd31c454eff7$var$ya = $905dbd31c454eff7$var$So.prototype.$mount;
$905dbd31c454eff7$var$So.prototype.$mount = function(t1, e) {
    if ((t1 = t1 && $905dbd31c454eff7$var$nr(t1)) === document.body || t1 === document.documentElement) return this;
    var n1 = this.$options;
    if (!n1.render) {
        var _$e = n1.template;
        if (_$e) {
            if ("string" == typeof _$e) "#" === _$e.charAt(0) && (_$e = $905dbd31c454eff7$var$va(_$e));
            else {
                if (!_$e.nodeType) return this;
                _$e = _$e.innerHTML;
            }
        } else t1 && (_$e = function(t1) {
            if (t1.outerHTML) return t1.outerHTML;
            {
                var _$e = document.createElement("div");
                return _$e.appendChild(t1.cloneNode(!0)), _$e.innerHTML;
            }
        }(t1));
        if (_$e) {
            var _da = $905dbd31c454eff7$var$da(_$e, {
                outputSourceRange: !1,
                shouldDecodeNewlines: $905dbd31c454eff7$var$ma,
                shouldDecodeNewlinesForHref: $905dbd31c454eff7$var$ga,
                delimiters: n1.delimiters,
                comments: n1.comments
            }, this), _$t = _da.render, o = _da.staticRenderFns;
            n1.render = _$t, n1.staticRenderFns = o;
        }
    }
    return $905dbd31c454eff7$var$ya.call(this, t1, e);
}, $905dbd31c454eff7$var$So.compile = $905dbd31c454eff7$var$da, $905dbd31c454eff7$var$A($905dbd31c454eff7$var$So, $905dbd31c454eff7$var$Hn), $905dbd31c454eff7$var$So.effect = function(t1, e) {
    var n1 = new $905dbd31c454eff7$var$Kn($905dbd31c454eff7$var$at, t1, $905dbd31c454eff7$var$E, {
        sync: !0
    });
    e && (n1.update = function() {
        e(function() {
            return n1.run();
        });
    });
}, module.exports = $905dbd31c454eff7$var$So;

});
parcelRegister("80pZ5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5d427ac6ed937ad6$export$d60067ff2358eee8; });
function $5d427ac6ed937ad6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5d427ac6ed937ad6$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $5d427ac6ed937ad6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d427ac6ed937ad6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("ddmaO", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $99edb06f4caee105$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $99edb06f4caee105$export$1e71eb4bef00f6b0; });
function $99edb06f4caee105$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("enz33", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a77e668b641a0d33$export$2e2bcd8739ae039; });
var $a77e668b641a0d33$var$scriptExports = {
    name: "app",
    data: function() {
        return {
            msg: "Welcome to Your Vue.js App!"
        };
    }
};
var $a77e668b641a0d33$var$options = typeof $a77e668b641a0d33$var$scriptExports === "function" ? $a77e668b641a0d33$var$scriptExports.options : $a77e668b641a0d33$var$scriptExports;
var $a77e668b641a0d33$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $a77e668b641a0d33$var$options;

});

parcelRegister("9q13L", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $6db75d32fae61afc$export$b3890eb0ae9dca99; }, function (v) { return $6db75d32fae61afc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $6db75d32fae61afc$export$f8436702749526f9; }, function (v) { return $6db75d32fae61afc$export$f8436702749526f9 = v; });
var $6db75d32fae61afc$export$b3890eb0ae9dca99;
var $6db75d32fae61afc$export$f8436702749526f9;
var $6db75d32fae61afc$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm._m(0);
};
var $6db75d32fae61afc$var$staticRenderFns = [
    function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("div", {
            staticClass: "container-fluid page-padding",
            attrs: {
                "id": "NewsApp"
            }
        }, [
            _c("div", {
                staticClass: "heading"
            }, [
                _c("div", {
                    staticClass: "row"
                }, [
                    _c("div", {
                        staticClass: "col-12 col-sm-6 stream"
                    }, [
                        _c("h1", {
                            staticClass: "heading__title"
                        }, [
                            _vm._v("Aktuelles")
                        ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                        staticClass: "col-12 col-sm-6 stream"
                    }, [
                        _c("div", {
                            staticClass: "heading__menu"
                        }, [
                            _c("div", {
                                staticClass: "stream-nav"
                            }, [
                                _c("a", {
                                    staticClass: "stream-nav__button stream-nav__button--prev",
                                    attrs: {
                                        "href": "http://localhost:5000/de/aktuelles/2017/",
                                        "title": "Vorheriges Jahr (2017)"
                                    }
                                }, [
                                    _c("span", {
                                        staticClass: "sr-only"
                                    }, [
                                        _vm._v("(Vorheriges Jahr (2017))")
                                    ])
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                    staticClass: "stream-nav__track"
                                }, [
                                    _c("a", {
                                        staticClass: "stream-nav__item stream-nav__item--active",
                                        attrs: {
                                            "href": "http://localhost:5000/de/aktuelles/2018/",
                                            "title": "Zu Jahr 2018"
                                        }
                                    }, [
                                        _vm._v("\n              2018\n            ")
                                    ]),
                                    _vm._v(" "),
                                    _c("a", {
                                        staticClass: "stream-nav__item",
                                        attrs: {
                                            "href": "http://localhost:5000/de/aktuelles/2017/",
                                            "title": "Zu Jahr 2017"
                                        }
                                    }, [
                                        _vm._v("\n              2017\n            ")
                                    ])
                                ]),
                                _vm._v(" "),
                                _c("a", {
                                    staticClass: "stream-nav__button stream-nav__button--next",
                                    attrs: {
                                        "href": "http://localhost:5000/de/aktuelles/2017/",
                                        "title": "N\xe4chstes Jahr (2017)"
                                    }
                                }, [
                                    _c("span", {
                                        staticClass: "sr-only"
                                    }, [
                                        _vm._v("(N\xe4chstes Jahr (2017))")
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _vm._v(" "),
            _c("div", {
                staticClass: "row pt-3"
            }, [
                _c("div", {
                    staticClass: "col-12 col-md-6"
                }, [
                    _c("div", {
                        staticClass: "streamteaser row swiper-container"
                    }, [
                        _c("div", {
                            staticClass: "swiper-wrapper"
                        }, [
                            _c("div", {
                                staticClass: "streamteaser__item swiper-slide col-12"
                            }, [
                                _c("div", {
                                    staticClass: "row"
                                }, [
                                    _c("div", {
                                        staticClass: "gallery col-12 col-sm-6 col-md-12"
                                    }, [
                                        _c("div", {
                                            staticClass: "gallery-item"
                                        }, [
                                            _c("div", {
                                                staticClass: "caption caption--embed"
                                            }, [
                                                _c("p", {
                                                    staticClass: "caption__text"
                                                }, [
                                                    _vm._v("\n                    Das Gr\xfcnderteam von Trowis.\n                  ")
                                                ]),
                                                _vm._v(" "),
                                                _c("div", {
                                                    staticClass: "caption__author"
                                                }, [
                                                    _vm._v("\n                    Foto: Michael Chlebusch / Klang von Blau\n                  ")
                                                ])
                                            ]),
                                            _vm._v(" "),
                                            _c("a", {
                                                staticClass: "gallery__enlarge",
                                                attrs: {
                                                    "href": "http://localhost:5000/media/images/TCC_trovis.max-1920x1080.jpg",
                                                    "title": "Vergr\xf6\xdfern",
                                                    "data-size": "3031x2022"
                                                }
                                            }, [
                                                _c("img", {
                                                    staticClass: "img-fluid",
                                                    attrs: {
                                                        "src": "http://localhost:5000/media/images/TCC_trovis.2e16d0ba.fill-1040x594.jpg",
                                                        "alt": "",
                                                        "width": "1040",
                                                        "height": "594"
                                                    }
                                                })
                                            ])
                                        ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                        staticClass: "teaser__content col-12 col-sm-6 col-md-12"
                                    }, [
                                        _c("div", {
                                            staticClass: "linkedpage linkedpage--highlighted"
                                        }, [
                                            _vm._v("Technologie Centrum Chemnitz GmbH")
                                        ]),
                                        _vm._v(" "),
                                        _c("h6", {
                                            staticClass: "stream-item__date-category"
                                        }, [
                                            _vm._v("21. Juni 2018")
                                        ]),
                                        _vm._v(" "),
                                        _c("h2", {
                                            staticClass: "stream-item__title stream-item__title--highlighted stream-item__title--balanced"
                                        }, [
                                            _c("a", {
                                                staticClass: "stream-item__title--linked",
                                                attrs: {
                                                    "href": "http://localhost:5000/de/aktuelles/wenn-fasern-stahl-%C3%BCberlegen-sind/"
                                                }
                                            }, [
                                                _vm._v("Wenn Fasern Stahl \xfcberlegen sind")
                                            ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", {
                                            staticClass: "stream-item__content stream-item__content--highlighted stream-item__content--balanced"
                                        }, [
                                            _vm._v("\n                Im Technologie Centrum Chemnitz entwickelt Trowis Faserseile, die solchen aus Stahl in mancherlei Hinsicht \xfcberlegen sind.\n                Im Technologie Centrum Chemnitz ...\n              ")
                                        ])
                                    ])
                                ])
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "streamteaser__item swiper-slide col-12"
                            }, [
                                _c("div", {
                                    staticClass: "row"
                                }, [
                                    _c("div", {
                                        staticClass: "gallery col-12 col-sm-6 col-md-12"
                                    }, [
                                        _c("div", {
                                            staticClass: "gallery-item"
                                        }, [
                                            _c("div", {
                                                staticClass: "caption caption--embed"
                                            }, [
                                                _c("p", {
                                                    staticClass: "caption__text"
                                                }, [
                                                    _vm._v("\n                    Dr. Madlen Wuttke vom Gr\xfcnderteam PIAS berichtete \xfcber ihre Erfahrungen mit dem EXIST-Programm\n                  ")
                                                ]),
                                                _vm._v(" "),
                                                _c("div", {
                                                    staticClass: "caption__author"
                                                }, [
                                                    _vm._v("\n                    Foto: SAXEED\n                  ")
                                                ])
                                            ]),
                                            _vm._v(" "),
                                            _c("a", {
                                                staticClass: "gallery__enlarge",
                                                attrs: {
                                                    "href": "http://localhost:5000/media/images/TCC_Saxeed-Info.max-1920x1080.jpg",
                                                    "title": "Vergr\xf6\xdfern",
                                                    "data-size": "4735x3157"
                                                }
                                            }, [
                                                _c("img", {
                                                    staticClass: "img-fluid",
                                                    attrs: {
                                                        "src": "http://localhost:5000/media/images/TCC_Saxeed-Info.2e16d0ba.fill-1040x594.jpg",
                                                        "alt": "",
                                                        "width": "1040",
                                                        "height": "594"
                                                    }
                                                })
                                            ])
                                        ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                        staticClass: "teaser__content col-12 col-sm-6 col-md-12"
                                    }, [
                                        _c("div", {
                                            staticClass: "linkedpage linkedpage--highlighted"
                                        }, [
                                            _vm._v("Technologie Centrum Chemnitz GmbH")
                                        ]),
                                        _vm._v(" "),
                                        _c("h6", {
                                            staticClass: "stream-item__date-category"
                                        }, [
                                            _vm._v("14. Juni 2018")
                                        ]),
                                        _vm._v(" "),
                                        _c("h2", {
                                            staticClass: "stream-item__title stream-item__title--highlighted stream-item__title--balanced"
                                        }, [
                                            _c("a", {
                                                staticClass: "stream-item__title--linked",
                                                attrs: {
                                                    "href": "http://localhost:5000/de/aktuelles/f%C3%B6rderungen-und-fallstricke/"
                                                }
                                            }, [
                                                _vm._v("F\xf6rderungen und Fallstricke")
                                            ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", {
                                            staticClass: "stream-item__content stream-item__content--highlighted stream-item__content--balanced"
                                        }, [
                                            _vm._v('\n                Der Info-Abend "Forschung nutzbar machen" gab in Chemnitz Einblicke in etablierte, ge\xe4nderte und neue F\xf6rderm\xf6glichkeiten\n                Reichlich Informationen zu F\xf6rderprogrammen f\xfcr ...\n              ')
                                        ])
                                    ])
                                ])
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "streamteaser__item swiper-slide col-12"
                            }, [
                                _c("div", {
                                    staticClass: "row"
                                }, [
                                    _c("div", {
                                        staticClass: "gallery col-12 col-sm-6 col-md-12"
                                    }, [
                                        _c("div", {
                                            staticClass: "gallery-item"
                                        }, [
                                            _c("div", {
                                                staticClass: "caption caption--embed"
                                            }, [
                                                _c("p", {
                                                    staticClass: "caption__text"
                                                }, [
                                                    _vm._v('\n                    Das Team im "Solution Center Chemnitz" der GMVT mbH k\xfcmmert sich um Kunden in Mitteldeutschland.\n                  ')
                                                ]),
                                                _vm._v(" "),
                                                _c("div", {
                                                    staticClass: "caption__author"
                                                }, [
                                                    _vm._v("\n                    Foto: Michael Chlebusch / Klang von Blau\n                  ")
                                                ])
                                            ]),
                                            _vm._v(" "),
                                            _c("a", {
                                                staticClass: "gallery__enlarge",
                                                attrs: {
                                                    "href": "http://localhost:5000/media/images/gmvt.max-1920x1080.jpg",
                                                    "title": "Vergr\xf6\xdfern",
                                                    "data-size": "3031x2022"
                                                }
                                            }, [
                                                _c("img", {
                                                    staticClass: "img-fluid",
                                                    attrs: {
                                                        "src": "http://localhost:5000/media/images/gmvt.2e16d0ba.fill-1040x594.jpg",
                                                        "alt": "",
                                                        "width": "1040",
                                                        "height": "594"
                                                    }
                                                })
                                            ])
                                        ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                        staticClass: "teaser__content col-12 col-sm-6 col-md-12"
                                    }, [
                                        _c("h6", {
                                            staticClass: "stream-item__date-category"
                                        }, [
                                            _vm._v("8. Juni 2018")
                                        ]),
                                        _vm._v(" "),
                                        _c("h2", {
                                            staticClass: "stream-item__title stream-item__title--highlighted stream-item__title--balanced"
                                        }, [
                                            _c("a", {
                                                staticClass: "stream-item__title--linked",
                                                attrs: {
                                                    "href": "http://localhost:5000/de/aktuelles/automatisierung-vom-profi/"
                                                }
                                            }, [
                                                _vm._v("Automatisierung vom Profi")
                                            ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", {
                                            staticClass: "stream-item__content stream-item__content--highlighted stream-item__content--balanced"
                                        }, [
                                            _vm._v("\n                Die GMVT mbH er\xf6ffnet einen zweiten Standort im Technologie Centrum Chemnitz. Die GMVT mbH wurde 2000 im bayrischen Ichenhausen\n                gegr\xfcndet ...\n              ")
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "swiper-pagination"
                        })
                    ])
                ]),
                _vm._v(" "),
                _c("div", {
                    staticClass: "col-12 col-sm-9 col-md-6 stream__content"
                }, [
                    _c("div", {
                        staticClass: "slider stream__content--slider"
                    }, [
                        _c("div", {
                            staticClass: "item",
                            attrs: {
                                "data-year": "2018"
                            }
                        }, [
                            _c("div", {
                                staticClass: "stream__content--year-hint d-block d-md-none"
                            }, [
                                _c("h4", {
                                    staticClass: "heading__title"
                                }, [
                                    _vm._v("\n            Alle Beitr\xe4ge von 2018\n          ")
                                ])
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "linkedpage"
                            }, [
                                _vm._v("Technologie Centrum Chemnitz GmbH")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "stream-item"
                            }, [
                                _c("h6", {
                                    staticClass: "stream-item__date-category"
                                }, [
                                    _vm._v("21. Juni 2018")
                                ]),
                                _vm._v(" "),
                                _c("h4", {
                                    staticClass: "stream-item__title"
                                }, [
                                    _c("a", {
                                        staticClass: "stream-item__title--linked",
                                        attrs: {
                                            "href": "http://localhost:5000/de/aktuelles/wenn-fasern-stahl-%C3%BCberlegen-sind/"
                                        }
                                    }, [
                                        _vm._v("Wenn Fa\xadsern Stahl \xfcber\xadle\xadgen sind")
                                    ])
                                ]),
                                _vm._v(" "),
                                _c("p", {
                                    staticClass: "stream-item__content"
                                }, [
                                    _vm._v("Im Technologie Centrum Chemnitz entwickelt Trowis Faserseile, die solchen aus Stahl in mancherlei Hinsicht \xfcberlegen\n            sind. Im Technologie Centrum Chemnitz ...")
                                ])
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "linkedpage"
                            }, [
                                _vm._v("Technologie Centrum Chemnitz GmbH")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "stream-item"
                            }, [
                                _c("h6", {
                                    staticClass: "stream-item__date-category"
                                }, [
                                    _vm._v("14. Juni 2018")
                                ]),
                                _vm._v(" "),
                                _c("h4", {
                                    staticClass: "stream-item__title"
                                }, [
                                    _c("a", {
                                        staticClass: "stream-item__title--linked",
                                        attrs: {
                                            "href": "http://localhost:5000/de/aktuelles/f%C3%B6rderungen-und-fallstricke/"
                                        }
                                    }, [
                                        _vm._v("F\xf6r\xadde\xadrun\xadgen und Fall\xadstri\xadcke")
                                    ])
                                ]),
                                _vm._v(" "),
                                _c("p", {
                                    staticClass: "stream-item__content"
                                }, [
                                    _vm._v('Der Info-Abend "Forschung nutzbar machen" gab in Chemnitz Einblicke in etablierte, ge\xe4nderte und neue\n            F\xf6rderm\xf6glichkeiten Reichlich Informationen zu F\xf6rderprogrammen f\xfcr ...')
                                ])
                            ]),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "stream-item"
                            }, [
                                _c("h6", {
                                    staticClass: "stream-item__date-category"
                                }, [
                                    _vm._v("8. Juni 2018")
                                ]),
                                _vm._v(" "),
                                _c("h4", {
                                    staticClass: "stream-item__title"
                                }, [
                                    _c("a", {
                                        staticClass: "stream-item__title--linked",
                                        attrs: {
                                            "href": "http://localhost:5000/de/aktuelles/automatisierung-vom-profi/"
                                        }
                                    }, [
                                        _vm._v("Au\xadto\xadma\xadti\xadsie\xadrung vom Profi")
                                    ])
                                ]),
                                _vm._v(" "),
                                _c("p", {
                                    staticClass: "stream-item__content"
                                }, [
                                    _vm._v("Die GMVT mbH er\xf6ffnet einen zweiten Standort im Technologie Centrum Chemnitz. Die GMVT mbH wurde 2000 im bayrischen\n            Ichenhausen gegr\xfcndet ...")
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ]);
    }
];
$6db75d32fae61afc$export$b3890eb0ae9dca99 = $6db75d32fae61afc$var$render;
$6db75d32fae61afc$export$f8436702749526f9 = $6db75d32fae61afc$var$staticRenderFns;

});

parcelRegister("aHthO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ca4a329d0634754$export$2e2bcd8739ae039; });
var $7ca4a329d0634754$var$NOOP = function() {};
var $7ca4a329d0634754$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("2iPxl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1ad53d55b0ac2844$export$2e2bcd8739ae039; });

var $5LNuC = parcelRequire("5LNuC");

var $kJm69 = parcelRequire("kJm69");

var $9ODLq = parcelRequire("9ODLq");
parcelRequire("cEFUb");

var $jeU0p = parcelRequire("jeU0p");

var $kCDa9 = parcelRequire("kCDa9");

var $fEbUF = parcelRequire("fEbUF");
var $1ad53d55b0ac2844$var$MemberIcon = {
    path: "M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z",
    fillColor: "#42166a",
    fillOpacity: 0.85,
    strokeWeight: 1,
    strokeColor: "#00a095",
    strokeOpacity: 0.5,
    labelOrigin: {
        x: 12,
        y: 12
    },
    anchor: {
        x: 12,
        y: 24
    },
    scale: 1.33
};
var $1ad53d55b0ac2844$var$LocationIcon = {
    path: "M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z",
    fillColor: "#00b598",
    fillOpacity: 0.85,
    strokeWeight: 1,
    strokeColor: "#00a095",
    strokeOpacity: 0.5,
    labelOrigin: {
        x: 12,
        y: 12
    },
    anchor: {
        x: 12,
        y: 24
    },
    scale: 1.25
};
var $1ad53d55b0ac2844$var$defaultBreakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
var $1ad53d55b0ac2844$var$defaultZoom = 9;
var $1ad53d55b0ac2844$var$defaultZooms = {
    default: $1ad53d55b0ac2844$var$defaultZoom
};
var $1ad53d55b0ac2844$var$scriptExports = {
    name: "TZMap",
    props: {
        zooms: Object,
        breakpoints: Object,
        showLocations: {
            type: Boolean,
            default: false
        },
        center: {
            type: Object,
            default: {
                lat: 50.961169,
                lng: 13.329005
            }
        }
    },
    data: function() {
        return {
            members: [],
            locations: [],
            zoom: 10,
            paths: (0, $kCDa9.default),
            mapStyles: (0, $jeU0p.default),
            infoContent: "",
            infoWindowPos: null,
            infoIsOpen: false,
            currentInfoIndex: null,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -55
                }
            }
        };
    },
    mounted: function() {
        window.addEventListener("resize", this.handleResize);
        (0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).delay(this.loadMembers, 50);
        if (this.showLocations) (0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).delay(this.loadAddionalLocations, 150);
        this.handleResize();
    },
    computed: {
        _breakpoints: function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).merge($1ad53d55b0ac2844$var$defaultBreakpoints, this.breakpoints);
        },
        _zooms: function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).merge($1ad53d55b0ac2844$var$defaultZooms, this.zooms);
        },
        markers: function markers() {
            var _this = this;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).remove((0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).union((0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).map(this.members, function(member) {
                try {
                    var _member_seat_detail_geolocation = member.seat_detail.geolocation, lat = _member_seat_detail_geolocation.lat, lng = _member_seat_detail_geolocation.lng;
                    var data = {
                        city: member.seat_detail.main_address.city,
                        title: member.title,
                        url: member.meta.html_url
                    };
                    var contentString = '<div class="marker"><div class="marker__city">' + data.city + "</div>" + '<div class="marker__title"><a href="' + data.url + '">' + data.title + "</a></div>" + "</div>";
                    return {
                        position: {
                            lat: parseFloat(lat),
                            lng: parseFloat(lng)
                        },
                        data: contentString,
                        icon: (0, $kJm69._)((0, $5LNuC._)({}, $1ad53d55b0ac2844$var$MemberIcon), {
                            scale: $1ad53d55b0ac2844$var$MemberIcon.scale * (_this.zoom / $1ad53d55b0ac2844$var$defaultZoom)
                        })
                    };
                } catch (error) {}
            }), (0, (/*@__PURE__*/$parcel$interopDefault($fEbUF))).map(this.locations, function(location) {
                try {
                    var _location_geolocation = location.geolocation, lat = _location_geolocation.lat, lng = _location_geolocation.lng;
                    var data = {
                        city: location.main_address.city,
                        title: location.title,
                        url: location.meta.html_url
                    };
                    var contentString = '<div class="marker"><div class="marker__city">' + data.city + "</div>" + '<div class="marker__title"><a href="' + data.url + '">' + data.title + "</a></div>" + "</div>";
                    return {
                        position: {
                            lat: parseFloat(lat),
                            lng: parseFloat(lng)
                        },
                        data: contentString,
                        icon: (0, $kJm69._)((0, $5LNuC._)({}, $1ad53d55b0ac2844$var$LocationIcon), {
                            scale: $1ad53d55b0ac2844$var$LocationIcon.scale * (_this.zoom / $1ad53d55b0ac2844$var$defaultZoom)
                        })
                    };
                } catch (error) {}
            })), function(i) {
                return i;
            });
        }
    },
    methods: {
        handleResize: function() {
            var clientWidth = window.innerWidth;
            var possibleBreakpoints = [
                "default"
            ];
            for(var breakpoint in this._breakpoints)if (this._breakpoints.hasOwnProperty(breakpoint)) {
                var minWidth = this._breakpoints[breakpoint];
                if (clientWidth > minWidth) possibleBreakpoints.push(breakpoint);
            }
            for(var i = possibleBreakpoints.length - 1; i >= 0; i--){
                var possibleBreakpoint = possibleBreakpoints[i];
                if (this._zooms.hasOwnProperty(possibleBreakpoint)) {
                    this.zoom = this._zooms[possibleBreakpoint];
                    return;
                }
            }
            this.zoom = $1ad53d55b0ac2844$var$defaultZoom;
        },
        loadMembers: function() {
            var _this = this;
            (0, (/*@__PURE__*/$parcel$interopDefault($9ODLq))).get("/api/v2/members/?fields=seat_detail").then(function(response) {
                _this.members = response.data.items;
            });
        },
        loadAddionalLocations: function() {
            var _this = this;
            (0, (/*@__PURE__*/$parcel$interopDefault($9ODLq))).get("/api/v2/locations/?seat_of__isnull=True&fields=*").then(function(response) {
                _this.locations = response.data.items;
            });
        },
        toggleInfoWindow: function toggleInfoWindow(marker, index) {
            var isVisible = false;
            if (this.currentInfoIndex == index) // same marker was so toggle
            isVisible = !this.infoIsOpen;
            else // new marker selected so show
            isVisible = true;
            // init, hide box
            this.infoIsOpen = false;
            if (isVisible && marker) {
                var position = marker.position, data = marker.data;
                this.infoWindowPos = position;
                this.infoContent = data;
            } else {
                this.infoWindowPos = null;
                this.infoContent = "";
            }
            // set new states
            this.infoIsOpen = isVisible;
            this.currentInfoIndex = index;
        }
    }
};
var $1ad53d55b0ac2844$var$options = typeof $1ad53d55b0ac2844$var$scriptExports === "function" ? $1ad53d55b0ac2844$var$scriptExports.options : $1ad53d55b0ac2844$var$scriptExports;
var $1ad53d55b0ac2844$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $1ad53d55b0ac2844$var$options;

});
parcelRegister("5LNuC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4337bbcbab01b66b$export$581ff339ea0ba762; });

var $ddmaO = parcelRequire("ddmaO");
function $4337bbcbab01b66b$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $ddmaO._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("kJm69", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f17926d94fac1fd9$export$4fa2f4023c9cbda5; });
function $f17926d94fac1fd9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17926d94fac1fd9$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17926d94fac1fd9$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("9ODLq", function(module, exports) {

module.exports = (parcelRequire("aPVgy"));

});
parcelRegister("aPVgy", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");

var $1UF5R = parcelRequire("1UF5R");

var $8mJdi = parcelRequire("8mJdi");

var $iFNhA = parcelRequire("iFNhA");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $7e3b16a1e0915233$var$createInstance(defaultConfig) {
    var context = new $8mJdi(defaultConfig);
    var instance = $1UF5R($8mJdi.prototype.request, context);
    // Copy axios.prototype to instance
    $439dX.extend(instance, $8mJdi.prototype, context);
    // Copy context to instance
    $439dX.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $7e3b16a1e0915233$var$axios = $7e3b16a1e0915233$var$createInstance($iFNhA);
// Expose Axios class to allow class inheritance
$7e3b16a1e0915233$var$axios.Axios = $8mJdi;
// Factory for creating new instances
$7e3b16a1e0915233$var$axios.create = function create(instanceConfig) {
    return $7e3b16a1e0915233$var$createInstance($439dX.merge($iFNhA, instanceConfig));
};

// Expose Cancel & CancelToken
$7e3b16a1e0915233$var$axios.Cancel = (parcelRequire("jXUdm"));

$7e3b16a1e0915233$var$axios.CancelToken = (parcelRequire("cZVi6"));

$7e3b16a1e0915233$var$axios.isCancel = (parcelRequire("ktxWx"));
// Expose all/spread
$7e3b16a1e0915233$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$7e3b16a1e0915233$var$axios.spread = (parcelRequire("6omYQ"));
module.exports = $7e3b16a1e0915233$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $7e3b16a1e0915233$var$axios;

});
parcelRegister("439dX", function(module, exports) {
"use strict";

var $1UF5R = parcelRequire("1UF5R");

var $jOvvp = parcelRequire("jOvvp");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $2f2e98f5b0943f42$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $2f2e98f5b0943f42$var$isArray(val) {
    return $2f2e98f5b0943f42$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $2f2e98f5b0943f42$var$isArrayBuffer(val) {
    return $2f2e98f5b0943f42$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $2f2e98f5b0943f42$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $2f2e98f5b0943f42$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $2f2e98f5b0943f42$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $2f2e98f5b0943f42$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $2f2e98f5b0943f42$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $2f2e98f5b0943f42$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $2f2e98f5b0943f42$var$isDate(val) {
    return $2f2e98f5b0943f42$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $2f2e98f5b0943f42$var$isFile(val) {
    return $2f2e98f5b0943f42$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $2f2e98f5b0943f42$var$isBlob(val) {
    return $2f2e98f5b0943f42$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $2f2e98f5b0943f42$var$isFunction(val) {
    return $2f2e98f5b0943f42$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $2f2e98f5b0943f42$var$isStream(val) {
    return $2f2e98f5b0943f42$var$isObject(val) && $2f2e98f5b0943f42$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $2f2e98f5b0943f42$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $2f2e98f5b0943f42$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */ function $2f2e98f5b0943f42$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && navigator.product === "ReactNative") return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $2f2e98f5b0943f42$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($2f2e98f5b0943f42$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $2f2e98f5b0943f42$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $2f2e98f5b0943f42$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$2f2e98f5b0943f42$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $2f2e98f5b0943f42$var$extend(a, b, thisArg) {
    $2f2e98f5b0943f42$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $1UF5R(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $2f2e98f5b0943f42$var$isArray,
    isArrayBuffer: $2f2e98f5b0943f42$var$isArrayBuffer,
    isBuffer: $jOvvp,
    isFormData: $2f2e98f5b0943f42$var$isFormData,
    isArrayBufferView: $2f2e98f5b0943f42$var$isArrayBufferView,
    isString: $2f2e98f5b0943f42$var$isString,
    isNumber: $2f2e98f5b0943f42$var$isNumber,
    isObject: $2f2e98f5b0943f42$var$isObject,
    isUndefined: $2f2e98f5b0943f42$var$isUndefined,
    isDate: $2f2e98f5b0943f42$var$isDate,
    isFile: $2f2e98f5b0943f42$var$isFile,
    isBlob: $2f2e98f5b0943f42$var$isBlob,
    isFunction: $2f2e98f5b0943f42$var$isFunction,
    isStream: $2f2e98f5b0943f42$var$isStream,
    isURLSearchParams: $2f2e98f5b0943f42$var$isURLSearchParams,
    isStandardBrowserEnv: $2f2e98f5b0943f42$var$isStandardBrowserEnv,
    forEach: $2f2e98f5b0943f42$var$forEach,
    merge: $2f2e98f5b0943f42$var$merge,
    extend: $2f2e98f5b0943f42$var$extend,
    trim: $2f2e98f5b0943f42$var$trim
};

});
parcelRegister("1UF5R", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});

parcelRegister("jOvvp", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});


parcelRegister("8mJdi", function(module, exports) {
"use strict";

var $iFNhA = parcelRequire("iFNhA");

var $439dX = parcelRequire("439dX");

var $isWS7 = parcelRequire("isWS7");

var $53yuD = parcelRequire("53yuD");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $617373407b7de009$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $isWS7(),
        response: new $isWS7()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $617373407b7de009$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") config = $439dX.merge({
        url: arguments[0]
    }, arguments[1]);
    config = $439dX.merge($iFNhA, {
        method: "get"
    }, this.defaults, config);
    config.method = config.method.toLowerCase();
    // Hook up interceptors middleware
    var chain = [
        $53yuD,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
// Provide aliases for supported request methods
$439dX.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $617373407b7de009$var$Axios.prototype[method] = function(url, config) {
        return this.request($439dX.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$439dX.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $617373407b7de009$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($439dX.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $617373407b7de009$var$Axios;

});
parcelRegister("iFNhA", function(module, exports) {

var $iVtIh = parcelRequire("iVtIh");
"use strict";

var $439dX = parcelRequire("439dX");

var $kCkdf = parcelRequire("kCkdf");
var $d98248db5496e05d$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $d98248db5496e05d$var$setContentTypeIfUnset(headers, value) {
    if (!$439dX.isUndefined(headers) && $439dX.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $d98248db5496e05d$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("21Y2J"));
    else if (typeof $iVtIh !== "undefined") // For node use HTTP adapter
    adapter = (parcelRequire("21Y2J"));
    return adapter;
}
var $d98248db5496e05d$var$defaults = {
    adapter: $d98248db5496e05d$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kCkdf(headers, "Content-Type");
            if ($439dX.isFormData(data) || $439dX.isArrayBuffer(data) || $439dX.isBuffer(data) || $439dX.isStream(data) || $439dX.isFile(data) || $439dX.isBlob(data)) return data;
            if ($439dX.isArrayBufferView(data)) return data.buffer;
            if ($439dX.isURLSearchParams(data)) {
                $d98248db5496e05d$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($439dX.isObject(data)) {
                $d98248db5496e05d$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$d98248db5496e05d$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$439dX.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $d98248db5496e05d$var$defaults.headers[method] = {};
});
$439dX.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $d98248db5496e05d$var$defaults.headers[method] = $439dX.merge($d98248db5496e05d$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $d98248db5496e05d$var$defaults;

});
parcelRegister("iVtIh", function(module, exports) {
// shim for using process in browser
var $dc74994bdfebe31c$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $dc74994bdfebe31c$var$cachedSetTimeout;
var $dc74994bdfebe31c$var$cachedClearTimeout;
function $dc74994bdfebe31c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $dc74994bdfebe31c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $dc74994bdfebe31c$var$cachedSetTimeout = setTimeout;
        else $dc74994bdfebe31c$var$cachedSetTimeout = $dc74994bdfebe31c$var$defaultSetTimout;
    } catch (e) {
        $dc74994bdfebe31c$var$cachedSetTimeout = $dc74994bdfebe31c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $dc74994bdfebe31c$var$cachedClearTimeout = clearTimeout;
        else $dc74994bdfebe31c$var$cachedClearTimeout = $dc74994bdfebe31c$var$defaultClearTimeout;
    } catch (e) {
        $dc74994bdfebe31c$var$cachedClearTimeout = $dc74994bdfebe31c$var$defaultClearTimeout;
    }
})();
function $dc74994bdfebe31c$var$runTimeout(fun) {
    if ($dc74994bdfebe31c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($dc74994bdfebe31c$var$cachedSetTimeout === $dc74994bdfebe31c$var$defaultSetTimout || !$dc74994bdfebe31c$var$cachedSetTimeout) && setTimeout) {
        $dc74994bdfebe31c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dc74994bdfebe31c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $dc74994bdfebe31c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $dc74994bdfebe31c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $dc74994bdfebe31c$var$runClearTimeout(marker) {
    if ($dc74994bdfebe31c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($dc74994bdfebe31c$var$cachedClearTimeout === $dc74994bdfebe31c$var$defaultClearTimeout || !$dc74994bdfebe31c$var$cachedClearTimeout) && clearTimeout) {
        $dc74994bdfebe31c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dc74994bdfebe31c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $dc74994bdfebe31c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $dc74994bdfebe31c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $dc74994bdfebe31c$var$queue = [];
var $dc74994bdfebe31c$var$draining = false;
var $dc74994bdfebe31c$var$currentQueue;
var $dc74994bdfebe31c$var$queueIndex = -1;
function $dc74994bdfebe31c$var$cleanUpNextTick() {
    if (!$dc74994bdfebe31c$var$draining || !$dc74994bdfebe31c$var$currentQueue) return;
    $dc74994bdfebe31c$var$draining = false;
    if ($dc74994bdfebe31c$var$currentQueue.length) $dc74994bdfebe31c$var$queue = $dc74994bdfebe31c$var$currentQueue.concat($dc74994bdfebe31c$var$queue);
    else $dc74994bdfebe31c$var$queueIndex = -1;
    if ($dc74994bdfebe31c$var$queue.length) $dc74994bdfebe31c$var$drainQueue();
}
function $dc74994bdfebe31c$var$drainQueue() {
    if ($dc74994bdfebe31c$var$draining) return;
    var timeout = $dc74994bdfebe31c$var$runTimeout($dc74994bdfebe31c$var$cleanUpNextTick);
    $dc74994bdfebe31c$var$draining = true;
    var len = $dc74994bdfebe31c$var$queue.length;
    while(len){
        $dc74994bdfebe31c$var$currentQueue = $dc74994bdfebe31c$var$queue;
        $dc74994bdfebe31c$var$queue = [];
        while(++$dc74994bdfebe31c$var$queueIndex < len)if ($dc74994bdfebe31c$var$currentQueue) $dc74994bdfebe31c$var$currentQueue[$dc74994bdfebe31c$var$queueIndex].run();
        $dc74994bdfebe31c$var$queueIndex = -1;
        len = $dc74994bdfebe31c$var$queue.length;
    }
    $dc74994bdfebe31c$var$currentQueue = null;
    $dc74994bdfebe31c$var$draining = false;
    $dc74994bdfebe31c$var$runClearTimeout(timeout);
}
$dc74994bdfebe31c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $dc74994bdfebe31c$var$queue.push(new $dc74994bdfebe31c$var$Item(fun, args));
    if ($dc74994bdfebe31c$var$queue.length === 1 && !$dc74994bdfebe31c$var$draining) $dc74994bdfebe31c$var$runTimeout($dc74994bdfebe31c$var$drainQueue);
};
// v8 likes predictible objects
function $dc74994bdfebe31c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$dc74994bdfebe31c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$dc74994bdfebe31c$var$process.title = "browser";
$dc74994bdfebe31c$var$process.browser = true;
$dc74994bdfebe31c$var$process.env = {};
$dc74994bdfebe31c$var$process.argv = [];
$dc74994bdfebe31c$var$process.version = ""; // empty string to avoid regexp issues
$dc74994bdfebe31c$var$process.versions = {};
function $dc74994bdfebe31c$var$noop() {}
$dc74994bdfebe31c$var$process.on = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.addListener = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.once = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.off = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.removeListener = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.removeAllListeners = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.emit = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.prependListener = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.prependOnceListener = $dc74994bdfebe31c$var$noop;
$dc74994bdfebe31c$var$process.listeners = function(name) {
    return [];
};
$dc74994bdfebe31c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$dc74994bdfebe31c$var$process.cwd = function() {
    return "/";
};
$dc74994bdfebe31c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$dc74994bdfebe31c$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kCkdf", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $439dX.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("21Y2J", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");

var $boISI = parcelRequire("boISI");

var $8GT3y = parcelRequire("8GT3y");

var $cjERo = parcelRequire("cjERo");

var $d5eq1 = parcelRequire("d5eq1");

var $410PL = parcelRequire("410PL");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($439dX.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        request.open(config.method.toUpperCase(), $8GT3y(config.url, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $cjERo(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $boISI(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($410PL("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            reject($410PL("timeout of " + config.timeout + "ms exceeded", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($439dX.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("cougo"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $d5eq1(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $439dX.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (config.withCredentials) request.withCredentials = true;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("boISI", function(module, exports) {
"use strict";

var $410PL = parcelRequire("410PL");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    // Note: status is not exposed by XDomainRequest
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($410PL("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("410PL", function(module, exports) {
"use strict";

var $luM4n = parcelRequire("luM4n");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $luM4n(error, config, code, request, response);
};

});
parcelRegister("luM4n", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    return error;
};

});



parcelRegister("8GT3y", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
function $653cf400ccf9b655$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($439dX.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $439dX.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($439dX.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $439dX.forEach(val, function parseValue(v) {
                if ($439dX.isDate(v)) v = v.toISOString();
                else if ($439dX.isObject(v)) v = JSON.stringify(v);
                parts.push($653cf400ccf9b655$var$encode(key) + "=" + $653cf400ccf9b655$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    return url;
};

});

parcelRegister("cjERo", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $8f76f4629bb51c81$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $439dX.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $439dX.trim(line.substr(0, i)).toLowerCase();
        val = $439dX.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $8f76f4629bb51c81$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("d5eq1", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
module.exports = $439dX.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $439dX.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("cougo", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
module.exports = $439dX.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($439dX.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($439dX.isString(path)) cookie.push("path=" + path);
            if ($439dX.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});



parcelRegister("isWS7", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
function $d718824168b0d17f$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $d718824168b0d17f$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $d718824168b0d17f$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $d718824168b0d17f$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $439dX.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $d718824168b0d17f$var$InterceptorManager;

});

parcelRegister("53yuD", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");

var $5zFxy = parcelRequire("5zFxy");

var $ktxWx = parcelRequire("ktxWx");

var $iFNhA = parcelRequire("iFNhA");

var $ludyA = parcelRequire("ludyA");

var $1fITD = parcelRequire("1fITD");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $3ae7fd3398873b03$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $3ae7fd3398873b03$var$throwIfCancellationRequested(config);
    // Support baseURL config
    if (config.baseURL && !$ludyA(config.url)) config.url = $1fITD(config.baseURL, config.url);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $5zFxy(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $439dX.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    $439dX.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $iFNhA.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $3ae7fd3398873b03$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $5zFxy(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$ktxWx(reason)) {
            $3ae7fd3398873b03$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $5zFxy(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("5zFxy", function(module, exports) {
"use strict";

var $439dX = parcelRequire("439dX");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $439dX.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("ktxWx", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("ludyA", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("1fITD", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});



parcelRegister("jXUdm", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $e88f220f45caedb4$var$Cancel(message) {
    this.message = message;
}
$e88f220f45caedb4$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$e88f220f45caedb4$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $e88f220f45caedb4$var$Cancel;

});

parcelRegister("cZVi6", function(module, exports) {
"use strict";

var $jXUdm = parcelRequire("jXUdm");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $97679f560991cf45$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $jXUdm(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $97679f560991cf45$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $97679f560991cf45$var$CancelToken.source = function source() {
    var cancel;
    var token = new $97679f560991cf45$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $97679f560991cf45$var$CancelToken;

});

parcelRegister("6omYQ", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});



parcelRegister("cEFUb", function(module, exports) {
var $9369b9f0cd181052$export$2e2bcd8739ae039 = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "stylers": [
            {
                "color": "#d7e5ea"
            },
            {
                "visibility": "on"
            }
        ]
    }
];

});

parcelRegister("jeU0p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e01ac4a75685f7c4$export$2e2bcd8739ae039; });
var $e01ac4a75685f7c4$export$2e2bcd8739ae039 = [
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#878787"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f9f5ed"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#8abf89"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "transit.station.airport",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#aee0f4"
            }
        ]
    }
];

});

parcelRegister("kCDa9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f035bc24b5c910cd$export$2e2bcd8739ae039; });
var $f035bc24b5c910cd$export$2e2bcd8739ae039 = [
    {
        lng: 12.7275907,
        lat: 50.8170908
    },
    {
        lng: 12.7287901,
        lat: 50.8189047
    },
    {
        lng: 12.731847,
        lat: 50.8203998
    },
    {
        lng: 12.7351288,
        lat: 50.822619
    },
    {
        lng: 12.7367509,
        lat: 50.8232745
    },
    {
        lng: 12.7367943,
        lat: 50.8255433
    },
    {
        lng: 12.736776,
        lat: 50.8272027
    },
    {
        lng: 12.736998,
        lat: 50.8277219
    },
    {
        lng: 12.737352,
        lat: 50.8285496
    },
    {
        lng: 12.7377941,
        lat: 50.8288951
    },
    {
        lng: 12.7385449,
        lat: 50.8291515
    },
    {
        lng: 12.7388092,
        lat: 50.8293333
    },
    {
        lng: 12.7396751,
        lat: 50.8295062
    },
    {
        lng: 12.7401664,
        lat: 50.8294433
    },
    {
        lng: 12.7409439,
        lat: 50.8293214
    },
    {
        lng: 12.7417523,
        lat: 50.8290486
    },
    {
        lng: 12.7417342,
        lat: 50.8283149
    },
    {
        lng: 12.744012,
        lat: 50.8281559
    },
    {
        lng: 12.7449747,
        lat: 50.8283168
    },
    {
        lng: 12.7457486,
        lat: 50.8279353
    },
    {
        lng: 12.7463338,
        lat: 50.8275239
    },
    {
        lng: 12.7472965,
        lat: 50.8273034
    },
    {
        lng: 12.7480317,
        lat: 50.8270182
    },
    {
        lng: 12.7484572,
        lat: 50.8263158
    },
    {
        lng: 12.7488653,
        lat: 50.8257099
    },
    {
        lng: 12.7491054,
        lat: 50.8253525
    },
    {
        lng: 12.7497026,
        lat: 50.824979
    },
    {
        lng: 12.7508927,
        lat: 50.8243376
    },
    {
        lng: 12.7528461,
        lat: 50.824382
    },
    {
        lng: 12.7530349,
        lat: 50.8248053
    },
    {
        lng: 12.7535456,
        lat: 50.8243586
    },
    {
        lng: 12.7545221,
        lat: 50.8228075
    },
    {
        lng: 12.7551219,
        lat: 50.8225217
    },
    {
        lng: 12.7563247,
        lat: 50.8230006
    },
    {
        lng: 12.7572481,
        lat: 50.8237322
    },
    {
        lng: 12.7612367,
        lat: 50.8226172
    },
    {
        lng: 12.7619446,
        lat: 50.8220925
    },
    {
        lng: 12.7617747,
        lat: 50.8220627
    },
    {
        lng: 12.7622713,
        lat: 50.8213072
    },
    {
        lng: 12.764191,
        lat: 50.8217467
    },
    {
        lng: 12.7651348,
        lat: 50.8215678
    },
    {
        lng: 12.7657011,
        lat: 50.8217407
    },
    {
        lng: 12.7649177,
        lat: 50.8224622
    },
    {
        lng: 12.7666152,
        lat: 50.8230137
    },
    {
        lng: 12.7651033,
        lat: 50.8242047
    },
    {
        lng: 12.7644715,
        lat: 50.8246672
    },
    {
        lng: 12.7631441,
        lat: 50.8259041
    },
    {
        lng: 12.7649931,
        lat: 50.8264459
    },
    {
        lng: 12.7633415,
        lat: 50.8281916
    },
    {
        lng: 12.7624899,
        lat: 50.8293947
    },
    {
        lng: 12.7648422,
        lat: 50.8301172
    },
    {
        lng: 12.7658951,
        lat: 50.8302275
    },
    {
        lng: 12.7678813,
        lat: 50.8281678
    },
    {
        lng: 12.7702975,
        lat: 50.8258308
    },
    {
        lng: 12.772142,
        lat: 50.824672
    },
    {
        lng: 12.7737084,
        lat: 50.8255208
    },
    {
        lng: 12.774271,
        lat: 50.8263554
    },
    {
        lng: 12.774589,
        lat: 50.8272001
    },
    {
        lng: 12.7747712,
        lat: 50.8275001
    },
    {
        lng: 12.7756679,
        lat: 50.8282453
    },
    {
        lng: 12.7777463,
        lat: 50.8295251
    },
    {
        lng: 12.7761777,
        lat: 50.8304245
    },
    {
        lng: 12.7785814,
        lat: 50.8323239
    },
    {
        lng: 12.7797375,
        lat: 50.8313672
    },
    {
        lng: 12.7805473,
        lat: 50.8300755
    },
    {
        lng: 12.7821369,
        lat: 50.8300306
    },
    {
        lng: 12.7830859,
        lat: 50.8302863
    },
    {
        lng: 12.7846461,
        lat: 50.8306856
    },
    {
        lng: 12.7854354,
        lat: 50.8310018
    },
    {
        lng: 12.7864612,
        lat: 50.8317595
    },
    {
        lng: 12.787781,
        lat: 50.8325684
    },
    {
        lng: 12.7861146,
        lat: 50.8335722
    },
    {
        lng: 12.7845208,
        lat: 50.8348235
    },
    {
        lng: 12.7837138,
        lat: 50.8358458
    },
    {
        lng: 12.782818,
        lat: 50.8366266
    },
    {
        lng: 12.7831145,
        lat: 50.8368918
    },
    {
        lng: 12.78465,
        lat: 50.8373431
    },
    {
        lng: 12.7865622,
        lat: 50.8378176
    },
    {
        lng: 12.7870408,
        lat: 50.8379975
    },
    {
        lng: 12.7884059,
        lat: 50.8386902
    },
    {
        lng: 12.7888941,
        lat: 50.8382258
    },
    {
        lng: 12.7894571,
        lat: 50.8376518
    },
    {
        lng: 12.7901554,
        lat: 50.8370319
    },
    {
        lng: 12.7905897,
        lat: 50.8375147
    },
    {
        lng: 12.7916372,
        lat: 50.8391598
    },
    {
        lng: 12.792128,
        lat: 50.8397498
    },
    {
        lng: 12.7923234,
        lat: 50.8402821
    },
    {
        lng: 12.7924017,
        lat: 50.8411504
    },
    {
        lng: 12.7926276,
        lat: 50.8415623
    },
    {
        lng: 12.7935754,
        lat: 50.8422335
    },
    {
        lng: 12.7953842,
        lat: 50.8427417
    },
    {
        lng: 12.7963273,
        lat: 50.8432503
    },
    {
        lng: 12.7981997,
        lat: 50.8438277
    },
    {
        lng: 12.7989613,
        lat: 50.8440529
    },
    {
        lng: 12.8001316,
        lat: 50.8444998
    },
    {
        lng: 12.8010293,
        lat: 50.8452119
    },
    {
        lng: 12.8023024,
        lat: 50.8459122
    },
    {
        lng: 12.8028066,
        lat: 50.8463394
    },
    {
        lng: 12.8045754,
        lat: 50.8471637
    },
    {
        lng: 12.8058994,
        lat: 50.8472404
    },
    {
        lng: 12.8061082,
        lat: 50.8472733
    },
    {
        lng: 12.8044827,
        lat: 50.851393
    },
    {
        lng: 12.8043002,
        lat: 50.8529041
    },
    {
        lng: 12.8043965,
        lat: 50.8531523
    },
    {
        lng: 12.8055974,
        lat: 50.8562485
    },
    {
        lng: 12.8060372,
        lat: 50.8585604
    },
    {
        lng: 12.8058676,
        lat: 50.8588707
    },
    {
        lng: 12.805692,
        lat: 50.8591433
    },
    {
        lng: 12.8054441,
        lat: 50.8594054
    },
    {
        lng: 12.804831,
        lat: 50.8596182
    },
    {
        lng: 12.8047974,
        lat: 50.8595564
    },
    {
        lng: 12.804109,
        lat: 50.8599443
    },
    {
        lng: 12.8047674,
        lat: 50.860506
    },
    {
        lng: 12.8057388,
        lat: 50.8609606
    },
    {
        lng: 12.8055857,
        lat: 50.8612658
    },
    {
        lng: 12.8054496,
        lat: 50.8619065
    },
    {
        lng: 12.8054352,
        lat: 50.8619742
    },
    {
        lng: 12.8052958,
        lat: 50.86437
    },
    {
        lng: 12.8052927,
        lat: 50.8644215
    },
    {
        lng: 12.8053508,
        lat: 50.8657982
    },
    {
        lng: 12.805417,
        lat: 50.8674542
    },
    {
        lng: 12.807163,
        lat: 50.8681804
    },
    {
        lng: 12.8088928,
        lat: 50.8691793
    },
    {
        lng: 12.8146489,
        lat: 50.8723781
    },
    {
        lng: 12.8168185,
        lat: 50.8746335
    },
    {
        lng: 12.8173848,
        lat: 50.8753601
    },
    {
        lng: 12.818121,
        lat: 50.876444
    },
    {
        lng: 12.819226,
        lat: 50.8774374
    },
    {
        lng: 12.8199237,
        lat: 50.8773135
    },
    {
        lng: 12.8219529,
        lat: 50.8770753
    },
    {
        lng: 12.8229996,
        lat: 50.8768875
    },
    {
        lng: 12.8235354,
        lat: 50.8768233
    },
    {
        lng: 12.8243151,
        lat: 50.8769237
    },
    {
        lng: 12.8247397,
        lat: 50.8771933
    },
    {
        lng: 12.824713,
        lat: 50.8781718
    },
    {
        lng: 12.8247309,
        lat: 50.8785134
    },
    {
        lng: 12.8250946,
        lat: 50.8792173
    },
    {
        lng: 12.8260605,
        lat: 50.8808878
    },
    {
        lng: 12.8269007,
        lat: 50.882123
    },
    {
        lng: 12.8273908,
        lat: 50.8831636
    },
    {
        lng: 12.8272132,
        lat: 50.8839912
    },
    {
        lng: 12.8275823,
        lat: 50.8842529
    },
    {
        lng: 12.8279635,
        lat: 50.8845278
    },
    {
        lng: 12.8283773,
        lat: 50.8847906
    },
    {
        lng: 12.8309616,
        lat: 50.886695
    },
    {
        lng: 12.8325954,
        lat: 50.8873733
    },
    {
        lng: 12.833889,
        lat: 50.8875909
    },
    {
        lng: 12.8356398,
        lat: 50.8876086
    },
    {
        lng: 12.8375686,
        lat: 50.8872243
    },
    {
        lng: 12.8387812,
        lat: 50.8866982
    },
    {
        lng: 12.8394749,
        lat: 50.8861414
    },
    {
        lng: 12.8397334,
        lat: 50.8862393
    },
    {
        lng: 12.8389644,
        lat: 50.8878724
    },
    {
        lng: 12.8377866,
        lat: 50.8901993
    },
    {
        lng: 12.8370548,
        lat: 50.891644
    },
    {
        lng: 12.8371289,
        lat: 50.8916549
    },
    {
        lng: 12.8376447,
        lat: 50.8916967
    },
    {
        lng: 12.8394761,
        lat: 50.8923573
    },
    {
        lng: 12.841507,
        lat: 50.8936593
    },
    {
        lng: 12.843758,
        lat: 50.895094
    },
    {
        lng: 12.8460807,
        lat: 50.8963283
    },
    {
        lng: 12.846912,
        lat: 50.8970412
    },
    {
        lng: 12.847061,
        lat: 50.897615
    },
    {
        lng: 12.8469489,
        lat: 50.8980155
    },
    {
        lng: 12.8491063,
        lat: 50.8979004
    },
    {
        lng: 12.8501421,
        lat: 50.8978444
    },
    {
        lng: 12.8514886,
        lat: 50.8979389
    },
    {
        lng: 12.8540731,
        lat: 50.8981681
    },
    {
        lng: 12.8549301,
        lat: 50.8980273
    },
    {
        lng: 12.8561266,
        lat: 50.8983129
    },
    {
        lng: 12.8592733,
        lat: 50.8985992
    },
    {
        lng: 12.8611744,
        lat: 50.898518
    },
    {
        lng: 12.861669,
        lat: 50.8989036
    },
    {
        lng: 12.8622649,
        lat: 50.8988538
    },
    {
        lng: 12.8627701,
        lat: 50.898781
    },
    {
        lng: 12.862945,
        lat: 50.8989026
    },
    {
        lng: 12.8632611,
        lat: 50.8990377
    },
    {
        lng: 12.8636469,
        lat: 50.899189
    },
    {
        lng: 12.8640151,
        lat: 50.8993402
    },
    {
        lng: 12.8643326,
        lat: 50.8994915
    },
    {
        lng: 12.8645527,
        lat: 50.8996506
    },
    {
        lng: 12.8650064,
        lat: 50.9001378
    },
    {
        lng: 12.8651606,
        lat: 50.9002828
    },
    {
        lng: 12.8654546,
        lat: 50.900493
    },
    {
        lng: 12.8658236,
        lat: 50.9006751
    },
    {
        lng: 12.8664141,
        lat: 50.9008358
    },
    {
        lng: 12.8668922,
        lat: 50.9010028
    },
    {
        lng: 12.8677894,
        lat: 50.9012802
    },
    {
        lng: 12.868612,
        lat: 50.9016135
    },
    {
        lng: 12.8691905,
        lat: 50.901873
    },
    {
        lng: 12.869201,
        lat: 50.9019468
    },
    {
        lng: 12.8699148,
        lat: 50.9019199
    },
    {
        lng: 12.8706808,
        lat: 50.901537
    },
    {
        lng: 12.8709586,
        lat: 50.9013622
    },
    {
        lng: 12.8708534,
        lat: 50.9010191
    },
    {
        lng: 12.8710522,
        lat: 50.9008683
    },
    {
        lng: 12.8712453,
        lat: 50.9006819
    },
    {
        lng: 12.8715411,
        lat: 50.9002841
    },
    {
        lng: 12.8716885,
        lat: 50.9003609
    },
    {
        lng: 12.8718378,
        lat: 50.9004031
    },
    {
        lng: 12.8719519,
        lat: 50.9004293
    },
    {
        lng: 12.8721295,
        lat: 50.900508
    },
    {
        lng: 12.8721227,
        lat: 50.9006321
    },
    {
        lng: 12.872237,
        lat: 50.9006531
    },
    {
        lng: 12.8723196,
        lat: 50.9006099
    },
    {
        lng: 12.8723411,
        lat: 50.9005426
    },
    {
        lng: 12.8723996,
        lat: 50.9004928
    },
    {
        lng: 12.8724944,
        lat: 50.9004622
    },
    {
        lng: 12.872771,
        lat: 50.9005318
    },
    {
        lng: 12.8728933,
        lat: 50.90054
    },
    {
        lng: 12.8730514,
        lat: 50.9005829
    },
    {
        lng: 12.8732559,
        lat: 50.9006687
    },
    {
        lng: 12.8735865,
        lat: 50.9008914
    },
    {
        lng: 12.8743257,
        lat: 50.9014489
    },
    {
        lng: 12.875513,
        lat: 50.9014377
    },
    {
        lng: 12.8769039,
        lat: 50.9012971
    },
    {
        lng: 12.8770813,
        lat: 50.9012792
    },
    {
        lng: 12.877147,
        lat: 50.9011682
    },
    {
        lng: 12.8794037,
        lat: 50.9013275
    },
    {
        lng: 12.8804631,
        lat: 50.9013944
    },
    {
        lng: 12.8820705,
        lat: 50.901496
    },
    {
        lng: 12.8823087,
        lat: 50.9015369
    },
    {
        lng: 12.8825132,
        lat: 50.9016079
    },
    {
        lng: 12.8834226,
        lat: 50.9018275
    },
    {
        lng: 12.8842083,
        lat: 50.9021543
    },
    {
        lng: 12.8851298,
        lat: 50.9029591
    },
    {
        lng: 12.8855249,
        lat: 50.9032153
    },
    {
        lng: 12.8860415,
        lat: 50.9034606
    },
    {
        lng: 12.8869126,
        lat: 50.9036361
    },
    {
        lng: 12.8876172,
        lat: 50.9037369
    },
    {
        lng: 12.8878509,
        lat: 50.9038614
    },
    {
        lng: 12.8881492,
        lat: 50.9039377
    },
    {
        lng: 12.8883694,
        lat: 50.9036491
    },
    {
        lng: 12.8886118,
        lat: 50.9034362
    },
    {
        lng: 12.8892168,
        lat: 50.9029879
    },
    {
        lng: 12.8898236,
        lat: 50.9026936
    },
    {
        lng: 12.8902185,
        lat: 50.9025818
    },
    {
        lng: 12.8906387,
        lat: 50.9024922
    },
    {
        lng: 12.8910067,
        lat: 50.9024515
    },
    {
        lng: 12.8913831,
        lat: 50.9024021
    },
    {
        lng: 12.8917092,
        lat: 50.9023781
    },
    {
        lng: 12.892004,
        lat: 50.902372
    },
    {
        lng: 12.8923523,
        lat: 50.902489
    },
    {
        lng: 12.8924619,
        lat: 50.9025644
    },
    {
        lng: 12.8928251,
        lat: 50.9027014
    },
    {
        lng: 12.8940157,
        lat: 50.9025137
    },
    {
        lng: 12.8946249,
        lat: 50.9023997
    },
    {
        lng: 12.8950849,
        lat: 50.9024079
    },
    {
        lng: 12.895138,
        lat: 50.9021514
    },
    {
        lng: 12.8952975,
        lat: 50.9019739
    },
    {
        lng: 12.8953433,
        lat: 50.9018096
    },
    {
        lng: 12.895622,
        lat: 50.9017217
    },
    {
        lng: 12.8957865,
        lat: 50.9016094
    },
    {
        lng: 12.8961122,
        lat: 50.9011033
    },
    {
        lng: 12.8964537,
        lat: 50.9011254
    },
    {
        lng: 12.8967577,
        lat: 50.9012339
    },
    {
        lng: 12.8969971,
        lat: 50.9014687
    },
    {
        lng: 12.8971207,
        lat: 50.9016907
    },
    {
        lng: 12.8967641,
        lat: 50.9021909
    },
    {
        lng: 12.8966797,
        lat: 50.9024749
    },
    {
        lng: 12.8974227,
        lat: 50.9023642
    },
    {
        lng: 12.897628,
        lat: 50.9023003
    },
    {
        lng: 12.8977908,
        lat: 50.9022289
    },
    {
        lng: 12.8978662,
        lat: 50.9020998
    },
    {
        lng: 12.8979389,
        lat: 50.901649
    },
    {
        lng: 12.8979349,
        lat: 50.9013505
    },
    {
        lng: 12.8979734,
        lat: 50.901057
    },
    {
        lng: 12.8985366,
        lat: 50.9002889
    },
    {
        lng: 12.8986813,
        lat: 50.900055
    },
    {
        lng: 12.8987356,
        lat: 50.8998325
    },
    {
        lng: 12.8987095,
        lat: 50.8997075
    },
    {
        lng: 12.8986269,
        lat: 50.8995727
    },
    {
        lng: 12.8984701,
        lat: 50.8994623
    },
    {
        lng: 12.8982019,
        lat: 50.8994047
    },
    {
        lng: 12.8975999,
        lat: 50.8993534
    },
    {
        lng: 12.8973336,
        lat: 50.899302
    },
    {
        lng: 12.8971732,
        lat: 50.899261
    },
    {
        lng: 12.897058,
        lat: 50.8991872
    },
    {
        lng: 12.8968786,
        lat: 50.89908
    },
    {
        lng: 12.8956862,
        lat: 50.8977753
    },
    {
        lng: 12.8957092,
        lat: 50.8977242
    },
    {
        lng: 12.8957937,
        lat: 50.8975369
    },
    {
        lng: 12.8959047,
        lat: 50.8971493
    },
    {
        lng: 12.8959885,
        lat: 50.8968568
    },
    {
        lng: 12.8959891,
        lat: 50.8967892
    },
    {
        lng: 12.8959909,
        lat: 50.8965978
    },
    {
        lng: 12.8961578,
        lat: 50.8963281
    },
    {
        lng: 12.8966324,
        lat: 50.8962219
    },
    {
        lng: 12.8968769,
        lat: 50.8960596
    },
    {
        lng: 12.8968903,
        lat: 50.8958355
    },
    {
        lng: 12.8967466,
        lat: 50.8956501
    },
    {
        lng: 12.8945813,
        lat: 50.8950467
    },
    {
        lng: 12.8945282,
        lat: 50.8949747
    },
    {
        lng: 12.8946004,
        lat: 50.8948876
    },
    {
        lng: 12.8947175,
        lat: 50.8948177
    },
    {
        lng: 12.8948223,
        lat: 50.8947841
    },
    {
        lng: 12.8951008,
        lat: 50.8948265
    },
    {
        lng: 12.8955427,
        lat: 50.8947397
    },
    {
        lng: 12.8957162,
        lat: 50.8946421
    },
    {
        lng: 12.8957795,
        lat: 50.8945719
    },
    {
        lng: 12.895777,
        lat: 50.8944764
    },
    {
        lng: 12.8957258,
        lat: 50.8943461
    },
    {
        lng: 12.89573,
        lat: 50.8942149
    },
    {
        lng: 12.8958442,
        lat: 50.8940025
    },
    {
        lng: 12.8955998,
        lat: 50.8937491
    },
    {
        lng: 12.8955943,
        lat: 50.8934561
    },
    {
        lng: 12.8951785,
        lat: 50.8930744
    },
    {
        lng: 12.8947484,
        lat: 50.8927087
    },
    {
        lng: 12.8942534,
        lat: 50.8921473
    },
    {
        lng: 12.8939934,
        lat: 50.8918121
    },
    {
        lng: 12.8938994,
        lat: 50.8915585
    },
    {
        lng: 12.8940839,
        lat: 50.8915985
    },
    {
        lng: 12.8946766,
        lat: 50.8917396
    },
    {
        lng: 12.8953146,
        lat: 50.8918959
    },
    {
        lng: 12.8956047,
        lat: 50.8919615
    },
    {
        lng: 12.8966541,
        lat: 50.892183
    },
    {
        lng: 12.8970128,
        lat: 50.8922497
    },
    {
        lng: 12.8982405,
        lat: 50.8922731
    },
    {
        lng: 12.8999834,
        lat: 50.8923048
    },
    {
        lng: 12.9002067,
        lat: 50.8923093
    },
    {
        lng: 12.9005602,
        lat: 50.8923643
    },
    {
        lng: 12.9013096,
        lat: 50.8923858
    },
    {
        lng: 12.9020548,
        lat: 50.8923951
    },
    {
        lng: 12.9035776,
        lat: 50.8923552
    },
    {
        lng: 12.9043255,
        lat: 50.8923418
    },
    {
        lng: 12.9057755,
        lat: 50.8922863
    },
    {
        lng: 12.9067749,
        lat: 50.8921296
    },
    {
        lng: 12.9077395,
        lat: 50.8919539
    },
    {
        lng: 12.9094385,
        lat: 50.8916037
    },
    {
        lng: 12.9108164,
        lat: 50.8911696
    },
    {
        lng: 12.9109512,
        lat: 50.8911165
    },
    {
        lng: 12.9114006,
        lat: 50.8909682
    },
    {
        lng: 12.9121559,
        lat: 50.8907219
    },
    {
        lng: 12.9128521,
        lat: 50.8905118
    },
    {
        lng: 12.9136401,
        lat: 50.8902237
    },
    {
        lng: 12.9150069,
        lat: 50.8895981
    },
    {
        lng: 12.9161843,
        lat: 50.8891897
    },
    {
        lng: 12.9188001,
        lat: 50.8882654
    },
    {
        lng: 12.920007,
        lat: 50.8871794
    },
    {
        lng: 12.9203898,
        lat: 50.886887
    },
    {
        lng: 12.9206085,
        lat: 50.8866106
    },
    {
        lng: 12.920919,
        lat: 50.8862275
    },
    {
        lng: 12.9218833,
        lat: 50.8862109
    },
    {
        lng: 12.922312,
        lat: 50.8863088
    },
    {
        lng: 12.9228295,
        lat: 50.8863511
    },
    {
        lng: 12.9235378,
        lat: 50.8864212
    },
    {
        lng: 12.9239164,
        lat: 50.8864508
    },
    {
        lng: 12.924118,
        lat: 50.8864557
    },
    {
        lng: 12.9242472,
        lat: 50.8892601
    },
    {
        lng: 12.9263343,
        lat: 50.8894215
    },
    {
        lng: 12.9264038,
        lat: 50.8899025
    },
    {
        lng: 12.927492,
        lat: 50.8898902
    },
    {
        lng: 12.9277153,
        lat: 50.8898947
    },
    {
        lng: 12.9281196,
        lat: 50.8899027
    },
    {
        lng: 12.9282502,
        lat: 50.8898602
    },
    {
        lng: 12.9288527,
        lat: 50.8898445
    },
    {
        lng: 12.9295184,
        lat: 50.8897818
    },
    {
        lng: 12.9303451,
        lat: 50.889577
    },
    {
        lng: 12.9304973,
        lat: 50.8906782
    },
    {
        lng: 12.9305844,
        lat: 50.8907298
    },
    {
        lng: 12.931682,
        lat: 50.8903507
    },
    {
        lng: 12.9316412,
        lat: 50.8894265
    },
    {
        lng: 12.931627,
        lat: 50.8891062
    },
    {
        lng: 12.9315757,
        lat: 50.8888158
    },
    {
        lng: 12.9318429,
        lat: 50.88885
    },
    {
        lng: 12.9320419,
        lat: 50.8889269
    },
    {
        lng: 12.93257,
        lat: 50.8889874
    },
    {
        lng: 12.9330388,
        lat: 50.8889989
    },
    {
        lng: 12.9334762,
        lat: 50.8889428
    },
    {
        lng: 12.9336759,
        lat: 50.8889291
    },
    {
        lng: 12.9342967,
        lat: 50.8888946
    },
    {
        lng: 12.9354615,
        lat: 50.88883
    },
    {
        lng: 12.9368841,
        lat: 50.8888454
    },
    {
        lng: 12.9377473,
        lat: 50.8890315
    },
    {
        lng: 12.9379918,
        lat: 50.8893973
    },
    {
        lng: 12.9380002,
        lat: 50.8895818
    },
    {
        lng: 12.9381279,
        lat: 50.8898102
    },
    {
        lng: 12.9384513,
        lat: 50.8899132
    },
    {
        lng: 12.9389421,
        lat: 50.8900655
    },
    {
        lng: 12.9392656,
        lat: 50.8900919
    },
    {
        lng: 12.9397035,
        lat: 50.890309
    },
    {
        lng: 12.9401355,
        lat: 50.8905017
    },
    {
        lng: 12.9406311,
        lat: 50.8906881
    },
    {
        lng: 12.9412603,
        lat: 50.890831
    },
    {
        lng: 12.9415561,
        lat: 50.8908982
    },
    {
        lng: 12.9419758,
        lat: 50.8909935
    },
    {
        lng: 12.9421104,
        lat: 50.8910241
    },
    {
        lng: 12.942213,
        lat: 50.8910129
    },
    {
        lng: 12.9430072,
        lat: 50.8909262
    },
    {
        lng: 12.9431811,
        lat: 50.8909115
    },
    {
        lng: 12.9435931,
        lat: 50.8907039
    },
    {
        lng: 12.9437086,
        lat: 50.8905326
    },
    {
        lng: 12.9438608,
        lat: 50.8902525
    },
    {
        lng: 12.9442166,
        lat: 50.8893174
    },
    {
        lng: 12.944339,
        lat: 50.8893137
    },
    {
        lng: 12.9454562,
        lat: 50.8895333
    },
    {
        lng: 12.9454282,
        lat: 50.8899216
    },
    {
        lng: 12.9451157,
        lat: 50.8909948
    },
    {
        lng: 12.9449331,
        lat: 50.8919321
    },
    {
        lng: 12.9450188,
        lat: 50.891941
    },
    {
        lng: 12.9449437,
        lat: 50.8926918
    },
    {
        lng: 12.946763,
        lat: 50.8926707
    },
    {
        lng: 12.9466858,
        lat: 50.8899845
    },
    {
        lng: 12.9482111,
        lat: 50.8899135
    },
    {
        lng: 12.9480621,
        lat: 50.8894401
    },
    {
        lng: 12.9480142,
        lat: 50.8891434
    },
    {
        lng: 12.9480457,
        lat: 50.8886965
    },
    {
        lng: 12.9482658,
        lat: 50.8871852
    },
    {
        lng: 12.9498172,
        lat: 50.887289
    },
    {
        lng: 12.9503356,
        lat: 50.887239
    },
    {
        lng: 12.9506248,
        lat: 50.8871308
    },
    {
        lng: 12.9511697,
        lat: 50.8872722
    },
    {
        lng: 12.9518647,
        lat: 50.8875364
    },
    {
        lng: 12.9527667,
        lat: 50.889604
    },
    {
        lng: 12.9529249,
        lat: 50.890122
    },
    {
        lng: 12.9536313,
        lat: 50.8901535
    },
    {
        lng: 12.9540322,
        lat: 50.8901345
    },
    {
        lng: 12.955338,
        lat: 50.8901435
    },
    {
        lng: 12.9554695,
        lat: 50.8905642
    },
    {
        lng: 12.9535022,
        lat: 50.8908495
    },
    {
        lng: 12.9531542,
        lat: 50.8909313
    },
    {
        lng: 12.9531502,
        lat: 50.8919612
    },
    {
        lng: 12.9532652,
        lat: 50.8927211
    },
    {
        lng: 12.9537582,
        lat: 50.8925572
    },
    {
        lng: 12.9550479,
        lat: 50.8921183
    },
    {
        lng: 12.9558665,
        lat: 50.8918869
    },
    {
        lng: 12.9562702,
        lat: 50.8917815
    },
    {
        lng: 12.9564736,
        lat: 50.8917612
    },
    {
        lng: 12.9571702,
        lat: 50.8916649
    },
    {
        lng: 12.9578555,
        lat: 50.8922786
    },
    {
        lng: 12.9578536,
        lat: 50.8923663
    },
    {
        lng: 12.9579348,
        lat: 50.8923734
    },
    {
        lng: 12.9601613,
        lat: 50.8925373
    },
    {
        lng: 12.962115,
        lat: 50.8926523
    },
    {
        lng: 12.9645755,
        lat: 50.8927973
    },
    {
        lng: 12.9653615,
        lat: 50.8937811
    },
    {
        lng: 12.9660043,
        lat: 50.8943571
    },
    {
        lng: 12.9667312,
        lat: 50.8947921
    },
    {
        lng: 12.9674601,
        lat: 50.895231
    },
    {
        lng: 12.9687949,
        lat: 50.8949291
    },
    {
        lng: 12.9713576,
        lat: 50.8944181
    },
    {
        lng: 12.9727494,
        lat: 50.8940822
    },
    {
        lng: 12.9738822,
        lat: 50.8936472
    },
    {
        lng: 12.974705,
        lat: 50.8942241
    },
    {
        lng: 12.9756288,
        lat: 50.8947921
    },
    {
        lng: 12.9785944,
        lat: 50.8937123
    },
    {
        lng: 12.9814431,
        lat: 50.8926594
    },
    {
        lng: 12.9823209,
        lat: 50.8927323
    },
    {
        lng: 12.9828789,
        lat: 50.8926064
    },
    {
        lng: 12.9833498,
        lat: 50.8922594
    },
    {
        lng: 12.9836568,
        lat: 50.8925565
    },
    {
        lng: 12.9841966,
        lat: 50.8930794
    },
    {
        lng: 12.9851956,
        lat: 50.8927134
    },
    {
        lng: 12.9860184,
        lat: 50.8922975
    },
    {
        lng: 12.9862544,
        lat: 50.8920725
    },
    {
        lng: 12.9864373,
        lat: 50.8917746
    },
    {
        lng: 12.9869643,
        lat: 50.8910036
    },
    {
        lng: 12.9870963,
        lat: 50.8911186
    },
    {
        lng: 12.9875793,
        lat: 50.8913966
    },
    {
        lng: 12.9879732,
        lat: 50.8917476
    },
    {
        lng: 12.988221,
        lat: 50.8919735
    },
    {
        lng: 12.9893639,
        lat: 50.8918896
    },
    {
        lng: 12.9897468,
        lat: 50.8917325
    },
    {
        lng: 12.9901319,
        lat: 50.8917256
    },
    {
        lng: 12.9898138,
        lat: 50.8914736
    },
    {
        lng: 12.9883482,
        lat: 50.8902757
    },
    {
        lng: 12.989292,
        lat: 50.8894137
    },
    {
        lng: 12.989648,
        lat: 50.8890588
    },
    {
        lng: 12.9897919,
        lat: 50.8889179
    },
    {
        lng: 12.9903589,
        lat: 50.8892878
    },
    {
        lng: 12.9909348,
        lat: 50.8896608
    },
    {
        lng: 12.9910238,
        lat: 50.8894589
    },
    {
        lng: 12.9907617,
        lat: 50.8889399
    },
    {
        lng: 12.9905129,
        lat: 50.8886729
    },
    {
        lng: 12.9901189,
        lat: 50.8882539
    },
    {
        lng: 12.9885352,
        lat: 50.8880969
    },
    {
        lng: 12.9880952,
        lat: 50.888132
    },
    {
        lng: 12.9881842,
        lat: 50.887727
    },
    {
        lng: 12.9888022,
        lat: 50.887651
    },
    {
        lng: 12.9888331,
        lat: 50.8873571
    },
    {
        lng: 12.989743,
        lat: 50.887323
    },
    {
        lng: 12.9904528,
        lat: 50.8873801
    },
    {
        lng: 12.9909458,
        lat: 50.887552
    },
    {
        lng: 12.9916807,
        lat: 50.8874261
    },
    {
        lng: 12.9914808,
        lat: 50.8863352
    },
    {
        lng: 12.9906328,
        lat: 50.8855533
    },
    {
        lng: 12.990202,
        lat: 50.8854232
    },
    {
        lng: 12.9898719,
        lat: 50.8853082
    },
    {
        lng: 12.9887851,
        lat: 50.8851563
    },
    {
        lng: 12.9877263,
        lat: 50.8858351
    },
    {
        lng: 12.9875424,
        lat: 50.8850072
    },
    {
        lng: 12.9874383,
        lat: 50.8845384
    },
    {
        lng: 12.9871694,
        lat: 50.8840993
    },
    {
        lng: 12.9871329,
        lat: 50.8840063
    },
    {
        lng: 12.989496,
        lat: 50.8824749
    },
    {
        lng: 12.9899102,
        lat: 50.8821441
    },
    {
        lng: 12.9903386,
        lat: 50.8818113
    },
    {
        lng: 12.9906693,
        lat: 50.8816186
    },
    {
        lng: 12.9949614,
        lat: 50.878286
    },
    {
        lng: 12.9957403,
        lat: 50.8776521
    },
    {
        lng: 12.9967032,
        lat: 50.8768662
    },
    {
        lng: 12.9982418,
        lat: 50.8756413
    },
    {
        lng: 12.9986679,
        lat: 50.875219
    },
    {
        lng: 12.9995579,
        lat: 50.8741517
    },
    {
        lng: 12.9962607,
        lat: 50.8733503
    },
    {
        lng: 12.9959274,
        lat: 50.8740502
    },
    {
        lng: 12.9956419,
        lat: 50.8738755
    },
    {
        lng: 12.9954641,
        lat: 50.8734714
    },
    {
        lng: 12.9956293,
        lat: 50.8732469
    },
    {
        lng: 12.9958534,
        lat: 50.8722744
    },
    {
        lng: 12.995329,
        lat: 50.8721192
    },
    {
        lng: 12.9955979,
        lat: 50.8717149
    },
    {
        lng: 12.9951717,
        lat: 50.8716481
    },
    {
        lng: 12.9947252,
        lat: 50.8715091
    },
    {
        lng: 12.9943403,
        lat: 50.8713186
    },
    {
        lng: 12.9938857,
        lat: 50.8719232
    },
    {
        lng: 12.9931313,
        lat: 50.8712174
    },
    {
        lng: 12.9929508,
        lat: 50.8708124
    },
    {
        lng: 12.9933939,
        lat: 50.8703469
    },
    {
        lng: 12.9925556,
        lat: 50.8692976
    },
    {
        lng: 12.9927927,
        lat: 50.868911
    },
    {
        lng: 12.9934738,
        lat: 50.8691952
    },
    {
        lng: 12.9945904,
        lat: 50.8692622
    },
    {
        lng: 12.9957924,
        lat: 50.8692545
    },
    {
        lng: 12.9966173,
        lat: 50.8692592
    },
    {
        lng: 12.9972417,
        lat: 50.8692088
    },
    {
        lng: 12.9962647,
        lat: 50.8684385
    },
    {
        lng: 12.996036,
        lat: 50.8689431
    },
    {
        lng: 12.9947389,
        lat: 50.8689318
    },
    {
        lng: 12.9937126,
        lat: 50.8688214
    },
    {
        lng: 12.9930291,
        lat: 50.86864
    },
    {
        lng: 12.9930878,
        lat: 50.8683685
    },
    {
        lng: 12.9934987,
        lat: 50.8674649
    },
    {
        lng: 12.9937119,
        lat: 50.8671571
    },
    {
        lng: 12.993196,
        lat: 50.8668855
    },
    {
        lng: 12.9930466,
        lat: 50.8667644
    },
    {
        lng: 12.9921601,
        lat: 50.8663479
    },
    {
        lng: 12.9919551,
        lat: 50.8662563
    },
    {
        lng: 12.9920863,
        lat: 50.8660342
    },
    {
        lng: 12.9885514,
        lat: 50.865141
    },
    {
        lng: 12.9884521,
        lat: 50.8652386
    },
    {
        lng: 12.9873539,
        lat: 50.865025
    },
    {
        lng: 12.9866667,
        lat: 50.8648265
    },
    {
        lng: 12.9866931,
        lat: 50.8646947
    },
    {
        lng: 12.9866408,
        lat: 50.8644848
    },
    {
        lng: 12.98758,
        lat: 50.8641171
    },
    {
        lng: 12.9882494,
        lat: 50.8639449
    },
    {
        lng: 12.9872118,
        lat: 50.8631207
    },
    {
        lng: 12.9867694,
        lat: 50.8628357
    },
    {
        lng: 12.9867831,
        lat: 50.862436
    },
    {
        lng: 12.9868677,
        lat: 50.8622512
    },
    {
        lng: 12.9873098,
        lat: 50.8621073
    },
    {
        lng: 12.9876471,
        lat: 50.8619442
    },
    {
        lng: 12.987822,
        lat: 50.8617422
    },
    {
        lng: 12.9878955,
        lat: 50.8615066
    },
    {
        lng: 12.9878529,
        lat: 50.8610759
    },
    {
        lng: 12.9877064,
        lat: 50.8605222
    },
    {
        lng: 12.9866925,
        lat: 50.8606866
    },
    {
        lng: 12.9867198,
        lat: 50.8604799
    },
    {
        lng: 12.98679,
        lat: 50.8602815
    },
    {
        lng: 12.9869756,
        lat: 50.8599903
    },
    {
        lng: 12.9870739,
        lat: 50.8598043
    },
    {
        lng: 12.9871885,
        lat: 50.8594838
    },
    {
        lng: 12.9871837,
        lat: 50.8590457
    },
    {
        lng: 12.9870123,
        lat: 50.8581465
    },
    {
        lng: 12.9863385,
        lat: 50.8576129
    },
    {
        lng: 12.9860609,
        lat: 50.8574014
    },
    {
        lng: 12.985561,
        lat: 50.856984
    },
    {
        lng: 12.9850176,
        lat: 50.8566273
    },
    {
        lng: 12.9846063,
        lat: 50.856392
    },
    {
        lng: 12.9842517,
        lat: 50.8561547
    },
    {
        lng: 12.9832047,
        lat: 50.8556954
    },
    {
        lng: 12.9830982,
        lat: 50.8554052
    },
    {
        lng: 12.9831526,
        lat: 50.8552298
    },
    {
        lng: 12.9832664,
        lat: 50.8548374
    },
    {
        lng: 12.98388,
        lat: 50.8549126
    },
    {
        lng: 12.9841929,
        lat: 50.8549523
    },
    {
        lng: 12.9844297,
        lat: 50.8549959
    },
    {
        lng: 12.9844604,
        lat: 50.854705
    },
    {
        lng: 12.9844682,
        lat: 50.8542051
    },
    {
        lng: 12.9844544,
        lat: 50.8538326
    },
    {
        lng: 12.9844538,
        lat: 50.853432
    },
    {
        lng: 12.9843129,
        lat: 50.8528479
    },
    {
        lng: 12.984297,
        lat: 50.8525746
    },
    {
        lng: 12.9842888,
        lat: 50.8524333
    },
    {
        lng: 12.9842884,
        lat: 50.8519792
    },
    {
        lng: 12.9841874,
        lat: 50.8516194
    },
    {
        lng: 12.9840643,
        lat: 50.8513176
    },
    {
        lng: 12.9837551,
        lat: 50.8509278
    },
    {
        lng: 12.983567,
        lat: 50.8506452
    },
    {
        lng: 12.9826279,
        lat: 50.8496006
    },
    {
        lng: 12.982509,
        lat: 50.849465
    },
    {
        lng: 12.9817789,
        lat: 50.8487966
    },
    {
        lng: 12.9812202,
        lat: 50.8483073
    },
    {
        lng: 12.9810163,
        lat: 50.8480926
    },
    {
        lng: 12.9815426,
        lat: 50.8479132
    },
    {
        lng: 12.9822897,
        lat: 50.847761
    },
    {
        lng: 12.982723,
        lat: 50.8477026
    },
    {
        lng: 12.9830751,
        lat: 50.8476177
    },
    {
        lng: 12.9834025,
        lat: 50.8475116
    },
    {
        lng: 12.9840544,
        lat: 50.8473356
    },
    {
        lng: 12.9841971,
        lat: 50.847628
    },
    {
        lng: 12.9843573,
        lat: 50.8479624
    },
    {
        lng: 12.9844243,
        lat: 50.8480865
    },
    {
        lng: 12.9844991,
        lat: 50.8482441
    },
    {
        lng: 12.9846228,
        lat: 50.8484516
    },
    {
        lng: 12.9848134,
        lat: 50.8487762
    },
    {
        lng: 12.9850634,
        lat: 50.8491038
    },
    {
        lng: 12.9853415,
        lat: 50.849404
    },
    {
        lng: 12.9860023,
        lat: 50.85009
    },
    {
        lng: 12.9865508,
        lat: 50.8513698
    },
    {
        lng: 12.9866746,
        lat: 50.8518256
    },
    {
        lng: 12.9866801,
        lat: 50.8522567
    },
    {
        lng: 12.9870929,
        lat: 50.8521827
    },
    {
        lng: 12.9896537,
        lat: 50.8514873
    },
    {
        lng: 12.9911298,
        lat: 50.8512596
    },
    {
        lng: 12.9927029,
        lat: 50.8510768
    },
    {
        lng: 12.993705,
        lat: 50.8509821
    },
    {
        lng: 12.9948821,
        lat: 50.8509139
    },
    {
        lng: 12.9979183,
        lat: 50.8508294
    },
    {
        lng: 12.9988523,
        lat: 50.850846
    },
    {
        lng: 12.9998494,
        lat: 50.8509426
    },
    {
        lng: 13.0013142,
        lat: 50.851138
    },
    {
        lng: 13.0022687,
        lat: 50.8512992
    },
    {
        lng: 13.0034622,
        lat: 50.8514743
    },
    {
        lng: 13.0038269,
        lat: 50.8515277
    },
    {
        lng: 13.0044736,
        lat: 50.8515942
    },
    {
        lng: 13.0053554,
        lat: 50.8517852
    },
    {
        lng: 13.0063093,
        lat: 50.8519952
    },
    {
        lng: 13.0069751,
        lat: 50.8520672
    },
    {
        lng: 13.0079191,
        lat: 50.8519761
    },
    {
        lng: 13.008458,
        lat: 50.8518502
    },
    {
        lng: 13.0090729,
        lat: 50.8512932
    },
    {
        lng: 13.0099897,
        lat: 50.8503854
    },
    {
        lng: 13.0112881,
        lat: 50.8493596
    },
    {
        lng: 13.011787,
        lat: 50.8498774
    },
    {
        lng: 13.014355,
        lat: 50.8486752
    },
    {
        lng: 13.0163062,
        lat: 50.8480765
    },
    {
        lng: 13.0183698,
        lat: 50.8472991
    },
    {
        lng: 13.022014,
        lat: 50.8463494
    },
    {
        lng: 13.023553,
        lat: 50.8462273
    },
    {
        lng: 13.0239515,
        lat: 50.8465193
    },
    {
        lng: 13.0244166,
        lat: 50.8466776
    },
    {
        lng: 13.0255928,
        lat: 50.8471813
    },
    {
        lng: 13.0259301,
        lat: 50.8472648
    },
    {
        lng: 13.0261787,
        lat: 50.8472548
    },
    {
        lng: 13.0282749,
        lat: 50.8484383
    },
    {
        lng: 13.0311106,
        lat: 50.848059
    },
    {
        lng: 13.033022,
        lat: 50.8480668
    },
    {
        lng: 13.0324206,
        lat: 50.847114
    },
    {
        lng: 13.0331104,
        lat: 50.8464502
    },
    {
        lng: 13.0333657,
        lat: 50.8457363
    },
    {
        lng: 13.0332262,
        lat: 50.8452404
    },
    {
        lng: 13.0356707,
        lat: 50.8440824
    },
    {
        lng: 13.0361981,
        lat: 50.8439192
    },
    {
        lng: 13.0373369,
        lat: 50.8436403
    },
    {
        lng: 13.0397806,
        lat: 50.8431245
    },
    {
        lng: 13.0416535,
        lat: 50.84278
    },
    {
        lng: 13.0429176,
        lat: 50.8426217
    },
    {
        lng: 13.043213,
        lat: 50.8423971
    },
    {
        lng: 13.0437843,
        lat: 50.8421768
    },
    {
        lng: 13.0453485,
        lat: 50.8419557
    },
    {
        lng: 13.0461353,
        lat: 50.8419974
    },
    {
        lng: 13.0472462,
        lat: 50.8420214
    },
    {
        lng: 13.0487272,
        lat: 50.842375
    },
    {
        lng: 13.0487949,
        lat: 50.841143
    },
    {
        lng: 13.0490331,
        lat: 50.8407742
    },
    {
        lng: 13.0494542,
        lat: 50.8385269
    },
    {
        lng: 13.0494971,
        lat: 50.8361053
    },
    {
        lng: 13.0495877,
        lat: 50.8340227
    },
    {
        lng: 13.0487179,
        lat: 50.832884
    },
    {
        lng: 13.0479317,
        lat: 50.831649
    },
    {
        lng: 13.0477557,
        lat: 50.8304704
    },
    {
        lng: 13.0476862,
        lat: 50.8298295
    },
    {
        lng: 13.0465608,
        lat: 50.8279626
    },
    {
        lng: 13.0455136,
        lat: 50.8262839
    },
    {
        lng: 13.044572,
        lat: 50.8249407
    },
    {
        lng: 13.0443545,
        lat: 50.8246468
    },
    {
        lng: 13.0437888,
        lat: 50.8228212
    },
    {
        lng: 13.0433241,
        lat: 50.8219919
    },
    {
        lng: 13.0426573,
        lat: 50.822261
    },
    {
        lng: 13.0423385,
        lat: 50.8225651
    },
    {
        lng: 13.0415716,
        lat: 50.8221257
    },
    {
        lng: 13.0412479,
        lat: 50.8213953
    },
    {
        lng: 13.0393548,
        lat: 50.8189133
    },
    {
        lng: 13.0395869,
        lat: 50.8183753
    },
    {
        lng: 13.0410358,
        lat: 50.8176966
    },
    {
        lng: 13.0422962,
        lat: 50.8166288
    },
    {
        lng: 13.0452779,
        lat: 50.8152399
    },
    {
        lng: 13.0469541,
        lat: 50.8146758
    },
    {
        lng: 13.0479383,
        lat: 50.8144986
    },
    {
        lng: 13.0488617,
        lat: 50.8143085
    },
    {
        lng: 13.0495467,
        lat: 50.8132438
    },
    {
        lng: 13.049772,
        lat: 50.8130279
    },
    {
        lng: 13.049881,
        lat: 50.812217
    },
    {
        lng: 13.0499836,
        lat: 50.8120793
    },
    {
        lng: 13.049799,
        lat: 50.8118831
    },
    {
        lng: 13.0498214,
        lat: 50.811526
    },
    {
        lng: 13.0510316,
        lat: 50.8113789
    },
    {
        lng: 13.0512888,
        lat: 50.8109456
    },
    {
        lng: 13.0527582,
        lat: 50.8104427
    },
    {
        lng: 13.0540393,
        lat: 50.8103252
    },
    {
        lng: 13.0538806,
        lat: 50.8093956
    },
    {
        lng: 13.0537541,
        lat: 50.8091918
    },
    {
        lng: 13.0528304,
        lat: 50.8069575
    },
    {
        lng: 13.0489307,
        lat: 50.8067038
    },
    {
        lng: 13.0482477,
        lat: 50.8065916
    },
    {
        lng: 13.0467381,
        lat: 50.8063901
    },
    {
        lng: 13.0452154,
        lat: 50.8063632
    },
    {
        lng: 13.0447892,
        lat: 50.8045889
    },
    {
        lng: 13.0438581,
        lat: 50.8039506
    },
    {
        lng: 13.0424773,
        lat: 50.8035916
    },
    {
        lng: 13.0429125,
        lat: 50.802402
    },
    {
        lng: 13.0418318,
        lat: 50.8014404
    },
    {
        lng: 13.0430829,
        lat: 50.8009798
    },
    {
        lng: 13.0423143,
        lat: 50.8002987
    },
    {
        lng: 13.0404475,
        lat: 50.7998206
    },
    {
        lng: 13.0403937,
        lat: 50.7985464
    },
    {
        lng: 13.0407948,
        lat: 50.7984164
    },
    {
        lng: 13.0408172,
        lat: 50.7982843
    },
    {
        lng: 13.0403513,
        lat: 50.7973642
    },
    {
        lng: 13.0393614,
        lat: 50.7967101
    },
    {
        lng: 13.0391957,
        lat: 50.7958855
    },
    {
        lng: 13.0385916,
        lat: 50.7951128
    },
    {
        lng: 13.038198,
        lat: 50.7946096
    },
    {
        lng: 13.0365204,
        lat: 50.7933298
    },
    {
        lng: 13.0355917,
        lat: 50.7924685
    },
    {
        lng: 13.0350605,
        lat: 50.7921629
    },
    {
        lng: 13.0342653,
        lat: 50.7919028
    },
    {
        lng: 13.0333774,
        lat: 50.7914344
    },
    {
        lng: 13.0329422,
        lat: 50.7912906
    },
    {
        lng: 13.0312386,
        lat: 50.7908971
    },
    {
        lng: 13.0309491,
        lat: 50.7908787
    },
    {
        lng: 13.0310471,
        lat: 50.7907024
    },
    {
        lng: 13.0313578,
        lat: 50.7893995
    },
    {
        lng: 13.0318637,
        lat: 50.7885332
    },
    {
        lng: 13.0320147,
        lat: 50.7878648
    },
    {
        lng: 13.0319118,
        lat: 50.7867247
    },
    {
        lng: 13.0311955,
        lat: 50.7859576
    },
    {
        lng: 13.0305975,
        lat: 50.7854917
    },
    {
        lng: 13.0302054,
        lat: 50.7855384
    },
    {
        lng: 13.0293014,
        lat: 50.7852191
    },
    {
        lng: 13.028801,
        lat: 50.7836874
    },
    {
        lng: 13.0278792,
        lat: 50.78222
    },
    {
        lng: 13.0256594,
        lat: 50.780512
    },
    {
        lng: 13.0249798,
        lat: 50.7796187
    },
    {
        lng: 13.0228373,
        lat: 50.7772762
    },
    {
        lng: 13.021671,
        lat: 50.7767594
    },
    {
        lng: 13.0220451,
        lat: 50.7758791
    },
    {
        lng: 13.02172,
        lat: 50.7752989
    },
    {
        lng: 13.0221353,
        lat: 50.7738083
    },
    {
        lng: 13.0228094,
        lat: 50.7730091
    },
    {
        lng: 13.0220823,
        lat: 50.7726812
    },
    {
        lng: 13.0219484,
        lat: 50.7718415
    },
    {
        lng: 13.0210892,
        lat: 50.7714678
    },
    {
        lng: 13.0197677,
        lat: 50.7710268
    },
    {
        lng: 13.0199367,
        lat: 50.7707393
    },
    {
        lng: 13.020617,
        lat: 50.770214
    },
    {
        lng: 13.0188536,
        lat: 50.7693705
    },
    {
        lng: 13.0183257,
        lat: 50.7692313
    },
    {
        lng: 13.018003,
        lat: 50.7691451
    },
    {
        lng: 13.017857,
        lat: 50.7690436
    },
    {
        lng: 13.0176436,
        lat: 50.7688857
    },
    {
        lng: 13.0169808,
        lat: 50.7693822
    },
    {
        lng: 13.0168822,
        lat: 50.7691601
    },
    {
        lng: 13.0145832,
        lat: 50.7701607
    },
    {
        lng: 13.0129008,
        lat: 50.771178
    },
    {
        lng: 13.0118022,
        lat: 50.7715457
    },
    {
        lng: 13.0110735,
        lat: 50.7715181
    },
    {
        lng: 13.0106344,
        lat: 50.7714403
    },
    {
        lng: 13.0102672,
        lat: 50.7713645
    },
    {
        lng: 13.0094955,
        lat: 50.7714352
    },
    {
        lng: 13.0088598,
        lat: 50.7718442
    },
    {
        lng: 13.0086268,
        lat: 50.7721818
    },
    {
        lng: 13.0081812,
        lat: 50.7724281
    },
    {
        lng: 13.0068621,
        lat: 50.7729524
    },
    {
        lng: 13.0059044,
        lat: 50.7736834
    },
    {
        lng: 13.0055139,
        lat: 50.7744032
    },
    {
        lng: 13.0049067,
        lat: 50.7750308
    },
    {
        lng: 13.0030255,
        lat: 50.7751935
    },
    {
        lng: 13.0021367,
        lat: 50.7756604
    },
    {
        lng: 13.0008427,
        lat: 50.7759098
    },
    {
        lng: 12.9995013,
        lat: 50.776309
    },
    {
        lng: 12.9984204,
        lat: 50.7769327
    },
    {
        lng: 12.9981238,
        lat: 50.7772772
    },
    {
        lng: 12.9968498,
        lat: 50.7774995
    },
    {
        lng: 12.9958344,
        lat: 50.7779652
    },
    {
        lng: 12.9954663,
        lat: 50.7784432
    },
    {
        lng: 12.9945288,
        lat: 50.7786002
    },
    {
        lng: 12.9930894,
        lat: 50.7793834
    },
    {
        lng: 12.9916525,
        lat: 50.7797612
    },
    {
        lng: 12.9901324,
        lat: 50.7791223
    },
    {
        lng: 12.9893401,
        lat: 50.7784026
    },
    {
        lng: 12.9884934,
        lat: 50.7773172
    },
    {
        lng: 12.9880616,
        lat: 50.7771698
    },
    {
        lng: 12.9886858,
        lat: 50.7768088
    },
    {
        lng: 12.9889228,
        lat: 50.7769556
    },
    {
        lng: 12.9895019,
        lat: 50.7770187
    },
    {
        lng: 12.9899212,
        lat: 50.7769429
    },
    {
        lng: 12.9900809,
        lat: 50.7768209
    },
    {
        lng: 12.9902074,
        lat: 50.7765473
    },
    {
        lng: 12.9901874,
        lat: 50.7762863
    },
    {
        lng: 12.9900676,
        lat: 50.7759412
    },
    {
        lng: 12.9897881,
        lat: 50.7754908
    },
    {
        lng: 12.9904603,
        lat: 50.7752509
    },
    {
        lng: 12.9910328,
        lat: 50.7751289
    },
    {
        lng: 12.9914721,
        lat: 50.7747542
    },
    {
        lng: 12.9912457,
        lat: 50.7746069
    },
    {
        lng: 12.9905269,
        lat: 50.7748005
    },
    {
        lng: 12.9895351,
        lat: 50.7749352
    },
    {
        lng: 12.9896562,
        lat: 50.773717
    },
    {
        lng: 12.9897814,
        lat: 50.7735083
    },
    {
        lng: 12.9901275,
        lat: 50.7734115
    },
    {
        lng: 12.990487,
        lat: 50.7732221
    },
    {
        lng: 12.9906866,
        lat: 50.7728685
    },
    {
        lng: 12.9904337,
        lat: 50.7723845
    },
    {
        lng: 12.9895169,
        lat: 50.7718198
    },
    {
        lng: 12.9895393,
        lat: 50.771292
    },
    {
        lng: 12.9903206,
        lat: 50.7706712
    },
    {
        lng: 12.9912355,
        lat: 50.7705363
    },
    {
        lng: 12.9910261,
        lat: 50.7696188
    },
    {
        lng: 12.9900876,
        lat: 50.7689916
    },
    {
        lng: 12.9900011,
        lat: 50.7685875
    },
    {
        lng: 12.9893171,
        lat: 50.7677568
    },
    {
        lng: 12.9896765,
        lat: 50.7675295
    },
    {
        lng: 12.9897564,
        lat: 50.7671843
    },
    {
        lng: 12.9894236,
        lat: 50.7669822
    },
    {
        lng: 12.9880686,
        lat: 50.7669318
    },
    {
        lng: 12.9876366,
        lat: 50.7668851
    },
    {
        lng: 12.9867611,
        lat: 50.7666497
    },
    {
        lng: 12.9861535,
        lat: 50.7663129
    },
    {
        lng: 12.985608,
        lat: 50.765578
    },
    {
        lng: 12.9855815,
        lat: 50.7654073
    },
    {
        lng: 12.9857489,
        lat: 50.7653852
    },
    {
        lng: 12.9863325,
        lat: 50.7654209
    },
    {
        lng: 12.9870624,
        lat: 50.765363
    },
    {
        lng: 12.9871938,
        lat: 50.7651828
    },
    {
        lng: 12.9872503,
        lat: 50.7650101
    },
    {
        lng: 12.9872079,
        lat: 50.7648017
    },
    {
        lng: 12.9864809,
        lat: 50.7640176
    },
    {
        lng: 12.9858482,
        lat: 50.7635923
    },
    {
        lng: 12.984345,
        lat: 50.7630915
    },
    {
        lng: 12.9833325,
        lat: 50.7630177
    },
    {
        lng: 12.981454,
        lat: 50.7624529
    },
    {
        lng: 12.980688,
        lat: 50.7622877
    },
    {
        lng: 12.9802226,
        lat: 50.7622616
    },
    {
        lng: 12.9796576,
        lat: 50.7624278
    },
    {
        lng: 12.9794529,
        lat: 50.7621573
    },
    {
        lng: 12.9792062,
        lat: 50.7614955
    },
    {
        lng: 12.9790536,
        lat: 50.7608521
    },
    {
        lng: 12.9788273,
        lat: 50.7598668
    },
    {
        lng: 12.9786855,
        lat: 50.7596367
    },
    {
        lng: 12.9785491,
        lat: 50.7591455
    },
    {
        lng: 12.9785726,
        lat: 50.7587197
    },
    {
        lng: 12.9785985,
        lat: 50.7579039
    },
    {
        lng: 12.9787773,
        lat: 50.7573695
    },
    {
        lng: 12.978429,
        lat: 50.7572429
    },
    {
        lng: 12.9783137,
        lat: 50.7573546
    },
    {
        lng: 12.9777466,
        lat: 50.7575437
    },
    {
        lng: 12.9776619,
        lat: 50.7576836
    },
    {
        lng: 12.9776713,
        lat: 50.7578756
    },
    {
        lng: 12.9776289,
        lat: 50.7580275
    },
    {
        lng: 12.9776689,
        lat: 50.758483
    },
    {
        lng: 12.9776783,
        lat: 50.7586483
    },
    {
        lng: 12.9775324,
        lat: 50.7589758
    },
    {
        lng: 12.9777207,
        lat: 50.7596099
    },
    {
        lng: 12.9778422,
        lat: 50.7598332
    },
    {
        lng: 12.9781084,
        lat: 50.7605068
    },
    {
        lng: 12.9780285,
        lat: 50.76081
    },
    {
        lng: 12.9772639,
        lat: 50.7607217
    },
    {
        lng: 12.97697,
        lat: 50.7605879
    },
    {
        lng: 12.9752661,
        lat: 50.7586426
    },
    {
        lng: 12.9749961,
        lat: 50.7584106
    },
    {
        lng: 12.9747253,
        lat: 50.7584353
    },
    {
        lng: 12.9745489,
        lat: 50.7586584
    },
    {
        lng: 12.9743006,
        lat: 50.7588596
    },
    {
        lng: 12.974038,
        lat: 50.7589563
    },
    {
        lng: 12.9736453,
        lat: 50.7590132
    },
    {
        lng: 12.9732626,
        lat: 50.7590026
    },
    {
        lng: 12.9726699,
        lat: 50.7588717
    },
    {
        lng: 12.971692,
        lat: 50.7577262
    },
    {
        lng: 12.9717807,
        lat: 50.7568644
    },
    {
        lng: 12.9716326,
        lat: 50.7564286
    },
    {
        lng: 12.9712889,
        lat: 50.7560828
    },
    {
        lng: 12.9683597,
        lat: 50.7551694
    },
    {
        lng: 12.9679687,
        lat: 50.7546431
    },
    {
        lng: 12.9684984,
        lat: 50.7542043
    },
    {
        lng: 12.9663719,
        lat: 50.7532104
    },
    {
        lng: 12.9657753,
        lat: 50.7537167
    },
    {
        lng: 12.9654159,
        lat: 50.7541045
    },
    {
        lng: 12.9649823,
        lat: 50.753745
    },
    {
        lng: 12.9645889,
        lat: 50.7532191
    },
    {
        lng: 12.964813,
        lat: 50.7529835
    },
    {
        lng: 12.9636353,
        lat: 50.7525377
    },
    {
        lng: 12.9642847,
        lat: 50.7520399
    },
    {
        lng: 12.9631203,
        lat: 50.751791
    },
    {
        lng: 12.9647367,
        lat: 50.7506178
    },
    {
        lng: 12.9638036,
        lat: 50.7502947
    },
    {
        lng: 12.9620605,
        lat: 50.7516092
    },
    {
        lng: 12.9609598,
        lat: 50.7528154
    },
    {
        lng: 12.9597368,
        lat: 50.7540402
    },
    {
        lng: 12.9590948,
        lat: 50.7545461
    },
    {
        lng: 12.9583709,
        lat: 50.7554804
    },
    {
        lng: 12.9575916,
        lat: 50.7561926
    },
    {
        lng: 12.9559742,
        lat: 50.7570945
    },
    {
        lng: 12.9522029,
        lat: 50.7587713
    },
    {
        lng: 12.9470749,
        lat: 50.7574822
    },
    {
        lng: 12.9443681,
        lat: 50.7567925
    },
    {
        lng: 12.9442893,
        lat: 50.7567723
    },
    {
        lng: 12.9408063,
        lat: 50.7545228
    },
    {
        lng: 12.9375372,
        lat: 50.753799
    },
    {
        lng: 12.936343,
        lat: 50.7533492
    },
    {
        lng: 12.9371453,
        lat: 50.7527013
    },
    {
        lng: 12.9378259,
        lat: 50.751439
    },
    {
        lng: 12.9379442,
        lat: 50.7511602
    },
    {
        lng: 12.9385028,
        lat: 50.750778
    },
    {
        lng: 12.9381342,
        lat: 50.7497941
    },
    {
        lng: 12.937636,
        lat: 50.7488616
    },
    {
        lng: 12.9376452,
        lat: 50.747096
    },
    {
        lng: 12.9387044,
        lat: 50.7467589
    },
    {
        lng: 12.9367177,
        lat: 50.7434321
    },
    {
        lng: 12.9350763,
        lat: 50.7432174
    },
    {
        lng: 12.9335393,
        lat: 50.7427681
    },
    {
        lng: 12.9307959,
        lat: 50.742238
    },
    {
        lng: 12.9282049,
        lat: 50.7416277
    },
    {
        lng: 12.9260231,
        lat: 50.7414253
    },
    {
        lng: 12.9241578,
        lat: 50.7413803
    },
    {
        lng: 12.9235944,
        lat: 50.7424916
    },
    {
        lng: 12.921157,
        lat: 50.7427207
    },
    {
        lng: 12.9211696,
        lat: 50.7430439
    },
    {
        lng: 12.9194542,
        lat: 50.7436337
    },
    {
        lng: 12.9194015,
        lat: 50.7434364
    },
    {
        lng: 12.9167475,
        lat: 50.7437976
    },
    {
        lng: 12.9168303,
        lat: 50.7433967
    },
    {
        lng: 12.9158338,
        lat: 50.7434334
    },
    {
        lng: 12.9158741,
        lat: 50.7437633
    },
    {
        lng: 12.9158946,
        lat: 50.7441258
    },
    {
        lng: 12.9147696,
        lat: 50.7442107
    },
    {
        lng: 12.914789,
        lat: 50.7440479
    },
    {
        lng: 12.9148278,
        lat: 50.743722
    },
    {
        lng: 12.9147931,
        lat: 50.7432932
    },
    {
        lng: 12.9131562,
        lat: 50.7436962
    },
    {
        lng: 12.9122463,
        lat: 50.7439854
    },
    {
        lng: 12.911348,
        lat: 50.744093
    },
    {
        lng: 12.9081703,
        lat: 50.7459287
    },
    {
        lng: 12.9077012,
        lat: 50.7463799
    },
    {
        lng: 12.9064431,
        lat: 50.7477766
    },
    {
        lng: 12.9057803,
        lat: 50.7482917
    },
    {
        lng: 12.905288,
        lat: 50.7485336
    },
    {
        lng: 12.9049805,
        lat: 50.7488478
    },
    {
        lng: 12.9046059,
        lat: 50.7493356
    },
    {
        lng: 12.9044474,
        lat: 50.7494222
    },
    {
        lng: 12.9040512,
        lat: 50.7495817
    },
    {
        lng: 12.9035973,
        lat: 50.7498735
    },
    {
        lng: 12.9034964,
        lat: 50.7500285
    },
    {
        lng: 12.9035181,
        lat: 50.7501516
    },
    {
        lng: 12.9011766,
        lat: 50.7506621
    },
    {
        lng: 12.8999662,
        lat: 50.7511271
    },
    {
        lng: 12.8981795,
        lat: 50.7516603
    },
    {
        lng: 12.8978265,
        lat: 50.7518518
    },
    {
        lng: 12.8975095,
        lat: 50.7519475
    },
    {
        lng: 12.8967747,
        lat: 50.7523714
    },
    {
        lng: 12.8960902,
        lat: 50.7527224
    },
    {
        lng: 12.8959778,
        lat: 50.7530506
    },
    {
        lng: 12.8952113,
        lat: 50.7540277
    },
    {
        lng: 12.8949304,
        lat: 50.754336
    },
    {
        lng: 12.8941645,
        lat: 50.7552378
    },
    {
        lng: 12.894054,
        lat: 50.7554478
    },
    {
        lng: 12.8939145,
        lat: 50.755913
    },
    {
        lng: 12.893547,
        lat: 50.7566149
    },
    {
        lng: 12.8933597,
        lat: 50.758128
    },
    {
        lng: 12.8925456,
        lat: 50.7595453
    },
    {
        lng: 12.8921421,
        lat: 50.7607439
    },
    {
        lng: 12.8921421,
        lat: 50.7621157
    },
    {
        lng: 12.8920052,
        lat: 50.7624666
    },
    {
        lng: 12.8915369,
        lat: 50.7631591
    },
    {
        lng: 12.8896998,
        lat: 50.7626169
    },
    {
        lng: 12.8879131,
        lat: 50.7622569
    },
    {
        lng: 12.8842676,
        lat: 50.7619196
    },
    {
        lng: 12.8811896,
        lat: 50.761685
    },
    {
        lng: 12.8805756,
        lat: 50.7637713
    },
    {
        lng: 12.8805616,
        lat: 50.7638096
    },
    {
        lng: 12.8805201,
        lat: 50.7639226
    },
    {
        lng: 12.8801683,
        lat: 50.7660528
    },
    {
        lng: 12.8806834,
        lat: 50.7665291
    },
    {
        lng: 12.8814285,
        lat: 50.7672557
    },
    {
        lng: 12.8824774,
        lat: 50.7682787
    },
    {
        lng: 12.8825998,
        lat: 50.7683379
    },
    {
        lng: 12.883486,
        lat: 50.7681079
    },
    {
        lng: 12.8839146,
        lat: 50.7682491
    },
    {
        lng: 12.8849124,
        lat: 50.769108
    },
    {
        lng: 12.8855752,
        lat: 50.7695659
    },
    {
        lng: 12.885496,
        lat: 50.7697094
    },
    {
        lng: 12.8853988,
        lat: 50.7697392
    },
    {
        lng: 12.8855631,
        lat: 50.7698157
    },
    {
        lng: 12.8858618,
        lat: 50.7697696
    },
    {
        lng: 12.8860387,
        lat: 50.7697664
    },
    {
        lng: 12.8862181,
        lat: 50.7697824
    },
    {
        lng: 12.887143,
        lat: 50.7698111
    },
    {
        lng: 12.8871481,
        lat: 50.7698319
    },
    {
        lng: 12.8868625,
        lat: 50.7698415
    },
    {
        lng: 12.8865795,
        lat: 50.7699166
    },
    {
        lng: 12.8864152,
        lat: 50.7700173
    },
    {
        lng: 12.8879189,
        lat: 50.770222
    },
    {
        lng: 12.8894074,
        lat: 50.7704234
    },
    {
        lng: 12.8893694,
        lat: 50.7696193
    },
    {
        lng: 12.88942,
        lat: 50.7696209
    },
    {
        lng: 12.8894073,
        lat: 50.7698111
    },
    {
        lng: 12.8894479,
        lat: 50.7698144
    },
    {
        lng: 12.8896034,
        lat: 50.7704541
    },
    {
        lng: 12.8901319,
        lat: 50.7705366
    },
    {
        lng: 12.8925384,
        lat: 50.7707876
    },
    {
        lng: 12.8927305,
        lat: 50.7706949
    },
    {
        lng: 12.8930286,
        lat: 50.7705607
    },
    {
        lng: 12.8934229,
        lat: 50.7704456
    },
    {
        lng: 12.8938529,
        lat: 50.7703862
    },
    {
        lng: 12.8938879,
        lat: 50.7696849
    },
    {
        lng: 12.8943681,
        lat: 50.7697073
    },
    {
        lng: 12.8942973,
        lat: 50.7703753
    },
    {
        lng: 12.8943832,
        lat: 50.7703785
    },
    {
        lng: 12.8948128,
        lat: 50.7706118
    },
    {
        lng: 12.8949948,
        lat: 50.7707621
    },
    {
        lng: 12.8960864,
        lat: 50.7717785
    },
    {
        lng: 12.8973299,
        lat: 50.7731626
    },
    {
        lng: 12.8921239,
        lat: 50.7751537
    },
    {
        lng: 12.892225,
        lat: 50.775403
    },
    {
        lng: 12.8923963,
        lat: 50.7761208
    },
    {
        lng: 12.8929024,
        lat: 50.7761062
    },
    {
        lng: 12.8942063,
        lat: 50.777538
    },
    {
        lng: 12.8946814,
        lat: 50.7789473
    },
    {
        lng: 12.8947446,
        lat: 50.7791998
    },
    {
        lng: 12.8947041,
        lat: 50.7799237
    },
    {
        lng: 12.8946811,
        lat: 50.7802411
    },
    {
        lng: 12.8946056,
        lat: 50.7804318
    },
    {
        lng: 12.8942,
        lat: 50.7804949
    },
    {
        lng: 12.8940344,
        lat: 50.7805492
    },
    {
        lng: 12.8941974,
        lat: 50.7828295
    },
    {
        lng: 12.8924313,
        lat: 50.7834949
    },
    {
        lng: 12.887957,
        lat: 50.7852647
    },
    {
        lng: 12.8868331,
        lat: 50.7850167
    },
    {
        lng: 12.8857994,
        lat: 50.7845507
    },
    {
        lng: 12.8855084,
        lat: 50.7839297
    },
    {
        lng: 12.8851275,
        lat: 50.7833108
    },
    {
        lng: 12.8848204,
        lat: 50.7831468
    },
    {
        lng: 12.8844435,
        lat: 50.7829379
    },
    {
        lng: 12.8835496,
        lat: 50.782453
    },
    {
        lng: 12.8844236,
        lat: 50.782327
    },
    {
        lng: 12.8843276,
        lat: 50.782014
    },
    {
        lng: 12.8842356,
        lat: 50.7817131
    },
    {
        lng: 12.8841947,
        lat: 50.781576
    },
    {
        lng: 12.8838977,
        lat: 50.7813621
    },
    {
        lng: 12.8835428,
        lat: 50.7812741
    },
    {
        lng: 12.8829508,
        lat: 50.7811141
    },
    {
        lng: 12.8821331,
        lat: 50.7810341
    },
    {
        lng: 12.8821761,
        lat: 50.7816469
    },
    {
        lng: 12.8812954,
        lat: 50.7816435
    },
    {
        lng: 12.8806322,
        lat: 50.781549
    },
    {
        lng: 12.8783194,
        lat: 50.7814609
    },
    {
        lng: 12.8781605,
        lat: 50.7810261
    },
    {
        lng: 12.8777996,
        lat: 50.7800462
    },
    {
        lng: 12.8776577,
        lat: 50.7796824
    },
    {
        lng: 12.8767385,
        lat: 50.77958
    },
    {
        lng: 12.8767577,
        lat: 50.7802101
    },
    {
        lng: 12.8766775,
        lat: 50.7804779
    },
    {
        lng: 12.8761937,
        lat: 50.7804567
    },
    {
        lng: 12.8759498,
        lat: 50.7804567
    },
    {
        lng: 12.8755302,
        lat: 50.7804178
    },
    {
        lng: 12.8755529,
        lat: 50.7801301
    },
    {
        lng: 12.875581,
        lat: 50.7794702
    },
    {
        lng: 12.8745143,
        lat: 50.7794951
    },
    {
        lng: 12.8744201,
        lat: 50.7794131
    },
    {
        lng: 12.8730141,
        lat: 50.7794982
    },
    {
        lng: 12.8712456,
        lat: 50.7797095
    },
    {
        lng: 12.8706552,
        lat: 50.7798878
    },
    {
        lng: 12.8701069,
        lat: 50.7800412
    },
    {
        lng: 12.8692596,
        lat: 50.7802948
    },
    {
        lng: 12.8692503,
        lat: 50.7804651
    },
    {
        lng: 12.8690107,
        lat: 50.7814663
    },
    {
        lng: 12.8688414,
        lat: 50.7821773
    },
    {
        lng: 12.8693036,
        lat: 50.7823703
    },
    {
        lng: 12.8692237,
        lat: 50.7826111
    },
    {
        lng: 12.8696966,
        lat: 50.7829417
    },
    {
        lng: 12.8713851,
        lat: 50.7833725
    },
    {
        lng: 12.8723632,
        lat: 50.7839716
    },
    {
        lng: 12.8726568,
        lat: 50.7841528
    },
    {
        lng: 12.8729998,
        lat: 50.7844589
    },
    {
        lng: 12.8724876,
        lat: 50.7846776
    },
    {
        lng: 12.8722371,
        lat: 50.7847955
    },
    {
        lng: 12.8720006,
        lat: 50.7848945
    },
    {
        lng: 12.8734063,
        lat: 50.7861611
    },
    {
        lng: 12.8743061,
        lat: 50.7869761
    },
    {
        lng: 12.8753981,
        lat: 50.7879496
    },
    {
        lng: 12.8759086,
        lat: 50.7886574
    },
    {
        lng: 12.87556,
        lat: 50.7887209
    },
    {
        lng: 12.8742087,
        lat: 50.7893194
    },
    {
        lng: 12.8739991,
        lat: 50.7894287
    },
    {
        lng: 12.8731804,
        lat: 50.7901251
    },
    {
        lng: 12.8729628,
        lat: 50.7903658
    },
    {
        lng: 12.8728542,
        lat: 50.7904528
    },
    {
        lng: 12.8726879,
        lat: 50.7905348
    },
    {
        lng: 12.8716756,
        lat: 50.7905384
    },
    {
        lng: 12.8708803,
        lat: 50.7905436
    },
    {
        lng: 12.86975,
        lat: 50.7906449
    },
    {
        lng: 12.8677878,
        lat: 50.7907397
    },
    {
        lng: 12.8669659,
        lat: 50.7907555
    },
    {
        lng: 12.8663341,
        lat: 50.7907945
    },
    {
        lng: 12.865764,
        lat: 50.7909284
    },
    {
        lng: 12.8629867,
        lat: 50.7917914
    },
    {
        lng: 12.8618062,
        lat: 50.7921339
    },
    {
        lng: 12.8612851,
        lat: 50.7923119
    },
    {
        lng: 12.8600051,
        lat: 50.7929244
    },
    {
        lng: 12.8593939,
        lat: 50.7932353
    },
    {
        lng: 12.8587871,
        lat: 50.7929434
    },
    {
        lng: 12.8585803,
        lat: 50.7933585
    },
    {
        lng: 12.8583215,
        lat: 50.7936832
    },
    {
        lng: 12.8579416,
        lat: 50.7939654
    },
    {
        lng: 12.8576584,
        lat: 50.794132
    },
    {
        lng: 12.8573699,
        lat: 50.7943007
    },
    {
        lng: 12.8569901,
        lat: 50.7944411
    },
    {
        lng: 12.8567115,
        lat: 50.7944987
    },
    {
        lng: 12.8560639,
        lat: 50.7945788
    },
    {
        lng: 12.8556027,
        lat: 50.7946168
    },
    {
        lng: 12.8551059,
        lat: 50.7946578
    },
    {
        lng: 12.8547375,
        lat: 50.7947138
    },
    {
        lng: 12.8543841,
        lat: 50.794777
    },
    {
        lng: 12.8537372,
        lat: 50.7949477
    },
    {
        lng: 12.8529821,
        lat: 50.7952553
    },
    {
        lng: 12.851455,
        lat: 50.7957084
    },
    {
        lng: 12.8505748,
        lat: 50.7960953
    },
    {
        lng: 12.8502662,
        lat: 50.7962323
    },
    {
        lng: 12.8495928,
        lat: 50.7965568
    },
    {
        lng: 12.8491043,
        lat: 50.7967707
    },
    {
        lng: 12.8486726,
        lat: 50.7969056
    },
    {
        lng: 12.8473039,
        lat: 50.7972049
    },
    {
        lng: 12.846817,
        lat: 50.797344
    },
    {
        lng: 12.8457734,
        lat: 50.7977212
    },
    {
        lng: 12.844533,
        lat: 50.7989267
    },
    {
        lng: 12.8443129,
        lat: 50.7990194
    },
    {
        lng: 12.8436495,
        lat: 50.7995072
    },
    {
        lng: 12.8433426,
        lat: 50.7997412
    },
    {
        lng: 12.8427091,
        lat: 50.8002638
    },
    {
        lng: 12.8419874,
        lat: 50.8009919
    },
    {
        lng: 12.8419289,
        lat: 50.8011088
    },
    {
        lng: 12.8415339,
        lat: 50.801388
    },
    {
        lng: 12.8410487,
        lat: 50.8018232
    },
    {
        lng: 12.8407319,
        lat: 50.8019475
    },
    {
        lng: 12.8406502,
        lat: 50.8020127
    },
    {
        lng: 12.8400003,
        lat: 50.8015634
    },
    {
        lng: 12.8394674,
        lat: 50.8008619
    },
    {
        lng: 12.8391576,
        lat: 50.800678
    },
    {
        lng: 12.8390674,
        lat: 50.8006404
    },
    {
        lng: 12.8381857,
        lat: 50.8003703
    },
    {
        lng: 12.8378878,
        lat: 50.8002359
    },
    {
        lng: 12.8376273,
        lat: 50.8001067
    },
    {
        lng: 12.8372699,
        lat: 50.7999604
    },
    {
        lng: 12.8366775,
        lat: 50.7997193
    },
    {
        lng: 12.8366383,
        lat: 50.799685
    },
    {
        lng: 12.8366281,
        lat: 50.7995828
    },
    {
        lng: 12.8366742,
        lat: 50.7993052
    },
    {
        lng: 12.8366758,
        lat: 50.7992213
    },
    {
        lng: 12.8366366,
        lat: 50.7991374
    },
    {
        lng: 12.8365787,
        lat: 50.7990094
    },
    {
        lng: 12.8362172,
        lat: 50.7987449
    },
    {
        lng: 12.8355326,
        lat: 50.7983352
    },
    {
        lng: 12.8352139,
        lat: 50.7982668
    },
    {
        lng: 12.8349824,
        lat: 50.798177
    },
    {
        lng: 12.8347902,
        lat: 50.7981892
    },
    {
        lng: 12.8347311,
        lat: 50.7981628
    },
    {
        lng: 12.8346303,
        lat: 50.7982001
    },
    {
        lng: 12.8343817,
        lat: 50.7981958
    },
    {
        lng: 12.8339265,
        lat: 50.7980398
    },
    {
        lng: 12.8336969,
        lat: 50.7979398
    },
    {
        lng: 12.8335579,
        lat: 50.7978475
    },
    {
        lng: 12.8326402,
        lat: 50.7975663
    },
    {
        lng: 12.831952,
        lat: 50.7971664
    },
    {
        lng: 12.8318007,
        lat: 50.7970269
    },
    {
        lng: 12.831726,
        lat: 50.7969291
    },
    {
        lng: 12.8317034,
        lat: 50.7966391
    },
    {
        lng: 12.8311195,
        lat: 50.7962875
    },
    {
        lng: 12.8306953,
        lat: 50.7959898
    },
    {
        lng: 12.8301253,
        lat: 50.7957328
    },
    {
        lng: 12.8295552,
        lat: 50.7955339
    },
    {
        lng: 12.8292753,
        lat: 50.7954691
    },
    {
        lng: 12.8289156,
        lat: 50.795425
    },
    {
        lng: 12.8287157,
        lat: 50.7954306
    },
    {
        lng: 12.8284185,
        lat: 50.7953274
    },
    {
        lng: 12.8270332,
        lat: 50.7947956
    },
    {
        lng: 12.8263798,
        lat: 50.7945342
    },
    {
        lng: 12.8259869,
        lat: 50.7944243
    },
    {
        lng: 12.8256777,
        lat: 50.7943572
    },
    {
        lng: 12.8253056,
        lat: 50.7943429
    },
    {
        lng: 12.8249459,
        lat: 50.7943793
    },
    {
        lng: 12.8240873,
        lat: 50.7944041
    },
    {
        lng: 12.8232392,
        lat: 50.7944033
    },
    {
        lng: 12.8227211,
        lat: 50.7944682
    },
    {
        lng: 12.8222727,
        lat: 50.7946637
    },
    {
        lng: 12.8223283,
        lat: 50.7945682
    },
    {
        lng: 12.8223266,
        lat: 50.7945067
    },
    {
        lng: 12.8223214,
        lat: 50.7943716
    },
    {
        lng: 12.8225438,
        lat: 50.7939189
    },
    {
        lng: 12.8225491,
        lat: 50.7938025
    },
    {
        lng: 12.8226099,
        lat: 50.7934641
    },
    {
        lng: 12.8227124,
        lat: 50.7932191
    },
    {
        lng: 12.8228671,
        lat: 50.7928994
    },
    {
        lng: 12.8228515,
        lat: 50.7928631
    },
    {
        lng: 12.8227402,
        lat: 50.7928247
    },
    {
        lng: 12.8225977,
        lat: 50.7927642
    },
    {
        lng: 12.8225856,
        lat: 50.792717
    },
    {
        lng: 12.8225352,
        lat: 50.7926719
    },
    {
        lng: 12.8225856,
        lat: 50.7925577
    },
    {
        lng: 12.8224743,
        lat: 50.792483
    },
    {
        lng: 12.8224535,
        lat: 50.7924214
    },
    {
        lng: 12.8223839,
        lat: 50.7924105
    },
    {
        lng: 12.8223462,
        lat: 50.7923504
    },
    {
        lng: 12.8222727,
        lat: 50.7922841
    },
    {
        lng: 12.8221024,
        lat: 50.7922138
    },
    {
        lng: 12.8218869,
        lat: 50.7921622
    },
    {
        lng: 12.8216939,
        lat: 50.7921358
    },
    {
        lng: 12.8215983,
        lat: 50.7921413
    },
    {
        lng: 12.8215097,
        lat: 50.7921149
    },
    {
        lng: 12.8208562,
        lat: 50.7918326
    },
    {
        lng: 12.8207477,
        lat: 50.7917464
    },
    {
        lng: 12.8205607,
        lat: 50.7915018
    },
    {
        lng: 12.8205051,
        lat: 50.79117
    },
    {
        lng: 12.8204756,
        lat: 50.7911085
    },
    {
        lng: 12.8202044,
        lat: 50.7909085
    },
    {
        lng: 12.8190973,
        lat: 50.7904668
    },
    {
        lng: 12.8189478,
        lat: 50.7903812
    },
    {
        lng: 12.8184751,
        lat: 50.7898856
    },
    {
        lng: 12.8184055,
        lat: 50.7897659
    },
    {
        lng: 12.8184073,
        lat: 50.7896637
    },
    {
        lng: 12.8184959,
        lat: 50.7896076
    },
    {
        lng: 12.8180823,
        lat: 50.789445
    },
    {
        lng: 12.818011,
        lat: 50.789467
    },
    {
        lng: 12.8179085,
        lat: 50.7893945
    },
    {
        lng: 12.8178806,
        lat: 50.7894154
    },
    {
        lng: 12.8177931,
        lat: 50.7893513
    },
    {
        lng: 12.817792,
        lat: 50.7890715
    },
    {
        lng: 12.8175643,
        lat: 50.7888638
    },
    {
        lng: 12.8171993,
        lat: 50.7886682
    },
    {
        lng: 12.8169855,
        lat: 50.7883902
    },
    {
        lng: 12.816864,
        lat: 50.7883232
    },
    {
        lng: 12.8153184,
        lat: 50.7881923
    },
    {
        lng: 12.8129667,
        lat: 50.7885523
    },
    {
        lng: 12.8098157,
        lat: 50.7885698
    },
    {
        lng: 12.8055963,
        lat: 50.7881414
    },
    {
        lng: 12.8047539,
        lat: 50.7879541
    },
    {
        lng: 12.8033613,
        lat: 50.7872508
    },
    {
        lng: 12.8019081,
        lat: 50.7870942
    },
    {
        lng: 12.7994465,
        lat: 50.7864496
    },
    {
        lng: 12.7968612,
        lat: 50.7856156
    },
    {
        lng: 12.7931724,
        lat: 50.7843027
    },
    {
        lng: 12.7927411,
        lat: 50.7845455
    },
    {
        lng: 12.7922916,
        lat: 50.7847628
    },
    {
        lng: 12.7911669,
        lat: 50.7848586
    },
    {
        lng: 12.7900156,
        lat: 50.7847728
    },
    {
        lng: 12.7878307,
        lat: 50.7856324
    },
    {
        lng: 12.781911,
        lat: 50.7857928
    },
    {
        lng: 12.7783648,
        lat: 50.7868397
    },
    {
        lng: 12.777487,
        lat: 50.7867395
    },
    {
        lng: 12.7784185,
        lat: 50.7881738
    },
    {
        lng: 12.779259,
        lat: 50.789553
    },
    {
        lng: 12.7788632,
        lat: 50.7900349
    },
    {
        lng: 12.7786247,
        lat: 50.7907166
    },
    {
        lng: 12.778341,
        lat: 50.7916691
    },
    {
        lng: 12.7778232,
        lat: 50.7923176
    },
    {
        lng: 12.7777729,
        lat: 50.7939647
    },
    {
        lng: 12.7771835,
        lat: 50.7954129
    },
    {
        lng: 12.7769932,
        lat: 50.7975611
    },
    {
        lng: 12.7761336,
        lat: 50.7991032
    },
    {
        lng: 12.7760483,
        lat: 50.8001884
    },
    {
        lng: 12.7756625,
        lat: 50.8011843
    },
    {
        lng: 12.7753053,
        lat: 50.801461
    },
    {
        lng: 12.7750936,
        lat: 50.8016248
    },
    {
        lng: 12.7743826,
        lat: 50.8017704
    },
    {
        lng: 12.7737387,
        lat: 50.8020142
    },
    {
        lng: 12.7731734,
        lat: 50.8022078
    },
    {
        lng: 12.7727259,
        lat: 50.8022539
    },
    {
        lng: 12.7721576,
        lat: 50.8023736
    },
    {
        lng: 12.7718262,
        lat: 50.8024494
    },
    {
        lng: 12.7713192,
        lat: 50.8024966
    },
    {
        lng: 12.770551,
        lat: 50.8027715
    },
    {
        lng: 12.7707332,
        lat: 50.8029832
    },
    {
        lng: 12.7699486,
        lat: 50.8032812
    },
    {
        lng: 12.7686617,
        lat: 50.8036559
    },
    {
        lng: 12.7670368,
        lat: 50.8039021
    },
    {
        lng: 12.7669409,
        lat: 50.8039404
    },
    {
        lng: 12.766618,
        lat: 50.8041738
    },
    {
        lng: 12.7674375,
        lat: 50.8055083
    },
    {
        lng: 12.7679044,
        lat: 50.8062975
    },
    {
        lng: 12.7685505,
        lat: 50.8073773
    },
    {
        lng: 12.7686031,
        lat: 50.8081705
    },
    {
        lng: 12.7685402,
        lat: 50.8084873
    },
    {
        lng: 12.7686747,
        lat: 50.8090666
    },
    {
        lng: 12.7685627,
        lat: 50.8098875
    },
    {
        lng: 12.7689972,
        lat: 50.8113107
    },
    {
        lng: 12.768217,
        lat: 50.8115357
    },
    {
        lng: 12.7678402,
        lat: 50.811395
    },
    {
        lng: 12.7674477,
        lat: 50.8109912
    },
    {
        lng: 12.7666149,
        lat: 50.8116153
    },
    {
        lng: 12.767384,
        lat: 50.8119716
    },
    {
        lng: 12.7666715,
        lat: 50.812287
    },
    {
        lng: 12.7657406,
        lat: 50.8123504
    },
    {
        lng: 12.7640003,
        lat: 50.8127031
    },
    {
        lng: 12.7626332,
        lat: 50.8133719
    },
    {
        lng: 12.7615254,
        lat: 50.8129466
    },
    {
        lng: 12.7597292,
        lat: 50.8130218
    },
    {
        lng: 12.7586063,
        lat: 50.8148156
    },
    {
        lng: 12.758057,
        lat: 50.814477
    },
    {
        lng: 12.7574208,
        lat: 50.8145729
    },
    {
        lng: 12.7572783,
        lat: 50.8147736
    },
    {
        lng: 12.7558086,
        lat: 50.8153776
    },
    {
        lng: 12.7542756,
        lat: 50.8166033
    },
    {
        lng: 12.7529304,
        lat: 50.8178763
    },
    {
        lng: 12.750659,
        lat: 50.8183819
    },
    {
        lng: 12.7501181,
        lat: 50.8185199
    },
    {
        lng: 12.7486977,
        lat: 50.8188836
    },
    {
        lng: 12.7477364,
        lat: 50.8191297
    },
    {
        lng: 12.7465826,
        lat: 50.8193548
    },
    {
        lng: 12.7476986,
        lat: 50.8214168
    },
    {
        lng: 12.7447327,
        lat: 50.8224207
    },
    {
        lng: 12.7416359,
        lat: 50.8224706
    },
    {
        lng: 12.7387121,
        lat: 50.8212091
    },
    {
        lng: 12.7399645,
        lat: 50.8199665
    },
    {
        lng: 12.7392435,
        lat: 50.8196864
    },
    {
        lng: 12.7385018,
        lat: 50.8191937
    },
    {
        lng: 12.7373397,
        lat: 50.818347
    },
    {
        lng: 12.7364506,
        lat: 50.8181552
    },
    {
        lng: 12.7336265,
        lat: 50.8176323
    },
    {
        lng: 12.731785,
        lat: 50.8172033
    },
    {
        lng: 12.72958,
        lat: 50.8165705
    },
    {
        lng: 12.7287238,
        lat: 50.8162496
    },
    {
        lng: 12.727798,
        lat: 50.8160287
    },
    {
        lng: 12.7276552,
        lat: 50.8162625
    },
    {
        lng: 12.7275333,
        lat: 50.8165949
    },
    {
        lng: 12.7275907,
        lat: 50.8170908
    }
];

});

parcelRegister("fEbUF", function(module, exports) {

var $1ciUP = parcelRequire("1ciUP");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)["delete"](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data["delete"](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join("") : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) _$result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + "", array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case "drop":
                        start += _$size;
                        break;
                    case "dropRight":
                        end -= _$size;
                        break;
                    case "take":
                        end = nativeMin(end, start + _$size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $1ciUP._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == "function" ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value);
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $1ciUP._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (_$result.__dir__ < 0 ? "Right" : "")
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == "function" && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});


parcelRegister("5K88x", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $42e78f6a9134b472$export$b3890eb0ae9dca99; }, function (v) { return $42e78f6a9134b472$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $42e78f6a9134b472$export$f8436702749526f9; }, function (v) { return $42e78f6a9134b472$export$f8436702749526f9 = v; });
var $42e78f6a9134b472$export$b3890eb0ae9dca99;
var $42e78f6a9134b472$export$f8436702749526f9;
var $42e78f6a9134b472$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("gmap-map", {
        attrs: {
            "center": _vm.center,
            "zoom": _vm.zoom,
            "mapTypeId": "roadmap",
            "options": {
                styles: _vm.mapStyles,
                scrollwheel: true
            }
        }
    }, [
        _c("gmap-info-window", {
            attrs: {
                "options": _vm.infoOptions,
                "position": _vm.infoWindowPos,
                "opened": _vm.infoIsOpen
            },
            on: {
                "closeclick": function($event) {
                    return _vm.toggleInfoWindow(null, _vm.currentInfoIndex);
                }
            }
        }, [
            _c("div", {
                domProps: {
                    "innerHTML": _vm._s(_vm.infoContent)
                }
            })
        ]),
        _vm._v(" "),
        _c("gmap-polygon", {
            attrs: {
                "paths": _vm.paths,
                "options": {
                    strokeColor: "#ffac00",
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    fillColor: "#ffac00",
                    fillOpacity: 0.15
                }
            }
        }),
        _vm._v(" "),
        _vm._l(_vm.markers, function(m, index) {
            return _c("gmap-marker", {
                key: index,
                attrs: {
                    "animation": 2,
                    "icon": m.icon,
                    "position": m.position
                },
                on: {
                    "click": function($event) {
                        return _vm.toggleInfoWindow(m, index);
                    }
                }
            });
        })
    ], 2);
};
var $42e78f6a9134b472$var$staticRenderFns = [];
$42e78f6a9134b472$export$b3890eb0ae9dca99 = $42e78f6a9134b472$var$render;
$42e78f6a9134b472$export$f8436702749526f9 = $42e78f6a9134b472$var$staticRenderFns;

});

parcelRegister("55t4g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b43f79ec56f841a$export$2e2bcd8739ae039; });
var $3b43f79ec56f841a$var$NOOP = function() {};
var $3b43f79ec56f841a$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("1mW8x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0ff4f14871451f02$export$2e2bcd8739ae039; });

var $0ff4f14871451f02$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("huuap")));
var $0ff4f14871451f02$var$options = typeof $0ff4f14871451f02$var$scriptExports === "function" ? $0ff4f14871451f02$var$scriptExports.options : $0ff4f14871451f02$var$scriptExports;
var $0ff4f14871451f02$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $0ff4f14871451f02$var$options;

});
parcelRegister("huuap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aPMlq = parcelRequire("aPMlq");
var $cbbca38b9984d785$var$_mapElementFactory2 = $cbbca38b9984d785$var$_interopRequireDefault($aPMlq);
function $cbbca38b9984d785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cbbca38b9984d785$var$props = {
    options: {
        type: Object,
        required: false,
        default: function _default() {
            return {};
        }
    },
    position: {
        type: Object,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    }
};
var $cbbca38b9984d785$var$events = [
    "domready",
    "closeclick",
    "content_changed"
];
module.exports.default = (0, $cbbca38b9984d785$var$_mapElementFactory2.default)({
    mappedProps: $cbbca38b9984d785$var$props,
    events: $cbbca38b9984d785$var$events,
    name: "infoWindow",
    ctr: function ctr() {
        return google.maps.InfoWindow;
    },
    props: {
        opened: {
            type: Boolean,
            default: true
        }
    },
    inject: {
        "$markerPromise": {
            default: null
        }
    },
    mounted: function mounted() {
        var el = this.$refs.flyaway;
        el.parentNode.removeChild(el);
    },
    beforeCreate: function beforeCreate(options) {
        var _this = this;
        options.content = this.$refs.flyaway;
        if (this.$markerPromise) {
            delete options.position;
            return this.$markerPromise.then(function(mo) {
                _this.$markerObject = mo;
                return mo;
            });
        }
    },
    methods: {
        _openInfoWindow: function _openInfoWindow() {
            if (this.opened) {
                if (this.$markerObject !== null) this.$infoWindowObject.open(this.$map, this.$markerObject);
                else this.$infoWindowObject.open(this.$map);
            } else this.$infoWindowObject.close();
        }
    },
    afterCreate: function afterCreate() {
        var _this2 = this;
        this._openInfoWindow();
        this.$watch("opened", function() {
            _this2._openInfoWindow();
        });
    }
});

});
parcelRegister("aPMlq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7e342b0389f3b3d8$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $7e342b0389f3b3d8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.default = function(options) {
    var mappedProps = options.mappedProps, name = options.name, ctr = options.ctr, ctrArgs = options.ctrArgs, events = options.events, beforeCreate = options.beforeCreate, afterCreate = options.afterCreate, props = options.props, rest = $7e342b0389f3b3d8$var$_objectWithoutProperties(options, [
        "mappedProps",
        "name",
        "ctr",
        "ctrArgs",
        "events",
        "beforeCreate",
        "afterCreate",
        "props"
    ]);
    var promiseName = "$" + name + "Promise";
    var instanceName = "$" + name + "Object";
    $7e342b0389f3b3d8$var$assert(!(rest.props instanceof Array), "`props` should be an object, not Array");
    return $7e342b0389f3b3d8$var$_extends({}, typeof GENERATE_DOC !== "undefined" ? {
        $vgmOptions: options
    } : {}, {
        mixins: [
            $7e342b0389f3b3d8$var$_mapElementMixin2.default
        ],
        props: $7e342b0389f3b3d8$var$_extends({}, props, $7e342b0389f3b3d8$var$mappedPropsToVueProps(mappedProps)),
        render: function render() {
            return "";
        },
        provide: function provide() {
            var _this = this;
            var promise = this.$mapPromise.then(function(map) {
                // Infowindow needs this to be immediately available
                _this.$map = map;
                // Initialize the maps with the given options
                var _$options = $7e342b0389f3b3d8$var$_extends({}, _this.options, {
                    map: map
                }, (0, $elenB.getPropsValues)(_this, mappedProps));
                delete _$options.options; // delete the extra options
                if (beforeCreate) {
                    var result = beforeCreate.bind(_this)(_$options);
                    if (result instanceof Promise) return result.then(function() {
                        return {
                            options: _$options
                        };
                    });
                }
                return {
                    options: _$options
                };
            }).then(function(_ref) {
                var _Function$prototype$b;
                var _$options = _ref.options;
                var ConstructorObject = ctr();
                // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
                _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [
                    ConstructorObject,
                    null
                ].concat($7e342b0389f3b3d8$var$_toConsumableArray(ctrArgs(_$options, (0, $elenB.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(_$options);
                (0, $elenB.bindProps)(_this, _this[instanceName], mappedProps);
                (0, $7e342b0389f3b3d8$var$_bindEvents2.default)(_this, _this[instanceName], events);
                if (afterCreate) afterCreate.bind(_this)(_this[instanceName]);
                return _this[instanceName];
            });
            this[promiseName] = promise;
            return $7e342b0389f3b3d8$var$_defineProperty({}, promiseName, promise);
        },
        destroyed: function destroyed() {
            // Note: not all Google Maps components support maps
            if (this[instanceName] && this[instanceName].setMap) this[instanceName].setMap(null);
        }
    }, rest);
};
module.exports.mappedPropsToVueProps = $7e342b0389f3b3d8$var$mappedPropsToVueProps;

var $3VI0X = parcelRequire("3VI0X");
var $7e342b0389f3b3d8$var$_bindEvents2 = $7e342b0389f3b3d8$var$_interopRequireDefault($3VI0X);

var $elenB = parcelRequire("elenB");

var $bax0Z = parcelRequire("bax0Z");
var $7e342b0389f3b3d8$var$_mapElementMixin2 = $7e342b0389f3b3d8$var$_interopRequireDefault($bax0Z);
function $7e342b0389f3b3d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e342b0389f3b3d8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7e342b0389f3b3d8$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $7e342b0389f3b3d8$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */ function $7e342b0389f3b3d8$var$assert(v, message) {
    if (!v) throw new Error(message);
}
/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */ function $7e342b0389f3b3d8$var$mappedPropsToVueProps(mappedProps) {
    return Object.entries(mappedProps).map(function(_ref3) {
        var _ref4 = $7e342b0389f3b3d8$var$_slicedToArray(_ref3, 2), key = _ref4[0], prop = _ref4[1];
        var value = {};
        if ("type" in prop) value.type = prop.type;
        if ("default" in prop) value.default = prop.default;
        if ("required" in prop) value.required = prop.required;
        return [
            key,
            value
        ];
    }).reduce(function(acc, _ref5) {
        var _ref6 = $7e342b0389f3b3d8$var$_slicedToArray(_ref5, 2), key = _ref6[0], val = _ref6[1];
        acc[key] = val;
        return acc;
    }, {});
}

});
parcelRegister("3VI0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(vueInst, googleMapsInst, events) {
    var _loop = function _loop(eventName) {
        if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) googleMapsInst.addListener(eventName, function(ev) {
            vueInst.$emit(eventName, ev);
        });
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventName = _step.value;
            _loop(eventName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
};

});

parcelRegister("elenB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPropsValues = $a70e2e5c139c3b87$var$getPropsValues;
module.exports.bindProps = $a70e2e5c139c3b87$var$bindProps;

var $a4PDV = parcelRequire("a4PDV");
var $a70e2e5c139c3b87$var$_WatchPrimitiveProperties2 = $a70e2e5c139c3b87$var$_interopRequireDefault($a4PDV);
function $a70e2e5c139c3b87$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a70e2e5c139c3b87$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $a70e2e5c139c3b87$var$getPropsValues(vueInst, props) {
    return Object.keys(props).reduce(function(acc, prop) {
        if (vueInst[prop] !== undefined) acc[prop] = vueInst[prop];
        return acc;
    }, {});
}
/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */ function $a70e2e5c139c3b87$var$bindProps(vueInst, googleMapsInst, props) {
    var _loop = function _loop(attribute) {
        var _props$attribute = props[attribute], twoWay = _props$attribute.twoWay, type = _props$attribute.type, trackProperties = _props$attribute.trackProperties, noBind = _props$attribute.noBind;
        if (noBind) return "continue";
        var setMethodName = "set" + $a70e2e5c139c3b87$var$capitalizeFirstLetter(attribute);
        var getMethodName = "get" + $a70e2e5c139c3b87$var$capitalizeFirstLetter(attribute);
        var eventName = attribute.toLowerCase() + "_changed";
        var initialValue = vueInst[attribute];
        if (typeof googleMapsInst[setMethodName] === "undefined") throw new Error(setMethodName + " is not a method of (the Maps object corresponding to) " + vueInst.$options._componentTag);
        // We need to avoid an endless
        // propChanged -> event emitted -> propChanged -> event emitted loop
        // although this may really be the user's responsibility
        if (type !== Object || !trackProperties) // Track the object deeply
        vueInst.$watch(attribute, function() {
            var attributeValue = vueInst[attribute];
            googleMapsInst[setMethodName](attributeValue);
        }, {
            immediate: typeof initialValue !== "undefined",
            deep: type === Object
        });
        else (0, $a70e2e5c139c3b87$var$_WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function(prop) {
            return attribute + "." + prop;
        }), function() {
            googleMapsInst[setMethodName](vueInst[attribute]);
        }, vueInst[attribute] !== undefined);
        if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) googleMapsInst.addListener(eventName, function() {
            // eslint-disable-line no-unused-vars
            vueInst.$emit(eventName, googleMapsInst[getMethodName]());
        });
    };
    for(var attribute in props){
        var _ret = _loop(attribute);
        if (_ret === "continue") continue;
    }
}

});
parcelRegister("a4PDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $756256509fe271e2$var$WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */ function $756256509fe271e2$var$WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
    var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var isHandled = false;
    function requestHandle() {
        if (!isHandled) {
            isHandled = true;
            vueInst.$nextTick(function() {
                isHandled = false;
                handler();
            });
        }
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            vueInst.$watch(prop, requestHandle, {
                immediate: immediate
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}

});


parcelRegister("bax0Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */ module.exports.default = {
    inject: {
        "$mapPromise": {
            default: "abcdef"
        }
    },
    provide: function provide() {
        var _this = this;
        // Note: although this mixin is not "providing" anything,
        // components' expect the `$map` property to be present on the component.
        // In order for that to happen, this mixin must intercept the $mapPromise
        // .then(() =>) first before its component does so.
        //
        // Since a provide() on a mixin is executed before a provide() on the
        // component, putting this code in provide() ensures that the $map is
        // already set by the time the
        // component's provide() is called.
        this.$mapPromise.then(function(map) {
            _this.$map = map;
        });
        return {};
    }
};

});




parcelRegister("cvBCQ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $91b590f070fa783b$export$b3890eb0ae9dca99; }, function (v) { return $91b590f070fa783b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $91b590f070fa783b$export$f8436702749526f9; }, function (v) { return $91b590f070fa783b$export$f8436702749526f9 = v; });
var $91b590f070fa783b$export$b3890eb0ae9dca99;
var $91b590f070fa783b$export$f8436702749526f9;
var $91b590f070fa783b$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("div", {
            ref: "flyaway"
        }, [
            _vm._t("default")
        ], 2)
    ]);
};
var $91b590f070fa783b$var$staticRenderFns = [];
$91b590f070fa783b$export$b3890eb0ae9dca99 = $91b590f070fa783b$var$render;
$91b590f070fa783b$export$f8436702749526f9 = $91b590f070fa783b$var$staticRenderFns;

});

parcelRegister("ivgzu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d787f9f7f3ed457f$export$2e2bcd8739ae039; });
var $d787f9f7f3ed457f$var$NOOP = function() {};
var $d787f9f7f3ed457f$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("lqgY7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f98930523cde1d26$export$2e2bcd8739ae039; });

var $f98930523cde1d26$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("1R5MB")));
var $f98930523cde1d26$var$options = typeof $f98930523cde1d26$var$scriptExports === "function" ? $f98930523cde1d26$var$scriptExports.options : $f98930523cde1d26$var$scriptExports;
var $f98930523cde1d26$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $f98930523cde1d26$var$options;

});
parcelRegister("1R5MB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $159f3a0997f246ef$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $3VI0X = parcelRequire("3VI0X");
var $159f3a0997f246ef$var$_bindEvents2 = $159f3a0997f246ef$var$_interopRequireDefault($3VI0X);

var $elenB = parcelRequire("elenB");

var $iRPkI = parcelRequire("iRPkI");
var $159f3a0997f246ef$var$_mountableMixin2 = $159f3a0997f246ef$var$_interopRequireDefault($iRPkI);

var $4VeqU = parcelRequire("4VeqU");
var $159f3a0997f246ef$var$_TwoWayBindingWrapper2 = $159f3a0997f246ef$var$_interopRequireDefault($4VeqU);

var $a4PDV = parcelRequire("a4PDV");
var $159f3a0997f246ef$var$_WatchPrimitiveProperties2 = $159f3a0997f246ef$var$_interopRequireDefault($a4PDV);

var $aPMlq = parcelRequire("aPMlq");
function $159f3a0997f246ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $159f3a0997f246ef$var$props = {
    center: {
        required: true,
        twoWay: true,
        type: Object,
        noBind: true
    },
    zoom: {
        required: false,
        twoWay: true,
        type: Number,
        noBind: true
    },
    heading: {
        type: Number,
        twoWay: true
    },
    mapTypeId: {
        twoWay: true,
        type: String
    },
    tilt: {
        twoWay: true,
        type: Number
    },
    options: {
        type: Object,
        default: function _default() {
            return {};
        }
    }
};
var $159f3a0997f246ef$var$events = [
    "bounds_changed",
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "idle",
    "mousemove",
    "mouseout",
    "mouseover",
    "resize",
    "rightclick",
    "tilesloaded"
];
// Plain Google Maps methods exposed here for convenience
var $159f3a0997f246ef$var$linkedMethods = [
    "panBy",
    "panTo",
    "panToBounds",
    "fitBounds"
].reduce(function(all, methodName) {
    all[methodName] = function() {
        if (this.$mapObject) this.$mapObject[methodName].apply(this.$mapObject, arguments);
    };
    return all;
}, {});
// Other convenience methods exposed by Vue Google Maps
var $159f3a0997f246ef$var$customMethods = {
    resize: function resize() {
        if (this.$mapObject) google.maps.event.trigger(this.$mapObject, "resize");
    },
    resizePreserveCenter: function resizePreserveCenter() {
        if (!this.$mapObject) return;
        var oldCenter = this.$mapObject.getCenter();
        google.maps.event.trigger(this.$mapObject, "resize");
        this.$mapObject.setCenter(oldCenter);
    },
    /// Override mountableMixin::_resizeCallback
    /// because resizePreserveCenter is usually the
    /// expected behaviour
    _resizeCallback: function _resizeCallback() {
        this.resizePreserveCenter();
    }
};
module.exports.default = {
    mixins: [
        $159f3a0997f246ef$var$_mountableMixin2.default
    ],
    props: (0, $aPMlq.mappedPropsToVueProps)($159f3a0997f246ef$var$props),
    provide: function provide() {
        var _this = this;
        this.$mapPromise = new Promise(function(resolve, reject) {
            _this.$mapPromiseDeferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            "$mapPromise": this.$mapPromise
        };
    },
    computed: {
        finalLat: function finalLat() {
            return this.center && typeof this.center.lat === "function" ? this.center.lat() : this.center.lat;
        },
        finalLng: function finalLng() {
            return this.center && typeof this.center.lng === "function" ? this.center.lng() : this.center.lng;
        },
        finalLatLng: function finalLatLng() {
            return {
                lat: this.finalLat,
                lng: this.finalLng
            };
        }
    },
    watch: {
        zoom: function zoom(_zoom) {
            if (this.$mapObject) this.$mapObject.setZoom(_zoom);
        }
    },
    mounted: function mounted() {
        var _this2 = this;
        return this.$gmapApiPromiseLazy().then(function() {
            // getting the DOM element where to create the map
            var element = _this2.$refs["vue-map"];
            // creating the map
            var options = $159f3a0997f246ef$var$_extends({}, _this2.options, (0, $elenB.getPropsValues)(_this2, $159f3a0997f246ef$var$props));
            delete options.options;
            _this2.$mapObject = new google.maps.Map(element, options);
            // binding properties (two and one way)
            (0, $elenB.bindProps)(_this2, _this2.$mapObject, $159f3a0997f246ef$var$props);
            // binding events
            (0, $159f3a0997f246ef$var$_bindEvents2.default)(_this2, _this2.$mapObject, $159f3a0997f246ef$var$events);
            // manually trigger center and zoom
            (0, $159f3a0997f246ef$var$_TwoWayBindingWrapper2.default)(function(increment, decrement, shouldUpdate) {
                _this2.$mapObject.addListener("center_changed", function() {
                    if (shouldUpdate()) _this2.$emit("center_changed", _this2.$mapObject.getCenter());
                    decrement();
                });
                (0, $159f3a0997f246ef$var$_WatchPrimitiveProperties2.default)(_this2, [
                    "finalLat",
                    "finalLng"
                ], function updateCenter() {
                    increment();
                    _this2.$mapObject.setCenter(_this2.finalLatLng);
                });
            });
            _this2.$mapObject.addListener("zoom_changed", function() {
                _this2.$emit("zoom_changed", _this2.$mapObject.getZoom());
            });
            _this2.$mapObject.addListener("bounds_changed", function() {
                _this2.$emit("bounds_changed", _this2.$mapObject.getBounds());
            });
            _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);
            return _this2.$mapObject;
        }).catch(function(error) {
            throw error;
        });
    },
    methods: $159f3a0997f246ef$var$_extends({}, $159f3a0997f246ef$var$customMethods, $159f3a0997f246ef$var$linkedMethods)
};

});
parcelRegister("iRPkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/ module.exports.default = {
    props: [
        "resizeBus"
    ],
    data: function data() {
        return {
            _actualResizeBus: null
        };
    },
    created: function created() {
        if (typeof this.resizeBus === "undefined") this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
        else this.$data._actualResizeBus = this.resizeBus;
    },
    methods: {
        _resizeCallback: function _resizeCallback() {
            this.resize();
        },
        _delayedResizeCallback: function _delayedResizeCallback() {
            var _this = this;
            this.$nextTick(function() {
                return _this._resizeCallback();
            });
        }
    },
    watch: {
        resizeBus: function resizeBus(newVal) {
            // eslint-disable-line no-unused-vars
            this.$data._actualResizeBus = newVal;
        },
        "$data._actualResizeBus": function $data_actualResizeBus(newVal, oldVal) {
            if (oldVal) oldVal.$off("resize", this._delayedResizeCallback);
            if (newVal) newVal.$on("resize", this._delayedResizeCallback);
        }
    },
    destroyed: function destroyed() {
        if (this.$data._actualResizeBus) this.$data._actualResizeBus.$off("resize", this._delayedResizeCallback);
    }
};

});

parcelRegister("4VeqU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3957ae6332aed797$var$TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */ function $3957ae6332aed797$var$TwoWayBindingWrapper(fn) {
    var counter = 0;
    fn(function() {
        counter += 1;
    }, function() {
        counter = Math.max(0, counter - 1);
    }, function() {
        return counter === 0;
    });
}

});



parcelRegister("72J80", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $520bb9cddd2bb8b1$export$b3890eb0ae9dca99; }, function (v) { return $520bb9cddd2bb8b1$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $520bb9cddd2bb8b1$export$f8436702749526f9; }, function (v) { return $520bb9cddd2bb8b1$export$f8436702749526f9 = v; });
var $520bb9cddd2bb8b1$export$b3890eb0ae9dca99;
var $520bb9cddd2bb8b1$export$f8436702749526f9;
var $520bb9cddd2bb8b1$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "vue-map-container"
    }, [
        _c("div", {
            ref: "vue-map",
            staticClass: "vue-map"
        }),
        _vm._v(" "),
        _c("div", {
            staticClass: "vue-map-hidden"
        }, [
            _vm._t("default")
        ], 2),
        _vm._v(" "),
        _vm._t("visible")
    ], 2);
};
var $520bb9cddd2bb8b1$var$staticRenderFns = [];
$520bb9cddd2bb8b1$export$b3890eb0ae9dca99 = $520bb9cddd2bb8b1$var$render;
$520bb9cddd2bb8b1$export$f8436702749526f9 = $520bb9cddd2bb8b1$var$staticRenderFns;

});

parcelRegister("g35cf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baf0f514549f98ef$export$2e2bcd8739ae039; });
var $baf0f514549f98ef$var$NOOP = function() {};
var $baf0f514549f98ef$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("5N94W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4378922dd06248f2$export$2e2bcd8739ae039; });

var $4378922dd06248f2$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("78vBE")));
var $4378922dd06248f2$var$options = typeof $4378922dd06248f2$var$scriptExports === "function" ? $4378922dd06248f2$var$scriptExports.options : $4378922dd06248f2$var$scriptExports;
var $4378922dd06248f2$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $4378922dd06248f2$var$options;

});
parcelRegister("78vBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5321cc1c20b220e7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $3VI0X = parcelRequire("3VI0X");
var $5321cc1c20b220e7$var$_bindEvents2 = $5321cc1c20b220e7$var$_interopRequireDefault($3VI0X);

var $elenB = parcelRequire("elenB");

var $iRPkI = parcelRequire("iRPkI");
var $5321cc1c20b220e7$var$_mountableMixin2 = $5321cc1c20b220e7$var$_interopRequireDefault($iRPkI);

var $4VeqU = parcelRequire("4VeqU");
var $5321cc1c20b220e7$var$_TwoWayBindingWrapper2 = $5321cc1c20b220e7$var$_interopRequireDefault($4VeqU);

var $a4PDV = parcelRequire("a4PDV");
var $5321cc1c20b220e7$var$_WatchPrimitiveProperties2 = $5321cc1c20b220e7$var$_interopRequireDefault($a4PDV);

var $aPMlq = parcelRequire("aPMlq");
function $5321cc1c20b220e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5321cc1c20b220e7$var$props = {
    zoom: {
        twoWay: true,
        type: Number
    },
    pov: {
        twoWay: true,
        type: Object,
        trackProperties: [
            "pitch",
            "heading"
        ]
    },
    position: {
        twoWay: true,
        type: Object,
        noBind: true
    },
    pano: {
        twoWay: true,
        type: String
    },
    motionTracking: {
        twoWay: false,
        type: Boolean
    },
    visible: {
        twoWay: true,
        type: Boolean,
        default: true
    },
    options: {
        twoWay: false,
        type: Object,
        default: function _default() {
            return {};
        }
    }
};
var $5321cc1c20b220e7$var$events = [
    "closeclick",
    "status_changed"
];
module.exports.default = {
    mixins: [
        $5321cc1c20b220e7$var$_mountableMixin2.default
    ],
    props: (0, $aPMlq.mappedPropsToVueProps)($5321cc1c20b220e7$var$props),
    replace: false,
    methods: {
        resize: function resize() {
            if (this.$panoObject) google.maps.event.trigger(this.$panoObject, "resize");
        }
    },
    provide: function provide() {
        var _this = this;
        var promise = new Promise(function(resolve, reject) {
            _this.$panoPromiseDeferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            "$panoPromise": promise,
            "$mapPromise": promise // so that we can use it with markers
        };
    },
    computed: {
        finalLat: function finalLat() {
            return this.position && typeof this.position.lat === "function" ? this.position.lat() : this.position.lat;
        },
        finalLng: function finalLng() {
            return this.position && typeof this.position.lng === "function" ? this.position.lng() : this.position.lng;
        },
        finalLatLng: function finalLatLng() {
            return {
                lat: this.finalLat,
                lng: this.finalLng
            };
        }
    },
    watch: {
        zoom: function zoom(_zoom) {
            if (this.$panoObject) this.$panoObject.setZoom(_zoom);
        }
    },
    mounted: function mounted() {
        var _this2 = this;
        return this.$gmapApiPromiseLazy().then(function() {
            // getting the DOM element where to create the map
            var element = _this2.$refs["vue-street-view-pano"];
            // creating the map
            var options = $5321cc1c20b220e7$var$_extends({}, _this2.options, (0, $elenB.getPropsValues)(_this2, $5321cc1c20b220e7$var$props));
            delete options.options;
            _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);
            // binding properties (two and one way)
            (0, $elenB.bindProps)(_this2, _this2.$panoObject, $5321cc1c20b220e7$var$props);
            // binding events
            (0, $5321cc1c20b220e7$var$_bindEvents2.default)(_this2, _this2.$panoObject, $5321cc1c20b220e7$var$events);
            // manually trigger position
            (0, $5321cc1c20b220e7$var$_TwoWayBindingWrapper2.default)(function(increment, decrement, shouldUpdate) {
                // Panos take a while to load
                increment();
                _this2.$panoObject.addListener("position_changed", function() {
                    if (shouldUpdate()) _this2.$emit("position_changed", _this2.$panoObject.getPosition());
                    decrement();
                });
                (0, $5321cc1c20b220e7$var$_WatchPrimitiveProperties2.default)(_this2, [
                    "finalLat",
                    "finalLng"
                ], function updateCenter() {
                    increment();
                    _this2.$panoObject.setPosition(_this2.finalLatLng);
                });
            });
            _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);
            return _this2.$panoPromise;
        }).catch(function(error) {
            throw error;
        });
    }
};

});


parcelRegister("3C85z", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2a1b32005eede806$export$b3890eb0ae9dca99; }, function (v) { return $2a1b32005eede806$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $2a1b32005eede806$export$f8436702749526f9; }, function (v) { return $2a1b32005eede806$export$f8436702749526f9 = v; });
var $2a1b32005eede806$export$b3890eb0ae9dca99;
var $2a1b32005eede806$export$f8436702749526f9;
var $2a1b32005eede806$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "vue-street-view-pano-container"
    }, [
        _c("div", {
            ref: "vue-street-view-pano",
            staticClass: "vue-street-view-pano"
        }),
        _vm._v(" "),
        _vm._t("default")
    ], 2);
};
var $2a1b32005eede806$var$staticRenderFns = [];
$2a1b32005eede806$export$b3890eb0ae9dca99 = $2a1b32005eede806$var$render;
$2a1b32005eede806$export$f8436702749526f9 = $2a1b32005eede806$var$staticRenderFns;

});

parcelRegister("ft8tN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4302450495e5acf$export$2e2bcd8739ae039; });
var $b4302450495e5acf$var$NOOP = function() {};
var $b4302450495e5acf$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("d3PgA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $elenB = parcelRequire("elenB");

var $eL1rY = parcelRequire("eL1rY");
var $982352a69f0a17e2$var$_simulateArrowDown2 = $982352a69f0a17e2$var$_interopRequireDefault($eL1rY);
function $982352a69f0a17e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $982352a69f0a17e2$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $982352a69f0a17e2$var$props = {
    bounds: {
        type: Object
    },
    defaultPlace: {
        type: String,
        default: ""
    },
    componentRestrictions: {
        type: Object,
        default: null
    },
    types: {
        type: Array,
        default: function _default() {
            return [];
        }
    },
    placeholder: {
        required: false,
        type: String
    },
    className: {
        required: false,
        type: String
    },
    label: {
        required: false,
        type: String,
        default: null
    },
    selectFirstOnEnter: {
        require: false,
        type: Boolean,
        default: false
    }
};
module.exports.default = {
    mounted: function mounted() {
        var _this = this;
        var input = this.$refs.input;
        // Allow default place to be set
        input.value = this.defaultPlace;
        this.$watch("defaultPlace", function() {
            input.value = _this.defaultPlace;
        });
        this.$gmapApiPromiseLazy().then(function() {
            var options = (0, $elenB.getPropsValues)(_this, $982352a69f0a17e2$var$props);
            if (_this.selectFirstOnEnter) (0, $982352a69f0a17e2$var$_simulateArrowDown2.default)(_this.$refs.input);
            if (typeof google.maps.places.Autocomplete !== "function") throw new Error("google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?");
            _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);
            var placeholder = $982352a69f0a17e2$var$props.placeholder, place = $982352a69f0a17e2$var$props.place, defaultPlace = $982352a69f0a17e2$var$props.defaultPlace, className = $982352a69f0a17e2$var$props.className, label = $982352a69f0a17e2$var$props.label, selectFirstOnEnter = $982352a69f0a17e2$var$props.selectFirstOnEnter, rest = $982352a69f0a17e2$var$_objectWithoutProperties($982352a69f0a17e2$var$props, [
                "placeholder",
                "place",
                "defaultPlace",
                "className",
                "label",
                "selectFirstOnEnter"
            ]); // eslint-disable-line
            (0, $elenB.bindProps)(_this, _this.autoCompleter, rest);
            _this.autoCompleter.addListener("place_changed", function() {
                _this.$emit("place_changed", _this.autoCompleter.getPlace());
            });
        });
    },
    created: function created() {
        console.warn("The PlaceInput class is deprecated! Please consider using the Autocomplete input instead"); // eslint-disable-line no-console
    },
    props: $982352a69f0a17e2$var$props
};

});
parcelRegister("eL1rY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
module.exports.default = function(input) {
    var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
    function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type === "keydown") {
            var origListener = listener;
            listener = function listener(event) {
                var suggestionSelected = document.getElementsByClassName("pac-item-selected").length > 0;
                if (event.which === 13 && !suggestionSelected) {
                    var simulatedEvent = document.createEvent("Event");
                    simulatedEvent.keyCode = 40;
                    simulatedEvent.which = 40;
                    origListener.apply(input, [
                        simulatedEvent
                    ]);
                }
                origListener.apply(input, [
                    event
                ]);
            };
        }
        _addEventListener.apply(input, [
            type,
            listener
        ]);
    }
    input.addEventListener = addEventListenerWrapper;
    input.attachEvent = addEventListenerWrapper;
};

});


parcelRegister("6DkLa", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $4d467d0e184b490a$export$b3890eb0ae9dca99; }, function (v) { return $4d467d0e184b490a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $4d467d0e184b490a$export$f8436702749526f9; }, function (v) { return $4d467d0e184b490a$export$f8436702749526f9 = v; });
var $4d467d0e184b490a$export$b3890eb0ae9dca99;
var $4d467d0e184b490a$export$f8436702749526f9;
var $4d467d0e184b490a$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("label", [
        _c("span", {
            domProps: {
                "textContent": _vm._s(_vm.label)
            }
        }),
        _vm._v(" "),
        _c("input", {
            ref: "input",
            class: _vm.className,
            attrs: {
                "type": "text",
                "placeholder": _vm.placeholder
            }
        })
    ]);
};
var $4d467d0e184b490a$var$staticRenderFns = [];
$4d467d0e184b490a$export$b3890eb0ae9dca99 = $4d467d0e184b490a$var$render;
$4d467d0e184b490a$export$f8436702749526f9 = $4d467d0e184b490a$var$staticRenderFns;

});

parcelRegister("irgqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6c77e6d71815675$export$2e2bcd8739ae039; });
var $d6c77e6d71815675$var$NOOP = function() {};
var $d6c77e6d71815675$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("kgAzi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ec11aaf616341274$export$2e2bcd8739ae039; });

var $ec11aaf616341274$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("jHmdc")));
var $ec11aaf616341274$var$options = typeof $ec11aaf616341274$var$scriptExports === "function" ? $ec11aaf616341274$var$scriptExports.options : $ec11aaf616341274$var$scriptExports;
var $ec11aaf616341274$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $ec11aaf616341274$var$options;

});
parcelRegister("jHmdc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e57343481ecfea13$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $elenB = parcelRequire("elenB");

var $eL1rY = parcelRequire("eL1rY");
var $e57343481ecfea13$var$_simulateArrowDown2 = $e57343481ecfea13$var$_interopRequireDefault($eL1rY);

var $aPMlq = parcelRequire("aPMlq");
function $e57343481ecfea13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e57343481ecfea13$var$mappedProps = {
    bounds: {
        type: Object
    },
    componentRestrictions: {
        type: Object,
        // Do not bind -- must check for undefined
        // in the property
        noBind: true
    },
    types: {
        type: Array,
        default: function _default() {
            return [];
        }
    }
};
var $e57343481ecfea13$var$props = {
    selectFirstOnEnter: {
        required: false,
        type: Boolean,
        default: false
    },
    options: {
        type: Object
    }
};
module.exports.default = {
    mounted: function mounted() {
        var _this = this;
        this.$gmapApiPromiseLazy().then(function() {
            if (_this.selectFirstOnEnter) (0, $e57343481ecfea13$var$_simulateArrowDown2.default)(_this.$refs.input);
            if (typeof google.maps.places.Autocomplete !== "function") throw new Error("google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?");
            /* eslint-disable no-unused-vars */ var finalOptions = $e57343481ecfea13$var$_extends({}, (0, $elenB.getPropsValues)(_this, $e57343481ecfea13$var$mappedProps), _this.options);
            _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
            (0, $elenB.bindProps)(_this, _this.$autocomplete, $e57343481ecfea13$var$mappedProps);
            _this.$watch("componentRestrictions", function(v) {
                if (v !== undefined) _this.$autocomplete.setComponentRestrictions(v);
            });
            // Not using `bindEvents` because we also want
            // to return the result of `getPlace()`
            _this.$autocomplete.addListener("place_changed", function() {
                _this.$emit("place_changed", _this.$autocomplete.getPlace());
            });
        });
    },
    props: $e57343481ecfea13$var$_extends({}, (0, $aPMlq.mappedPropsToVueProps)($e57343481ecfea13$var$mappedProps), $e57343481ecfea13$var$props)
};

});


parcelRegister("eHprZ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ab38d2befdfee3f6$export$b3890eb0ae9dca99; }, function (v) { return $ab38d2befdfee3f6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $ab38d2befdfee3f6$export$f8436702749526f9; }, function (v) { return $ab38d2befdfee3f6$export$f8436702749526f9 = v; });
var $ab38d2befdfee3f6$export$b3890eb0ae9dca99;
var $ab38d2befdfee3f6$export$f8436702749526f9;
var $ab38d2befdfee3f6$var$render = function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("input", _vm._g(_vm._b({
        ref: "input"
    }, "input", _vm.$attrs, false), _vm.$listeners));
};
var $ab38d2befdfee3f6$var$staticRenderFns = [];
$ab38d2befdfee3f6$export$b3890eb0ae9dca99 = $ab38d2befdfee3f6$var$render;
$ab38d2befdfee3f6$export$f8436702749526f9 = $ab38d2befdfee3f6$var$staticRenderFns;

});

parcelRegister("dbOht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99a34e2875f8df60$export$2e2bcd8739ae039; });
var $99a34e2875f8df60$var$NOOP = function() {};
var $99a34e2875f8df60$export$2e2bcd8739ae039 = function(script) {};

});





var $152411b773325f9f$exports = {};

var $1ciUP = parcelRequire("1ciUP");


/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory($152411b773325f9f$exports, (parcelRequire("aPoFX")), (parcelRequire("1x6H7")));
})(undefined, function(exports1, $, Popper) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    var Popper__default = /*#__PURE__*/ _interopDefaultLegacy(Popper);
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Private TransitionEnd Helpers
   */ var TRANSITION_END = "transitionend";
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        if (obj === null || typeof obj === "undefined") return "" + obj;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: TRANSITION_END,
            delegateType: TRANSITION_END,
            handle: function handle(event) {
                if ($__default["default"](event.target).is(this)) return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                return undefined;
            }
        };
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $__default["default"](this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
        $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * Public Util API
   */ var Util = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function getUID(prefix) {
            do // eslint-disable-next-line no-bitwise
            prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function getSelectorFromElement(element) {
            var selector = element.getAttribute("data-target");
            if (!selector || selector === "#") {
                var hrefAttr = element.getAttribute("href");
                selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : "";
            }
            try {
                return document.querySelector(selector) ? selector : null;
            } catch (_) {
                return null;
            }
        },
        getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
            if (!element) return 0;
             // Get transition-duration of the element
            var transitionDuration = $__default["default"](element).css("transition-duration");
            var transitionDelay = $__default["default"](element).css("transition-delay");
            var floatTransitionDuration = parseFloat(transitionDuration);
            var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
            if (!floatTransitionDuration && !floatTransitionDelay) return 0;
             // If multiple durations are defined, take the first
            transitionDuration = transitionDuration.split(",")[0];
            transitionDelay = transitionDelay.split(",")[0];
            return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
        },
        reflow: function reflow(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function triggerTransitionEnd(element) {
            $__default["default"](element).trigger(TRANSITION_END);
        },
        supportsTransitionEnd: function supportsTransitionEnd() {
            return Boolean(TRANSITION_END);
        },
        isElement: function isElement(obj) {
            return (obj[0] || obj).nodeType;
        },
        typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
            for(var property in configTypes)if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && Util.isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error(componentName.toUpperCase() + ": " + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
            }
        },
        findShadowRoot: function findShadowRoot(element) {
            if (!document.documentElement.attachShadow) return null;
             // Can find the shadow root otherwise it'll return the document
            if (typeof element.getRootNode === "function") {
                var root = element.getRootNode();
                return root instanceof ShadowRoot ? root : null;
            }
            if (element instanceof ShadowRoot) return element;
             // when we don't find a shadow root
            if (!element.parentNode) return null;
            return Util.findShadowRoot(element.parentNode);
        },
        jQueryDetection: function jQueryDetection() {
            if (typeof $__default["default"] === "undefined") throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var version = $__default["default"].fn.jquery.split(" ")[0].split(".");
            var minMajor = 1;
            var ltMajor = 2;
            var minMinor = 9;
            var minPatch = 1;
            var maxMajor = 4;
            if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    Util.jQueryDetection();
    setTransitionEndSupport();
    /**
   * Constants
   */ var NAME$a = "alert";
    var VERSION$a = "4.6.2";
    var DATA_KEY$a = "bs.alert";
    var EVENT_KEY$a = "." + DATA_KEY$a;
    var DATA_API_KEY$7 = ".data-api";
    var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
    var CLASS_NAME_ALERT = "alert";
    var CLASS_NAME_FADE$5 = "fade";
    var CLASS_NAME_SHOW$7 = "show";
    var EVENT_CLOSE = "close" + EVENT_KEY$a;
    var EVENT_CLOSED = "closed" + EVENT_KEY$a;
    var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
    var SELECTOR_DISMISS = '[data-dismiss="alert"]';
    /**
   * Class definition
   */ var Alert = /*#__PURE__*/ function() {
        function Alert(element) {
            this._element = element;
        } // Getters
        var _proto = Alert.prototype;
        // Public
        _proto.close = function close(element) {
            var rootElement = this._element;
            if (element) rootElement = this._getRootElement(element);
            var customEvent = this._triggerCloseEvent(rootElement);
            if (customEvent.isDefaultPrevented()) return;
            this._removeElement(rootElement);
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$a);
            this._element = null;
        } // Private
        ;
        _proto._getRootElement = function _getRootElement(element) {
            var selector = Util.getSelectorFromElement(element);
            var parent = false;
            if (selector) parent = document.querySelector(selector);
            if (!parent) parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
            return parent;
        };
        _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
            var closeEvent = $__default["default"].Event(EVENT_CLOSE);
            $__default["default"](element).trigger(closeEvent);
            return closeEvent;
        };
        _proto._removeElement = function _removeElement(element) {
            var _this = this;
            $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);
            if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
                this._destroyElement(element);
                return;
            }
            var transitionDuration = Util.getTransitionDurationFromElement(element);
            $__default["default"](element).one(Util.TRANSITION_END, function(event) {
                return _this._destroyElement(element, event);
            }).emulateTransitionEnd(transitionDuration);
        };
        _proto._destroyElement = function _destroyElement(element) {
            $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
        } // Static
        ;
        Alert._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$a);
                if (!data) {
                    data = new Alert(this);
                    $element.data(DATA_KEY$a, data);
                }
                if (config === "close") data[config](this);
            });
        };
        Alert._handleDismiss = function _handleDismiss(alertInstance) {
            return function(event) {
                if (event) event.preventDefault();
                alertInstance.close(this);
            };
        };
        _createClass(Alert, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$a;
                }
            }
        ]);
        return Alert;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
    /**
   * jQuery
   */ $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
    $__default["default"].fn[NAME$a].Constructor = Alert;
    $__default["default"].fn[NAME$a].noConflict = function() {
        $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
        return Alert._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$9 = "button";
    var VERSION$9 = "4.6.2";
    var DATA_KEY$9 = "bs.button";
    var EVENT_KEY$9 = "." + DATA_KEY$9;
    var DATA_API_KEY$6 = ".data-api";
    var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
    var CLASS_NAME_ACTIVE$3 = "active";
    var CLASS_NAME_BUTTON = "btn";
    var CLASS_NAME_FOCUS = "focus";
    var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
    var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
    var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
    var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
    var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
    var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
    var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
    var SELECTOR_INPUT = 'input:not([type="hidden"])';
    var SELECTOR_ACTIVE$2 = ".active";
    var SELECTOR_BUTTON = ".btn";
    /**
   * Class definition
   */ var Button = /*#__PURE__*/ function() {
        function Button(element) {
            this._element = element;
            this.shouldAvoidTriggerChange = false;
        } // Getters
        var _proto = Button.prototype;
        // Public
        _proto.toggle = function toggle() {
            var triggerChangeEvent = true;
            var addAriaPressed = true;
            var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
            if (rootElement) {
                var input = this._element.querySelector(SELECTOR_INPUT);
                if (input) {
                    if (input.type === "radio") {
                        if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) triggerChangeEvent = false;
                        else {
                            var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);
                            if (activeElement) $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
                        }
                    }
                    if (triggerChangeEvent) {
                        // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
                        if (input.type === "checkbox" || input.type === "radio") input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
                        if (!this.shouldAvoidTriggerChange) $__default["default"](input).trigger("change");
                    }
                    input.focus();
                    addAriaPressed = false;
                }
            }
            if (!(this._element.hasAttribute("disabled") || this._element.classList.contains("disabled"))) {
                if (addAriaPressed) this._element.setAttribute("aria-pressed", !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
                if (triggerChangeEvent) $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
            }
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$9);
            this._element = null;
        } // Static
        ;
        Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$9);
                if (!data) {
                    data = new Button(this);
                    $element.data(DATA_KEY$9, data);
                }
                data.shouldAvoidTriggerChange = avoidTriggerChange;
                if (config === "toggle") data[config]();
            });
        };
        _createClass(Button, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$9;
                }
            }
        ]);
        return Button;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = event.target;
        var initialButton = button;
        if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
        if (!button || button.hasAttribute("disabled") || button.classList.contains("disabled")) event.preventDefault(); // work around Firefox bug #1540995
        else {
            var inputBtn = button.querySelector(SELECTOR_INPUT);
            if (inputBtn && (inputBtn.hasAttribute("disabled") || inputBtn.classList.contains("disabled"))) {
                event.preventDefault(); // work around Firefox bug #1540995
                return;
            }
            if (initialButton.tagName === "INPUT" || button.tagName !== "LABEL") Button._jQueryInterface.call($__default["default"](button), "toggle", initialButton.tagName === "INPUT");
        }
    }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
        $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
    });
    $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function() {
        // ensure correct active class is set to match the controls' actual values/states
        // find all checkboxes/readio buttons inside data-toggle groups
        var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
        for(var i = 0, len = buttons.length; i < len; i++){
            var button = buttons[i];
            var input = button.querySelector(SELECTOR_INPUT);
            if (input.checked || input.hasAttribute("checked")) button.classList.add(CLASS_NAME_ACTIVE$3);
            else button.classList.remove(CLASS_NAME_ACTIVE$3);
        } // find all button toggles
        buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));
        for(var _i = 0, _len = buttons.length; _i < _len; _i++){
            var _button = buttons[_i];
            if (_button.getAttribute("aria-pressed") === "true") _button.classList.add(CLASS_NAME_ACTIVE$3);
            else _button.classList.remove(CLASS_NAME_ACTIVE$3);
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$9] = Button._jQueryInterface;
    $__default["default"].fn[NAME$9].Constructor = Button;
    $__default["default"].fn[NAME$9].noConflict = function() {
        $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
        return Button._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$8 = "carousel";
    var VERSION$8 = "4.6.2";
    var DATA_KEY$8 = "bs.carousel";
    var EVENT_KEY$8 = "." + DATA_KEY$8;
    var DATA_API_KEY$5 = ".data-api";
    var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    var SWIPE_THRESHOLD = 40;
    var CLASS_NAME_CAROUSEL = "carousel";
    var CLASS_NAME_ACTIVE$2 = "active";
    var CLASS_NAME_SLIDE = "slide";
    var CLASS_NAME_RIGHT = "carousel-item-right";
    var CLASS_NAME_LEFT = "carousel-item-left";
    var CLASS_NAME_NEXT = "carousel-item-next";
    var CLASS_NAME_PREV = "carousel-item-prev";
    var CLASS_NAME_POINTER_EVENT = "pointer-event";
    var DIRECTION_NEXT = "next";
    var DIRECTION_PREV = "prev";
    var DIRECTION_LEFT = "left";
    var DIRECTION_RIGHT = "right";
    var EVENT_SLIDE = "slide" + EVENT_KEY$8;
    var EVENT_SLID = "slid" + EVENT_KEY$8;
    var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
    var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
    var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
    var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
    var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
    var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
    var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
    var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
    var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
    var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
    var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
    var SELECTOR_ACTIVE$1 = ".active";
    var SELECTOR_ACTIVE_ITEM = ".active.carousel-item";
    var SELECTOR_ITEM = ".carousel-item";
    var SELECTOR_ITEM_IMG = ".carousel-item img";
    var SELECTOR_NEXT_PREV = ".carousel-item-next, .carousel-item-prev";
    var SELECTOR_INDICATORS = ".carousel-indicators";
    var SELECTOR_DATA_SLIDE = "[data-slide], [data-slide-to]";
    var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
    var Default$7 = {
        interval: 5000,
        keyboard: true,
        slide: false,
        pause: "hover",
        wrap: true,
        touch: true
    };
    var DefaultType$7 = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    };
    var PointerType = {
        TOUCH: "touch",
        PEN: "pen"
    };
    /**
   * Class definition
   */ var Carousel = /*#__PURE__*/ function() {
        function Carousel(element, config) {
            this._items = null;
            this._interval = null;
            this._activeElement = null;
            this._isPaused = false;
            this._isSliding = false;
            this.touchTimeout = null;
            this.touchStartX = 0;
            this.touchDeltaX = 0;
            this._config = this._getConfig(config);
            this._element = element;
            this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
            this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
            this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
            this._addEventListeners();
        } // Getters
        var _proto = Carousel.prototype;
        // Public
        _proto.next = function next() {
            if (!this._isSliding) this._slide(DIRECTION_NEXT);
        };
        _proto.nextWhenVisible = function nextWhenVisible() {
            var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && $element.is(":visible") && $element.css("visibility") !== "hidden") this.next();
        };
        _proto.prev = function prev() {
            if (!this._isSliding) this._slide(DIRECTION_PREV);
        };
        _proto.pause = function pause(event) {
            if (!event) this._isPaused = true;
            if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
                Util.triggerTransitionEnd(this._element);
                this.cycle(true);
            }
            clearInterval(this._interval);
            this._interval = null;
        };
        _proto.cycle = function cycle(event) {
            if (!event) this._isPaused = false;
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
            if (this._config.interval && !this._isPaused) {
                this._updateInterval();
                this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
            }
        };
        _proto.to = function to(index) {
            var _this = this;
            this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeIndex = this._getItemIndex(this._activeElement);
            if (index > this._items.length - 1 || index < 0) return;
            if (this._isSliding) {
                $__default["default"](this._element).one(EVENT_SLID, function() {
                    return _this.to(index);
                });
                return;
            }
            if (activeIndex === index) {
                this.pause();
                this.cycle();
                return;
            }
            var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
            this._slide(direction, this._items[index]);
        };
        _proto.dispose = function dispose() {
            $__default["default"](this._element).off(EVENT_KEY$8);
            $__default["default"].removeData(this._element, DATA_KEY$8);
            this._items = null;
            this._config = null;
            this._element = null;
            this._interval = null;
            this._isPaused = null;
            this._isSliding = null;
            this._activeElement = null;
            this._indicatorsElement = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$7, config);
            Util.typeCheckConfig(NAME$8, config, DefaultType$7);
            return config;
        };
        _proto._handleSwipe = function _handleSwipe() {
            var absDeltax = Math.abs(this.touchDeltaX);
            if (absDeltax <= SWIPE_THRESHOLD) return;
            var direction = absDeltax / this.touchDeltaX;
            this.touchDeltaX = 0; // swipe left
            if (direction > 0) this.prev();
             // swipe right
            if (direction < 0) this.next();
        };
        _proto._addEventListeners = function _addEventListeners() {
            var _this2 = this;
            if (this._config.keyboard) $__default["default"](this._element).on(EVENT_KEYDOWN, function(event) {
                return _this2._keydown(event);
            });
            if (this._config.pause === "hover") $__default["default"](this._element).on(EVENT_MOUSEENTER, function(event) {
                return _this2.pause(event);
            }).on(EVENT_MOUSELEAVE, function(event) {
                return _this2.cycle(event);
            });
            if (this._config.touch) this._addTouchEventListeners();
        };
        _proto._addTouchEventListeners = function _addTouchEventListeners() {
            var _this3 = this;
            if (!this._touchSupported) return;
            var start = function start(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchStartX = event.originalEvent.clientX;
                else if (!_this3._pointerEvent) _this3.touchStartX = event.originalEvent.touches[0].clientX;
            };
            var move = function move(event) {
                // ensure swiping with one touch and not pinching
                _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
            };
            var end = function end(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
                _this3._handleSwipe();
                if (_this3._config.pause === "hover") {
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this3.pause();
                    if (_this3.touchTimeout) clearTimeout(_this3.touchTimeout);
                    _this3.touchTimeout = setTimeout(function(event) {
                        return _this3.cycle(event);
                    }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
                }
            };
            $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function(e) {
                return e.preventDefault();
            });
            if (this._pointerEvent) {
                $__default["default"](this._element).on(EVENT_POINTERDOWN, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_POINTERUP, function(event) {
                    return end(event);
                });
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                $__default["default"](this._element).on(EVENT_TOUCHSTART, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHMOVE, function(event) {
                    return move(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHEND, function(event) {
                    return end(event);
                });
            }
        };
        _proto._keydown = function _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            switch(event.which){
                case ARROW_LEFT_KEYCODE:
                    event.preventDefault();
                    this.prev();
                    break;
                case ARROW_RIGHT_KEYCODE:
                    event.preventDefault();
                    this.next();
                    break;
            }
        };
        _proto._getItemIndex = function _getItemIndex(element) {
            this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
            return this._items.indexOf(element);
        };
        _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
            var isNextDirection = direction === DIRECTION_NEXT;
            var isPrevDirection = direction === DIRECTION_PREV;
            var activeIndex = this._getItemIndex(activeElement);
            var lastItemIndex = this._items.length - 1;
            var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
            if (isGoingToWrap && !this._config.wrap) return activeElement;
            var delta = direction === DIRECTION_PREV ? -1 : 1;
            var itemIndex = (activeIndex + delta) % this._items.length;
            return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
        };
        _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
            var targetIndex = this._getItemIndex(relatedTarget);
            var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
            var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
                relatedTarget: relatedTarget,
                direction: eventDirectionName,
                from: fromIndex,
                to: targetIndex
            });
            $__default["default"](this._element).trigger(slideEvent);
            return slideEvent;
        };
        _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
            if (this._indicatorsElement) {
                var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
                $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);
                var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                if (nextIndicator) $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
            }
        };
        _proto._updateInterval = function _updateInterval() {
            var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            if (!element) return;
            var elementInterval = parseInt(element.getAttribute("data-interval"), 10);
            if (elementInterval) {
                this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
                this._config.interval = elementInterval;
            } else this._config.interval = this._config.defaultInterval || this._config.interval;
        };
        _proto._slide = function _slide(direction, element) {
            var _this4 = this;
            var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeElementIndex = this._getItemIndex(activeElement);
            var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
            var nextElementIndex = this._getItemIndex(nextElement);
            var isCycling = Boolean(this._interval);
            var directionalClassName;
            var orderClassName;
            var eventDirectionName;
            if (direction === DIRECTION_NEXT) {
                directionalClassName = CLASS_NAME_LEFT;
                orderClassName = CLASS_NAME_NEXT;
                eventDirectionName = DIRECTION_LEFT;
            } else {
                directionalClassName = CLASS_NAME_RIGHT;
                orderClassName = CLASS_NAME_PREV;
                eventDirectionName = DIRECTION_RIGHT;
            }
            if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
                this._isSliding = false;
                return;
            }
            var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
            if (slideEvent.isDefaultPrevented()) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            return;
            this._isSliding = true;
            if (isCycling) this.pause();
            this._setActiveIndicatorElement(nextElement);
            this._activeElement = nextElement;
            var slidEvent = $__default["default"].Event(EVENT_SLID, {
                relatedTarget: nextElement,
                direction: eventDirectionName,
                from: activeElementIndex,
                to: nextElementIndex
            });
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
                $__default["default"](nextElement).addClass(orderClassName);
                Util.reflow(nextElement);
                $__default["default"](activeElement).addClass(directionalClassName);
                $__default["default"](nextElement).addClass(directionalClassName);
                var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
                $__default["default"](activeElement).one(Util.TRANSITION_END, function() {
                    $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
                    $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
                    _this4._isSliding = false;
                    setTimeout(function() {
                        return $__default["default"](_this4._element).trigger(slidEvent);
                    }, 0);
                }).emulateTransitionEnd(transitionDuration);
            } else {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
                $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
                this._isSliding = false;
                $__default["default"](this._element).trigger(slidEvent);
            }
            if (isCycling) this.cycle();
        } // Static
        ;
        Carousel._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$8);
                var _config = _extends({}, Default$7, $__default["default"](this).data());
                if (typeof config === "object") _config = _extends({}, _config, config);
                var action = typeof config === "string" ? config : _config.slide;
                if (!data) {
                    data = new Carousel(this, _config);
                    $__default["default"](this).data(DATA_KEY$8, data);
                }
                if (typeof config === "number") data.to(config);
                else if (typeof action === "string") {
                    if (typeof data[action] === "undefined") throw new TypeError('No method named "' + action + '"');
                    data[action]();
                } else if (_config.interval && _config.ride) {
                    data.pause();
                    data.cycle();
                }
            });
        };
        Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
            var selector = Util.getSelectorFromElement(this);
            if (!selector) return;
            var target = $__default["default"](selector)[0];
            if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) return;
            var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
            var slideIndex = this.getAttribute("data-slide-to");
            if (slideIndex) config.interval = false;
            Carousel._jQueryInterface.call($__default["default"](target), config);
            if (slideIndex) $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
            event.preventDefault();
        };
        _createClass(Carousel, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$8;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$7;
                }
            }
        ]);
        return Carousel;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
    $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function() {
        var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
        for(var i = 0, len = carousels.length; i < len; i++){
            var $carousel = $__default["default"](carousels[i]);
            Carousel._jQueryInterface.call($carousel, $carousel.data());
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
    $__default["default"].fn[NAME$8].Constructor = Carousel;
    $__default["default"].fn[NAME$8].noConflict = function() {
        $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
        return Carousel._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$7 = "collapse";
    var VERSION$7 = "4.6.2";
    var DATA_KEY$7 = "bs.collapse";
    var EVENT_KEY$7 = "." + DATA_KEY$7;
    var DATA_API_KEY$4 = ".data-api";
    var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
    var CLASS_NAME_SHOW$6 = "show";
    var CLASS_NAME_COLLAPSE = "collapse";
    var CLASS_NAME_COLLAPSING = "collapsing";
    var CLASS_NAME_COLLAPSED = "collapsed";
    var DIMENSION_WIDTH = "width";
    var DIMENSION_HEIGHT = "height";
    var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
    var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
    var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
    var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
    var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
    var SELECTOR_ACTIVES = ".show, .collapsing";
    var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
    var Default$6 = {
        toggle: true,
        parent: ""
    };
    var DefaultType$6 = {
        toggle: "boolean",
        parent: "(string|element)"
    };
    /**
   * Class definition
   */ var Collapse = /*#__PURE__*/ function() {
        function Collapse(element, config) {
            this._isTransitioning = false;
            this._element = element;
            this._config = this._getConfig(config);
            this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
            var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));
            for(var i = 0, len = toggleList.length; i < len; i++){
                var elem = toggleList[i];
                var selector = Util.getSelectorFromElement(elem);
                var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function(foundElem) {
                    return foundElem === element;
                });
                if (selector !== null && filterElement.length > 0) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._parent = this._config.parent ? this._getParent() : null;
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._element, this._triggerArray);
            if (this._config.toggle) this.toggle();
        } // Getters
        var _proto = Collapse.prototype;
        // Public
        _proto.toggle = function toggle() {
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) this.hide();
            else this.show();
        };
        _proto.show = function show() {
            var _this = this;
            if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) return;
            var actives;
            var activesData;
            if (this._parent) {
                actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function(elem) {
                    if (typeof _this._config.parent === "string") return elem.getAttribute("data-parent") === _this._config.parent;
                    return elem.classList.contains(CLASS_NAME_COLLAPSE);
                });
                if (actives.length === 0) actives = null;
            }
            if (actives) {
                activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);
                if (activesData && activesData._isTransitioning) return;
            }
            var startEvent = $__default["default"].Event(EVENT_SHOW$4);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            if (actives) {
                Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), "hide");
                if (!activesData) $__default["default"](actives).data(DATA_KEY$7, null);
            }
            var dimension = this._getDimension();
            $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            if (this._triggerArray.length) $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", true);
            this.setTransitioning(true);
            var complete = function complete() {
                $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
                _this._element.style[dimension] = "";
                _this.setTransitioning(false);
                $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
            };
            var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            var scrollSize = "scroll" + capitalizedDimension;
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            this._element.style[dimension] = this._element[scrollSize] + "px";
        };
        _proto.hide = function hide() {
            var _this2 = this;
            if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) return;
            var startEvent = $__default["default"].Event(EVENT_HIDE$4);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            var dimension = this._getDimension();
            this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
            Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
            var triggerArrayLength = this._triggerArray.length;
            if (triggerArrayLength > 0) for(var i = 0; i < triggerArrayLength; i++){
                var trigger = this._triggerArray[i];
                var selector = Util.getSelectorFromElement(trigger);
                if (selector !== null) {
                    var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));
                    if (!$elem.hasClass(CLASS_NAME_SHOW$6)) $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", false);
                }
            }
            this.setTransitioning(true);
            var complete = function complete() {
                _this2.setTransitioning(false);
                $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
            };
            this._element.style[dimension] = "";
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        };
        _proto.setTransitioning = function setTransitioning(isTransitioning) {
            this._isTransitioning = isTransitioning;
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$7);
            this._config = null;
            this._parent = null;
            this._element = null;
            this._triggerArray = null;
            this._isTransitioning = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$6, config);
            config.toggle = Boolean(config.toggle); // Coerce string values
            Util.typeCheckConfig(NAME$7, config, DefaultType$6);
            return config;
        };
        _proto._getDimension = function _getDimension() {
            var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
            return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
        };
        _proto._getParent = function _getParent() {
            var _this3 = this;
            var parent;
            if (Util.isElement(this._config.parent)) {
                parent = this._config.parent; // It's a jQuery object
                if (typeof this._config.parent.jquery !== "undefined") parent = this._config.parent[0];
            } else parent = document.querySelector(this._config.parent);
            var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
            var children = [].slice.call(parent.querySelectorAll(selector));
            $__default["default"](children).each(function(i, element) {
                _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                    element
                ]);
            });
            return parent;
        };
        _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
            var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);
            if (triggerArray.length) $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr("aria-expanded", isOpen);
        } // Static
        ;
        Collapse._getTargetFromElement = function _getTargetFromElement(element) {
            var selector = Util.getSelectorFromElement(element);
            return selector ? document.querySelector(selector) : null;
        };
        Collapse._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$7);
                var _config = _extends({}, Default$6, $element.data(), typeof config === "object" && config ? config : {});
                if (!data && _config.toggle && typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                if (!data) {
                    data = new Collapse(this, _config);
                    $element.data(DATA_KEY$7, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Collapse, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$6;
                }
            }
        ]);
        return Collapse;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.currentTarget.tagName === "A") event.preventDefault();
        var $trigger = $__default["default"](this);
        var selector = Util.getSelectorFromElement(this);
        var selectors = [].slice.call(document.querySelectorAll(selector));
        $__default["default"](selectors).each(function() {
            var $target = $__default["default"](this);
            var data = $target.data(DATA_KEY$7);
            var config = data ? "toggle" : $trigger.data();
            Collapse._jQueryInterface.call($target, config);
        });
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
    $__default["default"].fn[NAME$7].Constructor = Collapse;
    $__default["default"].fn[NAME$7].noConflict = function() {
        $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
        return Collapse._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$6 = "dropdown";
    var VERSION$6 = "4.6.2";
    var DATA_KEY$6 = "bs.dropdown";
    var EVENT_KEY$6 = "." + DATA_KEY$6;
    var DATA_API_KEY$3 = ".data-api";
    var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
    var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
    var CLASS_NAME_DISABLED$1 = "disabled";
    var CLASS_NAME_SHOW$5 = "show";
    var CLASS_NAME_DROPUP = "dropup";
    var CLASS_NAME_DROPRIGHT = "dropright";
    var CLASS_NAME_DROPLEFT = "dropleft";
    var CLASS_NAME_MENURIGHT = "dropdown-menu-right";
    var CLASS_NAME_POSITION_STATIC = "position-static";
    var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
    var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
    var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
    var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
    var EVENT_CLICK = "click" + EVENT_KEY$6;
    var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
    var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
    var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
    var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
    var SELECTOR_FORM_CHILD = ".dropdown form";
    var SELECTOR_MENU = ".dropdown-menu";
    var SELECTOR_NAVBAR_NAV = ".navbar-nav";
    var SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    var PLACEMENT_TOP = "top-start";
    var PLACEMENT_TOPEND = "top-end";
    var PLACEMENT_BOTTOM = "bottom-start";
    var PLACEMENT_BOTTOMEND = "bottom-end";
    var PLACEMENT_RIGHT = "right-start";
    var PLACEMENT_LEFT = "left-start";
    var Default$5 = {
        offset: 0,
        flip: true,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    };
    var DefaultType$5 = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    };
    /**
   * Class definition
   */ var Dropdown = /*#__PURE__*/ function() {
        function Dropdown(element, config) {
            this._element = element;
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
            this._addEventListeners();
        } // Getters
        var _proto = Dropdown.prototype;
        // Public
        _proto.toggle = function toggle() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) return;
            var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);
            Dropdown._clearMenus();
            if (isActive) return;
            this.show(true);
        };
        _proto.show = function show(usePopper) {
            if (usePopper === void 0) usePopper = false;
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
             // Totally disable Popper for Dropdowns in Navbar
            if (!this._inNavbar && usePopper) {
                // Check for Popper dependency
                if (typeof Popper__default["default"] === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                var referenceElement = this._element;
                if (this._config.reference === "parent") referenceElement = parent;
                else if (Util.isElement(this._config.reference)) {
                    referenceElement = this._config.reference; // Check if it's jQuery element
                    if (typeof this._config.reference.jquery !== "undefined") referenceElement = this._config.reference[0];
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251
                if (this._config.boundary !== "scrollParent") $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
                this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
            } // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
        };
        _proto.hide = function hide() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            if (this._popper) this._popper.destroy();
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$6);
            $__default["default"](this._element).off(EVENT_KEY$6);
            this._element = null;
            this._menu = null;
            if (this._popper !== null) {
                this._popper.destroy();
                this._popper = null;
            }
        };
        _proto.update = function update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Private
        ;
        _proto._addEventListeners = function _addEventListeners() {
            var _this = this;
            $__default["default"](this._element).on(EVENT_CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        };
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
            Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
            return config;
        };
        _proto._getMenuElement = function _getMenuElement() {
            if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);
                if (parent) this._menu = parent.querySelector(SELECTOR_MENU);
            }
            return this._menu;
        };
        _proto._getPlacement = function _getPlacement() {
            var $parentDropdown = $__default["default"](this._element.parentNode);
            var placement = PLACEMENT_BOTTOM; // Handle dropup
            if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) placement = PLACEMENT_RIGHT;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) placement = PLACEMENT_LEFT;
            else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) placement = PLACEMENT_BOTTOMEND;
            return placement;
        };
        _proto._detectNavbar = function _detectNavbar() {
            return $__default["default"](this._element).closest(".navbar").length > 0;
        };
        _proto._getOffset = function _getOffset() {
            var _this2 = this;
            var offset = {};
            if (typeof this._config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
                return data;
            };
            else offset.offset = this._config.offset;
            return offset;
        };
        _proto._getPopperConfig = function _getPopperConfig() {
            var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") popperConfig.modifiers.applyStyle = {
                enabled: false
            };
            return _extends({}, popperConfig, this._config.popperConfig);
        } // Static
        ;
        Dropdown._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$6);
                var _config = typeof config === "object" ? config : null;
                if (!data) {
                    data = new Dropdown(this, _config);
                    $__default["default"](this).data(DATA_KEY$6, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        Dropdown._clearMenus = function _clearMenus(event) {
            if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === "keyup" && event.which !== TAB_KEYCODE)) return;
            var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
            for(var i = 0, len = toggles.length; i < len; i++){
                var parent = Dropdown._getParentFromElement(toggles[i]);
                var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
                var relatedTarget = {
                    relatedTarget: toggles[i]
                };
                if (event && event.type === "click") relatedTarget.clickEvent = event;
                if (!context) continue;
                var dropdownMenu = context._menu;
                if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) continue;
                if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "keyup" && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) continue;
                var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
                $__default["default"](parent).trigger(hideEvent);
                if (hideEvent.isDefaultPrevented()) continue;
                 // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
                toggles[i].setAttribute("aria-expanded", "false");
                if (context._popper) context._popper.destroy();
                $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
                $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
            }
        };
        Dropdown._getParentFromElement = function _getParentFromElement(element) {
            var parent;
            var selector = Util.getSelectorFromElement(element);
            if (selector) parent = document.querySelector(selector);
            return parent || element.parentNode;
        } // eslint-disable-next-line complexity
        ;
        Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) return;
            if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) return;
            var parent = Dropdown._getParentFromElement(this);
            var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);
            if (!isActive && event.which === ESCAPE_KEYCODE$1) return;
            event.preventDefault();
            event.stopPropagation();
            if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
                if (event.which === ESCAPE_KEYCODE$1) $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger("focus");
                $__default["default"](this).trigger("click");
                return;
            }
            var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function(item) {
                return $__default["default"](item).is(":visible");
            });
            if (items.length === 0) return;
            var index = items.indexOf(event.target);
            if (event.which === ARROW_UP_KEYCODE && index > 0) // Up
            index--;
            if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) // Down
            index++;
            if (index < 0) index = 0;
            items[index].focus();
        };
        _createClass(Dropdown, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$6;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$5;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$5;
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        event.preventDefault();
        event.stopPropagation();
        Dropdown._jQueryInterface.call($__default["default"](this), "toggle");
    }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
    $__default["default"].fn[NAME$6].Constructor = Dropdown;
    $__default["default"].fn[NAME$6].noConflict = function() {
        $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
        return Dropdown._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$5 = "modal";
    var VERSION$5 = "4.6.2";
    var DATA_KEY$5 = "bs.modal";
    var EVENT_KEY$5 = "." + DATA_KEY$5;
    var DATA_API_KEY$2 = ".data-api";
    var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
    var CLASS_NAME_SCROLLABLE = "modal-dialog-scrollable";
    var CLASS_NAME_SCROLLBAR_MEASURER = "modal-scrollbar-measure";
    var CLASS_NAME_BACKDROP = "modal-backdrop";
    var CLASS_NAME_OPEN = "modal-open";
    var CLASS_NAME_FADE$4 = "fade";
    var CLASS_NAME_SHOW$4 = "show";
    var CLASS_NAME_STATIC = "modal-static";
    var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
    var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
    var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
    var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
    var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
    var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
    var EVENT_RESIZE = "resize" + EVENT_KEY$5;
    var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
    var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
    var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
    var SELECTOR_DIALOG = ".modal-dialog";
    var SELECTOR_MODAL_BODY = ".modal-body";
    var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
    var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
    var SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
    var SELECTOR_STICKY_CONTENT = ".sticky-top";
    var Default$4 = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
    };
    var DefaultType$4 = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    };
    /**
   * Class definition
   */ var Modal = /*#__PURE__*/ function() {
        function Modal(element, config) {
            this._config = this._getConfig(config);
            this._element = element;
            this._dialog = element.querySelector(SELECTOR_DIALOG);
            this._backdrop = null;
            this._isShown = false;
            this._isBodyOverflowing = false;
            this._ignoreBackdropClick = false;
            this._isTransitioning = false;
            this._scrollbarWidth = 0;
        } // Getters
        var _proto = Modal.prototype;
        // Public
        _proto.toggle = function toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        };
        _proto.show = function show(relatedTarget) {
            var _this = this;
            if (this._isShown || this._isTransitioning) return;
            var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
                relatedTarget: relatedTarget
            });
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._isShown = true;
            if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) this._isTransitioning = true;
            this._checkScrollbar();
            this._setScrollbar();
            this._adjustDialog();
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function(event) {
                return _this.hide(event);
            });
            $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function() {
                $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function(event) {
                    if ($__default["default"](event.target).is(_this._element)) _this._ignoreBackdropClick = true;
                });
            });
            this._showBackdrop(function() {
                return _this._showElement(relatedTarget);
            });
        };
        _proto.hide = function hide(event) {
            var _this2 = this;
            if (event) event.preventDefault();
            if (!this._isShown || this._isTransitioning) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
            $__default["default"](this._element).trigger(hideEvent);
            if (!this._isShown || hideEvent.isDefaultPrevented()) return;
            this._isShown = false;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
            if (transition) this._isTransitioning = true;
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
            $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, function(event) {
                    return _this2._hideModal(event);
                }).emulateTransitionEnd(transitionDuration);
            } else this._hideModal();
        };
        _proto.dispose = function dispose() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(htmlElement) {
                return $__default["default"](htmlElement).off(EVENT_KEY$5);
            });
            /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */ $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"].removeData(this._element, DATA_KEY$5);
            this._config = null;
            this._element = null;
            this._dialog = null;
            this._backdrop = null;
            this._isShown = null;
            this._isBodyOverflowing = null;
            this._ignoreBackdropClick = null;
            this._isTransitioning = null;
            this._scrollbarWidth = null;
        };
        _proto.handleUpdate = function handleUpdate() {
            this._adjustDialog();
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$4, config);
            Util.typeCheckConfig(NAME$5, config, DefaultType$4);
            return config;
        };
        _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
            var _this3 = this;
            var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
            $__default["default"](this._element).trigger(hideEventPrevented);
            if (hideEventPrevented.isDefaultPrevented()) return;
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!isModalOverflowing) this._element.style.overflowY = "hidden";
            this._element.classList.add(CLASS_NAME_STATIC);
            var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
            $__default["default"](this._element).off(Util.TRANSITION_END);
            $__default["default"](this._element).one(Util.TRANSITION_END, function() {
                _this3._element.classList.remove(CLASS_NAME_STATIC);
                if (!isModalOverflowing) $__default["default"](_this3._element).one(Util.TRANSITION_END, function() {
                    _this3._element.style.overflowY = "";
                }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
            }).emulateTransitionEnd(modalTransitionDuration);
            this._element.focus();
        };
        _proto._showElement = function _showElement(relatedTarget) {
            var _this4 = this;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
            var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
            if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) // Don't move modal's DOM position
            document.body.appendChild(this._element);
            this._element.style.display = "block";
            this._element.removeAttribute("aria-hidden");
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) modalBody.scrollTop = 0;
            else this._element.scrollTop = 0;
            if (transition) Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);
            if (this._config.focus) this._enforceFocus();
            var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
                relatedTarget: relatedTarget
            });
            var transitionComplete = function transitionComplete() {
                if (_this4._config.focus) _this4._element.focus();
                _this4._isTransitioning = false;
                $__default["default"](_this4._element).trigger(shownEvent);
            };
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
                $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
            } else transitionComplete();
        };
        _proto._enforceFocus = function _enforceFocus() {
            var _this5 = this;
            $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
            .on(EVENT_FOCUSIN, function(event) {
                if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) _this5._element.focus();
            });
        };
        _proto._setEscapeEvent = function _setEscapeEvent() {
            var _this6 = this;
            if (this._isShown) $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function(event) {
                if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
                    event.preventDefault();
                    _this6.hide();
                } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) _this6._triggerBackdropTransition();
            });
            else if (!this._isShown) $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
        };
        _proto._setResizeEvent = function _setResizeEvent() {
            var _this7 = this;
            if (this._isShown) $__default["default"](window).on(EVENT_RESIZE, function(event) {
                return _this7.handleUpdate(event);
            });
            else $__default["default"](window).off(EVENT_RESIZE);
        };
        _proto._hideModal = function _hideModal() {
            var _this8 = this;
            this._element.style.display = "none";
            this._element.setAttribute("aria-hidden", true);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            this._isTransitioning = false;
            this._showBackdrop(function() {
                $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);
                _this8._resetAdjustments();
                _this8._resetScrollbar();
                $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
            });
        };
        _proto._removeBackdrop = function _removeBackdrop() {
            if (this._backdrop) {
                $__default["default"](this._backdrop).remove();
                this._backdrop = null;
            }
        };
        _proto._showBackdrop = function _showBackdrop(callback) {
            var _this9 = this;
            var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : "";
            if (this._isShown && this._config.backdrop) {
                this._backdrop = document.createElement("div");
                this._backdrop.className = CLASS_NAME_BACKDROP;
                if (animate) this._backdrop.classList.add(animate);
                $__default["default"](this._backdrop).appendTo(document.body);
                $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function(event) {
                    if (_this9._ignoreBackdropClick) {
                        _this9._ignoreBackdropClick = false;
                        return;
                    }
                    if (event.target !== event.currentTarget) return;
                    if (_this9._config.backdrop === "static") _this9._triggerBackdropTransition();
                    else _this9.hide();
                });
                if (animate) Util.reflow(this._backdrop);
                $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);
                if (!callback) return;
                if (!animate) {
                    callback();
                    return;
                }
                var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
            } else if (!this._isShown && this._backdrop) {
                $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);
                var callbackRemove = function callbackRemove() {
                    _this9._removeBackdrop();
                    if (callback) callback();
                };
                if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
                    var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                    $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
                } else callbackRemove();
            } else if (callback) callback();
        } // ----------------------------------------------------------------------
        ;
        _proto._adjustDialog = function _adjustDialog() {
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!this._isBodyOverflowing && isModalOverflowing) this._element.style.paddingLeft = this._scrollbarWidth + "px";
            if (this._isBodyOverflowing && !isModalOverflowing) this._element.style.paddingRight = this._scrollbarWidth + "px";
        };
        _proto._resetAdjustments = function _resetAdjustments() {
            this._element.style.paddingLeft = "";
            this._element.style.paddingRight = "";
        };
        _proto._checkScrollbar = function _checkScrollbar() {
            var rect = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
            this._scrollbarWidth = this._getScrollbarWidth();
        };
        _proto._setScrollbar = function _setScrollbar() {
            var _this10 = this;
            if (this._isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
                var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
                $__default["default"](fixedContent).each(function(index, element) {
                    var actualPadding = element.style.paddingRight;
                    var calculatedPadding = $__default["default"](element).css("padding-right");
                    $__default["default"](element).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
                }); // Adjust sticky content margin
                $__default["default"](stickyContent).each(function(index, element) {
                    var actualMargin = element.style.marginRight;
                    var calculatedMargin = $__default["default"](element).css("margin-right");
                    $__default["default"](element).data("margin-right", actualMargin).css("margin-right", parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
                }); // Adjust body padding
                var actualPadding = document.body.style.paddingRight;
                var calculatedPadding = $__default["default"](document.body).css("padding-right");
                $__default["default"](document.body).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
            }
            $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
        };
        _proto._resetScrollbar = function _resetScrollbar() {
            // Restore fixed content padding
            var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
            $__default["default"](fixedContent).each(function(index, element) {
                var padding = $__default["default"](element).data("padding-right");
                $__default["default"](element).removeData("padding-right");
                element.style.paddingRight = padding ? padding : "";
            }); // Restore sticky content
            var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
            $__default["default"](elements).each(function(index, element) {
                var margin = $__default["default"](element).data("margin-right");
                if (typeof margin !== "undefined") $__default["default"](element).css("margin-right", margin).removeData("margin-right");
            }); // Restore body padding
            var padding = $__default["default"](document.body).data("padding-right");
            $__default["default"](document.body).removeData("padding-right");
            document.body.style.paddingRight = padding ? padding : "";
        };
        _proto._getScrollbarWidth = function _getScrollbarWidth() {
            // thx d.walsh
            var scrollDiv = document.createElement("div");
            scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
            document.body.appendChild(scrollDiv);
            var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        } // Static
        ;
        Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$5);
                var _config = _extends({}, Default$4, $__default["default"](this).data(), typeof config === "object" && config ? config : {});
                if (!data) {
                    data = new Modal(this, _config);
                    $__default["default"](this).data(DATA_KEY$5, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](relatedTarget);
                } else if (_config.show) data.show(relatedTarget);
            });
        };
        _createClass(Modal, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$5;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$4;
                }
            }
        ]);
        return Modal;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        var _this11 = this;
        var target;
        var selector = Util.getSelectorFromElement(this);
        if (selector) target = document.querySelector(selector);
        var config = $__default["default"](target).data(DATA_KEY$5) ? "toggle" : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
        if (this.tagName === "A" || this.tagName === "AREA") event.preventDefault();
        var $target = $__default["default"](target).one(EVENT_SHOW$2, function(showEvent) {
            if (showEvent.isDefaultPrevented()) // Only register focus restorer if modal will actually get shown
            return;
            $target.one(EVENT_HIDDEN$2, function() {
                if ($__default["default"](_this11).is(":visible")) _this11.focus();
            });
        });
        Modal._jQueryInterface.call($__default["default"](target), config, this);
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
    $__default["default"].fn[NAME$5].Constructor = Modal;
    $__default["default"].fn[NAME$5].noConflict = function() {
        $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
        return Modal._jQueryInterface;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var uriAttrs = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ];
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultWhitelist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
    /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function allowedAttribute(attr, allowedAttributeList) {
        var attrName = attr.nodeName.toLowerCase();
        if (allowedAttributeList.indexOf(attrName) !== -1) {
            if (uriAttrs.indexOf(attrName) !== -1) return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
            return true;
        }
        var regExp = allowedAttributeList.filter(function(attrRegex) {
            return attrRegex instanceof RegExp;
        }); // Check if a regular expression validates the attribute.
        for(var i = 0, len = regExp.length; i < len; i++){
            if (regExp[i].test(attrName)) return true;
        }
        return false;
    }
    function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
        if (unsafeHtml.length === 0) return unsafeHtml;
        if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeHtml);
        var domParser = new window.DOMParser();
        var createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        var whitelistKeys = Object.keys(whiteList);
        var elements = [].slice.call(createdDocument.body.querySelectorAll("*"));
        var _loop = function _loop(i, len) {
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
                el.parentNode.removeChild(el);
                return "continue";
            }
            var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread
            var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
            attributeList.forEach(function(attr) {
                if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
            });
        };
        for(var i = 0, len = elements.length; i < len; i++){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * Constants
   */ var NAME$4 = "tooltip";
    var VERSION$4 = "4.6.2";
    var DATA_KEY$4 = "bs.tooltip";
    var EVENT_KEY$4 = "." + DATA_KEY$4;
    var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
    var CLASS_PREFIX$1 = "bs-tooltip";
    var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", "g");
    var DISALLOWED_ATTRIBUTES = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ];
    var CLASS_NAME_FADE$3 = "fade";
    var CLASS_NAME_SHOW$3 = "show";
    var HOVER_STATE_SHOW = "show";
    var HOVER_STATE_OUT = "out";
    var SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    var SELECTOR_ARROW = ".arrow";
    var TRIGGER_HOVER = "hover";
    var TRIGGER_FOCUS = "focus";
    var TRIGGER_CLICK = "click";
    var TRIGGER_MANUAL = "manual";
    var AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    };
    var Default$3 = {
        animation: true,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: false,
        selector: false,
        placement: "top",
        offset: 0,
        container: false,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        customClass: "",
        sanitize: true,
        sanitizeFn: null,
        whiteList: DefaultWhitelist,
        popperConfig: null
    };
    var DefaultType$3 = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        customClass: "(string|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    };
    var Event$1 = {
        HIDE: "hide" + EVENT_KEY$4,
        HIDDEN: "hidden" + EVENT_KEY$4,
        SHOW: "show" + EVENT_KEY$4,
        SHOWN: "shown" + EVENT_KEY$4,
        INSERTED: "inserted" + EVENT_KEY$4,
        CLICK: "click" + EVENT_KEY$4,
        FOCUSIN: "focusin" + EVENT_KEY$4,
        FOCUSOUT: "focusout" + EVENT_KEY$4,
        MOUSEENTER: "mouseenter" + EVENT_KEY$4,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$4
    };
    /**
   * Class definition
   */ var Tooltip = /*#__PURE__*/ function() {
        function Tooltip(element, config) {
            if (typeof Popper__default["default"] === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
             // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._hoverState = "";
            this._activeTrigger = {};
            this._popper = null; // Protected
            this.element = element;
            this.config = this._getConfig(config);
            this.tip = null;
            this._setListeners();
        } // Getters
        var _proto = Tooltip.prototype;
        // Public
        _proto.enable = function enable() {
            this._isEnabled = true;
        };
        _proto.disable = function disable() {
            this._isEnabled = false;
        };
        _proto.toggleEnabled = function toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        };
        _proto.toggle = function toggle(event) {
            if (!this._isEnabled) return;
            if (event) {
                var dataKey = this.constructor.DATA_KEY;
                var context = $__default["default"](event.currentTarget).data(dataKey);
                if (!context) {
                    context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                    $__default["default"](event.currentTarget).data(dataKey, context);
                }
                context._activeTrigger.click = !context._activeTrigger.click;
                if (context._isWithActiveTrigger()) context._enter(null, context);
                else context._leave(null, context);
            } else {
                if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
                    this._leave(null, this);
                    return;
                }
                this._enter(null, this);
            }
        };
        _proto.dispose = function dispose() {
            clearTimeout(this._timeout);
            $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
            $__default["default"](this.element).off(this.constructor.EVENT_KEY);
            $__default["default"](this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler);
            if (this.tip) $__default["default"](this.tip).remove();
            this._isEnabled = null;
            this._timeout = null;
            this._hoverState = null;
            this._activeTrigger = null;
            if (this._popper) this._popper.destroy();
            this._popper = null;
            this.element = null;
            this.config = null;
            this.tip = null;
        };
        _proto.show = function show() {
            var _this = this;
            if ($__default["default"](this.element).css("display") === "none") throw new Error("Please use show on visible elements");
            var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                $__default["default"](this.element).trigger(showEvent);
                var shadowRoot = Util.findShadowRoot(this.element);
                var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
                if (showEvent.isDefaultPrevented() || !isInTheDom) return;
                var tip = this.getTipElement();
                var tipId = Util.getUID(this.constructor.NAME);
                tip.setAttribute("id", tipId);
                this.element.setAttribute("aria-describedby", tipId);
                this.setContent();
                if (this.config.animation) $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
                var placement = typeof this.config.placement === "function" ? this.config.placement.call(this, tip, this.element) : this.config.placement;
                var attachment = this._getAttachment(placement);
                this.addAttachmentClass(attachment);
                var container = this._getContainer();
                $__default["default"](tip).data(this.constructor.DATA_KEY, this);
                if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) $__default["default"](tip).appendTo(container);
                $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
                this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
                $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
                $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
                var complete = function complete() {
                    if (_this.config.animation) _this._fixTransition();
                    var prevHoverState = _this._hoverState;
                    _this._hoverState = null;
                    $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);
                    if (prevHoverState === HOVER_STATE_OUT) _this._leave(null, _this);
                };
                if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
                    var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
                    $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                } else complete();
            }
        };
        _proto.hide = function hide(callback) {
            var _this2 = this;
            var tip = this.getTipElement();
            var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);
            var complete = function complete() {
                if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) tip.parentNode.removeChild(tip);
                _this2._cleanTipClass();
                _this2.element.removeAttribute("aria-describedby");
                $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
                if (_this2._popper !== null) _this2._popper.destroy();
                if (callback) callback();
            };
            $__default["default"](this.element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
                var transitionDuration = Util.getTransitionDurationFromElement(tip);
                $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
            this._hoverState = "";
        };
        _proto.update = function update() {
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Protected
        ;
        _proto.isWithContent = function isWithContent() {
            return Boolean(this.getTitle());
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var tip = this.getTipElement();
            this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
        };
        _proto.setElementContent = function setElementContent($element, content) {
            if (typeof content === "object" && (content.nodeType || content.jquery)) {
                // Content is a DOM node or a jQuery
                if (this.config.html) {
                    if (!$__default["default"](content).parent().is($element)) $element.empty().append(content);
                } else $element.text($__default["default"](content).text());
                return;
            }
            if (this.config.html) {
                if (this.config.sanitize) content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
                $element.html(content);
            } else $element.text(content);
        };
        _proto.getTitle = function getTitle() {
            var title = this.element.getAttribute("data-original-title");
            if (!title) title = typeof this.config.title === "function" ? this.config.title.call(this.element) : this.config.title;
            return title;
        } // Private
        ;
        _proto._getPopperConfig = function _getPopperConfig(attachment) {
            var _this3 = this;
            var defaultBsConfig = {
                placement: attachment,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: SELECTOR_ARROW
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function onCreate(data) {
                    if (data.originalPlacement !== data.placement) _this3._handlePopperPlacementChange(data);
                },
                onUpdate: function onUpdate(data) {
                    return _this3._handlePopperPlacementChange(data);
                }
            };
            return _extends({}, defaultBsConfig, this.config.popperConfig);
        };
        _proto._getOffset = function _getOffset() {
            var _this4 = this;
            var offset = {};
            if (typeof this.config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
                return data;
            };
            else offset.offset = this.config.offset;
            return offset;
        };
        _proto._getContainer = function _getContainer() {
            if (this.config.container === false) return document.body;
            if (Util.isElement(this.config.container)) return $__default["default"](this.config.container);
            return $__default["default"](document).find(this.config.container);
        };
        _proto._getAttachment = function _getAttachment(placement) {
            return AttachmentMap[placement.toUpperCase()];
        };
        _proto._setListeners = function _setListeners() {
            var _this5 = this;
            var triggers = this.config.trigger.split(" ");
            triggers.forEach(function(trigger) {
                if (trigger === "click") $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function(event) {
                    return _this5.toggle(event);
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
                    var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
                    $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function(event) {
                        return _this5._enter(event);
                    }).on(eventOut, _this5.config.selector, function(event) {
                        return _this5._leave(event);
                    });
                }
            });
            this._hideModalHandler = function() {
                if (_this5.element) _this5.hide();
            };
            $__default["default"](this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler);
            if (this.config.selector) this.config = _extends({}, this.config, {
                trigger: "manual",
                selector: ""
            });
            else this._fixTitle();
        };
        _proto._fixTitle = function _fixTitle() {
            var titleType = (0, $1ciUP._)(this.element.getAttribute("data-original-title"));
            if (this.element.getAttribute("title") || titleType !== "string") {
                this.element.setAttribute("data-original-title", this.element.getAttribute("title") || "");
                this.element.setAttribute("title", "");
            }
        };
        _proto._enter = function _enter(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
            if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
                context._hoverState = HOVER_STATE_SHOW;
                return;
            }
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_SHOW;
            if (!context.config.delay || !context.config.delay.show) {
                context.show();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_SHOW) context.show();
            }, context.config.delay.show);
        };
        _proto._leave = function _leave(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
            if (context._isWithActiveTrigger()) return;
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_OUT;
            if (!context.config.delay || !context.config.delay.hide) {
                context.hide();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_OUT) context.hide();
            }, context.config.delay.hide);
        };
        _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
            for(var trigger in this._activeTrigger){
                if (this._activeTrigger[trigger]) return true;
            }
            return false;
        };
        _proto._getConfig = function _getConfig(config) {
            var dataAttributes = $__default["default"](this.element).data();
            Object.keys(dataAttributes).forEach(function(dataAttr) {
                if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) delete dataAttributes[dataAttr];
            });
            config = _extends({}, this.constructor.Default, dataAttributes, typeof config === "object" && config ? config : {});
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
            if (config.sanitize) config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
            return config;
        };
        _proto._getDelegateConfig = function _getDelegateConfig() {
            var config = {};
            if (this.config) {
                for(var key in this.config)if (this.constructor.Default[key] !== this.config[key]) config[key] = this.config[key];
            }
            return config;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX$1);
            if (tabClass !== null && tabClass.length) $tip.removeClass(tabClass.join(""));
        };
        _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
            this.tip = popperData.instance.popper;
            this._cleanTipClass();
            this.addAttachmentClass(this._getAttachment(popperData.placement));
        };
        _proto._fixTransition = function _fixTransition() {
            var tip = this.getTipElement();
            var initConfigAnimation = this.config.animation;
            if (tip.getAttribute("x-placement") !== null) return;
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
            this.config.animation = false;
            this.hide();
            this.show();
            this.config.animation = initConfigAnimation;
        } // Static
        ;
        Tooltip._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$4);
                var _config = typeof config === "object" && config;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Tooltip(this, _config);
                    $element.data(DATA_KEY$4, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tooltip, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$4;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$3;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$4;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$4;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event$1;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$4;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$3;
                }
            }
        ]);
        return Tooltip;
    }();
    /**
   * jQuery
   */ $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
    $__default["default"].fn[NAME$4].Constructor = Tooltip;
    $__default["default"].fn[NAME$4].noConflict = function() {
        $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
        return Tooltip._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$3 = "popover";
    var VERSION$3 = "4.6.2";
    var DATA_KEY$3 = "bs.popover";
    var EVENT_KEY$3 = "." + DATA_KEY$3;
    var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
    var CLASS_PREFIX = "bs-popover";
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", "g");
    var CLASS_NAME_FADE$2 = "fade";
    var CLASS_NAME_SHOW$2 = "show";
    var SELECTOR_TITLE = ".popover-header";
    var SELECTOR_CONTENT = ".popover-body";
    var Default$2 = _extends({}, Tooltip.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
        content: "(string|element|function)"
    });
    var Event = {
        HIDE: "hide" + EVENT_KEY$3,
        HIDDEN: "hidden" + EVENT_KEY$3,
        SHOW: "show" + EVENT_KEY$3,
        SHOWN: "shown" + EVENT_KEY$3,
        INSERTED: "inserted" + EVENT_KEY$3,
        CLICK: "click" + EVENT_KEY$3,
        FOCUSIN: "focusin" + EVENT_KEY$3,
        FOCUSOUT: "focusout" + EVENT_KEY$3,
        MOUSEENTER: "mouseenter" + EVENT_KEY$3,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$3
    };
    /**
   * Class definition
   */ var Popover = /*#__PURE__*/ function(_Tooltip) {
        _inheritsLoose(Popover, _Tooltip);
        function Popover() {
            return _Tooltip.apply(this, arguments) || this;
        }
        var _proto = Popover.prototype;
        // Overrides
        _proto.isWithContent = function isWithContent() {
            return this.getTitle() || this._getContent();
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events
            this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
            var content = this._getContent();
            if (typeof content === "function") content = content.call(this.element);
            this.setElementContent($tip.find(SELECTOR_CONTENT), content);
            $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
        } // Private
        ;
        _proto._getContent = function _getContent() {
            return this.element.getAttribute("data-content") || this.config.content;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX);
            if (tabClass !== null && tabClass.length > 0) $tip.removeClass(tabClass.join(""));
        } // Static
        ;
        Popover._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$3);
                var _config = typeof config === "object" ? config : null;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Popover(this, _config);
                    $__default["default"](this).data(DATA_KEY$3, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Popover, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$3;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$2;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$3;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$3;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$3;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$2;
                }
            }
        ]);
        return Popover;
    }(Tooltip);
    /**
   * jQuery
   */ $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
    $__default["default"].fn[NAME$3].Constructor = Popover;
    $__default["default"].fn[NAME$3].noConflict = function() {
        $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
        return Popover._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$2 = "scrollspy";
    var VERSION$2 = "4.6.2";
    var DATA_KEY$2 = "bs.scrollspy";
    var EVENT_KEY$2 = "." + DATA_KEY$2;
    var DATA_API_KEY$1 = ".data-api";
    var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
    var CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    var CLASS_NAME_ACTIVE$1 = "active";
    var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
    var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
    var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
    var METHOD_OFFSET = "offset";
    var METHOD_POSITION = "position";
    var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
    var SELECTOR_NAV_LIST_GROUP$1 = ".nav, .list-group";
    var SELECTOR_NAV_LINKS = ".nav-link";
    var SELECTOR_NAV_ITEMS = ".nav-item";
    var SELECTOR_LIST_ITEMS = ".list-group-item";
    var SELECTOR_DROPDOWN$1 = ".dropdown";
    var SELECTOR_DROPDOWN_ITEMS = ".dropdown-item";
    var SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
    var Default$1 = {
        offset: 10,
        method: "auto",
        target: ""
    };
    var DefaultType$1 = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    };
    /**
   * Class definition
   */ var ScrollSpy = /*#__PURE__*/ function() {
        function ScrollSpy(element, config) {
            var _this = this;
            this._element = element;
            this._scrollElement = element.tagName === "BODY" ? window : element;
            this._config = this._getConfig(config);
            this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            $__default["default"](this._scrollElement).on(EVENT_SCROLL, function(event) {
                return _this._process(event);
            });
            this.refresh();
            this._process();
        } // Getters
        var _proto = ScrollSpy.prototype;
        // Public
        _proto.refresh = function refresh() {
            var _this2 = this;
            var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            var offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
            var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            var targets = [].slice.call(document.querySelectorAll(this._selector));
            targets.map(function(element) {
                var target;
                var targetSelector = Util.getSelectorFromElement(element);
                if (targetSelector) target = document.querySelector(targetSelector);
                if (target) {
                    var targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) // TODO (fat): remove sketch reliance on jQuery position/offset
                    return [
                        $__default["default"](target)[offsetMethod]().top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter(Boolean).sort(function(a, b) {
                return a[0] - b[0];
            }).forEach(function(item) {
                _this2._offsets.push(item[0]);
                _this2._targets.push(item[1]);
            });
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$2);
            $__default["default"](this._scrollElement).off(EVENT_KEY$2);
            this._element = null;
            this._scrollElement = null;
            this._config = null;
            this._selector = null;
            this._offsets = null;
            this._targets = null;
            this._activeTarget = null;
            this._scrollHeight = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$1, typeof config === "object" && config ? config : {});
            if (typeof config.target !== "string" && Util.isElement(config.target)) {
                var id = $__default["default"](config.target).attr("id");
                if (!id) {
                    id = Util.getUID(NAME$2);
                    $__default["default"](config.target).attr("id", id);
                }
                config.target = "#" + id;
            }
            Util.typeCheckConfig(NAME$2, config, DefaultType$1);
            return config;
        };
        _proto._getScrollTop = function _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        };
        _proto._getScrollHeight = function _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        };
        _proto._getOffsetHeight = function _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        };
        _proto._process = function _process() {
            var scrollTop = this._getScrollTop() + this._config.offset;
            var scrollHeight = this._getScrollHeight();
            var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                var target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(var i = this._offsets.length; i--;){
                var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === "undefined" || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        };
        _proto._activate = function _activate(target) {
            this._activeTarget = target;
            this._clear();
            var queries = this._selector.split(",").map(function(selector) {
                return selector + '[data-target="' + target + '"],' + selector + '[href="' + target + '"]';
            });
            var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(","))));
            if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
                $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
                $link.addClass(CLASS_NAME_ACTIVE$1);
            } else {
                // Set triggered link as active
                $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item
                $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
            }
            $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
                relatedTarget: target
            });
        };
        _proto._clear = function _clear() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(node) {
                return node.classList.contains(CLASS_NAME_ACTIVE$1);
            }).forEach(function(node) {
                return node.classList.remove(CLASS_NAME_ACTIVE$1);
            });
        } // Static
        ;
        ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$2);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new ScrollSpy(this, _config);
                    $__default["default"](this).data(DATA_KEY$2, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(ScrollSpy, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$2;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$1;
                }
            }
        ]);
        return ScrollSpy;
    }();
    /**
   * Data API implementation
   */ $__default["default"](window).on(EVENT_LOAD_DATA_API, function() {
        var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
        var scrollSpysLength = scrollSpys.length;
        for(var i = scrollSpysLength; i--;){
            var $spy = $__default["default"](scrollSpys[i]);
            ScrollSpy._jQueryInterface.call($spy, $spy.data());
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
    $__default["default"].fn[NAME$2].Constructor = ScrollSpy;
    $__default["default"].fn[NAME$2].noConflict = function() {
        $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
        return ScrollSpy._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$1 = "tab";
    var VERSION$1 = "4.6.2";
    var DATA_KEY$1 = "bs.tab";
    var EVENT_KEY$1 = "." + DATA_KEY$1;
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
    var CLASS_NAME_DROPDOWN_MENU = "dropdown-menu";
    var CLASS_NAME_ACTIVE = "active";
    var CLASS_NAME_DISABLED = "disabled";
    var CLASS_NAME_FADE$1 = "fade";
    var CLASS_NAME_SHOW$1 = "show";
    var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
    var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
    var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
    var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
    var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
    var SELECTOR_DROPDOWN = ".dropdown";
    var SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    var SELECTOR_ACTIVE = ".active";
    var SELECTOR_ACTIVE_UL = "> li > .active";
    var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
    var SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    var SELECTOR_DROPDOWN_ACTIVE_CHILD = "> .dropdown-menu .active";
    /**
   * Class definition
   */ var Tab = /*#__PURE__*/ function() {
        function Tab(element) {
            this._element = element;
        } // Getters
        var _proto = Tab.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || this._element.hasAttribute("disabled")) return;
            var target;
            var previous;
            var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
            var selector = Util.getSelectorFromElement(this._element);
            if (listElement) {
                var itemSelector = listElement.nodeName === "UL" || listElement.nodeName === "OL" ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
                previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
                previous = previous[previous.length - 1];
            }
            var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
                relatedTarget: this._element
            });
            var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
                relatedTarget: previous
            });
            if (previous) $__default["default"](previous).trigger(hideEvent);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
            if (selector) target = document.querySelector(selector);
            this._activate(this._element, listElement);
            var complete = function complete() {
                var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
                    relatedTarget: _this._element
                });
                var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
                    relatedTarget: previous
                });
                $__default["default"](previous).trigger(hiddenEvent);
                $__default["default"](_this._element).trigger(shownEvent);
            };
            if (target) this._activate(target, target.parentNode, complete);
            else complete();
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$1);
            this._element = null;
        } // Private
        ;
        _proto._activate = function _activate(element, container, callback) {
            var _this2 = this;
            var activeElements = container && (container.nodeName === "UL" || container.nodeName === "OL") ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
            var active = activeElements[0];
            var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);
            var complete = function complete() {
                return _this2._transitionComplete(element, active, callback);
            };
            if (active && isTransitioning) {
                var transitionDuration = Util.getTransitionDurationFromElement(active);
                $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._transitionComplete = function _transitionComplete(element, active, callback) {
            if (active) {
                $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
                var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
                if (dropdownChild) $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
                if (active.getAttribute("role") === "tab") active.setAttribute("aria-selected", false);
            }
            $__default["default"](element).addClass(CLASS_NAME_ACTIVE);
            if (element.getAttribute("role") === "tab") element.setAttribute("aria-selected", true);
            Util.reflow(element);
            if (element.classList.contains(CLASS_NAME_FADE$1)) element.classList.add(CLASS_NAME_SHOW$1);
            var parent = element.parentNode;
            if (parent && parent.nodeName === "LI") parent = parent.parentNode;
            if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
                var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];
                if (dropdownElement) {
                    var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
                    $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
                }
                element.setAttribute("aria-expanded", true);
            }
            if (callback) callback();
        } // Static
        ;
        Tab._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $this = $__default["default"](this);
                var data = $this.data(DATA_KEY$1);
                if (!data) {
                    data = new Tab(this);
                    $this.data(DATA_KEY$1, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tab, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$1;
                }
            }
        ]);
        return Tab;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Tab._jQueryInterface.call($__default["default"](this), "show");
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
    $__default["default"].fn[NAME$1].Constructor = Tab;
    $__default["default"].fn[NAME$1].noConflict = function() {
        $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
        return Tab._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME = "toast";
    var VERSION = "4.6.2";
    var DATA_KEY = "bs.toast";
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
    var CLASS_NAME_FADE = "fade";
    var CLASS_NAME_HIDE = "hide";
    var CLASS_NAME_SHOW = "show";
    var CLASS_NAME_SHOWING = "showing";
    var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
    var EVENT_HIDE = "hide" + EVENT_KEY;
    var EVENT_HIDDEN = "hidden" + EVENT_KEY;
    var EVENT_SHOW = "show" + EVENT_KEY;
    var EVENT_SHOWN = "shown" + EVENT_KEY;
    var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
    var Default = {
        animation: true,
        autohide: true,
        delay: 500
    };
    var DefaultType = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    /**
   * Class definition
   */ var Toast = /*#__PURE__*/ function() {
        function Toast(element, config) {
            this._element = element;
            this._config = this._getConfig(config);
            this._timeout = null;
            this._setListeners();
        } // Getters
        var _proto = Toast.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            var showEvent = $__default["default"].Event(EVENT_SHOW);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            var complete = function complete() {
                _this._element.classList.remove(CLASS_NAME_SHOWING);
                _this._element.classList.add(CLASS_NAME_SHOW);
                $__default["default"](_this._element).trigger(EVENT_SHOWN);
                if (_this._config.autohide) _this._timeout = setTimeout(function() {
                    _this.hide();
                }, _this._config.delay);
            };
            this._element.classList.remove(CLASS_NAME_HIDE);
            Util.reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOWING);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto.hide = function hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW)) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE);
            $__default["default"](this._element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            this._close();
        };
        _proto.dispose = function dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW)) this._element.classList.remove(CLASS_NAME_SHOW);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
            $__default["default"].removeData(this._element, DATA_KEY);
            this._element = null;
            this._config = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default, $__default["default"](this._element).data(), typeof config === "object" && config ? config : {});
            Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
            return config;
        };
        _proto._setListeners = function _setListeners() {
            var _this2 = this;
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function() {
                return _this2.hide();
            });
        };
        _proto._close = function _close() {
            var _this3 = this;
            var complete = function complete() {
                _this3._element.classList.add(CLASS_NAME_HIDE);
                $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
            };
            this._element.classList.remove(CLASS_NAME_SHOW);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._clearTimeout = function _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        } // Static
        ;
        Toast._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new Toast(this, _config);
                    $element.data(DATA_KEY, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](this);
                }
            });
        };
        _createClass(Toast, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * jQuery
   */ $__default["default"].fn[NAME] = Toast._jQueryInterface;
    $__default["default"].fn[NAME].Constructor = Toast;
    $__default["default"].fn[NAME].noConflict = function() {
        $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
        return Toast._jQueryInterface;
    };
    exports1.Alert = Alert;
    exports1.Button = Button;
    exports1.Carousel = Carousel;
    exports1.Collapse = Collapse;
    exports1.Dropdown = Dropdown;
    exports1.Modal = Modal;
    exports1.Popover = Popover;
    exports1.Scrollspy = ScrollSpy;
    exports1.Tab = Tab;
    exports1.Toast = Toast;
    exports1.Tooltip = Tooltip;
    exports1.Util = Util;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $aPoFX = parcelRequire("aPoFX");
/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */ function $f2d4454c65effdb1$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $2yCSJ = parcelRequire("2yCSJ");

var $80pZ5 = parcelRequire("80pZ5");

var $ddmaO = parcelRequire("ddmaO");
function $03cd821d06a81811$export$c2c98ac76e997b63(o, p) {
    $03cd821d06a81811$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $03cd821d06a81811$export$c2c98ac76e997b63(o, p);
}


function $346e2f3a84730f45$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $03cd821d06a81811$export$c2c98ac76e997b63)(subClass, superClass);
}




var $1ciUP = parcelRequire("1ciUP");
function $283ca50bf5310286$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $1ciUP._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $f2d4454c65effdb1$export$f3b8ed2e4a5d10b8)(self);
}



var $59ZDq = parcelRequire("59ZDq");

var $e8VKf = parcelRequire("e8VKf");
function $27293a1bd63dd752$export$f09211a7d3c496a1(o) {
    $27293a1bd63dd752$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $27293a1bd63dd752$export$f09211a7d3c496a1(o);
}


function $f60de5dfd97cc079$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $521c51dabf7c315d$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $f60de5dfd97cc079$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $27293a1bd63dd752$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $27293a1bd63dd752$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $283ca50bf5310286$export$ef97c660ca164e52)(this, result);
    };
}



var $lQE57 = parcelRequire("lQE57");
/**
 * SSR Window 1.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2018, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: July 18, 2018
 */ var $493f762f30aff8bc$export$5a7bfc01df82fcd1 = typeof document === "undefined" ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
        blur: function blur() {},
        nodeName: ""
    },
    querySelector: function querySelector() {
        return null;
    },
    querySelectorAll: function querySelectorAll() {
        return [];
    },
    getElementById: function getElementById() {
        return null;
    },
    createEvent: function createEvent() {
        return {
            initEvent: function initEvent() {}
        };
    },
    createElement: function createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function setAttribute() {},
            getElementsByTagName: function getElementsByTagName() {
                return [];
            }
        };
    },
    location: {
        hash: ""
    }
} : document; // eslint-disable-line
var $493f762f30aff8bc$export$8291e5b88f90ce4 = typeof window === "undefined" ? {
    document: $493f762f30aff8bc$export$5a7bfc01df82fcd1,
    navigator: {
        userAgent: ""
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
        return {
            getPropertyValue: function getPropertyValue() {
                return "";
            }
        };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {}
} : window; // eslint-disable-line


var $5e44c3fe32d2063c$var$Methods = {
    addClass: (0, $lQE57.addClass),
    removeClass: (0, $lQE57.removeClass),
    hasClass: (0, $lQE57.hasClass),
    toggleClass: (0, $lQE57.toggleClass),
    attr: (0, $lQE57.attr),
    removeAttr: (0, $lQE57.removeAttr),
    data: (0, $lQE57.data),
    transform: (0, $lQE57.transform),
    transition: (0, $lQE57.transition),
    on: (0, $lQE57.on),
    off: (0, $lQE57.off),
    trigger: (0, $lQE57.trigger),
    transitionEnd: (0, $lQE57.transitionEnd),
    outerWidth: (0, $lQE57.outerWidth),
    outerHeight: (0, $lQE57.outerHeight),
    offset: (0, $lQE57.offset),
    css: (0, $lQE57.css),
    each: (0, $lQE57.each),
    html: (0, $lQE57.html),
    text: (0, $lQE57.text),
    is: (0, $lQE57.is),
    index: (0, $lQE57.index),
    eq: (0, $lQE57.eq),
    append: (0, $lQE57.append),
    prepend: (0, $lQE57.prepend),
    next: (0, $lQE57.next),
    nextAll: (0, $lQE57.nextAll),
    prev: (0, $lQE57.prev),
    prevAll: (0, $lQE57.prevAll),
    parent: (0, $lQE57.parent),
    parents: (0, $lQE57.parents),
    closest: (0, $lQE57.closest),
    find: (0, $lQE57.find),
    children: (0, $lQE57.children),
    remove: (0, $lQE57.remove),
    add: (0, $lQE57.add),
    styles: (0, $lQE57.styles)
};
Object.keys($5e44c3fe32d2063c$var$Methods).forEach(function(methodName) {
    (0, $lQE57.$).fn[methodName] = (0, $lQE57.$).fn[methodName] || $5e44c3fe32d2063c$var$Methods[methodName];
});
var $5e44c3fe32d2063c$var$Utils = {
    deleteProps: function(obj) {
        var object = obj;
        Object.keys(object).forEach(function(key) {
            try {
                object[key] = null;
            } catch (e) {
            // no getter for object
            }
            try {
                delete object[key];
            } catch (e) {
            // something got wrong
            }
        });
    },
    nextTick: function(callback) {
        var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return setTimeout(callback, delay);
    },
    now: function() {
        return Date.now();
    },
    getTranslate: function(el) {
        var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
        var matrix;
        var curTransform;
        var transformMatrix;
        var curStyle = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).getComputedStyle(el, null);
        if ((0, $493f762f30aff8bc$export$8291e5b88f90ce4).WebKitCSSMatrix) {
            curTransform = curStyle.transform || curStyle.webkitTransform;
            if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
                return a.replace(",", ".");
            }).join(", ");
            // Some old versions of Webkit choke when 'none' is passed; pass
            // empty string instead in this case
            transformMatrix = new (0, $493f762f30aff8bc$export$8291e5b88f90ce4).WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
        } else {
            transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
            matrix = transformMatrix.toString().split(",");
        }
        if (axis === "x") {
            // Latest Chrome and webkits Fix
            if ((0, $493f762f30aff8bc$export$8291e5b88f90ce4).WebKitCSSMatrix) curTransform = transformMatrix.m41;
            else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
            else curTransform = parseFloat(matrix[4]);
        }
        if (axis === "y") {
            // Latest Chrome and webkits Fix
            if ((0, $493f762f30aff8bc$export$8291e5b88f90ce4).WebKitCSSMatrix) curTransform = transformMatrix.m42;
            else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
            else curTransform = parseFloat(matrix[5]);
        }
        return curTransform || 0;
    },
    parseUrlQuery: function(url) {
        var query = {};
        var urlToParse = url || (0, $493f762f30aff8bc$export$8291e5b88f90ce4).location.href;
        var i;
        var params;
        var param;
        var length;
        if (typeof urlToParse === "string" && urlToParse.length) {
            urlToParse = urlToParse.indexOf("?") > -1 ? urlToParse.replace(/\S*\?/, "") : "";
            params = urlToParse.split("&").filter(function(paramsPart) {
                return paramsPart !== "";
            });
            length = params.length;
            for(i = 0; i < length; i += 1){
                param = params[i].replace(/#\S+/g, "").split("=");
                query[decodeURIComponent(param[0])] = typeof param[1] === "undefined" ? undefined : decodeURIComponent(param[1]) || "";
            }
        }
        return query;
    },
    isObject: function(o) {
        return typeof o === "object" && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = Object(args[0]);
        for(var i = 1; i < args.length; i += 1){
            var nextSource = args[i];
            if (nextSource !== undefined && nextSource !== null) {
                var keysArray = Object.keys(Object(nextSource));
                for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                        if ($5e44c3fe32d2063c$var$Utils.isObject(to[nextKey]) && $5e44c3fe32d2063c$var$Utils.isObject(nextSource[nextKey])) $5e44c3fe32d2063c$var$Utils.extend(to[nextKey], nextSource[nextKey]);
                        else if (!$5e44c3fe32d2063c$var$Utils.isObject(to[nextKey]) && $5e44c3fe32d2063c$var$Utils.isObject(nextSource[nextKey])) {
                            to[nextKey] = {};
                            $5e44c3fe32d2063c$var$Utils.extend(to[nextKey], nextSource[nextKey]);
                        } else to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    }
};
var $5e44c3fe32d2063c$var$Support = function Support() {
    var testDiv = (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).createElement("div");
    return {
        touch: (0, $493f762f30aff8bc$export$8291e5b88f90ce4).Modernizr && (0, $493f762f30aff8bc$export$8291e5b88f90ce4).Modernizr.touch === true || function checkTouch() {
            return !!((0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.maxTouchPoints > 0 || "ontouchstart" in (0, $493f762f30aff8bc$export$8291e5b88f90ce4) || (0, $493f762f30aff8bc$export$8291e5b88f90ce4).DocumentTouch && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1) instanceof (0, $493f762f30aff8bc$export$8291e5b88f90ce4).DocumentTouch);
        }(),
        pointerEvents: !!((0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.pointerEnabled || (0, $493f762f30aff8bc$export$8291e5b88f90ce4).PointerEvent || "maxTouchPoints" in (0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator && (0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.maxTouchPoints > 0),
        prefixedPointerEvents: !!(0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.msPointerEnabled,
        transition: function checkTransition() {
            var style = testDiv.style;
            return "transition" in style || "webkitTransition" in style || "MozTransition" in style;
        }(),
        transforms3d: (0, $493f762f30aff8bc$export$8291e5b88f90ce4).Modernizr && (0, $493f762f30aff8bc$export$8291e5b88f90ce4).Modernizr.csstransforms3d === true || function checkTransforms3d() {
            var style = testDiv.style;
            return "webkitPerspective" in style || "MozPerspective" in style || "OPerspective" in style || "MsPerspective" in style || "perspective" in style;
        }(),
        flexbox: function checkFlexbox() {
            var style = testDiv.style;
            var _$styles = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" ");
            for(var i = 0; i < _$styles.length; i += 1){
                if (_$styles[i] in style) return true;
            }
            return false;
        }(),
        observer: function checkObserver() {
            return "MutationObserver" in (0, $493f762f30aff8bc$export$8291e5b88f90ce4) || "WebkitMutationObserver" in (0, $493f762f30aff8bc$export$8291e5b88f90ce4);
        }(),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get: function() {
                        supportsPassive = true;
                    }
                });
                (0, $493f762f30aff8bc$export$8291e5b88f90ce4).addEventListener("testPassiveListener", null, opts);
            } catch (e) {
            // No support
            }
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in (0, $493f762f30aff8bc$export$8291e5b88f90ce4);
        }()
    };
}();
var $5e44c3fe32d2063c$var$Browser = function Browser() {
    function isSafari() {
        var ua = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isIE: !!(0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent.match(/Trident/g) || !!(0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent.match(/MSIE/g),
        isEdge: !!(0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test((0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent)
    };
}();
var $5e44c3fe32d2063c$var$SwiperClass = /*#__PURE__*/ function() {
    "use strict";
    function SwiperClass() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $2yCSJ._)(this, SwiperClass);
        var self = this;
        self.params = params;
        // Events
        self.eventsListeners = {};
        if (self.params && self.params.on) Object.keys(self.params.on).forEach(function(eventName) {
            self.on(eventName, self.params.on[eventName]);
        });
    }
    (0, $80pZ5._)(SwiperClass, [
        {
            key: "on",
            value: function on(events, handler, priority) {
                var self = this;
                if (typeof handler !== "function") return self;
                var method = priority ? "unshift" : "push";
                events.split(" ").forEach(function(event) {
                    if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
                    self.eventsListeners[event][method](handler);
                });
                return self;
            }
        },
        {
            key: "once",
            value: function once(events, handler, priority) {
                var self = this;
                if (typeof handler !== "function") return self;
                function onceHandler() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    handler.apply(self, args);
                    self.off(events, onceHandler);
                    if (onceHandler.f7proxy) delete onceHandler.f7proxy;
                }
                onceHandler.f7proxy = handler;
                return self.on(events, onceHandler, priority);
            }
        },
        {
            key: "off",
            value: function off(events, handler) {
                var self = this;
                if (!self.eventsListeners) return self;
                events.split(" ").forEach(function(event) {
                    if (typeof handler === "undefined") self.eventsListeners[event] = [];
                    else if (self.eventsListeners[event] && self.eventsListeners[event].length) self.eventsListeners[event].forEach(function(eventHandler, index) {
                        if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) self.eventsListeners[event].splice(index, 1);
                    });
                });
                return self;
            }
        },
        {
            key: "emit",
            value: function emit() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var self = this;
                if (!self.eventsListeners) return self;
                var events;
                var _$data;
                var context;
                if (typeof args[0] === "string" || Array.isArray(args[0])) {
                    events = args[0];
                    _$data = args.slice(1, args.length);
                    context = self;
                } else {
                    events = args[0].events;
                    _$data = args[0].data;
                    context = args[0].context || self;
                }
                var eventsArray = Array.isArray(events) ? events : events.split(" ");
                eventsArray.forEach(function(event) {
                    if (self.eventsListeners && self.eventsListeners[event]) {
                        var handlers = [];
                        self.eventsListeners[event].forEach(function(eventHandler) {
                            handlers.push(eventHandler);
                        });
                        handlers.forEach(function(eventHandler) {
                            eventHandler.apply(context, _$data);
                        });
                    }
                });
                return self;
            }
        },
        {
            key: "useModulesParams",
            value: function useModulesParams(instanceParams) {
                var instance = this;
                if (!instance.modules) return;
                Object.keys(instance.modules).forEach(function(moduleName) {
                    var module = instance.modules[moduleName];
                    // Extend params
                    if (module.params) $5e44c3fe32d2063c$var$Utils.extend(instanceParams, module.params);
                });
            }
        },
        {
            key: "useModules",
            value: function useModules() {
                var modulesParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var instance = this;
                if (!instance.modules) return;
                Object.keys(instance.modules).forEach(function(moduleName) {
                    var module = instance.modules[moduleName];
                    var moduleParams = modulesParams[moduleName] || {};
                    // Extend instance methods and props
                    if (module.instance) Object.keys(module.instance).forEach(function(modulePropName) {
                        var moduleProp = module.instance[modulePropName];
                        if (typeof moduleProp === "function") instance[modulePropName] = moduleProp.bind(instance);
                        else instance[modulePropName] = moduleProp;
                    });
                    // Add event listeners
                    if (module.on && instance.on) Object.keys(module.on).forEach(function(moduleEventName) {
                        instance.on(moduleEventName, module.on[moduleEventName]);
                    });
                    // Module create callback
                    if (module.create) module.create.bind(instance)(moduleParams);
                });
            }
        }
    ], [
        {
            key: "components",
            set: function set(components) {
                var Class = this;
                if (!Class.use) return;
                Class.use(components);
            }
        },
        {
            key: "installModule",
            value: function installModule(module) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    params[_key - 1] = arguments[_key];
                }
                var Class = this;
                if (!Class.prototype.modules) Class.prototype.modules = {};
                var name = module.name || "".concat(Object.keys(Class.prototype.modules).length, "_").concat($5e44c3fe32d2063c$var$Utils.now());
                Class.prototype.modules[name] = module;
                // Prototype
                if (module.proto) Object.keys(module.proto).forEach(function(key) {
                    Class.prototype[key] = module.proto[key];
                });
                // Class
                if (module.static) Object.keys(module.static).forEach(function(key) {
                    Class[key] = module.static[key];
                });
                // Callback
                if (module.install) module.install.apply(Class, params);
                return Class;
            }
        },
        {
            key: "use",
            value: function use(module) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    params[_key - 1] = arguments[_key];
                }
                var _Class;
                var Class = this;
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Class.installModule(m);
                    });
                    return Class;
                }
                return (_Class = Class).installModule.apply(_Class, [
                    module
                ].concat((0, $e8VKf._)(params)));
            }
        }
    ]);
    return SwiperClass;
}();
function $5e44c3fe32d2063c$var$updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined") width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined") height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt($el.css("padding-left"), 10) - parseInt($el.css("padding-right"), 10);
    height = height - parseInt($el.css("padding-top"), 10) - parseInt($el.css("padding-bottom"), 10);
    $5e44c3fe32d2063c$var$Utils.extend(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $5e44c3fe32d2063c$var$updateSlides() {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var _$index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween;
    // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: ""
    });
    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        if (params.slidesPerView !== "auto" && params.slidesPerColumnFill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
            // Set slides order
            var newSlideOrderIndex = void 0;
            var column = void 0;
            var row = void 0;
            if (params.slidesPerColumnFill === "column" || params.slidesPerColumnFill === "row" && params.slidesPerGroup > 1) {
                if (params.slidesPerColumnFill === "column") {
                    column = Math.floor(i / slidesPerColumn);
                    row = i - column * slidesPerColumn;
                    if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                        row += 1;
                        if (row >= slidesPerColumn) {
                            row = 0;
                            column += 1;
                        }
                    }
                } else {
                    var groupIndex = Math.floor(i / params.slidesPerGroup);
                    row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
                    column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
                }
                newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                slide.css({
                    "-webkit-box-ordinal-group": newSlideOrderIndex,
                    "-moz-box-ordinal-group": newSlideOrderIndex,
                    "-ms-flex-order": newSlideOrderIndex,
                    "-webkit-order": newSlideOrderIndex,
                    order: newSlideOrderIndex
                });
            } else {
                row = Math.floor(i / slidesPerRow);
                column = i - row * slidesPerRow;
            }
            slide.css("margin-".concat(swiper.isHorizontal() ? "top" : "left"), row !== 0 && params.spaceBetween && "".concat(params.spaceBetween, "px")).attr("data-swiper-column", column).attr("data-swiper-row", row);
        }
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            var slideStyles = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).getComputedStyle(slide[0], null);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else // eslint-disable-next-line
            if (swiper.isHorizontal()) {
                var width = parseFloat(slideStyles.getPropertyValue("width"));
                var paddingLeft = parseFloat(slideStyles.getPropertyValue("padding-left"));
                var paddingRight = parseFloat(slideStyles.getPropertyValue("padding-right"));
                var marginLeft = parseFloat(slideStyles.getPropertyValue("margin-left"));
                var marginRight = parseFloat(slideStyles.getPropertyValue("margin-right"));
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box" && !$5e44c3fe32d2063c$var$Browser.isIE) slideSize = width + marginLeft + marginRight;
                else slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            } else {
                var height = parseFloat(slideStyles.getPropertyValue("height"));
                var paddingTop = parseFloat(slideStyles.getPropertyValue("padding-top"));
                var paddingBottom = parseFloat(slideStyles.getPropertyValue("padding-bottom"));
                var marginTop = parseFloat(slideStyles.getPropertyValue("margin-top"));
                var marginBottom = parseFloat(slideStyles.getPropertyValue("margin-bottom"));
                var boxSizing1 = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing1 && boxSizing1 === "border-box" && !$5e44c3fe32d2063c$var$Browser.isIE) slideSize = height + marginTop + marginBottom;
                else slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) {
                if (swiper.isHorizontal()) slides[i].style.width = "".concat(slideSize, "px");
                else slides[i].style.height = "".concat(slideSize, "px");
            }
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (_$index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (_$index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        _$index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
    if (!$5e44c3fe32d2063c$var$Support.flexbox || params.setWrapperSize) {
        if (swiper.isHorizontal()) $wrapperEl.css({
            width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
        else $wrapperEl.css({
            height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
    }
    if (params.slidesPerColumn > 1) {
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        if (swiper.isHorizontal()) $wrapperEl.css({
            width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
        else $wrapperEl.css({
            height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
        if (params.centeredSlides) {
            newSlidesGrid = [];
            for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
                var slidesGridItem = snapGrid[i1];
                if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i1] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid = newSlidesGrid;
        }
    }
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        newSlidesGrid = [];
        for(var i2 = 0; i2 < snapGrid.length; i2 += 1){
            var slidesGridItem1 = snapGrid[i2];
            if (params.roundLengths) slidesGridItem1 = Math.floor(slidesGridItem1);
            if (snapGrid[i2] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem1);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        if (swiper.isHorizontal()) {
            if (rtl) slides.css({
                marginLeft: "".concat(spaceBetween, "px")
            });
            else slides.css({
                marginRight: "".concat(spaceBetween, "px")
            });
        } else slides.css({
            marginBottom: "".concat(spaceBetween, "px")
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    $5e44c3fe32d2063c$var$Utils.extend(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesOffset();
}
function $5e44c3fe32d2063c$var$updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
        var _$index = swiper.activeIndex + i;
        if (_$index > swiper.slides.length) break;
        activeSlides.push(swiper.slides.eq(_$index)[0]);
    }
    else activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight) swiper.$wrapperEl.css("height", "".concat(newHeight, "px"));
}
function $5e44c3fe32d2063c$var$updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}
function $5e44c3fe32d2063c$var$updateSlidesProgress() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        if (params.watchSlidesVisibility) {
            var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
            var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
            var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
            if (isVisible) {
                swiper.visibleSlides.push(slide);
                swiper.visibleSlidesIndexes.push(i);
                slides.eq(i).addClass(params.slideVisibleClass);
            }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = (0, $lQE57.$)(swiper.visibleSlides);
}
function $5e44c3fe32d2063c$var$updateProgress() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    $5e44c3fe32d2063c$var$Utils.extend(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function $5e44c3fe32d2063c$var$updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
    var activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(activeIndex, '"]'));
    else activeSlide = slides.eq(activeIndex);
    // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(nextSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(nextSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(prevSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(prevSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicatePrevClass);
    }
}
function $5e44c3fe32d2063c$var$updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === "undefined") {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        }
        // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    $5e44c3fe32d2063c$var$Utils.extend(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.runCallbacksOnInit) swiper.emit("slideChange");
}
function $5e44c3fe32d2063c$var$updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = (0, $lQE57.$)(e.target).closest(".".concat(params.slideClass))[0];
    var slideFound = false;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) slideFound = true;
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $lQE57.$)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = (0, $lQE57.$)(slide).index();
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $5e44c3fe32d2063c$var$update = {
    updateSize: $5e44c3fe32d2063c$var$updateSize,
    updateSlides: $5e44c3fe32d2063c$var$updateSlides,
    updateAutoHeight: $5e44c3fe32d2063c$var$updateAutoHeight,
    updateSlidesOffset: $5e44c3fe32d2063c$var$updateSlidesOffset,
    updateSlidesProgress: $5e44c3fe32d2063c$var$updateSlidesProgress,
    updateProgress: $5e44c3fe32d2063c$var$updateProgress,
    updateSlidesClasses: $5e44c3fe32d2063c$var$updateSlidesClasses,
    updateActiveIndex: $5e44c3fe32d2063c$var$updateActiveIndex,
    updateClickedSlide: $5e44c3fe32d2063c$var$updateClickedSlide
};
function $5e44c3fe32d2063c$var$getTranslate() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    var currentTranslate = $5e44c3fe32d2063c$var$Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $5e44c3fe32d2063c$var$setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (!params.virtualTranslate) {
        if ($5e44c3fe32d2063c$var$Support.transforms3d) $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
        else $wrapperEl.transform("translate(".concat(x, "px, ").concat(y, "px)"));
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $5e44c3fe32d2063c$var$minTranslate() {
    return -this.snapGrid[0];
}
function $5e44c3fe32d2063c$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
var $5e44c3fe32d2063c$var$translate = {
    getTranslate: $5e44c3fe32d2063c$var$getTranslate,
    setTranslate: $5e44c3fe32d2063c$var$setTranslate,
    minTranslate: $5e44c3fe32d2063c$var$minTranslate,
    maxTranslate: $5e44c3fe32d2063c$var$maxTranslate
};
function $5e44c3fe32d2063c$var$setTransition(duration, byController) {
    var swiper = this;
    swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}
function $5e44c3fe32d2063c$var$transitionStart() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var activeIndex = swiper.activeIndex, params = swiper.params, previousIndex = swiper.previousIndex;
    if (params.autoHeight) swiper.updateAutoHeight();
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transitionStart");
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransitionStart");
            return;
        }
        swiper.emit("slideChangeTransitionStart");
        if (dir === "next") swiper.emit("slideNextTransitionStart");
        else swiper.emit("slidePrevTransitionStart");
    }
}
function $5e44c3fe32d2063c$var$transitionEnd() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transitionEnd");
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransitionEnd");
            return;
        }
        swiper.emit("slideChangeTransitionEnd");
        if (dir === "next") swiper.emit("slideNextTransitionEnd");
        else swiper.emit("slidePrevTransitionEnd");
    }
}
var $5e44c3fe32d2063c$var$transition = {
    setTransition: $5e44c3fe32d2063c$var$setTransition,
    transitionStart: $5e44c3fe32d2063c$var$transitionStart,
    transitionEnd: $5e44c3fe32d2063c$var$transitionEnd
};
function $5e44c3fe32d2063c$var$slideTo() {
    var _$index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    var swiper = this;
    var slideIndex = _$index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    var translate = -snapGrid[snapIndex];
    // Update progress
    swiper.updateProgress(translate);
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        for(var i = 0; i < slidesGrid.length; i += 1)if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (speed === 0 || !$5e44c3fe32d2063c$var$Support.transition) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
                swiper.onSlideToWrapperTransitionEnd = null;
                delete swiper.onSlideToWrapperTransitionEnd;
                swiper.transitionEnd(runCallbacks, direction);
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
        }
    }
    return true;
}
function $5e44c3fe32d2063c$var$slideToLoop() {
    var _$index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    var swiper = this;
    var newIndex = _$index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $5e44c3fe32d2063c$var$slideNext() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating;
    if (params.loop) {
        if (animating) return false;
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $5e44c3fe32d2063c$var$slidePrev() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate;
    if (params.loop) {
        if (animating) return false;
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var normalizedSlidesGrid = slidesGrid.map(function(val) {
        return normalize(val);
    });
    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $5e44c3fe32d2063c$var$slideReset() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $5e44c3fe32d2063c$var$slideToClosest() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var _$index = swiper.activeIndex;
    var snapIndex = Math.floor(_$index / swiper.params.slidesPerGroup);
    if (snapIndex < swiper.snapGrid.length - 1) {
        var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) / 2) _$index = swiper.params.slidesPerGroup;
    }
    return swiper.slideTo(_$index, speed, runCallbacks, internal);
}
function $5e44c3fe32d2063c$var$slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $lQE57.$)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
                $5e44c3fe32d2063c$var$Utils.nextTick(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
            $5e44c3fe32d2063c$var$Utils.nextTick(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $5e44c3fe32d2063c$var$slide = {
    slideTo: $5e44c3fe32d2063c$var$slideTo,
    slideToLoop: $5e44c3fe32d2063c$var$slideToLoop,
    slideNext: $5e44c3fe32d2063c$var$slideNext,
    slidePrev: $5e44c3fe32d2063c$var$slidePrev,
    slideReset: $5e44c3fe32d2063c$var$slideReset,
    slideToClosest: $5e44c3fe32d2063c$var$slideToClosest,
    slideToClickedSlide: $5e44c3fe32d2063c$var$slideToClickedSlide
};
function $5e44c3fe32d2063c$var$loopCreate() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
    var slides = $wrapperEl.children(".".concat(params.slideClass));
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = (0, $lQE57.$)((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).createElement("div")).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
                $wrapperEl.append(blankNode);
            }
            slides = $wrapperEl.children(".".concat(params.slideClass));
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(index, el) {
        var slide = (0, $lQE57.$)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(var i1 = 0; i1 < appendSlides.length; i1 += 1)$wrapperEl.append((0, $lQE57.$)(appendSlides[i1].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(var i2 = prependSlides.length - 1; i2 >= 0; i2 -= 1)$wrapperEl.prepend((0, $lQE57.$)(prependSlides[i2].cloneNode(true)).addClass(params.slideDuplicateClass));
}
function $5e44c3fe32d2063c$var$loopFix() {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();
    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (params.slidesPerView === "auto" && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var slideChanged1 = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged1 && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
}
function $5e44c3fe32d2063c$var$loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
    slides.removeAttr("data-swiper-slide-index");
}
var $5e44c3fe32d2063c$var$loop = {
    loopCreate: $5e44c3fe32d2063c$var$loopCreate,
    loopFix: $5e44c3fe32d2063c$var$loopFix,
    loopDestroy: $5e44c3fe32d2063c$var$loopDestroy
};
function $5e44c3fe32d2063c$var$setGrabCursor(moving) {
    var swiper = this;
    if ($5e44c3fe32d2063c$var$Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) return;
    var el = swiper.el;
    el.style.cursor = "move";
    el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
    el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
    el.style.cursor = moving ? "grabbing" : "grab";
}
function $5e44c3fe32d2063c$var$unsetGrabCursor() {
    var swiper = this;
    if ($5e44c3fe32d2063c$var$Support.touch || swiper.params.watchOverflow && swiper.isLocked) return;
    swiper.el.style.cursor = "";
}
var $5e44c3fe32d2063c$var$grabCursor = {
    setGrabCursor: $5e44c3fe32d2063c$var$setGrabCursor,
    unsetGrabCursor: $5e44c3fe32d2063c$var$unsetGrabCursor
};
function $5e44c3fe32d2063c$var$appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && $5e44c3fe32d2063c$var$Support.observer)) swiper.update();
}
function $5e44c3fe32d2063c$var$prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && $5e44c3fe32d2063c$var$Support.observer)) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $5e44c3fe32d2063c$var$addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) $wrapperEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)$wrapperEl.append(slidesBuffer[i2]);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && $5e44c3fe32d2063c$var$Support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $5e44c3fe32d2063c$var$removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && $5e44c3fe32d2063c$var$Support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $5e44c3fe32d2063c$var$removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
var $5e44c3fe32d2063c$var$manipulation = {
    appendSlide: $5e44c3fe32d2063c$var$appendSlide,
    prependSlide: $5e44c3fe32d2063c$var$prependSlide,
    addSlide: $5e44c3fe32d2063c$var$addSlide,
    removeSlide: $5e44c3fe32d2063c$var$removeSlide,
    removeAllSlides: $5e44c3fe32d2063c$var$removeAllSlides
};
var $5e44c3fe32d2063c$var$Device = function Device() {
    var ua = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent;
    var device = {
        ios: false,
        android: false,
        androidChrome: false,
        desktop: false,
        windows: false,
        iphone: false,
        ipod: false,
        ipad: false,
        cordova: (0, $493f762f30aff8bc$export$8291e5b88f90ce4).cordova || (0, $493f762f30aff8bc$export$8291e5b88f90ce4).phonegap,
        phonegap: (0, $493f762f30aff8bc$export$8291e5b88f90ce4).cordova || (0, $493f762f30aff8bc$export$8291e5b88f90ce4).phonegap
    };
    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    // Windows
    if (windows) {
        device.os = "windows";
        device.osVersion = windows[2];
        device.windows = true;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf("chrome") >= 0;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, ".");
        device.iphone = true;
    }
    if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, ".");
        device.ipad = true;
    }
    if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, ".") : null;
        device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf("Version/") >= 0) {
        if (device.osVersion.split(".")[0] === "10") device.osVersion = ua.toLowerCase().split("version/")[1].split(" ")[0];
    }
    // Desktop
    device.desktop = !(device.os || device.android || device.webView);
    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
    // Minimal UI
    if (device.os && device.os === "ios") {
        var osVersionArr = device.osVersion.split(".");
        var metaViewport = (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).querySelector('meta[name="viewport"]');
        device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute("content").indexOf("minimal-ui") >= 0;
    }
    // Pixel Ratio
    device.pixelRatio = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).devicePixelRatio || 1;
    // Export object
    return device;
}();
function $5e44c3fe32d2063c$var$onTouchStart(event) {
    var swiper = this;
    var _$data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    _$data.isTouchEvent = e.type === "touchstart";
    if (!_$data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!_$data.isTouchEvent && "button" in e && e.button > 0) return;
    if (_$data.isTouched && _$data.isMoved) return;
    if (params.noSwiping && (0, $lQE57.$)(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass))[0]) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!(0, $lQE57.$)(e).closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= (0, $493f762f30aff8bc$export$8291e5b88f90ce4).screen.width - edgeSwipeThreshold)) return;
    $5e44c3fe32d2063c$var$Utils.extend(_$data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    _$data.touchStartTime = $5e44c3fe32d2063c$var$Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) _$data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        var preventDefault = true;
        if ((0, $lQE57.$)(e.target).is(_$data.formElements)) preventDefault = false;
        if ((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement && (0, $lQE57.$)((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement).is(_$data.formElements) && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement !== e.target) (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement.blur();
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if (params.touchStartForcePreventDefault || shouldPreventDefault) e.preventDefault();
    }
    swiper.emit("touchStart", e);
}
function $5e44c3fe32d2063c$var$onTouchMove(event) {
    var swiper = this;
    var _$data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!_$data.isTouched) {
        if (_$data.startMoving && _$data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (_$data.isTouchEvent && e.type === "mousemove") return;
    var pageX = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (_$data.isTouched) {
            $5e44c3fe32d2063c$var$Utils.extend(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            _$data.touchStartTime = $5e44c3fe32d2063c$var$Utils.now();
        }
        return;
    }
    if (_$data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                _$data.isTouched = false;
                _$data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (_$data.isTouchEvent && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement) {
        if (e.target === (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement && (0, $lQE57.$)(e.target).is(_$data.formElements)) {
            _$data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (_$data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof _$data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) _$data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            _$data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (_$data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof _$data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) _$data.startMoving = true;
    }
    if (_$data.isScrolling) {
        _$data.isTouched = false;
        return;
    }
    if (!_$data.startMoving) return;
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!_$data.isMoved) {
        if (params.loop) swiper.loopFix();
        _$data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        _$data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    _$data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    _$data.currentTranslate = diff + _$data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && _$data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) _$data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + _$data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && _$data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) _$data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - _$data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && _$data.currentTranslate < _$data.startTranslate) _$data.currentTranslate = _$data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && _$data.currentTranslate > _$data.startTranslate) _$data.currentTranslate = _$data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || _$data.allowThresholdMove) {
            if (!_$data.allowThresholdMove) {
                _$data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                _$data.currentTranslate = _$data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            _$data.currentTranslate = _$data.startTranslate;
            return;
        }
    }
    if (!params.followFinger) return;
    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
        // Velocity
        if (_$data.velocities.length === 0) _$data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: _$data.touchStartTime
        });
        _$data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: $5e44c3fe32d2063c$var$Utils.now()
        });
    }
    // Update progress
    swiper.updateProgress(_$data.currentTranslate);
    // Update translate
    swiper.setTranslate(_$data.currentTranslate);
}
function $5e44c3fe32d2063c$var$onTouchEnd(event) {
    var swiper = this;
    var _$data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, $wrapperEl = swiper.$wrapperEl, slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (_$data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    _$data.allowTouchCallbacks = false;
    if (!_$data.isTouched) {
        if (_$data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        _$data.isMoved = false;
        _$data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && _$data.isMoved && _$data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = $5e44c3fe32d2063c$var$Utils.now();
    var timeDiff = touchEndTime - _$data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit("tap", e);
        if (timeDiff < 300 && touchEndTime - _$data.lastClickTime > 300) {
            if (_$data.clickTimeout) clearTimeout(_$data.clickTimeout);
            _$data.clickTimeout = $5e44c3fe32d2063c$var$Utils.nextTick(function() {
                if (!swiper || swiper.destroyed) return;
                swiper.emit("click", e);
            }, 300);
        }
        if (timeDiff < 300 && touchEndTime - _$data.lastClickTime < 300) {
            if (_$data.clickTimeout) clearTimeout(_$data.clickTimeout);
            swiper.emit("doubleTap", e);
        }
    }
    _$data.lastClickTime = $5e44c3fe32d2063c$var$Utils.now();
    $5e44c3fe32d2063c$var$Utils.nextTick(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!_$data.isTouched || !_$data.isMoved || !swiper.swipeDirection || touches.diff === 0 || _$data.currentTranslate === _$data.startTranslate) {
        _$data.isTouched = false;
        _$data.isMoved = false;
        _$data.startMoving = false;
        return;
    }
    _$data.isTouched = false;
    _$data.isMoved = false;
    _$data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -_$data.currentTranslate;
    if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeModeMomentum) {
            if (_$data.velocities.length > 1) {
                var lastMoveEvent = _$data.velocities.pop();
                var velocityEvent = _$data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || $5e44c3fe32d2063c$var$Utils.now() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeModeMomentumVelocityRatio;
            _$data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeModeMomentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    _$data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    _$data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeModeSticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) swiper.once("transitionEnd", function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
            } else if (params.freeModeSticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeModeMomentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !_$data.allowMomentumBounce) return;
                    swiper.emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    swiper.setTranslate(afterBouncePosition);
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                });
            } else if (swiper.velocity) {
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
        }
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        return;
    }
    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += params.slidesPerGroup){
        if (typeof slidesGrid[i + params.slidesPerGroup] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
                stopIndex = i;
                groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") swiper.slideTo(stopIndex + params.slidesPerGroup);
        if (swiper.swipeDirection === "prev") swiper.slideTo(stopIndex);
    }
}
function $5e44c3fe32d2063c$var$onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    if (params.freeMode) {
        var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (params.autoHeight) swiper.updateAutoHeight();
    } else {
        swiper.updateSlidesClasses();
        if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        else swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $5e44c3fe32d2063c$var$onClick(e) {
    var swiper = this;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $5e44c3fe32d2063c$var$attachEvents() {
    var swiper = this;
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl;
    swiper.onTouchStart = $5e44c3fe32d2063c$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $5e44c3fe32d2063c$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $5e44c3fe32d2063c$var$onTouchEnd.bind(swiper);
    swiper.onClick = $5e44c3fe32d2063c$var$onClick.bind(swiper);
    var target = params.touchEventsTarget === "container" ? el : wrapperEl;
    var capture = !!params.nested;
    if (!$5e44c3fe32d2063c$var$Support.touch && ($5e44c3fe32d2063c$var$Support.pointerEvents || $5e44c3fe32d2063c$var$Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if ($5e44c3fe32d2063c$var$Support.touch) {
            var passiveListener = touchEvents.start === "touchstart" && $5e44c3fe32d2063c$var$Support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            target.addEventListener(touchEvents.move, swiper.onTouchMove, $5e44c3fe32d2063c$var$Support.passiveListener ? {
                passive: false,
                capture: capture
            } : capture);
            target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !$5e44c3fe32d2063c$var$Device.ios && !$5e44c3fe32d2063c$var$Device.android || params.simulateTouch && !$5e44c3fe32d2063c$var$Support.touch && $5e44c3fe32d2063c$var$Device.ios) {
            target.addEventListener("mousedown", swiper.onTouchStart, false);
            (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).addEventListener("mousemove", swiper.onTouchMove, capture);
            (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).addEventListener("mouseup", swiper.onTouchEnd, false);
        }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) target.addEventListener("click", swiper.onClick, true);
    // Resize handler
    swiper.on($5e44c3fe32d2063c$var$Device.ios || $5e44c3fe32d2063c$var$Device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $5e44c3fe32d2063c$var$onResize, true);
}
function $5e44c3fe32d2063c$var$detachEvents() {
    var swiper = this;
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl;
    var target = params.touchEventsTarget === "container" ? el : wrapperEl;
    var capture = !!params.nested;
    if (!$5e44c3fe32d2063c$var$Support.touch && ($5e44c3fe32d2063c$var$Support.pointerEvents || $5e44c3fe32d2063c$var$Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if ($5e44c3fe32d2063c$var$Support.touch) {
            var passiveListener = touchEvents.start === "onTouchStart" && $5e44c3fe32d2063c$var$Support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !$5e44c3fe32d2063c$var$Device.ios && !$5e44c3fe32d2063c$var$Device.android || params.simulateTouch && !$5e44c3fe32d2063c$var$Support.touch && $5e44c3fe32d2063c$var$Device.ios) {
            target.removeEventListener("mousedown", swiper.onTouchStart, false);
            (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).removeEventListener("mousemove", swiper.onTouchMove, capture);
            (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).removeEventListener("mouseup", swiper.onTouchEnd, false);
        }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) target.removeEventListener("click", swiper.onClick, true);
    // Resize handler
    swiper.off($5e44c3fe32d2063c$var$Device.ios || $5e44c3fe32d2063c$var$Device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $5e44c3fe32d2063c$var$onResize);
}
var $5e44c3fe32d2063c$var$events = {
    attachEvents: $5e44c3fe32d2063c$var$attachEvents,
    detachEvents: $5e44c3fe32d2063c$var$detachEvents
};
function $5e44c3fe32d2063c$var$setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _swiper_loopedSlides = swiper.loopedSlides, loopedSlides = _swiper_loopedSlides === void 0 ? 0 : _swiper_loopedSlides, params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);
    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
        var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
        if (breakpointOnlyParams) [
            "slidesPerView",
            "spaceBetween",
            "slidesPerGroup"
        ].forEach(function(param) {
            var paramValue = breakpointOnlyParams[param];
            if (typeof paramValue === "undefined") return;
            if (param === "slidesPerView" && (paramValue === "AUTO" || paramValue === "auto")) breakpointOnlyParams[param] = "auto";
            else if (param === "slidesPerView") breakpointOnlyParams[param] = parseFloat(paramValue);
            else breakpointOnlyParams[param] = parseInt(paramValue, 10);
        });
        var breakpointParams = breakpointOnlyParams || swiper.originalParams;
        var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
        var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
        if (directionChanged && initialized) swiper.changeDirection();
        $5e44c3fe32d2063c$var$Utils.extend(swiper.params, breakpointParams);
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            allowTouchMove: swiper.params.allowTouchMove,
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev
        });
        swiper.currentBreakpoint = breakpoint;
        if (needsReLoop && initialized) {
            swiper.loopDestroy();
            swiper.loopCreate();
            swiper.updateSlides();
            swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
        }
        swiper.emit("breakpoint", breakpointParams);
    }
}
function $5e44c3fe32d2063c$var$getBreakpoint(breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) return undefined;
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function(point) {
        points.push(point);
    });
    points.sort(function(a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var point = points[i];
        if (swiper.params.breakpointsInverse) {
            if (point <= (0, $493f762f30aff8bc$export$8291e5b88f90ce4).innerWidth) breakpoint = point;
        } else if (point >= (0, $493f762f30aff8bc$export$8291e5b88f90ce4).innerWidth && !breakpoint) breakpoint = point;
    }
    return breakpoint || "max";
}
var $5e44c3fe32d2063c$var$breakpoints = {
    setBreakpoint: $5e44c3fe32d2063c$var$setBreakpoint,
    getBreakpoint: $5e44c3fe32d2063c$var$getBreakpoint
};
function $5e44c3fe32d2063c$var$addClasses() {
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el;
    var suffixes = [];
    suffixes.push("initialized");
    suffixes.push(params.direction);
    if (params.freeMode) suffixes.push("free-mode");
    if (!$5e44c3fe32d2063c$var$Support.flexbox) suffixes.push("no-flexbox");
    if (params.autoHeight) suffixes.push("autoheight");
    if (rtl) suffixes.push("rtl");
    if (params.slidesPerColumn > 1) suffixes.push("multirow");
    if ($5e44c3fe32d2063c$var$Device.android) suffixes.push("android");
    if ($5e44c3fe32d2063c$var$Device.ios) suffixes.push("ios");
    // WP8 Touch Events Fix
    if (($5e44c3fe32d2063c$var$Browser.isIE || $5e44c3fe32d2063c$var$Browser.isEdge) && ($5e44c3fe32d2063c$var$Support.pointerEvents || $5e44c3fe32d2063c$var$Support.prefixedPointerEvents)) suffixes.push("wp8-".concat(params.direction));
    suffixes.forEach(function(suffix) {
        classNames.push(params.containerModifierClass + suffix);
    });
    $el.addClass(classNames.join(" "));
}
function $5e44c3fe32d2063c$var$removeClasses() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(" "));
}
var $5e44c3fe32d2063c$var$classes = {
    addClasses: $5e44c3fe32d2063c$var$addClasses,
    removeClasses: $5e44c3fe32d2063c$var$removeClasses
};
function $5e44c3fe32d2063c$var$loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
        if (callback) callback();
    }
    if (!imageEl.complete || !checkForComplete) {
        if (src) {
            image = new (0, $493f762f30aff8bc$export$8291e5b88f90ce4).Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}
function $5e44c3fe32d2063c$var$preloadImages() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}
var $5e44c3fe32d2063c$var$images = {
    loadImage: $5e44c3fe32d2063c$var$loadImage,
    preloadImages: $5e44c3fe32d2063c$var$preloadImages
};
function $5e44c3fe32d2063c$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;
    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;
    // events
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
    if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        swiper.navigation.update();
    }
}
var $5e44c3fe32d2063c$var$checkOverflow$1 = {
    checkOverflow: $5e44c3fe32d2063c$var$checkOverflow
};
var $5e44c3fe32d2063c$var$defaults = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "container",
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,
    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: "column",
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: "swiper-container-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true
};
/* eslint no-param-reassign: "off" */ var $5e44c3fe32d2063c$var$prototypes = {
    update: $5e44c3fe32d2063c$var$update,
    translate: $5e44c3fe32d2063c$var$translate,
    transition: $5e44c3fe32d2063c$var$transition,
    slide: $5e44c3fe32d2063c$var$slide,
    loop: $5e44c3fe32d2063c$var$loop,
    grabCursor: $5e44c3fe32d2063c$var$grabCursor,
    manipulation: $5e44c3fe32d2063c$var$manipulation,
    events: $5e44c3fe32d2063c$var$events,
    breakpoints: $5e44c3fe32d2063c$var$breakpoints,
    checkOverflow: $5e44c3fe32d2063c$var$checkOverflow$1,
    classes: $5e44c3fe32d2063c$var$classes,
    images: $5e44c3fe32d2063c$var$images
};
var $5e44c3fe32d2063c$var$extendedDefaults = {};
var $5e44c3fe32d2063c$var$Swiper = /*#__PURE__*/ function(SwiperClass1) {
    "use strict";
    (0, $346e2f3a84730f45$export$7e4530ad35d3bb8)(Swiper, SwiperClass1);
    var _super = (0, $521c51dabf7c315d$export$8dd05c13f5255580)(Swiper);
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $2yCSJ._)(this, Swiper);
        var _this;
        var el;
        var params;
        var ref;
        if (args.length === 1 && args[0].constructor && args[0].constructor === Object) params = args[0];
        else ref = (0, $59ZDq._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = $5e44c3fe32d2063c$var$Utils.extend({}, params);
        if (el && !params.el) params.el = el;
        _this = _super.call(this, params);
        Object.keys($5e44c3fe32d2063c$var$prototypes).forEach(function(prototypeGroup) {
            Object.keys($5e44c3fe32d2063c$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
                if (!Swiper.prototype[protoMethod]) Swiper.prototype[protoMethod] = $5e44c3fe32d2063c$var$prototypes[prototypeGroup][protoMethod];
            });
        });
        // Swiper Instance
        var swiper = (0, $f2d4454c65effdb1$export$f3b8ed2e4a5d10b8)(_this);
        if (typeof swiper.modules === "undefined") swiper.modules = {};
        Object.keys(swiper.modules).forEach(function(moduleName) {
            var module = swiper.modules[moduleName];
            if (module.params) {
                var moduleParamName = Object.keys(module.params)[0];
                var moduleParams = module.params[moduleParamName];
                if (typeof moduleParams !== "object" || moduleParams === null) return;
                if (!(moduleParamName in params && "enabled" in moduleParams)) return;
                if (params[moduleParamName] === true) params[moduleParamName] = {
                    enabled: true
                };
                if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
                if (!params[moduleParamName]) params[moduleParamName] = {
                    enabled: false
                };
            }
        });
        // Extend defaults with modules params
        var swiperParams = $5e44c3fe32d2063c$var$Utils.extend({}, $5e44c3fe32d2063c$var$defaults);
        swiper.useModulesParams(swiperParams);
        // Extend defaults with passed params
        swiper.params = $5e44c3fe32d2063c$var$Utils.extend({}, swiperParams, $5e44c3fe32d2063c$var$extendedDefaults, params);
        swiper.originalParams = $5e44c3fe32d2063c$var$Utils.extend({}, swiper.params);
        swiper.passedParams = $5e44c3fe32d2063c$var$Utils.extend({}, params);
        // Save Dom lib
        swiper.$ = (0, $lQE57.$);
        // Find el
        var $el = (0, $lQE57.$)(swiper.params.el);
        el = $el[0];
        if (!el) return (0, $283ca50bf5310286$export$ef97c660ca164e52)(_this, undefined);
        if ($el.length > 1) {
            var swipers = [];
            $el.each(function(index, containerEl) {
                var newParams = $5e44c3fe32d2063c$var$Utils.extend({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return (0, $283ca50bf5310286$export$ef97c660ca164e52)(_this, swipers);
        }
        el.swiper = swiper;
        $el.data("swiper", swiper);
        // Find Wrapper
        var $wrapperEl = $el.children(".".concat(swiper.params.wrapperClass));
        // Extend Swiper
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            // Classes
            classNames: [],
            // Slides
            slides: (0, $lQE57.$)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function() {
                return swiper.params.direction === "vertical";
            },
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box",
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    "touchstart",
                    "touchmove",
                    "touchend"
                ];
                var desktop = [
                    "mousedown",
                    "mousemove",
                    "mouseup"
                ];
                if ($5e44c3fe32d2063c$var$Support.pointerEvents) desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                else if ($5e44c3fe32d2063c$var$Support.prefixedPointerEvents) desktop = [
                    "MSPointerDown",
                    "MSPointerMove",
                    "MSPointerUp"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return $5e44c3fe32d2063c$var$Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                formElements: "input, select, option, textarea, button, video",
                // Last click time
                lastClickTime: $5e44c3fe32d2063c$var$Utils.now(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        // Install Modules
        swiper.useModules();
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        return (0, $283ca50bf5310286$export$ef97c660ca164e52)(_this, swiper);
    }
    (0, $80pZ5._)(Swiper, [
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex].swiperSlideSize;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += slides[i].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1)if (slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize) spv += 1;
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (swiper.params.freeMode) {
                    setTranslate();
                    if (swiper.params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
                    else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
                swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection, " wp8-").concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
                if (($5e44c3fe32d2063c$var$Browser.isIE || $5e44c3fe32d2063c$var$Browser.isEdge) && ($5e44c3fe32d2063c$var$Support.pointerEvents || $5e44c3fe32d2063c$var$Support.prefixedPointerEvents)) swiper.$el.addClass("".concat(swiper.params.containerModifierClass, "wp8-").concat(newDirection));
                swiper.params.direction = newDirection;
                swiper.slides.each(function(slideIndex, slideEl) {
                    if (newDirection === "vertical") slideEl.style.width = "";
                    else slideEl.style.height = "";
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "init",
            value: function init() {
                var swiper = this;
                if (swiper.initialized) return;
                swiper.emit("beforeInit");
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                if (swiper.params.preloadImages) swiper.preloadImages();
                // Slide To Initial Slide
                if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
                // Attach events
                swiper.attachEvents();
                // Init Flag
                swiper.initialized = true;
                // Emit
                swiper.emit("init");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
                swiper.emit("beforeDestroy");
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    $el.removeAttr("style");
                    $wrapperEl.removeAttr("style");
                    if (slides && slides.length) slides.removeClass([
                        params.slideVisibleClass,
                        params.slideActiveClass,
                        params.slideNextClass,
                        params.slidePrevClass
                    ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row");
                }
                swiper.emit("destroy");
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.$el[0].swiper = null;
                    swiper.$el.data("swiper", null);
                    $5e44c3fe32d2063c$var$Utils.deleteProps(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                $5e44c3fe32d2063c$var$Utils.extend($5e44c3fe32d2063c$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $5e44c3fe32d2063c$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $5e44c3fe32d2063c$var$defaults;
            }
        },
        {
            key: "Class",
            get: function get() {
                return $5e44c3fe32d2063c$var$SwiperClass;
            }
        },
        {
            key: "$",
            get: function get() {
                return 0, $lQE57.$;
            }
        }
    ]);
    return Swiper;
}($5e44c3fe32d2063c$var$SwiperClass);
var $5e44c3fe32d2063c$var$Device$1 = {
    name: "device",
    proto: {
        device: $5e44c3fe32d2063c$var$Device
    },
    static: {
        device: $5e44c3fe32d2063c$var$Device
    }
};
var $5e44c3fe32d2063c$var$Support$1 = {
    name: "support",
    proto: {
        support: $5e44c3fe32d2063c$var$Support
    },
    static: {
        support: $5e44c3fe32d2063c$var$Support
    }
};
var $5e44c3fe32d2063c$var$Browser$1 = {
    name: "browser",
    proto: {
        browser: $5e44c3fe32d2063c$var$Browser
    },
    static: {
        browser: $5e44c3fe32d2063c$var$Browser
    }
};
var $5e44c3fe32d2063c$var$Resize = {
    name: "resize",
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            resize: {
                resizeHandler: function() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit("beforeResize");
                    swiper.emit("resize");
                },
                orientationChangeHandler: function() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit("orientationchange");
                }
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            // Emit resize
            (0, $493f762f30aff8bc$export$8291e5b88f90ce4).addEventListener("resize", swiper.resize.resizeHandler);
            // Emit orientationchange
            (0, $493f762f30aff8bc$export$8291e5b88f90ce4).addEventListener("orientationchange", swiper.resize.orientationChangeHandler);
        },
        destroy: function() {
            var swiper = this;
            (0, $493f762f30aff8bc$export$8291e5b88f90ce4).removeEventListener("resize", swiper.resize.resizeHandler);
            (0, $493f762f30aff8bc$export$8291e5b88f90ce4).removeEventListener("orientationchange", swiper.resize.orientationChangeHandler);
        }
    }
};
var $5e44c3fe32d2063c$var$Observer = {
    func: (0, $493f762f30aff8bc$export$8291e5b88f90ce4).MutationObserver || (0, $493f762f30aff8bc$export$8291e5b88f90ce4).WebkitMutationObserver,
    attach: function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var swiper = this;
        var ObserverFunc = $5e44c3fe32d2063c$var$Observer.func;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                swiper.emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                swiper.emit("observerUpdate", mutations[0]);
            };
            if ((0, $493f762f30aff8bc$export$8291e5b88f90ce4).requestAnimationFrame) (0, $493f762f30aff8bc$export$8291e5b88f90ce4).requestAnimationFrame(observerUpdate);
            else (0, $493f762f30aff8bc$export$8291e5b88f90ce4).setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
    },
    init: function() {
        var swiper = this;
        if (!$5e44c3fe32d2063c$var$Support.observer || !swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1)swiper.observer.attach(containerParents[i]);
        }
        // Observe container
        swiper.observer.attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    },
    destroy: function() {
        var swiper = this;
        swiper.observer.observers.forEach(function(observer) {
            observer.disconnect();
        });
        swiper.observer.observers = [];
    }
};
var $5e44c3fe32d2063c$var$Observer$1 = {
    name: "observer",
    params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            observer: {
                init: $5e44c3fe32d2063c$var$Observer.init.bind(swiper),
                attach: $5e44c3fe32d2063c$var$Observer.attach.bind(swiper),
                destroy: $5e44c3fe32d2063c$var$Observer.destroy.bind(swiper),
                observers: []
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            swiper.observer.init();
        },
        destroy: function() {
            var swiper = this;
            swiper.observer.destroy();
        }
    }
};
var $5e44c3fe32d2063c$var$Virtual = {
    update: function(force) {
        var swiper = this;
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, renderSlide = _swiper_virtual.renderSlide, previousOffset = _swiper_virtual.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
            slidesBefore = slidesPerGroup + addSlidesAfter;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var _$offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        $5e44c3fe32d2063c$var$Utils.extend(swiper.virtual, {
            from: from,
            to: to,
            offset: _$offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && _$offset !== previousOffset) swiper.slides.css(offsetProp, "".concat(_$offset, "px"));
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: _$offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            onRendered();
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(i, '"]')).remove();
        }
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (i1 >= from && i1 <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i1);
            else {
                if (i1 > previousTo) appendIndexes.push(i1);
                if (i1 < previousFrom) prependIndexes.push(i1);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function(a, b) {
            return b - a;
        }).forEach(function(index) {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, "".concat(_$offset, "px"));
        onRendered();
    },
    renderSlide: function(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        var $slideEl = params.renderSlide ? (0, $lQE57.$)(params.renderSlide.call(swiper, slide, index)) : (0, $lQE57.$)('<div class="'.concat(swiper.params.slideClass, '" data-swiper-slide-index="').concat(index, '">').concat(slide, "</div>"));
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    },
    appendSlide: function(slides) {
        var swiper = this;
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        swiper.virtual.update(true);
    },
    prependSlide: function(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
            });
            swiper.virtual.cache = newCache;
        }
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function(slidesIndexes) {
        var swiper = this;
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function() {
        var swiper = this;
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
    }
};
var $5e44c3fe32d2063c$var$Virtual$1 = {
    name: "virtual",
    params: {
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            virtual: {
                update: $5e44c3fe32d2063c$var$Virtual.update.bind(swiper),
                appendSlide: $5e44c3fe32d2063c$var$Virtual.appendSlide.bind(swiper),
                prependSlide: $5e44c3fe32d2063c$var$Virtual.prependSlide.bind(swiper),
                removeSlide: $5e44c3fe32d2063c$var$Virtual.removeSlide.bind(swiper),
                removeAllSlides: $5e44c3fe32d2063c$var$Virtual.removeAllSlides.bind(swiper),
                renderSlide: $5e44c3fe32d2063c$var$Virtual.renderSlide.bind(swiper),
                slides: swiper.params.virtual.slides,
                cache: {}
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (!swiper.params.virtual.enabled) return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
            var overwriteParams = {
                watchSlidesProgress: true
            };
            $5e44c3fe32d2063c$var$Utils.extend(swiper.params, overwriteParams);
            $5e44c3fe32d2063c$var$Utils.extend(swiper.originalParams, overwriteParams);
            if (!swiper.params.initialSlide) swiper.virtual.update();
        },
        setTranslate: function() {
            var swiper = this;
            if (!swiper.params.virtual.enabled) return;
            swiper.virtual.update();
        }
    }
};
var $5e44c3fe32d2063c$var$Keyboard = {
    handle: function(event) {
        var swiper = this;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40 || kc === 34)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38 || kc === 33)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if ((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement.nodeName && ((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement.nodeName.toLowerCase() === "input" || (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var windowWidth = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).innerWidth;
            var windowHeight = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).innerHeight;
            var swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiper.width,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiper.height
                ],
                [
                    swiperOffset.left + swiper.width,
                    swiperOffset.top + swiper.height
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) inView = true;
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((kc === 34 || kc === 39) && !rtl || (kc === 33 || kc === 37) && rtl) swiper.slideNext();
            if ((kc === 33 || kc === 37) && !rtl || (kc === 34 || kc === 39) && rtl) swiper.slidePrev();
        } else {
            if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (kc === 34 || kc === 40) swiper.slideNext();
            if (kc === 33 || kc === 38) swiper.slidePrev();
        }
        swiper.emit("keyPress", kc);
        return undefined;
    },
    enable: function() {
        var swiper = this;
        if (swiper.keyboard.enabled) return;
        (0, $lQE57.$)((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1)).on("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
    },
    disable: function() {
        var swiper = this;
        if (!swiper.keyboard.enabled) return;
        (0, $lQE57.$)((0, $493f762f30aff8bc$export$5a7bfc01df82fcd1)).off("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
    }
};
var $5e44c3fe32d2063c$var$Keyboard$1 = {
    name: "keyboard",
    params: {
        keyboard: {
            enabled: false,
            onlyInViewport: true
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            keyboard: {
                enabled: false,
                enable: $5e44c3fe32d2063c$var$Keyboard.enable.bind(swiper),
                disable: $5e44c3fe32d2063c$var$Keyboard.disable.bind(swiper),
                handle: $5e44c3fe32d2063c$var$Keyboard.handle.bind(swiper)
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (swiper.params.keyboard.enabled) swiper.keyboard.enable();
        },
        destroy: function() {
            var swiper = this;
            if (swiper.keyboard.enabled) swiper.keyboard.disable();
        }
    }
};
function $5e44c3fe32d2063c$var$isEventSupported() {
    var eventName = "onwheel";
    var isSupported = eventName in (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1);
    if (!isSupported) {
        var element = (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).createElement("div");
        element.setAttribute(eventName, "return;");
        isSupported = typeof element[eventName] === "function";
    }
    if (!isSupported && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).implementation && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).implementation.hasFeature && (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).implementation.hasFeature("", "") !== true) // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).implementation.hasFeature("Events.wheel", "3.0");
    return isSupported;
}
var $5e44c3fe32d2063c$var$Mousewheel = {
    lastScrollTime: $5e44c3fe32d2063c$var$Utils.now(),
    event: function getEvent() {
        if ((0, $493f762f30aff8bc$export$8291e5b88f90ce4).navigator.userAgent.indexOf("firefox") > -1) return "DOMMouseScroll";
        return $5e44c3fe32d2063c$var$isEventSupported() ? "wheel" : "mousewheel";
    }(),
    normalize: function(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    },
    handleMouseEnter: function() {
        var swiper = this;
        swiper.mouseEntered = true;
    },
    handleMouseLeave: function() {
        var swiper = this;
        swiper.mouseEntered = false;
    },
    handle: function(event) {
        var e = event;
        var swiper = this;
        var params = swiper.params.mousewheel;
        if (!swiper.mouseEntered && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var _$data = $5e44c3fe32d2063c$var$Mousewheel.normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(_$data.pixelX) > Math.abs(_$data.pixelY)) delta = _$data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(_$data.pixelY) > Math.abs(_$data.pixelX)) delta = _$data.pixelY;
            else return true;
        } else delta = Math.abs(_$data.pixelX) > Math.abs(_$data.pixelY) ? -_$data.pixelX * rtlFactor : -_$data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        if (!swiper.params.freeMode) {
            if ($5e44c3fe32d2063c$var$Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
                if (delta < 0) {
                    if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                        swiper.slideNext();
                        swiper.emit("scroll", e);
                    } else if (params.releaseOnEdges) return true;
                } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
                    swiper.slidePrev();
                    swiper.emit("scroll", e);
                } else if (params.releaseOnEdges) return true;
            }
            swiper.mousewheel.lastScrollTime = new (0, $493f762f30aff8bc$export$8291e5b88f90ce4).Date().getTime();
        } else {
            // Freemode or scrollContainer:
            if (swiper.params.loop) swiper.loopFix();
            var position = swiper.getTranslate() + delta * params.sensitivity;
            var wasBeginning = swiper.isBeginning;
            var wasEnd = swiper.isEnd;
            if (position >= swiper.minTranslate()) position = swiper.minTranslate();
            if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
            swiper.setTransition(0);
            swiper.setTranslate(position);
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
            if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
            if (swiper.params.freeModeSticky) {
                clearTimeout(swiper.mousewheel.timeout);
                swiper.mousewheel.timeout = $5e44c3fe32d2063c$var$Utils.nextTick(function() {
                    swiper.slideToClosest();
                }, 300);
            }
            // Emit event
            swiper.emit("scroll", e);
            // Stop autoplay
            if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
            // Return page scroll on edge positions
            if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    },
    enable: function() {
        var swiper = this;
        if (!$5e44c3fe32d2063c$var$Mousewheel.event) return false;
        if (swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") target = (0, $lQE57.$)(swiper.params.mousewheel.eventsTarged);
        target.on("mouseenter", swiper.mousewheel.handleMouseEnter);
        target.on("mouseleave", swiper.mousewheel.handleMouseLeave);
        target.on($5e44c3fe32d2063c$var$Mousewheel.event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
    },
    disable: function() {
        var swiper = this;
        if (!$5e44c3fe32d2063c$var$Mousewheel.event) return false;
        if (!swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") target = (0, $lQE57.$)(swiper.params.mousewheel.eventsTarged);
        target.off($5e44c3fe32d2063c$var$Mousewheel.event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
    }
};
var $5e44c3fe32d2063c$var$Mousewheel$1 = {
    name: "mousewheel",
    params: {
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarged: "container"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            mousewheel: {
                enabled: false,
                enable: $5e44c3fe32d2063c$var$Mousewheel.enable.bind(swiper),
                disable: $5e44c3fe32d2063c$var$Mousewheel.disable.bind(swiper),
                handle: $5e44c3fe32d2063c$var$Mousewheel.handle.bind(swiper),
                handleMouseEnter: $5e44c3fe32d2063c$var$Mousewheel.handleMouseEnter.bind(swiper),
                handleMouseLeave: $5e44c3fe32d2063c$var$Mousewheel.handleMouseLeave.bind(swiper),
                lastScrollTime: $5e44c3fe32d2063c$var$Utils.now()
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
        },
        destroy: function() {
            var swiper = this;
            if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        }
    }
};
var $5e44c3fe32d2063c$var$Navigation = {
    update: function() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        if (swiper.params.loop) return;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) $prevEl.addClass(params.disabledClass);
            else $prevEl.removeClass(params.disabledClass);
            $prevEl[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) $nextEl.addClass(params.disabledClass);
            else $nextEl.removeClass(params.disabledClass);
            $nextEl[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    },
    onPrevClick: function(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
    },
    onNextClick: function(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
    },
    init: function() {
        var swiper = this;
        var params = swiper.params.navigation;
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl;
        var $prevEl;
        if (params.nextEl) {
            $nextEl = (0, $lQE57.$)(params.nextEl);
            if (swiper.params.uniqueNavElements && typeof params.nextEl === "string" && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) $nextEl = swiper.$el.find(params.nextEl);
        }
        if (params.prevEl) {
            $prevEl = (0, $lQE57.$)(params.prevEl);
            if (swiper.params.uniqueNavElements && typeof params.prevEl === "string" && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) $prevEl = swiper.$el.find(params.prevEl);
        }
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", swiper.navigation.onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", swiper.navigation.onPrevClick);
        $5e44c3fe32d2063c$var$Utils.extend(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
    },
    destroy: function() {
        var swiper = this;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", swiper.navigation.onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", swiper.navigation.onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
};
var $5e44c3fe32d2063c$var$Navigation$1 = {
    name: "navigation",
    params: {
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            navigation: {
                init: $5e44c3fe32d2063c$var$Navigation.init.bind(swiper),
                update: $5e44c3fe32d2063c$var$Navigation.update.bind(swiper),
                destroy: $5e44c3fe32d2063c$var$Navigation.destroy.bind(swiper),
                onNextClick: $5e44c3fe32d2063c$var$Navigation.onNextClick.bind(swiper),
                onPrevClick: $5e44c3fe32d2063c$var$Navigation.onPrevClick.bind(swiper)
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            swiper.navigation.init();
            swiper.navigation.update();
        },
        toEdge: function() {
            var swiper = this;
            swiper.navigation.update();
        },
        fromEdge: function() {
            var swiper = this;
            swiper.navigation.update();
        },
        destroy: function() {
            var swiper = this;
            swiper.navigation.destroy();
        },
        click: function(e) {
            var swiper = this;
            var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
            if (swiper.params.navigation.hideOnClick && !(0, $lQE57.$)(e.target).is($prevEl) && !(0, $lQE57.$)(e.target).is($nextEl)) {
                var isHidden;
                if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
                else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
                if (isHidden === true) swiper.emit("navigationShow", swiper);
                else swiper.emit("navigationHide", swiper);
                if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
                if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
        }
    }
};
var $5e44c3fe32d2063c$var$Pagination = {
    update: function() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", "".concat(swiper.pagination.bulletSize * (params.dynamicMainBullets + 4), "px"));
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
                    if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (swiper.pagination.dynamicBulletIndex < 0) swiper.pagination.dynamicBulletIndex = 0;
                }
                firstIndex = current - swiper.pagination.dynamicBulletIndex;
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass("".concat(params.bulletActiveClass, " ").concat(params.bulletActiveClass, "-next ").concat(params.bulletActiveClass, "-next-next ").concat(params.bulletActiveClass, "-prev ").concat(params.bulletActiveClass, "-prev-prev ").concat(params.bulletActiveClass, "-main"));
            if ($el.length > 1) bullets.each(function(index, bullet) {
                var $bullet = (0, $lQE57.$)(bullet);
                var bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
                    if (bulletIndex === firstIndex) $bullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
                    if (bulletIndex === lastIndex) $bullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
                }
            });
            else {
                var $bullet = bullets.eq(current);
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
                    $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
                    $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", "".concat(bulletsOffset, "px"));
            }
        }
        if (params.type === "fraction") {
            $el.find(".".concat(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find(".".concat(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            var progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find(".".concat(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            swiper.emit("paginationRender", swiper, $el[0]);
        } else swiper.emit("paginationUpdate", swiper, $el[0]);
        $el[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    },
    render: function() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += "<".concat(params.bulletElement, ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find(".".concat(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + " / " + '<span class="'.concat(params.totalClass, '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") swiper.emit("paginationRender", swiper.pagination.$el[0]);
    },
    init: function() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = (0, $lQE57.$)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && swiper.$el.find(params.el).length === 1) $el = swiper.$el.find(params.el);
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
            swiper.pagination.dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", ".".concat(params.bulletClass), function onClick(e) {
            e.preventDefault();
            var _$index = (0, $lQE57.$)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) _$index += swiper.loopedSlides;
            swiper.slideTo(_$index);
        });
        $5e44c3fe32d2063c$var$Utils.extend(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
    },
    destroy: function() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", ".".concat(params.bulletClass));
    }
};
var $5e44c3fe32d2063c$var$Pagination$1 = {
    name: "pagination",
    params: {
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            lockClass: "swiper-pagination-lock"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            pagination: {
                init: $5e44c3fe32d2063c$var$Pagination.init.bind(swiper),
                render: $5e44c3fe32d2063c$var$Pagination.render.bind(swiper),
                update: $5e44c3fe32d2063c$var$Pagination.update.bind(swiper),
                destroy: $5e44c3fe32d2063c$var$Pagination.destroy.bind(swiper),
                dynamicBulletIndex: 0
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        },
        activeIndexChange: function() {
            var swiper = this;
            if (swiper.params.loop) swiper.pagination.update();
            else if (typeof swiper.snapIndex === "undefined") swiper.pagination.update();
        },
        snapIndexChange: function() {
            var swiper = this;
            if (!swiper.params.loop) swiper.pagination.update();
        },
        slidesLengthChange: function() {
            var swiper = this;
            if (swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        snapGridLengthChange: function() {
            var swiper = this;
            if (!swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        destroy: function() {
            var swiper = this;
            swiper.pagination.destroy();
        },
        click: function(e) {
            var swiper = this;
            if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, $lQE57.$)(e.target).hasClass(swiper.params.pagination.bulletClass)) {
                var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
                if (isHidden === true) swiper.emit("paginationShow", swiper);
                else swiper.emit("paginationHide", swiper);
                swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
            }
        }
    }
};
var $5e44c3fe32d2063c$var$_obj;
var $5e44c3fe32d2063c$var$Scrollbar = ($5e44c3fe32d2063c$var$_obj = {
    setTranslate: function() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate, progress = swiper.progress;
        var dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            if ($5e44c3fe32d2063c$var$Support.transforms3d) $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
            else $dragEl.transform("translateX(".concat(newPos, "px)"));
            $dragEl[0].style.width = "".concat(newSize, "px");
        } else {
            if ($5e44c3fe32d2063c$var$Support.transforms3d) $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
            else $dragEl.transform("translateY(".concat(newPos, "px)"));
            $dragEl[0].style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.timeout);
            $el[0].style.opacity = 1;
            swiper.scrollbar.timeout = setTimeout(function() {
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    },
    setTransition: function(duration) {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = "".concat(dragSize, "px");
        else $dragEl[0].style.height = "".concat(dragSize, "px");
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        $5e44c3fe32d2063c$var$Utils.extend(scrollbar, {
            trackSize: trackSize,
            divider: divider,
            moveDivider: moveDivider,
            dragSize: dragSize
        });
        scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function(e) {
        var swiper = this;
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX || e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY || e.clientY;
    }
}, (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "setDragPosition", function(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar, rtl = swiper["rtlTranslate"];
    var $el = scrollbar.$el, dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, dragStartPos = scrollbar.dragStartPos;
    var positionRatio;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) positionRatio = 1 - positionRatio;
    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "onDragStart", function(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);
    clearTimeout(swiper.scrollbar.dragTimeout);
    $el.transition(0);
    if (params.hide) $el.css("opacity", 1);
    swiper.emit("scrollbarDragStart", e);
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "onDragMove", function(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();
    else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit("scrollbarDragMove", e);
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "onDragEnd", function(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar;
    var $el = scrollbar.$el;
    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;
    if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = $5e44c3fe32d2063c$var$Utils.nextTick(function() {
            $el.css("opacity", 0);
            $el.transition(400);
        }, 1000);
    }
    swiper.emit("scrollbarDragEnd", e);
    if (params.snapOnRelease) swiper.slideToClosest();
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "enableDraggable", function() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = $5e44c3fe32d2063c$var$Support.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
    } : false;
    var passiveListener = $5e44c3fe32d2063c$var$Support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
    } : false;
    if (!$5e44c3fe32d2063c$var$Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "disableDraggable", function() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = $5e44c3fe32d2063c$var$Support.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
    } : false;
    var passiveListener = $5e44c3fe32d2063c$var$Support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
    } : false;
    if (!$5e44c3fe32d2063c$var$Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "init", function() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar, $swiperEl = swiper.$el;
    var params = swiper.params.scrollbar;
    var $el = (0, $lQE57.$)(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
    var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));
    if ($dragEl.length === 0) {
        $dragEl = (0, $lQE57.$)('<div class="'.concat(swiper.params.scrollbar.dragClass, '"></div>'));
        $el.append($dragEl);
    }
    $5e44c3fe32d2063c$var$Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0]
    });
    if (params.draggable) scrollbar.enableDraggable();
}), (0, $ddmaO._)($5e44c3fe32d2063c$var$_obj, "destroy", function() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
}), $5e44c3fe32d2063c$var$_obj);
var $5e44c3fe32d2063c$var$Scrollbar$1 = {
    name: "scrollbar",
    params: {
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            scrollbar: {
                init: $5e44c3fe32d2063c$var$Scrollbar.init.bind(swiper),
                destroy: $5e44c3fe32d2063c$var$Scrollbar.destroy.bind(swiper),
                updateSize: $5e44c3fe32d2063c$var$Scrollbar.updateSize.bind(swiper),
                setTranslate: $5e44c3fe32d2063c$var$Scrollbar.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Scrollbar.setTransition.bind(swiper),
                enableDraggable: $5e44c3fe32d2063c$var$Scrollbar.enableDraggable.bind(swiper),
                disableDraggable: $5e44c3fe32d2063c$var$Scrollbar.disableDraggable.bind(swiper),
                setDragPosition: $5e44c3fe32d2063c$var$Scrollbar.setDragPosition.bind(swiper),
                getPointerPosition: $5e44c3fe32d2063c$var$Scrollbar.getPointerPosition.bind(swiper),
                onDragStart: $5e44c3fe32d2063c$var$Scrollbar.onDragStart.bind(swiper),
                onDragMove: $5e44c3fe32d2063c$var$Scrollbar.onDragMove.bind(swiper),
                onDragEnd: $5e44c3fe32d2063c$var$Scrollbar.onDragEnd.bind(swiper),
                isTouched: false,
                timeout: null,
                dragTimeout: null
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            swiper.scrollbar.init();
            swiper.scrollbar.updateSize();
            swiper.scrollbar.setTranslate();
        },
        update: function() {
            var swiper = this;
            swiper.scrollbar.updateSize();
        },
        resize: function() {
            var swiper = this;
            swiper.scrollbar.updateSize();
        },
        observerUpdate: function() {
            var swiper = this;
            swiper.scrollbar.updateSize();
        },
        setTranslate: function() {
            var swiper = this;
            swiper.scrollbar.setTranslate();
        },
        setTransition: function(duration) {
            var swiper = this;
            swiper.scrollbar.setTransition(duration);
        },
        destroy: function() {
            var swiper = this;
            swiper.scrollbar.destroy();
        }
    }
};
var $5e44c3fe32d2063c$var$Parallax = {
    setTransform: function(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = (0, $lQE57.$)(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr("data-swiper-parallax") || "0";
        var x = $el.attr("data-swiper-parallax-x");
        var y = $el.attr("data-swiper-parallax-y");
        var scale = $el.attr("data-swiper-parallax-scale");
        var opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf("%") >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
        else {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
        }
    },
    setTranslate: function() {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(index, el) {
            swiper.parallax.setTransform(el, progress);
        });
        slides.each(function(slideIndex, slideEl) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $lQE57.$)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(index, el) {
                swiper.parallax.setTransform(el, slideProgress);
            });
        });
    },
    setTransition: function() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed;
        var swiper = this;
        var $el = swiper.$el;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(index, parallaxEl) {
            var $parallaxEl = (0, $lQE57.$)(parallaxEl);
            var parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    }
};
var $5e44c3fe32d2063c$var$Parallax$1 = {
    name: "parallax",
    params: {
        parallax: {
            enabled: false
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            parallax: {
                setTransform: $5e44c3fe32d2063c$var$Parallax.setTransform.bind(swiper),
                setTranslate: $5e44c3fe32d2063c$var$Parallax.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Parallax.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        init: function() {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTranslate: function() {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTransition: function(duration) {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTransition(duration);
        }
    }
};
var $5e44c3fe32d2063c$var$Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    },
    // Events
    onGestureStart: function(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
        if (!$5e44c3fe32d2063c$var$Support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            zoom.fakeGestureTouched = true;
            gesture.scaleStart = $5e44c3fe32d2063c$var$Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $lQE57.$)(e.target).closest(".swiper-slide");
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas");
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        gesture.$imageEl.transition(0);
        swiper.zoom.isScaling = true;
    },
    onGestureChange: function(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!$5e44c3fe32d2063c$var$Support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            zoom.fakeGestureMoved = true;
            gesture.scaleMove = $5e44c3fe32d2063c$var$Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if ($5e44c3fe32d2063c$var$Support.gestures) zoom.scale = e.scale * zoom.currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    },
    onGestureEnd: function(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!$5e44c3fe32d2063c$var$Support.gestures) {
            if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !$5e44c3fe32d2063c$var$Device.android) return;
            zoom.fakeGestureTouched = false;
            zoom.fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    },
    onTouchStart: function(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if ($5e44c3fe32d2063c$var$Device.android) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = $5e44c3fe32d2063c$var$Utils.getTranslate(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = $5e44c3fe32d2063c$var$Utils.getTranslate(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
            if (swiper.rtl) {
                image.startX = -image.startX;
                image.startY = -image.startY;
            }
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !zoom.isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    },
    onTouchEnd: function() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    },
    onTransitionEnd: function() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            zoom.currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    },
    // Toggle Zoom
    toggle: function(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoom.out();
        else // Zoom In
        zoom.in(e);
    },
    in: function(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$slideEl) {
            gesture.$slideEl = swiper.clickedSlide ? (0, $lQE57.$)(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas");
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left;
            offsetY = gesture.$slideEl.offset().top;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    },
    out: function() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        if (!gesture.$slideEl) {
            gesture.$slideEl = swiper.clickedSlide ? (0, $lQE57.$)(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas");
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
        gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === "touchstart" && $5e44c3fe32d2063c$var$Support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        // Scale image
        if ($5e44c3fe32d2063c$var$Support.gestures) {
            swiper.$wrapperEl.on("gesturestart", ".swiper-slide", zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.on("gesturechange", ".swiper-slide", zoom.onGestureChange, passiveListener);
            swiper.$wrapperEl.on("gestureend", ".swiper-slide", zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, ".swiper-slide", zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, ".swiper-slide", zoom.onGestureChange, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, ".swiper-slide", zoom.onGestureEnd, passiveListener);
        }
        // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove);
    },
    disable: function() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === "touchstart" && $5e44c3fe32d2063c$var$Support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        // Scale image
        if ($5e44c3fe32d2063c$var$Support.gestures) {
            swiper.$wrapperEl.off("gesturestart", ".swiper-slide", zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.off("gesturechange", ".swiper-slide", zoom.onGestureChange, passiveListener);
            swiper.$wrapperEl.off("gestureend", ".swiper-slide", zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, ".swiper-slide", zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, ".swiper-slide", zoom.onGestureChange, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, ".swiper-slide", zoom.onGestureEnd, passiveListener);
        }
        // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove);
    }
};
var $5e44c3fe32d2063c$var$Zoom$1 = {
    name: "zoom",
    params: {
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    },
    create: function() {
        var swiper = this;
        var zoom = {
            enabled: false,
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
                $slideEl: undefined,
                slideWidth: undefined,
                slideHeight: undefined,
                $imageEl: undefined,
                $imageWrapEl: undefined,
                maxRatio: 3
            },
            image: {
                isTouched: undefined,
                isMoved: undefined,
                currentX: undefined,
                currentY: undefined,
                minX: undefined,
                minY: undefined,
                maxX: undefined,
                maxY: undefined,
                width: undefined,
                height: undefined,
                startX: undefined,
                startY: undefined,
                touchesStart: {},
                touchesCurrent: {}
            },
            velocity: {
                x: undefined,
                y: undefined,
                prevPositionX: undefined,
                prevPositionY: undefined,
                prevTime: undefined
            }
        };
        "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(methodName) {
            zoom[methodName] = $5e44c3fe32d2063c$var$Zoom[methodName].bind(swiper);
        });
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            zoom: zoom
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, "scale", {
            get: function() {
                return scale;
            },
            set: function(value) {
                if (scale !== value) {
                    var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
                    var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
                    swiper.emit("zoomChange", value, imageEl, slideEl);
                }
                scale = value;
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (swiper.params.zoom.enabled) swiper.zoom.enable();
        },
        destroy: function() {
            var swiper = this;
            swiper.zoom.disable();
        },
        touchStart: function(e) {
            var swiper = this;
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchStart(e);
        },
        touchEnd: function(e) {
            var swiper = this;
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function(e) {
            var swiper = this;
            if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) swiper.zoom.toggle(e);
        },
        transitionEnd: function() {
            var swiper = this;
            if (swiper.zoom.enabled && swiper.params.zoom.enabled) swiper.zoom.onTransitionEnd();
        }
    }
};
var $5e44c3fe32d2063c$var$Lazy = {
    loadInSlide: function(index) {
        var loadInDuplicate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var swiper = this;
        var params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(index, '"]')) : swiper.slides.eq(index);
        var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images = $images.add($slideEl[0]);
        if ($images.length === 0) return;
        $images.each(function(imageIndex, imageEl) {
            var $imageEl = (0, $lQE57.$)(imageEl);
            $imageEl.addClass(params.loadingClass);
            var background = $imageEl.attr("data-background");
            var src = $imageEl.attr("data-src");
            var srcset = $imageEl.attr("data-srcset");
            var sizes = $imageEl.attr("data-sizes");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function() {
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", 'url("'.concat(background, '")'));
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(".".concat(params.preloaderClass)).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    var slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(slideOriginalIndex, '"]:not(.').concat(swiper.params.slideDuplicateClass, ")"));
                        swiper.lazy.loadInSlide(originalSlide.index(), false);
                    } else {
                        var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, '[data-swiper-slide-index="').concat(slideOriginalIndex, '"]'));
                        swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                swiper.emit("lazyImageReady", $slideEl[0], $imageEl[0]);
            });
            swiper.emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    },
    load: function() {
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl, swiperParams = swiper.params, slides = swiper.slides, activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(".".concat(swiperParams.slideClass, '[data-swiper-slide-index="').concat(index, '"]')).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $lQE57.$)(slideEl).attr("data-swiper-slide-index");
            return (0, $lQE57.$)(slideEl).index();
        }
        if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
        if (swiper.params.watchSlidesVisibility) $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(function(elIndex, slideEl) {
            var _$index = isVirtual ? (0, $lQE57.$)(slideEl).attr("data-swiper-slide-index") : (0, $lQE57.$)(slideEl).index();
            swiper.lazy.loadInSlide(_$index);
        });
        else if (slidesPerView > 1) {
            for(var i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) swiper.lazy.loadInSlide(i);
        } else swiper.lazy.loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                var amount = params.loadPrevNextAmount;
                var spv = slidesPerView;
                var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
                // Next Slides
                for(var i1 = activeIndex + slidesPerView; i1 < maxIndex; i1 += 1)if (slideExist(i1)) swiper.lazy.loadInSlide(i1);
                // Prev Slides
                for(var i2 = minIndex; i2 < activeIndex; i2 += 1)if (slideExist(i2)) swiper.lazy.loadInSlide(i2);
            } else {
                var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
                if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
                var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
                if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
            }
        }
    }
};
var $5e44c3fe32d2063c$var$Lazy$1 = {
    name: "lazy",
    params: {
        lazy: {
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            lazy: {
                initialImageLoaded: false,
                load: $5e44c3fe32d2063c$var$Lazy.load.bind(swiper),
                loadInSlide: $5e44c3fe32d2063c$var$Lazy.loadInSlide.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
        },
        init: function() {
            var swiper = this;
            if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) swiper.lazy.load();
        },
        scroll: function() {
            var swiper = this;
            if (swiper.params.freeMode && !swiper.params.freeModeSticky) swiper.lazy.load();
        },
        resize: function() {
            var swiper = this;
            if (swiper.params.lazy.enabled) swiper.lazy.load();
        },
        scrollbarDragMove: function() {
            var swiper = this;
            if (swiper.params.lazy.enabled) swiper.lazy.load();
        },
        transitionStart: function() {
            var swiper = this;
            if (swiper.params.lazy.enabled) {
                if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) swiper.lazy.load();
            }
        },
        transitionEnd: function() {
            var swiper = this;
            if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) swiper.lazy.load();
        }
    }
};
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ var $5e44c3fe32d2063c$var$Controller = {
    LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function(c) {
        var swiper = this;
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new $5e44c3fe32d2063c$var$Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $5e44c3fe32d2063c$var$Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    },
    setTranslate: function(setTranslate, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                swiper.controller.getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof $5e44c3fe32d2063c$var$Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof $5e44c3fe32d2063c$var$Swiper && byController !== controlled) setControlledTranslate(controlled);
    },
    setTransition: function(duration, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) $5e44c3fe32d2063c$var$Utils.nextTick(function() {
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(function() {
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof $5e44c3fe32d2063c$var$Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof $5e44c3fe32d2063c$var$Swiper && byController !== controlled) setControlledTransition(controlled);
    }
};
var $5e44c3fe32d2063c$var$Controller$1 = {
    name: "controller",
    params: {
        controller: {
            control: undefined,
            inverse: false,
            by: "slide"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            controller: {
                control: swiper.params.controller.control,
                getInterpolateFunction: $5e44c3fe32d2063c$var$Controller.getInterpolateFunction.bind(swiper),
                setTranslate: $5e44c3fe32d2063c$var$Controller.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Controller.setTransition.bind(swiper)
            }
        });
    },
    on: {
        update: function() {
            var swiper = this;
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        resize: function() {
            var swiper = this;
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        observerUpdate: function() {
            var swiper = this;
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        setTranslate: function(translate, byController) {
            var swiper = this;
            if (!swiper.controller.control) return;
            swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function(duration, byController) {
            var swiper = this;
            if (!swiper.controller.control) return;
            swiper.controller.setTransition(duration, byController);
        }
    }
};
var $5e44c3fe32d2063c$var$a11y = {
    makeElFocusable: function($el) {
        $el.attr("tabIndex", "0");
        return $el;
    },
    addElRole: function($el, role) {
        $el.attr("role", role);
        return $el;
    },
    addElLabel: function($el, label) {
        $el.attr("aria-label", label);
        return $el;
    },
    disableEl: function($el) {
        $el.attr("aria-disabled", true);
        return $el;
    },
    enableEl: function($el) {
        $el.attr("aria-disabled", false);
        return $el;
    },
    onEnterKey: function(e) {
        var swiper = this;
        var params = swiper.params.a11y;
        if (e.keyCode !== 13) return;
        var $targetEl = (0, $lQE57.$)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) swiper.a11y.notify(params.lastSlideMessage);
            else swiper.a11y.notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) swiper.a11y.notify(params.firstSlideMessage);
            else swiper.a11y.notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is(".".concat(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    },
    notify: function(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    },
    updateNavigation: function() {
        var swiper = this;
        if (swiper.params.loop) return;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) swiper.a11y.disableEl($prevEl);
            else swiper.a11y.enableEl($prevEl);
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) swiper.a11y.disableEl($nextEl);
            else swiper.a11y.enableEl($nextEl);
        }
    },
    updatePagination: function() {
        var swiper = this;
        var params = swiper.params.a11y;
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.bullets.each(function(bulletIndex, bulletEl) {
            var $bulletEl = (0, $lQE57.$)(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
            swiper.a11y.addElRole($bulletEl, "button");
            swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
    },
    init: function() {
        var swiper = this;
        swiper.$el.append(swiper.a11y.liveRegion);
        // Navigation
        var params = swiper.params.a11y;
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) {
            swiper.a11y.makeElFocusable($nextEl);
            swiper.a11y.addElRole($nextEl, "button");
            swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
            $nextEl.on("keydown", swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
            swiper.a11y.makeElFocusable($prevEl);
            swiper.a11y.addElRole($prevEl, "button");
            swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
            $prevEl.on("keydown", swiper.a11y.onEnterKey);
        }
        // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.$el.on("keydown", ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
    },
    destroy: function() {
        var swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", swiper.a11y.onEnterKey);
        if ($prevEl) $prevEl.off("keydown", swiper.a11y.onEnterKey);
        // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.$el.off("keydown", ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
    }
};
var $5e44c3fe32d2063c$var$A11y = {
    name: "a11y",
    params: {
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            a11y: {
                liveRegion: (0, $lQE57.$)('<span class="'.concat(swiper.params.a11y.notificationClass, '" aria-live="assertive" aria-atomic="true"></span>'))
            }
        });
        Object.keys($5e44c3fe32d2063c$var$a11y).forEach(function(methodName) {
            swiper.a11y[methodName] = $5e44c3fe32d2063c$var$a11y[methodName].bind(swiper);
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.init();
            swiper.a11y.updateNavigation();
        },
        toEdge: function() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        fromEdge: function() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        paginationUpdate: function() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updatePagination();
        },
        destroy: function() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.destroy();
        }
    }
};
var $5e44c3fe32d2063c$var$History = {
    init: function() {
        var swiper = this;
        if (!swiper.params.history) return;
        if (!(0, $493f762f30aff8bc$export$8291e5b88f90ce4).history || !(0, $493f762f30aff8bc$export$8291e5b88f90ce4).history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        var history = swiper.history;
        history.initialized = true;
        history.paths = $5e44c3fe32d2063c$var$History.getPathValues();
        if (!history.paths.key && !history.paths.value) return;
        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) (0, $493f762f30aff8bc$export$8291e5b88f90ce4).addEventListener("popstate", swiper.history.setHistoryPopState);
    },
    destroy: function() {
        var swiper = this;
        if (!swiper.params.history.replaceState) (0, $493f762f30aff8bc$export$8291e5b88f90ce4).removeEventListener("popstate", swiper.history.setHistoryPopState);
    },
    setHistoryPopState: function() {
        var swiper = this;
        swiper.history.paths = $5e44c3fe32d2063c$var$History.getPathValues();
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function() {
        var pathArray = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    },
    setHistory: function(key, index) {
        var swiper = this;
        if (!swiper.history.initialized || !swiper.params.history.enabled) return;
        var slide = swiper.slides.eq(index);
        var value = $5e44c3fe32d2063c$var$History.slugify(slide.attr("data-history"));
        if (!(0, $493f762f30aff8bc$export$8291e5b88f90ce4).location.pathname.includes(key)) value = "".concat(key, "/").concat(value);
        var currentState = (0, $493f762f30aff8bc$export$8291e5b88f90ce4).history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) (0, $493f762f30aff8bc$export$8291e5b88f90ce4).history.replaceState({
            value: value
        }, null, value);
        else (0, $493f762f30aff8bc$export$8291e5b88f90ce4).history.pushState({
            value: value
        }, null, value);
    },
    slugify: function(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    },
    scrollToSlide: function(speed, value, runCallbacks) {
        var swiper = this;
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides.eq(i);
            var slideHistory = $5e44c3fe32d2063c$var$History.slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                var _$index = slide.index();
                swiper.slideTo(_$index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    }
};
var $5e44c3fe32d2063c$var$History$1 = {
    name: "history",
    params: {
        history: {
            enabled: false,
            replaceState: false,
            key: "slides"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            history: {
                init: $5e44c3fe32d2063c$var$History.init.bind(swiper),
                setHistory: $5e44c3fe32d2063c$var$History.setHistory.bind(swiper),
                setHistoryPopState: $5e44c3fe32d2063c$var$History.setHistoryPopState.bind(swiper),
                scrollToSlide: $5e44c3fe32d2063c$var$History.scrollToSlide.bind(swiper),
                destroy: $5e44c3fe32d2063c$var$History.destroy.bind(swiper)
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (swiper.params.history.enabled) swiper.history.init();
        },
        destroy: function() {
            var swiper = this;
            if (swiper.params.history.enabled) swiper.history.destroy();
        },
        transitionEnd: function() {
            var swiper = this;
            if (swiper.history.initialized) swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
    }
};
var $5e44c3fe32d2063c$var$HashNavigation = {
    onHashCange: function() {
        var swiper = this;
        var newHash = (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).location.hash.replace("#", "");
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-hash="').concat(newHash, '"]')).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    },
    setHash: function() {
        var swiper = this;
        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && (0, $493f762f30aff8bc$export$8291e5b88f90ce4).history && (0, $493f762f30aff8bc$export$8291e5b88f90ce4).history.replaceState) (0, $493f762f30aff8bc$export$8291e5b88f90ce4).history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr("data-hash")) || "");
        else {
            var slide = swiper.slides.eq(swiper.activeIndex);
            var hash = slide.attr("data-hash") || slide.attr("data-history");
            (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).location.hash = hash || "";
        }
    },
    init: function() {
        var swiper = this;
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        swiper.hashNavigation.initialized = true;
        var hash = (0, $493f762f30aff8bc$export$5a7bfc01df82fcd1).location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var _$index = slide.index();
                    swiper.slideTo(_$index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $lQE57.$)((0, $493f762f30aff8bc$export$8291e5b88f90ce4)).on("hashchange", swiper.hashNavigation.onHashCange);
    },
    destroy: function() {
        var swiper = this;
        if (swiper.params.hashNavigation.watchState) (0, $lQE57.$)((0, $493f762f30aff8bc$export$8291e5b88f90ce4)).off("hashchange", swiper.hashNavigation.onHashCange);
    }
};
var $5e44c3fe32d2063c$var$HashNavigation$1 = {
    name: "hash-navigation",
    params: {
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            hashNavigation: {
                initialized: false,
                init: $5e44c3fe32d2063c$var$HashNavigation.init.bind(swiper),
                destroy: $5e44c3fe32d2063c$var$HashNavigation.destroy.bind(swiper),
                setHash: $5e44c3fe32d2063c$var$HashNavigation.setHash.bind(swiper),
                onHashCange: $5e44c3fe32d2063c$var$HashNavigation.onHashCange.bind(swiper)
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (swiper.params.hashNavigation.enabled) swiper.hashNavigation.init();
        },
        destroy: function() {
            var swiper = this;
            if (swiper.params.hashNavigation.enabled) swiper.hashNavigation.destroy();
        },
        transitionEnd: function() {
            var swiper = this;
            if (swiper.hashNavigation.initialized) swiper.hashNavigation.setHash();
        }
    }
};
/* eslint no-underscore-dangle: "off" */ var $5e44c3fe32d2063c$var$Autoplay = {
    run: function() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = $5e44c3fe32d2063c$var$Utils.nextTick(function() {
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else if (!swiper.isBeginning) {
                    swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else swiper.autoplay.stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else if (!swiper.isEnd) {
                swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                swiper.slideTo(0, swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else swiper.autoplay.stop();
        }, delay);
    },
    start: function() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit("autoplayStart");
        swiper.autoplay.run();
        return true;
    },
    stop: function() {
        var swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === "undefined") return false;
        if (swiper.autoplay.timeout) {
            clearTimeout(swiper.autoplay.timeout);
            swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit("autoplayStop");
        return true;
    },
    pause: function(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            swiper.autoplay.run();
        } else {
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.autoplay.onTransitionEnd);
        }
    }
};
var $5e44c3fe32d2063c$var$Autoplay$1 = {
    name: "autoplay",
    params: {
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            autoplay: {
                running: false,
                paused: false,
                run: $5e44c3fe32d2063c$var$Autoplay.run.bind(swiper),
                start: $5e44c3fe32d2063c$var$Autoplay.start.bind(swiper),
                stop: $5e44c3fe32d2063c$var$Autoplay.stop.bind(swiper),
                pause: $5e44c3fe32d2063c$var$Autoplay.pause.bind(swiper),
                onTransitionEnd: function(e) {
                    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
                    if (e.target !== this) return;
                    swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.autoplay.onTransitionEnd);
                    swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.autoplay.onTransitionEnd);
                    swiper.autoplay.paused = false;
                    if (!swiper.autoplay.running) swiper.autoplay.stop();
                    else swiper.autoplay.run();
                }
            }
        });
    },
    on: {
        init: function() {
            var swiper = this;
            if (swiper.params.autoplay.enabled) swiper.autoplay.start();
        },
        beforeTransitionStart: function(speed, internal) {
            var swiper = this;
            if (swiper.autoplay.running) {
                if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
                else swiper.autoplay.stop();
            }
        },
        sliderFirstMove: function() {
            var swiper = this;
            if (swiper.autoplay.running) {
                if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                else swiper.autoplay.pause();
            }
        },
        destroy: function() {
            var swiper = this;
            if (swiper.autoplay.running) swiper.autoplay.stop();
        }
    }
};
var $5e44c3fe32d2063c$var$Fade = {
    setTranslate: function() {
        var swiper = this;
        var slides = swiper.slides;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = swiper.slides.eq(i);
            var _$offset = $slideEl[0].swiperSlideOffset;
            var tx = -_$offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            $slideEl.css({
                opacity: slideOpacity
            }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
        }
    },
    setTransition: function(duration) {
        var swiper = this;
        var slides = swiper.slides, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            slides.transitionEnd(function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    "webkitTransitionEnd",
                    "transitionend"
                ];
                for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
            });
        }
    }
};
var $5e44c3fe32d2063c$var$EffectFade = {
    name: "effect-fade",
    params: {
        fadeEffect: {
            crossFade: false
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            fadeEffect: {
                setTranslate: $5e44c3fe32d2063c$var$Fade.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Fade.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (swiper.params.effect !== "fade") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "fade"));
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            $5e44c3fe32d2063c$var$Utils.extend(swiper.params, overwriteParams);
            $5e44c3fe32d2063c$var$Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function() {
            var swiper = this;
            if (swiper.params.effect !== "fade") return;
            swiper.fadeEffect.setTranslate();
        },
        setTransition: function(duration) {
            var swiper = this;
            if (swiper.params.effect !== "fade") return;
            swiper.fadeEffect.setTransition(duration);
        }
    }
};
var $5e44c3fe32d2063c$var$Cube = {
    setTranslate: function() {
        var swiper = this;
        var $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $lQE57.$)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: "".concat(swiperWidth, "px")
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $lQE57.$)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var _$transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(_$transform);
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $lQE57.$)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "left" : "top", '"></div>'));
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $lQE57.$)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "right" : "bottom", '"></div>'));
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            "-webkit-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "-moz-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "-ms-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "transform-origin": "50% 50% -".concat(swiperSize / 2, "px")
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var _$offset = params.shadowOffset;
                $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + _$offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
            }
        }
        var zFactor = $5e44c3fe32d2063c$var$Browser.isSafari || $5e44c3fe32d2063c$var$Browser.isUiWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
    },
    setTransition: function(duration) {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    }
};
var $5e44c3fe32d2063c$var$EffectCube = {
    name: "effect-cube",
    params: {
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            cubeEffect: {
                setTranslate: $5e44c3fe32d2063c$var$Cube.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Cube.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (swiper.params.effect !== "cube") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "cube"));
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
            $5e44c3fe32d2063c$var$Utils.extend(swiper.params, overwriteParams);
            $5e44c3fe32d2063c$var$Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function() {
            var swiper = this;
            if (swiper.params.effect !== "cube") return;
            swiper.cubeEffect.setTranslate();
        },
        setTransition: function(duration) {
            var swiper = this;
            if (swiper.params.effect !== "cube") return;
            swiper.cubeEffect.setTransition(duration);
        }
    }
};
var $5e44c3fe32d2063c$var$Flip = {
    setTranslate: function() {
        var swiper = this;
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var _$offset = $slideEl[0].swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = -_$offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (swiper.params.flipEffect.slideShadows) {
                // Set shadows
                var shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $lQE57.$)('<div class="swiper-slide-shadow-'.concat(swiper.isHorizontal() ? "left" : "top", '"></div>'));
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $lQE57.$)('<div class="swiper-slide-shadow-'.concat(swiper.isHorizontal() ? "right" : "bottom", '"></div>'));
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            $slideEl.transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)"));
        }
    },
    setTransition: function(duration) {
        var swiper = this;
        var slides = swiper.slides, activeIndex = swiper.activeIndex, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            // eslint-disable-next-line
            slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    "webkitTransitionEnd",
                    "transitionend"
                ];
                for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
            });
        }
    }
};
var $5e44c3fe32d2063c$var$EffectFlip = {
    name: "effect-flip",
    params: {
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            flipEffect: {
                setTranslate: $5e44c3fe32d2063c$var$Flip.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Flip.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (swiper.params.effect !== "flip") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "flip"));
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            $5e44c3fe32d2063c$var$Utils.extend(swiper.params, overwriteParams);
            $5e44c3fe32d2063c$var$Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function() {
            var swiper = this;
            if (swiper.params.effect !== "flip") return;
            swiper.flipEffect.setTranslate();
        },
        setTransition: function(duration) {
            var swiper = this;
            if (swiper.params.effect !== "flip") return;
            swiper.flipEffect.setTransition(duration);
        }
    }
};
var $5e44c3fe32d2063c$var$Coverflow = {
    setTranslate: function() {
        var swiper = this;
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, $wrapperEl = swiper.$wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var _$transform = swiper.translate;
        var center = isHorizontal ? -_$transform + swiperWidth / 2 : -_$transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var $slideEl = slides.eq(i);
            var slideSize = slidesSizesGrid[i];
            var slideOffset = $slideEl[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
            var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0;
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)");
            $slideEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) {
                    $shadowBeforeEl = (0, $lQE57.$)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "left" : "top", '"></div>'));
                    $slideEl.append($shadowBeforeEl);
                }
                if ($shadowAfterEl.length === 0) {
                    $shadowAfterEl = (0, $lQE57.$)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "right" : "bottom", '"></div>'));
                    $slideEl.append($shadowAfterEl);
                }
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
        // Set correct perspective for IE10
        if ($5e44c3fe32d2063c$var$Support.pointerEvents || $5e44c3fe32d2063c$var$Support.prefixedPointerEvents) {
            var ws = $wrapperEl[0].style;
            ws.perspectiveOrigin = "".concat(center, "px 50%");
        }
    },
    setTransition: function(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    }
};
var $5e44c3fe32d2063c$var$EffectCoverflow = {
    name: "effect-coverflow",
    params: {
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            coverflowEffect: {
                setTranslate: $5e44c3fe32d2063c$var$Coverflow.setTranslate.bind(swiper),
                setTransition: $5e44c3fe32d2063c$var$Coverflow.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            if (swiper.params.effect !== "coverflow") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "coverflow"));
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function() {
            var swiper = this;
            if (swiper.params.effect !== "coverflow") return;
            swiper.coverflowEffect.setTranslate();
        },
        setTransition: function(duration) {
            var swiper = this;
            if (swiper.params.effect !== "coverflow") return;
            swiper.coverflowEffect.setTransition(duration);
        }
    }
};
var $5e44c3fe32d2063c$var$Thumbs = {
    init: function() {
        var swiper = this;
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            $5e44c3fe32d2063c$var$Utils.extend(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            $5e44c3fe32d2063c$var$Utils.extend(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ($5e44c3fe32d2063c$var$Utils.isObject(thumbsParams.swiper)) {
            swiper.thumbs.swiper = new SwiperClass($5e44c3fe32d2063c$var$Utils.extend({}, thumbsParams.swiper, {
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: false
            }));
            swiper.thumbs.swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", swiper.thumbs.onThumbClick);
    },
    onThumbClick: function() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $lQE57.$)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $lQE57.$)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            var currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix();
                // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    },
    update: function(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        if (swiper.realIndex !== thumbsSwiper.realIndex) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix();
                    // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                }
                // Find actual thumbs index to slide to
                var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
            } else newThumbsIndex = swiper.realIndex;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - slidesPerView + 1;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) for(var i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).addClass(thumbActiveClass);
        else for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)thumbsSwiper.slides.eq(swiper.realIndex + i1).addClass(thumbActiveClass);
    }
};
var $5e44c3fe32d2063c$var$Thumbs$1 = {
    name: "thumbs",
    params: {
        thumbs: {
            swiper: null,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-container-thumbs"
        }
    },
    create: function() {
        var swiper = this;
        $5e44c3fe32d2063c$var$Utils.extend(swiper, {
            thumbs: {
                swiper: null,
                init: $5e44c3fe32d2063c$var$Thumbs.init.bind(swiper),
                update: $5e44c3fe32d2063c$var$Thumbs.update.bind(swiper),
                onThumbClick: $5e44c3fe32d2063c$var$Thumbs.onThumbClick.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function() {
            var swiper = this;
            var thumbs = swiper.params.thumbs;
            if (!thumbs || !thumbs.swiper) return;
            swiper.thumbs.init();
            swiper.thumbs.update(true);
        },
        slideChange: function() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        update: function() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        resize: function() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        observerUpdate: function() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        setTransition: function(duration) {
            var swiper = this;
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function() {
            var swiper = this;
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            if (swiper.thumbs.swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
        }
    }
};
// Swiper Class
var $5e44c3fe32d2063c$var$components = [
    $5e44c3fe32d2063c$var$Device$1,
    $5e44c3fe32d2063c$var$Support$1,
    $5e44c3fe32d2063c$var$Browser$1,
    $5e44c3fe32d2063c$var$Resize,
    $5e44c3fe32d2063c$var$Observer$1,
    $5e44c3fe32d2063c$var$Virtual$1,
    $5e44c3fe32d2063c$var$Keyboard$1,
    $5e44c3fe32d2063c$var$Mousewheel$1,
    $5e44c3fe32d2063c$var$Navigation$1,
    $5e44c3fe32d2063c$var$Pagination$1,
    $5e44c3fe32d2063c$var$Scrollbar$1,
    $5e44c3fe32d2063c$var$Parallax$1,
    $5e44c3fe32d2063c$var$Zoom$1,
    $5e44c3fe32d2063c$var$Lazy$1,
    $5e44c3fe32d2063c$var$Controller$1,
    $5e44c3fe32d2063c$var$A11y,
    $5e44c3fe32d2063c$var$History$1,
    $5e44c3fe32d2063c$var$HashNavigation$1,
    $5e44c3fe32d2063c$var$Autoplay$1,
    $5e44c3fe32d2063c$var$EffectFade,
    $5e44c3fe32d2063c$var$EffectCube,
    $5e44c3fe32d2063c$var$EffectFlip,
    $5e44c3fe32d2063c$var$EffectCoverflow,
    $5e44c3fe32d2063c$var$Thumbs$1
];
if (typeof $5e44c3fe32d2063c$var$Swiper.use === "undefined") {
    $5e44c3fe32d2063c$var$Swiper.use = $5e44c3fe32d2063c$var$Swiper.Class.use;
    $5e44c3fe32d2063c$var$Swiper.installModule = $5e44c3fe32d2063c$var$Swiper.Class.installModule;
}
$5e44c3fe32d2063c$var$Swiper.use($5e44c3fe32d2063c$var$components);
var $5e44c3fe32d2063c$export$2e2bcd8739ae039 = $5e44c3fe32d2063c$var$Swiper;


var $91235eee3740bd67$exports = {};



/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, $91235eee3740bd67$exports) // Node
    $91235eee3740bd67$exports = factory((parcelRequire("kLeCf")), (parcelRequire("8BYBg")), (parcelRequire("lY1XY")));
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "./punycode",
        "./IPv6",
        "./SecondLevelDomains"
    ], factory);
    else // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
})($91235eee3740bd67$exports, function(punycode, IPv6, SLD, root) {
    "use strict";
    /*global location, escape, unescape */ // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
    /*jshint camelcase: false */ // save current URI variable, if any
    var _URI = root && root.URI;
    function URI(url, base) {
        var _urlSupplied = arguments.length >= 1;
        var _baseSupplied = arguments.length >= 2;
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof URI)) {
            if (_urlSupplied) {
                if (_baseSupplied) return new URI(url, base);
                return new URI(url);
            }
            return new URI();
        }
        if (url === undefined) {
            if (_urlSupplied) throw new TypeError("undefined is not a valid argument for URI");
            if (typeof location !== "undefined") url = location.href + "";
            else url = "";
        }
        if (url === null) {
            if (_urlSupplied) throw new TypeError("null is not a valid argument for URI");
        }
        this.href(url);
        // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
        if (base !== undefined) return this.absoluteTo(base);
        return this;
    }
    function isInteger(value) {
        return /^[0-9]+$/.test(value);
    }
    URI.version = "1.19.11";
    var p = URI.prototype;
    var hasOwn = Object.prototype.hasOwnProperty;
    function escapeRegEx(string) {
        // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
        return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
    }
    function getType(value) {
        // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
        if (value === undefined) return "Undefined";
        return String(Object.prototype.toString.call(value)).slice(8, -1);
    }
    function isArray(obj) {
        return getType(obj) === "Array";
    }
    function filterArrayValues(data, value) {
        var lookup = {};
        var i, length;
        if (getType(value) === "RegExp") lookup = null;
        else if (isArray(value)) for(i = 0, length = value.length; i < length; i++)lookup[value[i]] = true;
        else lookup[value] = true;
        for(i = 0, length = data.length; i < length; i++){
            /*jshint laxbreak: true */ var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
            /*jshint laxbreak: false */ if (_match) {
                data.splice(i, 1);
                length--;
                i--;
            }
        }
        return data;
    }
    function arrayContains(list, value) {
        var i, length;
        // value may be string, number, array, regexp
        if (isArray(value)) {
            // Note: this can be optimized to O(n) (instead of current O(m * n))
            for(i = 0, length = value.length; i < length; i++){
                if (!arrayContains(list, value[i])) return false;
            }
            return true;
        }
        var _type = getType(value);
        for(i = 0, length = list.length; i < length; i++){
            if (_type === "RegExp") {
                if (typeof list[i] === "string" && list[i].match(value)) return true;
            } else if (list[i] === value) return true;
        }
        return false;
    }
    function arraysEqual(one, two) {
        if (!isArray(one) || !isArray(two)) return false;
        // arrays can't be equal if they have different amount of content
        if (one.length !== two.length) return false;
        one.sort();
        two.sort();
        for(var i = 0, l = one.length; i < l; i++){
            if (one[i] !== two[i]) return false;
        }
        return true;
    }
    function trimSlashes(text) {
        var trim_expression = /^\/+|\/+$/g;
        return text.replace(trim_expression, "");
    }
    URI._parts = function() {
        return {
            protocol: null,
            username: null,
            password: null,
            hostname: null,
            urn: null,
            port: null,
            path: null,
            query: null,
            fragment: null,
            // state
            preventInvalidHostname: URI.preventInvalidHostname,
            duplicateQueryParameters: URI.duplicateQueryParameters,
            escapeQuerySpace: URI.escapeQuerySpace
        };
    };
    // state: throw on invalid hostname
    // see https://github.com/medialize/URI.js/pull/345
    // and https://github.com/medialize/URI.js/issues/354
    URI.preventInvalidHostname = false;
    // state: allow duplicate query parameters (a=1&a=1)
    URI.duplicateQueryParameters = false;
    // state: replaces + with %20 (space in query strings)
    URI.escapeQuerySpace = true;
    // static properties
    URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
    URI.idn_expression = /[^a-z0-9\._-]/i;
    URI.punycode_expression = /(xn--)/i;
    // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
    URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    // credits to Rich Brown
    // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
    // specification: http://www.ietf.org/rfc/rfc4291.txt
    URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    // expression used is "gruber revised" (@gruber v2) determined to be the
    // best solution in a regex-golf we did a couple of ages ago at
    // * http://mathiasbynens.be/demo/url-regex
    // * http://rodneyrehm.de/t/url-regex.html
    URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    URI.findUri = {
        // valid "scheme://" or "www."
        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
        // everything up to the next whitespace
        end: /[\s\r\n]|$/,
        // trim trailing punctuation captured by end RegExp
        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
        // balanced parens inclusion (), [], {}, <>
        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
    };
    URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/;
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g;
    // http://www.iana.org/assignments/uri-schemes.html
    // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
    URI.defaultPorts = {
        http: "80",
        https: "443",
        ftp: "21",
        gopher: "70",
        ws: "80",
        wss: "443"
    };
    // list of protocols which always require a hostname
    URI.hostProtocols = [
        "http",
        "https"
    ];
    // allowed hostname characters according to RFC 3986
    // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
    // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
    URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
    // map DOM Elements to their URI attribute
    URI.domAttributes = {
        "a": "href",
        "blockquote": "cite",
        "link": "href",
        "base": "href",
        "script": "src",
        "form": "action",
        "img": "src",
        "area": "href",
        "iframe": "src",
        "embed": "src",
        "source": "src",
        "track": "src",
        "input": "src",
        "audio": "src",
        "video": "src"
    };
    URI.getDomAttribute = function(node) {
        if (!node || !node.nodeName) return undefined;
        var nodeName = node.nodeName.toLowerCase();
        // <input> should only expose src for type="image"
        if (nodeName === "input" && node.type !== "image") return undefined;
        return URI.domAttributes[nodeName];
    };
    function escapeForDumbFirefox36(value) {
        // https://github.com/medialize/URI.js/issues/91
        return escape(value);
    }
    // encoding / decoding according to RFC3986
    function strictEncodeURIComponent(string) {
        // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
        return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, "%2A");
    }
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
    URI.iso8859 = function() {
        URI.encode = escape;
        URI.decode = unescape;
    };
    URI.unicode = function() {
        URI.encode = strictEncodeURIComponent;
        URI.decode = decodeURIComponent;
    };
    URI.characters = {
        pathname: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
                map: {
                    // -._~!'()*
                    "%24": "$",
                    "%26": "&",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "=",
                    "%3A": ":",
                    "%40": "@"
                }
            },
            decode: {
                expression: /[\/\?#]/g,
                map: {
                    "/": "%2F",
                    "?": "%3F",
                    "#": "%23"
                }
            }
        },
        reserved: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
                map: {
                    // gen-delims
                    "%3A": ":",
                    "%2F": "/",
                    "%3F": "?",
                    "%23": "#",
                    "%5B": "[",
                    "%5D": "]",
                    "%40": "@",
                    // sub-delims
                    "%21": "!",
                    "%24": "$",
                    "%26": "&",
                    "%27": "'",
                    "%28": "(",
                    "%29": ")",
                    "%2A": "*",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "="
                }
            }
        },
        urnpath: {
            // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
            // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
            // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
            // note that the colon character is not featured in the encoding map; this is because URI.js
            // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
            // should not appear unencoded in a segment itself.
            // See also the note above about RFC3986 and capitalalized hex digits.
            encode: {
                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
                map: {
                    "%21": "!",
                    "%24": "$",
                    "%27": "'",
                    "%28": "(",
                    "%29": ")",
                    "%2A": "*",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "=",
                    "%40": "@"
                }
            },
            // These characters are the characters called out by RFC2141 as "reserved" characters that
            // should never appear in a URN, plus the colon character (see note above).
            decode: {
                expression: /[\/\?#:]/g,
                map: {
                    "/": "%2F",
                    "?": "%3F",
                    "#": "%23",
                    ":": "%3A"
                }
            }
        }
    };
    URI.encodeQuery = function(string, escapeQuerySpace) {
        var escaped = URI.encode(string + "");
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        return escapeQuerySpace ? escaped.replace(/%20/g, "+") : escaped;
    };
    URI.decodeQuery = function(string, escapeQuerySpace) {
        string += "";
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        try {
            return URI.decode(escapeQuerySpace ? string.replace(/\+/g, "%20") : string);
        } catch (e) {
            // we're not going to mess with weird encodings,
            // give up and return the undecoded original string
            // see https://github.com/medialize/URI.js/issues/87
            // see https://github.com/medialize/URI.js/issues/92
            return string;
        }
    };
    // generate encode/decode path functions
    var _parts = {
        "encode": "encode",
        "decode": "decode"
    };
    var _part;
    var generateAccessor = function generateAccessor(_group, _part) {
        return function(string) {
            try {
                return URI[_part](string + "").replace(URI.characters[_group][_part].expression, function(c) {
                    return URI.characters[_group][_part].map[c];
                });
            } catch (e) {
                // we're not going to mess with weird encodings,
                // give up and return the undecoded original string
                // see https://github.com/medialize/URI.js/issues/87
                // see https://github.com/medialize/URI.js/issues/92
                return string;
            }
        };
    };
    for(_part in _parts){
        URI[_part + "PathSegment"] = generateAccessor("pathname", _parts[_part]);
        URI[_part + "UrnPathSegment"] = generateAccessor("urnpath", _parts[_part]);
    }
    var generateSegmentedPathFunction = function generateSegmentedPathFunction(_sep, _codingFuncName, _innerCodingFuncName) {
        return function(string) {
            // Why pass in names of functions, rather than the function objects themselves? The
            // definitions of some functions (but in particular, URI.decode) will occasionally change due
            // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
            // that the functions we use here are "fresh".
            var actualCodingFunc;
            if (!_innerCodingFuncName) actualCodingFunc = URI[_codingFuncName];
            else actualCodingFunc = function actualCodingFunc(string) {
                return URI[_codingFuncName](URI[_innerCodingFuncName](string));
            };
            var segments = (string + "").split(_sep);
            for(var i = 0, length = segments.length; i < length; i++)segments[i] = actualCodingFunc(segments[i]);
            return segments.join(_sep);
        };
    };
    // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
    URI.decodePath = generateSegmentedPathFunction("/", "decodePathSegment");
    URI.decodeUrnPath = generateSegmentedPathFunction(":", "decodeUrnPathSegment");
    URI.recodePath = generateSegmentedPathFunction("/", "encodePathSegment", "decode");
    URI.recodeUrnPath = generateSegmentedPathFunction(":", "encodeUrnPathSegment", "decode");
    URI.encodeReserved = generateAccessor("reserved", "encode");
    URI.parse = function(string, parts) {
        var pos;
        if (!parts) parts = {
            preventInvalidHostname: URI.preventInvalidHostname
        };
        string = string.replace(URI.leading_whitespace_expression, "");
        // https://infra.spec.whatwg.org/#ascii-tab-or-newline
        string = string.replace(URI.ascii_tab_whitespace, "");
        // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
        // extract fragment
        pos = string.indexOf("#");
        if (pos > -1) {
            // escaping?
            parts.fragment = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // extract query
        pos = string.indexOf("?");
        if (pos > -1) {
            // escaping?
            parts.query = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
        string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, "$1://");
        // slashes and backslashes have lost all meaning for scheme relative URLs
        string = string.replace(/^[/\\]{2,}/i, "//");
        // extract protocol
        if (string.substring(0, 2) === "//") {
            // relative-scheme
            parts.protocol = null;
            string = string.substring(2);
            // extract "user:pass@host:port"
            string = URI.parseAuthority(string, parts);
        } else {
            pos = string.indexOf(":");
            if (pos > -1) {
                parts.protocol = string.substring(0, pos) || null;
                if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) // : may be within the path
                parts.protocol = undefined;
                else if (string.substring(pos + 1, pos + 3).replace(/\\/g, "/") === "//") {
                    string = string.substring(pos + 3);
                    // extract "user:pass@host:port"
                    string = URI.parseAuthority(string, parts);
                } else {
                    string = string.substring(pos + 1);
                    parts.urn = true;
                }
            }
        }
        // what's left must be the path
        parts.path = string;
        // and we're done
        return parts;
    };
    URI.parseHost = function(string, parts) {
        if (!string) string = "";
        // Copy chrome, IE, opera backslash-handling behavior.
        // Back slashes before the query string get converted to forward slashes
        // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
        // See: https://code.google.com/p/chromium/issues/detail?id=25916
        // https://github.com/medialize/URI.js/pull/233
        string = string.replace(/\\/g, "/");
        // extract host:port
        var pos = string.indexOf("/");
        var bracketPos;
        var t;
        if (pos === -1) pos = string.length;
        if (string.charAt(0) === "[") {
            // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
            // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
            // IPv6+port in the format [2001:db8::1]:80 (for the time being)
            bracketPos = string.indexOf("]");
            parts.hostname = string.substring(1, bracketPos) || null;
            parts.port = string.substring(bracketPos + 2, pos) || null;
            if (parts.port === "/") parts.port = null;
        } else {
            var firstColon = string.indexOf(":");
            var firstSlash = string.indexOf("/");
            var nextColon = string.indexOf(":", firstColon + 1);
            if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
                // IPv6 host contains multiple colons - but no port
                // this notation is actually not allowed by RFC 3986, but we're a liberal parser
                parts.hostname = string.substring(0, pos) || null;
                parts.port = null;
            } else {
                t = string.substring(0, pos).split(":");
                parts.hostname = t[0] || null;
                parts.port = t[1] || null;
            }
        }
        if (parts.hostname && string.substring(pos).charAt(0) !== "/") {
            pos++;
            string = "/" + string;
        }
        if (parts.preventInvalidHostname) URI.ensureValidHostname(parts.hostname, parts.protocol);
        if (parts.port) URI.ensureValidPort(parts.port);
        return string.substring(pos) || "/";
    };
    URI.parseAuthority = function(string, parts) {
        string = URI.parseUserinfo(string, parts);
        return URI.parseHost(string, parts);
    };
    URI.parseUserinfo = function(string, parts) {
        // extract username:password
        var _string = string;
        var firstBackSlash = string.indexOf("\\");
        if (firstBackSlash !== -1) string = string.replace(/\\/g, "/");
        var firstSlash = string.indexOf("/");
        var pos = string.lastIndexOf("@", firstSlash > -1 ? firstSlash : string.length - 1);
        var t;
        // authority@ must come before /path or \path
        if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
            t = string.substring(0, pos).split(":");
            parts.username = t[0] ? URI.decode(t[0]) : null;
            t.shift();
            parts.password = t[0] ? URI.decode(t.join(":")) : null;
            string = _string.substring(pos + 1);
        } else {
            parts.username = null;
            parts.password = null;
        }
        return string;
    };
    URI.parseQuery = function(string, escapeQuerySpace) {
        if (!string) return {};
        // throw out the funky business - "?"[name"="value"&"]+
        string = string.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, "");
        if (!string) return {};
        var items = {};
        var splits = string.split("&");
        var length = splits.length;
        var v, name, value;
        for(var i = 0; i < length; i++){
            v = splits[i].split("=");
            name = URI.decodeQuery(v.shift(), escapeQuerySpace);
            // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
            value = v.length ? URI.decodeQuery(v.join("="), escapeQuerySpace) : null;
            if (name === "__proto__") continue;
            else if (hasOwn.call(items, name)) {
                if (typeof items[name] === "string" || items[name] === null) items[name] = [
                    items[name]
                ];
                items[name].push(value);
            } else items[name] = value;
        }
        return items;
    };
    URI.build = function(parts) {
        var t = "";
        var requireAbsolutePath = false;
        if (parts.protocol) t += parts.protocol + ":";
        if (!parts.urn && (t || parts.hostname)) {
            t += "//";
            requireAbsolutePath = true;
        }
        t += URI.buildAuthority(parts) || "";
        if (typeof parts.path === "string") {
            if (parts.path.charAt(0) !== "/" && requireAbsolutePath) t += "/";
            t += parts.path;
        }
        if (typeof parts.query === "string" && parts.query) t += "?" + parts.query;
        if (typeof parts.fragment === "string" && parts.fragment) t += "#" + parts.fragment;
        return t;
    };
    URI.buildHost = function(parts) {
        var t = "";
        if (!parts.hostname) return "";
        else if (URI.ip6_expression.test(parts.hostname)) t += "[" + parts.hostname + "]";
        else t += parts.hostname;
        if (parts.port) t += ":" + parts.port;
        return t;
    };
    URI.buildAuthority = function(parts) {
        return URI.buildUserinfo(parts) + URI.buildHost(parts);
    };
    URI.buildUserinfo = function(parts) {
        var t = "";
        if (parts.username) t += URI.encode(parts.username);
        if (parts.password) t += ":" + URI.encode(parts.password);
        if (t) t += "@";
        return t;
    };
    URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
        // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
        // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
        // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
        // URI.js treats the query string as being application/x-www-form-urlencoded
        // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
        var t = "";
        var unique, key, i, length;
        for(key in data){
            if (key === "__proto__") continue;
            else if (hasOwn.call(data, key)) {
                if (isArray(data[key])) {
                    unique = {};
                    for(i = 0, length = data[key].length; i < length; i++)if (data[key][i] !== undefined && unique[data[key][i] + ""] === undefined) {
                        t += "&" + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                        if (duplicateQueryParameters !== true) unique[data[key][i] + ""] = true;
                    }
                } else if (data[key] !== undefined) t += "&" + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
            }
        }
        return t.substring(1);
    };
    URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
        // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
        // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
        return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? "=" + URI.encodeQuery(value, escapeQuerySpace) : "");
    };
    URI.addQuery = function(data, name, value) {
        if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) URI.addQuery(data, key, name[key]);
        } else if (typeof name === "string") {
            if (data[name] === undefined) {
                data[name] = value;
                return;
            } else if (typeof data[name] === "string") data[name] = [
                data[name]
            ];
            if (!isArray(value)) value = [
                value
            ];
            data[name] = (data[name] || []).concat(value);
        } else throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
    };
    URI.setQuery = function(data, name, value) {
        if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) URI.setQuery(data, key, name[key]);
        } else if (typeof name === "string") data[name] = value === undefined ? null : value;
        else throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
    };
    URI.removeQuery = function(data, name, value) {
        var i, length, key;
        if (isArray(name)) for(i = 0, length = name.length; i < length; i++)data[name[i]] = undefined;
        else if (getType(name) === "RegExp") {
            for(key in data)if (name.test(key)) data[key] = undefined;
        } else if (typeof name === "object") {
            for(key in name)if (hasOwn.call(name, key)) URI.removeQuery(data, key, name[key]);
        } else if (typeof name === "string") {
            if (value !== undefined) {
                if (getType(value) === "RegExp") {
                    if (!isArray(data[name]) && value.test(data[name])) data[name] = undefined;
                    else data[name] = filterArrayValues(data[name], value);
                } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) data[name] = undefined;
                else if (isArray(data[name])) data[name] = filterArrayValues(data[name], value);
            } else data[name] = undefined;
        } else throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
    };
    URI.hasQuery = function(data, name, value, withinArray) {
        switch(getType(name)){
            case "String":
                break;
            case "RegExp":
                for(var key in data)if (hasOwn.call(data, key)) {
                    if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) return true;
                }
                return false;
            case "Object":
                for(var _key in name)if (hasOwn.call(name, _key)) {
                    if (!URI.hasQuery(data, _key, name[_key])) return false;
                }
                return true;
            default:
                throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
        }
        switch(getType(value)){
            case "Undefined":
                // true if exists (but may be empty)
                return name in data; // data[name] !== undefined;
            case "Boolean":
                // true if exists and non-empty
                var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
                return value === _booly;
            case "Function":
                // allow complex comparison
                return !!value(data[name], name, data);
            case "Array":
                if (!isArray(data[name])) return false;
                var op = withinArray ? arrayContains : arraysEqual;
                return op(data[name], value);
            case "RegExp":
                if (!isArray(data[name])) return Boolean(data[name] && data[name].match(value));
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            case "Number":
                value = String(value);
            /* falls through */ case "String":
                if (!isArray(data[name])) return data[name] === value;
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            default:
                throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
        }
    };
    URI.joinPaths = function() {
        var input = [];
        var segments = [];
        var nonEmptySegments = 0;
        for(var i = 0; i < arguments.length; i++){
            var url = new URI(arguments[i]);
            input.push(url);
            var _segments = url.segment();
            for(var s = 0; s < _segments.length; s++){
                if (typeof _segments[s] === "string") segments.push(_segments[s]);
                if (_segments[s]) nonEmptySegments++;
            }
        }
        if (!segments.length || !nonEmptySegments) return new URI("");
        var uri = new URI("").segment(segments);
        if (input[0].path() === "" || input[0].path().slice(0, 1) === "/") uri.path("/" + uri.path());
        return uri.normalize();
    };
    URI.commonPath = function(one, two) {
        var length = Math.min(one.length, two.length);
        var pos;
        // find first non-matching character
        for(pos = 0; pos < length; pos++)if (one.charAt(pos) !== two.charAt(pos)) {
            pos--;
            break;
        }
        if (pos < 1) return one.charAt(0) === two.charAt(0) && one.charAt(0) === "/" ? "/" : "";
        // revert to last /
        if (one.charAt(pos) !== "/" || two.charAt(pos) !== "/") pos = one.substring(0, pos).lastIndexOf("/");
        return one.substring(0, pos + 1);
    };
    URI.withinString = function(string, callback, options) {
        options || (options = {});
        var _start = options.start || URI.findUri.start;
        var _end = options.end || URI.findUri.end;
        var _trim = options.trim || URI.findUri.trim;
        var _parens = options.parens || URI.findUri.parens;
        var _attributeOpen = /[a-z0-9-]=["']?$/i;
        _start.lastIndex = 0;
        while(true){
            var match = _start.exec(string);
            if (!match) break;
            var start = match.index;
            if (options.ignoreHtml) {
                // attribut(e=["']?$)
                var attributeOpen = string.slice(Math.max(start - 3, 0), start);
                if (attributeOpen && _attributeOpen.test(attributeOpen)) continue;
            }
            var end = start + string.slice(start).search(_end);
            var slice = string.slice(start, end);
            // make sure we include well balanced parens
            var parensEnd = -1;
            while(true){
                var parensMatch = _parens.exec(slice);
                if (!parensMatch) break;
                var parensMatchEnd = parensMatch.index + parensMatch[0].length;
                parensEnd = Math.max(parensEnd, parensMatchEnd);
            }
            if (parensEnd > -1) slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, "");
            else slice = slice.replace(_trim, "");
            if (slice.length <= match[0].length) continue;
            if (options.ignore && options.ignore.test(slice)) continue;
            end = start + slice.length;
            var result = callback(slice, start, end, string);
            if (result === undefined) {
                _start.lastIndex = end;
                continue;
            }
            result = String(result);
            string = string.slice(0, start) + result + string.slice(end);
            _start.lastIndex = start + result.length;
        }
        _start.lastIndex = 0;
        return string;
    };
    URI.ensureValidHostname = function(v, protocol) {
        // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
        // they are not part of DNS and therefore ignored by URI.js
        var hasHostname = !!v; // not null and not an empty string
        var hasProtocol = !!protocol;
        var rejectEmptyHostname = false;
        if (hasProtocol) rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
        if (rejectEmptyHostname && !hasHostname) throw new TypeError("Hostname cannot be empty, if protocol is " + protocol);
        else if (v && v.match(URI.invalid_hostname_characters)) {
            // test punycode
            if (!punycode) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
            if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
        }
    };
    URI.ensureValidPort = function(v) {
        if (!v) return;
        var port = Number(v);
        if (isInteger(port) && port > 0 && port < 65536) return;
        throw new TypeError('Port "' + v + '" is not a valid port');
    };
    // noConflict
    URI.noConflict = function(removeAll) {
        if (removeAll) {
            var unconflicted = {
                URI: this.noConflict()
            };
            if (root.URITemplate && typeof root.URITemplate.noConflict === "function") unconflicted.URITemplate = root.URITemplate.noConflict();
            if (root.IPv6 && typeof root.IPv6.noConflict === "function") unconflicted.IPv6 = root.IPv6.noConflict();
            if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === "function") unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
            return unconflicted;
        } else if (root.URI === this) root.URI = _URI;
        return this;
    };
    p.build = function(deferBuild) {
        if (deferBuild === true) this._deferred_build = true;
        else if (deferBuild === undefined || this._deferred_build) {
            this._string = URI.build(this._parts);
            this._deferred_build = false;
        }
        return this;
    };
    p.clone = function() {
        return new URI(this);
    };
    p.valueOf = p.toString = function() {
        return this.build(false)._string;
    };
    function generateSimpleAccessor(_part) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || "";
            else {
                this._parts[_part] = v || null;
                this.build(!build);
                return this;
            }
        };
    }
    function generatePrefixAccessor(_part, _key) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || "";
            else {
                if (v !== null) {
                    v = v + "";
                    if (v.charAt(0) === _key) v = v.substring(1);
                }
                this._parts[_part] = v;
                this.build(!build);
                return this;
            }
        };
    }
    p.protocol = generateSimpleAccessor("protocol");
    p.username = generateSimpleAccessor("username");
    p.password = generateSimpleAccessor("password");
    p.hostname = generateSimpleAccessor("hostname");
    p.port = generateSimpleAccessor("port");
    p.query = generatePrefixAccessor("query", "?");
    p.fragment = generatePrefixAccessor("fragment", "#");
    p.search = function(v, build) {
        var t = this.query(v, build);
        return typeof t === "string" && t.length ? "?" + t : t;
    };
    p.hash = function(v, build) {
        var t = this.fragment(v, build);
        return typeof t === "string" && t.length ? "#" + t : t;
    };
    p.pathname = function(v, build) {
        if (v === undefined || v === true) {
            var res = this._parts.path || (this._parts.hostname ? "/" : "");
            return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
        } else {
            if (this._parts.urn) this._parts.path = v ? URI.recodeUrnPath(v) : "";
            else this._parts.path = v ? URI.recodePath(v) : "/";
            this.build(!build);
            return this;
        }
    };
    p.path = p.pathname;
    p.href = function(href, build) {
        var key;
        if (href === undefined) return this.toString();
        this._string = "";
        this._parts = URI._parts();
        var _URI = href instanceof URI;
        var _object = typeof href === "object" && (href.hostname || href.path || href.pathname);
        if (href.nodeName) {
            var attribute = URI.getDomAttribute(href);
            href = href[attribute] || "";
            _object = false;
        }
        // window.location is reported to be an object, but it's not the sort
        // of object we're looking for:
        // * location.protocol ends with a colon
        // * location.query != object.search
        // * location.hash != object.fragment
        // simply serializing the unknown object should do the trick
        // (for location, not for everything...)
        if (!_URI && _object && href.pathname !== undefined) href = href.toString();
        if (typeof href === "string" || href instanceof String) this._parts = URI.parse(String(href), this._parts);
        else if (_URI || _object) {
            var src = _URI ? href._parts : href;
            for(key in src){
                if (key === "query") continue;
                if (hasOwn.call(this._parts, key)) this._parts[key] = src[key];
            }
            if (src.query) this.query(src.query, false);
        } else throw new TypeError("invalid input");
        this.build(!build);
        return this;
    };
    // identification accessors
    p.is = function(what) {
        var ip = false;
        var ip4 = false;
        var ip6 = false;
        var name = false;
        var sld = false;
        var idn = false;
        var punycode = false;
        var relative = !this._parts.urn;
        if (this._parts.hostname) {
            relative = false;
            ip4 = URI.ip4_expression.test(this._parts.hostname);
            ip6 = URI.ip6_expression.test(this._parts.hostname);
            ip = ip4 || ip6;
            name = !ip;
            sld = name && SLD && SLD.has(this._parts.hostname);
            idn = name && URI.idn_expression.test(this._parts.hostname);
            punycode = name && URI.punycode_expression.test(this._parts.hostname);
        }
        switch(what.toLowerCase()){
            case "relative":
                return relative;
            case "absolute":
                return !relative;
            // hostname identification
            case "domain":
            case "name":
                return name;
            case "sld":
                return sld;
            case "ip":
                return ip;
            case "ip4":
            case "ipv4":
            case "inet4":
                return ip4;
            case "ip6":
            case "ipv6":
            case "inet6":
                return ip6;
            case "idn":
                return idn;
            case "url":
                return !this._parts.urn;
            case "urn":
                return !!this._parts.urn;
            case "punycode":
                return punycode;
        }
        return null;
    };
    // component specific input validation
    var _protocol = p.protocol;
    var _port = p.port;
    var _hostname = p.hostname;
    p.protocol = function(v, build) {
        if (v) {
            // accept trailing ://
            v = v.replace(/:(\/\/)?$/, "");
            if (!v.match(URI.protocol_expression)) throw new TypeError('Protocol "' + v + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
        }
        return _protocol.call(this, v, build);
    };
    p.scheme = p.protocol;
    p.port = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v !== undefined) {
            if (v === 0) v = null;
            if (v) {
                v += "";
                if (v.charAt(0) === ":") v = v.substring(1);
                URI.ensureValidPort(v);
            }
        }
        return _port.call(this, v, build);
    };
    p.hostname = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v !== undefined) {
            var x = {
                preventInvalidHostname: this._parts.preventInvalidHostname
            };
            var res = URI.parseHost(v, x);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            v = x.hostname;
            if (this._parts.preventInvalidHostname) URI.ensureValidHostname(v, this._parts.protocol);
        }
        return _hostname.call(this, v, build);
    };
    // compound accessors
    p.origin = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) {
            var protocol = this.protocol();
            var authority = this.authority();
            if (!authority) return "";
            return (protocol ? protocol + "://" : "") + this.authority();
        } else {
            var origin = URI(v);
            this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
            return this;
        }
    };
    p.host = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) return this._parts.hostname ? URI.buildHost(this._parts) : "";
        else {
            var res = URI.parseHost(v, this._parts);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.authority = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) return this._parts.hostname ? URI.buildAuthority(this._parts) : "";
        else {
            var res = URI.parseAuthority(v, this._parts);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.userinfo = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) {
            var t = URI.buildUserinfo(this._parts);
            return t ? t.substring(0, t.length - 1) : t;
        } else {
            if (v[v.length - 1] !== "@") v += "@";
            URI.parseUserinfo(v, this._parts);
            this.build(!build);
            return this;
        }
    };
    p.resource = function(v, build) {
        var parts;
        if (v === undefined) return this.path() + this.search() + this.hash();
        parts = URI.parse(v);
        this._parts.path = parts.path;
        this._parts.query = parts.query;
        this._parts.fragment = parts.fragment;
        this.build(!build);
        return this;
    };
    // fraction accessors
    p.subdomain = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        // convenience, return "www" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            // grab domain and add another segment
            var end = this._parts.hostname.length - this.domain().length - 1;
            return this._parts.hostname.substring(0, end) || "";
        } else {
            var e = this._parts.hostname.length - this.domain().length;
            var sub = this._parts.hostname.substring(0, e);
            var replace = new RegExp("^" + escapeRegEx(sub));
            if (v && v.charAt(v.length - 1) !== ".") v += ".";
            if (v.indexOf(":") !== -1) throw new TypeError("Domains cannot contain colons");
            if (v) URI.ensureValidHostname(v, this._parts.protocol);
            this._parts.hostname = this._parts.hostname.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.domain = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v === "boolean") {
            build = v;
            v = undefined;
        }
        // convenience, return "example.org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            // if hostname consists of 1 or 2 segments, it must be the domain
            var t = this._parts.hostname.match(/\./g);
            if (t && t.length < 2) return this._parts.hostname;
            // grab tld and add another segment
            var end = this._parts.hostname.length - this.tld(build).length - 1;
            end = this._parts.hostname.lastIndexOf(".", end - 1) + 1;
            return this._parts.hostname.substring(end) || "";
        } else {
            if (!v) throw new TypeError("cannot set domain empty");
            if (v.indexOf(":") !== -1) throw new TypeError("Domains cannot contain colons");
            URI.ensureValidHostname(v, this._parts.protocol);
            if (!this._parts.hostname || this.is("IP")) this._parts.hostname = v;
            else {
                var replace = new RegExp(escapeRegEx(this.domain()) + "$");
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.tld = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v === "boolean") {
            build = v;
            v = undefined;
        }
        // return "org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            var pos = this._parts.hostname.lastIndexOf(".");
            var tld = this._parts.hostname.substring(pos + 1);
            if (build !== true && SLD && SLD.list[tld.toLowerCase()]) return SLD.get(this._parts.hostname) || tld;
            return tld;
        } else {
            var replace;
            if (!v) throw new TypeError("cannot set TLD empty");
            else if (v.match(/[^a-zA-Z0-9-]/)) {
                if (SLD && SLD.is(v)) {
                    replace = new RegExp(escapeRegEx(this.tld()) + "$");
                    this._parts.hostname = this._parts.hostname.replace(replace, v);
                } else throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
            } else if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
            else {
                replace = new RegExp(escapeRegEx(this.tld()) + "$");
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.directory = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined || v === true) {
            if (!this._parts.path && !this._parts.hostname) return "";
            if (this._parts.path === "/") return "/";
            var end = this._parts.path.length - this.filename().length - 1;
            var res = this._parts.path.substring(0, end) || (this._parts.hostname ? "/" : "");
            return v ? URI.decodePath(res) : res;
        } else {
            var e = this._parts.path.length - this.filename().length;
            var directory = this._parts.path.substring(0, e);
            var replace = new RegExp("^" + escapeRegEx(directory));
            // fully qualifier directories begin with a slash
            if (!this.is("relative")) {
                if (!v) v = "/";
                if (v.charAt(0) !== "/") v = "/" + v;
            }
            // directories always end with a slash
            if (v && v.charAt(v.length - 1) !== "/") v += "/";
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.filename = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v !== "string") {
            if (!this._parts.path || this._parts.path === "/") return "";
            var pos = this._parts.path.lastIndexOf("/");
            var res = this._parts.path.substring(pos + 1);
            return v ? URI.decodePathSegment(res) : res;
        } else {
            var mutatedDirectory = false;
            if (v.charAt(0) === "/") v = v.substring(1);
            if (v.match(/\.?\//)) mutatedDirectory = true;
            var replace = new RegExp(escapeRegEx(this.filename()) + "$");
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            if (mutatedDirectory) this.normalizePath(build);
            else this.build(!build);
            return this;
        }
    };
    p.suffix = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined || v === true) {
            if (!this._parts.path || this._parts.path === "/") return "";
            var filename = this.filename();
            var pos = filename.lastIndexOf(".");
            var s, res;
            if (pos === -1) return "";
            // suffix may only contain alnum characters (yup, I made this up.)
            s = filename.substring(pos + 1);
            res = /^[a-z0-9%]+$/i.test(s) ? s : "";
            return v ? URI.decodePathSegment(res) : res;
        } else {
            if (v.charAt(0) === ".") v = v.substring(1);
            var suffix = this.suffix();
            var replace;
            if (!suffix) {
                if (!v) return this;
                this._parts.path += "." + URI.recodePath(v);
            } else if (!v) replace = new RegExp(escapeRegEx("." + suffix) + "$");
            else replace = new RegExp(escapeRegEx(suffix) + "$");
            if (replace) {
                v = URI.recodePath(v);
                this._parts.path = this._parts.path.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.segment = function(segment, v, build) {
        var separator = this._parts.urn ? ":" : "/";
        var path = this.path();
        var absolute = path.substring(0, 1) === "/";
        var segments = path.split(separator);
        if (segment !== undefined && typeof segment !== "number") {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (segment !== undefined && typeof segment !== "number") throw new Error('Bad segment "' + segment + '", must be 0-based integer');
        if (absolute) segments.shift();
        if (segment < 0) // allow negative indexes to address from the end
        segment = Math.max(segments.length + segment, 0);
        if (v === undefined) /*jshint laxbreak: true */ return segment === undefined ? segments : segments[segment];
        else if (segment === null || segments[segment] === undefined) {
            if (isArray(v)) {
                segments = [];
                // collapse empty elements within array
                for(var i = 0, l = v.length; i < l; i++){
                    if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) continue;
                    if (segments.length && !segments[segments.length - 1].length) segments.pop();
                    segments.push(trimSlashes(v[i]));
                }
            } else if (v || typeof v === "string") {
                v = trimSlashes(v);
                if (segments[segments.length - 1] === "") // empty trailing elements have to be overwritten
                // to prevent results such as /foo//bar
                segments[segments.length - 1] = v;
                else segments.push(v);
            }
        } else if (v) segments[segment] = trimSlashes(v);
        else segments.splice(segment, 1);
        if (absolute) segments.unshift("");
        return this.path(segments.join(separator), build);
    };
    p.segmentCoded = function(segment, v, build) {
        var segments, i, l;
        if (typeof segment !== "number") {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (v === undefined) {
            segments = this.segment(segment, v, build);
            if (!isArray(segments)) segments = segments !== undefined ? URI.decode(segments) : undefined;
            else for(i = 0, l = segments.length; i < l; i++)segments[i] = URI.decode(segments[i]);
            return segments;
        }
        if (!isArray(v)) v = typeof v === "string" || v instanceof String ? URI.encode(v) : v;
        else for(i = 0, l = v.length; i < l; i++)v[i] = URI.encode(v[i]);
        return this.segment(segment, v, build);
    };
    // mutating query string
    var q = p.query;
    p.query = function(v, build) {
        if (v === true) return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        else if (typeof v === "function") {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            var result = v.call(this, data);
            this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else if (v !== undefined && typeof v !== "string") {
            this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else return q.call(this, v, build);
    };
    p.setQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        if (typeof name === "string" || name instanceof String) data[name] = value !== undefined ? value : null;
        else if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) data[key] = name[key];
        } else throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.addQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.addQuery(data, name, value === undefined ? null : value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.removeQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.removeQuery(data, name, value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.hasQuery = function(name, value, withinArray) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        return URI.hasQuery(data, name, value, withinArray);
    };
    p.setSearch = p.setQuery;
    p.addSearch = p.addQuery;
    p.removeSearch = p.removeQuery;
    p.hasSearch = p.hasQuery;
    // sanitizing URLs
    p.normalize = function() {
        if (this._parts.urn) return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
        return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    };
    p.normalizeProtocol = function(build) {
        if (typeof this._parts.protocol === "string") {
            this._parts.protocol = this._parts.protocol.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizeHostname = function(build) {
        if (this._parts.hostname) {
            if (this.is("IDN") && punycode) this._parts.hostname = punycode.toASCII(this._parts.hostname);
            else if (this.is("IPv6") && IPv6) this._parts.hostname = IPv6.best(this._parts.hostname);
            this._parts.hostname = this._parts.hostname.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizePort = function(build) {
        // remove port of it's the protocol's default
        if (typeof this._parts.protocol === "string" && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
            this._parts.port = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizePath = function(build) {
        var _path = this._parts.path;
        if (!_path) return this;
        if (this._parts.urn) {
            this._parts.path = URI.recodeUrnPath(this._parts.path);
            this.build(!build);
            return this;
        }
        if (this._parts.path === "/") return this;
        _path = URI.recodePath(_path);
        var _was_relative;
        var _leadingParents = "";
        var _parent, _pos;
        // handle relative paths
        if (_path.charAt(0) !== "/") {
            _was_relative = true;
            _path = "/" + _path;
        }
        // handle relative files (as opposed to directories)
        if (_path.slice(-3) === "/.." || _path.slice(-2) === "/.") _path += "/";
        // resolve simples
        _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/");
        // remember leading parents
        if (_was_relative) {
            _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || "";
            if (_leadingParents) _leadingParents = _leadingParents[0];
        }
        // resolve parents
        while(true){
            _parent = _path.search(/\/\.\.(\/|$)/);
            if (_parent === -1) break;
            else if (_parent === 0) {
                // top level cannot be relative, skip it
                _path = _path.substring(3);
                continue;
            }
            _pos = _path.substring(0, _parent).lastIndexOf("/");
            if (_pos === -1) _pos = _parent;
            _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
        }
        // revert to relative
        if (_was_relative && this.is("relative")) _path = _leadingParents + _path.substring(1);
        this._parts.path = _path;
        this.build(!build);
        return this;
    };
    p.normalizePathname = p.normalizePath;
    p.normalizeQuery = function(build) {
        if (typeof this._parts.query === "string") {
            if (!this._parts.query.length) this._parts.query = null;
            else this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
            this.build(!build);
        }
        return this;
    };
    p.normalizeFragment = function(build) {
        if (!this._parts.fragment) {
            this._parts.fragment = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizeSearch = p.normalizeQuery;
    p.normalizeHash = p.normalizeFragment;
    p.iso8859 = function() {
        // expect unicode input, iso8859 output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = escape;
        URI.decode = decodeURIComponent;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.unicode = function() {
        // expect iso8859 input, unicode output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = strictEncodeURIComponent;
        URI.decode = unescape;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.readable = function() {
        var uri = this.clone();
        // removing username, password, because they shouldn't be displayed according to RFC 3986
        uri.username("").password("").normalize();
        var t = "";
        if (uri._parts.protocol) t += uri._parts.protocol + "://";
        if (uri._parts.hostname) {
            if (uri.is("punycode") && punycode) {
                t += punycode.toUnicode(uri._parts.hostname);
                if (uri._parts.port) t += ":" + uri._parts.port;
            } else t += uri.host();
        }
        if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== "/") t += "/";
        t += uri.path(true);
        if (uri._parts.query) {
            var q = "";
            for(var i = 0, qp = uri._parts.query.split("&"), l = qp.length; i < l; i++){
                var kv = (qp[i] || "").split("=");
                q += "&" + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, "%26");
                if (kv[1] !== undefined) q += "=" + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, "%26");
            }
            t += "?" + q.substring(1);
        }
        t += URI.decodeQuery(uri.hash(), true);
        return t;
    };
    // resolving relative and absolute URLs
    p.absoluteTo = function(base) {
        var resolved = this.clone();
        var properties = [
            "protocol",
            "username",
            "password",
            "hostname",
            "port"
        ];
        var basedir, i, p;
        if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
        if (!(base instanceof URI)) base = new URI(base);
        if (resolved._parts.protocol) // Directly returns even if this._parts.hostname is empty.
        return resolved;
        else resolved._parts.protocol = base._parts.protocol;
        if (this._parts.hostname) return resolved;
        for(i = 0; p = properties[i]; i++)resolved._parts[p] = base._parts[p];
        if (!resolved._parts.path) {
            resolved._parts.path = base._parts.path;
            if (!resolved._parts.query) resolved._parts.query = base._parts.query;
        } else {
            if (resolved._parts.path.substring(-2) === "..") resolved._parts.path += "/";
            if (resolved.path().charAt(0) !== "/") {
                basedir = base.directory();
                basedir = basedir ? basedir : base.path().indexOf("/") === 0 ? "/" : "";
                resolved._parts.path = (basedir ? basedir + "/" : "") + resolved._parts.path;
                resolved.normalizePath();
            }
        }
        resolved.build();
        return resolved;
    };
    p.relativeTo = function(base) {
        var relative = this.clone().normalize();
        var relativeParts, baseParts, common, relativePath, basePath;
        if (relative._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
        base = new URI(base).normalize();
        relativeParts = relative._parts;
        baseParts = base._parts;
        relativePath = relative.path();
        basePath = base.path();
        if (relativePath.charAt(0) !== "/") throw new Error("URI is already relative");
        if (basePath.charAt(0) !== "/") throw new Error("Cannot calculate a URI relative to another relative URI");
        if (relativeParts.protocol === baseParts.protocol) relativeParts.protocol = null;
        if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) return relative.build();
        if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) return relative.build();
        if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
            relativeParts.hostname = null;
            relativeParts.port = null;
        } else return relative.build();
        if (relativePath === basePath) {
            relativeParts.path = "";
            return relative.build();
        }
        // determine common sub path
        common = URI.commonPath(relativePath, basePath);
        // If the paths have nothing in common, return a relative URL with the absolute path.
        if (!common) return relative.build();
        var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
        relativeParts.path = parents + relativeParts.path.substring(common.length) || "./";
        return relative.build();
    };
    // comparing URIs
    p.equals = function(uri) {
        var one = this.clone();
        var two = new URI(uri);
        var one_map = {};
        var two_map = {};
        var checked = {};
        var one_query, two_query, key;
        one.normalize();
        two.normalize();
        // exact match
        if (one.toString() === two.toString()) return true;
        // extract query string
        one_query = one.query();
        two_query = two.query();
        one.query("");
        two.query("");
        // definitely not equal if not even non-query parts match
        if (one.toString() !== two.toString()) return false;
        // query parameters have the same length, even if they're permuted
        if (one_query.length !== two_query.length) return false;
        one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
        two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
        for(key in one_map)if (hasOwn.call(one_map, key)) {
            if (!isArray(one_map[key])) {
                if (one_map[key] !== two_map[key]) return false;
            } else if (!arraysEqual(one_map[key], two_map[key])) return false;
            checked[key] = true;
        }
        for(key in two_map)if (hasOwn.call(two_map, key)) {
            if (!checked[key]) // two contains a parameter not present in one
            return false;
        }
        return true;
    };
    // state
    p.preventInvalidHostname = function(v) {
        this._parts.preventInvalidHostname = !!v;
        return this;
    };
    p.duplicateQueryParameters = function(v) {
        this._parts.duplicateQueryParameters = !!v;
        return this;
    };
    p.escapeQuerySpace = function(v) {
        this._parts.escapeQuerySpace = !!v;
        return this;
    };
    return URI;
});


var $b749015d180113c6$exports = {};
(function(root, factory, undefined1) {
    "use strict";
    if (typeof define === "function" && define.amd) define([], factory);
    else $b749015d180113c6$exports = factory();
})(window, function() {
    "use strict";
    var CookiesEuBanner, document = window.document;
    CookiesEuBanner = function(launchFunction, waitAccept, undefined1) {
        if (!(this instanceof CookiesEuBanner)) return new CookiesEuBanner(launchFunction);
        this.cookieTimeout = 33696000000; // 13 months in milliseconds
        this.bots = /bot|googlebot|crawler|spider|robot|crawling/i;
        this.cookieName = "hasConsent";
        this.trackingCookiesNames = [
            "__utma",
            "__utmb",
            "__utmc",
            "__utmt",
            "__utmv",
            "__utmz",
            "_ga",
            "_gat",
            "_gid"
        ];
        this.launchFunction = launchFunction;
        this.waitAccept = waitAccept || false;
        this.init();
    };
    CookiesEuBanner.prototype = {
        init: function init() {
            // Do nothing if it is a bot
            // If DoNotTrack is activated, do nothing too
            if (this.isBot() || !this.isToTrack() || this.hasConsent() === false) return false;
            // User has already consent to use cookies to tracking
            if (this.hasConsent() === true) {
                // Launch user custom function
                this.launchFunction();
                return true;
            }
            // If it's not a bot, no DoNotTrack and not already accept : show banner
            this.showBanner();
            if (!this.waitAccept) // Accept cookies by default for the next page
            this.setCookie(this.cookieName, true);
        },
        /*
     * Show banner at the top of the page
     */ showBanner: function showBanner() {
            var _this = this, banner = document.getElementById("cookies-eu-banner"), rejectButton = document.getElementById("cookies-eu-reject"), acceptButton = document.getElementById("cookies-eu-accept"), moreLink = document.getElementById("cookies-eu-more"), waitRemove = banner.dataset.waitRemove === undefined ? 0 : parseInt(banner.dataset.waitRemove);
            banner.style.display = "block";
            if (moreLink) this.addEventListener(moreLink, "click", function() {
                _this.deleteCookie(_this.cookieName);
            });
            if (acceptButton) this.addEventListener(acceptButton, "click", function() {
                _this.removeBanner(banner, waitRemove);
                _this.setCookie(_this.cookieName, true);
                _this.launchFunction();
            });
            if (rejectButton) this.addEventListener(rejectButton, "click", function() {
                _this.removeBanner(banner, waitRemove);
                _this.setCookie(_this.cookieName, false);
                _this.deleteTrackingCookies();
            });
        },
        /*
     * Check if user already consent
     */ hasConsent: function hasConsent() {
            if (document.cookie.indexOf(this.cookieName + "=true") > -1) return true;
            else if (document.cookie.indexOf(this.cookieName + "=false") > -1) return false;
            return null;
        },
        /*
     * Detect if the visitor is a bot or not
     * Prevent for search engine take the cookie
     * alert message as main content of the page
     */ isBot: function isBot() {
            return this.bots.test(navigator.userAgent);
        },
        /*
     * Check if DoNotTrack is activated
     */ isToTrack: function isToTrack() {
            var dnt = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
            return dnt !== null && dnt !== undefined ? dnt && dnt !== "yes" && dnt !== 1 && dnt !== "1" : true;
        },
        /*
     * Delete existent tracking cookies
     */ deleteTrackingCookies: function deleteTrackingCookies() {
            var _this = this;
            this.trackingCookiesNames.map(function(cookieName) {
                _this.deleteCookie(cookieName);
            });
        },
        /*
     * Create/update cookie
     */ setCookie: function setCookie(name, value) {
            var date = new Date();
            date.setTime(date.getTime() + this.cookieTimeout);
            document.cookie = name + "=" + value + ";expires=" + date.toGMTString() + ";path=/";
        },
        /*
     * Delete cookie by changing expire
     */ deleteCookie: function deleteCookie(name) {
            var hostname = document.location.hostname;
            if (hostname.indexOf("www.") === 0) hostname = hostname.substring(4);
            document.cookie = name + "=; domain=." + hostname + "; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
            document.cookie = name + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
        },
        addEventListener: function addEventListener(DOMElement, evnt, callback) {
            if (document.addEventListener) DOMElement.addEventListener(evnt, callback);
            else if (DOMElement.attachEvent) DOMElement.attachEvent("on" + evnt, callback);
        },
        /*
     * Delays removal of banner allowing developers
     * to specify their own transition effects
     */ removeBanner: function removeBanner(banner, wait) {
            setTimeout(function() {
                banner.parentNode.removeChild(banner);
            }, wait);
        }
    };
    return CookiesEuBanner;
});



var $aPoFX = parcelRequire("aPoFX");
var $23e1e44ff66ceb71$exports = {};
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else $23e1e44ff66ceb71$exports = factory();
})($23e1e44ff66ceb71$exports, function() {
    "use strict";
    var PhotoSwipe = function PhotoSwipe(template, UiClass, items, options) {
        /*>>framework-bridge*/ /**
 *
 * Set of generic functions used by gallery.
 * 
 * You're free to modify anything here as long as functionality is kept.
 * 
 */ var framework = {
            features: null,
            bind: function bind(target, type, listener, unbind) {
                var methodName = (unbind ? "remove" : "add") + "EventListener";
                type = type.split(" ");
                for(var i = 0; i < type.length; i++)if (type[i]) target[methodName](type[i], listener, false);
            },
            isArray: function isArray(obj) {
                return obj instanceof Array;
            },
            createEl: function createEl(classes, tag) {
                var el = document.createElement(tag || "div");
                if (classes) el.className = classes;
                return el;
            },
            getScrollY: function getScrollY() {
                var yOffset = window.pageYOffset;
                return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
            },
            unbind: function unbind(target, type, listener) {
                framework.bind(target, type, listener, true);
            },
            removeClass: function removeClass(el, className) {
                var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
                el.className = el.className.replace(reg, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            },
            addClass: function addClass(el, className) {
                if (!framework.hasClass(el, className)) el.className += (el.className ? " " : "") + className;
            },
            hasClass: function hasClass(el, className) {
                return el.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(el.className);
            },
            getChildByClass: function getChildByClass(parentEl, childClassName) {
                var node = parentEl.firstChild;
                while(node){
                    if (framework.hasClass(node, childClassName)) return node;
                    node = node.nextSibling;
                }
            },
            arraySearch: function arraySearch(array, value, key) {
                var i = array.length;
                while(i--){
                    if (array[i][key] === value) return i;
                }
                return -1;
            },
            extend: function extend(o1, o2, preventOverwrite) {
                for(var prop in o2)if (o2.hasOwnProperty(prop)) {
                    if (preventOverwrite && o1.hasOwnProperty(prop)) continue;
                    o1[prop] = o2[prop];
                }
            },
            easing: {
                sine: {
                    out: function out(k) {
                        return Math.sin(k * (Math.PI / 2));
                    },
                    inOut: function inOut(k) {
                        return -(Math.cos(Math.PI * k) - 1) / 2;
                    }
                },
                cubic: {
                    out: function out(k) {
                        return --k * k * k + 1;
                    }
                }
            },
            /**
	 * 
	 * @return {object}
	 * 
	 * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
	 * 
	 */ detectFeatures: function detectFeatures() {
                if (framework.features) return framework.features;
                var helperEl = framework.createEl(), helperStyle = helperEl.style, vendor = "", features = {};
                // IE8 and below
                features.oldIE = document.all && !document.addEventListener;
                features.touch = "ontouchstart" in window;
                if (window.requestAnimationFrame) {
                    features.raf = window.requestAnimationFrame;
                    features.caf = window.cancelAnimationFrame;
                }
                features.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled;
                // fix false-positive detection of old Android in new IE
                // (IE11 ua string contains "Android 4.0")
                if (!features.pointerEvent) {
                    var ua = navigator.userAgent;
                    // Detect if device is iPhone or iPod and if it's older than iOS 8
                    // http://stackoverflow.com/a/14223920
                    // 
                    // This detection is made because of buggy top/bottom toolbars
                    // that don't trigger window.resize event.
                    // For more info refer to _isFixedPosition variable in core.js
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        if (v && v.length > 0) {
                            v = parseInt(v[1], 10);
                            if (v >= 1 && v < 8) features.isOldIOSPhone = true;
                        }
                    }
                    // Detect old Android (before KitKat)
                    // due to bugs related to position:fixed
                    // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
                    var match = ua.match(/Android\s([0-9\.]*)/);
                    var androidversion = match ? match[1] : 0;
                    androidversion = parseFloat(androidversion);
                    if (androidversion >= 1) {
                        if (androidversion < 4.4) features.isOldAndroid = true; // for fixed position bug & performance
                        features.androidVersion = androidversion; // for touchend bug
                    }
                    features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
                // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
                }
                var styleChecks = [
                    "transform",
                    "perspective",
                    "animationName"
                ], vendors = [
                    "",
                    "webkit",
                    "Moz",
                    "ms",
                    "O"
                ], styleCheckItem, styleName;
                for(var i = 0; i < 4; i++){
                    vendor = vendors[i];
                    for(var a = 0; a < 3; a++){
                        styleCheckItem = styleChecks[a];
                        // uppercase first letter of property name, if vendor is present
                        styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);
                        if (!features[styleCheckItem] && styleName in helperStyle) features[styleCheckItem] = styleName;
                    }
                    if (vendor && !features.raf) {
                        vendor = vendor.toLowerCase();
                        features.raf = window[vendor + "RequestAnimationFrame"];
                        if (features.raf) features.caf = window[vendor + "CancelAnimationFrame"] || window[vendor + "CancelRequestAnimationFrame"];
                    }
                }
                if (!features.raf) {
                    var lastTime = 0;
                    features.raf = function(fn) {
                        var currTime = new Date().getTime();
                        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                        var id = window.setTimeout(function() {
                            fn(currTime + timeToCall);
                        }, timeToCall);
                        lastTime = currTime + timeToCall;
                        return id;
                    };
                    features.caf = function(id) {
                        clearTimeout(id);
                    };
                }
                // Detect SVG support
                features.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect;
                framework.features = features;
                return features;
            }
        };
        framework.detectFeatures();
        // Override addEventListener for old versions of IE
        if (framework.features.oldIE) framework.bind = function(target, type, listener, unbind) {
            type = type.split(" ");
            var methodName = (unbind ? "detach" : "attach") + "Event", evName, _handleEv = function _handleEv() {
                listener.handleEvent.call(listener);
            };
            for(var i = 0; i < type.length; i++){
                evName = type[i];
                if (evName) {
                    if (typeof listener === "object" && listener.handleEvent) {
                        if (!unbind) listener["oldIE" + evName] = _handleEv;
                        else {
                            if (!listener["oldIE" + evName]) return false;
                        }
                        target[methodName]("on" + evName, listener["oldIE" + evName]);
                    } else target[methodName]("on" + evName, listener);
                }
            }
        };
        /*>>framework-bridge*/ /*>>core*/ //function(template, UiClass, items, options)
        var self = this;
        /**
 * Static vars, don't change unless you know what you're doing.
 */ var DOUBLE_TAP_RADIUS = 25, NUM_HOLDERS = 3;
        /**
 * Options
 */ var _options = {
            allowPanToNext: true,
            spacing: 0.12,
            bgOpacity: 1,
            mouseUsed: false,
            loop: true,
            pinchToClose: true,
            closeOnScroll: true,
            closeOnVerticalDrag: true,
            verticalDragRange: 0.75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: false,
            focus: true,
            escKey: true,
            arrowKeys: true,
            mainScrollEndFriction: 0.35,
            panEndFriction: 0.35,
            isClickableElement: function isClickableElement(el) {
                return el.tagName === "A";
            },
            getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                if (isMouseClick) return 1;
                else return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            maxSpreadZoom: 1.33,
            modal: true,
            // not fully implemented yet
            scaleMode: "fit" // TODO
        };
        framework.extend(_options, options);
        /**
 * Private helper variables & functions
 */ var _getEmptyPoint = function _getEmptyPoint() {
            return {
                x: 0,
                y: 0
            };
        };
        var _isOpen, _isDestroying, _closedByScroll, _currentItemIndex, _containerStyle, _containerShiftIndex, _currPanDist = _getEmptyPoint(), _startPanOffset = _getEmptyPoint(), _panOffset = _getEmptyPoint(), _upMoveEvents, _downEvents, _globalEventHandlers, _viewportSize = {}, _currZoomLevel, _startZoomLevel, _translatePrefix, _translateSufix, _updateSizeInterval, _itemsNeedUpdate, _currPositionIndex = 0, _offset = {}, _slideSize = _getEmptyPoint(), _itemHolders, _prevItemIndex, _indexDiff = 0, _dragStartEvent, _dragMoveEvent, _dragEndEvent, _dragCancelEvent, _transformKey, _pointerEventEnabled, _isFixedPosition = true, _likelyTouchDevice, _modules = [], _requestAF, _cancelAF, _initalClassName, _initalWindowScrollY, _oldIE, _currentWindowScrollY, _features, _windowVisibleSize = {}, _renderMaxResolution = false, _orientationChangeTimeout, // Registers PhotoSWipe module (History, Controller ...)
        _registerModule = function _registerModule(name, module1) {
            framework.extend(self, module1.publicMethods);
            _modules.push(name);
        }, _getLoopedId = function _getLoopedId(index) {
            var numSlides = _getNumItems();
            if (index > numSlides - 1) return index - numSlides;
            else if (index < 0) return numSlides + index;
            return index;
        }, // Micro bind/trigger
        _listeners = {}, _listen = function _listen(name, fn) {
            if (!_listeners[name]) _listeners[name] = [];
            return _listeners[name].push(fn);
        }, _shout = function _shout(name) {
            var listeners = _listeners[name];
            if (listeners) {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                for(var i = 0; i < listeners.length; i++)listeners[i].apply(self, args);
            }
        }, _getCurrentTime = function _getCurrentTime() {
            return new Date().getTime();
        }, _applyBgOpacity = function _applyBgOpacity(opacity) {
            _bgOpacity = opacity;
            self.bg.style.opacity = opacity * _options.bgOpacity;
        }, _applyZoomTransform = function _applyZoomTransform(styleObj, x, y, zoom, item) {
            if (!_renderMaxResolution || item && item !== self.currItem) zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
            styleObj[_transformKey] = _translatePrefix + x + "px, " + y + "px" + _translateSufix + " scale(" + zoom + ")";
        }, _applyCurrentZoomPan = function _applyCurrentZoomPan(allowRenderResolution) {
            if (_currZoomElementStyle) {
                if (allowRenderResolution) {
                    if (_currZoomLevel > self.currItem.fitRatio) {
                        if (!_renderMaxResolution) {
                            _setImageSize(self.currItem, false, true);
                            _renderMaxResolution = true;
                        }
                    } else if (_renderMaxResolution) {
                        _setImageSize(self.currItem);
                        _renderMaxResolution = false;
                    }
                }
                _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
            }
        }, _applyZoomPanToItem = function _applyZoomPanToItem(item) {
            if (item.container) _applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item);
        }, _setTranslateX = function _setTranslateX(x, elStyle) {
            elStyle[_transformKey] = _translatePrefix + x + "px, 0px" + _translateSufix;
        }, _moveMainScroll = function _moveMainScroll(x, dragging) {
            if (!_options.loop && dragging) {
                var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x, delta = Math.round(x - _mainScrollPos.x);
                if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
            }
            _mainScrollPos.x = x;
            _setTranslateX(x, _containerStyle);
        }, _calculatePanOffset = function _calculatePanOffset(axis, zoomLevel) {
            var m = _midZoomPoint[axis] - _offset[axis];
            return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel);
        }, _equalizePoints = function _equalizePoints(p1, p2) {
            p1.x = p2.x;
            p1.y = p2.y;
            if (p2.id) p1.id = p2.id;
        }, _roundPoint = function _roundPoint(p) {
            p.x = Math.round(p.x);
            p.y = Math.round(p.y);
        }, _mouseMoveTimeout = null, _onFirstMouseMove = function _onFirstMouseMove1() {
            // Wait until mouse move event is fired at least twice during 100ms
            // We do this, because some mobile browsers trigger it on touchstart
            if (_mouseMoveTimeout) {
                framework.unbind(document, "mousemove", _onFirstMouseMove);
                framework.addClass(template, "pswp--has_mouse");
                _options.mouseUsed = true;
                _shout("mouseUsed");
            }
            _mouseMoveTimeout = setTimeout(function() {
                _mouseMoveTimeout = null;
            }, 100);
        }, _bindEvents = function _bindEvents() {
            framework.bind(document, "keydown", self);
            if (_features.transform) // don't bind click event in browsers that don't support transform (mostly IE8)
            framework.bind(self.scrollWrap, "click", self);
            if (!_options.mouseUsed) framework.bind(document, "mousemove", _onFirstMouseMove);
            framework.bind(window, "resize scroll orientationchange", self);
            _shout("bindEvents");
        }, _unbindEvents = function _unbindEvents() {
            framework.unbind(window, "resize scroll orientationchange", self);
            framework.unbind(window, "scroll", _globalEventHandlers.scroll);
            framework.unbind(document, "keydown", self);
            framework.unbind(document, "mousemove", _onFirstMouseMove);
            if (_features.transform) framework.unbind(self.scrollWrap, "click", self);
            if (_isDragging) framework.unbind(window, _upMoveEvents, self);
            clearTimeout(_orientationChangeTimeout);
            _shout("unbindEvents");
        }, _calculatePanBounds = function _calculatePanBounds(zoomLevel, update) {
            var bounds = _calculateItemSize(self.currItem, _viewportSize, zoomLevel);
            if (update) _currPanBounds = bounds;
            return bounds;
        }, _getMinZoomLevel = function _getMinZoomLevel(item) {
            if (!item) item = self.currItem;
            return item.initialZoomLevel;
        }, _getMaxZoomLevel = function _getMaxZoomLevel(item) {
            if (!item) item = self.currItem;
            return item.w > 0 ? _options.maxSpreadZoom : 1;
        }, // Return true if offset is out of the bounds
        _modifyDestPanOffset = function _modifyDestPanOffset(axis, destPanBounds, destPanOffset, destZoomLevel) {
            if (destZoomLevel === self.currItem.initialZoomLevel) {
                destPanOffset[axis] = self.currItem.initialPosition[axis];
                return true;
            } else {
                destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);
                if (destPanOffset[axis] > destPanBounds.min[axis]) {
                    destPanOffset[axis] = destPanBounds.min[axis];
                    return true;
                } else if (destPanOffset[axis] < destPanBounds.max[axis]) {
                    destPanOffset[axis] = destPanBounds.max[axis];
                    return true;
                }
            }
            return false;
        }, _setupTransforms = function _setupTransforms() {
            if (_transformKey) {
                // setup 3d transforms
                var allow3dTransform = _features.perspective && !_likelyTouchDevice;
                _translatePrefix = "translate" + (allow3dTransform ? "3d(" : "(");
                _translateSufix = _features.perspective ? ", 0px)" : ")";
                return;
            }
            // Override zoom/pan/move functions in case old browser is used (most likely IE)
            // (so they use left/top/width/height, instead of CSS transform)
            _transformKey = "left";
            framework.addClass(template, "pswp--ie");
            _setTranslateX = function _setTranslateX(x, elStyle) {
                elStyle.left = x + "px";
            };
            _applyZoomPanToItem = function _applyZoomPanToItem(item) {
                var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, s = item.container.style, w = zoomRatio * item.w, h = zoomRatio * item.h;
                s.width = w + "px";
                s.height = h + "px";
                s.left = item.initialPosition.x + "px";
                s.top = item.initialPosition.y + "px";
            };
            _applyCurrentZoomPan = function _applyCurrentZoomPan() {
                if (_currZoomElementStyle) {
                    var s = _currZoomElementStyle, item = self.currItem, zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, w = zoomRatio * item.w, h = zoomRatio * item.h;
                    s.width = w + "px";
                    s.height = h + "px";
                    s.left = _panOffset.x + "px";
                    s.top = _panOffset.y + "px";
                }
            };
        }, _onKeyDown = function _onKeyDown(e) {
            var keydownAction = "";
            if (_options.escKey && e.keyCode === 27) keydownAction = "close";
            else if (_options.arrowKeys) {
                if (e.keyCode === 37) keydownAction = "prev";
                else if (e.keyCode === 39) keydownAction = "next";
            }
            if (keydownAction) // don't do anything if special key pressed to prevent from overriding default browser actions
            // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
            {
                if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                    self[keydownAction]();
                }
            }
        }, _onGlobalClick = function _onGlobalClick(e) {
            if (!e) return;
            // don't allow click event to pass through when triggering after drag or some other gesture
            if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, _updatePageScrollOffset = function _updatePageScrollOffset() {
            self.setScrollOffset(0, framework.getScrollY());
        };
        // Micro animation engine
        var _animations = {}, _numAnimations = 0, _stopAnimation = function _stopAnimation(name) {
            if (_animations[name]) {
                if (_animations[name].raf) _cancelAF(_animations[name].raf);
                _numAnimations--;
                delete _animations[name];
            }
        }, _registerStartAnimation = function _registerStartAnimation(name) {
            if (_animations[name]) _stopAnimation(name);
            if (!_animations[name]) {
                _numAnimations++;
                _animations[name] = {};
            }
        }, _stopAllAnimations = function _stopAllAnimations() {
            for(var prop in _animations)if (_animations.hasOwnProperty(prop)) _stopAnimation(prop);
        }, _animateProp = function _animateProp(name, b, endProp, d, easingFn, onUpdate, onComplete) {
            var startAnimTime = _getCurrentTime(), t;
            _registerStartAnimation(name);
            var animloop = function animloop1() {
                if (_animations[name]) {
                    t = _getCurrentTime() - startAnimTime; // time diff
                    //b - beginning (start prop)
                    //d - anim duration
                    if (t >= d) {
                        _stopAnimation(name);
                        onUpdate(endProp);
                        if (onComplete) onComplete();
                        return;
                    }
                    onUpdate((endProp - b) * easingFn(t / d) + b);
                    _animations[name].raf = _requestAF(animloop);
                }
            };
            animloop();
        };
        var publicMethods = {
            // make a few local variables and functions public
            shout: _shout,
            listen: _listen,
            viewportSize: _viewportSize,
            options: _options,
            isMainScrollAnimating: function isMainScrollAnimating() {
                return _mainScrollAnimating;
            },
            getZoomLevel: function getZoomLevel() {
                return _currZoomLevel;
            },
            getCurrentIndex: function getCurrentIndex() {
                return _currentItemIndex;
            },
            isDragging: function isDragging() {
                return _isDragging;
            },
            isZooming: function isZooming() {
                return _isZooming;
            },
            setScrollOffset: function setScrollOffset(x, y) {
                _offset.x = x;
                _currentWindowScrollY = _offset.y = y;
                _shout("updateScrollOffset", _offset);
            },
            applyZoomPan: function applyZoomPan(zoomLevel, panX, panY, allowRenderResolution) {
                _panOffset.x = panX;
                _panOffset.y = panY;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan(allowRenderResolution);
            },
            init: function init() {
                if (_isOpen || _isDestroying) return;
                var i;
                self.framework = framework; // basic functionality
                self.template = template; // root DOM element of PhotoSwipe
                self.bg = framework.getChildByClass(template, "pswp__bg");
                _initalClassName = template.className;
                _isOpen = true;
                _features = framework.detectFeatures();
                _requestAF = _features.raf;
                _cancelAF = _features.caf;
                _transformKey = _features.transform;
                _oldIE = _features.oldIE;
                self.scrollWrap = framework.getChildByClass(template, "pswp__scroll-wrap");
                self.container = framework.getChildByClass(self.scrollWrap, "pswp__container");
                _containerStyle = self.container.style; // for fast access
                // Objects that hold slides (there are only 3 in DOM)
                self.itemHolders = _itemHolders = [
                    {
                        el: self.container.children[0],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[1],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[2],
                        wrap: 0,
                        index: -1
                    }
                ];
                // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = "none";
                _setupTransforms();
                // Setup global events
                _globalEventHandlers = {
                    resize: self.updateSize,
                    // Fixes: iOS 10.3 resize event
                    // does not update scrollWrap.clientWidth instantly after resize
                    // https://github.com/dimsemenov/PhotoSwipe/issues/1315
                    orientationchange: function orientationchange() {
                        clearTimeout(_orientationChangeTimeout);
                        _orientationChangeTimeout = setTimeout(function() {
                            if (_viewportSize.x !== self.scrollWrap.clientWidth) self.updateSize();
                        }, 500);
                    },
                    scroll: _updatePageScrollOffset,
                    keydown: _onKeyDown,
                    click: _onGlobalClick
                };
                // disable show/hide effects on old browsers that don't support CSS animations or transforms, 
                // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
                var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
                if (!_features.animationName || !_features.transform || oldPhone) _options.showAnimationDuration = _options.hideAnimationDuration = 0;
                // init modules
                for(i = 0; i < _modules.length; i++)self["init" + _modules[i]]();
                // init
                if (UiClass) {
                    var ui = self.ui = new UiClass(self, framework);
                    ui.init();
                }
                _shout("firstUpdate");
                _currentItemIndex = _currentItemIndex || _options.index || 0;
                // validate index
                if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) _currentItemIndex = 0;
                self.currItem = _getItemAt(_currentItemIndex);
                if (_features.isOldIOSPhone || _features.isOldAndroid) _isFixedPosition = false;
                template.setAttribute("aria-hidden", "false");
                if (_options.modal) {
                    if (!_isFixedPosition) {
                        template.style.position = "absolute";
                        template.style.top = framework.getScrollY() + "px";
                    } else template.style.position = "fixed";
                }
                if (_currentWindowScrollY === undefined) {
                    _shout("initialLayout");
                    _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
                }
                // add classes to root element of PhotoSwipe
                var rootClasses = "pswp--open ";
                if (_options.mainClass) rootClasses += _options.mainClass + " ";
                if (_options.showHideOpacity) rootClasses += "pswp--animate_opacity ";
                rootClasses += _likelyTouchDevice ? "pswp--touch" : "pswp--notouch";
                rootClasses += _features.animationName ? " pswp--css_animation" : "";
                rootClasses += _features.svg ? " pswp--svg" : "";
                framework.addClass(template, rootClasses);
                self.updateSize();
                // initial update
                _containerShiftIndex = -1;
                _indexDiff = null;
                for(i = 0; i < NUM_HOLDERS; i++)_setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
                if (!_oldIE) framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
                _listen("initialZoomInEnd", function() {
                    self.setContent(_itemHolders[0], _currentItemIndex - 1);
                    self.setContent(_itemHolders[2], _currentItemIndex + 1);
                    _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = "block";
                    if (_options.focus) // focus causes layout, 
                    // which causes lag during the animation, 
                    // that's why we delay it untill the initial zoom transition ends
                    template.focus();
                    _bindEvents();
                });
                // set content for center slide (first time)
                self.setContent(_itemHolders[1], _currentItemIndex);
                self.updateCurrItem();
                _shout("afterInit");
                if (!_isFixedPosition) // On all versions of iOS lower than 8.0, we check size of viewport every second.
                // 
                // This is done to detect when Safari top & bottom bars appear, 
                // as this action doesn't trigger any events (like resize). 
                // 
                // On iOS8 they fixed this.
                // 
                // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
                _updateSizeInterval = setInterval(function() {
                    if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self.currItem.initialZoomLevel) self.updateSize();
                }, 1000);
                framework.addClass(template, "pswp--visible");
            },
            // Close the gallery, then destroy it
            close: function close() {
                if (!_isOpen) return;
                _isOpen = false;
                _isDestroying = true;
                _shout("close");
                _unbindEvents();
                _showOrHide(self.currItem, null, true, self.destroy);
            },
            // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
            destroy: function destroy() {
                _shout("destroy");
                if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
                template.setAttribute("aria-hidden", "true");
                template.className = _initalClassName;
                if (_updateSizeInterval) clearInterval(_updateSizeInterval);
                framework.unbind(self.scrollWrap, _downEvents, self);
                // we unbind scroll event at the end, as closing animation may depend on it
                framework.unbind(window, "scroll", self);
                _stopDragUpdateLoop();
                _stopAllAnimations();
                _listeners = null;
            },
            /**
	 * Pan image to position
	 * @param {Number} x     
	 * @param {Number} y     
	 * @param {Boolean} force Will ignore bounds if set to true.
	 */ panTo: function panTo(x, y, force) {
                if (!force) {
                    if (x > _currPanBounds.min.x) x = _currPanBounds.min.x;
                    else if (x < _currPanBounds.max.x) x = _currPanBounds.max.x;
                    if (y > _currPanBounds.min.y) y = _currPanBounds.min.y;
                    else if (y < _currPanBounds.max.y) y = _currPanBounds.max.y;
                }
                _panOffset.x = x;
                _panOffset.y = y;
                _applyCurrentZoomPan();
            },
            handleEvent: function handleEvent(e) {
                e = e || window.event;
                if (_globalEventHandlers[e.type]) _globalEventHandlers[e.type](e);
            },
            goTo: function goTo(index) {
                index = _getLoopedId(index);
                var diff = index - _currentItemIndex;
                _indexDiff = diff;
                _currentItemIndex = index;
                self.currItem = _getItemAt(_currentItemIndex);
                _currPositionIndex -= diff;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _stopAllAnimations();
                _mainScrollAnimating = false;
                self.updateCurrItem();
            },
            next: function next() {
                self.goTo(_currentItemIndex + 1);
            },
            prev: function prev() {
                self.goTo(_currentItemIndex - 1);
            },
            // update current zoom/pan objects
            updateCurrZoomItem: function updateCurrZoomItem(emulateSetContent) {
                if (emulateSetContent) _shout("beforeChange", 0);
                // itemHolder[1] is middle (current) item
                if (_itemHolders[1].el.children.length) {
                    var zoomElement = _itemHolders[1].el.children[0];
                    if (framework.hasClass(zoomElement, "pswp__zoom-wrap")) _currZoomElementStyle = zoomElement.style;
                    else _currZoomElementStyle = null;
                } else _currZoomElementStyle = null;
                _currPanBounds = self.currItem.bounds;
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _panOffset.x = _currPanBounds.center.x;
                _panOffset.y = _currPanBounds.center.y;
                if (emulateSetContent) _shout("afterChange");
            },
            invalidateCurrItems: function invalidateCurrItems() {
                _itemsNeedUpdate = true;
                for(var i = 0; i < NUM_HOLDERS; i++)if (_itemHolders[i].item) _itemHolders[i].item.needsUpdate = true;
            },
            updateCurrItem: function updateCurrItem(beforeAnimation) {
                if (_indexDiff === 0) return;
                var diffAbs = Math.abs(_indexDiff), tempHolder;
                if (beforeAnimation && diffAbs < 2) return;
                self.currItem = _getItemAt(_currentItemIndex);
                _renderMaxResolution = false;
                _shout("beforeChange", _indexDiff);
                if (diffAbs >= NUM_HOLDERS) {
                    _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
                    diffAbs = NUM_HOLDERS;
                }
                for(var i = 0; i < diffAbs; i++)if (_indexDiff > 0) {
                    tempHolder = _itemHolders.shift();
                    _itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last
                    _containerShiftIndex++;
                    _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
                } else {
                    tempHolder = _itemHolders.pop();
                    _itemHolders.unshift(tempHolder); // move last to first
                    _containerShiftIndex--;
                    _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
                }
                // reset zoom/pan on previous item
                if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
                    var prevItem = _getItemAt(_prevItemIndex);
                    if (prevItem.initialZoomLevel !== _currZoomLevel) {
                        _calculateItemSize(prevItem, _viewportSize);
                        _setImageSize(prevItem);
                        _applyZoomPanToItem(prevItem);
                    }
                }
                // reset diff after update
                _indexDiff = 0;
                self.updateCurrZoomItem();
                _prevItemIndex = _currentItemIndex;
                _shout("afterChange");
            },
            updateSize: function updateSize(force) {
                if (!_isFixedPosition && _options.modal) {
                    var windowScrollY = framework.getScrollY();
                    if (_currentWindowScrollY !== windowScrollY) {
                        template.style.top = windowScrollY + "px";
                        _currentWindowScrollY = windowScrollY;
                    }
                    if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) return;
                    _windowVisibleSize.x = window.innerWidth;
                    _windowVisibleSize.y = window.innerHeight;
                    //template.style.width = _windowVisibleSize.x + 'px';
                    template.style.height = _windowVisibleSize.y + "px";
                }
                _viewportSize.x = self.scrollWrap.clientWidth;
                _viewportSize.y = self.scrollWrap.clientHeight;
                _updatePageScrollOffset();
                _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
                _slideSize.y = _viewportSize.y;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _shout("beforeResize"); // even may be used for example to switch image sources
                // don't re-calculate size on inital size update
                if (_containerShiftIndex !== undefined) {
                    var holder, item, hIndex;
                    for(var i = 0; i < NUM_HOLDERS; i++){
                        holder = _itemHolders[i];
                        _setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style);
                        hIndex = _currentItemIndex + i - 1;
                        if (_options.loop && _getNumItems() > 2) hIndex = _getLoopedId(hIndex);
                        // update zoom level on items and refresh source (if needsUpdate)
                        item = _getItemAt(hIndex);
                        // re-render gallery item if `needsUpdate`,
                        // or doesn't have `bounds` (entirely new slide object)
                        if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {
                            self.cleanSlide(item);
                            self.setContent(holder, hIndex);
                            // if "center" slide
                            if (i === 1) {
                                self.currItem = item;
                                self.updateCurrZoomItem(true);
                            }
                            item.needsUpdate = false;
                        } else if (holder.index === -1 && hIndex >= 0) // add content first time
                        self.setContent(holder, hIndex);
                        if (item && item.container) {
                            _calculateItemSize(item, _viewportSize);
                            _setImageSize(item);
                            _applyZoomPanToItem(item);
                        }
                    }
                    _itemsNeedUpdate = false;
                }
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _currPanBounds = self.currItem.bounds;
                if (_currPanBounds) {
                    _panOffset.x = _currPanBounds.center.x;
                    _panOffset.y = _currPanBounds.center.y;
                    _applyCurrentZoomPan(true);
                }
                _shout("resize");
            },
            // Zoom current item to
            zoomTo: function zoomTo(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
                /*
			if(destZoomLevel === 'fit') {
				destZoomLevel = self.currItem.fitRatio;
			} else if(destZoomLevel === 'fill') {
				destZoomLevel = self.currItem.fillRatio;
			}
		*/ if (centerPoint) {
                    _startZoomLevel = _currZoomLevel;
                    _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
                    _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
                    _equalizePoints(_startPanOffset, _panOffset);
                }
                var destPanBounds = _calculatePanBounds(destZoomLevel, false), destPanOffset = {};
                _modifyDestPanOffset("x", destPanBounds, destPanOffset, destZoomLevel);
                _modifyDestPanOffset("y", destPanBounds, destPanOffset, destZoomLevel);
                var initialZoomLevel = _currZoomLevel;
                var initialPanOffset = {
                    x: _panOffset.x,
                    y: _panOffset.y
                };
                _roundPoint(destPanOffset);
                var onUpdate = function onUpdate(now) {
                    if (now === 1) {
                        _currZoomLevel = destZoomLevel;
                        _panOffset.x = destPanOffset.x;
                        _panOffset.y = destPanOffset.y;
                    } else {
                        _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                        _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
                        _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
                    }
                    if (updateFn) updateFn(now);
                    _applyCurrentZoomPan(now === 1);
                };
                if (speed) _animateProp("customZoomTo", 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
                else onUpdate(1);
            }
        };
        /*>>core*/ /*>>gestures*/ /**
 * Mouse/touch/pointer event handlers.
 * 
 * separated from @core.js for readability
 */ var MIN_SWIPE_DISTANCE = 30, DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
        var _gestureStartTime, _gestureCheckSpeedTime, // pool of objects that are used during dragging of zooming
        p = {}, p2 = {}, delta = {}, _currPoint = {}, _startPoint = {}, _currPointers = [], _startMainScrollPos = {}, _releaseAnimData, _posPoints = [], _tempPoint = {}, _isZoomingIn, _verticalDragInitiated, _oldAndroidTouchEndTimeout, _currZoomedItemIndex = 0, _centerPoint = _getEmptyPoint(), _lastReleaseTime = 0, _isDragging, _isMultitouch, _zoomStarted, _moved, _dragAnimFrame, _mainScrollShifted, _currentPoints, _isZooming, _currPointsDistance, _startPointsDistance, _currPanBounds, _mainScrollPos = _getEmptyPoint(), _currZoomElementStyle, _mainScrollAnimating, _midZoomPoint = _getEmptyPoint(), _currCenterPoint = _getEmptyPoint(), _direction, _isFirstMove, _opacityChanged, _bgOpacity, _wasOverInitialZoom, _isEqualPoints = function _isEqualPoints(p1, p2) {
            return p1.x === p2.x && p1.y === p2.y;
        }, _isNearbyPoints = function _isNearbyPoints(touch0, touch1) {
            return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
        }, _calculatePointsDistance = function _calculatePointsDistance(p1, p2) {
            _tempPoint.x = Math.abs(p1.x - p2.x);
            _tempPoint.y = Math.abs(p1.y - p2.y);
            return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
        }, _stopDragUpdateLoop = function _stopDragUpdateLoop() {
            if (_dragAnimFrame) {
                _cancelAF(_dragAnimFrame);
                _dragAnimFrame = null;
            }
        }, _dragUpdateLoop = function _dragUpdateLoop1() {
            if (_isDragging) {
                _dragAnimFrame = _requestAF(_dragUpdateLoop);
                _renderMovement();
            }
        }, _canPan = function _canPan() {
            return !(_options.scaleMode === "fit" && _currZoomLevel === self.currItem.initialZoomLevel);
        }, // find the closest parent DOM element
        _closestElement = function _closestElement1(el, fn) {
            if (!el || el === document) return false;
            // don't search elements above pswp__scroll-wrap
            if (el.getAttribute("class") && el.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) return false;
            if (fn(el)) return el;
            return _closestElement(el.parentNode, fn);
        }, _preventObj = {}, _preventDefaultEventBehaviour = function _preventDefaultEventBehaviour(e, isDown) {
            _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
            _shout("preventDragEvent", e, isDown, _preventObj);
            return _preventObj.prevent;
        }, _convertTouchToPoint = function _convertTouchToPoint(touch, p) {
            p.x = touch.pageX;
            p.y = touch.pageY;
            p.id = touch.identifier;
            return p;
        }, _findCenterOfPoints = function _findCenterOfPoints(p1, p2, pCenter) {
            pCenter.x = (p1.x + p2.x) * 0.5;
            pCenter.y = (p1.y + p2.y) * 0.5;
        }, _pushPosPoint = function _pushPosPoint(time, x, y) {
            if (time - _gestureCheckSpeedTime > 50) {
                var o = _posPoints.length > 2 ? _posPoints.shift() : {};
                o.x = x;
                o.y = y;
                _posPoints.push(o);
                _gestureCheckSpeedTime = time;
            }
        }, _calculateVerticalDragOpacityRatio = function _calculateVerticalDragOpacityRatio() {
            var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
            return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
        }, // points pool, reused during touch events
        _ePoint1 = {}, _ePoint2 = {}, _tempPointsArr = [], _tempCounter, _getTouchPoints = function _getTouchPoints(e) {
            // clean up previous points, without recreating array
            while(_tempPointsArr.length > 0)_tempPointsArr.pop();
            if (!_pointerEventEnabled) {
                if (e.type.indexOf("touch") > -1) {
                    if (e.touches && e.touches.length > 0) {
                        _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
                        if (e.touches.length > 1) _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
                    }
                } else {
                    _ePoint1.x = e.pageX;
                    _ePoint1.y = e.pageY;
                    _ePoint1.id = "";
                    _tempPointsArr[0] = _ePoint1; //_ePoint1;
                }
            } else {
                _tempCounter = 0;
                // we can use forEach, as pointer events are supported only in modern browsers
                _currPointers.forEach(function(p) {
                    if (_tempCounter === 0) _tempPointsArr[0] = p;
                    else if (_tempCounter === 1) _tempPointsArr[1] = p;
                    _tempCounter++;
                });
            }
            return _tempPointsArr;
        }, _panOrMoveMainScroll = function _panOrMoveMainScroll(axis, delta) {
            var panFriction, overDiff = 0, newOffset = _panOffset[axis] + delta[axis], startOverDiff, dir = delta[axis] > 0, newMainScrollPosition = _mainScrollPos.x + delta.x, mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x, newPanPos, newMainScrollPos;
            // calculate fdistance over the bounds and friction
            if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) panFriction = _options.panEndFriction;
            else panFriction = 1;
            newOffset = _panOffset[axis] + delta[axis] * panFriction;
            // move main scroll or start panning
            if (_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
                if (!_currZoomElementStyle) newMainScrollPos = newMainScrollPosition;
                else if (_direction === "h" && axis === "x" && !_zoomStarted) {
                    if (dir) {
                        if (newOffset > _currPanBounds.min[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = _currPanBounds.min[axis] - newOffset;
                            startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
                        }
                        // drag right
                        if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    } else {
                        if (newOffset < _currPanBounds.max[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = newOffset - _currPanBounds.max[axis];
                            startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
                        }
                        if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    }
                }
                if (axis === "x") {
                    if (newMainScrollPos !== undefined) {
                        _moveMainScroll(newMainScrollPos, true);
                        if (newMainScrollPos === _startMainScrollPos.x) _mainScrollShifted = false;
                        else _mainScrollShifted = true;
                    }
                    if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                        if (newPanPos !== undefined) _panOffset.x = newPanPos;
                        else if (!_mainScrollShifted) _panOffset.x += delta.x * panFriction;
                    }
                    return newMainScrollPos !== undefined;
                }
            }
            if (!_mainScrollAnimating) {
                if (!_mainScrollShifted) {
                    if (_currZoomLevel > self.currItem.fitRatio) _panOffset[axis] += delta[axis] * panFriction;
                }
            }
        }, // Pointerdown/touchstart/mousedown handler
        _onDragStart = function _onDragStart(e) {
            // Allow dragging only via left mouse button.
            // As this handler is not added in IE8 - we ignore e.which
            // 
            // http://www.quirksmode.org/js/events_properties.html
            // https://developer.mozilla.org/en-US/docs/Web/API/event.button
            if (e.type === "mousedown" && e.button > 0) return;
            if (_initialZoomRunning) {
                e.preventDefault();
                return;
            }
            if (_oldAndroidTouchEndTimeout && e.type === "mousedown") return;
            if (_preventDefaultEventBehaviour(e, true)) e.preventDefault();
            _shout("pointerDown");
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, "id");
                if (pointerIndex < 0) pointerIndex = _currPointers.length;
                _currPointers[pointerIndex] = {
                    x: e.pageX,
                    y: e.pageY,
                    id: e.pointerId
                };
            }
            var startPointsList = _getTouchPoints(e), numPoints = startPointsList.length;
            _currentPoints = null;
            _stopAllAnimations();
            // init drag
            if (!_isDragging || numPoints === 1) {
                _isDragging = _isFirstMove = true;
                framework.bind(window, _upMoveEvents, self);
                _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;
                _direction = null;
                _shout("firstTouchStart", startPointsList);
                _equalizePoints(_startPanOffset, _panOffset);
                _currPanDist.x = _currPanDist.y = 0;
                _equalizePoints(_currPoint, startPointsList[0]);
                _equalizePoints(_startPoint, _currPoint);
                //_equalizePoints(_startMainScrollPos, _mainScrollPos);
                _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
                _posPoints = [
                    {
                        x: _currPoint.x,
                        y: _currPoint.y
                    }
                ];
                _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
                //_mainScrollAnimationEnd(true);
                _calculatePanBounds(_currZoomLevel, true);
                // Start rendering
                _stopDragUpdateLoop();
                _dragUpdateLoop();
            }
            // init zoom
            if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
                _startZoomLevel = _currZoomLevel;
                _zoomStarted = false; // true if zoom changed at least once
                _isZooming = _isMultitouch = true;
                _currPanDist.y = _currPanDist.x = 0;
                _equalizePoints(_startPanOffset, _panOffset);
                _equalizePoints(p, startPointsList[0]);
                _equalizePoints(p2, startPointsList[1]);
                _findCenterOfPoints(p, p2, _currCenterPoint);
                _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
                _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
                _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
            }
        }, // Pointermove/touchmove/mousemove handler
        _onDragMove = function _onDragMove(e) {
            e.preventDefault();
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, "id");
                if (pointerIndex > -1) {
                    var p = _currPointers[pointerIndex];
                    p.x = e.pageX;
                    p.y = e.pageY;
                }
            }
            if (_isDragging) {
                var touchesList = _getTouchPoints(e);
                if (!_direction && !_moved && !_isZooming) {
                    if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) // if main scroll position is shifted – direction is always horizontal
                    _direction = "h";
                    else {
                        var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
                        // check the direction of movement
                        if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
                            _direction = diff > 0 ? "h" : "v";
                            _currentPoints = touchesList;
                        }
                    }
                } else _currentPoints = touchesList;
            }
        }, // 
        _renderMovement = function _renderMovement() {
            if (!_currentPoints) return;
            var numPoints = _currentPoints.length;
            if (numPoints === 0) return;
            _equalizePoints(p, _currentPoints[0]);
            delta.x = p.x - _currPoint.x;
            delta.y = p.y - _currPoint.y;
            if (_isZooming && numPoints > 1) {
                // Handle behaviour for more than 1 point
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // check if one of two points changed
                if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) return;
                _equalizePoints(p2, _currentPoints[1]);
                if (!_zoomStarted) {
                    _zoomStarted = true;
                    _shout("zoomGestureStarted");
                }
                // Distance between two points
                var pointsDistance = _calculatePointsDistance(p, p2);
                var zoomLevel = _calculateZoomLevel(pointsDistance);
                // slightly over the of initial zoom level
                if (zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) _wasOverInitialZoom = true;
                // Apply the friction if zoom level is out of the bounds
                var zoomFriction = 1, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
                if (zoomLevel < minZoomLevel) {
                    if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
                        // fade out background if zooming out
                        var minusDiff = minZoomLevel - zoomLevel;
                        var percent = 1 - minusDiff / (minZoomLevel / 1.2);
                        _applyBgOpacity(percent);
                        _shout("onPinchClose", percent);
                        _opacityChanged = true;
                    } else {
                        zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
                        if (zoomFriction > 1) zoomFriction = 1;
                        zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
                    }
                } else if (zoomLevel > maxZoomLevel) {
                    // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
                    zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
                    if (zoomFriction > 1) zoomFriction = 1;
                    zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
                }
                if (zoomFriction < 0) zoomFriction = 0;
                // distance between touch points after friction is applied
                _currPointsDistance = pointsDistance;
                // _centerPoint - The point in the middle of two pointers
                _findCenterOfPoints(p, p2, _centerPoint);
                // paning with two pointers pressed
                _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
                _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
                _equalizePoints(_currCenterPoint, _centerPoint);
                _panOffset.x = _calculatePanOffset("x", zoomLevel);
                _panOffset.y = _calculatePanOffset("y", zoomLevel);
                _isZoomingIn = zoomLevel > _currZoomLevel;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan();
            } else {
                // handle behaviour for one point (dragging or panning)
                if (!_direction) return;
                if (_isFirstMove) {
                    _isFirstMove = false;
                    // subtract drag distance that was used during the detection direction  
                    if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) delta.x -= _currentPoints[0].x - _startPoint.x;
                    if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) delta.y -= _currentPoints[0].y - _startPoint.y;
                }
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // do nothing if pointers position hasn't changed
                if (delta.x === 0 && delta.y === 0) return;
                if (_direction === "v" && _options.closeOnVerticalDrag) {
                    if (!_canPan()) {
                        _currPanDist.y += delta.y;
                        _panOffset.y += delta.y;
                        var opacityRatio = _calculateVerticalDragOpacityRatio();
                        _verticalDragInitiated = true;
                        _shout("onVerticalDrag", opacityRatio);
                        _applyBgOpacity(opacityRatio);
                        _applyCurrentZoomPan();
                        return;
                    }
                }
                _pushPosPoint(_getCurrentTime(), p.x, p.y);
                _moved = true;
                _currPanBounds = self.currItem.bounds;
                var mainScrollChanged = _panOrMoveMainScroll("x", delta);
                if (!mainScrollChanged) {
                    _panOrMoveMainScroll("y", delta);
                    _roundPoint(_panOffset);
                    _applyCurrentZoomPan();
                }
            }
        }, // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
        _onDragRelease = function _onDragRelease(e) {
            if (_features.isOldAndroid) {
                if (_oldAndroidTouchEndTimeout && e.type === "mouseup") return;
                // on Android (v4.1, 4.2, 4.3 & possibly older) 
                // ghost mousedown/up event isn't preventable via e.preventDefault,
                // which causes fake mousedown event
                // so we block mousedown/up for 600ms
                if (e.type.indexOf("touch") > -1) {
                    clearTimeout(_oldAndroidTouchEndTimeout);
                    _oldAndroidTouchEndTimeout = setTimeout(function() {
                        _oldAndroidTouchEndTimeout = 0;
                    }, 600);
                }
            }
            _shout("pointerUp");
            if (_preventDefaultEventBehaviour(e, false)) e.preventDefault();
            var releasePoint;
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, "id");
                if (pointerIndex > -1) {
                    releasePoint = _currPointers.splice(pointerIndex, 1)[0];
                    if (navigator.msPointerEnabled) {
                        var MSPOINTER_TYPES = {
                            4: "mouse",
                            2: "touch",
                            3: "pen" // event.MSPOINTER_TYPE_PEN
                        };
                        releasePoint.type = MSPOINTER_TYPES[e.pointerType];
                        if (!releasePoint.type) releasePoint.type = e.pointerType || "mouse";
                    } else releasePoint.type = e.pointerType || "mouse";
                }
            }
            var touchList = _getTouchPoints(e), gestureType, numPoints = touchList.length;
            if (e.type === "mouseup") numPoints = 0;
            // Do nothing if there were 3 touch points or more
            if (numPoints === 2) {
                _currentPoints = null;
                return true;
            }
            // if second pointer released
            if (numPoints === 1) _equalizePoints(_startPoint, touchList[0]);
            // pointer hasn't moved, send "tap release" point
            if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
                if (!releasePoint) {
                    if (e.type === "mouseup") releasePoint = {
                        x: e.pageX,
                        y: e.pageY,
                        type: "mouse"
                    };
                    else if (e.changedTouches && e.changedTouches[0]) releasePoint = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: "touch"
                    };
                }
                _shout("touchRelease", e, releasePoint);
            }
            // Difference in time between releasing of two last touch points (zoom gesture)
            var releaseTimeDiff = -1;
            // Gesture completed, no pointers left
            if (numPoints === 0) {
                _isDragging = false;
                framework.unbind(window, _upMoveEvents, self);
                _stopDragUpdateLoop();
                if (_isZooming) // Two points released at the same time
                releaseTimeDiff = 0;
                else if (_lastReleaseTime !== -1) releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
            }
            _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
            if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) gestureType = "zoom";
            else gestureType = "swipe";
            if (_isZooming && numPoints < 2) {
                _isZooming = false;
                // Only second point released
                if (numPoints === 1) gestureType = "zoomPointerUp";
                _shout("zoomGestureEnded");
            }
            _currentPoints = null;
            if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) // nothing to animate
            return;
            _stopAllAnimations();
            if (!_releaseAnimData) _releaseAnimData = _initDragReleaseAnimationData();
            _releaseAnimData.calculateSwipeSpeed("x");
            if (_verticalDragInitiated) {
                var opacityRatio = _calculateVerticalDragOpacityRatio();
                if (opacityRatio < _options.verticalDragRange) self.close();
                else {
                    var initalPanY = _panOffset.y, initialBgOpacity = _bgOpacity;
                    _animateProp("verticalDrag", 0, 1, 300, framework.easing.cubic.out, function(now) {
                        _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
                        _applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity);
                        _applyCurrentZoomPan();
                    });
                    _shout("onVerticalDrag", 1);
                }
                return;
            }
            // main scroll 
            if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
                var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
                if (itemChanged) return;
                gestureType = "zoomPointerUp";
            }
            // prevent zoom/pan animation when main scroll animation runs
            if (_mainScrollAnimating) return;
            // Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
            if (gestureType !== "swipe") {
                _completeZoomGesture();
                return;
            }
            // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
            if (!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) _completePanGesture(_releaseAnimData);
        }, // Returns object with data about gesture
        // It's created only once and then reused
        _initDragReleaseAnimationData = function _initDragReleaseAnimationData() {
            // temp local vars
            var lastFlickDuration, tempReleasePos;
            // s = this
            var s = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function calculateSwipeSpeed(axis) {
                    if (_posPoints.length > 1) {
                        lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
                        tempReleasePos = _posPoints[_posPoints.length - 2][axis];
                    } else {
                        lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
                        tempReleasePos = _startPoint[axis];
                    }
                    s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
                    s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
                    if (s.lastFlickDist[axis] > 20) s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
                    else s.lastFlickSpeed[axis] = 0;
                    if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) s.lastFlickSpeed[axis] = 0;
                    s.slowDownRatio[axis] = 0.95;
                    s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                    s.speedDecelerationRatio[axis] = 1;
                },
                calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(axis, speed) {
                    if (!s.backAnimStarted[axis]) {
                        if (_panOffset[axis] > _currPanBounds.min[axis]) s.backAnimDestination[axis] = _currPanBounds.min[axis];
                        else if (_panOffset[axis] < _currPanBounds.max[axis]) s.backAnimDestination[axis] = _currPanBounds.max[axis];
                        if (s.backAnimDestination[axis] !== undefined) {
                            s.slowDownRatio[axis] = 0.7;
                            s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                            if (s.speedDecelerationRatioAbs[axis] < 0.05) {
                                s.lastFlickSpeed[axis] = 0;
                                s.backAnimStarted[axis] = true;
                                _animateProp("bounceZoomPan" + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function(pos) {
                                    _panOffset[axis] = pos;
                                    _applyCurrentZoomPan();
                                });
                            }
                        }
                    }
                },
                // Reduces the speed by slowDownRatio (per 10ms)
                calculateAnimOffset: function calculateAnimOffset(axis) {
                    if (!s.backAnimStarted[axis]) {
                        s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10);
                        s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
                        s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
                        _panOffset[axis] += s.distanceOffset[axis];
                    }
                },
                panAnimLoop: function panAnimLoop() {
                    if (_animations.zoomPan) {
                        _animations.zoomPan.raf = _requestAF(s.panAnimLoop);
                        s.now = _getCurrentTime();
                        s.timeDiff = s.now - s.lastNow;
                        s.lastNow = s.now;
                        s.calculateAnimOffset("x");
                        s.calculateAnimOffset("y");
                        _applyCurrentZoomPan();
                        s.calculateOverBoundsAnimOffset("x");
                        s.calculateOverBoundsAnimOffset("y");
                        if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
                            // round pan position
                            _panOffset.x = Math.round(_panOffset.x);
                            _panOffset.y = Math.round(_panOffset.y);
                            _applyCurrentZoomPan();
                            _stopAnimation("zoomPan");
                            return;
                        }
                    }
                }
            };
            return s;
        }, _completePanGesture = function _completePanGesture(animData) {
            // calculate swipe speed for Y axis (paanning)
            animData.calculateSwipeSpeed("y");
            _currPanBounds = self.currItem.bounds;
            animData.backAnimDestination = {};
            animData.backAnimStarted = {};
            // Avoid acceleration animation if speed is too low
            if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
                animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
                // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
                animData.calculateOverBoundsAnimOffset("x");
                animData.calculateOverBoundsAnimOffset("y");
                return true;
            }
            // Animation loop that controls the acceleration after pan gesture ends
            _registerStartAnimation("zoomPan");
            animData.lastNow = _getCurrentTime();
            animData.panAnimLoop();
        }, _finishSwipeMainScrollGesture = function _finishSwipeMainScrollGesture(gestureType, _releaseAnimData) {
            var itemChanged;
            if (!_mainScrollAnimating) _currZoomedItemIndex = _currentItemIndex;
            var itemsDiff;
            if (gestureType === "swipe") {
                var totalShiftDist = _currPoint.x - _startPoint.x, isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
                // if container is shifted for more than MIN_SWIPE_DISTANCE, 
                // and last flick gesture was in right direction
                if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)) // go to prev item
                itemsDiff = -1;
                else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)) // go to next item
                itemsDiff = 1;
            }
            var nextCircle;
            if (itemsDiff) {
                _currentItemIndex += itemsDiff;
                if (_currentItemIndex < 0) {
                    _currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
                    nextCircle = true;
                } else if (_currentItemIndex >= _getNumItems()) {
                    _currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
                    nextCircle = true;
                }
                if (!nextCircle || _options.loop) {
                    _indexDiff += itemsDiff;
                    _currPositionIndex -= itemsDiff;
                    itemChanged = true;
                }
            }
            var animateToX = _slideSize.x * _currPositionIndex;
            var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
            var finishAnimDuration;
            if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) // "return to current" duration, e.g. when dragging from slide 0 to -1
            finishAnimDuration = 333;
            else {
                finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 333;
                finishAnimDuration = Math.min(finishAnimDuration, 400);
                finishAnimDuration = Math.max(finishAnimDuration, 250);
            }
            if (_currZoomedItemIndex === _currentItemIndex) itemChanged = false;
            _mainScrollAnimating = true;
            _shout("mainScrollAnimStart");
            _animateProp("mainScroll", _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function() {
                _stopAllAnimations();
                _mainScrollAnimating = false;
                _currZoomedItemIndex = -1;
                if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) self.updateCurrItem();
                _shout("mainScrollAnimComplete");
            });
            if (itemChanged) self.updateCurrItem(true);
            return itemChanged;
        }, _calculateZoomLevel = function _calculateZoomLevel(touchesDistance) {
            return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
        }, // Resets zoom if it's out of bounds
        _completeZoomGesture = function _completeZoomGesture() {
            var destZoomLevel = _currZoomLevel, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
            if (_currZoomLevel < minZoomLevel) destZoomLevel = minZoomLevel;
            else if (_currZoomLevel > maxZoomLevel) destZoomLevel = maxZoomLevel;
            var destOpacity = 1, onUpdate, initialOpacity = _bgOpacity;
            if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
                //_closedByScroll = true;
                self.close();
                return true;
            }
            if (_opacityChanged) onUpdate = function onUpdate(now) {
                _applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity);
            };
            self.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
            return true;
        };
        _registerModule("Gestures", {
            publicMethods: {
                initGestures: function initGestures() {
                    // helper function that builds touch/pointer/mouse events
                    var addEventNames = function addEventNames(pref, down, move, up, cancel) {
                        _dragStartEvent = pref + down;
                        _dragMoveEvent = pref + move;
                        _dragEndEvent = pref + up;
                        if (cancel) _dragCancelEvent = pref + cancel;
                        else _dragCancelEvent = "";
                    };
                    _pointerEventEnabled = _features.pointerEvent;
                    if (_pointerEventEnabled && _features.touch) // we don't need touch events, if browser supports pointer events
                    _features.touch = false;
                    if (_pointerEventEnabled) {
                        if (navigator.msPointerEnabled) // IE10 pointer events are case-sensitive
                        addEventNames("MSPointer", "Down", "Move", "Up", "Cancel");
                        else addEventNames("pointer", "down", "move", "up", "cancel");
                    } else if (_features.touch) {
                        addEventNames("touch", "start", "move", "end", "cancel");
                        _likelyTouchDevice = true;
                    } else addEventNames("mouse", "down", "move", "up");
                    _upMoveEvents = _dragMoveEvent + " " + _dragEndEvent + " " + _dragCancelEvent;
                    _downEvents = _dragStartEvent;
                    if (_pointerEventEnabled && !_likelyTouchDevice) _likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
                    // make variable public
                    self.likelyTouchDevice = _likelyTouchDevice;
                    _globalEventHandlers[_dragStartEvent] = _onDragStart;
                    _globalEventHandlers[_dragMoveEvent] = _onDragMove;
                    _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
                    if (_dragCancelEvent) _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
                    // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
                    if (_features.touch) {
                        _downEvents += " mousedown";
                        _upMoveEvents += " mousemove mouseup";
                        _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
                        _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
                        _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
                    }
                    if (!_likelyTouchDevice) // don't allow pan to next slide from zoomed state on Desktop
                    _options.allowPanToNext = false;
                }
            }
        });
        /*>>gestures*/ /*>>show-hide-transition*/ /**
 * show-hide-transition.js:
 *
 * Manages initial opening or closing transition.
 *
 * If you're not planning to use transition for gallery at all,
 * you may set options hideAnimationDuration and showAnimationDuration to 0,
 * and just delete startAnimation function.
 * 
 */ var _showOrHideTimeout, _showOrHide = function _showOrHide(item, img, out, completeFn) {
            if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
            _initialZoomRunning = true;
            _initialContentSet = true;
            // dimensions of small thumbnail {x:,y:,w:}.
            // Height is optional, as calculated based on large image.
            var thumbBounds;
            if (item.initialLayout) {
                thumbBounds = item.initialLayout;
                item.initialLayout = null;
            } else thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
            var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
            var onComplete = function onComplete() {
                _stopAnimation("initialZoom");
                if (!out) {
                    _applyBgOpacity(1);
                    if (img) img.style.display = "block";
                    framework.addClass(template, "pswp--animated-in");
                    _shout("initialZoom" + (out ? "OutEnd" : "InEnd"));
                } else {
                    self.template.removeAttribute("style");
                    self.bg.removeAttribute("style");
                }
                if (completeFn) completeFn();
                _initialZoomRunning = false;
            };
            // if bounds aren't provided, just open gallery without animation
            if (!duration || !thumbBounds || thumbBounds.x === undefined) {
                _shout("initialZoom" + (out ? "Out" : "In"));
                _currZoomLevel = item.initialZoomLevel;
                _equalizePoints(_panOffset, item.initialPosition);
                _applyCurrentZoomPan();
                template.style.opacity = out ? 0 : 1;
                _applyBgOpacity(1);
                if (duration) setTimeout(function() {
                    onComplete();
                }, duration);
                else onComplete();
                return;
            }
            var startAnimation = function startAnimation() {
                var closeWithRaf = _closedByScroll, fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
                // apply hw-acceleration to image
                if (item.miniImg) item.miniImg.style.webkitBackfaceVisibility = "hidden";
                if (!out) {
                    _currZoomLevel = thumbBounds.w / item.w;
                    _panOffset.x = thumbBounds.x;
                    _panOffset.y = thumbBounds.y - _initalWindowScrollY;
                    self[fadeEverything ? "template" : "bg"].style.opacity = 0.001;
                    _applyCurrentZoomPan();
                }
                _registerStartAnimation("initialZoom");
                if (out && !closeWithRaf) framework.removeClass(template, "pswp--animated-in");
                if (fadeEverything) {
                    if (out) framework[(closeWithRaf ? "remove" : "add") + "Class"](template, "pswp--animate_opacity");
                    else setTimeout(function() {
                        framework.addClass(template, "pswp--animate_opacity");
                    }, 30);
                }
                _showOrHideTimeout = setTimeout(function() {
                    _shout("initialZoom" + (out ? "Out" : "In"));
                    if (!out) {
                        // "in" animation always uses CSS transitions (instead of rAF).
                        // CSS transition work faster here, 
                        // as developer may also want to animate other things, 
                        // like ui on top of sliding area, which can be animated just via CSS
                        _currZoomLevel = item.initialZoomLevel;
                        _equalizePoints(_panOffset, item.initialPosition);
                        _applyCurrentZoomPan();
                        _applyBgOpacity(1);
                        if (fadeEverything) template.style.opacity = 1;
                        else _applyBgOpacity(1);
                        _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                    } else {
                        // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
                        var destZoomLevel = thumbBounds.w / item.w, initialPanOffset = {
                            x: _panOffset.x,
                            y: _panOffset.y
                        }, initialZoomLevel = _currZoomLevel, initalBgOpacity = _bgOpacity, onUpdate = function onUpdate(now) {
                            if (now === 1) {
                                _currZoomLevel = destZoomLevel;
                                _panOffset.x = thumbBounds.x;
                                _panOffset.y = thumbBounds.y - _currentWindowScrollY;
                            } else {
                                _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                                _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
                                _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
                            }
                            _applyCurrentZoomPan();
                            if (fadeEverything) template.style.opacity = 1 - now;
                            else _applyBgOpacity(initalBgOpacity - now * initalBgOpacity);
                        };
                        if (closeWithRaf) _animateProp("initialZoom", 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
                        else {
                            onUpdate(1);
                            _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                        }
                    }
                }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
            // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
            // Which avoids lag at the beginning of scale transition.
            };
            startAnimation();
        };
        /*>>show-hide-transition*/ /*>>items-controller*/ /**
*
* Controller manages gallery items, their dimensions, and their content.
* 
*/ var _items, _tempPanAreaSize = {}, _imagesToAppendPool = [], _initialContentSet, _initialZoomRunning, _controllerDefaultOptions = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: false,
            preload: [
                1,
                1
            ],
            getNumItemsFn: function getNumItemsFn() {
                return _items.length;
            }
        };
        var _getItemAt, _getNumItems, _initialIsLoop, _getZeroBounds = function _getZeroBounds() {
            return {
                center: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                min: {
                    x: 0,
                    y: 0
                }
            };
        }, _calculateSingleItemPanBounds = function _calculateSingleItemPanBounds(item, realPanElementW, realPanElementH) {
            var bounds = item.bounds;
            // position of element when it's centered
            bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
            bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
            // maximum pan position
            bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;
            bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;
            // minimum pan position
            bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
            bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
        }, _calculateItemSize = function _calculateItemSize(item, viewportSize, zoomLevel) {
            if (item.src && !item.loadError) {
                var isInitial = !zoomLevel;
                if (isInitial) {
                    if (!item.vGap) item.vGap = {
                        top: 0,
                        bottom: 0
                    };
                    // allows overriding vertical margin for individual items
                    _shout("parseVerticalMargin", item);
                }
                _tempPanAreaSize.x = viewportSize.x;
                _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
                if (isInitial) {
                    var hRatio = _tempPanAreaSize.x / item.w;
                    var vRatio = _tempPanAreaSize.y / item.h;
                    item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
                    //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
                    var scaleMode = _options.scaleMode;
                    if (scaleMode === "orig") zoomLevel = 1;
                    else if (scaleMode === "fit") zoomLevel = item.fitRatio;
                    if (zoomLevel > 1) zoomLevel = 1;
                    item.initialZoomLevel = zoomLevel;
                    if (!item.bounds) // reuse bounds object
                    item.bounds = _getZeroBounds();
                }
                if (!zoomLevel) return;
                _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
                if (isInitial && zoomLevel === item.initialZoomLevel) item.initialPosition = item.bounds.center;
                return item.bounds;
            } else {
                item.w = item.h = 0;
                item.initialZoomLevel = item.fitRatio = 1;
                item.bounds = _getZeroBounds();
                item.initialPosition = item.bounds.center;
                // if it's not image, we return zero bounds (content is not zoomable)
                return item.bounds;
            }
        }, _appendImage = function _appendImage(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
            if (item.loadError) return;
            if (img) {
                item.imageAppended = true;
                _setImageSize(item, img, item === self.currItem && _renderMaxResolution);
                baseDiv.appendChild(img);
                if (keepPlaceholder) setTimeout(function() {
                    if (item && item.loaded && item.placeholder) {
                        item.placeholder.style.display = "none";
                        item.placeholder = null;
                    }
                }, 500);
            }
        }, _preloadImage = function _preloadImage(item) {
            item.loading = true;
            item.loaded = false;
            var img = item.img = framework.createEl("pswp__img", "img");
            var onComplete = function onComplete() {
                item.loading = false;
                item.loaded = true;
                if (item.loadComplete) item.loadComplete(item);
                else item.img = null; // no need to store image object
                img.onload = img.onerror = null;
                img = null;
            };
            img.onload = onComplete;
            img.onerror = function() {
                item.loadError = true;
                onComplete();
            };
            img.src = item.src; // + '?a=' + Math.random();
            return img;
        }, _checkForError = function _checkForError(item, cleanUp) {
            if (item.src && item.loadError && item.container) {
                if (cleanUp) item.container.innerHTML = "";
                item.container.innerHTML = _options.errorMsg.replace("%url%", item.src);
                return true;
            }
        }, _setImageSize = function _setImageSize(item, img, maxRes) {
            if (!item.src) return;
            if (!img) img = item.container.lastChild;
            var w = maxRes ? item.w : Math.round(item.w * item.fitRatio), h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
            if (item.placeholder && !item.loaded) {
                item.placeholder.style.width = w + "px";
                item.placeholder.style.height = h + "px";
            }
            img.style.width = w + "px";
            img.style.height = h + "px";
        }, _appendImagesPool = function _appendImagesPool() {
            if (_imagesToAppendPool.length) {
                var poolItem;
                for(var i = 0; i < _imagesToAppendPool.length; i++){
                    poolItem = _imagesToAppendPool[i];
                    if (poolItem.holder.index === poolItem.index) _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
                }
                _imagesToAppendPool = [];
            }
        };
        _registerModule("Controller", {
            publicMethods: {
                lazyLoadItem: function lazyLoadItem(index) {
                    index = _getLoopedId(index);
                    var item = _getItemAt(index);
                    if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) return;
                    _shout("gettingData", index, item);
                    if (!item.src) return;
                    _preloadImage(item);
                },
                initController: function initController() {
                    framework.extend(_options, _controllerDefaultOptions, true);
                    self.items = _items = items;
                    _getItemAt = self.getItemAt;
                    _getNumItems = _options.getNumItemsFn; //self.getNumItems;
                    _initialIsLoop = _options.loop;
                    if (_getNumItems() < 3) _options.loop = false; // disable loop if less then 3 items
                    _listen("beforeChange", function(diff) {
                        var p = _options.preload, isNext = diff === null ? true : diff >= 0, preloadBefore = Math.min(p[0], _getNumItems()), preloadAfter = Math.min(p[1], _getNumItems()), i;
                        for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++)self.lazyLoadItem(_currentItemIndex + i);
                        for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++)self.lazyLoadItem(_currentItemIndex - i);
                    });
                    _listen("initialLayout", function() {
                        self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                    });
                    _listen("mainScrollAnimComplete", _appendImagesPool);
                    _listen("initialZoomInEnd", _appendImagesPool);
                    _listen("destroy", function() {
                        var item;
                        for(var i = 0; i < _items.length; i++){
                            item = _items[i];
                            // remove reference to DOM elements, for GC
                            if (item.container) item.container = null;
                            if (item.placeholder) item.placeholder = null;
                            if (item.img) item.img = null;
                            if (item.preloader) item.preloader = null;
                            if (item.loadError) item.loaded = item.loadError = false;
                        }
                        _imagesToAppendPool = null;
                    });
                },
                getItemAt: function getItemAt(index) {
                    if (index >= 0) return _items[index] !== undefined ? _items[index] : false;
                    return false;
                },
                allowProgressiveImg: function allowProgressiveImg() {
                    // 1. Progressive image loading isn't working on webkit/blink 
                    //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
                    //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
                    //    
                    // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
                    //    That's why it's disabled on touch devices (mainly because of swipe transition)
                    //    
                    // 3. Progressive image loading sometimes doesn't work in IE (up to 11).
                    // Don't allow progressive loading on non-large touch devices
                    return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
                // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
                },
                setContent: function setContent(holder, index) {
                    if (_options.loop) index = _getLoopedId(index);
                    var prevItem = self.getItemAt(holder.index);
                    if (prevItem) prevItem.container = null;
                    var item = self.getItemAt(index), img;
                    if (!item) {
                        holder.el.innerHTML = "";
                        return;
                    }
                    // allow to override data
                    _shout("gettingData", index, item);
                    holder.index = index;
                    holder.item = item;
                    // base container DIV is created only once for each of 3 holders
                    var baseDiv = item.container = framework.createEl("pswp__zoom-wrap");
                    if (!item.src && item.html) {
                        if (item.html.tagName) baseDiv.appendChild(item.html);
                        else baseDiv.innerHTML = item.html;
                    }
                    _checkForError(item);
                    _calculateItemSize(item, _viewportSize);
                    if (item.src && !item.loadError && !item.loaded) {
                        item.loadComplete = function(item) {
                            // gallery closed before image finished loading
                            if (!_isOpen) return;
                            // check if holder hasn't changed while image was loading
                            if (holder && holder.index === index) {
                                if (_checkForError(item, true)) {
                                    item.loadComplete = item.img = null;
                                    _calculateItemSize(item, _viewportSize);
                                    _applyZoomPanToItem(item);
                                    if (holder.index === _currentItemIndex) // recalculate dimensions
                                    self.updateCurrZoomItem();
                                    return;
                                }
                                if (!item.imageAppended) {
                                    if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) _imagesToAppendPool.push({
                                        item: item,
                                        baseDiv: baseDiv,
                                        img: item.img,
                                        index: index,
                                        holder: holder,
                                        clearPlaceholder: true
                                    });
                                    else _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
                                } else // remove preloader & mini-img
                                if (!_initialZoomRunning && item.placeholder) {
                                    item.placeholder.style.display = "none";
                                    item.placeholder = null;
                                }
                            }
                            item.loadComplete = null;
                            item.img = null; // no need to store image element after it's added
                            _shout("imageLoadComplete", index, item);
                        };
                        if (framework.features.transform) {
                            var placeholderClassName = "pswp__img pswp__img--placeholder";
                            placeholderClassName += item.msrc ? "" : " pswp__img--placeholder--blank";
                            var placeholder = framework.createEl(placeholderClassName, item.msrc ? "img" : "");
                            if (item.msrc) placeholder.src = item.msrc;
                            _setImageSize(item, placeholder);
                            baseDiv.appendChild(placeholder);
                            item.placeholder = placeholder;
                        }
                        if (!item.loading) _preloadImage(item);
                        if (self.allowProgressiveImg()) {
                            // just append image
                            if (!_initialContentSet && _features.transform) _imagesToAppendPool.push({
                                item: item,
                                baseDiv: baseDiv,
                                img: item.img,
                                index: index,
                                holder: holder
                            });
                            else _appendImage(index, item, baseDiv, item.img, true, true);
                        }
                    } else if (item.src && !item.loadError) {
                        // image object is created every time, due to bugs of image loading & delay when switching images
                        img = framework.createEl("pswp__img", "img");
                        img.style.opacity = 1;
                        img.src = item.src;
                        _setImageSize(item, img);
                        _appendImage(index, item, baseDiv, img, true);
                    }
                    if (!_initialContentSet && index === _currentItemIndex) {
                        _currZoomElementStyle = baseDiv.style;
                        _showOrHide(item, img || item.img);
                    } else _applyZoomPanToItem(item);
                    holder.el.innerHTML = "";
                    holder.el.appendChild(baseDiv);
                },
                cleanSlide: function cleanSlide(item) {
                    if (item.img) item.img.onload = item.img.onerror = null;
                    item.loaded = item.loading = item.img = item.imageAppended = false;
                }
            }
        });
        /*>>items-controller*/ /*>>tap*/ /**
 * tap.js:
 *
 * Displatches tap and double-tap events.
 * 
 */ var tapTimer, tapReleasePoint = {}, _dispatchTapEvent = function _dispatchTapEvent(origEvent, releasePoint, pointerType) {
            var e = document.createEvent("CustomEvent"), eDetail = {
                origEvent: origEvent,
                target: origEvent.target,
                releasePoint: releasePoint,
                pointerType: pointerType || "touch"
            };
            e.initCustomEvent("pswpTap", true, true, eDetail);
            origEvent.target.dispatchEvent(e);
        };
        _registerModule("Tap", {
            publicMethods: {
                initTap: function initTap() {
                    _listen("firstTouchStart", self.onTapStart);
                    _listen("touchRelease", self.onTapRelease);
                    _listen("destroy", function() {
                        tapReleasePoint = {};
                        tapTimer = null;
                    });
                },
                onTapStart: function onTapStart(touchList) {
                    if (touchList.length > 1) {
                        clearTimeout(tapTimer);
                        tapTimer = null;
                    }
                },
                onTapRelease: function onTapRelease(e, releasePoint) {
                    if (!releasePoint) return;
                    if (!_moved && !_isMultitouch && !_numAnimations) {
                        var p0 = releasePoint;
                        if (tapTimer) {
                            clearTimeout(tapTimer);
                            tapTimer = null;
                            // Check if taped on the same place
                            if (_isNearbyPoints(p0, tapReleasePoint)) {
                                _shout("doubleTap", p0);
                                return;
                            }
                        }
                        if (releasePoint.type === "mouse") {
                            _dispatchTapEvent(e, releasePoint, "mouse");
                            return;
                        }
                        var clickedTagName = e.target.tagName.toUpperCase();
                        // avoid double tap delay on buttons and elements that have class pswp__single-tap
                        if (clickedTagName === "BUTTON" || framework.hasClass(e.target, "pswp__single-tap")) {
                            _dispatchTapEvent(e, releasePoint);
                            return;
                        }
                        _equalizePoints(tapReleasePoint, p0);
                        tapTimer = setTimeout(function() {
                            _dispatchTapEvent(e, releasePoint);
                            tapTimer = null;
                        }, 300);
                    }
                }
            }
        });
        /*>>tap*/ /*>>desktop-zoom*/ /**
 *
 * desktop-zoom.js:
 *
 * - Binds mousewheel event for paning zoomed image.
 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
 *   (which are used for cursors and zoom icon)
 * - Adds toggleDesktopZoom function.
 * 
 */ var _wheelDelta;
        _registerModule("DesktopZoom", {
            publicMethods: {
                initDesktopZoom: function initDesktopZoom() {
                    if (_oldIE) // no zoom for old IE (<=8)
                    return;
                    if (_likelyTouchDevice) // if detected hardware touch support, we wait until mouse is used,
                    // and only then apply desktop-zoom features
                    _listen("mouseUsed", function() {
                        self.setupDesktopZoom();
                    });
                    else self.setupDesktopZoom(true);
                },
                setupDesktopZoom: function setupDesktopZoom(onInit) {
                    _wheelDelta = {};
                    var events = "wheel mousewheel DOMMouseScroll";
                    _listen("bindEvents", function() {
                        framework.bind(template, events, self.handleMouseWheel);
                    });
                    _listen("unbindEvents", function() {
                        if (_wheelDelta) framework.unbind(template, events, self.handleMouseWheel);
                    });
                    self.mouseZoomedIn = false;
                    var hasDraggingClass, updateZoomable = function updateZoomable() {
                        if (self.mouseZoomedIn) {
                            framework.removeClass(template, "pswp--zoomed-in");
                            self.mouseZoomedIn = false;
                        }
                        if (_currZoomLevel < 1) framework.addClass(template, "pswp--zoom-allowed");
                        else framework.removeClass(template, "pswp--zoom-allowed");
                        removeDraggingClass();
                    }, removeDraggingClass = function removeDraggingClass() {
                        if (hasDraggingClass) {
                            framework.removeClass(template, "pswp--dragging");
                            hasDraggingClass = false;
                        }
                    };
                    _listen("resize", updateZoomable);
                    _listen("afterChange", updateZoomable);
                    _listen("pointerDown", function() {
                        if (self.mouseZoomedIn) {
                            hasDraggingClass = true;
                            framework.addClass(template, "pswp--dragging");
                        }
                    });
                    _listen("pointerUp", removeDraggingClass);
                    if (!onInit) updateZoomable();
                },
                handleMouseWheel: function handleMouseWheel(e) {
                    if (_currZoomLevel <= self.currItem.fitRatio) {
                        if (_options.modal) {
                            if (!_options.closeOnScroll || _numAnimations || _isDragging) e.preventDefault();
                            else if (_transformKey && Math.abs(e.deltaY) > 2) {
                                // close PhotoSwipe
                                // if browser supports transforms & scroll changed enough
                                _closedByScroll = true;
                                self.close();
                            }
                        }
                        return true;
                    }
                    // allow just one event to fire
                    e.stopPropagation();
                    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                    _wheelDelta.x = 0;
                    if ("deltaX" in e) {
                        if (e.deltaMode === 1 /* DOM_DELTA_LINE */ ) {
                            // 18 - average line height
                            _wheelDelta.x = e.deltaX * 18;
                            _wheelDelta.y = e.deltaY * 18;
                        } else {
                            _wheelDelta.x = e.deltaX;
                            _wheelDelta.y = e.deltaY;
                        }
                    } else if ("wheelDelta" in e) {
                        if (e.wheelDeltaX) _wheelDelta.x = -0.16 * e.wheelDeltaX;
                        if (e.wheelDeltaY) _wheelDelta.y = -0.16 * e.wheelDeltaY;
                        else _wheelDelta.y = -0.16 * e.wheelDelta;
                    } else if ("detail" in e) _wheelDelta.y = e.detail;
                    else return;
                    _calculatePanBounds(_currZoomLevel, true);
                    var newPanX = _panOffset.x - _wheelDelta.x, newPanY = _panOffset.y - _wheelDelta.y;
                    // only prevent scrolling in nonmodal mode when not at edges
                    if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) e.preventDefault();
                    // TODO: use rAF instead of mousewheel?
                    self.panTo(newPanX, newPanY);
                },
                toggleDesktopZoom: function toggleDesktopZoom(centerPoint) {
                    centerPoint = centerPoint || {
                        x: _viewportSize.x / 2 + _offset.x,
                        y: _viewportSize.y / 2 + _offset.y
                    };
                    var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
                    var zoomOut = _currZoomLevel === doubleTapZoomLevel;
                    self.mouseZoomedIn = !zoomOut;
                    self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
                    framework[(!zoomOut ? "add" : "remove") + "Class"](template, "pswp--zoomed-in");
                }
            }
        });
        /*>>desktop-zoom*/ /*>>history*/ /**
 *
 * history.js:
 *
 * - Back button to close gallery.
 * 
 * - Unique URL for each slide: example.com/&pid=1&gid=3
 *   (where PID is picture index, and GID and gallery index)
 *   
 * - Switch URL when slides change.
 * 
 */ var _historyDefaultOptions = {
            history: true,
            galleryUID: 1
        };
        var _historyUpdateTimeout, _hashChangeTimeout, _hashAnimCheckTimeout, _hashChangedByScript, _hashChangedByHistory, _hashReseted, _initialHash, _historyChanged, _closedFromURL, _urlChangedOnce, _windowLoc, _supportsPushState, _getHash = function _getHash() {
            return _windowLoc.hash.substring(1);
        }, _cleanHistoryTimeouts = function _cleanHistoryTimeouts() {
            if (_historyUpdateTimeout) clearTimeout(_historyUpdateTimeout);
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
        }, // pid - Picture index
        // gid - Gallery index
        _parseItemIndexFromURL = function _parseItemIndexFromURL() {
            var hash = _getHash(), params = {};
            if (hash.length < 5) return params;
            var i, vars = hash.split("&");
            for(i = 0; i < vars.length; i++){
                if (!vars[i]) continue;
                var pair = vars[i].split("=");
                if (pair.length < 2) continue;
                params[pair[0]] = pair[1];
            }
            if (_options.galleryPIDs) {
                // detect custom pid in hash and search for it among the items collection
                var searchfor = params.pid;
                params.pid = 0; // if custom pid cannot be found, fallback to the first item
                for(i = 0; i < _items.length; i++)if (_items[i].pid === searchfor) {
                    params.pid = i;
                    break;
                }
            } else params.pid = parseInt(params.pid, 10) - 1;
            if (params.pid < 0) params.pid = 0;
            return params;
        }, _updateHash = function _updateHash1() {
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
            if (_numAnimations || _isDragging) {
                // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
                // that's why we update hash only when no animations running
                _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
                return;
            }
            if (_hashChangedByScript) clearTimeout(_hashChangeTimeout);
            else _hashChangedByScript = true;
            var pid = _currentItemIndex + 1;
            var item = _getItemAt(_currentItemIndex);
            if (item.hasOwnProperty("pid")) // carry forward any custom pid assigned to the item
            pid = item.pid;
            var newHash = _initialHash + "&" + "gid=" + _options.galleryUID + "&" + "pid=" + pid;
            if (!_historyChanged) {
                if (_windowLoc.hash.indexOf(newHash) === -1) _urlChangedOnce = true;
            }
            var newURL = _windowLoc.href.split("#")[0] + "#" + newHash;
            if (_supportsPushState) {
                if ("#" + newHash !== window.location.hash) history[_historyChanged ? "replaceState" : "pushState"]("", document.title, newURL);
            } else if (_historyChanged) _windowLoc.replace(newURL);
            else _windowLoc.hash = newHash;
            _historyChanged = true;
            _hashChangeTimeout = setTimeout(function() {
                _hashChangedByScript = false;
            }, 60);
        };
        _registerModule("History", {
            publicMethods: {
                initHistory: function initHistory() {
                    framework.extend(_options, _historyDefaultOptions, true);
                    if (!_options.history) return;
                    _windowLoc = window.location;
                    _urlChangedOnce = false;
                    _closedFromURL = false;
                    _historyChanged = false;
                    _initialHash = _getHash();
                    _supportsPushState = "pushState" in history;
                    if (_initialHash.indexOf("gid=") > -1) {
                        _initialHash = _initialHash.split("&gid=")[0];
                        _initialHash = _initialHash.split("?gid=")[0];
                    }
                    _listen("afterChange", self.updateURL);
                    _listen("unbindEvents", function() {
                        framework.unbind(window, "hashchange", self.onHashChange);
                    });
                    var returnToOriginal = function returnToOriginal() {
                        _hashReseted = true;
                        if (!_closedFromURL) {
                            if (_urlChangedOnce) history.back();
                            else {
                                if (_initialHash) _windowLoc.hash = _initialHash;
                                else if (_supportsPushState) // remove hash from url without refreshing it or scrolling to top
                                history.pushState("", document.title, _windowLoc.pathname + _windowLoc.search);
                                else _windowLoc.hash = "";
                            }
                        }
                        _cleanHistoryTimeouts();
                    };
                    _listen("unbindEvents", function() {
                        if (_closedByScroll) // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
                        // this is done to keep the scroll position
                        returnToOriginal();
                    });
                    _listen("destroy", function() {
                        if (!_hashReseted) returnToOriginal();
                    });
                    _listen("firstUpdate", function() {
                        _currentItemIndex = _parseItemIndexFromURL().pid;
                    });
                    var index = _initialHash.indexOf("pid=");
                    if (index > -1) {
                        _initialHash = _initialHash.substring(0, index);
                        if (_initialHash.slice(-1) === "&") _initialHash = _initialHash.slice(0, -1);
                    }
                    setTimeout(function() {
                        if (_isOpen) framework.bind(window, "hashchange", self.onHashChange);
                    }, 40);
                },
                onHashChange: function onHashChange() {
                    if (_getHash() === _initialHash) {
                        _closedFromURL = true;
                        self.close();
                        return;
                    }
                    if (!_hashChangedByScript) {
                        _hashChangedByHistory = true;
                        self.goTo(_parseItemIndexFromURL().pid);
                        _hashChangedByHistory = false;
                    }
                },
                updateURL: function updateURL() {
                    // Delay the update of URL, to avoid lag during transition, 
                    // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
                    _cleanHistoryTimeouts();
                    if (_hashChangedByHistory) return;
                    if (!_historyChanged) _updateHash(); // first time
                    else _historyUpdateTimeout = setTimeout(_updateHash, 800);
                }
            }
        });
        /*>>history*/ framework.extend(self, publicMethods);
    };
    return PhotoSwipe;
});


var $96c1c0a59496a49e$exports = {};
/**
*
* UI on top of main sliding area (caption, arrows, close button, etc.).
* Built just using public methods/properties of PhotoSwipe.
* 
*/ (function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else $96c1c0a59496a49e$exports = factory();
})($96c1c0a59496a49e$exports, function() {
    "use strict";
    var PhotoSwipeUI_Default = function PhotoSwipeUI_Default(pswp, framework) {
        var ui = this;
        var _overlayUIUpdated = false, _controlsVisible = true, _fullscrenAPI, _controls, _captionContainer, _fakeCaptionContainer, _indexIndicator, _shareButton, _shareModal, _shareModalHidden = true, _initalCloseOnScrollValue, _isIdle, _listen, _loadingIndicator, _loadingIndicatorHidden, _loadingIndicatorTimeout, _galleryHasOneSlide, _options, _defaultUIOptions = {
            barsSize: {
                top: 44,
                bottom: "auto"
            },
            closeElClasses: [
                "item",
                "caption",
                "zoom-wrap",
                "ui",
                "top-bar"
            ],
            timeToIdle: 4000,
            timeToIdleOutside: 1000,
            loadingIndicatorDelay: 1000,
            addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl /*, isFake */ ) {
                if (!item.title) {
                    captionEl.children[0].innerHTML = "";
                    return false;
                }
                captionEl.children[0].innerHTML = item.title;
                return true;
            },
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
            tapToClose: false,
            tapToToggleControls: true,
            clickToCloseNonZoomable: true,
            shareButtons: [
                {
                    id: "facebook",
                    label: "Share on Facebook",
                    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                },
                {
                    id: "twitter",
                    label: "Tweet",
                    url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                },
                {
                    id: "pinterest",
                    label: "Pin it",
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                },
                {
                    id: "download",
                    label: "Download image",
                    url: "{{raw_image_url}}",
                    download: true
                }
            ],
            getImageURLForShare: function getImageURLForShare() {
                return pswp.currItem.src || "";
            },
            getPageURLForShare: function getPageURLForShare() {
                return window.location.href;
            },
            getTextForShare: function getTextForShare() {
                return pswp.currItem.title || "";
            },
            indexIndicatorSep: " / ",
            fitControlsWidth: 1200
        }, _blockControlsTap, _blockControlsTapTimeout;
        var _onControlsTap = function _onControlsTap(e) {
            if (_blockControlsTap) return true;
            e = e || window.event;
            if (_options.timeToIdle && _options.mouseUsed && !_isIdle) // reset idle timer
            _onIdleMouseMove();
            var target = e.target || e.srcElement, uiElement, clickedClass = target.getAttribute("class") || "", found;
            for(var i = 0; i < _uiElements.length; i++){
                uiElement = _uiElements[i];
                if (uiElement.onTap && clickedClass.indexOf("pswp__" + uiElement.name) > -1) {
                    uiElement.onTap();
                    found = true;
                }
            }
            if (found) {
                if (e.stopPropagation) e.stopPropagation();
                _blockControlsTap = true;
                // Some versions of Android don't prevent ghost click event 
                // when preventDefault() was called on touchstart and/or touchend.
                // 
                // This happens on v4.3, 4.2, 4.1, 
                // older versions strangely work correctly, 
                // but just in case we add delay on all of them)	
                var tapDelay = framework.features.isOldAndroid ? 600 : 30;
                _blockControlsTapTimeout = setTimeout(function() {
                    _blockControlsTap = false;
                }, tapDelay);
            }
        }, _fitControlsInViewport = function _fitControlsInViewport() {
            return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
        }, _togglePswpClass = function _togglePswpClass(el, cName, add) {
            framework[(add ? "add" : "remove") + "Class"](el, "pswp__" + cName);
        }, // add class when there is just one item in the gallery
        // (by default it hides left/right arrows and 1ofX counter)
        _countNumItems = function _countNumItems() {
            var hasOneSlide = _options.getNumItemsFn() === 1;
            if (hasOneSlide !== _galleryHasOneSlide) {
                _togglePswpClass(_controls, "ui--one-slide", hasOneSlide);
                _galleryHasOneSlide = hasOneSlide;
            }
        }, _toggleShareModalClass = function _toggleShareModalClass() {
            _togglePswpClass(_shareModal, "share-modal--hidden", _shareModalHidden);
        }, _toggleShareModal = function _toggleShareModal() {
            _shareModalHidden = !_shareModalHidden;
            if (!_shareModalHidden) {
                _toggleShareModalClass();
                setTimeout(function() {
                    if (!_shareModalHidden) framework.addClass(_shareModal, "pswp__share-modal--fade-in");
                }, 30);
            } else {
                framework.removeClass(_shareModal, "pswp__share-modal--fade-in");
                setTimeout(function() {
                    if (_shareModalHidden) _toggleShareModalClass();
                }, 300);
            }
            if (!_shareModalHidden) _updateShareURLs();
            return false;
        }, _openWindowPopup = function _openWindowPopup(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            pswp.shout("shareLinkClick", e, target);
            if (!target.href) return false;
            if (target.hasAttribute("download")) return true;
            window.open(target.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100));
            if (!_shareModalHidden) _toggleShareModal();
            return false;
        }, _updateShareURLs = function _updateShareURLs() {
            var shareButtonOut = "", shareButtonData, shareURL, image_url, page_url, share_text;
            for(var i = 0; i < _options.shareButtons.length; i++){
                shareButtonData = _options.shareButtons[i];
                image_url = _options.getImageURLForShare(shareButtonData);
                page_url = _options.getPageURLForShare(shareButtonData);
                share_text = _options.getTextForShare(shareButtonData);
                shareURL = shareButtonData.url.replace("{{url}}", encodeURIComponent(page_url)).replace("{{image_url}}", encodeURIComponent(image_url)).replace("{{raw_image_url}}", image_url).replace("{{text}}", encodeURIComponent(share_text));
                shareButtonOut += '<a href="' + shareURL + '" target="_blank" ' + 'class="pswp__share--' + shareButtonData.id + '"' + (shareButtonData.download ? "download" : "") + ">" + shareButtonData.label + "</a>";
                if (_options.parseShareButtonOut) shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
            }
            _shareModal.children[0].innerHTML = shareButtonOut;
            _shareModal.children[0].onclick = _openWindowPopup;
        }, _hasCloseClass = function _hasCloseClass(target) {
            for(var i = 0; i < _options.closeElClasses.length; i++){
                if (framework.hasClass(target, "pswp__" + _options.closeElClasses[i])) return true;
            }
        }, _idleInterval, _idleTimer, _idleIncrement = 0, _onIdleMouseMove = function _onIdleMouseMove() {
            clearTimeout(_idleTimer);
            _idleIncrement = 0;
            if (_isIdle) ui.setIdle(false);
        }, _onMouseLeaveWindow = function _onMouseLeaveWindow(e) {
            e = e ? e : window.event;
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === "HTML") {
                clearTimeout(_idleTimer);
                _idleTimer = setTimeout(function() {
                    ui.setIdle(true);
                }, _options.timeToIdleOutside);
            }
        }, _setupFullscreenAPI = function _setupFullscreenAPI() {
            if (_options.fullscreenEl && !framework.features.isOldAndroid) {
                if (!_fullscrenAPI) _fullscrenAPI = ui.getFullscreenAPI();
                if (_fullscrenAPI) {
                    framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                    ui.updateFullscreen();
                    framework.addClass(pswp.template, "pswp--supports-fs");
                } else framework.removeClass(pswp.template, "pswp--supports-fs");
            }
        }, _setupLoadingIndicator = function _setupLoadingIndicator() {
            // Setup loading indicator
            if (_options.preloaderEl) {
                _toggleLoadingIndicator(true);
                _listen("beforeChange", function() {
                    clearTimeout(_loadingIndicatorTimeout);
                    // display loading indicator with delay
                    _loadingIndicatorTimeout = setTimeout(function() {
                        if (pswp.currItem && pswp.currItem.loading) {
                            if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) // show preloader if progressive loading is not enabled, 
                            // or image width is not defined yet (because of slow connection)
                            _toggleLoadingIndicator(false);
                        // items-controller.js function allowProgressiveImg
                        } else _toggleLoadingIndicator(true); // hide preloader
                    }, _options.loadingIndicatorDelay);
                });
                _listen("imageLoadComplete", function(index, item) {
                    if (pswp.currItem === item) _toggleLoadingIndicator(true);
                });
            }
        }, _toggleLoadingIndicator = function _toggleLoadingIndicator(hide) {
            if (_loadingIndicatorHidden !== hide) {
                _togglePswpClass(_loadingIndicator, "preloader--active", !hide);
                _loadingIndicatorHidden = hide;
            }
        }, _applyNavBarGaps = function _applyNavBarGaps(item) {
            var gap = item.vGap;
            if (_fitControlsInViewport()) {
                var bars = _options.barsSize;
                if (_options.captionEl && bars.bottom === "auto") {
                    if (!_fakeCaptionContainer) {
                        _fakeCaptionContainer = framework.createEl("pswp__caption pswp__caption--fake");
                        _fakeCaptionContainer.appendChild(framework.createEl("pswp__caption__center"));
                        _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
                        framework.addClass(_controls, "pswp__ui--fit");
                    }
                    if (_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)) {
                        var captionSize = _fakeCaptionContainer.clientHeight;
                        gap.bottom = parseInt(captionSize, 10) || 44;
                    } else gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
                } else gap.bottom = bars.bottom === "auto" ? 0 : bars.bottom;
                // height of top bar is static, no need to calculate it
                gap.top = bars.top;
            } else gap.top = gap.bottom = 0;
        }, _setupIdle = function _setupIdle() {
            // Hide controls when mouse is used
            if (_options.timeToIdle) _listen("mouseUsed", function() {
                framework.bind(document, "mousemove", _onIdleMouseMove);
                framework.bind(document, "mouseout", _onMouseLeaveWindow);
                _idleInterval = setInterval(function() {
                    _idleIncrement++;
                    if (_idleIncrement === 2) ui.setIdle(true);
                }, _options.timeToIdle / 2);
            });
        }, _setupHidingControlsDuringGestures = function _setupHidingControlsDuringGestures() {
            // Hide controls on vertical drag
            _listen("onVerticalDrag", function(now) {
                if (_controlsVisible && now < 0.95) ui.hideControls();
                else if (!_controlsVisible && now >= 0.95) ui.showControls();
            });
            // Hide controls when pinching to close
            var pinchControlsHidden;
            _listen("onPinchClose", function(now) {
                if (_controlsVisible && now < 0.9) {
                    ui.hideControls();
                    pinchControlsHidden = true;
                } else if (pinchControlsHidden && !_controlsVisible && now > 0.9) ui.showControls();
            });
            _listen("zoomGestureEnded", function() {
                pinchControlsHidden = false;
                if (pinchControlsHidden && !_controlsVisible) ui.showControls();
            });
        };
        var _uiElements = [
            {
                name: "caption",
                option: "captionEl",
                onInit: function onInit(el) {
                    _captionContainer = el;
                }
            },
            {
                name: "share-modal",
                option: "shareEl",
                onInit: function onInit(el) {
                    _shareModal = el;
                },
                onTap: function onTap() {
                    _toggleShareModal();
                }
            },
            {
                name: "button--share",
                option: "shareEl",
                onInit: function onInit(el) {
                    _shareButton = el;
                },
                onTap: function onTap() {
                    _toggleShareModal();
                }
            },
            {
                name: "button--zoom",
                option: "zoomEl",
                onTap: pswp.toggleDesktopZoom
            },
            {
                name: "counter",
                option: "counterEl",
                onInit: function onInit(el) {
                    _indexIndicator = el;
                }
            },
            {
                name: "button--close",
                option: "closeEl",
                onTap: pswp.close
            },
            {
                name: "button--arrow--left",
                option: "arrowEl",
                onTap: pswp.prev
            },
            {
                name: "button--arrow--right",
                option: "arrowEl",
                onTap: pswp.next
            },
            {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function onTap() {
                    if (_fullscrenAPI.isFullscreen()) _fullscrenAPI.exit();
                    else _fullscrenAPI.enter();
                }
            },
            {
                name: "preloader",
                option: "preloaderEl",
                onInit: function onInit(el) {
                    _loadingIndicator = el;
                }
            }
        ];
        var _setupUIElements = function _setupUIElements() {
            var item, classAttr, uiElement;
            var loopThroughChildElements = function loopThroughChildElements(sChildren) {
                if (!sChildren) return;
                var l = sChildren.length;
                for(var i = 0; i < l; i++){
                    item = sChildren[i];
                    classAttr = item.className;
                    for(var a = 0; a < _uiElements.length; a++){
                        uiElement = _uiElements[a];
                        if (classAttr.indexOf("pswp__" + uiElement.name) > -1) {
                            if (_options[uiElement.option]) {
                                framework.removeClass(item, "pswp__element--disabled");
                                if (uiElement.onInit) uiElement.onInit(item);
                            //item.style.display = 'block';
                            } else framework.addClass(item, "pswp__element--disabled");
                        }
                    }
                }
            };
            loopThroughChildElements(_controls.children);
            var topBar = framework.getChildByClass(_controls, "pswp__top-bar");
            if (topBar) loopThroughChildElements(topBar.children);
        };
        ui.init = function() {
            // extend options
            framework.extend(pswp.options, _defaultUIOptions, true);
            // create local link for fast access
            _options = pswp.options;
            // find pswp__ui element
            _controls = framework.getChildByClass(pswp.scrollWrap, "pswp__ui");
            // create local link
            _listen = pswp.listen;
            _setupHidingControlsDuringGestures();
            // update controls when slides change
            _listen("beforeChange", ui.update);
            // toggle zoom on double-tap
            _listen("doubleTap", function(point) {
                var initialZoomLevel = pswp.currItem.initialZoomLevel;
                if (pswp.getZoomLevel() !== initialZoomLevel) pswp.zoomTo(initialZoomLevel, point, 333);
                else pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
            });
            // Allow text selection in caption
            _listen("preventDragEvent", function(e, isDown, preventObj) {
                var t = e.target || e.srcElement;
                if (t && t.getAttribute("class") && e.type.indexOf("mouse") > -1 && (t.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(t.tagName))) preventObj.prevent = false;
            });
            // bind events for UI
            _listen("bindEvents", function() {
                framework.bind(_controls, "pswpTap click", _onControlsTap);
                framework.bind(pswp.scrollWrap, "pswpTap", ui.onGlobalTap);
                if (!pswp.likelyTouchDevice) framework.bind(pswp.scrollWrap, "mouseover", ui.onMouseOver);
            });
            // unbind events for UI
            _listen("unbindEvents", function() {
                if (!_shareModalHidden) _toggleShareModal();
                if (_idleInterval) clearInterval(_idleInterval);
                framework.unbind(document, "mouseout", _onMouseLeaveWindow);
                framework.unbind(document, "mousemove", _onIdleMouseMove);
                framework.unbind(_controls, "pswpTap click", _onControlsTap);
                framework.unbind(pswp.scrollWrap, "pswpTap", ui.onGlobalTap);
                framework.unbind(pswp.scrollWrap, "mouseover", ui.onMouseOver);
                if (_fullscrenAPI) {
                    framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                    if (_fullscrenAPI.isFullscreen()) {
                        _options.hideAnimationDuration = 0;
                        _fullscrenAPI.exit();
                    }
                    _fullscrenAPI = null;
                }
            });
            // clean up things when gallery is destroyed
            _listen("destroy", function() {
                if (_options.captionEl) {
                    if (_fakeCaptionContainer) _controls.removeChild(_fakeCaptionContainer);
                    framework.removeClass(_captionContainer, "pswp__caption--empty");
                }
                if (_shareModal) _shareModal.children[0].onclick = null;
                framework.removeClass(_controls, "pswp__ui--over-close");
                framework.addClass(_controls, "pswp__ui--hidden");
                ui.setIdle(false);
            });
            if (!_options.showAnimationDuration) framework.removeClass(_controls, "pswp__ui--hidden");
            _listen("initialZoomIn", function() {
                if (_options.showAnimationDuration) framework.removeClass(_controls, "pswp__ui--hidden");
            });
            _listen("initialZoomOut", function() {
                framework.addClass(_controls, "pswp__ui--hidden");
            });
            _listen("parseVerticalMargin", _applyNavBarGaps);
            _setupUIElements();
            if (_options.shareEl && _shareButton && _shareModal) _shareModalHidden = true;
            _countNumItems();
            _setupIdle();
            _setupFullscreenAPI();
            _setupLoadingIndicator();
        };
        ui.setIdle = function(isIdle) {
            _isIdle = isIdle;
            _togglePswpClass(_controls, "ui--idle", isIdle);
        };
        ui.update = function() {
            // Don't update UI if it's hidden
            if (_controlsVisible && pswp.currItem) {
                ui.updateIndexIndicator();
                if (_options.captionEl) {
                    _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
                    _togglePswpClass(_captionContainer, "caption--empty", !pswp.currItem.title);
                }
                _overlayUIUpdated = true;
            } else _overlayUIUpdated = false;
            if (!_shareModalHidden) _toggleShareModal();
            _countNumItems();
        };
        ui.updateFullscreen = function(e) {
            if (e) // some browsers change window scroll position during the fullscreen
            // so PhotoSwipe updates it just in case
            setTimeout(function() {
                pswp.setScrollOffset(0, framework.getScrollY());
            }, 50);
            // toogle pswp--fs class on root element
            framework[(_fullscrenAPI.isFullscreen() ? "add" : "remove") + "Class"](pswp.template, "pswp--fs");
        };
        ui.updateIndexIndicator = function() {
            if (_options.counterEl) _indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
        };
        ui.onGlobalTap = function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (_blockControlsTap) return;
            if (e.detail && e.detail.pointerType === "mouse") {
                // close gallery if clicked outside of the image
                if (_hasCloseClass(target)) {
                    pswp.close();
                    return;
                }
                if (framework.hasClass(target, "pswp__img")) {
                    if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
                        if (_options.clickToCloseNonZoomable) pswp.close();
                    } else pswp.toggleDesktopZoom(e.detail.releasePoint);
                }
            } else {
                // tap anywhere (except buttons) to toggle visibility of controls
                if (_options.tapToToggleControls) {
                    if (_controlsVisible) ui.hideControls();
                    else ui.showControls();
                }
                // tap to close gallery
                if (_options.tapToClose && (framework.hasClass(target, "pswp__img") || _hasCloseClass(target))) {
                    pswp.close();
                    return;
                }
            }
        };
        ui.onMouseOver = function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            // add class when mouse is over an element that should close the gallery
            _togglePswpClass(_controls, "ui--over-close", _hasCloseClass(target));
        };
        ui.hideControls = function() {
            framework.addClass(_controls, "pswp__ui--hidden");
            _controlsVisible = false;
        };
        ui.showControls = function() {
            _controlsVisible = true;
            if (!_overlayUIUpdated) ui.update();
            framework.removeClass(_controls, "pswp__ui--hidden");
        };
        ui.supportsFullscreen = function() {
            var d = document;
            return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
        };
        ui.getFullscreenAPI = function() {
            var dE = document.documentElement, api, tF = "fullscreenchange";
            if (dE.requestFullscreen) api = {
                enterK: "requestFullscreen",
                exitK: "exitFullscreen",
                elementK: "fullscreenElement",
                eventK: tF
            };
            else if (dE.mozRequestFullScreen) api = {
                enterK: "mozRequestFullScreen",
                exitK: "mozCancelFullScreen",
                elementK: "mozFullScreenElement",
                eventK: "moz" + tF
            };
            else if (dE.webkitRequestFullscreen) api = {
                enterK: "webkitRequestFullscreen",
                exitK: "webkitExitFullscreen",
                elementK: "webkitFullscreenElement",
                eventK: "webkit" + tF
            };
            else if (dE.msRequestFullscreen) api = {
                enterK: "msRequestFullscreen",
                exitK: "msExitFullscreen",
                elementK: "msFullscreenElement",
                eventK: "MSFullscreenChange"
            };
            if (api) {
                api.enter = function() {
                    // disable close-on-scroll in fullscreen
                    _initalCloseOnScrollValue = _options.closeOnScroll;
                    _options.closeOnScroll = false;
                    if (this.enterK === "webkitRequestFullscreen") pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                    else return pswp.template[this.enterK]();
                };
                api.exit = function() {
                    _options.closeOnScroll = _initalCloseOnScrollValue;
                    return document[this.exitK]();
                };
                api.isFullscreen = function() {
                    return document[this.elementK];
                };
            }
            return api;
        };
    };
    return PhotoSwipeUI_Default;
});


var $517b192713fb1ca4$var$jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)));
(function($, PhotoSwipe) {
    "use strict";
    var PhotoGallery = function PhotoGallery1(element, options) {
        this.$element = $(element);
        this.options = $.extend({}, PhotoGallery.DEFAULTS, options);
        this.$items = this.$element.find(this.options.itemSelector);
        if (this.options.itemFilter) this.$items = this.$items.filter(this.options.itemFilter);
        this.$pswpElement = $(this.options.pswpElement);
        var that = this;
        this.pswpItems = this.$items.map(function() {
            var el = $(this);
            var size = el.data("size").split("x");
            return {
                src: el.attr("href"),
                w: size[0],
                h: size[1],
                el: el[0],
                title: el.parent().find(that.options.captionSelector).html()
            };
        }).get();
        var self = this;
        this.$element.on("click", this.options.itemSelector, function(e) {
            // build items array
            e.preventDefault();
            self.show(this);
        });
    };
    PhotoGallery.DEFAULTS = {
        ui: (0, (/*@__PURE__*/$parcel$interopDefault($96c1c0a59496a49e$exports))),
        pswpElement: ".pswp",
        itemSelector: "a.gallery__enlarge",
        itemFilter: null,
        captionSelector: ".caption"
    };
    PhotoGallery.prototype.show = function(element) {
        // define options (if needed)
        var options = $.extend({}, this.options, {
            index: this.$items.index($(element))
        });
        // Initializes and opens PhotoSwipe
        var gallery = new PhotoSwipe(this.$pswpElement[0], this.options.ui, this.pswpItems, options);
        gallery.init();
    };
    // PLUGIN DEFINITION
    // ========================
    $.fn.photogallery = function(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data("sr.photogallery");
            var options = typeof option === "object" && option;
            if (!data) $this.data("sr.photogallery", data = new PhotoGallery(this, options));
        });
    };
    $.fn.photogallery.Constructor = PhotoGallery;
})($517b192713fb1ca4$var$jQuery, (0, (/*@__PURE__*/$parcel$interopDefault($23e1e44ff66ceb71$exports))));


var $d8b82b1bb410b51b$exports = {};

$d8b82b1bb410b51b$exports = (parcelRequire("cosnu"));


var $b14b149dc7b90384$var$script;




var $b14b149dc7b90384$var$initialize = function() {
    $b14b149dc7b90384$var$script = (parcelRequire("enz33"));
    if ($b14b149dc7b90384$var$script.__esModule) $b14b149dc7b90384$var$script = $b14b149dc7b90384$var$script.default;
    $b14b149dc7b90384$var$script.render = (parcelRequire("9q13L")).render;
    $b14b149dc7b90384$var$script.staticRenderFns = (parcelRequire("9q13L")).staticRenderFns;
    $b14b149dc7b90384$var$script._scopeId = "data-v-2db14f";
    (parcelRequire("aHthO")).default($b14b149dc7b90384$var$script);
    $b14b149dc7b90384$var$script.__scopeId = "data-v-2db14f";
    $b14b149dc7b90384$var$script.__file = "NewsApp.vue";
};
$b14b149dc7b90384$var$initialize();
var $b14b149dc7b90384$export$2e2bcd8739ae039 = $b14b149dc7b90384$var$script;


var $94e10b35aac535fc$var$script;




var $94e10b35aac535fc$var$initialize = function() {
    $94e10b35aac535fc$var$script = (parcelRequire("2iPxl"));
    if ($94e10b35aac535fc$var$script.__esModule) $94e10b35aac535fc$var$script = $94e10b35aac535fc$var$script.default;
    $94e10b35aac535fc$var$script.render = (parcelRequire("5K88x")).render;
    $94e10b35aac535fc$var$script.staticRenderFns = (parcelRequire("5K88x")).staticRenderFns;
    $94e10b35aac535fc$var$script._scopeId = "data-v-1aa167";
    (parcelRequire("55t4g")).default($94e10b35aac535fc$var$script);
    $94e10b35aac535fc$var$script.__scopeId = "data-v-1aa167";
    $94e10b35aac535fc$var$script.__file = "TZMap.vue";
};
$94e10b35aac535fc$var$initialize();
var $94e10b35aac535fc$export$2e2bcd8739ae039 = $94e10b35aac535fc$var$script;


var $ce40c7b0d439476b$exports = {};
"use strict";
Object.defineProperty($ce40c7b0d439476b$exports, "__esModule", {
    value: true
});
$ce40c7b0d439476b$exports.StreetViewPanorama = $ce40c7b0d439476b$exports.MountableMixin = $ce40c7b0d439476b$exports.Autocomplete = $ce40c7b0d439476b$exports.MapElementFactory = $ce40c7b0d439476b$exports.MapElementMixin = $ce40c7b0d439476b$exports.PlaceInput = $ce40c7b0d439476b$exports.Map = $ce40c7b0d439476b$exports.InfoWindow = $ce40c7b0d439476b$exports.Rectangle = $ce40c7b0d439476b$exports.Cluster = $ce40c7b0d439476b$exports.Circle = $ce40c7b0d439476b$exports.Polygon = $ce40c7b0d439476b$exports.Polyline = $ce40c7b0d439476b$exports.Marker = $ce40c7b0d439476b$exports.loadGmapApi = undefined;
var $ce40c7b0d439476b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
// Vue component imports
$ce40c7b0d439476b$exports.install = $ce40c7b0d439476b$var$install;
$ce40c7b0d439476b$exports.gmapApi = $ce40c7b0d439476b$var$gmapApi;
var $d2898d6f0e7d0f7b$exports = {};
"use strict";
Object.defineProperty($d2898d6f0e7d0f7b$exports, "__esModule", {
    value: true
});
// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js
$d2898d6f0e7d0f7b$exports.default = function(fn) {
    var called = false;
    var ret = void 0;
    return function() {
        if (!called) {
            called = true;
            ret = fn();
        }
        return ret;
    };
};


var $ce40c7b0d439476b$var$_lazyValue2 = $ce40c7b0d439476b$var$_interopRequireDefault($d2898d6f0e7d0f7b$exports);
var $04a92c71a91768a1$exports = {};

var $1ciUP = parcelRequire("1ciUP");
"use strict";
Object.defineProperty($04a92c71a91768a1$exports, "__esModule", {
    value: true
});
var $04a92c71a91768a1$var$_typeof = typeof Symbol === "function" && (0, $1ciUP._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $1ciUP._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $1ciUP._)(obj);
};
var $04a92c71a91768a1$var$isApiSetUp = false;
/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */ var $04a92c71a91768a1$var$loadGmapApi = $04a92c71a91768a1$exports.loadGmapApi = function loadGmapApi(options, loadCn) {
    if (typeof document === "undefined") // Do nothing if run from server-side
    return;
    if (!$04a92c71a91768a1$var$isApiSetUp) {
        $04a92c71a91768a1$var$isApiSetUp = true;
        var googleMapScript = document.createElement("SCRIPT");
        // Allow options to be an object.
        // This is to support more esoteric means of loading Google Maps,
        // such as Google for business
        // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
        if ((typeof options === "undefined" ? "undefined" : $04a92c71a91768a1$var$_typeof(options)) !== "object") throw new Error("options should  be an object");
        // libraries
        if (Array.prototype.isPrototypeOf(options.libraries)) options.libraries = options.libraries.join(",");
        options["callback"] = "vueGoogleMapsInit";
        var baseUrl = "https://maps.googleapis.com/";
        if (typeof loadCn === "boolean" && loadCn === true) baseUrl = "https://maps.google.cn/";
        var url = baseUrl + "maps/api/js?" + Object.keys(options).map(function(key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(options[key]);
        }).join("&");
        googleMapScript.setAttribute("src", url);
        googleMapScript.setAttribute("async", "");
        googleMapScript.setAttribute("defer", "");
        document.head.appendChild(googleMapScript);
    } else throw new Error("You already started the loading of google maps");
};


var $7f5688c7566232d1$exports = {};
"use strict";
Object.defineProperty($7f5688c7566232d1$exports, "__esModule", {
    value: true
});

var $aPMlq = parcelRequire("aPMlq");
var $7f5688c7566232d1$var$_mapElementFactory2 = $7f5688c7566232d1$var$_interopRequireDefault($aPMlq);
function $7f5688c7566232d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7f5688c7566232d1$var$props = {
    animation: {
        twoWay: true,
        type: Number
    },
    attribution: {
        type: Object
    },
    clickable: {
        type: Boolean,
        twoWay: true,
        default: true
    },
    cursor: {
        type: String,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        twoWay: true,
        default: false
    },
    icon: {
        twoWay: true
    },
    label: {},
    opacity: {
        type: Number,
        default: 1
    },
    options: {
        type: Object
    },
    place: {
        type: Object
    },
    position: {
        type: Object,
        twoWay: true
    },
    shape: {
        type: Object,
        twoWay: true
    },
    title: {
        type: String,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    },
    visible: {
        twoWay: true,
        default: true
    }
};
var $7f5688c7566232d1$var$events = [
    "click",
    "rightclick",
    "dblclick",
    "drag",
    "dragstart",
    "dragend",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout"
];
/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */ $7f5688c7566232d1$exports.default = (0, $7f5688c7566232d1$var$_mapElementFactory2.default)({
    mappedProps: $7f5688c7566232d1$var$props,
    events: $7f5688c7566232d1$var$events,
    name: "marker",
    ctr: function ctr() {
        return google.maps.Marker;
    },
    inject: {
        "$clusterPromise": {
            default: null
        }
    },
    render: function render(h) {
        if (!this.$slots.default || this.$slots.default.length === 0) return "";
        else if (this.$slots.default.length === 1) // So that infowindows can have a marker parent
        return this.$slots.default[0];
        else return h("div", this.$slots.default);
    },
    destroyed: function destroyed() {
        if (!this.$markerObject) return;
        if (this.$clusterObject) // Repaint will be performed in `updated()` of cluster
        this.$clusterObject.removeMarker(this.$markerObject, true);
        else this.$markerObject.setMap(null);
    },
    beforeCreate: function beforeCreate(options) {
        if (this.$clusterPromise) options.map = null;
        return this.$clusterPromise;
    },
    afterCreate: function afterCreate(inst) {
        var _this = this;
        if (this.$clusterPromise) this.$clusterPromise.then(function(co) {
            co.addMarker(inst);
            _this.$clusterObject = co;
        });
    }
});


var $ce40c7b0d439476b$var$_marker2 = $ce40c7b0d439476b$var$_interopRequireDefault($7f5688c7566232d1$exports);
var $b4038bf4a03d81e6$exports = {};
"use strict";
Object.defineProperty($b4038bf4a03d81e6$exports, "__esModule", {
    value: true
});
var $b4038bf4a03d81e6$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $aPMlq = parcelRequire("aPMlq");
var $b4038bf4a03d81e6$var$_mapElementFactory2 = $b4038bf4a03d81e6$var$_interopRequireDefault($aPMlq);
function $b4038bf4a03d81e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b4038bf4a03d81e6$var$props = {
    draggable: {
        type: Boolean
    },
    editable: {
        type: Boolean
    },
    options: {
        twoWay: false,
        type: Object
    },
    path: {
        type: Array,
        twoWay: true
    }
};
var $b4038bf4a03d81e6$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$b4038bf4a03d81e6$exports.default = (0, $b4038bf4a03d81e6$var$_mapElementFactory2.default)({
    mappedProps: $b4038bf4a03d81e6$var$props,
    props: {
        deepWatch: {
            type: Boolean,
            default: false
        }
    },
    events: $b4038bf4a03d81e6$var$events,
    name: "polyline",
    ctr: function ctr() {
        return google.maps.Polyline;
    },
    afterCreate: function afterCreate() {
        var _this = this;
        var clearEvents = function clearEvents() {};
        this.$watch("path", function(path) {
            if (path) {
                clearEvents();
                _this.$polylineObject.setPath(path);
                var mvcPath = _this.$polylineObject.getPath();
                var eventListeners = [];
                var updatePaths = function updatePaths() {
                    _this.$emit("path_changed", _this.$polylineObject.getPath());
                };
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths)
                ]);
                clearEvents = function clearEvents() {
                    eventListeners.map(function(_ref) {
                        var _ref2 = $b4038bf4a03d81e6$var$_slicedToArray(_ref, 2), obj = _ref2[0], listenerHandle = _ref2[1];
                        return google.maps.event.removeListener(listenerHandle);
                    });
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
    }
});


var $ce40c7b0d439476b$var$_polyline2 = $ce40c7b0d439476b$var$_interopRequireDefault($b4038bf4a03d81e6$exports);
var $8e3f1a35b3aed101$exports = {};
"use strict";
Object.defineProperty($8e3f1a35b3aed101$exports, "__esModule", {
    value: true
});
var $8e3f1a35b3aed101$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $aPMlq = parcelRequire("aPMlq");
var $8e3f1a35b3aed101$var$_mapElementFactory2 = $8e3f1a35b3aed101$var$_interopRequireDefault($aPMlq);
function $8e3f1a35b3aed101$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8e3f1a35b3aed101$var$props = {
    draggable: {
        type: Boolean
    },
    editable: {
        type: Boolean
    },
    options: {
        type: Object
    },
    path: {
        type: Array,
        twoWay: true,
        noBind: true
    },
    paths: {
        type: Array,
        twoWay: true,
        noBind: true
    }
};
var $8e3f1a35b3aed101$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$8e3f1a35b3aed101$exports.default = (0, $8e3f1a35b3aed101$var$_mapElementFactory2.default)({
    props: {
        deepWatch: {
            type: Boolean,
            default: false
        }
    },
    events: $8e3f1a35b3aed101$var$events,
    mappedProps: $8e3f1a35b3aed101$var$props,
    name: "polygon",
    ctr: function ctr() {
        return google.maps.Polygon;
    },
    beforeCreate: function beforeCreate(options) {
        if (!options.path) delete options.path;
        if (!options.paths) delete options.paths;
    },
    afterCreate: function afterCreate(inst) {
        var _this = this;
        var clearEvents = function clearEvents() {};
        // Watch paths, on our own, because we do not want to set either when it is
        // empty
        this.$watch("paths", function(paths) {
            if (paths) {
                clearEvents();
                inst.setPaths(paths);
                var updatePaths = function updatePaths() {
                    _this.$emit("paths_changed", inst.getPaths());
                };
                var eventListeners = [];
                var mvcArray = inst.getPaths();
                for(var i = 0; i < mvcArray.getLength(); i++){
                    var mvcPath = mvcArray.getAt(i);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("insert_at", updatePaths)
                    ]);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("remove_at", updatePaths)
                    ]);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("set_at", updatePaths)
                    ]);
                }
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("set_at", updatePaths)
                ]);
                clearEvents = function clearEvents() {
                    eventListeners.map(function(_ref) {
                        var _ref2 = $8e3f1a35b3aed101$var$_slicedToArray(_ref, 2), obj = _ref2[0], listenerHandle = _ref2[1];
                        return google.maps.event.removeListener(listenerHandle);
                    });
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
        this.$watch("path", function(path) {
            if (path) {
                clearEvents();
                inst.setPaths(path);
                var mvcPath = inst.getPath();
                var eventListeners = [];
                var updatePaths = function updatePaths() {
                    _this.$emit("path_changed", inst.getPath());
                };
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths)
                ]);
                clearEvents = function clearEvents() {
                    eventListeners.map(function(_ref3) {
                        var _ref4 = $8e3f1a35b3aed101$var$_slicedToArray(_ref3, 2), obj = _ref4[0], listenerHandle = _ref4[1];
                        return google.maps.event.removeListener(listenerHandle);
                    });
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
    }
});


var $ce40c7b0d439476b$var$_polygon2 = $ce40c7b0d439476b$var$_interopRequireDefault($8e3f1a35b3aed101$exports);
var $6caf146520a743e5$exports = {};
"use strict";
Object.defineProperty($6caf146520a743e5$exports, "__esModule", {
    value: true
});

var $aPMlq = parcelRequire("aPMlq");
var $6caf146520a743e5$var$_mapElementFactory2 = $6caf146520a743e5$var$_interopRequireDefault($aPMlq);
function $6caf146520a743e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6caf146520a743e5$var$props = {
    center: {
        type: Object,
        twoWay: true,
        required: true
    },
    radius: {
        type: Number,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        default: false
    },
    editable: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        twoWay: false
    }
};
var $6caf146520a743e5$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$6caf146520a743e5$exports.default = (0, $6caf146520a743e5$var$_mapElementFactory2.default)({
    mappedProps: $6caf146520a743e5$var$props,
    name: "circle",
    ctr: function ctr() {
        return google.maps.Circle;
    },
    events: $6caf146520a743e5$var$events
});


var $ce40c7b0d439476b$var$_circle2 = $ce40c7b0d439476b$var$_interopRequireDefault($6caf146520a743e5$exports);
var $3cbd2fd1edf8ad65$exports = {};
"use strict";
Object.defineProperty($3cbd2fd1edf8ad65$exports, "__esModule", {
    value: true
});

var $aPMlq = parcelRequire("aPMlq");
var $3cbd2fd1edf8ad65$var$_mapElementFactory2 = $3cbd2fd1edf8ad65$var$_interopRequireDefault($aPMlq);
function $3cbd2fd1edf8ad65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3cbd2fd1edf8ad65$var$props = {
    bounds: {
        type: Object,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        default: false
    },
    editable: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        twoWay: false
    }
};
var $3cbd2fd1edf8ad65$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$3cbd2fd1edf8ad65$exports.default = (0, $3cbd2fd1edf8ad65$var$_mapElementFactory2.default)({
    mappedProps: $3cbd2fd1edf8ad65$var$props,
    name: "rectangle",
    ctr: function ctr() {
        return google.maps.Rectangle;
    },
    events: $3cbd2fd1edf8ad65$var$events
});


var $ce40c7b0d439476b$var$_rectangle2 = $ce40c7b0d439476b$var$_interopRequireDefault($3cbd2fd1edf8ad65$exports);
var $80b6081aafa72dd4$exports = {};

$parcel$defineInteropFlag($80b6081aafa72dd4$exports);

$parcel$export($80b6081aafa72dd4$exports, "default", function () { return $80b6081aafa72dd4$export$2e2bcd8739ae039; });
var $80b6081aafa72dd4$var$script;




var $80b6081aafa72dd4$var$initialize = function() {
    $80b6081aafa72dd4$var$script = (parcelRequire("1mW8x"));
    if ($80b6081aafa72dd4$var$script.__esModule) $80b6081aafa72dd4$var$script = $80b6081aafa72dd4$var$script.default;
    $80b6081aafa72dd4$var$script.render = (parcelRequire("cvBCQ")).render;
    $80b6081aafa72dd4$var$script.staticRenderFns = (parcelRequire("cvBCQ")).staticRenderFns;
    $80b6081aafa72dd4$var$script._scopeId = "data-v-55aabc";
    (parcelRequire("ivgzu")).default($80b6081aafa72dd4$var$script);
    $80b6081aafa72dd4$var$script.__scopeId = "data-v-55aabc";
    $80b6081aafa72dd4$var$script.__file = "infoWindow.vue";
};
$80b6081aafa72dd4$var$initialize();
var $80b6081aafa72dd4$export$2e2bcd8739ae039 = $80b6081aafa72dd4$var$script;


var $ce40c7b0d439476b$var$_infoWindow2 = $ce40c7b0d439476b$var$_interopRequireDefault($80b6081aafa72dd4$exports);
var $2f9324d1aad920cb$exports = {};

$parcel$defineInteropFlag($2f9324d1aad920cb$exports);

$parcel$export($2f9324d1aad920cb$exports, "default", function () { return $2f9324d1aad920cb$export$2e2bcd8739ae039; });
var $2f9324d1aad920cb$var$script;





var $2f9324d1aad920cb$var$initialize = function() {
    $2f9324d1aad920cb$var$script = (parcelRequire("lqgY7"));
    if ($2f9324d1aad920cb$var$script.__esModule) $2f9324d1aad920cb$var$script = $2f9324d1aad920cb$var$script.default;
    $2f9324d1aad920cb$var$script.render = (parcelRequire("72J80")).render;
    $2f9324d1aad920cb$var$script.staticRenderFns = (parcelRequire("72J80")).staticRenderFns;
    $2f9324d1aad920cb$var$script._scopeId = "data-v-94b5d3";
    $2f9324d1aad920cb$var$script.__cssModules = {};
    (parcelRequire("g35cf")).default($2f9324d1aad920cb$var$script);
    $2f9324d1aad920cb$var$script.__scopeId = "data-v-94b5d3";
    $2f9324d1aad920cb$var$script.__file = "map.vue";
};
$2f9324d1aad920cb$var$initialize();
var $2f9324d1aad920cb$export$2e2bcd8739ae039 = $2f9324d1aad920cb$var$script;


var $ce40c7b0d439476b$var$_map2 = $ce40c7b0d439476b$var$_interopRequireDefault($2f9324d1aad920cb$exports);
var $4aea56fb709a5943$exports = {};

$parcel$defineInteropFlag($4aea56fb709a5943$exports);

$parcel$export($4aea56fb709a5943$exports, "default", function () { return $4aea56fb709a5943$export$2e2bcd8739ae039; });
var $4aea56fb709a5943$var$script;





var $4aea56fb709a5943$var$initialize = function() {
    $4aea56fb709a5943$var$script = (parcelRequire("5N94W"));
    if ($4aea56fb709a5943$var$script.__esModule) $4aea56fb709a5943$var$script = $4aea56fb709a5943$var$script.default;
    $4aea56fb709a5943$var$script.render = (parcelRequire("3C85z")).render;
    $4aea56fb709a5943$var$script.staticRenderFns = (parcelRequire("3C85z")).staticRenderFns;
    $4aea56fb709a5943$var$script._scopeId = "data-v-c8dbcc";
    $4aea56fb709a5943$var$script.__cssModules = {};
    (parcelRequire("ft8tN")).default($4aea56fb709a5943$var$script);
    $4aea56fb709a5943$var$script.__scopeId = "data-v-c8dbcc";
    $4aea56fb709a5943$var$script.__file = "streetViewPanorama.vue";
};
$4aea56fb709a5943$var$initialize();
var $4aea56fb709a5943$export$2e2bcd8739ae039 = $4aea56fb709a5943$var$script;


var $ce40c7b0d439476b$var$_streetViewPanorama2 = $ce40c7b0d439476b$var$_interopRequireDefault($4aea56fb709a5943$exports);
var $89aa169825d023dc$exports = {};

$parcel$defineInteropFlag($89aa169825d023dc$exports);

$parcel$export($89aa169825d023dc$exports, "default", function () { return $89aa169825d023dc$export$2e2bcd8739ae039; });
var $89aa169825d023dc$var$script;




var $89aa169825d023dc$var$initialize = function() {
    $89aa169825d023dc$var$script = (parcelRequire("d3PgA"));
    if ($89aa169825d023dc$var$script.__esModule) $89aa169825d023dc$var$script = $89aa169825d023dc$var$script.default;
    $89aa169825d023dc$var$script.render = (parcelRequire("6DkLa")).render;
    $89aa169825d023dc$var$script.staticRenderFns = (parcelRequire("6DkLa")).staticRenderFns;
    $89aa169825d023dc$var$script._scopeId = "data-v-bd149b";
    (parcelRequire("irgqM")).default($89aa169825d023dc$var$script);
    $89aa169825d023dc$var$script.__scopeId = "data-v-bd149b";
    $89aa169825d023dc$var$script.__file = "placeInput.vue";
};
$89aa169825d023dc$var$initialize();
var $89aa169825d023dc$export$2e2bcd8739ae039 = $89aa169825d023dc$var$script;


var $ce40c7b0d439476b$var$_placeInput2 = $ce40c7b0d439476b$var$_interopRequireDefault($89aa169825d023dc$exports);
var $832965e3465f0b0e$exports = {};

$parcel$defineInteropFlag($832965e3465f0b0e$exports);

$parcel$export($832965e3465f0b0e$exports, "default", function () { return $832965e3465f0b0e$export$2e2bcd8739ae039; });
var $832965e3465f0b0e$var$script;




var $832965e3465f0b0e$var$initialize = function() {
    $832965e3465f0b0e$var$script = (parcelRequire("kgAzi"));
    if ($832965e3465f0b0e$var$script.__esModule) $832965e3465f0b0e$var$script = $832965e3465f0b0e$var$script.default;
    $832965e3465f0b0e$var$script.render = (parcelRequire("eHprZ")).render;
    $832965e3465f0b0e$var$script.staticRenderFns = (parcelRequire("eHprZ")).staticRenderFns;
    $832965e3465f0b0e$var$script._scopeId = "data-v-aa3a26";
    (parcelRequire("dbOht")).default($832965e3465f0b0e$var$script);
    $832965e3465f0b0e$var$script.__scopeId = "data-v-aa3a26";
    $832965e3465f0b0e$var$script.__file = "autocomplete.vue";
};
$832965e3465f0b0e$var$initialize();
var $832965e3465f0b0e$export$2e2bcd8739ae039 = $832965e3465f0b0e$var$script;


var $ce40c7b0d439476b$var$_autocomplete2 = $ce40c7b0d439476b$var$_interopRequireDefault($832965e3465f0b0e$exports);

var $bax0Z = parcelRequire("bax0Z");
var $ce40c7b0d439476b$var$_mapElementMixin2 = $ce40c7b0d439476b$var$_interopRequireDefault($bax0Z);

var $aPMlq = parcelRequire("aPMlq");
var $ce40c7b0d439476b$var$_mapElementFactory2 = $ce40c7b0d439476b$var$_interopRequireDefault($aPMlq);

var $iRPkI = parcelRequire("iRPkI");
var $ce40c7b0d439476b$var$_mountableMixin2 = $ce40c7b0d439476b$var$_interopRequireDefault($iRPkI);
function $ce40c7b0d439476b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var $ce40c7b0d439476b$var$Cluster = undefined;
var $ce40c7b0d439476b$var$GmapApi = null;
// export everything
$ce40c7b0d439476b$exports.loadGmapApi = $04a92c71a91768a1$exports.loadGmapApi;
$ce40c7b0d439476b$exports.Marker = $ce40c7b0d439476b$var$_marker2.default;
$ce40c7b0d439476b$exports.Polyline = $ce40c7b0d439476b$var$_polyline2.default;
$ce40c7b0d439476b$exports.Polygon = $ce40c7b0d439476b$var$_polygon2.default;
$ce40c7b0d439476b$exports.Circle = $ce40c7b0d439476b$var$_circle2.default;
$ce40c7b0d439476b$exports.Cluster = $ce40c7b0d439476b$var$Cluster;
$ce40c7b0d439476b$exports.Rectangle = $ce40c7b0d439476b$var$_rectangle2.default;
$ce40c7b0d439476b$exports.InfoWindow = $ce40c7b0d439476b$var$_infoWindow2.default;
$ce40c7b0d439476b$exports.Map = $ce40c7b0d439476b$var$_map2.default;
$ce40c7b0d439476b$exports.PlaceInput = $ce40c7b0d439476b$var$_placeInput2.default;
$ce40c7b0d439476b$exports.MapElementMixin = $ce40c7b0d439476b$var$_mapElementMixin2.default;
$ce40c7b0d439476b$exports.MapElementFactory = $ce40c7b0d439476b$var$_mapElementFactory2.default;
$ce40c7b0d439476b$exports.Autocomplete = $ce40c7b0d439476b$var$_autocomplete2.default;
$ce40c7b0d439476b$exports.MountableMixin = $ce40c7b0d439476b$var$_mountableMixin2.default;
$ce40c7b0d439476b$exports.StreetViewPanorama = $ce40c7b0d439476b$var$_streetViewPanorama2.default;
function $ce40c7b0d439476b$var$install(Vue, options) {
    // Set defaults
    options = $ce40c7b0d439476b$var$_extends({
        installComponents: true,
        autobindAllEvents: false
    }, options);
    // Update the global `GmapApi`. This will allow
    // components to use the `google` global reactively
    // via:
    //   import {gmapApi} from 'vue2-google-maps'
    //   export default {  computed: { google: gmapApi }  }
    $ce40c7b0d439476b$var$GmapApi = new Vue({
        data: {
            gmapApi: null
        }
    });
    var defaultResizeBus = new Vue();
    // Use a lazy to only load the API when
    // a VGM component is loaded
    var gmapApiPromiseLazy = $ce40c7b0d439476b$var$makeGmapApiPromiseLazy(options);
    Vue.mixin({
        created: function created() {
            this.$gmapDefaultResizeBus = defaultResizeBus;
            this.$gmapOptions = options;
            this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
        }
    });
    Vue.$gmapDefaultResizeBus = defaultResizeBus;
    Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    if (options.installComponents) {
        Vue.component("GmapMap", $ce40c7b0d439476b$var$_map2.default);
        Vue.component("GmapMarker", $ce40c7b0d439476b$var$_marker2.default);
        Vue.component("GmapInfoWindow", $ce40c7b0d439476b$var$_infoWindow2.default);
        Vue.component("GmapPolyline", $ce40c7b0d439476b$var$_polyline2.default);
        Vue.component("GmapPolygon", $ce40c7b0d439476b$var$_polygon2.default);
        Vue.component("GmapCircle", $ce40c7b0d439476b$var$_circle2.default);
        Vue.component("GmapRectangle", $ce40c7b0d439476b$var$_rectangle2.default);
        Vue.component("GmapAutocomplete", $ce40c7b0d439476b$var$_autocomplete2.default);
        Vue.component("GmapPlaceInput", $ce40c7b0d439476b$var$_placeInput2.default);
        Vue.component("GmapStreetViewPanorama", $ce40c7b0d439476b$var$_streetViewPanorama2.default);
    }
}
function $ce40c7b0d439476b$var$makeGmapApiPromiseLazy(options) {
    // Things to do once the API is loaded
    function onApiLoaded() {
        $ce40c7b0d439476b$var$GmapApi.gmapApi = {};
        return window.google;
    }
    if (options.load) // If library should load the API
    return (0, $ce40c7b0d439476b$var$_lazyValue2.default)(function() {
        // Load the
        // This will only be evaluated once
        if (typeof window === "undefined") // server side -- never resolve this promise
        return new Promise(function() {}).then(onApiLoaded);
        else return new Promise(function(resolve, reject) {
            try {
                window["vueGoogleMapsInit"] = resolve;
                (0, $04a92c71a91768a1$exports.loadGmapApi)(options.load, options.loadCn);
            } catch (err) {
                reject(err);
            }
        }).then(onApiLoaded);
    });
    else {
        // If library should not handle API, provide
        // end-users with the global `vueGoogleMapsInit: () => undefined`
        // when the Google Maps API has been loaded
        var promise = new Promise(function(resolve) {
            if (typeof window === "undefined") // Do nothing if run from server-side
            return;
            window["vueGoogleMapsInit"] = resolve;
        }).then(onApiLoaded);
        return (0, $ce40c7b0d439476b$var$_lazyValue2.default)(function() {
            return promise;
        });
    }
}
function $ce40c7b0d439476b$var$gmapApi() {
    return $ce40c7b0d439476b$var$GmapApi.gmapApi && window.google;
}


(0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(document).ready(function() {
    var banner = new (0, (/*@__PURE__*/$parcel$interopDefault($b749015d180113c6$exports)))(function() {
        (function(b, o, i, l, e, r) {
            b.GoogleAnalyticsObject = l;
            b[l] || (b[l] = function() {
                (b[l].q = b[l].q || []).push(arguments);
            });
            b[l].l = +new Date;
            e = o.createElement(i);
            r = o.getElementsByTagName(i)[0];
            e.src = "https://www.google-analytics.com/analytics.js";
            r.parentNode.insertBefore(e, r);
        })(window, document, "script", "ga");
        ga("create", "UA-126236618-1", "auto");
        ga("send", "pageview");
        ga("set", "anonymizeIp", true);
    });
    try {
        var photogalleryOptions = {
            shareButtons: localizedShareButtons
        };
    } catch (ReferenceError) {
        var photogalleryOptions = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX))).extend(photogalleryOptions, {
        itemFilter: function itemFilter() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(this).parents(".slick-cloned").length === 0;
        },
        captionSelector: ".caption"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(".gallery").photogallery(photogalleryOptions);
    var homeNewsSwiper = new (0, $5e44c3fe32d2063c$export$2e2bcd8739ae039)(".homenews", {
        slidesPerView: "auto",
        slidesOffsetAfter: 80,
        navigation: {
            prevEl: ".homenews__arrow--prev",
            nextEl: ".homenews__arrow--next",
            disabledClass: "homenews__arrow--disabled"
        }
    });
    var home__slider = new (0, $5e44c3fe32d2063c$export$2e2bcd8739ae039)(".home__slider", {
        slidesPerView: 1,
        speed: 500,
        navigation: {
            prevEl: ".home__slider__arrow--prev",
            nextEl: ".home__slider__arrow--next",
            disabledClass: "home__slider__arrow--disabled"
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true
        }
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(".streamteaser .swiper-slide").length > 1) {
        var streamTeaserSwiper = new (0, $5e44c3fe32d2063c$export$2e2bcd8739ae039)(".streamteaser", {
            slidesPerView: 1,
            speed: 500,
            navigation: {
                prevEl: ".streamteaser__arrow--prev",
                nextEl: ".streamteaser__arrow--next",
                disabledClass: "streamteaser__arrow--disabled"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(".streamteaser").hover(function(params) {
            streamTeaserSwiper.autoplay.stop();
        }, function(e) {
            streamTeaserSwiper.autoplay.start();
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))("#StreamFilter").length >= 1) (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))("#StreamFilter").on("change", ".stream-filter__select", function() {
        var uri = new (0, (/*@__PURE__*/$parcel$interopDefault($91235eee3740bd67$exports)))();
        uri.query((0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))("#StreamFilter").serialize());
        window.location.href = uri;
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(".slide-gallery .swiper-slide").length > 1) {
        var gallerySwiper = new (0, $5e44c3fe32d2063c$export$2e2bcd8739ae039)(".slide-gallery", {
            slidesPerView: 1,
            speed: 500,
            navigation: {
                prevEl: ".slide-gallery__arrow--prev",
                nextEl: ".slide-gallery__arrow--next",
                disabledClass: "slide-gallery__arrow--disabled"
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
                clickable: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))(".slide-gallery").hover(function(params) {
            gallerySwiper.autoplay.stop();
        }, function(e) {
            gallerySwiper.autoplay.start();
        });
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($d8b82b1bb410b51b$exports))).use($ce40c7b0d439476b$exports, {
    load: {
        key: "AIzaSyDeySUzkx6-T6dCkT3P84b03p7EP8j1QBU",
        libraries: "places"
    }
});
var $15ed99db20581af4$var$VueTZMap = (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))("#TZMap");
if ($15ed99db20581af4$var$VueTZMap.length) new (0, (/*@__PURE__*/$parcel$interopDefault($d8b82b1bb410b51b$exports)))({
    el: "#TZMap",
    components: {
        TZMap: (0, $94e10b35aac535fc$export$2e2bcd8739ae039)
    }
});
var $15ed99db20581af4$var$VueNewsApp = (0, (/*@__PURE__*/$parcel$interopDefault($aPoFX)))("#NewsApp");
if ($15ed99db20581af4$var$VueNewsApp.length) new (0, (/*@__PURE__*/$parcel$interopDefault($d8b82b1bb410b51b$exports)))({
    el: "#NewsApp",
    components: {
        NewsApp: (0, $b14b149dc7b90384$export$2e2bcd8739ae039)
    }
});

})();
//# sourceMappingURL=index.d95c8ed9.js.map
